/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var AP = Object.create;
  var Li = Object.defineProperty;
  var PP = Object.getOwnPropertyDescriptor;
  var CP = Object.getOwnPropertyNames;
  var wP = Object.getPrototypeOf,
    MP = Object.prototype.hasOwnProperty;
  var OP = (e, t) => () => (e && (t = e((e = 0))), t);
  var E = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports),
    RP = (e, t) => {
      for (var r in t) Li(e, r, { get: t[r], enumerable: !0 });
    },
    Yh = (e, t, r, n) => {
      if ((t && typeof t == "object") || typeof t == "function")
        for (let i of CP(t))
          !MP.call(e, i) &&
            i !== r &&
            Li(e, i, {
              get: () => t[i],
              enumerable: !(n = PP(t, i)) || n.enumerable,
            });
      return e;
    };
  var DP = (e, t, r) => (
      (r = e != null ? AP(wP(e)) : {}),
      Yh(
        t || !e || !e.__esModule
          ? Li(r, "default", { value: e, enumerable: !0 })
          : r,
        e,
      )
    ),
    qP = (e) => Yh(Li({}, "__esModule", { value: !0 }), e);
  var Zs = E(() => {
    window.tram = (function (e) {
      function t(T, F) {
        var N = new oe.Bare();
        return N.init(T, F);
      }
      function r(T) {
        return T.replace(/[A-Z]/g, function (F) {
          return "-" + F.toLowerCase();
        });
      }
      function n(T) {
        var F = parseInt(T.slice(1), 16),
          N = (F >> 16) & 255,
          k = (F >> 8) & 255,
          z = 255 & F;
        return [N, k, z];
      }
      function i(T, F, N) {
        return (
          "#" + ((1 << 24) | (T << 16) | (F << 8) | N).toString(16).slice(1)
        );
      }
      function a() {}
      function s(T, F) {
        f("Type warning: Expected: [" + T + "] Got: [" + typeof F + "] " + F);
      }
      function o(T, F, N) {
        f("Units do not match [" + T + "]: " + F + ", " + N);
      }
      function l(T, F, N) {
        if ((F !== void 0 && (N = F), T === void 0)) return N;
        var k = N;
        return (
          tr.test(T) || !Ct.test(T)
            ? (k = parseInt(T, 10))
            : Ct.test(T) && (k = 1e3 * parseFloat(T)),
          0 > k && (k = 0),
          k === k ? k : N
        );
      }
      function f(T) {
        ge.debug && window && window.console.warn(T);
      }
      function u(T) {
        for (var F = -1, N = T ? T.length : 0, k = []; ++F < N; ) {
          var z = T[F];
          z && k.push(z);
        }
        return k;
      }
      var c = (function (T, F, N) {
          function k(K) {
            return typeof K == "object";
          }
          function z(K) {
            return typeof K == "function";
          }
          function V() {}
          function X(K, ce) {
            function W() {
              var Ue = new ee();
              return z(Ue.init) && Ue.init.apply(Ue, arguments), Ue;
            }
            function ee() {}
            ce === N && ((ce = K), (K = Object)), (W.Bare = ee);
            var ie,
              _e = (V[T] = K[T]),
              wt = (ee[T] = W[T] = new V());
            return (
              (wt.constructor = W),
              (W.mixin = function (Ue) {
                return (ee[T] = W[T] = X(W, Ue)[T]), W;
              }),
              (W.open = function (Ue) {
                if (
                  ((ie = {}),
                  z(Ue) ? (ie = Ue.call(W, wt, _e, W, K)) : k(Ue) && (ie = Ue),
                  k(ie))
                )
                  for (var Mn in ie) F.call(ie, Mn) && (wt[Mn] = ie[Mn]);
                return z(wt.init) || (wt.init = K), W;
              }),
              W.open(ce)
            );
          }
          return X;
        })("prototype", {}.hasOwnProperty),
        v = {
          ease: [
            "ease",
            function (T, F, N, k) {
              var z = (T /= k) * T,
                V = z * T;
              return (
                F +
                N * (-2.75 * V * z + 11 * z * z + -15.5 * V + 8 * z + 0.25 * T)
              );
            },
          ],
          "ease-in": [
            "ease-in",
            function (T, F, N, k) {
              var z = (T /= k) * T,
                V = z * T;
              return F + N * (-1 * V * z + 3 * z * z + -3 * V + 2 * z);
            },
          ],
          "ease-out": [
            "ease-out",
            function (T, F, N, k) {
              var z = (T /= k) * T,
                V = z * T;
              return (
                F +
                N * (0.3 * V * z + -1.6 * z * z + 2.2 * V + -1.8 * z + 1.9 * T)
              );
            },
          ],
          "ease-in-out": [
            "ease-in-out",
            function (T, F, N, k) {
              var z = (T /= k) * T,
                V = z * T;
              return F + N * (2 * V * z + -5 * z * z + 2 * V + 2 * z);
            },
          ],
          linear: [
            "linear",
            function (T, F, N, k) {
              return (N * T) / k + F;
            },
          ],
          "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function (T, F, N, k) {
              return N * (T /= k) * T + F;
            },
          ],
          "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function (T, F, N, k) {
              return -N * (T /= k) * (T - 2) + F;
            },
          ],
          "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function (T, F, N, k) {
              return (T /= k / 2) < 1
                ? (N / 2) * T * T + F
                : (-N / 2) * (--T * (T - 2) - 1) + F;
            },
          ],
          "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function (T, F, N, k) {
              return N * (T /= k) * T * T + F;
            },
          ],
          "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function (T, F, N, k) {
              return N * ((T = T / k - 1) * T * T + 1) + F;
            },
          ],
          "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function (T, F, N, k) {
              return (T /= k / 2) < 1
                ? (N / 2) * T * T * T + F
                : (N / 2) * ((T -= 2) * T * T + 2) + F;
            },
          ],
          "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function (T, F, N, k) {
              return N * (T /= k) * T * T * T + F;
            },
          ],
          "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function (T, F, N, k) {
              return -N * ((T = T / k - 1) * T * T * T - 1) + F;
            },
          ],
          "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function (T, F, N, k) {
              return (T /= k / 2) < 1
                ? (N / 2) * T * T * T * T + F
                : (-N / 2) * ((T -= 2) * T * T * T - 2) + F;
            },
          ],
          "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function (T, F, N, k) {
              return N * (T /= k) * T * T * T * T + F;
            },
          ],
          "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function (T, F, N, k) {
              return N * ((T = T / k - 1) * T * T * T * T + 1) + F;
            },
          ],
          "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function (T, F, N, k) {
              return (T /= k / 2) < 1
                ? (N / 2) * T * T * T * T * T + F
                : (N / 2) * ((T -= 2) * T * T * T * T + 2) + F;
            },
          ],
          "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function (T, F, N, k) {
              return -N * Math.cos((T / k) * (Math.PI / 2)) + N + F;
            },
          ],
          "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function (T, F, N, k) {
              return N * Math.sin((T / k) * (Math.PI / 2)) + F;
            },
          ],
          "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function (T, F, N, k) {
              return (-N / 2) * (Math.cos((Math.PI * T) / k) - 1) + F;
            },
          ],
          "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function (T, F, N, k) {
              return T === 0 ? F : N * Math.pow(2, 10 * (T / k - 1)) + F;
            },
          ],
          "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function (T, F, N, k) {
              return T === k
                ? F + N
                : N * (-Math.pow(2, (-10 * T) / k) + 1) + F;
            },
          ],
          "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function (T, F, N, k) {
              return T === 0
                ? F
                : T === k
                  ? F + N
                  : (T /= k / 2) < 1
                    ? (N / 2) * Math.pow(2, 10 * (T - 1)) + F
                    : (N / 2) * (-Math.pow(2, -10 * --T) + 2) + F;
            },
          ],
          "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function (T, F, N, k) {
              return -N * (Math.sqrt(1 - (T /= k) * T) - 1) + F;
            },
          ],
          "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function (T, F, N, k) {
              return N * Math.sqrt(1 - (T = T / k - 1) * T) + F;
            },
          ],
          "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function (T, F, N, k) {
              return (T /= k / 2) < 1
                ? (-N / 2) * (Math.sqrt(1 - T * T) - 1) + F
                : (N / 2) * (Math.sqrt(1 - (T -= 2) * T) + 1) + F;
            },
          ],
          "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function (T, F, N, k, z) {
              return (
                z === void 0 && (z = 1.70158),
                N * (T /= k) * T * ((z + 1) * T - z) + F
              );
            },
          ],
          "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function (T, F, N, k, z) {
              return (
                z === void 0 && (z = 1.70158),
                N * ((T = T / k - 1) * T * ((z + 1) * T + z) + 1) + F
              );
            },
          ],
          "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function (T, F, N, k, z) {
              return (
                z === void 0 && (z = 1.70158),
                (T /= k / 2) < 1
                  ? (N / 2) * T * T * (((z *= 1.525) + 1) * T - z) + F
                  : (N / 2) *
                      ((T -= 2) * T * (((z *= 1.525) + 1) * T + z) + 2) +
                    F
              );
            },
          ],
        },
        d = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)",
        },
        p = document,
        m = window,
        h = "bkwld-tram",
        g = /[\-\.0-9]/g,
        y = /[A-Z]/,
        _ = "number",
        b = /^(rgb|#)/,
        I = /(em|cm|mm|in|pt|pc|px)$/,
        P = /(em|cm|mm|in|pt|pc|px|%)$/,
        S = /(deg|rad|turn)$/,
        A = "unitless",
        R = /(all|none) 0s ease 0s/,
        w = /^(width|height)$/,
        C = " ",
        D = p.createElement("a"),
        M = ["Webkit", "Moz", "O", "ms"],
        O = ["-webkit-", "-moz-", "-o-", "-ms-"],
        q = function (T) {
          if (T in D.style) return { dom: T, css: T };
          var F,
            N,
            k = "",
            z = T.split("-");
          for (F = 0; F < z.length; F++)
            k += z[F].charAt(0).toUpperCase() + z[F].slice(1);
          for (F = 0; F < M.length; F++)
            if (((N = M[F] + k), N in D.style))
              return { dom: N, css: O[F] + T };
        },
        B = (t.support = {
          bind: Function.prototype.bind,
          transform: q("transform"),
          transition: q("transition"),
          backface: q("backface-visibility"),
          timing: q("transition-timing-function"),
        });
      if (B.transition) {
        var H = B.timing.dom;
        if (((D.style[H] = v["ease-in-back"][0]), !D.style[H]))
          for (var x in d) v[x][0] = d[x];
      }
      var L = (t.frame = (function () {
          var T =
            m.requestAnimationFrame ||
            m.webkitRequestAnimationFrame ||
            m.mozRequestAnimationFrame ||
            m.oRequestAnimationFrame ||
            m.msRequestAnimationFrame;
          return T && B.bind
            ? T.bind(m)
            : function (F) {
                m.setTimeout(F, 16);
              };
        })()),
        j = (t.now = (function () {
          var T = m.performance,
            F = T && (T.now || T.webkitNow || T.msNow || T.mozNow);
          return F && B.bind
            ? F.bind(T)
            : Date.now ||
                function () {
                  return +new Date();
                };
        })()),
        Y = c(function (T) {
          function F(Q, fe) {
            var Ie = u(("" + Q).split(C)),
              pe = Ie[0];
            fe = fe || {};
            var $e = J[pe];
            if (!$e) return f("Unsupported property: " + pe);
            if (!fe.weak || !this.props[pe]) {
              var gt = $e[0],
                tt = this.props[pe];
              return (
                tt || (tt = this.props[pe] = new gt.Bare()),
                tt.init(this.$el, Ie, $e, fe),
                tt
              );
            }
          }
          function N(Q, fe, Ie) {
            if (Q) {
              var pe = typeof Q;
              if (
                (fe ||
                  (this.timer && this.timer.destroy(),
                  (this.queue = []),
                  (this.active = !1)),
                pe == "number" && fe)
              )
                return (
                  (this.timer = new he({
                    duration: Q,
                    context: this,
                    complete: V,
                  })),
                  void (this.active = !0)
                );
              if (pe == "string" && fe) {
                switch (Q) {
                  case "hide":
                    W.call(this);
                    break;
                  case "stop":
                    X.call(this);
                    break;
                  case "redraw":
                    ee.call(this);
                    break;
                  default:
                    F.call(this, Q, Ie && Ie[1]);
                }
                return V.call(this);
              }
              if (pe == "function") return void Q.call(this, this);
              if (pe == "object") {
                var $e = 0;
                wt.call(
                  this,
                  Q,
                  function (Me, xP) {
                    Me.span > $e && ($e = Me.span), Me.stop(), Me.animate(xP);
                  },
                  function (Me) {
                    "wait" in Me && ($e = l(Me.wait, 0));
                  },
                ),
                  _e.call(this),
                  $e > 0 &&
                    ((this.timer = new he({ duration: $e, context: this })),
                    (this.active = !0),
                    fe && (this.timer.complete = V));
                var gt = this,
                  tt = !1,
                  Fi = {};
                L(function () {
                  wt.call(gt, Q, function (Me) {
                    Me.active && ((tt = !0), (Fi[Me.name] = Me.nextStyle));
                  }),
                    tt && gt.$el.css(Fi);
                });
              }
            }
          }
          function k(Q) {
            (Q = l(Q, 0)),
              this.active
                ? this.queue.push({ options: Q })
                : ((this.timer = new he({
                    duration: Q,
                    context: this,
                    complete: V,
                  })),
                  (this.active = !0));
          }
          function z(Q) {
            return this.active
              ? (this.queue.push({ options: Q, args: arguments }),
                void (this.timer.complete = V))
              : f(
                  "No active transition timer. Use start() or wait() before then().",
                );
          }
          function V() {
            if (
              (this.timer && this.timer.destroy(),
              (this.active = !1),
              this.queue.length)
            ) {
              var Q = this.queue.shift();
              N.call(this, Q.options, !0, Q.args);
            }
          }
          function X(Q) {
            this.timer && this.timer.destroy(),
              (this.queue = []),
              (this.active = !1);
            var fe;
            typeof Q == "string"
              ? ((fe = {}), (fe[Q] = 1))
              : (fe = typeof Q == "object" && Q != null ? Q : this.props),
              wt.call(this, fe, Ue),
              _e.call(this);
          }
          function K(Q) {
            X.call(this, Q), wt.call(this, Q, Mn, IP);
          }
          function ce(Q) {
            typeof Q != "string" && (Q = "block"), (this.el.style.display = Q);
          }
          function W() {
            X.call(this), (this.el.style.display = "none");
          }
          function ee() {
            this.el.offsetHeight;
          }
          function ie() {
            X.call(this), e.removeData(this.el, h), (this.$el = this.el = null);
          }
          function _e() {
            var Q,
              fe,
              Ie = [];
            this.upstream && Ie.push(this.upstream);
            for (Q in this.props)
              (fe = this.props[Q]), fe.active && Ie.push(fe.string);
            (Ie = Ie.join(",")),
              this.style !== Ie &&
                ((this.style = Ie), (this.el.style[B.transition.dom] = Ie));
          }
          function wt(Q, fe, Ie) {
            var pe,
              $e,
              gt,
              tt,
              Fi = fe !== Ue,
              Me = {};
            for (pe in Q)
              (gt = Q[pe]),
                pe in We
                  ? (Me.transform || (Me.transform = {}),
                    (Me.transform[pe] = gt))
                  : (y.test(pe) && (pe = r(pe)),
                    pe in J ? (Me[pe] = gt) : (tt || (tt = {}), (tt[pe] = gt)));
            for (pe in Me) {
              if (((gt = Me[pe]), ($e = this.props[pe]), !$e)) {
                if (!Fi) continue;
                $e = F.call(this, pe);
              }
              fe.call(this, $e, gt);
            }
            Ie && tt && Ie.call(this, tt);
          }
          function Ue(Q) {
            Q.stop();
          }
          function Mn(Q, fe) {
            Q.set(fe);
          }
          function IP(Q) {
            this.$el.css(Q);
          }
          function vt(Q, fe) {
            T[Q] = function () {
              return this.children
                ? TP.call(this, fe, arguments)
                : (this.el && fe.apply(this, arguments), this);
            };
          }
          function TP(Q, fe) {
            var Ie,
              pe = this.children.length;
            for (Ie = 0; pe > Ie; Ie++) Q.apply(this.children[Ie], fe);
            return this;
          }
          (T.init = function (Q) {
            if (
              ((this.$el = e(Q)),
              (this.el = this.$el[0]),
              (this.props = {}),
              (this.queue = []),
              (this.style = ""),
              (this.active = !1),
              ge.keepInherited && !ge.fallback)
            ) {
              var fe = He(this.el, "transition");
              fe && !R.test(fe) && (this.upstream = fe);
            }
            B.backface &&
              ge.hideBackface &&
              we(this.el, B.backface.css, "hidden");
          }),
            vt("add", F),
            vt("start", N),
            vt("wait", k),
            vt("then", z),
            vt("next", V),
            vt("stop", X),
            vt("set", K),
            vt("show", ce),
            vt("hide", W),
            vt("redraw", ee),
            vt("destroy", ie);
        }),
        oe = c(Y, function (T) {
          function F(N, k) {
            var z = e.data(N, h) || e.data(N, h, new Y.Bare());
            return z.el || z.init(N), k ? z.start(k) : z;
          }
          T.init = function (N, k) {
            var z = e(N);
            if (!z.length) return this;
            if (z.length === 1) return F(z[0], k);
            var V = [];
            return (
              z.each(function (X, K) {
                V.push(F(K, k));
              }),
              (this.children = V),
              this
            );
          };
        }),
        U = c(function (T) {
          function F() {
            var V = this.get();
            this.update("auto");
            var X = this.get();
            return this.update(V), X;
          }
          function N(V, X, K) {
            return X !== void 0 && (K = X), V in v ? V : K;
          }
          function k(V) {
            var X = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(V);
            return (X ? i(X[1], X[2], X[3]) : V).replace(
              /#(\w)(\w)(\w)$/,
              "#$1$1$2$2$3$3",
            );
          }
          var z = { duration: 500, ease: "ease", delay: 0 };
          (T.init = function (V, X, K, ce) {
            (this.$el = V), (this.el = V[0]);
            var W = X[0];
            K[2] && (W = K[2]),
              qe[W] && (W = qe[W]),
              (this.name = W),
              (this.type = K[1]),
              (this.duration = l(X[1], this.duration, z.duration)),
              (this.ease = N(X[2], this.ease, z.ease)),
              (this.delay = l(X[3], this.delay, z.delay)),
              (this.span = this.duration + this.delay),
              (this.active = !1),
              (this.nextStyle = null),
              (this.auto = w.test(this.name)),
              (this.unit = ce.unit || this.unit || ge.defaultUnit),
              (this.angle = ce.angle || this.angle || ge.defaultAngle),
              ge.fallback || ce.fallback
                ? (this.animate = this.fallback)
                : ((this.animate = this.transition),
                  (this.string =
                    this.name +
                    C +
                    this.duration +
                    "ms" +
                    (this.ease != "ease" ? C + v[this.ease][0] : "") +
                    (this.delay ? C + this.delay + "ms" : "")));
          }),
            (T.set = function (V) {
              (V = this.convert(V, this.type)), this.update(V), this.redraw();
            }),
            (T.transition = function (V) {
              (this.active = !0),
                (V = this.convert(V, this.type)),
                this.auto &&
                  (this.el.style[this.name] == "auto" &&
                    (this.update(this.get()), this.redraw()),
                  V == "auto" && (V = F.call(this))),
                (this.nextStyle = V);
            }),
            (T.fallback = function (V) {
              var X =
                this.el.style[this.name] || this.convert(this.get(), this.type);
              (V = this.convert(V, this.type)),
                this.auto &&
                  (X == "auto" && (X = this.convert(this.get(), this.type)),
                  V == "auto" && (V = F.call(this))),
                (this.tween = new se({
                  from: X,
                  to: V,
                  duration: this.duration,
                  delay: this.delay,
                  ease: this.ease,
                  update: this.update,
                  context: this,
                }));
            }),
            (T.get = function () {
              return He(this.el, this.name);
            }),
            (T.update = function (V) {
              we(this.el, this.name, V);
            }),
            (T.stop = function () {
              (this.active || this.nextStyle) &&
                ((this.active = !1),
                (this.nextStyle = null),
                we(this.el, this.name, this.get()));
              var V = this.tween;
              V && V.context && V.destroy();
            }),
            (T.convert = function (V, X) {
              if (V == "auto" && this.auto) return V;
              var K,
                ce = typeof V == "number",
                W = typeof V == "string";
              switch (X) {
                case _:
                  if (ce) return V;
                  if (W && V.replace(g, "") === "") return +V;
                  K = "number(unitless)";
                  break;
                case b:
                  if (W) {
                    if (V === "" && this.original) return this.original;
                    if (X.test(V))
                      return V.charAt(0) == "#" && V.length == 7 ? V : k(V);
                  }
                  K = "hex or rgb string";
                  break;
                case I:
                  if (ce) return V + this.unit;
                  if (W && X.test(V)) return V;
                  K = "number(px) or string(unit)";
                  break;
                case P:
                  if (ce) return V + this.unit;
                  if (W && X.test(V)) return V;
                  K = "number(px) or string(unit or %)";
                  break;
                case S:
                  if (ce) return V + this.angle;
                  if (W && X.test(V)) return V;
                  K = "number(deg) or string(angle)";
                  break;
                case A:
                  if (ce || (W && P.test(V))) return V;
                  K = "number(unitless) or string(unit or %)";
              }
              return s(K, V), V;
            }),
            (T.redraw = function () {
              this.el.offsetHeight;
            });
        }),
        ue = c(U, function (T, F) {
          T.init = function () {
            F.init.apply(this, arguments),
              this.original || (this.original = this.convert(this.get(), b));
          };
        }),
        le = c(U, function (T, F) {
          (T.init = function () {
            F.init.apply(this, arguments), (this.animate = this.fallback);
          }),
            (T.get = function () {
              return this.$el[this.name]();
            }),
            (T.update = function (N) {
              this.$el[this.name](N);
            });
        }),
        be = c(U, function (T, F) {
          function N(k, z) {
            var V, X, K, ce, W;
            for (V in k)
              (ce = We[V]),
                (K = ce[0]),
                (X = ce[1] || V),
                (W = this.convert(k[V], K)),
                z.call(this, X, W, K);
          }
          (T.init = function () {
            F.init.apply(this, arguments),
              this.current ||
                ((this.current = {}),
                We.perspective &&
                  ge.perspective &&
                  ((this.current.perspective = ge.perspective),
                  we(this.el, this.name, this.style(this.current)),
                  this.redraw()));
          }),
            (T.set = function (k) {
              N.call(this, k, function (z, V) {
                this.current[z] = V;
              }),
                we(this.el, this.name, this.style(this.current)),
                this.redraw();
            }),
            (T.transition = function (k) {
              var z = this.values(k);
              this.tween = new je({
                current: this.current,
                values: z,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
              });
              var V,
                X = {};
              for (V in this.current) X[V] = V in z ? z[V] : this.current[V];
              (this.active = !0), (this.nextStyle = this.style(X));
            }),
            (T.fallback = function (k) {
              var z = this.values(k);
              this.tween = new je({
                current: this.current,
                values: z,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this,
              });
            }),
            (T.update = function () {
              we(this.el, this.name, this.style(this.current));
            }),
            (T.style = function (k) {
              var z,
                V = "";
              for (z in k) V += z + "(" + k[z] + ") ";
              return V;
            }),
            (T.values = function (k) {
              var z,
                V = {};
              return (
                N.call(this, k, function (X, K, ce) {
                  (V[X] = K),
                    this.current[X] === void 0 &&
                      ((z = 0),
                      ~X.indexOf("scale") && (z = 1),
                      (this.current[X] = this.convert(z, ce)));
                }),
                V
              );
            });
        }),
        se = c(function (T) {
          function F(W) {
            K.push(W) === 1 && L(N);
          }
          function N() {
            var W,
              ee,
              ie,
              _e = K.length;
            if (_e)
              for (L(N), ee = j(), W = _e; W--; )
                (ie = K[W]), ie && ie.render(ee);
          }
          function k(W) {
            var ee,
              ie = e.inArray(W, K);
            ie >= 0 &&
              ((ee = K.slice(ie + 1)),
              (K.length = ie),
              ee.length && (K = K.concat(ee)));
          }
          function z(W) {
            return Math.round(W * ce) / ce;
          }
          function V(W, ee, ie) {
            return i(
              W[0] + ie * (ee[0] - W[0]),
              W[1] + ie * (ee[1] - W[1]),
              W[2] + ie * (ee[2] - W[2]),
            );
          }
          var X = { ease: v.ease[1], from: 0, to: 1 };
          (T.init = function (W) {
            (this.duration = W.duration || 0), (this.delay = W.delay || 0);
            var ee = W.ease || X.ease;
            v[ee] && (ee = v[ee][1]),
              typeof ee != "function" && (ee = X.ease),
              (this.ease = ee),
              (this.update = W.update || a),
              (this.complete = W.complete || a),
              (this.context = W.context || this),
              (this.name = W.name);
            var ie = W.from,
              _e = W.to;
            ie === void 0 && (ie = X.from),
              _e === void 0 && (_e = X.to),
              (this.unit = W.unit || ""),
              typeof ie == "number" && typeof _e == "number"
                ? ((this.begin = ie), (this.change = _e - ie))
                : this.format(_e, ie),
              (this.value = this.begin + this.unit),
              (this.start = j()),
              W.autoplay !== !1 && this.play();
          }),
            (T.play = function () {
              this.active ||
                (this.start || (this.start = j()), (this.active = !0), F(this));
            }),
            (T.stop = function () {
              this.active && ((this.active = !1), k(this));
            }),
            (T.render = function (W) {
              var ee,
                ie = W - this.start;
              if (this.delay) {
                if (ie <= this.delay) return;
                ie -= this.delay;
              }
              if (ie < this.duration) {
                var _e = this.ease(ie, 0, 1, this.duration);
                return (
                  (ee = this.startRGB
                    ? V(this.startRGB, this.endRGB, _e)
                    : z(this.begin + _e * this.change)),
                  (this.value = ee + this.unit),
                  void this.update.call(this.context, this.value)
                );
              }
              (ee = this.endHex || this.begin + this.change),
                (this.value = ee + this.unit),
                this.update.call(this.context, this.value),
                this.complete.call(this.context),
                this.destroy();
            }),
            (T.format = function (W, ee) {
              if (((ee += ""), (W += ""), W.charAt(0) == "#"))
                return (
                  (this.startRGB = n(ee)),
                  (this.endRGB = n(W)),
                  (this.endHex = W),
                  (this.begin = 0),
                  void (this.change = 1)
                );
              if (!this.unit) {
                var ie = ee.replace(g, ""),
                  _e = W.replace(g, "");
                ie !== _e && o("tween", ee, W), (this.unit = ie);
              }
              (ee = parseFloat(ee)),
                (W = parseFloat(W)),
                (this.begin = this.value = ee),
                (this.change = W - ee);
            }),
            (T.destroy = function () {
              this.stop(),
                (this.context = null),
                (this.ease = this.update = this.complete = a);
            });
          var K = [],
            ce = 1e3;
        }),
        he = c(se, function (T) {
          (T.init = function (F) {
            (this.duration = F.duration || 0),
              (this.complete = F.complete || a),
              (this.context = F.context),
              this.play();
          }),
            (T.render = function (F) {
              var N = F - this.start;
              N < this.duration ||
                (this.complete.call(this.context), this.destroy());
            });
        }),
        je = c(se, function (T, F) {
          (T.init = function (N) {
            (this.context = N.context),
              (this.update = N.update),
              (this.tweens = []),
              (this.current = N.current);
            var k, z;
            for (k in N.values)
              (z = N.values[k]),
                this.current[k] !== z &&
                  this.tweens.push(
                    new se({
                      name: k,
                      from: this.current[k],
                      to: z,
                      duration: N.duration,
                      delay: N.delay,
                      ease: N.ease,
                      autoplay: !1,
                    }),
                  );
            this.play();
          }),
            (T.render = function (N) {
              var k,
                z,
                V = this.tweens.length,
                X = !1;
              for (k = V; k--; )
                (z = this.tweens[k]),
                  z.context &&
                    (z.render(N), (this.current[z.name] = z.value), (X = !0));
              return X
                ? void (this.update && this.update.call(this.context))
                : this.destroy();
            }),
            (T.destroy = function () {
              if ((F.destroy.call(this), this.tweens)) {
                var N,
                  k = this.tweens.length;
                for (N = k; N--; ) this.tweens[N].destroy();
                (this.tweens = null), (this.current = null);
              }
            });
        }),
        ge = (t.config = {
          debug: !1,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: !1,
          hideBackface: !1,
          perspective: "",
          fallback: !B.transition,
          agentTests: [],
        });
      (t.fallback = function (T) {
        if (!B.transition) return (ge.fallback = !0);
        ge.agentTests.push("(" + T + ")");
        var F = new RegExp(ge.agentTests.join("|"), "i");
        ge.fallback = F.test(navigator.userAgent);
      }),
        t.fallback("6.0.[2-5] Safari"),
        (t.tween = function (T) {
          return new se(T);
        }),
        (t.delay = function (T, F, N) {
          return new he({ complete: F, duration: T, context: N });
        }),
        (e.fn.tram = function (T) {
          return t.call(null, this, T);
        });
      var we = e.style,
        He = e.css,
        qe = { transform: B.transform && B.transform.css },
        J = {
          color: [ue, b],
          background: [ue, b, "background-color"],
          "outline-color": [ue, b],
          "border-color": [ue, b],
          "border-top-color": [ue, b],
          "border-right-color": [ue, b],
          "border-bottom-color": [ue, b],
          "border-left-color": [ue, b],
          "border-width": [U, I],
          "border-top-width": [U, I],
          "border-right-width": [U, I],
          "border-bottom-width": [U, I],
          "border-left-width": [U, I],
          "border-spacing": [U, I],
          "letter-spacing": [U, I],
          margin: [U, I],
          "margin-top": [U, I],
          "margin-right": [U, I],
          "margin-bottom": [U, I],
          "margin-left": [U, I],
          padding: [U, I],
          "padding-top": [U, I],
          "padding-right": [U, I],
          "padding-bottom": [U, I],
          "padding-left": [U, I],
          "outline-width": [U, I],
          opacity: [U, _],
          top: [U, P],
          right: [U, P],
          bottom: [U, P],
          left: [U, P],
          "font-size": [U, P],
          "text-indent": [U, P],
          "word-spacing": [U, P],
          width: [U, P],
          "min-width": [U, P],
          "max-width": [U, P],
          height: [U, P],
          "min-height": [U, P],
          "max-height": [U, P],
          "line-height": [U, A],
          "scroll-top": [le, _, "scrollTop"],
          "scroll-left": [le, _, "scrollLeft"],
        },
        We = {};
      B.transform &&
        ((J.transform = [be]),
        (We = {
          x: [P, "translateX"],
          y: [P, "translateY"],
          rotate: [S],
          rotateX: [S],
          rotateY: [S],
          scale: [_],
          scaleX: [_],
          scaleY: [_],
          skew: [S],
          skewX: [S],
          skewY: [S],
        })),
        B.transform &&
          B.backface &&
          ((We.z = [P, "translateZ"]),
          (We.rotateZ = [S]),
          (We.scaleZ = [_]),
          (We.perspective = [I]));
      var tr = /ms/,
        Ct = /s|\./;
      return (e.tram = t);
    })(window.jQuery);
  });
  var Zh = E((ute, Qh) => {
    var FP = window.$,
      LP = Zs() && FP.tram;
    Qh.exports = (function () {
      var e = {};
      e.VERSION = "1.6.0-Webflow";
      var t = {},
        r = Array.prototype,
        n = Object.prototype,
        i = Function.prototype,
        a = r.push,
        s = r.slice,
        o = r.concat,
        l = n.toString,
        f = n.hasOwnProperty,
        u = r.forEach,
        c = r.map,
        v = r.reduce,
        d = r.reduceRight,
        p = r.filter,
        m = r.every,
        h = r.some,
        g = r.indexOf,
        y = r.lastIndexOf,
        _ = Array.isArray,
        b = Object.keys,
        I = i.bind,
        P =
          (e.each =
          e.forEach =
            function (M, O, q) {
              if (M == null) return M;
              if (u && M.forEach === u) M.forEach(O, q);
              else if (M.length === +M.length) {
                for (var B = 0, H = M.length; B < H; B++)
                  if (O.call(q, M[B], B, M) === t) return;
              } else
                for (var x = e.keys(M), B = 0, H = x.length; B < H; B++)
                  if (O.call(q, M[x[B]], x[B], M) === t) return;
              return M;
            });
      (e.map = e.collect =
        function (M, O, q) {
          var B = [];
          return M == null
            ? B
            : c && M.map === c
              ? M.map(O, q)
              : (P(M, function (H, x, L) {
                  B.push(O.call(q, H, x, L));
                }),
                B);
        }),
        (e.find = e.detect =
          function (M, O, q) {
            var B;
            return (
              S(M, function (H, x, L) {
                if (O.call(q, H, x, L)) return (B = H), !0;
              }),
              B
            );
          }),
        (e.filter = e.select =
          function (M, O, q) {
            var B = [];
            return M == null
              ? B
              : p && M.filter === p
                ? M.filter(O, q)
                : (P(M, function (H, x, L) {
                    O.call(q, H, x, L) && B.push(H);
                  }),
                  B);
          });
      var S =
        (e.some =
        e.any =
          function (M, O, q) {
            O || (O = e.identity);
            var B = !1;
            return M == null
              ? B
              : h && M.some === h
                ? M.some(O, q)
                : (P(M, function (H, x, L) {
                    if (B || (B = O.call(q, H, x, L))) return t;
                  }),
                  !!B);
          });
      (e.contains = e.include =
        function (M, O) {
          return M == null
            ? !1
            : g && M.indexOf === g
              ? M.indexOf(O) != -1
              : S(M, function (q) {
                  return q === O;
                });
        }),
        (e.delay = function (M, O) {
          var q = s.call(arguments, 2);
          return setTimeout(function () {
            return M.apply(null, q);
          }, O);
        }),
        (e.defer = function (M) {
          return e.delay.apply(e, [M, 1].concat(s.call(arguments, 1)));
        }),
        (e.throttle = function (M) {
          var O, q, B;
          return function () {
            O ||
              ((O = !0),
              (q = arguments),
              (B = this),
              LP.frame(function () {
                (O = !1), M.apply(B, q);
              }));
          };
        }),
        (e.debounce = function (M, O, q) {
          var B,
            H,
            x,
            L,
            j,
            Y = function () {
              var oe = e.now() - L;
              oe < O
                ? (B = setTimeout(Y, O - oe))
                : ((B = null), q || ((j = M.apply(x, H)), (x = H = null)));
            };
          return function () {
            (x = this), (H = arguments), (L = e.now());
            var oe = q && !B;
            return (
              B || (B = setTimeout(Y, O)),
              oe && ((j = M.apply(x, H)), (x = H = null)),
              j
            );
          };
        }),
        (e.defaults = function (M) {
          if (!e.isObject(M)) return M;
          for (var O = 1, q = arguments.length; O < q; O++) {
            var B = arguments[O];
            for (var H in B) M[H] === void 0 && (M[H] = B[H]);
          }
          return M;
        }),
        (e.keys = function (M) {
          if (!e.isObject(M)) return [];
          if (b) return b(M);
          var O = [];
          for (var q in M) e.has(M, q) && O.push(q);
          return O;
        }),
        (e.has = function (M, O) {
          return f.call(M, O);
        }),
        (e.isObject = function (M) {
          return M === Object(M);
        }),
        (e.now =
          Date.now ||
          function () {
            return new Date().getTime();
          }),
        (e.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g,
        });
      var A = /(.)^/,
        R = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029",
        },
        w = /\\|'|\r|\n|\u2028|\u2029/g,
        C = function (M) {
          return "\\" + R[M];
        },
        D = /^\s*(\w|\$)+\s*$/;
      return (
        (e.template = function (M, O, q) {
          !O && q && (O = q), (O = e.defaults({}, O, e.templateSettings));
          var B = RegExp(
              [
                (O.escape || A).source,
                (O.interpolate || A).source,
                (O.evaluate || A).source,
              ].join("|") + "|$",
              "g",
            ),
            H = 0,
            x = "__p+='";
          M.replace(B, function (oe, U, ue, le, be) {
            return (
              (x += M.slice(H, be).replace(w, C)),
              (H = be + oe.length),
              U
                ? (x +=
                    `'+
((__t=(` +
                    U +
                    `))==null?'':_.escape(__t))+
'`)
                : ue
                  ? (x +=
                      `'+
((__t=(` +
                      ue +
                      `))==null?'':__t)+
'`)
                  : le &&
                    (x +=
                      `';
` +
                      le +
                      `
__p+='`),
              oe
            );
          }),
            (x += `';
`);
          var L = O.variable;
          if (L) {
            if (!D.test(L))
              throw new Error("variable is not a bare identifier: " + L);
          } else
            (x =
              `with(obj||{}){
` +
              x +
              `}
`),
              (L = "obj");
          x =
            `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` +
            x +
            `return __p;
`;
          var j;
          try {
            j = new Function(O.variable || "obj", "_", x);
          } catch (oe) {
            throw ((oe.source = x), oe);
          }
          var Y = function (oe) {
            return j.call(this, oe, e);
          };
          return (
            (Y.source =
              "function(" +
              L +
              `){
` +
              x +
              "}"),
            Y
          );
        }),
        e
      );
    })();
  });
  var zt = E((hte, sc) => {
    var de = {},
      zr = {},
      jr = [],
      eo = window.Webflow || [],
      rr = window.jQuery,
      Et = rr(window),
      NP = rr(document),
      Mt = rr.isFunction,
      yt = (de._ = Zh()),
      ec = (de.tram = Zs() && rr.tram),
      ki = !1,
      to = !1;
    ec.config.hideBackface = !1;
    ec.config.keepInherited = !0;
    de.define = function (e, t, r) {
      zr[e] && rc(zr[e]);
      var n = (zr[e] = t(rr, yt, r) || {});
      return tc(n), n;
    };
    de.require = function (e) {
      return zr[e];
    };
    function tc(e) {
      de.env() &&
        (Mt(e.design) && Et.on("__wf_design", e.design),
        Mt(e.preview) && Et.on("__wf_preview", e.preview)),
        Mt(e.destroy) && Et.on("__wf_destroy", e.destroy),
        e.ready && Mt(e.ready) && kP(e);
    }
    function kP(e) {
      if (ki) {
        e.ready();
        return;
      }
      yt.contains(jr, e.ready) || jr.push(e.ready);
    }
    function rc(e) {
      Mt(e.design) && Et.off("__wf_design", e.design),
        Mt(e.preview) && Et.off("__wf_preview", e.preview),
        Mt(e.destroy) && Et.off("__wf_destroy", e.destroy),
        e.ready && Mt(e.ready) && BP(e);
    }
    function BP(e) {
      jr = yt.filter(jr, function (t) {
        return t !== e.ready;
      });
    }
    de.push = function (e) {
      if (ki) {
        Mt(e) && e();
        return;
      }
      eo.push(e);
    };
    de.env = function (e) {
      var t = window.__wf_design,
        r = typeof t < "u";
      if (!e) return r;
      if (e === "design") return r && t;
      if (e === "preview") return r && !t;
      if (e === "slug") return r && window.__wf_slug;
      if (e === "editor") return window.WebflowEditor;
      if (e === "test") return window.__wf_test;
      if (e === "frame") return window !== window.top;
    };
    var Ni = navigator.userAgent.toLowerCase(),
      nc = (de.env.touch =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
      VP = (de.env.chrome =
        /chrome/.test(Ni) &&
        /Google/.test(navigator.vendor) &&
        parseInt(Ni.match(/chrome\/(\d+)\./)[1], 10)),
      GP = (de.env.ios = /(ipod|iphone|ipad)/.test(Ni));
    de.env.safari = /safari/.test(Ni) && !VP && !GP;
    var Js;
    nc &&
      NP.on("touchstart mousedown", function (e) {
        Js = e.target;
      });
    de.validClick = nc
      ? function (e) {
          return e === Js || rr.contains(e, Js);
        }
      : function () {
          return !0;
        };
    var ic = "resize.webflow orientationchange.webflow load.webflow",
      zP = "scroll.webflow " + ic;
    de.resize = ro(Et, ic);
    de.scroll = ro(Et, zP);
    de.redraw = ro();
    function ro(e, t) {
      var r = [],
        n = {};
      return (
        (n.up = yt.throttle(function (i) {
          yt.each(r, function (a) {
            a(i);
          });
        })),
        e && t && e.on(t, n.up),
        (n.on = function (i) {
          typeof i == "function" && (yt.contains(r, i) || r.push(i));
        }),
        (n.off = function (i) {
          if (!arguments.length) {
            r = [];
            return;
          }
          r = yt.filter(r, function (a) {
            return a !== i;
          });
        }),
        n
      );
    }
    de.location = function (e) {
      window.location = e;
    };
    de.env() && (de.location = function () {});
    de.ready = function () {
      (ki = !0), to ? jP() : yt.each(jr, Jh), yt.each(eo, Jh), de.resize.up();
    };
    function Jh(e) {
      Mt(e) && e();
    }
    function jP() {
      (to = !1), yt.each(zr, tc);
    }
    var br;
    de.load = function (e) {
      br.then(e);
    };
    function ac() {
      br && (br.reject(), Et.off("load", br.resolve)),
        (br = new rr.Deferred()),
        Et.on("load", br.resolve);
    }
    de.destroy = function (e) {
      (e = e || {}),
        (to = !0),
        Et.triggerHandler("__wf_destroy"),
        e.domready != null && (ki = e.domready),
        yt.each(zr, rc),
        de.resize.off(),
        de.scroll.off(),
        de.redraw.off(),
        (jr = []),
        (eo = []),
        br.state() === "pending" && ac();
    };
    rr(de.ready);
    ac();
    sc.exports = window.Webflow = de;
  });
  var st = E((cte, On) => {
    function HP(e) {
      return e && e.__esModule ? e : { default: e };
    }
    (On.exports = HP),
      (On.exports.__esModule = !0),
      (On.exports.default = On.exports);
  });
  var Sr = E((fte, jt) => {
    function no() {
      return (
        (jt.exports = no =
          Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = arguments[t];
                  for (var n in r)
                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
              }),
        (jt.exports.__esModule = !0),
        (jt.exports.default = jt.exports),
        no.apply(this, arguments)
      );
    }
    (jt.exports = no),
      (jt.exports.__esModule = !0),
      (jt.exports.default = jt.exports);
  });
  var oc = E((pte, Rn) => {
    function WP(e, t, r) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r),
        e
      );
    }
    (Rn.exports = WP),
      (Rn.exports.__esModule = !0),
      (Rn.exports.default = Rn.exports);
  });
  var io = E((dte, lc) => {
    function XP(e, t, r, n) {
      for (var i = e.length, a = r + (n ? 1 : -1); n ? a-- : ++a < i; )
        if (t(e[a], a, e)) return a;
      return -1;
    }
    lc.exports = XP;
  });
  var hc = E((mte, uc) => {
    function UP() {
      (this.__data__ = []), (this.size = 0);
    }
    uc.exports = UP;
  });
  var Bi = E((vte, cc) => {
    function $P(e, t) {
      return e === t || (e !== e && t !== t);
    }
    cc.exports = $P;
  });
  var Dn = E((gte, fc) => {
    var KP = Bi();
    function YP(e, t) {
      for (var r = e.length; r--; ) if (KP(e[r][0], t)) return r;
      return -1;
    }
    fc.exports = YP;
  });
  var dc = E((yte, pc) => {
    var QP = Dn(),
      ZP = Array.prototype,
      JP = ZP.splice;
    function eC(e) {
      var t = this.__data__,
        r = QP(t, e);
      if (r < 0) return !1;
      var n = t.length - 1;
      return r == n ? t.pop() : JP.call(t, r, 1), --this.size, !0;
    }
    pc.exports = eC;
  });
  var vc = E((Ete, mc) => {
    var tC = Dn();
    function rC(e) {
      var t = this.__data__,
        r = tC(t, e);
      return r < 0 ? void 0 : t[r][1];
    }
    mc.exports = rC;
  });
  var yc = E((_te, gc) => {
    var nC = Dn();
    function iC(e) {
      return nC(this.__data__, e) > -1;
    }
    gc.exports = iC;
  });
  var _c = E((bte, Ec) => {
    var aC = Dn();
    function sC(e, t) {
      var r = this.__data__,
        n = aC(r, e);
      return n < 0 ? (++this.size, r.push([e, t])) : (r[n][1] = t), this;
    }
    Ec.exports = sC;
  });
  var qn = E((Ste, bc) => {
    var oC = hc(),
      lC = dc(),
      uC = vc(),
      hC = yc(),
      cC = _c();
    function Hr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    Hr.prototype.clear = oC;
    Hr.prototype.delete = lC;
    Hr.prototype.get = uC;
    Hr.prototype.has = hC;
    Hr.prototype.set = cC;
    bc.exports = Hr;
  });
  var Ic = E((Ite, Sc) => {
    var fC = qn();
    function pC() {
      (this.__data__ = new fC()), (this.size = 0);
    }
    Sc.exports = pC;
  });
  var xc = E((Tte, Tc) => {
    function dC(e) {
      var t = this.__data__,
        r = t.delete(e);
      return (this.size = t.size), r;
    }
    Tc.exports = dC;
  });
  var Pc = E((xte, Ac) => {
    function mC(e) {
      return this.__data__.get(e);
    }
    Ac.exports = mC;
  });
  var wc = E((Ate, Cc) => {
    function vC(e) {
      return this.__data__.has(e);
    }
    Cc.exports = vC;
  });
  var ao = E((Pte, Mc) => {
    var gC =
      typeof global == "object" && global && global.Object === Object && global;
    Mc.exports = gC;
  });
  var _t = E((Cte, Oc) => {
    var yC = ao(),
      EC = typeof self == "object" && self && self.Object === Object && self,
      _C = yC || EC || Function("return this")();
    Oc.exports = _C;
  });
  var Wr = E((wte, Rc) => {
    var bC = _t(),
      SC = bC.Symbol;
    Rc.exports = SC;
  });
  var Lc = E((Mte, Fc) => {
    var Dc = Wr(),
      qc = Object.prototype,
      IC = qc.hasOwnProperty,
      TC = qc.toString,
      Fn = Dc ? Dc.toStringTag : void 0;
    function xC(e) {
      var t = IC.call(e, Fn),
        r = e[Fn];
      try {
        e[Fn] = void 0;
        var n = !0;
      } catch {}
      var i = TC.call(e);
      return n && (t ? (e[Fn] = r) : delete e[Fn]), i;
    }
    Fc.exports = xC;
  });
  var kc = E((Ote, Nc) => {
    var AC = Object.prototype,
      PC = AC.toString;
    function CC(e) {
      return PC.call(e);
    }
    Nc.exports = CC;
  });
  var nr = E((Rte, Gc) => {
    var Bc = Wr(),
      wC = Lc(),
      MC = kc(),
      OC = "[object Null]",
      RC = "[object Undefined]",
      Vc = Bc ? Bc.toStringTag : void 0;
    function DC(e) {
      return e == null
        ? e === void 0
          ? RC
          : OC
        : Vc && Vc in Object(e)
          ? wC(e)
          : MC(e);
    }
    Gc.exports = DC;
  });
  var Ot = E((Dte, zc) => {
    function qC(e) {
      var t = typeof e;
      return e != null && (t == "object" || t == "function");
    }
    zc.exports = qC;
  });
  var so = E((qte, jc) => {
    var FC = nr(),
      LC = Ot(),
      NC = "[object AsyncFunction]",
      kC = "[object Function]",
      BC = "[object GeneratorFunction]",
      VC = "[object Proxy]";
    function GC(e) {
      if (!LC(e)) return !1;
      var t = FC(e);
      return t == kC || t == BC || t == NC || t == VC;
    }
    jc.exports = GC;
  });
  var Wc = E((Fte, Hc) => {
    var zC = _t(),
      jC = zC["__core-js_shared__"];
    Hc.exports = jC;
  });
  var $c = E((Lte, Uc) => {
    var oo = Wc(),
      Xc = (function () {
        var e = /[^.]+$/.exec((oo && oo.keys && oo.keys.IE_PROTO) || "");
        return e ? "Symbol(src)_1." + e : "";
      })();
    function HC(e) {
      return !!Xc && Xc in e;
    }
    Uc.exports = HC;
  });
  var lo = E((Nte, Kc) => {
    var WC = Function.prototype,
      XC = WC.toString;
    function UC(e) {
      if (e != null) {
        try {
          return XC.call(e);
        } catch {}
        try {
          return e + "";
        } catch {}
      }
      return "";
    }
    Kc.exports = UC;
  });
  var Qc = E((kte, Yc) => {
    var $C = so(),
      KC = $c(),
      YC = Ot(),
      QC = lo(),
      ZC = /[\\^$.*+?()[\]{}|]/g,
      JC = /^\[object .+?Constructor\]$/,
      ew = Function.prototype,
      tw = Object.prototype,
      rw = ew.toString,
      nw = tw.hasOwnProperty,
      iw = RegExp(
        "^" +
          rw
            .call(nw)
            .replace(ZC, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?",
            ) +
          "$",
      );
    function aw(e) {
      if (!YC(e) || KC(e)) return !1;
      var t = $C(e) ? iw : JC;
      return t.test(QC(e));
    }
    Yc.exports = aw;
  });
  var Jc = E((Bte, Zc) => {
    function sw(e, t) {
      return e?.[t];
    }
    Zc.exports = sw;
  });
  var ir = E((Vte, ef) => {
    var ow = Qc(),
      lw = Jc();
    function uw(e, t) {
      var r = lw(e, t);
      return ow(r) ? r : void 0;
    }
    ef.exports = uw;
  });
  var Vi = E((Gte, tf) => {
    var hw = ir(),
      cw = _t(),
      fw = hw(cw, "Map");
    tf.exports = fw;
  });
  var Ln = E((zte, rf) => {
    var pw = ir(),
      dw = pw(Object, "create");
    rf.exports = dw;
  });
  var sf = E((jte, af) => {
    var nf = Ln();
    function mw() {
      (this.__data__ = nf ? nf(null) : {}), (this.size = 0);
    }
    af.exports = mw;
  });
  var lf = E((Hte, of) => {
    function vw(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    of.exports = vw;
  });
  var hf = E((Wte, uf) => {
    var gw = Ln(),
      yw = "__lodash_hash_undefined__",
      Ew = Object.prototype,
      _w = Ew.hasOwnProperty;
    function bw(e) {
      var t = this.__data__;
      if (gw) {
        var r = t[e];
        return r === yw ? void 0 : r;
      }
      return _w.call(t, e) ? t[e] : void 0;
    }
    uf.exports = bw;
  });
  var ff = E((Xte, cf) => {
    var Sw = Ln(),
      Iw = Object.prototype,
      Tw = Iw.hasOwnProperty;
    function xw(e) {
      var t = this.__data__;
      return Sw ? t[e] !== void 0 : Tw.call(t, e);
    }
    cf.exports = xw;
  });
  var df = E((Ute, pf) => {
    var Aw = Ln(),
      Pw = "__lodash_hash_undefined__";
    function Cw(e, t) {
      var r = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (r[e] = Aw && t === void 0 ? Pw : t),
        this
      );
    }
    pf.exports = Cw;
  });
  var vf = E(($te, mf) => {
    var ww = sf(),
      Mw = lf(),
      Ow = hf(),
      Rw = ff(),
      Dw = df();
    function Xr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    Xr.prototype.clear = ww;
    Xr.prototype.delete = Mw;
    Xr.prototype.get = Ow;
    Xr.prototype.has = Rw;
    Xr.prototype.set = Dw;
    mf.exports = Xr;
  });
  var Ef = E((Kte, yf) => {
    var gf = vf(),
      qw = qn(),
      Fw = Vi();
    function Lw() {
      (this.size = 0),
        (this.__data__ = {
          hash: new gf(),
          map: new (Fw || qw)(),
          string: new gf(),
        });
    }
    yf.exports = Lw;
  });
  var bf = E((Yte, _f) => {
    function Nw(e) {
      var t = typeof e;
      return t == "string" || t == "number" || t == "symbol" || t == "boolean"
        ? e !== "__proto__"
        : e === null;
    }
    _f.exports = Nw;
  });
  var Nn = E((Qte, Sf) => {
    var kw = bf();
    function Bw(e, t) {
      var r = e.__data__;
      return kw(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
    }
    Sf.exports = Bw;
  });
  var Tf = E((Zte, If) => {
    var Vw = Nn();
    function Gw(e) {
      var t = Vw(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    If.exports = Gw;
  });
  var Af = E((Jte, xf) => {
    var zw = Nn();
    function jw(e) {
      return zw(this, e).get(e);
    }
    xf.exports = jw;
  });
  var Cf = E((ere, Pf) => {
    var Hw = Nn();
    function Ww(e) {
      return Hw(this, e).has(e);
    }
    Pf.exports = Ww;
  });
  var Mf = E((tre, wf) => {
    var Xw = Nn();
    function Uw(e, t) {
      var r = Xw(this, e),
        n = r.size;
      return r.set(e, t), (this.size += r.size == n ? 0 : 1), this;
    }
    wf.exports = Uw;
  });
  var Gi = E((rre, Of) => {
    var $w = Ef(),
      Kw = Tf(),
      Yw = Af(),
      Qw = Cf(),
      Zw = Mf();
    function Ur(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    Ur.prototype.clear = $w;
    Ur.prototype.delete = Kw;
    Ur.prototype.get = Yw;
    Ur.prototype.has = Qw;
    Ur.prototype.set = Zw;
    Of.exports = Ur;
  });
  var Df = E((nre, Rf) => {
    var Jw = qn(),
      eM = Vi(),
      tM = Gi(),
      rM = 200;
    function nM(e, t) {
      var r = this.__data__;
      if (r instanceof Jw) {
        var n = r.__data__;
        if (!eM || n.length < rM - 1)
          return n.push([e, t]), (this.size = ++r.size), this;
        r = this.__data__ = new tM(n);
      }
      return r.set(e, t), (this.size = r.size), this;
    }
    Rf.exports = nM;
  });
  var uo = E((ire, qf) => {
    var iM = qn(),
      aM = Ic(),
      sM = xc(),
      oM = Pc(),
      lM = wc(),
      uM = Df();
    function $r(e) {
      var t = (this.__data__ = new iM(e));
      this.size = t.size;
    }
    $r.prototype.clear = aM;
    $r.prototype.delete = sM;
    $r.prototype.get = oM;
    $r.prototype.has = lM;
    $r.prototype.set = uM;
    qf.exports = $r;
  });
  var Lf = E((are, Ff) => {
    var hM = "__lodash_hash_undefined__";
    function cM(e) {
      return this.__data__.set(e, hM), this;
    }
    Ff.exports = cM;
  });
  var kf = E((sre, Nf) => {
    function fM(e) {
      return this.__data__.has(e);
    }
    Nf.exports = fM;
  });
  var Vf = E((ore, Bf) => {
    var pM = Gi(),
      dM = Lf(),
      mM = kf();
    function zi(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.__data__ = new pM(); ++t < r; ) this.add(e[t]);
    }
    zi.prototype.add = zi.prototype.push = dM;
    zi.prototype.has = mM;
    Bf.exports = zi;
  });
  var zf = E((lre, Gf) => {
    function vM(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
        if (t(e[r], r, e)) return !0;
      return !1;
    }
    Gf.exports = vM;
  });
  var Hf = E((ure, jf) => {
    function gM(e, t) {
      return e.has(t);
    }
    jf.exports = gM;
  });
  var ho = E((hre, Wf) => {
    var yM = Vf(),
      EM = zf(),
      _M = Hf(),
      bM = 1,
      SM = 2;
    function IM(e, t, r, n, i, a) {
      var s = r & bM,
        o = e.length,
        l = t.length;
      if (o != l && !(s && l > o)) return !1;
      var f = a.get(e),
        u = a.get(t);
      if (f && u) return f == t && u == e;
      var c = -1,
        v = !0,
        d = r & SM ? new yM() : void 0;
      for (a.set(e, t), a.set(t, e); ++c < o; ) {
        var p = e[c],
          m = t[c];
        if (n) var h = s ? n(m, p, c, t, e, a) : n(p, m, c, e, t, a);
        if (h !== void 0) {
          if (h) continue;
          v = !1;
          break;
        }
        if (d) {
          if (
            !EM(t, function (g, y) {
              if (!_M(d, y) && (p === g || i(p, g, r, n, a))) return d.push(y);
            })
          ) {
            v = !1;
            break;
          }
        } else if (!(p === m || i(p, m, r, n, a))) {
          v = !1;
          break;
        }
      }
      return a.delete(e), a.delete(t), v;
    }
    Wf.exports = IM;
  });
  var Uf = E((cre, Xf) => {
    var TM = _t(),
      xM = TM.Uint8Array;
    Xf.exports = xM;
  });
  var Kf = E((fre, $f) => {
    function AM(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n, i) {
          r[++t] = [i, n];
        }),
        r
      );
    }
    $f.exports = AM;
  });
  var Qf = E((pre, Yf) => {
    function PM(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n) {
          r[++t] = n;
        }),
        r
      );
    }
    Yf.exports = PM;
  });
  var rp = E((dre, tp) => {
    var Zf = Wr(),
      Jf = Uf(),
      CM = Bi(),
      wM = ho(),
      MM = Kf(),
      OM = Qf(),
      RM = 1,
      DM = 2,
      qM = "[object Boolean]",
      FM = "[object Date]",
      LM = "[object Error]",
      NM = "[object Map]",
      kM = "[object Number]",
      BM = "[object RegExp]",
      VM = "[object Set]",
      GM = "[object String]",
      zM = "[object Symbol]",
      jM = "[object ArrayBuffer]",
      HM = "[object DataView]",
      ep = Zf ? Zf.prototype : void 0,
      co = ep ? ep.valueOf : void 0;
    function WM(e, t, r, n, i, a, s) {
      switch (r) {
        case HM:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case jM:
          return !(e.byteLength != t.byteLength || !a(new Jf(e), new Jf(t)));
        case qM:
        case FM:
        case kM:
          return CM(+e, +t);
        case LM:
          return e.name == t.name && e.message == t.message;
        case BM:
        case GM:
          return e == t + "";
        case NM:
          var o = MM;
        case VM:
          var l = n & RM;
          if ((o || (o = OM), e.size != t.size && !l)) return !1;
          var f = s.get(e);
          if (f) return f == t;
          (n |= DM), s.set(e, t);
          var u = wM(o(e), o(t), n, i, a, s);
          return s.delete(e), u;
        case zM:
          if (co) return co.call(e) == co.call(t);
      }
      return !1;
    }
    tp.exports = WM;
  });
  var ji = E((mre, np) => {
    function XM(e, t) {
      for (var r = -1, n = t.length, i = e.length; ++r < n; ) e[i + r] = t[r];
      return e;
    }
    np.exports = XM;
  });
  var ke = E((vre, ip) => {
    var UM = Array.isArray;
    ip.exports = UM;
  });
  var fo = E((gre, ap) => {
    var $M = ji(),
      KM = ke();
    function YM(e, t, r) {
      var n = t(e);
      return KM(e) ? n : $M(n, r(e));
    }
    ap.exports = YM;
  });
  var op = E((yre, sp) => {
    function QM(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
        var s = e[r];
        t(s, r, e) && (a[i++] = s);
      }
      return a;
    }
    sp.exports = QM;
  });
  var po = E((Ere, lp) => {
    function ZM() {
      return [];
    }
    lp.exports = ZM;
  });
  var mo = E((_re, hp) => {
    var JM = op(),
      eO = po(),
      tO = Object.prototype,
      rO = tO.propertyIsEnumerable,
      up = Object.getOwnPropertySymbols,
      nO = up
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                JM(up(e), function (t) {
                  return rO.call(e, t);
                }));
          }
        : eO;
    hp.exports = nO;
  });
  var fp = E((bre, cp) => {
    function iO(e, t) {
      for (var r = -1, n = Array(e); ++r < e; ) n[r] = t(r);
      return n;
    }
    cp.exports = iO;
  });
  var Ht = E((Sre, pp) => {
    function aO(e) {
      return e != null && typeof e == "object";
    }
    pp.exports = aO;
  });
  var mp = E((Ire, dp) => {
    var sO = nr(),
      oO = Ht(),
      lO = "[object Arguments]";
    function uO(e) {
      return oO(e) && sO(e) == lO;
    }
    dp.exports = uO;
  });
  var kn = E((Tre, yp) => {
    var vp = mp(),
      hO = Ht(),
      gp = Object.prototype,
      cO = gp.hasOwnProperty,
      fO = gp.propertyIsEnumerable,
      pO = vp(
        (function () {
          return arguments;
        })(),
      )
        ? vp
        : function (e) {
            return hO(e) && cO.call(e, "callee") && !fO.call(e, "callee");
          };
    yp.exports = pO;
  });
  var _p = E((xre, Ep) => {
    function dO() {
      return !1;
    }
    Ep.exports = dO;
  });
  var Hi = E((Bn, Kr) => {
    var mO = _t(),
      vO = _p(),
      Ip = typeof Bn == "object" && Bn && !Bn.nodeType && Bn,
      bp = Ip && typeof Kr == "object" && Kr && !Kr.nodeType && Kr,
      gO = bp && bp.exports === Ip,
      Sp = gO ? mO.Buffer : void 0,
      yO = Sp ? Sp.isBuffer : void 0,
      EO = yO || vO;
    Kr.exports = EO;
  });
  var Wi = E((Are, Tp) => {
    var _O = 9007199254740991,
      bO = /^(?:0|[1-9]\d*)$/;
    function SO(e, t) {
      var r = typeof e;
      return (
        (t = t ?? _O),
        !!t &&
          (r == "number" || (r != "symbol" && bO.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
      );
    }
    Tp.exports = SO;
  });
  var Xi = E((Pre, xp) => {
    var IO = 9007199254740991;
    function TO(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= IO;
    }
    xp.exports = TO;
  });
  var Pp = E((Cre, Ap) => {
    var xO = nr(),
      AO = Xi(),
      PO = Ht(),
      CO = "[object Arguments]",
      wO = "[object Array]",
      MO = "[object Boolean]",
      OO = "[object Date]",
      RO = "[object Error]",
      DO = "[object Function]",
      qO = "[object Map]",
      FO = "[object Number]",
      LO = "[object Object]",
      NO = "[object RegExp]",
      kO = "[object Set]",
      BO = "[object String]",
      VO = "[object WeakMap]",
      GO = "[object ArrayBuffer]",
      zO = "[object DataView]",
      jO = "[object Float32Array]",
      HO = "[object Float64Array]",
      WO = "[object Int8Array]",
      XO = "[object Int16Array]",
      UO = "[object Int32Array]",
      $O = "[object Uint8Array]",
      KO = "[object Uint8ClampedArray]",
      YO = "[object Uint16Array]",
      QO = "[object Uint32Array]",
      ye = {};
    ye[jO] =
      ye[HO] =
      ye[WO] =
      ye[XO] =
      ye[UO] =
      ye[$O] =
      ye[KO] =
      ye[YO] =
      ye[QO] =
        !0;
    ye[CO] =
      ye[wO] =
      ye[GO] =
      ye[MO] =
      ye[zO] =
      ye[OO] =
      ye[RO] =
      ye[DO] =
      ye[qO] =
      ye[FO] =
      ye[LO] =
      ye[NO] =
      ye[kO] =
      ye[BO] =
      ye[VO] =
        !1;
    function ZO(e) {
      return PO(e) && AO(e.length) && !!ye[xO(e)];
    }
    Ap.exports = ZO;
  });
  var wp = E((wre, Cp) => {
    function JO(e) {
      return function (t) {
        return e(t);
      };
    }
    Cp.exports = JO;
  });
  var Op = E((Vn, Yr) => {
    var eR = ao(),
      Mp = typeof Vn == "object" && Vn && !Vn.nodeType && Vn,
      Gn = Mp && typeof Yr == "object" && Yr && !Yr.nodeType && Yr,
      tR = Gn && Gn.exports === Mp,
      vo = tR && eR.process,
      rR = (function () {
        try {
          var e = Gn && Gn.require && Gn.require("util").types;
          return e || (vo && vo.binding && vo.binding("util"));
        } catch {}
      })();
    Yr.exports = rR;
  });
  var Ui = E((Mre, qp) => {
    var nR = Pp(),
      iR = wp(),
      Rp = Op(),
      Dp = Rp && Rp.isTypedArray,
      aR = Dp ? iR(Dp) : nR;
    qp.exports = aR;
  });
  var go = E((Ore, Fp) => {
    var sR = fp(),
      oR = kn(),
      lR = ke(),
      uR = Hi(),
      hR = Wi(),
      cR = Ui(),
      fR = Object.prototype,
      pR = fR.hasOwnProperty;
    function dR(e, t) {
      var r = lR(e),
        n = !r && oR(e),
        i = !r && !n && uR(e),
        a = !r && !n && !i && cR(e),
        s = r || n || i || a,
        o = s ? sR(e.length, String) : [],
        l = o.length;
      for (var f in e)
        (t || pR.call(e, f)) &&
          !(
            s &&
            (f == "length" ||
              (i && (f == "offset" || f == "parent")) ||
              (a &&
                (f == "buffer" || f == "byteLength" || f == "byteOffset")) ||
              hR(f, l))
          ) &&
          o.push(f);
      return o;
    }
    Fp.exports = dR;
  });
  var $i = E((Rre, Lp) => {
    var mR = Object.prototype;
    function vR(e) {
      var t = e && e.constructor,
        r = (typeof t == "function" && t.prototype) || mR;
      return e === r;
    }
    Lp.exports = vR;
  });
  var yo = E((Dre, Np) => {
    function gR(e, t) {
      return function (r) {
        return e(t(r));
      };
    }
    Np.exports = gR;
  });
  var Bp = E((qre, kp) => {
    var yR = yo(),
      ER = yR(Object.keys, Object);
    kp.exports = ER;
  });
  var Ki = E((Fre, Vp) => {
    var _R = $i(),
      bR = Bp(),
      SR = Object.prototype,
      IR = SR.hasOwnProperty;
    function TR(e) {
      if (!_R(e)) return bR(e);
      var t = [];
      for (var r in Object(e)) IR.call(e, r) && r != "constructor" && t.push(r);
      return t;
    }
    Vp.exports = TR;
  });
  var Ir = E((Lre, Gp) => {
    var xR = so(),
      AR = Xi();
    function PR(e) {
      return e != null && AR(e.length) && !xR(e);
    }
    Gp.exports = PR;
  });
  var zn = E((Nre, zp) => {
    var CR = go(),
      wR = Ki(),
      MR = Ir();
    function OR(e) {
      return MR(e) ? CR(e) : wR(e);
    }
    zp.exports = OR;
  });
  var Hp = E((kre, jp) => {
    var RR = fo(),
      DR = mo(),
      qR = zn();
    function FR(e) {
      return RR(e, qR, DR);
    }
    jp.exports = FR;
  });
  var Up = E((Bre, Xp) => {
    var Wp = Hp(),
      LR = 1,
      NR = Object.prototype,
      kR = NR.hasOwnProperty;
    function BR(e, t, r, n, i, a) {
      var s = r & LR,
        o = Wp(e),
        l = o.length,
        f = Wp(t),
        u = f.length;
      if (l != u && !s) return !1;
      for (var c = l; c--; ) {
        var v = o[c];
        if (!(s ? v in t : kR.call(t, v))) return !1;
      }
      var d = a.get(e),
        p = a.get(t);
      if (d && p) return d == t && p == e;
      var m = !0;
      a.set(e, t), a.set(t, e);
      for (var h = s; ++c < l; ) {
        v = o[c];
        var g = e[v],
          y = t[v];
        if (n) var _ = s ? n(y, g, v, t, e, a) : n(g, y, v, e, t, a);
        if (!(_ === void 0 ? g === y || i(g, y, r, n, a) : _)) {
          m = !1;
          break;
        }
        h || (h = v == "constructor");
      }
      if (m && !h) {
        var b = e.constructor,
          I = t.constructor;
        b != I &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            typeof b == "function" &&
            b instanceof b &&
            typeof I == "function" &&
            I instanceof I
          ) &&
          (m = !1);
      }
      return a.delete(e), a.delete(t), m;
    }
    Xp.exports = BR;
  });
  var Kp = E((Vre, $p) => {
    var VR = ir(),
      GR = _t(),
      zR = VR(GR, "DataView");
    $p.exports = zR;
  });
  var Qp = E((Gre, Yp) => {
    var jR = ir(),
      HR = _t(),
      WR = jR(HR, "Promise");
    Yp.exports = WR;
  });
  var Jp = E((zre, Zp) => {
    var XR = ir(),
      UR = _t(),
      $R = XR(UR, "Set");
    Zp.exports = $R;
  });
  var Eo = E((jre, ed) => {
    var KR = ir(),
      YR = _t(),
      QR = KR(YR, "WeakMap");
    ed.exports = QR;
  });
  var Yi = E((Hre, od) => {
    var _o = Kp(),
      bo = Vi(),
      So = Qp(),
      Io = Jp(),
      To = Eo(),
      sd = nr(),
      Qr = lo(),
      td = "[object Map]",
      ZR = "[object Object]",
      rd = "[object Promise]",
      nd = "[object Set]",
      id = "[object WeakMap]",
      ad = "[object DataView]",
      JR = Qr(_o),
      eD = Qr(bo),
      tD = Qr(So),
      rD = Qr(Io),
      nD = Qr(To),
      Tr = sd;
    ((_o && Tr(new _o(new ArrayBuffer(1))) != ad) ||
      (bo && Tr(new bo()) != td) ||
      (So && Tr(So.resolve()) != rd) ||
      (Io && Tr(new Io()) != nd) ||
      (To && Tr(new To()) != id)) &&
      (Tr = function (e) {
        var t = sd(e),
          r = t == ZR ? e.constructor : void 0,
          n = r ? Qr(r) : "";
        if (n)
          switch (n) {
            case JR:
              return ad;
            case eD:
              return td;
            case tD:
              return rd;
            case rD:
              return nd;
            case nD:
              return id;
          }
        return t;
      });
    od.exports = Tr;
  });
  var md = E((Wre, dd) => {
    var xo = uo(),
      iD = ho(),
      aD = rp(),
      sD = Up(),
      ld = Yi(),
      ud = ke(),
      hd = Hi(),
      oD = Ui(),
      lD = 1,
      cd = "[object Arguments]",
      fd = "[object Array]",
      Qi = "[object Object]",
      uD = Object.prototype,
      pd = uD.hasOwnProperty;
    function hD(e, t, r, n, i, a) {
      var s = ud(e),
        o = ud(t),
        l = s ? fd : ld(e),
        f = o ? fd : ld(t);
      (l = l == cd ? Qi : l), (f = f == cd ? Qi : f);
      var u = l == Qi,
        c = f == Qi,
        v = l == f;
      if (v && hd(e)) {
        if (!hd(t)) return !1;
        (s = !0), (u = !1);
      }
      if (v && !u)
        return (
          a || (a = new xo()),
          s || oD(e) ? iD(e, t, r, n, i, a) : aD(e, t, l, r, n, i, a)
        );
      if (!(r & lD)) {
        var d = u && pd.call(e, "__wrapped__"),
          p = c && pd.call(t, "__wrapped__");
        if (d || p) {
          var m = d ? e.value() : e,
            h = p ? t.value() : t;
          return a || (a = new xo()), i(m, h, r, n, a);
        }
      }
      return v ? (a || (a = new xo()), sD(e, t, r, n, i, a)) : !1;
    }
    dd.exports = hD;
  });
  var Ao = E((Xre, yd) => {
    var cD = md(),
      vd = Ht();
    function gd(e, t, r, n, i) {
      return e === t
        ? !0
        : e == null || t == null || (!vd(e) && !vd(t))
          ? e !== e && t !== t
          : cD(e, t, r, n, gd, i);
    }
    yd.exports = gd;
  });
  var _d = E((Ure, Ed) => {
    var fD = uo(),
      pD = Ao(),
      dD = 1,
      mD = 2;
    function vD(e, t, r, n) {
      var i = r.length,
        a = i,
        s = !n;
      if (e == null) return !a;
      for (e = Object(e); i--; ) {
        var o = r[i];
        if (s && o[2] ? o[1] !== e[o[0]] : !(o[0] in e)) return !1;
      }
      for (; ++i < a; ) {
        o = r[i];
        var l = o[0],
          f = e[l],
          u = o[1];
        if (s && o[2]) {
          if (f === void 0 && !(l in e)) return !1;
        } else {
          var c = new fD();
          if (n) var v = n(f, u, l, e, t, c);
          if (!(v === void 0 ? pD(u, f, dD | mD, n, c) : v)) return !1;
        }
      }
      return !0;
    }
    Ed.exports = vD;
  });
  var Po = E(($re, bd) => {
    var gD = Ot();
    function yD(e) {
      return e === e && !gD(e);
    }
    bd.exports = yD;
  });
  var Id = E((Kre, Sd) => {
    var ED = Po(),
      _D = zn();
    function bD(e) {
      for (var t = _D(e), r = t.length; r--; ) {
        var n = t[r],
          i = e[n];
        t[r] = [n, i, ED(i)];
      }
      return t;
    }
    Sd.exports = bD;
  });
  var Co = E((Yre, Td) => {
    function SD(e, t) {
      return function (r) {
        return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
      };
    }
    Td.exports = SD;
  });
  var Ad = E((Qre, xd) => {
    var ID = _d(),
      TD = Id(),
      xD = Co();
    function AD(e) {
      var t = TD(e);
      return t.length == 1 && t[0][2]
        ? xD(t[0][0], t[0][1])
        : function (r) {
            return r === e || ID(r, e, t);
          };
    }
    xd.exports = AD;
  });
  var jn = E((Zre, Pd) => {
    var PD = nr(),
      CD = Ht(),
      wD = "[object Symbol]";
    function MD(e) {
      return typeof e == "symbol" || (CD(e) && PD(e) == wD);
    }
    Pd.exports = MD;
  });
  var Zi = E((Jre, Cd) => {
    var OD = ke(),
      RD = jn(),
      DD = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      qD = /^\w*$/;
    function FD(e, t) {
      if (OD(e)) return !1;
      var r = typeof e;
      return r == "number" ||
        r == "symbol" ||
        r == "boolean" ||
        e == null ||
        RD(e)
        ? !0
        : qD.test(e) || !DD.test(e) || (t != null && e in Object(t));
    }
    Cd.exports = FD;
  });
  var Od = E((ene, Md) => {
    var wd = Gi(),
      LD = "Expected a function";
    function wo(e, t) {
      if (typeof e != "function" || (t != null && typeof t != "function"))
        throw new TypeError(LD);
      var r = function () {
        var n = arguments,
          i = t ? t.apply(this, n) : n[0],
          a = r.cache;
        if (a.has(i)) return a.get(i);
        var s = e.apply(this, n);
        return (r.cache = a.set(i, s) || a), s;
      };
      return (r.cache = new (wo.Cache || wd)()), r;
    }
    wo.Cache = wd;
    Md.exports = wo;
  });
  var Dd = E((tne, Rd) => {
    var ND = Od(),
      kD = 500;
    function BD(e) {
      var t = ND(e, function (n) {
          return r.size === kD && r.clear(), n;
        }),
        r = t.cache;
      return t;
    }
    Rd.exports = BD;
  });
  var Fd = E((rne, qd) => {
    var VD = Dd(),
      GD =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      zD = /\\(\\)?/g,
      jD = VD(function (e) {
        var t = [];
        return (
          e.charCodeAt(0) === 46 && t.push(""),
          e.replace(GD, function (r, n, i, a) {
            t.push(i ? a.replace(zD, "$1") : n || r);
          }),
          t
        );
      });
    qd.exports = jD;
  });
  var Mo = E((nne, Ld) => {
    function HD(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
        i[r] = t(e[r], r, e);
      return i;
    }
    Ld.exports = HD;
  });
  var zd = E((ine, Gd) => {
    var Nd = Wr(),
      WD = Mo(),
      XD = ke(),
      UD = jn(),
      $D = 1 / 0,
      kd = Nd ? Nd.prototype : void 0,
      Bd = kd ? kd.toString : void 0;
    function Vd(e) {
      if (typeof e == "string") return e;
      if (XD(e)) return WD(e, Vd) + "";
      if (UD(e)) return Bd ? Bd.call(e) : "";
      var t = e + "";
      return t == "0" && 1 / e == -$D ? "-0" : t;
    }
    Gd.exports = Vd;
  });
  var Hd = E((ane, jd) => {
    var KD = zd();
    function YD(e) {
      return e == null ? "" : KD(e);
    }
    jd.exports = YD;
  });
  var Hn = E((sne, Wd) => {
    var QD = ke(),
      ZD = Zi(),
      JD = Fd(),
      eq = Hd();
    function tq(e, t) {
      return QD(e) ? e : ZD(e, t) ? [e] : JD(eq(e));
    }
    Wd.exports = tq;
  });
  var Zr = E((one, Xd) => {
    var rq = jn(),
      nq = 1 / 0;
    function iq(e) {
      if (typeof e == "string" || rq(e)) return e;
      var t = e + "";
      return t == "0" && 1 / e == -nq ? "-0" : t;
    }
    Xd.exports = iq;
  });
  var Ji = E((lne, Ud) => {
    var aq = Hn(),
      sq = Zr();
    function oq(e, t) {
      t = aq(t, e);
      for (var r = 0, n = t.length; e != null && r < n; ) e = e[sq(t[r++])];
      return r && r == n ? e : void 0;
    }
    Ud.exports = oq;
  });
  var ea = E((une, $d) => {
    var lq = Ji();
    function uq(e, t, r) {
      var n = e == null ? void 0 : lq(e, t);
      return n === void 0 ? r : n;
    }
    $d.exports = uq;
  });
  var Yd = E((hne, Kd) => {
    function hq(e, t) {
      return e != null && t in Object(e);
    }
    Kd.exports = hq;
  });
  var Zd = E((cne, Qd) => {
    var cq = Hn(),
      fq = kn(),
      pq = ke(),
      dq = Wi(),
      mq = Xi(),
      vq = Zr();
    function gq(e, t, r) {
      t = cq(t, e);
      for (var n = -1, i = t.length, a = !1; ++n < i; ) {
        var s = vq(t[n]);
        if (!(a = e != null && r(e, s))) break;
        e = e[s];
      }
      return a || ++n != i
        ? a
        : ((i = e == null ? 0 : e.length),
          !!i && mq(i) && dq(s, i) && (pq(e) || fq(e)));
    }
    Qd.exports = gq;
  });
  var em = E((fne, Jd) => {
    var yq = Yd(),
      Eq = Zd();
    function _q(e, t) {
      return e != null && Eq(e, t, yq);
    }
    Jd.exports = _q;
  });
  var rm = E((pne, tm) => {
    var bq = Ao(),
      Sq = ea(),
      Iq = em(),
      Tq = Zi(),
      xq = Po(),
      Aq = Co(),
      Pq = Zr(),
      Cq = 1,
      wq = 2;
    function Mq(e, t) {
      return Tq(e) && xq(t)
        ? Aq(Pq(e), t)
        : function (r) {
            var n = Sq(r, e);
            return n === void 0 && n === t ? Iq(r, e) : bq(t, n, Cq | wq);
          };
    }
    tm.exports = Mq;
  });
  var ta = E((dne, nm) => {
    function Oq(e) {
      return e;
    }
    nm.exports = Oq;
  });
  var Oo = E((mne, im) => {
    function Rq(e) {
      return function (t) {
        return t?.[e];
      };
    }
    im.exports = Rq;
  });
  var sm = E((vne, am) => {
    var Dq = Ji();
    function qq(e) {
      return function (t) {
        return Dq(t, e);
      };
    }
    am.exports = qq;
  });
  var lm = E((gne, om) => {
    var Fq = Oo(),
      Lq = sm(),
      Nq = Zi(),
      kq = Zr();
    function Bq(e) {
      return Nq(e) ? Fq(kq(e)) : Lq(e);
    }
    om.exports = Bq;
  });
  var ar = E((yne, um) => {
    var Vq = Ad(),
      Gq = rm(),
      zq = ta(),
      jq = ke(),
      Hq = lm();
    function Wq(e) {
      return typeof e == "function"
        ? e
        : e == null
          ? zq
          : typeof e == "object"
            ? jq(e)
              ? Gq(e[0], e[1])
              : Vq(e)
            : Hq(e);
    }
    um.exports = Wq;
  });
  var cm = E((Ene, hm) => {
    var Xq = /\s/;
    function Uq(e) {
      for (var t = e.length; t-- && Xq.test(e.charAt(t)); );
      return t;
    }
    hm.exports = Uq;
  });
  var pm = E((_ne, fm) => {
    var $q = cm(),
      Kq = /^\s+/;
    function Yq(e) {
      return e && e.slice(0, $q(e) + 1).replace(Kq, "");
    }
    fm.exports = Yq;
  });
  var ra = E((bne, vm) => {
    var Qq = pm(),
      dm = Ot(),
      Zq = jn(),
      mm = 0 / 0,
      Jq = /^[-+]0x[0-9a-f]+$/i,
      eF = /^0b[01]+$/i,
      tF = /^0o[0-7]+$/i,
      rF = parseInt;
    function nF(e) {
      if (typeof e == "number") return e;
      if (Zq(e)) return mm;
      if (dm(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = dm(t) ? t + "" : t;
      }
      if (typeof e != "string") return e === 0 ? e : +e;
      e = Qq(e);
      var r = eF.test(e);
      return r || tF.test(e) ? rF(e.slice(2), r ? 2 : 8) : Jq.test(e) ? mm : +e;
    }
    vm.exports = nF;
  });
  var Em = E((Sne, ym) => {
    var iF = ra(),
      gm = 1 / 0,
      aF = 17976931348623157e292;
    function sF(e) {
      if (!e) return e === 0 ? e : 0;
      if (((e = iF(e)), e === gm || e === -gm)) {
        var t = e < 0 ? -1 : 1;
        return t * aF;
      }
      return e === e ? e : 0;
    }
    ym.exports = sF;
  });
  var Ro = E((Ine, _m) => {
    var oF = Em();
    function lF(e) {
      var t = oF(e),
        r = t % 1;
      return t === t ? (r ? t - r : t) : 0;
    }
    _m.exports = lF;
  });
  var Do = E((Tne, bm) => {
    var uF = io(),
      hF = ar(),
      cF = Ro(),
      fF = Math.max;
    function pF(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var i = r == null ? 0 : cF(r);
      return i < 0 && (i = fF(n + i, 0)), uF(e, hF(t, 3), i);
    }
    bm.exports = pF;
  });
  var Z = E((xne, Sm) => {
    var na = function (e) {
      return e && e.Math == Math && e;
    };
    Sm.exports =
      na(typeof globalThis == "object" && globalThis) ||
      na(typeof window == "object" && window) ||
      na(typeof self == "object" && self) ||
      na(typeof global == "object" && global) ||
      (function () {
        return this;
      })() ||
      Function("return this")();
  });
  var Fe = E((Ane, Im) => {
    Im.exports = function (e) {
      try {
        return !!e();
      } catch {
        return !0;
      }
    };
  });
  var bt = E((Pne, Tm) => {
    var dF = Fe();
    Tm.exports = !dF(function () {
      return (
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1] != 7
      );
    });
  });
  var ot = E((Cne, xm) => {
    var Wn = Function.prototype.call;
    xm.exports = Wn.bind
      ? Wn.bind(Wn)
      : function () {
          return Wn.apply(Wn, arguments);
        };
  });
  var wm = E((Cm) => {
    "use strict";
    var Am = {}.propertyIsEnumerable,
      Pm = Object.getOwnPropertyDescriptor,
      mF = Pm && !Am.call({ 1: 2 }, 1);
    Cm.f = mF
      ? function (t) {
          var r = Pm(this, t);
          return !!r && r.enumerable;
        }
      : Am;
  });
  var Xn = E((Mne, Mm) => {
    Mm.exports = function (e, t) {
      return {
        enumerable: !(e & 1),
        configurable: !(e & 2),
        writable: !(e & 4),
        value: t,
      };
    };
  });
  var Ee = E((One, Rm) => {
    var Om = Function.prototype,
      qo = Om.bind,
      Fo = Om.call,
      vF = qo && qo.bind(Fo);
    Rm.exports = qo
      ? function (e) {
          return e && vF(Fo, e);
        }
      : function (e) {
          return (
            e &&
            function () {
              return Fo.apply(e, arguments);
            }
          );
        };
  });
  var Jr = E((Rne, qm) => {
    var Dm = Ee(),
      gF = Dm({}.toString),
      yF = Dm("".slice);
    qm.exports = function (e) {
      return yF(gF(e), 8, -1);
    };
  });
  var xr = E((Dne, Fm) => {
    var EF = Z(),
      _F = Ee(),
      bF = Fe(),
      SF = Jr(),
      Lo = EF.Object,
      IF = _F("".split);
    Fm.exports = bF(function () {
      return !Lo("z").propertyIsEnumerable(0);
    })
      ? function (e) {
          return SF(e) == "String" ? IF(e, "") : Lo(e);
        }
      : Lo;
  });
  var ia = E((qne, Lm) => {
    var TF = Z(),
      xF = TF.TypeError;
    Lm.exports = function (e) {
      if (e == null) throw xF("Can't call method on " + e);
      return e;
    };
  });
  var Rt = E((Fne, Nm) => {
    var AF = xr(),
      PF = ia();
    Nm.exports = function (e) {
      return AF(PF(e));
    };
  });
  var Te = E((Lne, km) => {
    km.exports = function (e) {
      return typeof e == "function";
    };
  });
  var Ke = E((Nne, Bm) => {
    var CF = Te();
    Bm.exports = function (e) {
      return typeof e == "object" ? e !== null : CF(e);
    };
  });
  var lt = E((kne, Vm) => {
    var No = Z(),
      wF = Te(),
      MF = function (e) {
        return wF(e) ? e : void 0;
      };
    Vm.exports = function (e, t) {
      return arguments.length < 2 ? MF(No[e]) : No[e] && No[e][t];
    };
  });
  var aa = E((Bne, Gm) => {
    var OF = Ee();
    Gm.exports = OF({}.isPrototypeOf);
  });
  var sr = E((Vne, zm) => {
    var RF = lt();
    zm.exports = RF("navigator", "userAgent") || "";
  });
  var or = E((Gne, $m) => {
    var Um = Z(),
      ko = sr(),
      jm = Um.process,
      Hm = Um.Deno,
      Wm = (jm && jm.versions) || (Hm && Hm.version),
      Xm = Wm && Wm.v8,
      St,
      sa;
    Xm &&
      ((St = Xm.split(".")),
      (sa = St[0] > 0 && St[0] < 4 ? 1 : +(St[0] + St[1])));
    !sa &&
      ko &&
      ((St = ko.match(/Edge\/(\d+)/)),
      (!St || St[1] >= 74) &&
        ((St = ko.match(/Chrome\/(\d+)/)), St && (sa = +St[1])));
    $m.exports = sa;
  });
  var Bo = E((zne, Ym) => {
    var Km = or(),
      DF = Fe();
    Ym.exports =
      !!Object.getOwnPropertySymbols &&
      !DF(function () {
        var e = Symbol();
        return (
          !String(e) ||
          !(Object(e) instanceof Symbol) ||
          (!Symbol.sham && Km && Km < 41)
        );
      });
  });
  var Vo = E((jne, Qm) => {
    var qF = Bo();
    Qm.exports = qF && !Symbol.sham && typeof Symbol.iterator == "symbol";
  });
  var Go = E((Hne, Zm) => {
    var FF = Z(),
      LF = lt(),
      NF = Te(),
      kF = aa(),
      BF = Vo(),
      VF = FF.Object;
    Zm.exports = BF
      ? function (e) {
          return typeof e == "symbol";
        }
      : function (e) {
          var t = LF("Symbol");
          return NF(t) && kF(t.prototype, VF(e));
        };
  });
  var Un = E((Wne, Jm) => {
    var GF = Z(),
      zF = GF.String;
    Jm.exports = function (e) {
      try {
        return zF(e);
      } catch {
        return "Object";
      }
    };
  });
  var It = E((Xne, ev) => {
    var jF = Z(),
      HF = Te(),
      WF = Un(),
      XF = jF.TypeError;
    ev.exports = function (e) {
      if (HF(e)) return e;
      throw XF(WF(e) + " is not a function");
    };
  });
  var lr = E((Une, tv) => {
    var UF = It();
    tv.exports = function (e, t) {
      var r = e[t];
      return r == null ? void 0 : UF(r);
    };
  });
  var nv = E(($ne, rv) => {
    var $F = Z(),
      zo = ot(),
      jo = Te(),
      Ho = Ke(),
      KF = $F.TypeError;
    rv.exports = function (e, t) {
      var r, n;
      if (
        (t === "string" && jo((r = e.toString)) && !Ho((n = zo(r, e)))) ||
        (jo((r = e.valueOf)) && !Ho((n = zo(r, e)))) ||
        (t !== "string" && jo((r = e.toString)) && !Ho((n = zo(r, e))))
      )
        return n;
      throw KF("Can't convert object to primitive value");
    };
  });
  var en = E((Kne, iv) => {
    iv.exports = !1;
  });
  var oa = E((Yne, sv) => {
    var av = Z(),
      YF = Object.defineProperty;
    sv.exports = function (e, t) {
      try {
        YF(av, e, { value: t, configurable: !0, writable: !0 });
      } catch {
        av[e] = t;
      }
      return t;
    };
  });
  var $n = E((Qne, lv) => {
    var QF = Z(),
      ZF = oa(),
      ov = "__core-js_shared__",
      JF = QF[ov] || ZF(ov, {});
    lv.exports = JF;
  });
  var Wo = E((Zne, hv) => {
    var e2 = en(),
      uv = $n();
    (hv.exports = function (e, t) {
      return uv[e] || (uv[e] = t !== void 0 ? t : {});
    })("versions", []).push({
      version: "3.19.0",
      mode: e2 ? "pure" : "global",
      copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)",
    });
  });
  var Pe = E((Jne, cv) => {
    var t2 = Z(),
      r2 = ia(),
      n2 = t2.Object;
    cv.exports = function (e) {
      return n2(r2(e));
    };
  });
  var ut = E((eie, fv) => {
    var i2 = Ee(),
      a2 = Pe(),
      s2 = i2({}.hasOwnProperty);
    fv.exports =
      Object.hasOwn ||
      function (t, r) {
        return s2(a2(t), r);
      };
  });
  var la = E((tie, pv) => {
    var o2 = Ee(),
      l2 = 0,
      u2 = Math.random(),
      h2 = o2((1).toString);
    pv.exports = function (e) {
      return "Symbol(" + (e === void 0 ? "" : e) + ")_" + h2(++l2 + u2, 36);
    };
  });
  var xe = E((rie, yv) => {
    var c2 = Z(),
      f2 = Wo(),
      dv = ut(),
      p2 = la(),
      mv = Bo(),
      gv = Vo(),
      tn = f2("wks"),
      Ar = c2.Symbol,
      vv = Ar && Ar.for,
      d2 = gv ? Ar : (Ar && Ar.withoutSetter) || p2;
    yv.exports = function (e) {
      if (!dv(tn, e) || !(mv || typeof tn[e] == "string")) {
        var t = "Symbol." + e;
        mv && dv(Ar, e)
          ? (tn[e] = Ar[e])
          : gv && vv
            ? (tn[e] = vv(t))
            : (tn[e] = d2(t));
      }
      return tn[e];
    };
  });
  var Sv = E((nie, bv) => {
    var m2 = Z(),
      v2 = ot(),
      Ev = Ke(),
      _v = Go(),
      g2 = lr(),
      y2 = nv(),
      E2 = xe(),
      _2 = m2.TypeError,
      b2 = E2("toPrimitive");
    bv.exports = function (e, t) {
      if (!Ev(e) || _v(e)) return e;
      var r = g2(e, b2),
        n;
      if (r) {
        if (
          (t === void 0 && (t = "default"), (n = v2(r, e, t)), !Ev(n) || _v(n))
        )
          return n;
        throw _2("Can't convert object to primitive value");
      }
      return t === void 0 && (t = "number"), y2(e, t);
    };
  });
  var Kn = E((iie, Iv) => {
    var S2 = Sv(),
      I2 = Go();
    Iv.exports = function (e) {
      var t = S2(e, "string");
      return I2(t) ? t : t + "";
    };
  });
  var ua = E((aie, xv) => {
    var T2 = Z(),
      Tv = Ke(),
      Xo = T2.document,
      x2 = Tv(Xo) && Tv(Xo.createElement);
    xv.exports = function (e) {
      return x2 ? Xo.createElement(e) : {};
    };
  });
  var Uo = E((sie, Av) => {
    var A2 = bt(),
      P2 = Fe(),
      C2 = ua();
    Av.exports =
      !A2 &&
      !P2(function () {
        return (
          Object.defineProperty(C2("div"), "a", {
            get: function () {
              return 7;
            },
          }).a != 7
        );
      });
  });
  var ha = E((Cv) => {
    var w2 = bt(),
      M2 = ot(),
      O2 = wm(),
      R2 = Xn(),
      D2 = Rt(),
      q2 = Kn(),
      F2 = ut(),
      L2 = Uo(),
      Pv = Object.getOwnPropertyDescriptor;
    Cv.f = w2
      ? Pv
      : function (t, r) {
          if (((t = D2(t)), (r = q2(r)), L2))
            try {
              return Pv(t, r);
            } catch {}
          if (F2(t, r)) return R2(!M2(O2.f, t, r), t[r]);
        };
  });
  var Xe = E((lie, Mv) => {
    var wv = Z(),
      N2 = Ke(),
      k2 = wv.String,
      B2 = wv.TypeError;
    Mv.exports = function (e) {
      if (N2(e)) return e;
      throw B2(k2(e) + " is not an object");
    };
  });
  var ht = E((Dv) => {
    var V2 = Z(),
      G2 = bt(),
      z2 = Uo(),
      Ov = Xe(),
      j2 = Kn(),
      H2 = V2.TypeError,
      Rv = Object.defineProperty;
    Dv.f = G2
      ? Rv
      : function (t, r, n) {
          if ((Ov(t), (r = j2(r)), Ov(n), z2))
            try {
              return Rv(t, r, n);
            } catch {}
          if ("get" in n || "set" in n) throw H2("Accessors not supported");
          return "value" in n && (t[r] = n.value), t;
        };
  });
  var Yn = E((hie, qv) => {
    var W2 = bt(),
      X2 = ht(),
      U2 = Xn();
    qv.exports = W2
      ? function (e, t, r) {
          return X2.f(e, t, U2(1, r));
        }
      : function (e, t, r) {
          return (e[t] = r), e;
        };
  });
  var Qn = E((cie, Fv) => {
    var $2 = Ee(),
      K2 = Te(),
      $o = $n(),
      Y2 = $2(Function.toString);
    K2($o.inspectSource) ||
      ($o.inspectSource = function (e) {
        return Y2(e);
      });
    Fv.exports = $o.inspectSource;
  });
  var kv = E((fie, Nv) => {
    var Q2 = Z(),
      Z2 = Te(),
      J2 = Qn(),
      Lv = Q2.WeakMap;
    Nv.exports = Z2(Lv) && /native code/.test(J2(Lv));
  });
  var ca = E((pie, Vv) => {
    var eL = Wo(),
      tL = la(),
      Bv = eL("keys");
    Vv.exports = function (e) {
      return Bv[e] || (Bv[e] = tL(e));
    };
  });
  var Zn = E((die, Gv) => {
    Gv.exports = {};
  });
  var Cr = E((mie, Xv) => {
    var rL = kv(),
      Wv = Z(),
      Ko = Ee(),
      nL = Ke(),
      iL = Yn(),
      Yo = ut(),
      Qo = $n(),
      aL = ca(),
      sL = Zn(),
      zv = "Object already initialized",
      Jo = Wv.TypeError,
      oL = Wv.WeakMap,
      fa,
      Jn,
      pa,
      lL = function (e) {
        return pa(e) ? Jn(e) : fa(e, {});
      },
      uL = function (e) {
        return function (t) {
          var r;
          if (!nL(t) || (r = Jn(t)).type !== e)
            throw Jo("Incompatible receiver, " + e + " required");
          return r;
        };
      };
    rL || Qo.state
      ? ((ur = Qo.state || (Qo.state = new oL())),
        (jv = Ko(ur.get)),
        (Zo = Ko(ur.has)),
        (Hv = Ko(ur.set)),
        (fa = function (e, t) {
          if (Zo(ur, e)) throw new Jo(zv);
          return (t.facade = e), Hv(ur, e, t), t;
        }),
        (Jn = function (e) {
          return jv(ur, e) || {};
        }),
        (pa = function (e) {
          return Zo(ur, e);
        }))
      : ((Pr = aL("state")),
        (sL[Pr] = !0),
        (fa = function (e, t) {
          if (Yo(e, Pr)) throw new Jo(zv);
          return (t.facade = e), iL(e, Pr, t), t;
        }),
        (Jn = function (e) {
          return Yo(e, Pr) ? e[Pr] : {};
        }),
        (pa = function (e) {
          return Yo(e, Pr);
        }));
    var ur, jv, Zo, Hv, Pr;
    Xv.exports = { set: fa, get: Jn, has: pa, enforce: lL, getterFor: uL };
  });
  var rl = E((vie, $v) => {
    var el = bt(),
      hL = ut(),
      Uv = Function.prototype,
      cL = el && Object.getOwnPropertyDescriptor,
      tl = hL(Uv, "name"),
      fL = tl && function () {}.name === "something",
      pL = tl && (!el || (el && cL(Uv, "name").configurable));
    $v.exports = { EXISTS: tl, PROPER: fL, CONFIGURABLE: pL };
  });
  var Wt = E((gie, Zv) => {
    var dL = Z(),
      Kv = Te(),
      mL = ut(),
      Yv = Yn(),
      vL = oa(),
      gL = Qn(),
      Qv = Cr(),
      yL = rl().CONFIGURABLE,
      EL = Qv.get,
      _L = Qv.enforce,
      bL = String(String).split("String");
    (Zv.exports = function (e, t, r, n) {
      var i = n ? !!n.unsafe : !1,
        a = n ? !!n.enumerable : !1,
        s = n ? !!n.noTargetGet : !1,
        o = n && n.name !== void 0 ? n.name : t,
        l;
      if (
        (Kv(r) &&
          (String(o).slice(0, 7) === "Symbol(" &&
            (o = "[" + String(o).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
          (!mL(r, "name") || (yL && r.name !== o)) && Yv(r, "name", o),
          (l = _L(r)),
          l.source || (l.source = bL.join(typeof o == "string" ? o : ""))),
        e === dL)
      ) {
        a ? (e[t] = r) : vL(t, r);
        return;
      } else i ? !s && e[t] && (a = !0) : delete e[t];
      a ? (e[t] = r) : Yv(e, t, r);
    })(Function.prototype, "toString", function () {
      return (Kv(this) && EL(this).source) || gL(this);
    });
  });
  var hr = E((yie, Jv) => {
    var SL = Math.ceil,
      IL = Math.floor;
    Jv.exports = function (e) {
      var t = +e;
      return t !== t || t === 0 ? 0 : (t > 0 ? IL : SL)(t);
    };
  });
  var rn = E((Eie, eg) => {
    var TL = hr(),
      xL = Math.max,
      AL = Math.min;
    eg.exports = function (e, t) {
      var r = TL(e);
      return r < 0 ? xL(r + t, 0) : AL(r, t);
    };
  });
  var rg = E((_ie, tg) => {
    var PL = hr(),
      CL = Math.min;
    tg.exports = function (e) {
      return e > 0 ? CL(PL(e), 9007199254740991) : 0;
    };
  });
  var Se = E((bie, ng) => {
    var wL = rg();
    ng.exports = function (e) {
      return wL(e.length);
    };
  });
  var da = E((Sie, ag) => {
    var ML = Rt(),
      OL = rn(),
      RL = Se(),
      ig = function (e) {
        return function (t, r, n) {
          var i = ML(t),
            a = RL(i),
            s = OL(n, a),
            o;
          if (e && r != r) {
            for (; a > s; ) if (((o = i[s++]), o != o)) return !0;
          } else
            for (; a > s; s++)
              if ((e || s in i) && i[s] === r) return e || s || 0;
          return !e && -1;
        };
      };
    ag.exports = { includes: ig(!0), indexOf: ig(!1) };
  });
  var il = E((Iie, og) => {
    var DL = Ee(),
      nl = ut(),
      qL = Rt(),
      FL = da().indexOf,
      LL = Zn(),
      sg = DL([].push);
    og.exports = function (e, t) {
      var r = qL(e),
        n = 0,
        i = [],
        a;
      for (a in r) !nl(LL, a) && nl(r, a) && sg(i, a);
      for (; t.length > n; ) nl(r, (a = t[n++])) && (~FL(i, a) || sg(i, a));
      return i;
    };
  });
  var ma = E((Tie, lg) => {
    lg.exports = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ];
  });
  var va = E((ug) => {
    var NL = il(),
      kL = ma(),
      BL = kL.concat("length", "prototype");
    ug.f =
      Object.getOwnPropertyNames ||
      function (t) {
        return NL(t, BL);
      };
  });
  var cg = E((hg) => {
    hg.f = Object.getOwnPropertySymbols;
  });
  var pg = E((Pie, fg) => {
    var VL = lt(),
      GL = Ee(),
      zL = va(),
      jL = cg(),
      HL = Xe(),
      WL = GL([].concat);
    fg.exports =
      VL("Reflect", "ownKeys") ||
      function (t) {
        var r = zL.f(HL(t)),
          n = jL.f;
        return n ? WL(r, n(t)) : r;
      };
  });
  var mg = E((Cie, dg) => {
    var XL = ut(),
      UL = pg(),
      $L = ha(),
      KL = ht();
    dg.exports = function (e, t) {
      for (var r = UL(t), n = KL.f, i = $L.f, a = 0; a < r.length; a++) {
        var s = r[a];
        XL(e, s) || n(e, s, i(t, s));
      }
    };
  });
  var ga = E((wie, vg) => {
    var YL = Fe(),
      QL = Te(),
      ZL = /#|\.prototype\./,
      ei = function (e, t) {
        var r = eN[JL(e)];
        return r == rN ? !0 : r == tN ? !1 : QL(t) ? YL(t) : !!t;
      },
      JL = (ei.normalize = function (e) {
        return String(e).replace(ZL, ".").toLowerCase();
      }),
      eN = (ei.data = {}),
      tN = (ei.NATIVE = "N"),
      rN = (ei.POLYFILL = "P");
    vg.exports = ei;
  });
  var ae = E((Mie, gg) => {
    var al = Z(),
      nN = ha().f,
      iN = Yn(),
      aN = Wt(),
      sN = oa(),
      oN = mg(),
      lN = ga();
    gg.exports = function (e, t) {
      var r = e.target,
        n = e.global,
        i = e.stat,
        a,
        s,
        o,
        l,
        f,
        u;
      if (
        (n
          ? (s = al)
          : i
            ? (s = al[r] || sN(r, {}))
            : (s = (al[r] || {}).prototype),
        s)
      )
        for (o in t) {
          if (
            ((f = t[o]),
            e.noTargetGet ? ((u = nN(s, o)), (l = u && u.value)) : (l = s[o]),
            (a = lN(n ? o : r + (i ? "." : "#") + o, e.forced)),
            !a && l !== void 0)
          ) {
            if (typeof f == typeof l) continue;
            oN(f, l);
          }
          (e.sham || (l && l.sham)) && iN(f, "sham", !0), aN(s, o, f, e);
        }
    };
  });
  var Tt = E((Oie, _g) => {
    var yg = Ee(),
      uN = It(),
      Eg = yg(yg.bind);
    _g.exports = function (e, t) {
      return (
        uN(e),
        t === void 0
          ? e
          : Eg
            ? Eg(e, t)
            : function () {
                return e.apply(t, arguments);
              }
      );
    };
  });
  var sl = E((Rie, Sg) => {
    var hN = ot(),
      bg = Xe(),
      cN = lr();
    Sg.exports = function (e, t, r) {
      var n, i;
      bg(e);
      try {
        if (((n = cN(e, "return")), !n)) {
          if (t === "throw") throw r;
          return r;
        }
        n = hN(n, e);
      } catch (a) {
        (i = !0), (n = a);
      }
      if (t === "throw") throw r;
      if (i) throw n;
      return bg(n), r;
    };
  });
  var Tg = E((Die, Ig) => {
    var fN = Xe(),
      pN = sl();
    Ig.exports = function (e, t, r, n) {
      try {
        return n ? t(fN(r)[0], r[1]) : t(r);
      } catch (i) {
        pN(e, "throw", i);
      }
    };
  });
  var nn = E((qie, xg) => {
    xg.exports = {};
  });
  var ol = E((Fie, Ag) => {
    var dN = xe(),
      mN = nn(),
      vN = dN("iterator"),
      gN = Array.prototype;
    Ag.exports = function (e) {
      return e !== void 0 && (mN.Array === e || gN[vN] === e);
    };
  });
  var ya = E((Lie, Cg) => {
    var yN = xe(),
      EN = yN("toStringTag"),
      Pg = {};
    Pg[EN] = "z";
    Cg.exports = String(Pg) === "[object z]";
  });
  var ti = E((Nie, wg) => {
    var _N = Z(),
      bN = ya(),
      SN = Te(),
      Ea = Jr(),
      IN = xe(),
      TN = IN("toStringTag"),
      xN = _N.Object,
      AN =
        Ea(
          (function () {
            return arguments;
          })(),
        ) == "Arguments",
      PN = function (e, t) {
        try {
          return e[t];
        } catch {}
      };
    wg.exports = bN
      ? Ea
      : function (e) {
          var t, r, n;
          return e === void 0
            ? "Undefined"
            : e === null
              ? "Null"
              : typeof (r = PN((t = xN(e)), TN)) == "string"
                ? r
                : AN
                  ? Ea(t)
                  : (n = Ea(t)) == "Object" && SN(t.callee)
                    ? "Arguments"
                    : n;
        };
  });
  var wr = E((kie, Dg) => {
    var CN = Ee(),
      wN = Fe(),
      Mg = Te(),
      MN = ti(),
      ON = lt(),
      RN = Qn(),
      Og = function () {},
      DN = [],
      Rg = ON("Reflect", "construct"),
      ll = /^\s*(?:class|function)\b/,
      qN = CN(ll.exec),
      FN = !ll.exec(Og),
      ri = function (e) {
        if (!Mg(e)) return !1;
        try {
          return Rg(Og, DN, e), !0;
        } catch {
          return !1;
        }
      },
      LN = function (e) {
        if (!Mg(e)) return !1;
        switch (MN(e)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        return FN || !!qN(ll, RN(e));
      };
    Dg.exports =
      !Rg ||
      wN(function () {
        var e;
        return (
          ri(ri.call) ||
          !ri(Object) ||
          !ri(function () {
            e = !0;
          }) ||
          e
        );
      })
        ? LN
        : ri;
  });
  var an = E((Bie, qg) => {
    "use strict";
    var NN = Kn(),
      kN = ht(),
      BN = Xn();
    qg.exports = function (e, t, r) {
      var n = NN(t);
      n in e ? kN.f(e, n, BN(0, r)) : (e[n] = r);
    };
  });
  var ni = E((Vie, Lg) => {
    var VN = ti(),
      Fg = lr(),
      GN = nn(),
      zN = xe(),
      jN = zN("iterator");
    Lg.exports = function (e) {
      if (e != null) return Fg(e, jN) || Fg(e, "@@iterator") || GN[VN(e)];
    };
  });
  var ii = E((Gie, Ng) => {
    var HN = Z(),
      WN = ot(),
      XN = It(),
      UN = Xe(),
      $N = Un(),
      KN = ni(),
      YN = HN.TypeError;
    Ng.exports = function (e, t) {
      var r = arguments.length < 2 ? KN(e) : t;
      if (XN(r)) return UN(WN(r, e));
      throw YN($N(e) + " is not iterable");
    };
  });
  var Gg = E((zie, Vg) => {
    "use strict";
    var QN = Z(),
      ZN = Tt(),
      JN = ot(),
      ek = Pe(),
      tk = Tg(),
      rk = ol(),
      nk = wr(),
      ik = Se(),
      kg = an(),
      ak = ii(),
      sk = ni(),
      Bg = QN.Array;
    Vg.exports = function (t) {
      var r = ek(t),
        n = nk(this),
        i = arguments.length,
        a = i > 1 ? arguments[1] : void 0,
        s = a !== void 0;
      s && (a = ZN(a, i > 2 ? arguments[2] : void 0));
      var o = sk(r),
        l = 0,
        f,
        u,
        c,
        v,
        d,
        p;
      if (o && !(this == Bg && rk(o)))
        for (
          v = ak(r, o), d = v.next, u = n ? new this() : [];
          !(c = JN(d, v)).done;
          l++
        )
          (p = s ? tk(v, a, [c.value, l], !0) : c.value), kg(u, l, p);
      else
        for (f = ik(r), u = n ? new this(f) : Bg(f); f > l; l++)
          (p = s ? a(r[l], l) : r[l]), kg(u, l, p);
      return (u.length = l), u;
    };
  });
  var _a = E((jie, Wg) => {
    var ok = xe(),
      jg = ok("iterator"),
      Hg = !1;
    try {
      (zg = 0),
        (ul = {
          next: function () {
            return { done: !!zg++ };
          },
          return: function () {
            Hg = !0;
          },
        }),
        (ul[jg] = function () {
          return this;
        }),
        Array.from(ul, function () {
          throw 2;
        });
    } catch {}
    var zg, ul;
    Wg.exports = function (e, t) {
      if (!t && !Hg) return !1;
      var r = !1;
      try {
        var n = {};
        (n[jg] = function () {
          return {
            next: function () {
              return { done: (r = !0) };
            },
          };
        }),
          e(n);
      } catch {}
      return r;
    };
  });
  var Xg = E(() => {
    var lk = ae(),
      uk = Gg(),
      hk = _a(),
      ck = !hk(function (e) {
        Array.from(e);
      });
    lk({ target: "Array", stat: !0, forced: ck }, { from: uk });
  });
  var cr = E((Xie, Ug) => {
    var fk = Jr();
    Ug.exports =
      Array.isArray ||
      function (t) {
        return fk(t) == "Array";
      };
  });
  var $g = E(() => {
    var pk = ae(),
      dk = cr();
    pk({ target: "Array", stat: !0 }, { isArray: dk });
  });
  var Yg = E(() => {
    "use strict";
    var mk = ae(),
      vk = Z(),
      gk = Fe(),
      yk = wr(),
      Ek = an(),
      Kg = vk.Array,
      _k = gk(function () {
        function e() {}
        return !(Kg.of.call(e) instanceof e);
      });
    mk(
      { target: "Array", stat: !0, forced: _k },
      {
        of: function () {
          for (
            var t = 0, r = arguments.length, n = new (yk(this) ? this : Kg)(r);
            r > t;

          )
            Ek(n, t, arguments[t++]);
          return (n.length = r), n;
        },
      },
    );
  });
  var Zg = E((Qie, Qg) => {
    var bk = il(),
      Sk = ma();
    Qg.exports =
      Object.keys ||
      function (t) {
        return bk(t, Sk);
      };
  });
  var ey = E((Zie, Jg) => {
    var Ik = bt(),
      Tk = ht(),
      xk = Xe(),
      Ak = Rt(),
      Pk = Zg();
    Jg.exports = Ik
      ? Object.defineProperties
      : function (t, r) {
          xk(t);
          for (var n = Ak(r), i = Pk(r), a = i.length, s = 0, o; a > s; )
            Tk.f(t, (o = i[s++]), n[o]);
          return t;
        };
  });
  var hl = E((Jie, ty) => {
    var Ck = lt();
    ty.exports = Ck("document", "documentElement");
  });
  var fr = E((eae, ly) => {
    var wk = Xe(),
      Mk = ey(),
      ry = ma(),
      Ok = Zn(),
      Rk = hl(),
      Dk = ua(),
      qk = ca(),
      ny = ">",
      iy = "<",
      fl = "prototype",
      pl = "script",
      sy = qk("IE_PROTO"),
      cl = function () {},
      oy = function (e) {
        return iy + pl + ny + e + iy + "/" + pl + ny;
      },
      ay = function (e) {
        e.write(oy("")), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      Fk = function () {
        var e = Dk("iframe"),
          t = "java" + pl + ":",
          r;
        return (
          (e.style.display = "none"),
          Rk.appendChild(e),
          (e.src = String(t)),
          (r = e.contentWindow.document),
          r.open(),
          r.write(oy("document.F=Object")),
          r.close(),
          r.F
        );
      },
      ba,
      Sa = function () {
        try {
          ba = new ActiveXObject("htmlfile");
        } catch {}
        Sa =
          typeof document < "u"
            ? document.domain && ba
              ? ay(ba)
              : Fk()
            : ay(ba);
        for (var e = ry.length; e--; ) delete Sa[fl][ry[e]];
        return Sa();
      };
    Ok[sy] = !0;
    ly.exports =
      Object.create ||
      function (t, r) {
        var n;
        return (
          t !== null
            ? ((cl[fl] = wk(t)), (n = new cl()), (cl[fl] = null), (n[sy] = t))
            : (n = Sa()),
          r === void 0 ? n : Mk(n, r)
        );
      };
  });
  var Oe = E((tae, uy) => {
    var Lk = xe(),
      Nk = fr(),
      kk = ht(),
      dl = Lk("unscopables"),
      ml = Array.prototype;
    ml[dl] == null && kk.f(ml, dl, { configurable: !0, value: Nk(null) });
    uy.exports = function (e) {
      ml[dl][e] = !0;
    };
  });
  var vl = E(() => {
    "use strict";
    var Bk = ae(),
      Vk = Pe(),
      Gk = Se(),
      zk = hr(),
      jk = Oe();
    Bk(
      { target: "Array", proto: !0 },
      {
        at: function (t) {
          var r = Vk(this),
            n = Gk(r),
            i = zk(t),
            a = i >= 0 ? i : n + i;
          return a < 0 || a >= n ? void 0 : r[a];
        },
      },
    );
    jk("at");
  });
  var gl = E((iae, fy) => {
    var Hk = Z(),
      hy = cr(),
      Wk = wr(),
      Xk = Ke(),
      Uk = xe(),
      $k = Uk("species"),
      cy = Hk.Array;
    fy.exports = function (e) {
      var t;
      return (
        hy(e) &&
          ((t = e.constructor),
          Wk(t) && (t === cy || hy(t.prototype))
            ? (t = void 0)
            : Xk(t) && ((t = t[$k]), t === null && (t = void 0))),
        t === void 0 ? cy : t
      );
    };
  });
  var Mr = E((aae, py) => {
    var Kk = gl();
    py.exports = function (e, t) {
      return new (Kk(e))(t === 0 ? 0 : t);
    };
  });
  var sn = E((sae, dy) => {
    var Yk = Fe(),
      Qk = xe(),
      Zk = or(),
      Jk = Qk("species");
    dy.exports = function (e) {
      return (
        Zk >= 51 ||
        !Yk(function () {
          var t = [],
            r = (t.constructor = {});
          return (
            (r[Jk] = function () {
              return { foo: 1 };
            }),
            t[e](Boolean).foo !== 1
          );
        })
      );
    };
  });
  var _y = E(() => {
    "use strict";
    var eB = ae(),
      tB = Z(),
      rB = Fe(),
      nB = cr(),
      iB = Ke(),
      aB = Pe(),
      sB = Se(),
      my = an(),
      oB = Mr(),
      lB = sn(),
      uB = xe(),
      hB = or(),
      Ey = uB("isConcatSpreadable"),
      vy = 9007199254740991,
      gy = "Maximum allowed index exceeded",
      yy = tB.TypeError,
      cB =
        hB >= 51 ||
        !rB(function () {
          var e = [];
          return (e[Ey] = !1), e.concat()[0] !== e;
        }),
      fB = lB("concat"),
      pB = function (e) {
        if (!iB(e)) return !1;
        var t = e[Ey];
        return t !== void 0 ? !!t : nB(e);
      },
      dB = !cB || !fB;
    eB(
      { target: "Array", proto: !0, forced: dB },
      {
        concat: function (t) {
          var r = aB(this),
            n = oB(r, 0),
            i = 0,
            a,
            s,
            o,
            l,
            f;
          for (a = -1, o = arguments.length; a < o; a++)
            if (((f = a === -1 ? r : arguments[a]), pB(f))) {
              if (((l = sB(f)), i + l > vy)) throw yy(gy);
              for (s = 0; s < l; s++, i++) s in f && my(n, i, f[s]);
            } else {
              if (i >= vy) throw yy(gy);
              my(n, i++, f);
            }
          return (n.length = i), n;
        },
      },
    );
  });
  var Sy = E((uae, by) => {
    "use strict";
    var mB = Pe(),
      yl = rn(),
      vB = Se(),
      gB = Math.min;
    by.exports =
      [].copyWithin ||
      function (t, r) {
        var n = mB(this),
          i = vB(n),
          a = yl(t, i),
          s = yl(r, i),
          o = arguments.length > 2 ? arguments[2] : void 0,
          l = gB((o === void 0 ? i : yl(o, i)) - s, i - a),
          f = 1;
        for (
          s < a && a < s + l && ((f = -1), (s += l - 1), (a += l - 1));
          l-- > 0;

        )
          s in n ? (n[a] = n[s]) : delete n[a], (a += f), (s += f);
        return n;
      };
  });
  var Iy = E(() => {
    var yB = ae(),
      EB = Sy(),
      _B = Oe();
    yB({ target: "Array", proto: !0 }, { copyWithin: EB });
    _B("copyWithin");
  });
  var Dt = E((fae, xy) => {
    var bB = Tt(),
      SB = Ee(),
      IB = xr(),
      TB = Pe(),
      xB = Se(),
      AB = Mr(),
      Ty = SB([].push),
      pr = function (e) {
        var t = e == 1,
          r = e == 2,
          n = e == 3,
          i = e == 4,
          a = e == 6,
          s = e == 7,
          o = e == 5 || a;
        return function (l, f, u, c) {
          for (
            var v = TB(l),
              d = IB(v),
              p = bB(f, u),
              m = xB(d),
              h = 0,
              g = c || AB,
              y = t ? g(l, m) : r || s ? g(l, 0) : void 0,
              _,
              b;
            m > h;
            h++
          )
            if ((o || h in d) && ((_ = d[h]), (b = p(_, h, v)), e))
              if (t) y[h] = b;
              else if (b)
                switch (e) {
                  case 3:
                    return !0;
                  case 5:
                    return _;
                  case 6:
                    return h;
                  case 2:
                    Ty(y, _);
                }
              else
                switch (e) {
                  case 4:
                    return !1;
                  case 7:
                    Ty(y, _);
                }
          return a ? -1 : n || i ? i : y;
        };
      };
    xy.exports = {
      forEach: pr(0),
      map: pr(1),
      filter: pr(2),
      some: pr(3),
      every: pr(4),
      find: pr(5),
      findIndex: pr(6),
      filterReject: pr(7),
    };
  });
  var qt = E((pae, Ay) => {
    "use strict";
    var PB = Fe();
    Ay.exports = function (e, t) {
      var r = [][e];
      return (
        !!r &&
        PB(function () {
          r.call(
            null,
            t ||
              function () {
                throw 1;
              },
            1,
          );
        })
      );
    };
  });
  var Py = E(() => {
    "use strict";
    var CB = ae(),
      wB = Dt().every,
      MB = qt(),
      OB = MB("every");
    CB(
      { target: "Array", proto: !0, forced: !OB },
      {
        every: function (t) {
          return wB(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
  });
  var My = E((vae, wy) => {
    "use strict";
    var RB = Pe(),
      Cy = rn(),
      DB = Se();
    wy.exports = function (t) {
      for (
        var r = RB(this),
          n = DB(r),
          i = arguments.length,
          a = Cy(i > 1 ? arguments[1] : void 0, n),
          s = i > 2 ? arguments[2] : void 0,
          o = s === void 0 ? n : Cy(s, n);
        o > a;

      )
        r[a++] = t;
      return r;
    };
  });
  var Oy = E(() => {
    var qB = ae(),
      FB = My(),
      LB = Oe();
    qB({ target: "Array", proto: !0 }, { fill: FB });
    LB("fill");
  });
  var Ry = E(() => {
    "use strict";
    var NB = ae(),
      kB = Dt().filter,
      BB = sn(),
      VB = BB("filter");
    NB(
      { target: "Array", proto: !0, forced: !VB },
      {
        filter: function (t) {
          return kB(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
  });
  var qy = E(() => {
    "use strict";
    var GB = ae(),
      zB = Dt().find,
      jB = Oe(),
      El = "find",
      Dy = !0;
    El in [] &&
      Array(1)[El](function () {
        Dy = !1;
      });
    GB(
      { target: "Array", proto: !0, forced: Dy },
      {
        find: function (t) {
          return zB(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    jB(El);
  });
  var Ly = E(() => {
    "use strict";
    var HB = ae(),
      WB = Dt().findIndex,
      XB = Oe(),
      _l = "findIndex",
      Fy = !0;
    _l in [] &&
      Array(1)[_l](function () {
        Fy = !1;
      });
    HB(
      { target: "Array", proto: !0, forced: Fy },
      {
        findIndex: function (t) {
          return WB(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    XB(_l);
  });
  var bl = E((xae, ky) => {
    "use strict";
    var UB = Z(),
      $B = cr(),
      KB = Se(),
      YB = Tt(),
      QB = UB.TypeError,
      Ny = function (e, t, r, n, i, a, s, o) {
        for (var l = i, f = 0, u = s ? YB(s, o) : !1, c, v; f < n; ) {
          if (f in r) {
            if (((c = u ? u(r[f], f, t) : r[f]), a > 0 && $B(c)))
              (v = KB(c)), (l = Ny(e, t, c, v, l, a - 1) - 1);
            else {
              if (l >= 9007199254740991)
                throw QB("Exceed the acceptable array length");
              e[l] = c;
            }
            l++;
          }
          f++;
        }
        return l;
      };
    ky.exports = Ny;
  });
  var By = E(() => {
    "use strict";
    var ZB = ae(),
      JB = bl(),
      eV = Pe(),
      tV = Se(),
      rV = hr(),
      nV = Mr();
    ZB(
      { target: "Array", proto: !0 },
      {
        flat: function () {
          var t = arguments.length ? arguments[0] : void 0,
            r = eV(this),
            n = tV(r),
            i = nV(r, 0);
          return (i.length = JB(i, r, r, n, 0, t === void 0 ? 1 : rV(t))), i;
        },
      },
    );
  });
  var Vy = E(() => {
    "use strict";
    var iV = ae(),
      aV = bl(),
      sV = It(),
      oV = Pe(),
      lV = Se(),
      uV = Mr();
    iV(
      { target: "Array", proto: !0 },
      {
        flatMap: function (t) {
          var r = oV(this),
            n = lV(r),
            i;
          return (
            sV(t),
            (i = uV(r, 0)),
            (i.length = aV(
              i,
              r,
              r,
              n,
              0,
              1,
              t,
              arguments.length > 1 ? arguments[1] : void 0,
            )),
            i
          );
        },
      },
    );
  });
  var zy = E((Mae, Gy) => {
    "use strict";
    var hV = Dt().forEach,
      cV = qt(),
      fV = cV("forEach");
    Gy.exports = fV
      ? [].forEach
      : function (t) {
          return hV(this, t, arguments.length > 1 ? arguments[1] : void 0);
        };
  });
  var Hy = E(() => {
    "use strict";
    var pV = ae(),
      jy = zy();
    pV(
      { target: "Array", proto: !0, forced: [].forEach != jy },
      { forEach: jy },
    );
  });
  var Sl = E(() => {
    "use strict";
    var dV = ae(),
      mV = da().includes,
      vV = Oe();
    dV(
      { target: "Array", proto: !0 },
      {
        includes: function (t) {
          return mV(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    vV("includes");
  });
  var Xy = E(() => {
    "use strict";
    var gV = ae(),
      yV = Ee(),
      EV = da().indexOf,
      _V = qt(),
      Il = yV([].indexOf),
      Wy = !!Il && 1 / Il([1], 1, -0) < 0,
      bV = _V("indexOf");
    gV(
      { target: "Array", proto: !0, forced: Wy || !bV },
      {
        indexOf: function (t) {
          var r = arguments.length > 1 ? arguments[1] : void 0;
          return Wy ? Il(this, t, r) || 0 : EV(this, t, r);
        },
      },
    );
  });
  var $y = E((Nae, Uy) => {
    var SV = Fe();
    Uy.exports = !SV(function () {
      function e() {}
      return (
        (e.prototype.constructor = null),
        Object.getPrototypeOf(new e()) !== e.prototype
      );
    });
  });
  var Ia = E((kae, Yy) => {
    var IV = Z(),
      TV = ut(),
      xV = Te(),
      AV = Pe(),
      PV = ca(),
      CV = $y(),
      Ky = PV("IE_PROTO"),
      Tl = IV.Object,
      wV = Tl.prototype;
    Yy.exports = CV
      ? Tl.getPrototypeOf
      : function (e) {
          var t = AV(e);
          if (TV(t, Ky)) return t[Ky];
          var r = t.constructor;
          return xV(r) && t instanceof r
            ? r.prototype
            : t instanceof Tl
              ? wV
              : null;
        };
  });
  var Cl = E((Bae, Jy) => {
    "use strict";
    var MV = Fe(),
      OV = Te(),
      RV = fr(),
      Qy = Ia(),
      DV = Wt(),
      qV = xe(),
      FV = en(),
      Pl = qV("iterator"),
      Zy = !1,
      Xt,
      xl,
      Al;
    [].keys &&
      ((Al = [].keys()),
      "next" in Al
        ? ((xl = Qy(Qy(Al))), xl !== Object.prototype && (Xt = xl))
        : (Zy = !0));
    var LV =
      Xt == null ||
      MV(function () {
        var e = {};
        return Xt[Pl].call(e) !== e;
      });
    LV ? (Xt = {}) : FV && (Xt = RV(Xt));
    OV(Xt[Pl]) ||
      DV(Xt, Pl, function () {
        return this;
      });
    Jy.exports = { IteratorPrototype: Xt, BUGGY_SAFARI_ITERATORS: Zy };
  });
  var ai = E((Vae, t0) => {
    var NV = ht().f,
      kV = ut(),
      BV = xe(),
      e0 = BV("toStringTag");
    t0.exports = function (e, t, r) {
      e &&
        !kV((e = r ? e : e.prototype), e0) &&
        NV(e, e0, { configurable: !0, value: t });
    };
  });
  var n0 = E((Gae, r0) => {
    "use strict";
    var VV = Cl().IteratorPrototype,
      GV = fr(),
      zV = Xn(),
      jV = ai(),
      HV = nn(),
      WV = function () {
        return this;
      };
    r0.exports = function (e, t, r) {
      var n = t + " Iterator";
      return (
        (e.prototype = GV(VV, { next: zV(1, r) })),
        jV(e, n, !1, !0),
        (HV[n] = WV),
        e
      );
    };
  });
  var s0 = E((zae, a0) => {
    var i0 = Z(),
      XV = Te(),
      UV = i0.String,
      $V = i0.TypeError;
    a0.exports = function (e) {
      if (typeof e == "object" || XV(e)) return e;
      throw $V("Can't set " + UV(e) + " as a prototype");
    };
  });
  var Ta = E((jae, o0) => {
    var KV = Ee(),
      YV = Xe(),
      QV = s0();
    o0.exports =
      Object.setPrototypeOf ||
      ("__proto__" in {}
        ? (function () {
            var e = !1,
              t = {},
              r;
            try {
              (r = KV(
                Object.getOwnPropertyDescriptor(Object.prototype, "__proto__")
                  .set,
              )),
                r(t, []),
                (e = t instanceof Array);
            } catch {}
            return function (i, a) {
              return YV(i), QV(a), e ? r(i, a) : (i.__proto__ = a), i;
            };
          })()
        : void 0);
  });
  var Pa = E((Hae, g0) => {
    "use strict";
    var ZV = ae(),
      JV = ot(),
      xa = en(),
      m0 = rl(),
      eG = Te(),
      tG = n0(),
      l0 = Ia(),
      u0 = Ta(),
      rG = ai(),
      nG = Yn(),
      wl = Wt(),
      iG = xe(),
      h0 = nn(),
      v0 = Cl(),
      aG = m0.PROPER,
      sG = m0.CONFIGURABLE,
      c0 = v0.IteratorPrototype,
      Aa = v0.BUGGY_SAFARI_ITERATORS,
      si = iG("iterator"),
      f0 = "keys",
      oi = "values",
      p0 = "entries",
      d0 = function () {
        return this;
      };
    g0.exports = function (e, t, r, n, i, a, s) {
      tG(r, t, n);
      var o = function (g) {
          if (g === i && v) return v;
          if (!Aa && g in u) return u[g];
          switch (g) {
            case f0:
              return function () {
                return new r(this, g);
              };
            case oi:
              return function () {
                return new r(this, g);
              };
            case p0:
              return function () {
                return new r(this, g);
              };
          }
          return function () {
            return new r(this);
          };
        },
        l = t + " Iterator",
        f = !1,
        u = e.prototype,
        c = u[si] || u["@@iterator"] || (i && u[i]),
        v = (!Aa && c) || o(i),
        d = (t == "Array" && u.entries) || c,
        p,
        m,
        h;
      if (
        (d &&
          ((p = l0(d.call(new e()))),
          p !== Object.prototype &&
            p.next &&
            (!xa &&
              l0(p) !== c0 &&
              (u0 ? u0(p, c0) : eG(p[si]) || wl(p, si, d0)),
            rG(p, l, !0, !0),
            xa && (h0[l] = d0))),
        aG &&
          i == oi &&
          c &&
          c.name !== oi &&
          (!xa && sG
            ? nG(u, "name", oi)
            : ((f = !0),
              (v = function () {
                return JV(c, this);
              }))),
        i)
      )
        if (((m = { values: o(oi), keys: a ? v : o(f0), entries: o(p0) }), s))
          for (h in m) (Aa || f || !(h in u)) && wl(u, h, m[h]);
        else ZV({ target: t, proto: !0, forced: Aa || f }, m);
      return (
        (!xa || s) && u[si] !== v && wl(u, si, v, { name: i }), (h0[t] = v), m
      );
    };
  });
  var S0 = E((Wae, b0) => {
    "use strict";
    var oG = Rt(),
      Ml = Oe(),
      y0 = nn(),
      E0 = Cr(),
      lG = Pa(),
      _0 = "Array Iterator",
      uG = E0.set,
      hG = E0.getterFor(_0);
    b0.exports = lG(
      Array,
      "Array",
      function (e, t) {
        uG(this, { type: _0, target: oG(e), index: 0, kind: t });
      },
      function () {
        var e = hG(this),
          t = e.target,
          r = e.kind,
          n = e.index++;
        return !t || n >= t.length
          ? ((e.target = void 0), { value: void 0, done: !0 })
          : r == "keys"
            ? { value: n, done: !1 }
            : r == "values"
              ? { value: t[n], done: !1 }
              : { value: [n, t[n]], done: !1 };
      },
      "values",
    );
    y0.Arguments = y0.Array;
    Ml("keys");
    Ml("values");
    Ml("entries");
  });
  var I0 = E(() => {
    "use strict";
    var cG = ae(),
      fG = Ee(),
      pG = xr(),
      dG = Rt(),
      mG = qt(),
      vG = fG([].join),
      gG = pG != Object,
      yG = mG("join", ",");
    cG(
      { target: "Array", proto: !0, forced: gG || !yG },
      {
        join: function (t) {
          return vG(dG(this), t === void 0 ? "," : t);
        },
      },
    );
  });
  var Ca = E(($ae, A0) => {
    var Ol = Function.prototype,
      T0 = Ol.apply,
      EG = Ol.bind,
      x0 = Ol.call;
    A0.exports =
      (typeof Reflect == "object" && Reflect.apply) ||
      (EG
        ? x0.bind(T0)
        : function () {
            return x0.apply(T0, arguments);
          });
  });
  var w0 = E((Kae, C0) => {
    "use strict";
    var _G = Ca(),
      bG = Rt(),
      SG = hr(),
      IG = Se(),
      TG = qt(),
      xG = Math.min,
      Rl = [].lastIndexOf,
      P0 = !!Rl && 1 / [1].lastIndexOf(1, -0) < 0,
      AG = TG("lastIndexOf"),
      PG = P0 || !AG;
    C0.exports = PG
      ? function (t) {
          if (P0) return _G(Rl, this, arguments) || 0;
          var r = bG(this),
            n = IG(r),
            i = n - 1;
          for (
            arguments.length > 1 && (i = xG(i, SG(arguments[1]))),
              i < 0 && (i = n + i);
            i >= 0;
            i--
          )
            if (i in r && r[i] === t) return i || 0;
          return -1;
        }
      : Rl;
  });
  var O0 = E(() => {
    var CG = ae(),
      M0 = w0();
    CG(
      { target: "Array", proto: !0, forced: M0 !== [].lastIndexOf },
      { lastIndexOf: M0 },
    );
  });
  var R0 = E(() => {
    "use strict";
    var wG = ae(),
      MG = Dt().map,
      OG = sn(),
      RG = OG("map");
    wG(
      { target: "Array", proto: !0, forced: !RG },
      {
        map: function (t) {
          return MG(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
  });
  var Dl = E((ese, q0) => {
    var DG = Z(),
      qG = It(),
      FG = Pe(),
      LG = xr(),
      NG = Se(),
      kG = DG.TypeError,
      D0 = function (e) {
        return function (t, r, n, i) {
          qG(r);
          var a = FG(t),
            s = LG(a),
            o = NG(a),
            l = e ? o - 1 : 0,
            f = e ? -1 : 1;
          if (n < 2)
            for (;;) {
              if (l in s) {
                (i = s[l]), (l += f);
                break;
              }
              if (((l += f), e ? l < 0 : o <= l))
                throw kG("Reduce of empty array with no initial value");
            }
          for (; e ? l >= 0 : o > l; l += f) l in s && (i = r(i, s[l], l, a));
          return i;
        };
      };
    q0.exports = { left: D0(!1), right: D0(!0) };
  });
  var on = E((tse, F0) => {
    var BG = Jr(),
      VG = Z();
    F0.exports = BG(VG.process) == "process";
  });
  var N0 = E(() => {
    "use strict";
    var GG = ae(),
      zG = Dl().left,
      jG = qt(),
      L0 = or(),
      HG = on(),
      WG = jG("reduce"),
      XG = !HG && L0 > 79 && L0 < 83;
    GG(
      { target: "Array", proto: !0, forced: !WG || XG },
      {
        reduce: function (t) {
          var r = arguments.length;
          return zG(this, t, r, r > 1 ? arguments[1] : void 0);
        },
      },
    );
  });
  var B0 = E(() => {
    "use strict";
    var UG = ae(),
      $G = Dl().right,
      KG = qt(),
      k0 = or(),
      YG = on(),
      QG = KG("reduceRight"),
      ZG = !YG && k0 > 79 && k0 < 83;
    UG(
      { target: "Array", proto: !0, forced: !QG || ZG },
      {
        reduceRight: function (t) {
          return $G(
            this,
            t,
            arguments.length,
            arguments.length > 1 ? arguments[1] : void 0,
          );
        },
      },
    );
  });
  var G0 = E(() => {
    "use strict";
    var JG = ae(),
      e3 = Ee(),
      t3 = cr(),
      r3 = e3([].reverse),
      V0 = [1, 2];
    JG(
      {
        target: "Array",
        proto: !0,
        forced: String(V0) === String(V0.reverse()),
      },
      {
        reverse: function () {
          return t3(this) && (this.length = this.length), r3(this);
        },
      },
    );
  });
  var li = E((lse, z0) => {
    var n3 = Ee();
    z0.exports = n3([].slice);
  });
  var W0 = E(() => {
    "use strict";
    var i3 = ae(),
      a3 = Z(),
      j0 = cr(),
      s3 = wr(),
      o3 = Ke(),
      H0 = rn(),
      l3 = Se(),
      u3 = Rt(),
      h3 = an(),
      c3 = xe(),
      f3 = sn(),
      p3 = li(),
      d3 = f3("slice"),
      m3 = c3("species"),
      ql = a3.Array,
      v3 = Math.max;
    i3(
      { target: "Array", proto: !0, forced: !d3 },
      {
        slice: function (t, r) {
          var n = u3(this),
            i = l3(n),
            a = H0(t, i),
            s = H0(r === void 0 ? i : r, i),
            o,
            l,
            f;
          if (
            j0(n) &&
            ((o = n.constructor),
            s3(o) && (o === ql || j0(o.prototype))
              ? (o = void 0)
              : o3(o) && ((o = o[m3]), o === null && (o = void 0)),
            o === ql || o === void 0)
          )
            return p3(n, a, s);
          for (
            l = new (o === void 0 ? ql : o)(v3(s - a, 0)), f = 0;
            a < s;
            a++, f++
          )
            a in n && h3(l, f, n[a]);
          return (l.length = f), l;
        },
      },
    );
  });
  var X0 = E(() => {
    "use strict";
    var g3 = ae(),
      y3 = Dt().some,
      E3 = qt(),
      _3 = E3("some");
    g3(
      { target: "Array", proto: !0, forced: !_3 },
      {
        some: function (t) {
          return y3(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
  });
  var wa = E((pse, U0) => {
    var b3 = Z(),
      S3 = ti(),
      I3 = b3.String;
    U0.exports = function (e) {
      if (S3(e) === "Symbol")
        throw TypeError("Cannot convert a Symbol value to a string");
      return I3(e);
    };
  });
  var Y0 = E((dse, K0) => {
    var $0 = li(),
      T3 = Math.floor,
      Fl = function (e, t) {
        var r = e.length,
          n = T3(r / 2);
        return r < 8 ? x3(e, t) : A3(e, Fl($0(e, 0, n), t), Fl($0(e, n), t), t);
      },
      x3 = function (e, t) {
        for (var r = e.length, n = 1, i, a; n < r; ) {
          for (a = n, i = e[n]; a && t(e[a - 1], i) > 0; ) e[a] = e[--a];
          a !== n++ && (e[a] = i);
        }
        return e;
      },
      A3 = function (e, t, r, n) {
        for (var i = t.length, a = r.length, s = 0, o = 0; s < i || o < a; )
          e[s + o] =
            s < i && o < a
              ? n(t[s], r[o]) <= 0
                ? t[s++]
                : r[o++]
              : s < i
                ? t[s++]
                : r[o++];
        return e;
      };
    K0.exports = Fl;
  });
  var J0 = E((mse, Z0) => {
    var P3 = sr(),
      Q0 = P3.match(/firefox\/(\d+)/i);
    Z0.exports = !!Q0 && +Q0[1];
  });
  var tE = E((vse, eE) => {
    var C3 = sr();
    eE.exports = /MSIE|Trident/.test(C3);
  });
  var iE = E((gse, nE) => {
    var w3 = sr(),
      rE = w3.match(/AppleWebKit\/(\d+)\./);
    nE.exports = !!rE && +rE[1];
  });
  var fE = E(() => {
    "use strict";
    var M3 = ae(),
      hE = Ee(),
      O3 = It(),
      R3 = Pe(),
      D3 = Se(),
      aE = wa(),
      Ll = Fe(),
      q3 = Y0(),
      F3 = qt(),
      sE = J0(),
      L3 = tE(),
      oE = or(),
      lE = iE(),
      dr = [],
      uE = hE(dr.sort),
      N3 = hE(dr.push),
      k3 = Ll(function () {
        dr.sort(void 0);
      }),
      B3 = Ll(function () {
        dr.sort(null);
      }),
      V3 = F3("sort"),
      cE = !Ll(function () {
        if (oE) return oE < 70;
        if (!(sE && sE > 3)) {
          if (L3) return !0;
          if (lE) return lE < 603;
          var e = "",
            t,
            r,
            n,
            i;
          for (t = 65; t < 76; t++) {
            switch (((r = String.fromCharCode(t)), t)) {
              case 66:
              case 69:
              case 70:
              case 72:
                n = 3;
                break;
              case 68:
              case 71:
                n = 4;
                break;
              default:
                n = 2;
            }
            for (i = 0; i < 47; i++) dr.push({ k: r + i, v: n });
          }
          for (
            dr.sort(function (a, s) {
              return s.v - a.v;
            }),
              i = 0;
            i < dr.length;
            i++
          )
            (r = dr[i].k.charAt(0)), e.charAt(e.length - 1) !== r && (e += r);
          return e !== "DGBEFHACIJK";
        }
      }),
      G3 = k3 || !B3 || !V3 || !cE,
      z3 = function (e) {
        return function (t, r) {
          return r === void 0
            ? -1
            : t === void 0
              ? 1
              : e !== void 0
                ? +e(t, r) || 0
                : aE(t) > aE(r)
                  ? 1
                  : -1;
        };
      };
    M3(
      { target: "Array", proto: !0, forced: G3 },
      {
        sort: function (t) {
          t !== void 0 && O3(t);
          var r = R3(this);
          if (cE) return t === void 0 ? uE(r) : uE(r, t);
          var n = [],
            i = D3(r),
            a,
            s;
          for (s = 0; s < i; s++) s in r && N3(n, r[s]);
          for (q3(n, z3(t)), a = n.length, s = 0; s < a; ) r[s] = n[s++];
          for (; s < i; ) delete r[s++];
          return r;
        },
      },
    );
  });
  var Ma = E((_se, dE) => {
    "use strict";
    var j3 = lt(),
      H3 = ht(),
      W3 = xe(),
      X3 = bt(),
      pE = W3("species");
    dE.exports = function (e) {
      var t = j3(e),
        r = H3.f;
      X3 &&
        t &&
        !t[pE] &&
        r(t, pE, {
          configurable: !0,
          get: function () {
            return this;
          },
        });
    };
  });
  var mE = E(() => {
    var U3 = Ma();
    U3("Array");
  });
  var vE = E(() => {
    "use strict";
    var $3 = ae(),
      K3 = Z(),
      Y3 = rn(),
      Q3 = hr(),
      Z3 = Se(),
      J3 = Pe(),
      e5 = Mr(),
      t5 = an(),
      r5 = sn(),
      n5 = r5("splice"),
      i5 = K3.TypeError,
      a5 = Math.max,
      s5 = Math.min,
      o5 = 9007199254740991,
      l5 = "Maximum allowed length exceeded";
    $3(
      { target: "Array", proto: !0, forced: !n5 },
      {
        splice: function (t, r) {
          var n = J3(this),
            i = Z3(n),
            a = Y3(t, i),
            s = arguments.length,
            o,
            l,
            f,
            u,
            c,
            v;
          if (
            (s === 0
              ? (o = l = 0)
              : s === 1
                ? ((o = 0), (l = i - a))
                : ((o = s - 2), (l = s5(a5(Q3(r), 0), i - a))),
            i + o - l > o5)
          )
            throw i5(l5);
          for (f = e5(n, l), u = 0; u < l; u++)
            (c = a + u), c in n && t5(f, u, n[c]);
          if (((f.length = l), o < l)) {
            for (u = a; u < i - l; u++)
              (c = u + l), (v = u + o), c in n ? (n[v] = n[c]) : delete n[v];
            for (u = i; u > i - l + o; u--) delete n[u - 1];
          } else if (o > l)
            for (u = i - l; u > a; u--)
              (c = u + l - 1),
                (v = u + o - 1),
                c in n ? (n[v] = n[c]) : delete n[v];
          for (u = 0; u < o; u++) n[u + a] = arguments[u + 2];
          return (n.length = i - l + o), f;
        },
      },
    );
  });
  var gE = E(() => {
    var u5 = Oe();
    u5("flat");
  });
  var yE = E(() => {
    var h5 = Oe();
    h5("flatMap");
  });
  var _E = E((wse, EE) => {
    "use strict";
    var c5 = ya(),
      f5 = ti();
    EE.exports = c5
      ? {}.toString
      : function () {
          return "[object " + f5(this) + "]";
        };
  });
  var bE = E(() => {
    var p5 = ya(),
      d5 = Wt(),
      m5 = _E();
    p5 || d5(Object.prototype, "toString", m5, { unsafe: !0 });
  });
  var xE = E((Rse, TE) => {
    var Nl = Ee(),
      v5 = hr(),
      g5 = wa(),
      y5 = ia(),
      E5 = Nl("".charAt),
      SE = Nl("".charCodeAt),
      _5 = Nl("".slice),
      IE = function (e) {
        return function (t, r) {
          var n = g5(y5(t)),
            i = v5(r),
            a = n.length,
            s,
            o;
          return i < 0 || i >= a
            ? e
              ? ""
              : void 0
            : ((s = SE(n, i)),
              s < 55296 ||
              s > 56319 ||
              i + 1 === a ||
              (o = SE(n, i + 1)) < 56320 ||
              o > 57343
                ? e
                  ? E5(n, i)
                  : s
                : e
                  ? _5(n, i, i + 2)
                  : ((s - 55296) << 10) + (o - 56320) + 65536);
        };
      };
    TE.exports = { codeAt: IE(!1), charAt: IE(!0) };
  });
  var CE = E(() => {
    "use strict";
    var b5 = xE().charAt,
      S5 = wa(),
      AE = Cr(),
      I5 = Pa(),
      PE = "String Iterator",
      T5 = AE.set,
      x5 = AE.getterFor(PE);
    I5(
      String,
      "String",
      function (e) {
        T5(this, { type: PE, string: S5(e), index: 0 });
      },
      function () {
        var t = x5(this),
          r = t.string,
          n = t.index,
          i;
        return n >= r.length
          ? { value: void 0, done: !0 }
          : ((i = b5(r, n)), (t.index += i.length), { value: i, done: !1 });
      },
    );
  });
  var ME = E((Fse, wE) => {
    var A5 = Z();
    wE.exports = A5;
  });
  var RE = E((Lse, OE) => {
    Xg();
    $g();
    Yg();
    vl();
    _y();
    Iy();
    Py();
    Oy();
    Ry();
    qy();
    Ly();
    By();
    Vy();
    Hy();
    Sl();
    Xy();
    S0();
    I0();
    O0();
    R0();
    N0();
    B0();
    G0();
    W0();
    X0();
    fE();
    mE();
    vE();
    gE();
    yE();
    bE();
    CE();
    var P5 = ME();
    OE.exports = P5.Array;
  });
  var qE = E((Nse, DE) => {
    var C5 = RE();
    DE.exports = C5;
  });
  var kE = E((kse, NE) => {
    var w5 = Jr(),
      M5 = Rt(),
      FE = va().f,
      O5 = li(),
      LE =
        typeof window == "object" && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window)
          : [],
      R5 = function (e) {
        try {
          return FE(e);
        } catch {
          return O5(LE);
        }
      };
    NE.exports.f = function (t) {
      return LE && w5(t) == "Window" ? R5(t) : FE(M5(t));
    };
  });
  var VE = E((Bse, BE) => {
    var D5 = Fe();
    BE.exports = !D5(function () {
      return Object.isExtensible(Object.preventExtensions({}));
    });
  });
  var Gl = E((Vse, jE) => {
    var q5 = ae(),
      F5 = Ee(),
      L5 = Zn(),
      N5 = Ke(),
      kl = ut(),
      k5 = ht().f,
      GE = va(),
      B5 = kE(),
      V5 = la(),
      G5 = VE(),
      zE = !1,
      Ut = V5("meta"),
      z5 = 0,
      Bl =
        Object.isExtensible ||
        function () {
          return !0;
        },
      Vl = function (e) {
        k5(e, Ut, { value: { objectID: "O" + z5++, weakData: {} } });
      },
      j5 = function (e, t) {
        if (!N5(e))
          return typeof e == "symbol"
            ? e
            : (typeof e == "string" ? "S" : "P") + e;
        if (!kl(e, Ut)) {
          if (!Bl(e)) return "F";
          if (!t) return "E";
          Vl(e);
        }
        return e[Ut].objectID;
      },
      H5 = function (e, t) {
        if (!kl(e, Ut)) {
          if (!Bl(e)) return !0;
          if (!t) return !1;
          Vl(e);
        }
        return e[Ut].weakData;
      },
      W5 = function (e) {
        return G5 && zE && Bl(e) && !kl(e, Ut) && Vl(e), e;
      },
      X5 = function () {
        (U5.enable = function () {}), (zE = !0);
        var e = GE.f,
          t = F5([].splice),
          r = {};
        (r[Ut] = 1),
          e(r).length &&
            ((GE.f = function (n) {
              for (var i = e(n), a = 0, s = i.length; a < s; a++)
                if (i[a] === Ut) {
                  t(i, a, 1);
                  break;
                }
              return i;
            }),
            q5(
              { target: "Object", stat: !0, forced: !0 },
              { getOwnPropertyNames: B5.f },
            ));
      },
      U5 = (jE.exports = {
        enable: X5,
        fastKey: j5,
        getWeakData: H5,
        onFreeze: W5,
      });
    L5[Ut] = !0;
  });
  var Ra = E((Gse, UE) => {
    var $5 = Z(),
      K5 = Tt(),
      Y5 = ot(),
      Q5 = Xe(),
      Z5 = Un(),
      J5 = ol(),
      ez = Se(),
      HE = aa(),
      tz = ii(),
      rz = ni(),
      WE = sl(),
      nz = $5.TypeError,
      Oa = function (e, t) {
        (this.stopped = e), (this.result = t);
      },
      XE = Oa.prototype;
    UE.exports = function (e, t, r) {
      var n = r && r.that,
        i = !!(r && r.AS_ENTRIES),
        a = !!(r && r.IS_ITERATOR),
        s = !!(r && r.INTERRUPTED),
        o = K5(t, n),
        l,
        f,
        u,
        c,
        v,
        d,
        p,
        m = function (g) {
          return l && WE(l, "normal", g), new Oa(!0, g);
        },
        h = function (g) {
          return i
            ? (Q5(g), s ? o(g[0], g[1], m) : o(g[0], g[1]))
            : s
              ? o(g, m)
              : o(g);
        };
      if (a) l = e;
      else {
        if (((f = rz(e)), !f)) throw nz(Z5(e) + " is not iterable");
        if (J5(f)) {
          for (u = 0, c = ez(e); c > u; u++)
            if (((v = h(e[u])), v && HE(XE, v))) return v;
          return new Oa(!1);
        }
        l = tz(e, f);
      }
      for (d = l.next; !(p = Y5(d, l)).done; ) {
        try {
          v = h(p.value);
        } catch (g) {
          WE(l, "throw", g);
        }
        if (typeof v == "object" && v && HE(XE, v)) return v;
      }
      return new Oa(!1);
    };
  });
  var Da = E((zse, $E) => {
    var iz = Z(),
      az = aa(),
      sz = iz.TypeError;
    $E.exports = function (e, t) {
      if (az(t, e)) return e;
      throw sz("Incorrect invocation");
    };
  });
  var QE = E((jse, YE) => {
    var oz = Te(),
      lz = Ke(),
      KE = Ta();
    YE.exports = function (e, t, r) {
      var n, i;
      return (
        KE &&
          oz((n = t.constructor)) &&
          n !== r &&
          lz((i = n.prototype)) &&
          i !== r.prototype &&
          KE(e, i),
        e
      );
    };
  });
  var e1 = E((Hse, JE) => {
    "use strict";
    var uz = ae(),
      hz = Z(),
      cz = Ee(),
      ZE = ga(),
      fz = Wt(),
      pz = Gl(),
      dz = Ra(),
      mz = Da(),
      vz = Te(),
      zl = Ke(),
      jl = Fe(),
      gz = _a(),
      yz = ai(),
      Ez = QE();
    JE.exports = function (e, t, r) {
      var n = e.indexOf("Map") !== -1,
        i = e.indexOf("Weak") !== -1,
        a = n ? "set" : "add",
        s = hz[e],
        o = s && s.prototype,
        l = s,
        f = {},
        u = function (g) {
          var y = cz(o[g]);
          fz(
            o,
            g,
            g == "add"
              ? function (b) {
                  return y(this, b === 0 ? 0 : b), this;
                }
              : g == "delete"
                ? function (_) {
                    return i && !zl(_) ? !1 : y(this, _ === 0 ? 0 : _);
                  }
                : g == "get"
                  ? function (b) {
                      return i && !zl(b) ? void 0 : y(this, b === 0 ? 0 : b);
                    }
                  : g == "has"
                    ? function (b) {
                        return i && !zl(b) ? !1 : y(this, b === 0 ? 0 : b);
                      }
                    : function (b, I) {
                        return y(this, b === 0 ? 0 : b, I), this;
                      },
          );
        },
        c = ZE(
          e,
          !vz(s) ||
            !(
              i ||
              (o.forEach &&
                !jl(function () {
                  new s().entries().next();
                }))
            ),
        );
      if (c) (l = r.getConstructor(t, e, n, a)), pz.enable();
      else if (ZE(e, !0)) {
        var v = new l(),
          d = v[a](i ? {} : -0, 1) != v,
          p = jl(function () {
            v.has(1);
          }),
          m = gz(function (g) {
            new s(g);
          }),
          h =
            !i &&
            jl(function () {
              for (var g = new s(), y = 5; y--; ) g[a](y, y);
              return !g.has(-0);
            });
        m ||
          ((l = t(function (g, y) {
            mz(g, o);
            var _ = Ez(new s(), g, l);
            return y != null && dz(y, _[a], { that: _, AS_ENTRIES: n }), _;
          })),
          (l.prototype = o),
          (o.constructor = l)),
          (p || h) && (u("delete"), u("has"), n && u("get")),
          (h || d) && u(a),
          i && o.clear && delete o.clear;
      }
      return (
        (f[e] = l),
        uz({ global: !0, forced: l != s }, f),
        yz(l, e),
        i || r.setStrong(l, e, n),
        l
      );
    };
  });
  var qa = E((Wse, t1) => {
    var _z = Wt();
    t1.exports = function (e, t, r) {
      for (var n in t) _z(e, n, t[n], r);
      return e;
    };
  });
  var o1 = E((Xse, s1) => {
    "use strict";
    var bz = ht().f,
      Sz = fr(),
      r1 = qa(),
      Iz = Tt(),
      Tz = Da(),
      xz = Ra(),
      Az = Pa(),
      Pz = Ma(),
      ui = bt(),
      n1 = Gl().fastKey,
      a1 = Cr(),
      i1 = a1.set,
      Hl = a1.getterFor;
    s1.exports = {
      getConstructor: function (e, t, r, n) {
        var i = e(function (f, u) {
            Tz(f, a),
              i1(f, {
                type: t,
                index: Sz(null),
                first: void 0,
                last: void 0,
                size: 0,
              }),
              ui || (f.size = 0),
              u != null && xz(u, f[n], { that: f, AS_ENTRIES: r });
          }),
          a = i.prototype,
          s = Hl(t),
          o = function (f, u, c) {
            var v = s(f),
              d = l(f, u),
              p,
              m;
            return (
              d
                ? (d.value = c)
                : ((v.last = d =
                    {
                      index: (m = n1(u, !0)),
                      key: u,
                      value: c,
                      previous: (p = v.last),
                      next: void 0,
                      removed: !1,
                    }),
                  v.first || (v.first = d),
                  p && (p.next = d),
                  ui ? v.size++ : f.size++,
                  m !== "F" && (v.index[m] = d)),
              f
            );
          },
          l = function (f, u) {
            var c = s(f),
              v = n1(u),
              d;
            if (v !== "F") return c.index[v];
            for (d = c.first; d; d = d.next) if (d.key == u) return d;
          };
        return (
          r1(a, {
            clear: function () {
              for (var u = this, c = s(u), v = c.index, d = c.first; d; )
                (d.removed = !0),
                  d.previous && (d.previous = d.previous.next = void 0),
                  delete v[d.index],
                  (d = d.next);
              (c.first = c.last = void 0), ui ? (c.size = 0) : (u.size = 0);
            },
            delete: function (f) {
              var u = this,
                c = s(u),
                v = l(u, f);
              if (v) {
                var d = v.next,
                  p = v.previous;
                delete c.index[v.index],
                  (v.removed = !0),
                  p && (p.next = d),
                  d && (d.previous = p),
                  c.first == v && (c.first = d),
                  c.last == v && (c.last = p),
                  ui ? c.size-- : u.size--;
              }
              return !!v;
            },
            forEach: function (u) {
              for (
                var c = s(this),
                  v = Iz(u, arguments.length > 1 ? arguments[1] : void 0),
                  d;
                (d = d ? d.next : c.first);

              )
                for (v(d.value, d.key, this); d && d.removed; ) d = d.previous;
            },
            has: function (u) {
              return !!l(this, u);
            },
          }),
          r1(
            a,
            r
              ? {
                  get: function (u) {
                    var c = l(this, u);
                    return c && c.value;
                  },
                  set: function (u, c) {
                    return o(this, u === 0 ? 0 : u, c);
                  },
                }
              : {
                  add: function (u) {
                    return o(this, (u = u === 0 ? 0 : u), u);
                  },
                },
          ),
          ui &&
            bz(a, "size", {
              get: function () {
                return s(this).size;
              },
            }),
          i
        );
      },
      setStrong: function (e, t, r) {
        var n = t + " Iterator",
          i = Hl(t),
          a = Hl(n);
        Az(
          e,
          t,
          function (s, o) {
            i1(this, {
              type: n,
              target: s,
              state: i(s),
              kind: o,
              last: void 0,
            });
          },
          function () {
            for (var s = a(this), o = s.kind, l = s.last; l && l.removed; )
              l = l.previous;
            return !s.target || !(s.last = l = l ? l.next : s.state.first)
              ? ((s.target = void 0), { value: void 0, done: !0 })
              : o == "keys"
                ? { value: l.key, done: !1 }
                : o == "values"
                  ? { value: l.value, done: !1 }
                  : { value: [l.key, l.value], done: !1 };
          },
          r ? "entries" : "values",
          !r,
          !0,
        ),
          Pz(t);
      },
    };
  });
  var l1 = E(() => {
    "use strict";
    var Cz = e1(),
      wz = o1();
    Cz(
      "Map",
      function (e) {
        return function () {
          return e(this, arguments.length ? arguments[0] : void 0);
        };
      },
      wz,
    );
  });
  var h1 = E((Kse, u1) => {
    var Mz = Z();
    u1.exports = Mz.Promise;
  });
  var f1 = E((Yse, c1) => {
    var Oz = Z(),
      Rz = wr(),
      Dz = Un(),
      qz = Oz.TypeError;
    c1.exports = function (e) {
      if (Rz(e)) return e;
      throw qz(Dz(e) + " is not a constructor");
    };
  });
  var m1 = E((Qse, d1) => {
    var p1 = Xe(),
      Fz = f1(),
      Lz = xe(),
      Nz = Lz("species");
    d1.exports = function (e, t) {
      var r = p1(e).constructor,
        n;
      return r === void 0 || (n = p1(r)[Nz]) == null ? t : Fz(n);
    };
  });
  var Wl = E((Zse, v1) => {
    var kz = sr();
    v1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(kz);
  });
  var eu = E((Jse, T1) => {
    var rt = Z(),
      Bz = Ca(),
      Vz = Tt(),
      g1 = Te(),
      Gz = ut(),
      zz = Fe(),
      y1 = hl(),
      jz = li(),
      E1 = ua(),
      Hz = Wl(),
      Wz = on(),
      Ql = rt.setImmediate,
      Zl = rt.clearImmediate,
      Xz = rt.process,
      Xl = rt.Dispatch,
      Uz = rt.Function,
      _1 = rt.MessageChannel,
      $z = rt.String,
      Ul = 0,
      hi = {},
      b1 = "onreadystatechange",
      ci,
      Or,
      $l,
      Kl;
    try {
      ci = rt.location;
    } catch {}
    var Jl = function (e) {
        if (Gz(hi, e)) {
          var t = hi[e];
          delete hi[e], t();
        }
      },
      Yl = function (e) {
        return function () {
          Jl(e);
        };
      },
      S1 = function (e) {
        Jl(e.data);
      },
      I1 = function (e) {
        rt.postMessage($z(e), ci.protocol + "//" + ci.host);
      };
    (!Ql || !Zl) &&
      ((Ql = function (t) {
        var r = jz(arguments, 1);
        return (
          (hi[++Ul] = function () {
            Bz(g1(t) ? t : Uz(t), void 0, r);
          }),
          Or(Ul),
          Ul
        );
      }),
      (Zl = function (t) {
        delete hi[t];
      }),
      Wz
        ? (Or = function (e) {
            Xz.nextTick(Yl(e));
          })
        : Xl && Xl.now
          ? (Or = function (e) {
              Xl.now(Yl(e));
            })
          : _1 && !Hz
            ? (($l = new _1()),
              (Kl = $l.port2),
              ($l.port1.onmessage = S1),
              (Or = Vz(Kl.postMessage, Kl)))
            : rt.addEventListener &&
                g1(rt.postMessage) &&
                !rt.importScripts &&
                ci &&
                ci.protocol !== "file:" &&
                !zz(I1)
              ? ((Or = I1), rt.addEventListener("message", S1, !1))
              : b1 in E1("script")
                ? (Or = function (e) {
                    y1.appendChild(E1("script"))[b1] = function () {
                      y1.removeChild(this), Jl(e);
                    };
                  })
                : (Or = function (e) {
                    setTimeout(Yl(e), 0);
                  }));
    T1.exports = { set: Ql, clear: Zl };
  });
  var A1 = E((eoe, x1) => {
    var Kz = sr(),
      Yz = Z();
    x1.exports = /ipad|iphone|ipod/i.test(Kz) && Yz.Pebble !== void 0;
  });
  var C1 = E((toe, P1) => {
    var Qz = sr();
    P1.exports = /web0s(?!.*chrome)/i.test(Qz);
  });
  var N1 = E((roe, L1) => {
    var Dr = Z(),
      w1 = Tt(),
      Zz = ha().f,
      tu = eu().set,
      Jz = Wl(),
      ej = A1(),
      tj = C1(),
      ru = on(),
      M1 = Dr.MutationObserver || Dr.WebKitMutationObserver,
      O1 = Dr.document,
      R1 = Dr.process,
      Fa = Dr.Promise,
      D1 = Zz(Dr, "queueMicrotask"),
      F1 = D1 && D1.value,
      fi,
      Rr,
      pi,
      ln,
      nu,
      iu,
      La,
      q1;
    F1 ||
      ((fi = function () {
        var e, t;
        for (ru && (e = R1.domain) && e.exit(); Rr; ) {
          (t = Rr.fn), (Rr = Rr.next);
          try {
            t();
          } catch (r) {
            throw (Rr ? ln() : (pi = void 0), r);
          }
        }
        (pi = void 0), e && e.enter();
      }),
      !Jz && !ru && !tj && M1 && O1
        ? ((nu = !0),
          (iu = O1.createTextNode("")),
          new M1(fi).observe(iu, { characterData: !0 }),
          (ln = function () {
            iu.data = nu = !nu;
          }))
        : !ej && Fa && Fa.resolve
          ? ((La = Fa.resolve(void 0)),
            (La.constructor = Fa),
            (q1 = w1(La.then, La)),
            (ln = function () {
              q1(fi);
            }))
          : ru
            ? (ln = function () {
                R1.nextTick(fi);
              })
            : ((tu = w1(tu, Dr)),
              (ln = function () {
                tu(fi);
              })));
    L1.exports =
      F1 ||
      function (e) {
        var t = { fn: e, next: void 0 };
        pi && (pi.next = t), Rr || ((Rr = t), ln()), (pi = t);
      };
  });
  var au = E((noe, B1) => {
    "use strict";
    var k1 = It(),
      rj = function (e) {
        var t, r;
        (this.promise = new e(function (n, i) {
          if (t !== void 0 || r !== void 0)
            throw TypeError("Bad Promise constructor");
          (t = n), (r = i);
        })),
          (this.resolve = k1(t)),
          (this.reject = k1(r));
      };
    B1.exports.f = function (e) {
      return new rj(e);
    };
  });
  var G1 = E((ioe, V1) => {
    var nj = Xe(),
      ij = Ke(),
      aj = au();
    V1.exports = function (e, t) {
      if ((nj(e), ij(t) && t.constructor === e)) return t;
      var r = aj.f(e),
        n = r.resolve;
      return n(t), r.promise;
    };
  });
  var j1 = E((aoe, z1) => {
    var sj = Z();
    z1.exports = function (e, t) {
      var r = sj.console;
      r && r.error && (arguments.length == 1 ? r.error(e) : r.error(e, t));
    };
  });
  var W1 = E((soe, H1) => {
    H1.exports = function (e) {
      try {
        return { error: !1, value: e() };
      } catch (t) {
        return { error: !0, value: t };
      }
    };
  });
  var U1 = E((ooe, X1) => {
    X1.exports = typeof window == "object";
  });
  var p_ = E(() => {
    "use strict";
    var Ga = ae(),
      ka = en(),
      $t = Z(),
      oj = lt(),
      Kt = ot(),
      Ba = h1(),
      $1 = Wt(),
      lj = qa(),
      K1 = Ta(),
      uj = ai(),
      hj = Ma(),
      su = It(),
      di = Te(),
      cj = Ke(),
      fj = Da(),
      pj = Qn(),
      Y1 = Ra(),
      dj = _a(),
      mj = m1(),
      n_ = eu().set,
      i_ = N1(),
      vj = G1(),
      gj = j1(),
      a_ = au(),
      ou = W1(),
      cu = Cr(),
      yj = ga(),
      Ej = xe(),
      _j = U1(),
      Va = on(),
      Q1 = or(),
      bj = Ej("species"),
      Yt = "Promise",
      Z1 = cu.get,
      Sj = cu.set,
      Ij = cu.getterFor(Yt),
      qr = Ba && Ba.prototype,
      ct = Ba,
      un = qr,
      s_ = $t.TypeError,
      lu = $t.document,
      fu = $t.process,
      fn = a_.f,
      Tj = fn,
      xj = !!(lu && lu.createEvent && $t.dispatchEvent),
      o_ = di($t.PromiseRejectionEvent),
      l_ = "unhandledrejection",
      Aj = "rejectionhandled",
      J1 = 0,
      u_ = 1,
      Pj = 2,
      pu = 1,
      h_ = 2,
      uu = !1,
      Na,
      e_,
      du,
      t_,
      mi = yj(Yt, function () {
        var e = pj(ct),
          t = e !== String(ct);
        if ((!t && Q1 === 66) || (ka && !un.finally)) return !0;
        if (Q1 >= 51 && /native code/.test(e)) return !1;
        var r = new ct(function (a) {
            a(1);
          }),
          n = function (a) {
            a(
              function () {},
              function () {},
            );
          },
          i = (r.constructor = {});
        return (
          (i[bj] = n),
          (uu = r.then(function () {}) instanceof n),
          uu ? !t && _j && !o_ : !0
        );
      }),
      Cj =
        mi ||
        !dj(function (e) {
          ct.all(e).catch(function () {});
        }),
      c_ = function (e) {
        var t;
        return cj(e) && di((t = e.then)) ? t : !1;
      },
      mu = function (e, t) {
        if (!e.notified) {
          e.notified = !0;
          var r = e.reactions;
          i_(function () {
            for (var n = e.value, i = e.state == u_, a = 0; r.length > a; ) {
              var s = r[a++],
                o = i ? s.ok : s.fail,
                l = s.resolve,
                f = s.reject,
                u = s.domain,
                c,
                v,
                d;
              try {
                o
                  ? (i || (e.rejection === h_ && Mj(e), (e.rejection = pu)),
                    o === !0
                      ? (c = n)
                      : (u && u.enter(), (c = o(n)), u && (u.exit(), (d = !0))),
                    c === s.promise
                      ? f(s_("Promise-chain cycle"))
                      : (v = c_(c))
                        ? Kt(v, c, l, f)
                        : l(c))
                  : f(n);
              } catch (p) {
                u && !d && u.exit(), f(p);
              }
            }
            (e.reactions = []), (e.notified = !1), t && !e.rejection && wj(e);
          });
        }
      },
      f_ = function (e, t, r) {
        var n, i;
        xj
          ? ((n = lu.createEvent("Event")),
            (n.promise = t),
            (n.reason = r),
            n.initEvent(e, !1, !0),
            $t.dispatchEvent(n))
          : (n = { promise: t, reason: r }),
          !o_ && (i = $t["on" + e])
            ? i(n)
            : e === l_ && gj("Unhandled promise rejection", r);
      },
      wj = function (e) {
        Kt(n_, $t, function () {
          var t = e.facade,
            r = e.value,
            n = r_(e),
            i;
          if (
            n &&
            ((i = ou(function () {
              Va ? fu.emit("unhandledRejection", r, t) : f_(l_, t, r);
            })),
            (e.rejection = Va || r_(e) ? h_ : pu),
            i.error)
          )
            throw i.value;
        });
      },
      r_ = function (e) {
        return e.rejection !== pu && !e.parent;
      },
      Mj = function (e) {
        Kt(n_, $t, function () {
          var t = e.facade;
          Va ? fu.emit("rejectionHandled", t) : f_(Aj, t, e.value);
        });
      },
      hn = function (e, t, r) {
        return function (n) {
          e(t, n, r);
        };
      },
      cn = function (e, t, r) {
        e.done ||
          ((e.done = !0),
          r && (e = r),
          (e.value = t),
          (e.state = Pj),
          mu(e, !0));
      },
      hu = function (e, t, r) {
        if (!e.done) {
          (e.done = !0), r && (e = r);
          try {
            if (e.facade === t) throw s_("Promise can't be resolved itself");
            var n = c_(t);
            n
              ? i_(function () {
                  var i = { done: !1 };
                  try {
                    Kt(n, t, hn(hu, i, e), hn(cn, i, e));
                  } catch (a) {
                    cn(i, a, e);
                  }
                })
              : ((e.value = t), (e.state = u_), mu(e, !1));
          } catch (i) {
            cn({ done: !1 }, i, e);
          }
        }
      };
    if (
      mi &&
      ((ct = function (t) {
        fj(this, un), su(t), Kt(Na, this);
        var r = Z1(this);
        try {
          t(hn(hu, r), hn(cn, r));
        } catch (n) {
          cn(r, n);
        }
      }),
      (un = ct.prototype),
      (Na = function (t) {
        Sj(this, {
          type: Yt,
          done: !1,
          notified: !1,
          parent: !1,
          reactions: [],
          rejection: !1,
          state: J1,
          value: void 0,
        });
      }),
      (Na.prototype = lj(un, {
        then: function (t, r) {
          var n = Ij(this),
            i = n.reactions,
            a = fn(mj(this, ct));
          return (
            (a.ok = di(t) ? t : !0),
            (a.fail = di(r) && r),
            (a.domain = Va ? fu.domain : void 0),
            (n.parent = !0),
            (i[i.length] = a),
            n.state != J1 && mu(n, !1),
            a.promise
          );
        },
        catch: function (e) {
          return this.then(void 0, e);
        },
      })),
      (e_ = function () {
        var e = new Na(),
          t = Z1(e);
        (this.promise = e),
          (this.resolve = hn(hu, t)),
          (this.reject = hn(cn, t));
      }),
      (a_.f = fn =
        function (e) {
          return e === ct || e === du ? new e_(e) : Tj(e);
        }),
      !ka && di(Ba) && qr !== Object.prototype)
    ) {
      (t_ = qr.then),
        uu ||
          ($1(
            qr,
            "then",
            function (t, r) {
              var n = this;
              return new ct(function (i, a) {
                Kt(t_, n, i, a);
              }).then(t, r);
            },
            { unsafe: !0 },
          ),
          $1(qr, "catch", un.catch, { unsafe: !0 }));
      try {
        delete qr.constructor;
      } catch {}
      K1 && K1(qr, un);
    }
    Ga({ global: !0, wrap: !0, forced: mi }, { Promise: ct });
    uj(ct, Yt, !1, !0);
    hj(Yt);
    du = oj(Yt);
    Ga(
      { target: Yt, stat: !0, forced: mi },
      {
        reject: function (t) {
          var r = fn(this);
          return Kt(r.reject, void 0, t), r.promise;
        },
      },
    );
    Ga(
      { target: Yt, stat: !0, forced: ka || mi },
      {
        resolve: function (t) {
          return vj(ka && this === du ? ct : this, t);
        },
      },
    );
    Ga(
      { target: Yt, stat: !0, forced: Cj },
      {
        all: function (t) {
          var r = this,
            n = fn(r),
            i = n.resolve,
            a = n.reject,
            s = ou(function () {
              var o = su(r.resolve),
                l = [],
                f = 0,
                u = 1;
              Y1(t, function (c) {
                var v = f++,
                  d = !1;
                u++,
                  Kt(o, r, c).then(function (p) {
                    d || ((d = !0), (l[v] = p), --u || i(l));
                  }, a);
              }),
                --u || i(l);
            });
          return s.error && a(s.value), n.promise;
        },
        race: function (t) {
          var r = this,
            n = fn(r),
            i = n.reject,
            a = ou(function () {
              var s = su(r.resolve);
              Y1(t, function (o) {
                Kt(s, r, o).then(n.resolve, i);
              });
            });
          return a.error && i(a.value), n.promise;
        },
      },
    );
  });
  var S_ = E((hoe, b_) => {
    var y_ = Z(),
      E_ = $n(),
      __ = Te(),
      Oj = fr(),
      za = Ia(),
      Rj = Wt(),
      Dj = xe(),
      qj = en(),
      d_ = "USE_FUNCTION_CONSTRUCTOR",
      m_ = Dj("asyncIterator"),
      v_ = y_.AsyncIterator,
      g_ = E_.AsyncIteratorPrototype,
      Ft,
      vu;
    if (g_) Ft = g_;
    else if (__(v_)) Ft = v_.prototype;
    else if (E_[d_] || y_[d_])
      try {
        (vu = za(za(za(Function("return async function*(){}()")())))),
          za(vu) === Object.prototype && (Ft = vu);
      } catch {}
    Ft ? qj && (Ft = Oj(Ft)) : (Ft = {});
    __(Ft[m_]) ||
      Rj(Ft, m_, function () {
        return this;
      });
    b_.exports = Ft;
  });
  var _u = E((coe, A_) => {
    "use strict";
    var gu = Ca(),
      ja = Xe(),
      Fj = fr(),
      I_ = lr(),
      Lj = qa(),
      T_ = Cr(),
      Nj = lt(),
      kj = S_(),
      Ha = Nj("Promise"),
      Bj = T_.set,
      yu = T_.get,
      Eu = function (e, t, r) {
        var n = e.done;
        Ha.resolve(e.value).then(function (i) {
          t({ done: n, value: i });
        }, r);
      },
      x_ = function (t) {
        Bj(this, { iterator: ja(t), next: t.next });
      };
    x_.prototype = Lj(Fj(kj), {
      next: function (t) {
        var r = yu(this),
          n = !!arguments.length;
        return new Ha(function (i, a) {
          var s = ja(gu(r.next, r.iterator, n ? [t] : []));
          Eu(s, i, a);
        });
      },
      return: function (e) {
        var t = yu(this).iterator,
          r = !!arguments.length;
        return new Ha(function (n, i) {
          var a = I_(t, "return");
          if (a === void 0) return n({ done: !0, value: e });
          var s = ja(gu(a, t, r ? [e] : []));
          Eu(s, n, i);
        });
      },
      throw: function (e) {
        var t = yu(this).iterator,
          r = !!arguments.length;
        return new Ha(function (n, i) {
          var a = I_(t, "throw");
          if (a === void 0) return i(e);
          var s = ja(gu(a, t, r ? [e] : []));
          Eu(s, n, i);
        });
      },
    });
    A_.exports = x_;
  });
  var C_ = E((foe, P_) => {
    var Vj = ot(),
      Gj = _u(),
      zj = Xe(),
      jj = ii(),
      Hj = lr(),
      Wj = xe(),
      Xj = Wj("asyncIterator");
    P_.exports = function (e, t) {
      var r = arguments.length < 2 ? Hj(e, Xj) : t;
      return r ? zj(Vj(r, e)) : new Gj(jj(e));
    };
  });
  var M_ = E((poe, w_) => {
    var Uj = Z();
    w_.exports = function (e) {
      return Uj[e].prototype;
    };
  });
  var q_ = E((doe, D_) => {
    "use strict";
    var $j = Z(),
      O_ = ot(),
      R_ = It(),
      bu = Xe(),
      Kj = lt(),
      Yj = lr(),
      Qj = 9007199254740991,
      Zj = $j.TypeError,
      vi = function (e) {
        var t = e == 0,
          r = e == 1,
          n = e == 2,
          i = e == 3;
        return function (a, s, o) {
          bu(a);
          var l = Kj("Promise"),
            f = R_(a.next),
            u = 0,
            c = s !== void 0;
          return (
            (c || !t) && R_(s),
            new l(function (v, d) {
              var p = function (g, y) {
                  try {
                    var _ = Yj(a, "return");
                    if (_)
                      return l.resolve(O_(_, a)).then(
                        function () {
                          g(y);
                        },
                        function (b) {
                          d(b);
                        },
                      );
                  } catch (b) {
                    return d(b);
                  }
                  g(y);
                },
                m = function (g) {
                  p(d, g);
                },
                h = function () {
                  try {
                    if (t && u > Qj && c)
                      throw Zj(
                        "The allowed number of iterations has been exceeded",
                      );
                    l.resolve(bu(O_(f, a))).then(function (g) {
                      try {
                        if (bu(g).done)
                          t ? ((o.length = u), v(o)) : v(i ? !1 : n || void 0);
                        else {
                          var y = g.value;
                          c
                            ? l.resolve(t ? s(y, u) : s(y)).then(function (_) {
                                r
                                  ? h()
                                  : n
                                    ? _
                                      ? h()
                                      : p(v, !1)
                                    : t
                                      ? ((o[u++] = _), h())
                                      : _
                                        ? p(v, i || y)
                                        : h();
                              }, m)
                            : ((o[u++] = y), h());
                        }
                      } catch (_) {
                        m(_);
                      }
                    }, m);
                  } catch (g) {
                    m(g);
                  }
                };
              h();
            })
          );
        };
      };
    D_.exports = {
      toArray: vi(0),
      forEach: vi(1),
      every: vi(2),
      some: vi(3),
      find: vi(4),
    };
  });
  var L_ = E((moe, F_) => {
    "use strict";
    var Jj = Tt(),
      eH = Pe(),
      tH = wr(),
      rH = C_(),
      nH = ii(),
      iH = ni(),
      aH = lr(),
      sH = M_(),
      oH = lt(),
      lH = xe(),
      uH = _u(),
      hH = q_().toArray,
      cH = lH("asyncIterator"),
      fH = sH("Array").values;
    F_.exports = function (t) {
      var r = this,
        n = arguments.length,
        i = n > 1 ? arguments[1] : void 0,
        a = n > 2 ? arguments[2] : void 0;
      return new (oH("Promise"))(function (s) {
        var o = eH(t);
        i !== void 0 && (i = Jj(i, a));
        var l = aH(o, cH),
          f = l ? void 0 : iH(o) || fH,
          u = tH(r) ? new r() : [],
          c = l ? rH(o, l) : new uH(nH(o, f));
        s(hH(c, i, u));
      });
    };
  });
  var N_ = E(() => {
    var pH = ae(),
      dH = L_();
    pH({ target: "Array", stat: !0 }, { fromAsync: dH });
  });
  var k_ = E(() => {
    vl();
  });
  var B_ = E(() => {
    "use strict";
    var mH = ae(),
      vH = Dt().filterReject,
      gH = Oe();
    mH(
      { target: "Array", proto: !0 },
      {
        filterOut: function (t) {
          return vH(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    gH("filterOut");
  });
  var V_ = E(() => {
    "use strict";
    var yH = ae(),
      EH = Dt().filterReject,
      _H = Oe();
    yH(
      { target: "Array", proto: !0 },
      {
        filterReject: function (t) {
          return EH(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    _H("filterReject");
  });
  var Su = E((Toe, z_) => {
    var bH = Tt(),
      SH = xr(),
      IH = Pe(),
      TH = Se(),
      G_ = function (e) {
        var t = e == 1;
        return function (r, n, i) {
          for (
            var a = IH(r), s = SH(a), o = bH(n, i), l = TH(s), f, u;
            l-- > 0;

          )
            if (((f = s[l]), (u = o(f, l, a)), u))
              switch (e) {
                case 0:
                  return f;
                case 1:
                  return l;
              }
          return t ? -1 : void 0;
        };
      };
    z_.exports = { findLast: G_(0), findLastIndex: G_(1) };
  });
  var j_ = E(() => {
    "use strict";
    var xH = ae(),
      AH = Su().findLast,
      PH = Oe();
    xH(
      { target: "Array", proto: !0 },
      {
        findLast: function (t) {
          return AH(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    PH("findLast");
  });
  var H_ = E(() => {
    "use strict";
    var CH = ae(),
      wH = Su().findLastIndex,
      MH = Oe();
    CH(
      { target: "Array", proto: !0 },
      {
        findLastIndex: function (t) {
          return wH(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    MH("findLastIndex");
  });
  var X_ = E((woe, W_) => {
    W_.exports = function (e, t) {
      for (var r = 0, n = t.length, i = new e(n); n > r; ) i[r] = t[r++];
      return i;
    };
  });
  var $_ = E((Moe, U_) => {
    var OH = Z(),
      RH = Tt(),
      DH = Ee(),
      qH = xr(),
      FH = Pe(),
      LH = Kn(),
      NH = Se(),
      kH = fr(),
      BH = X_(),
      VH = OH.Array,
      GH = DH([].push);
    U_.exports = function (e, t, r, n) {
      for (
        var i = FH(e),
          a = qH(i),
          s = RH(t, r),
          o = kH(null),
          l = NH(a),
          f = 0,
          u,
          c,
          v;
        l > f;
        f++
      )
        (v = a[f]), (c = LH(s(v, f, i))), c in o ? GH(o[c], v) : (o[c] = [v]);
      if (n && ((u = n(i)), u !== VH)) for (c in o) o[c] = BH(u, o[c]);
      return o;
    };
  });
  var K_ = E(() => {
    "use strict";
    var zH = ae(),
      jH = $_(),
      HH = gl(),
      WH = Oe();
    zH(
      { target: "Array", proto: !0 },
      {
        groupBy: function (t) {
          var r = arguments.length > 1 ? arguments[1] : void 0;
          return jH(this, t, r, HH);
        },
      },
    );
    WH("groupBy");
  });
  var Z_ = E(() => {
    var XH = ae(),
      UH = cr(),
      Y_ = Object.isFrozen,
      Q_ = function (e, t) {
        if (!Y_ || !UH(e) || !Y_(e)) return !1;
        for (var r = 0, n = e.length, i; r < n; )
          if (((i = e[r++]), !(typeof i == "string" || (t && typeof i > "u"))))
            return !1;
        return n !== 0;
      };
    XH(
      { target: "Array", stat: !0 },
      {
        isTemplateObject: function (t) {
          if (!Q_(t, !0)) return !1;
          var r = t.raw;
          return !(r.length !== t.length || !Q_(r, !1));
        },
      },
    );
  });
  var tb = E(() => {
    "use strict";
    var $H = bt(),
      KH = Oe(),
      J_ = Pe(),
      eb = Se(),
      YH = ht().f;
    $H &&
      !("lastItem" in []) &&
      (YH(Array.prototype, "lastItem", {
        configurable: !0,
        get: function () {
          var t = J_(this),
            r = eb(t);
          return r == 0 ? void 0 : t[r - 1];
        },
        set: function (t) {
          var r = J_(this),
            n = eb(r);
          return (r[n == 0 ? 0 : n - 1] = t);
        },
      }),
      KH("lastItem"));
  });
  var rb = E(() => {
    "use strict";
    var QH = bt(),
      ZH = Oe(),
      JH = Pe(),
      eW = Se(),
      tW = ht().f;
    QH &&
      !("lastIndex" in []) &&
      (tW(Array.prototype, "lastIndex", {
        configurable: !0,
        get: function () {
          var t = JH(this),
            r = eW(t);
          return r == 0 ? 0 : r - 1;
        },
      }),
      ZH("lastIndex"));
  });
  var ab = E((Boe, ib) => {
    "use strict";
    var rW = lt(),
      Wa = Ee(),
      nW = It(),
      iW = Se(),
      aW = Pe(),
      sW = Mr(),
      nb = rW("Map"),
      Iu = nb.prototype,
      oW = Wa(Iu.forEach),
      lW = Wa(Iu.has),
      uW = Wa(Iu.set),
      hW = Wa([].push);
    ib.exports = function (t) {
      var r = aW(this),
        n = iW(r),
        i = sW(r, 0),
        a = new nb(),
        s =
          t != null
            ? nW(t)
            : function (u) {
                return u;
              },
        o,
        l,
        f;
      for (o = 0; o < n; o++) (l = r[o]), (f = s(l)), lW(a, f) || uW(a, f, l);
      return (
        oW(a, function (u) {
          hW(i, u);
        }),
        i
      );
    };
  });
  var sb = E(() => {
    "use strict";
    var cW = ae(),
      fW = Oe(),
      pW = ab();
    cW({ target: "Array", proto: !0 }, { uniqueBy: pW });
    fW("uniqueBy");
  });
  var ub = E((zoe, lb) => {
    var dW = qE();
    l1();
    p_();
    N_();
    k_();
    B_();
    V_();
    j_();
    H_();
    K_();
    Z_();
    tb();
    rb();
    sb();
    lb.exports = dW;
  });
  var Pb = E((Qa) => {
    "use strict";
    Object.defineProperty(Qa, "__esModule", { value: !0 });
    Qa.strFromU8 = Ab;
    Qa.unzip = PW;
    var hb = {},
      mW = function (e, t, r, n, i) {
        let a = new Worker(
          hb[t] ||
            (hb[t] = URL.createObjectURL(
              new Blob(
                [
                  e +
                    ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})',
                ],
                { type: "text/javascript" },
              ),
            )),
        );
        return (
          (a.onmessage = function (s) {
            let o = s.data,
              l = o.$e$;
            if (l) {
              let f = new Error(l[0]);
              (f.code = l[1]), (f.stack = l[2]), i(f, null);
            } else i(null, o);
          }),
          a.postMessage(r, n),
          a
        );
      },
      Qe = Uint8Array,
      vr = Uint16Array,
      Tu = Uint32Array,
      xu = new Qe([
        0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4,
        5, 5, 5, 5, 0, 0, 0, 0,
      ]),
      Au = new Qe([
        0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10,
        10, 11, 11, 12, 12, 13, 13, 0, 0,
      ]),
      db = new Qe([
        16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
      ]),
      mb = function (e, t) {
        let r = new vr(31);
        for (var n = 0; n < 31; ++n) r[n] = t += 1 << e[n - 1];
        let i = new Tu(r[30]);
        for (n = 1; n < 30; ++n)
          for (let a = r[n]; a < r[n + 1]; ++a) i[a] = ((a - r[n]) << 5) | n;
        return [r, i];
      },
      vb = mb(xu, 2),
      Pu = vb[0],
      vW = vb[1];
    (Pu[28] = 258), (vW[258] = 28);
    var gW = mb(Au, 0),
      gb = gW[0],
      Ka = new vr(32768);
    for (ve = 0; ve < 32768; ++ve) {
      let e = ((43690 & ve) >>> 1) | ((21845 & ve) << 1);
      (e = ((52428 & e) >>> 2) | ((13107 & e) << 2)),
        (e = ((61680 & e) >>> 4) | ((3855 & e) << 4)),
        (Ka[ve] = (((65280 & e) >>> 8) | ((255 & e) << 8)) >>> 1);
    }
    var ve,
      pn = function (e, t, r) {
        let n = e.length,
          i = 0,
          a = new vr(t);
        for (; i < n; ++i) e[i] && ++a[e[i] - 1];
        let s = new vr(t);
        for (i = 0; i < t; ++i) s[i] = (s[i - 1] + a[i - 1]) << 1;
        let o;
        if (r) {
          o = new vr(1 << t);
          let l = 15 - t;
          for (i = 0; i < n; ++i)
            if (e[i]) {
              let f = (i << 4) | e[i],
                u = t - e[i],
                c = s[e[i] - 1]++ << u;
              for (let v = c | ((1 << u) - 1); c <= v; ++c) o[Ka[c] >>> l] = f;
            }
        } else
          for (o = new vr(n), i = 0; i < n; ++i)
            e[i] && (o[i] = Ka[s[e[i] - 1]++] >>> (15 - e[i]));
        return o;
      },
      gi = new Qe(288);
    for (ve = 0; ve < 144; ++ve) gi[ve] = 8;
    for (ve = 144; ve < 256; ++ve) gi[ve] = 9;
    for (ve = 256; ve < 280; ++ve) gi[ve] = 7;
    for (ve = 280; ve < 288; ++ve) gi[ve] = 8;
    var yb = new Qe(32);
    for (ve = 0; ve < 32; ++ve) yb[ve] = 5;
    var Eb = pn(gi, 9, 1),
      _b = pn(yb, 5, 1),
      Ua = function (e) {
        let t = e[0];
        for (let r = 1; r < e.length; ++r) e[r] > t && (t = e[r]);
        return t;
      },
      ft = function (e, t, r) {
        let n = (t / 8) | 0;
        return ((e[n] | (e[n + 1] << 8)) >> (7 & t)) & r;
      },
      $a = function (e, t) {
        let r = (t / 8) | 0;
        return (e[r] | (e[r + 1] << 8) | (e[r + 2] << 16)) >> (7 & t);
      },
      bb = function (e) {
        return ((e + 7) / 8) | 0;
      },
      Ya = function (e, t, r) {
        (t == null || t < 0) && (t = 0),
          (r == null || r > e.length) && (r = e.length);
        let n = new (
          e.BYTES_PER_ELEMENT === 2 ? vr : e.BYTES_PER_ELEMENT === 4 ? Tu : Qe
        )(r - t);
        return n.set(e.subarray(t, r)), n;
      },
      Sb = [
        "unexpected EOF",
        "invalid block type",
        "invalid length/literal",
        "invalid distance",
        "stream finished",
        "no stream handler",
        ,
        "no callback",
        "invalid UTF-8 data",
        "extra field too long",
        "date not in range 1980-2099",
        "filename too long",
        "stream finishing",
        "invalid zip data",
      ],
      Ye = function (e, t, r) {
        let n = new Error(t || Sb[e]);
        if (
          ((n.code = e),
          Error.captureStackTrace && Error.captureStackTrace(n, Ye),
          !r)
        )
          throw n;
        return n;
      },
      Ib = function (e, t, r) {
        let n = e.length;
        if (!n || (r && r.f && !r.l)) return t || new Qe(0);
        let i = !t || r,
          a = !r || r.i;
        r || (r = {}), t || (t = new Qe(3 * n));
        let s = function (b) {
            let I = t.length;
            if (b > I) {
              let P = new Qe(Math.max(2 * I, b));
              P.set(t), (t = P);
            }
          },
          o = r.f || 0,
          l = r.p || 0,
          f = r.b || 0,
          u = r.l,
          c = r.d,
          v = r.m,
          d = r.n,
          p = 8 * n;
        do {
          if (!u) {
            o = ft(e, l, 1);
            let S = ft(e, l + 1, 3);
            if (((l += 3), !S)) {
              let A = e[(h = bb(l) + 4) - 4] | (e[h - 3] << 8),
                R = h + A;
              if (R > n) {
                a && Ye(0);
                break;
              }
              i && s(f + A),
                t.set(e.subarray(h, R), f),
                (r.b = f += A),
                (r.p = l = 8 * R),
                (r.f = o);
              continue;
            }
            if (S === 1) (u = Eb), (c = _b), (v = 9), (d = 5);
            else if (S === 2) {
              let A = ft(e, l, 31) + 257,
                R = ft(e, l + 10, 15) + 4,
                w = A + ft(e, l + 5, 31) + 1;
              l += 14;
              let C = new Qe(w),
                D = new Qe(19);
              for (var m = 0; m < R; ++m) D[db[m]] = ft(e, l + 3 * m, 7);
              l += 3 * R;
              let M = Ua(D),
                O = (1 << M) - 1,
                q = pn(D, M, 1);
              for (m = 0; m < w; ) {
                let H = q[ft(e, l, O)];
                var h;
                if (((l += 15 & H), (h = H >>> 4) < 16)) C[m++] = h;
                else {
                  var g = 0;
                  let x = 0;
                  for (
                    h === 16
                      ? ((x = 3 + ft(e, l, 3)), (l += 2), (g = C[m - 1]))
                      : h === 17
                        ? ((x = 3 + ft(e, l, 7)), (l += 3))
                        : h === 18 && ((x = 11 + ft(e, l, 127)), (l += 7));
                    x--;

                  )
                    C[m++] = g;
                }
              }
              let B = C.subarray(0, A);
              var y = C.subarray(A);
              (v = Ua(B)), (d = Ua(y)), (u = pn(B, v, 1)), (c = pn(y, d, 1));
            } else Ye(1);
            if (l > p) {
              a && Ye(0);
              break;
            }
          }
          i && s(f + 131072);
          let b = (1 << v) - 1,
            I = (1 << d) - 1,
            P = l;
          for (; ; P = l) {
            let S = (g = u[$a(e, l) & b]) >>> 4;
            if (((l += 15 & g), l > p)) {
              a && Ye(0);
              break;
            }
            if ((g || Ye(2), S < 256)) t[f++] = S;
            else {
              if (S === 256) {
                (P = l), (u = null);
                break;
              }
              {
                let A = S - 254;
                if (S > 264) {
                  var _ = xu[(m = S - 257)];
                  (A = ft(e, l, (1 << _) - 1) + Pu[m]), (l += _);
                }
                let R = c[$a(e, l) & I],
                  w = R >>> 4;
                if (
                  (R || Ye(3),
                  (l += 15 & R),
                  (y = gb[w]),
                  w > 3 &&
                    ((_ = Au[w]), (y += $a(e, l) & ((1 << _) - 1)), (l += _)),
                  l > p)
                ) {
                  a && Ye(0);
                  break;
                }
                i && s(f + 131072);
                let C = f + A;
                for (; f < C; f += 4)
                  (t[f] = t[f - y]),
                    (t[f + 1] = t[f + 1 - y]),
                    (t[f + 2] = t[f + 2 - y]),
                    (t[f + 3] = t[f + 3 - y]);
                f = C;
              }
            }
          }
          (r.l = u),
            (r.p = P),
            (r.b = f),
            (r.f = o),
            u && ((o = 1), (r.m = v), (r.d = c), (r.n = d));
        } while (!o);
        return f === t.length ? t : Ya(t, 0, f);
      },
      yW = function (e, t) {
        let r = {};
        for (var n in e) r[n] = e[n];
        for (var n in t) r[n] = t[n];
        return r;
      },
      cb = function (e, t, r) {
        let n = e(),
          i = e.toString(),
          a = i
            .slice(i.indexOf("[") + 1, i.lastIndexOf("]"))
            .replace(/\s+/g, "")
            .split(",");
        for (let s = 0; s < n.length; ++s) {
          let o = n[s],
            l = a[s];
          if (typeof o == "function") {
            t += ";" + l + "=";
            let f = o.toString();
            if (o.prototype)
              if (f.indexOf("[native code]") !== -1) {
                let u = f.indexOf(" ", 8) + 1;
                t += f.slice(u, f.indexOf("(", u));
              } else {
                t += f;
                for (let u in o.prototype)
                  t +=
                    ";" +
                    l +
                    ".prototype." +
                    u +
                    "=" +
                    o.prototype[u].toString();
              }
            else t += f;
          } else r[l] = o;
        }
        return [t, r];
      },
      Xa = [],
      EW = function (e) {
        let t = [];
        for (let r in e)
          e[r].buffer && t.push((e[r] = new e[r].constructor(e[r])).buffer);
        return t;
      },
      _W = function (e, t, r, n) {
        let i;
        if (!Xa[r]) {
          let s = "",
            o = {},
            l = e.length - 1;
          for (let f = 0; f < l; ++f)
            (i = cb(e[f], s, o)), (s = i[0]), (o = i[1]);
          Xa[r] = cb(e[l], s, o);
        }
        let a = yW({}, Xa[r][1]);
        return mW(
          Xa[r][0] +
            ";onmessage=function(e){for(var kz in e.data)self[kz]=e.data[kz];onmessage=" +
            t.toString() +
            "}",
          r,
          a,
          EW(a),
          n,
        );
      },
      bW = function () {
        return [
          Qe,
          vr,
          Tu,
          xu,
          Au,
          db,
          Pu,
          gb,
          Eb,
          _b,
          Ka,
          Sb,
          pn,
          Ua,
          ft,
          $a,
          bb,
          Ya,
          Ye,
          Ib,
          Cu,
          Tb,
          xb,
        ];
      },
      Tb = function (e) {
        return postMessage(e, [e.buffer]);
      },
      xb = function (e) {
        return e && e.size && new Qe(e.size);
      },
      SW = function (e, t, r, n, i, a) {
        var s = _W(r, n, i, function (o, l) {
          s.terminate(), a(o, l);
        });
        return (
          s.postMessage([e, t], t.consume ? [e.buffer] : []),
          function () {
            s.terminate();
          }
        );
      },
      mr = function (e, t) {
        return e[t] | (e[t + 1] << 8);
      },
      Qt = function (e, t) {
        return (
          (e[t] | (e[t + 1] << 8) | (e[t + 2] << 16) | (e[t + 3] << 24)) >>> 0
        );
      };
    function IW(e, t, r) {
      return (
        r || ((r = t), (t = {})),
        typeof r != "function" && Ye(7),
        SW(
          e,
          t,
          [bW],
          function (n) {
            return Tb(Cu(n.data[0], xb(n.data[1])));
          },
          1,
          r,
        )
      );
    }
    function Cu(e, t) {
      return Ib(e, t);
    }
    var fb = typeof TextDecoder < "u" && new TextDecoder(),
      TW = function (e) {
        for (let t = "", r = 0; ; ) {
          let n = e[r++],
            i = (n > 127) + (n > 223) + (n > 239);
          if (r + i > e.length) return [t, Ya(e, r - 1)];
          i
            ? i === 3
              ? ((n =
                  (((15 & n) << 18) |
                    ((63 & e[r++]) << 12) |
                    ((63 & e[r++]) << 6) |
                    (63 & e[r++])) -
                  65536),
                (t += String.fromCharCode(
                  55296 | (n >> 10),
                  56320 | (1023 & n),
                )))
              : (t +=
                  1 & i
                    ? String.fromCharCode(((31 & n) << 6) | (63 & e[r++]))
                    : String.fromCharCode(
                        ((15 & n) << 12) | ((63 & e[r++]) << 6) | (63 & e[r++]),
                      ))
            : (t += String.fromCharCode(n));
        }
      };
    function Ab(e, t) {
      if (t) {
        let r = "";
        for (let n = 0; n < e.length; n += 16384)
          r += String.fromCharCode.apply(null, e.subarray(n, n + 16384));
        return r;
      }
      if (fb) return fb.decode(e);
      {
        let r = TW(e),
          n = r[0];
        return r[1].length && Ye(8), n;
      }
    }
    var xW = function (e, t) {
        return t + 30 + mr(e, t + 26) + mr(e, t + 28);
      },
      AW = function (e, t, r) {
        let n = mr(e, t + 28),
          i = Ab(e.subarray(t + 46, t + 46 + n), !(2048 & mr(e, t + 8))),
          a = t + 46 + n,
          s = Qt(e, t + 20),
          o =
            r && s === 4294967295
              ? z64e(e, a)
              : [s, Qt(e, t + 24), Qt(e, t + 42)],
          l = o[0],
          f = o[1],
          u = o[2];
        return [mr(e, t + 10), l, f, i, a + mr(e, t + 30) + mr(e, t + 32), u];
      },
      pb =
        typeof queueMicrotask == "function"
          ? queueMicrotask
          : typeof setTimeout == "function"
            ? setTimeout
            : function (e) {
                e();
              };
    function PW(e, t, r) {
      r || ((r = t), (t = {})), typeof r != "function" && Ye(7);
      let n = [],
        i = function () {
          for (let f = 0; f < n.length; ++f) n[f]();
        },
        a = {},
        s = function (f, u) {
          pb(function () {
            r(f, u);
          });
        };
      pb(function () {
        s = r;
      });
      let o = e.length - 22;
      for (; Qt(e, o) !== 101010256; --o)
        if (!o || e.length - o > 65558) return s(Ye(13, 0, 1), null), i;
      let l = mr(e, o + 8);
      if (l) {
        let f = l,
          u = Qt(e, o + 16),
          c = u === 4294967295 || f === 65535;
        if (c) {
          let p = Qt(e, o - 12);
          (c = Qt(e, p) === 101075792),
            c && ((f = l = Qt(e, p + 32)), (u = Qt(e, p + 48)));
        }
        let v = t && t.filter,
          d = function () {
            let p = AW(e, u, c),
              m = p[0],
              h = p[1],
              g = p[2],
              y = p[3],
              _ = p[4],
              b = p[5],
              I = xW(e, b);
            u = _;
            let P = function (S, A) {
              S ? (i(), s(S, null)) : (A && (a[y] = A), --l || s(null, a));
            };
            if (!v || v({ name: y, size: h, originalSize: g, compression: m }))
              if (m)
                if (m === 8) {
                  let S = e.subarray(I, I + h);
                  if (h < 32e4)
                    try {
                      P(null, Cu(S, new Qe(g)));
                    } catch (A) {
                      P(A, null);
                    }
                  else n.push(IW(S, { size: g }, P));
                } else P(Ye(14, "unknown compression type " + m, 1), null);
              else P(null, Ya(e, I, I + h));
            else P(null, null);
          };
        for (let p = 0; p < f; ++p) d(p);
      } else s(null, {});
      return i;
    }
  });
  var wb = {};
  RP(wb, { fetchLottie: () => qW, unZipDotLottie: () => Cb });
  function CW(e) {
    let t = JSON.parse(e);
    if (!("animations" in t)) throw new Error("Manifest not found");
    if (t.animations.length === 0)
      throw new Error("No animations listed in the manifest");
    return t;
  }
  function wW(e) {
    let t = new Uint8Array(e, 0, 32);
    return t[0] === 80 && t[1] === 75 && t[2] === 3 && t[3] === 4;
  }
  async function MW(e) {
    return await fetch(new URL(e).href).then((t) => t.arrayBuffer());
  }
  async function OW(e) {
    return (
      await new Promise((r) => {
        let n = new FileReader();
        n.readAsDataURL(new Blob([e])), (n.onload = () => r(n.result));
      })
    ).split(",", 2)[1];
  }
  async function RW(e) {
    let t = new Uint8Array(e),
      r = await new Promise((n, i) => {
        (0, Za.unzip)(t, (a, s) => (a ? i(a) : n(s)));
      });
    return {
      read: (n) => (0, Za.strFromU8)(r[n]),
      readB64: async (n) => await OW(r[n]),
    };
  }
  async function DW(e, t) {
    if (!("assets" in e)) return e;
    async function r(i) {
      let { p: a } = i;
      if (a == null || t.read(`images/${a}`) == null) return i;
      let s = a.split(".").pop(),
        o = await t.readB64(`images/${a}`);
      if (s?.startsWith("data:")) return (i.p = s), (i.e = 1), i;
      switch (s) {
        case "svg":
        case "svg+xml":
          i.p = `data:image/svg+xml;base64,${o}`;
          break;
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "webp":
          i.p = `data:image/${s};base64,${o}`;
          break;
        default:
          i.p = `data:;base64,${o}`;
      }
      return (i.e = 1), i;
    }
    return (
      (await Promise.all(e.assets.map(r))).map((i, a) => {
        e.assets[a] = i;
      }),
      e
    );
  }
  async function Cb(e) {
    let t = await RW(e),
      r = CW(t.read("manifest.json"));
    return (
      await Promise.all(
        r.animations.map((i) => {
          let a = JSON.parse(t.read(`animations/${i.id}.json`));
          return DW(a, t);
        }),
      )
    )[0];
  }
  async function qW(e) {
    let t = await MW(e);
    return wW(t) ? await Cb(t) : JSON.parse(new TextDecoder().decode(t));
  }
  var Za,
    Mb = OP(() => {
      Za = DP(Pb());
    });
  var Fb = E((pt) => {
    "use strict";
    var Ru = st().default;
    Object.defineProperty(pt, "__esModule", { value: !0 });
    pt.ready =
      pt.init =
      pt.destroy =
      pt.createInstance =
      pt.cleanupElement =
        void 0;
    var FW = Ru(Sr()),
      Ja = Ru(oc()),
      wu = Ru(Do());
    ub();
    var LW = (Mb(), qP(wb)),
      NW = () => window.Webflow.require("lottie").lottie,
      kW = () =>
        !!(window.Webflow.env("design") || window.Webflow.env("preview")),
      yi = { Playing: "playing", Stopped: "stopped" },
      Mu = class {
        constructor() {
          (0, Ja.default)(this, "_cache", []);
        }
        set(t, r) {
          let n = (0, wu.default)(this._cache, ({ wrapper: i }) => i === t);
          n !== -1 && this._cache.splice(n, 1),
            this._cache.push({ wrapper: t, instance: r });
        }
        delete(t) {
          let r = (0, wu.default)(this._cache, ({ wrapper: n }) => n === t);
          r !== -1 && this._cache.splice(r, 1);
        }
        get(t) {
          let r = (0, wu.default)(this._cache, ({ wrapper: n }) => n === t);
          return r !== -1 ? this._cache[r].instance : null;
        }
      },
      es = new Mu(),
      Ob = {},
      Ou = class {
        constructor() {
          (0, Ja.default)(this, "config", null),
            (0, Ja.default)(this, "currentState", yi.Stopped),
            (0, Ja.default)(this, "handlers", {
              enterFrame: [],
              complete: [],
              loop: [],
              dataReady: [],
              destroy: [],
              error: [],
            });
        }
        load(t) {
          let n = (t.dataset || Ob).src || "";
          n.endsWith(".lottie")
            ? (0, LW.fetchLottie)(n).then((i) => {
                this._loadAnimation(t, i);
              })
            : this._loadAnimation(t, void 0),
            es.set(t, this),
            (this.container = t);
        }
        _loadAnimation(t, r) {
          let n = t.dataset || Ob,
            i = n.src || "",
            a = n.preserveAspectRatio || "xMidYMid meet",
            s = n.renderer || "svg",
            o = parseFloat(n.loop) === 1,
            l = parseFloat(n.direction) || 1,
            f = parseFloat(n.autoplay) === 1,
            u = parseFloat(n.duration) || 0,
            c = parseFloat(n.isIx2Target) === 1,
            v = parseFloat(n.ix2InitialState);
          isNaN(v) && (v = null);
          let d = {
            src: i,
            loop: o,
            autoplay: f,
            renderer: s,
            direction: l,
            duration: u,
            hasIx2: c,
            ix2InitialValue: v,
            preserveAspectRatio: a,
          };
          if (
            this.animationItem &&
            this.config &&
            this.config.src === i &&
            s === this.config.renderer &&
            a === this.config.preserveAspectRatio
          ) {
            if (
              (o !== this.config.loop && this.setLooping(o),
              c ||
                (l !== this.config.direction && this.setDirection(l),
                u !== this.config.duration &&
                  (u > 0 && u !== this.duration
                    ? this.setSpeed(this.duration / u)
                    : this.setSpeed(1))),
              f && this.play(),
              v && v !== this.config.ix2InitialValue)
            ) {
              let m = v / 100;
              this.goToFrame(this.frames * m);
            }
            this.config = d;
            return;
          }
          let p = {
            container: t,
            loop: o,
            autoplay: f,
            renderer: s,
            rendererSettings: {
              preserveAspectRatio: a,
              progressiveLoad: !0,
              hideOnTransparent: !0,
            },
          };
          try {
            this.animationItem && this.destroy(),
              (this.animationItem = NW().loadAnimation(
                (0, FW.default)({}, p, r ? { animationData: r } : { path: i }),
              ));
          } catch (m) {
            this.handlers.error.forEach((h) => h(m));
            return;
          }
          this.animationItem &&
            (kW() &&
              (this.animationItem.addEventListener("enterFrame", () => {
                if (!this.isPlaying) return;
                let {
                    currentFrame: m,
                    totalFrames: h,
                    playDirection: g,
                  } = this.animationItem,
                  y = (m / h) * 100,
                  _ = Math.round(g === 1 ? y : 100 - y);
                this.handlers.enterFrame.forEach((b) => b(_, m));
              }),
              this.animationItem.addEventListener("complete", () => {
                if (this.currentState !== yi.Playing) {
                  this.handlers.complete.forEach((m) => m());
                  return;
                }
                if (!this.animationItem.loop) {
                  this.handlers.complete.forEach((m) => m());
                  return;
                }
                this.currentState = yi.Stopped;
              }),
              this.animationItem.addEventListener("loopComplete", (m) => {
                this.handlers.loop.forEach((h) => h(m));
              }),
              this.animationItem.addEventListener("data_failed", (m) => {
                this.handlers.error.forEach((h) => h(m));
              }),
              this.animationItem.addEventListener("error", (m) => {
                this.handlers.error.forEach((h) => h(m));
              })),
            this.isLoaded
              ? (this.handlers.dataReady.forEach((m) => m()), f && this.play())
              : this.animationItem.addEventListener("data_ready", () => {
                  if (
                    (this.handlers.dataReady.forEach((m) => m()),
                    c ||
                      (this.setDirection(l),
                      u > 0 &&
                        u !== this.duration &&
                        this.setSpeed(this.duration / u),
                      f && this.play()),
                    v)
                  ) {
                    let m = v / 100;
                    this.goToFrame(this.frames * m);
                  }
                }),
            (this.config = d));
        }
        onFrameChange(t) {
          this.handlers.enterFrame.indexOf(t) === -1 &&
            this.handlers.enterFrame.push(t);
        }
        onPlaybackComplete(t) {
          this.handlers.complete.indexOf(t) === -1 &&
            this.handlers.complete.push(t);
        }
        onLoopComplete(t) {
          this.handlers.loop.indexOf(t) === -1 && this.handlers.loop.push(t);
        }
        onDestroy(t) {
          this.handlers.destroy.indexOf(t) === -1 &&
            this.handlers.destroy.push(t);
        }
        onDataReady(t) {
          this.handlers.dataReady.indexOf(t) === -1 &&
            this.handlers.dataReady.push(t);
        }
        onError(t) {
          this.handlers.error.indexOf(t) === -1 && this.handlers.error.push(t);
        }
        play() {
          if (!this.animationItem) return;
          let t = this.animationItem.playDirection === 1 ? 0 : this.frames;
          this.animationItem.goToAndPlay(t, !0),
            (this.currentState = yi.Playing);
        }
        stop() {
          if (this.animationItem) {
            if (this.isPlaying) {
              let { playDirection: t } = this.animationItem,
                r = t === 1 ? 0 : this.frames;
              this.animationItem.goToAndStop(r, !0);
            }
            this.currentState = yi.Stopped;
          }
        }
        destroy() {
          this.animationItem &&
            (this.isPlaying && this.stop(),
            this.handlers.destroy.forEach((t) => t()),
            this.container && es.delete(this.container),
            this.animationItem.destroy(),
            Object.keys(this.handlers).forEach(
              (t) => (this.handlers[t].length = 0),
            ),
            (this.animationItem = null),
            (this.container = null),
            (this.config = null));
        }
        get isPlaying() {
          return this.animationItem ? !this.animationItem.isPaused : !1;
        }
        get isPaused() {
          return this.animationItem ? this.animationItem.isPaused : !1;
        }
        get duration() {
          return this.animationItem ? this.animationItem.getDuration() : 0;
        }
        get frames() {
          return this.animationItem ? this.animationItem.totalFrames : 0;
        }
        get direction() {
          return this.animationItem ? this.animationItem.playDirection : 1;
        }
        get isLoaded() {
          return this.animationItem, this.animationItem.isLoaded;
        }
        get ix2InitialValue() {
          return this.config ? this.config.ix2InitialValue : null;
        }
        goToFrame(t) {
          this.animationItem && this.animationItem.setCurrentRawFrameValue(t);
        }
        setSubframe(t) {
          this.animationItem && this.animationItem.setSubframe(t);
        }
        setSpeed(t = 1) {
          this.animationItem &&
            (this.isPlaying && this.stop(), this.animationItem.setSpeed(t));
        }
        setLooping(t) {
          this.animationItem &&
            (this.isPlaying && this.stop(), (this.animationItem.loop = t));
        }
        setDirection(t) {
          this.animationItem &&
            (this.isPlaying && this.stop(),
            this.animationItem.setDirection(t),
            this.goToFrame(t === 1 ? 0 : this.frames));
        }
      },
      Rb = () =>
        Array.from(document.querySelectorAll('[data-animation-type="lottie"]')),
      Db = (e) => {
        let t = es.get(e);
        return t == null && (t = new Ou()), t.load(e), t;
      };
    pt.createInstance = Db;
    var Du = (e) => {
      let t = es.get(e);
      t && t.destroy();
    };
    pt.cleanupElement = Du;
    var qb = () => {
      Rb().forEach((e) => {
        parseFloat(e.getAttribute("data-is-ix2-target")) === 1 || Du(e), Db(e);
      });
    };
    pt.init = qb;
    var BW = () => {
      Rb().forEach(Du);
    };
    pt.destroy = BW;
    var VW = qb;
    pt.ready = VW;
  });
  var Lb = E((exports, module) => {
    typeof navigator < "u" &&
      (function (e, t) {
        typeof exports == "object" && typeof module < "u"
          ? (module.exports = t())
          : typeof define == "function" && define.amd
            ? define(t)
            : ((e = typeof globalThis < "u" ? globalThis : e || self).lottie =
                t());
      })(exports, function () {
        "use strict";
        var svgNS = "http://www.w3.org/2000/svg",
          locationHref = "",
          _useWebWorker = !1,
          initialDefaultFrame = -999999,
          setWebWorker = function (e) {
            _useWebWorker = !!e;
          },
          getWebWorker = function () {
            return _useWebWorker;
          },
          setLocationHref = function (e) {
            locationHref = e;
          },
          getLocationHref = function () {
            return locationHref;
          };
        function createTag(e) {
          return document.createElement(e);
        }
        function extendPrototype(e, t) {
          var r,
            n,
            i = e.length;
          for (r = 0; r < i; r += 1)
            for (var a in (n = e[r].prototype))
              Object.prototype.hasOwnProperty.call(n, a) &&
                (t.prototype[a] = n[a]);
        }
        function getDescriptor(e, t) {
          return Object.getOwnPropertyDescriptor(e, t);
        }
        function createProxyFunction(e) {
          function t() {}
          return (t.prototype = e), t;
        }
        var audioControllerFactory = (function () {
            function e(t) {
              (this.audios = []),
                (this.audioFactory = t),
                (this._volume = 1),
                (this._isMuted = !1);
            }
            return (
              (e.prototype = {
                addAudio: function (t) {
                  this.audios.push(t);
                },
                pause: function () {
                  var t,
                    r = this.audios.length;
                  for (t = 0; t < r; t += 1) this.audios[t].pause();
                },
                resume: function () {
                  var t,
                    r = this.audios.length;
                  for (t = 0; t < r; t += 1) this.audios[t].resume();
                },
                setRate: function (t) {
                  var r,
                    n = this.audios.length;
                  for (r = 0; r < n; r += 1) this.audios[r].setRate(t);
                },
                createAudio: function (t) {
                  return this.audioFactory
                    ? this.audioFactory(t)
                    : window.Howl
                      ? new window.Howl({ src: [t] })
                      : {
                          isPlaying: !1,
                          play: function () {
                            this.isPlaying = !0;
                          },
                          seek: function () {
                            this.isPlaying = !1;
                          },
                          playing: function () {},
                          rate: function () {},
                          setVolume: function () {},
                        };
                },
                setAudioFactory: function (t) {
                  this.audioFactory = t;
                },
                setVolume: function (t) {
                  (this._volume = t), this._updateVolume();
                },
                mute: function () {
                  (this._isMuted = !0), this._updateVolume();
                },
                unmute: function () {
                  (this._isMuted = !1), this._updateVolume();
                },
                getVolume: function () {
                  return this._volume;
                },
                _updateVolume: function () {
                  var t,
                    r = this.audios.length;
                  for (t = 0; t < r; t += 1)
                    this.audios[t].volume(
                      this._volume * (this._isMuted ? 0 : 1),
                    );
                },
              }),
              function () {
                return new e();
              }
            );
          })(),
          createTypedArray = (function () {
            function e(t, r) {
              var n,
                i = 0,
                a = [];
              switch (t) {
                case "int16":
                case "uint8c":
                  n = 1;
                  break;
                default:
                  n = 1.1;
              }
              for (i = 0; i < r; i += 1) a.push(n);
              return a;
            }
            return typeof Uint8ClampedArray == "function" &&
              typeof Float32Array == "function"
              ? function (t, r) {
                  return t === "float32"
                    ? new Float32Array(r)
                    : t === "int16"
                      ? new Int16Array(r)
                      : t === "uint8c"
                        ? new Uint8ClampedArray(r)
                        : e(t, r);
                }
              : e;
          })();
        function createSizedArray(e) {
          return Array.apply(null, { length: e });
        }
        function _typeof$6(e) {
          return (
            (_typeof$6 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$6(e)
          );
        }
        var subframeEnabled = !0,
          expressionsPlugin = null,
          expressionsInterfaces = null,
          idPrefix$1 = "",
          isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
          _shouldRoundValues = !1,
          bmPow = Math.pow,
          bmSqrt = Math.sqrt,
          bmFloor = Math.floor,
          bmMax = Math.max,
          bmMin = Math.min,
          BMMath = {};
        function ProjectInterface$1() {
          return {};
        }
        (function () {
          var e,
            t = [
              "abs",
              "acos",
              "acosh",
              "asin",
              "asinh",
              "atan",
              "atanh",
              "atan2",
              "ceil",
              "cbrt",
              "expm1",
              "clz32",
              "cos",
              "cosh",
              "exp",
              "floor",
              "fround",
              "hypot",
              "imul",
              "log",
              "log1p",
              "log2",
              "log10",
              "max",
              "min",
              "pow",
              "random",
              "round",
              "sign",
              "sin",
              "sinh",
              "sqrt",
              "tan",
              "tanh",
              "trunc",
              "E",
              "LN10",
              "LN2",
              "LOG10E",
              "LOG2E",
              "PI",
              "SQRT1_2",
              "SQRT2",
            ],
            r = t.length;
          for (e = 0; e < r; e += 1) BMMath[t[e]] = Math[t[e]];
        })(),
          (BMMath.random = Math.random),
          (BMMath.abs = function (e) {
            if (_typeof$6(e) === "object" && e.length) {
              var t,
                r = createSizedArray(e.length),
                n = e.length;
              for (t = 0; t < n; t += 1) r[t] = Math.abs(e[t]);
              return r;
            }
            return Math.abs(e);
          });
        var defaultCurveSegments = 150,
          degToRads = Math.PI / 180,
          roundCorner = 0.5519;
        function roundValues(e) {
          _shouldRoundValues = !!e;
        }
        function bmRnd(e) {
          return _shouldRoundValues ? Math.round(e) : e;
        }
        function styleDiv(e) {
          (e.style.position = "absolute"),
            (e.style.top = 0),
            (e.style.left = 0),
            (e.style.display = "block"),
            (e.style.transformOrigin = "0 0"),
            (e.style.webkitTransformOrigin = "0 0"),
            (e.style.backfaceVisibility = "visible"),
            (e.style.webkitBackfaceVisibility = "visible"),
            (e.style.transformStyle = "preserve-3d"),
            (e.style.webkitTransformStyle = "preserve-3d"),
            (e.style.mozTransformStyle = "preserve-3d");
        }
        function BMEnterFrameEvent(e, t, r, n) {
          (this.type = e),
            (this.currentTime = t),
            (this.totalTime = r),
            (this.direction = n < 0 ? -1 : 1);
        }
        function BMCompleteEvent(e, t) {
          (this.type = e), (this.direction = t < 0 ? -1 : 1);
        }
        function BMCompleteLoopEvent(e, t, r, n) {
          (this.type = e),
            (this.currentLoop = r),
            (this.totalLoops = t),
            (this.direction = n < 0 ? -1 : 1);
        }
        function BMSegmentStartEvent(e, t, r) {
          (this.type = e), (this.firstFrame = t), (this.totalFrames = r);
        }
        function BMDestroyEvent(e, t) {
          (this.type = e), (this.target = t);
        }
        function BMRenderFrameErrorEvent(e, t) {
          (this.type = "renderFrameError"),
            (this.nativeError = e),
            (this.currentTime = t);
        }
        function BMConfigErrorEvent(e) {
          (this.type = "configError"), (this.nativeError = e);
        }
        function BMAnimationConfigErrorEvent(e, t) {
          (this.type = e), (this.nativeError = t);
        }
        var createElementID =
            ((_count = 0),
            function () {
              return idPrefix$1 + "__lottie_element_" + (_count += 1);
            }),
          _count;
        function HSVtoRGB(e, t, r) {
          var n, i, a, s, o, l, f, u;
          switch (
            ((l = r * (1 - t)),
            (f = r * (1 - (o = 6 * e - (s = Math.floor(6 * e))) * t)),
            (u = r * (1 - (1 - o) * t)),
            s % 6)
          ) {
            case 0:
              (n = r), (i = u), (a = l);
              break;
            case 1:
              (n = f), (i = r), (a = l);
              break;
            case 2:
              (n = l), (i = r), (a = u);
              break;
            case 3:
              (n = l), (i = f), (a = r);
              break;
            case 4:
              (n = u), (i = l), (a = r);
              break;
            case 5:
              (n = r), (i = l), (a = f);
          }
          return [n, i, a];
        }
        function RGBtoHSV(e, t, r) {
          var n,
            i = Math.max(e, t, r),
            a = Math.min(e, t, r),
            s = i - a,
            o = i === 0 ? 0 : s / i,
            l = i / 255;
          switch (i) {
            case a:
              n = 0;
              break;
            case e:
              (n = t - r + s * (t < r ? 6 : 0)), (n /= 6 * s);
              break;
            case t:
              (n = r - e + 2 * s), (n /= 6 * s);
              break;
            case r:
              (n = e - t + 4 * s), (n /= 6 * s);
          }
          return [n, o, l];
        }
        function addSaturationToRGB(e, t) {
          var r = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
          return (
            (r[1] += t),
            r[1] > 1 ? (r[1] = 1) : r[1] <= 0 && (r[1] = 0),
            HSVtoRGB(r[0], r[1], r[2])
          );
        }
        function addBrightnessToRGB(e, t) {
          var r = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
          return (
            (r[2] += t),
            r[2] > 1 ? (r[2] = 1) : r[2] < 0 && (r[2] = 0),
            HSVtoRGB(r[0], r[1], r[2])
          );
        }
        function addHueToRGB(e, t) {
          var r = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
          return (
            (r[0] += t / 360),
            r[0] > 1 ? (r[0] -= 1) : r[0] < 0 && (r[0] += 1),
            HSVtoRGB(r[0], r[1], r[2])
          );
        }
        var rgbToHex = (function () {
            var e,
              t,
              r = [];
            for (e = 0; e < 256; e += 1)
              (t = e.toString(16)), (r[e] = t.length === 1 ? "0" + t : t);
            return function (n, i, a) {
              return (
                n < 0 && (n = 0),
                i < 0 && (i = 0),
                a < 0 && (a = 0),
                "#" + r[n] + r[i] + r[a]
              );
            };
          })(),
          setSubframeEnabled = function (e) {
            subframeEnabled = !!e;
          },
          getSubframeEnabled = function () {
            return subframeEnabled;
          },
          setExpressionsPlugin = function (e) {
            expressionsPlugin = e;
          },
          getExpressionsPlugin = function () {
            return expressionsPlugin;
          },
          setExpressionInterfaces = function (e) {
            expressionsInterfaces = e;
          },
          getExpressionInterfaces = function () {
            return expressionsInterfaces;
          },
          setDefaultCurveSegments = function (e) {
            defaultCurveSegments = e;
          },
          getDefaultCurveSegments = function () {
            return defaultCurveSegments;
          },
          setIdPrefix = function (e) {
            idPrefix$1 = e;
          },
          getIdPrefix = function () {
            return idPrefix$1;
          };
        function createNS(e) {
          return document.createElementNS(svgNS, e);
        }
        function _typeof$5(e) {
          return (
            (_typeof$5 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$5(e)
          );
        }
        var dataManager = (function () {
            var e,
              t,
              r = 1,
              n = [],
              i = {
                onmessage: function () {},
                postMessage: function (l) {
                  e({ data: l });
                },
              },
              a = {
                postMessage: function (l) {
                  i.onmessage({ data: l });
                },
              };
            function s() {
              t ||
                ((t = (function (l) {
                  if (window.Worker && window.Blob && getWebWorker()) {
                    var f = new Blob(
                        [
                          "var _workerSelf = self; self.onmessage = ",
                          l.toString(),
                        ],
                        { type: "text/javascript" },
                      ),
                      u = URL.createObjectURL(f);
                    return new Worker(u);
                  }
                  return (e = l), i;
                })(function (l) {
                  if (
                    (a.dataManager ||
                      (a.dataManager = (function () {
                        function u(S, A) {
                          var R,
                            w,
                            C,
                            D,
                            M,
                            O,
                            q = S.length;
                          for (w = 0; w < q; w += 1)
                            if ("ks" in (R = S[w]) && !R.completed) {
                              if (((R.completed = !0), R.hasMask)) {
                                var B = R.masksProperties;
                                for (D = B.length, C = 0; C < D; C += 1)
                                  if (B[C].pt.k.i) d(B[C].pt.k);
                                  else
                                    for (
                                      O = B[C].pt.k.length, M = 0;
                                      M < O;
                                      M += 1
                                    )
                                      B[C].pt.k[M].s && d(B[C].pt.k[M].s[0]),
                                        B[C].pt.k[M].e && d(B[C].pt.k[M].e[0]);
                              }
                              R.ty === 0
                                ? ((R.layers = c(R.refId, A)), u(R.layers, A))
                                : R.ty === 4
                                  ? v(R.shapes)
                                  : R.ty === 5 && I(R);
                            }
                        }
                        function c(S, A) {
                          var R = (function (w, C) {
                            for (var D = 0, M = C.length; D < M; ) {
                              if (C[D].id === w) return C[D];
                              D += 1;
                            }
                            return null;
                          })(S, A);
                          return R
                            ? R.layers.__used
                              ? JSON.parse(JSON.stringify(R.layers))
                              : ((R.layers.__used = !0), R.layers)
                            : null;
                        }
                        function v(S) {
                          var A, R, w;
                          for (A = S.length - 1; A >= 0; A -= 1)
                            if (S[A].ty === "sh")
                              if (S[A].ks.k.i) d(S[A].ks.k);
                              else
                                for (w = S[A].ks.k.length, R = 0; R < w; R += 1)
                                  S[A].ks.k[R].s && d(S[A].ks.k[R].s[0]),
                                    S[A].ks.k[R].e && d(S[A].ks.k[R].e[0]);
                            else S[A].ty === "gr" && v(S[A].it);
                        }
                        function d(S) {
                          var A,
                            R = S.i.length;
                          for (A = 0; A < R; A += 1)
                            (S.i[A][0] += S.v[A][0]),
                              (S.i[A][1] += S.v[A][1]),
                              (S.o[A][0] += S.v[A][0]),
                              (S.o[A][1] += S.v[A][1]);
                        }
                        function p(S, A) {
                          var R = A ? A.split(".") : [100, 100, 100];
                          return (
                            S[0] > R[0] ||
                            (!(R[0] > S[0]) &&
                              (S[1] > R[1] ||
                                (!(R[1] > S[1]) &&
                                  (S[2] > R[2] || (!(R[2] > S[2]) && null)))))
                          );
                        }
                        var m,
                          h = (function () {
                            var S = [4, 4, 14];
                            function A(R) {
                              var w,
                                C,
                                D,
                                M = R.length;
                              for (w = 0; w < M; w += 1)
                                R[w].ty === 5 &&
                                  ((D = void 0),
                                  (D = (C = R[w]).t.d),
                                  (C.t.d = { k: [{ s: D, t: 0 }] }));
                            }
                            return function (R) {
                              if (p(S, R.v) && (A(R.layers), R.assets)) {
                                var w,
                                  C = R.assets.length;
                                for (w = 0; w < C; w += 1)
                                  R.assets[w].layers && A(R.assets[w].layers);
                              }
                            };
                          })(),
                          g =
                            ((m = [4, 7, 99]),
                            function (S) {
                              if (S.chars && !p(m, S.v)) {
                                var A,
                                  R = S.chars.length;
                                for (A = 0; A < R; A += 1) {
                                  var w = S.chars[A];
                                  w.data &&
                                    w.data.shapes &&
                                    (v(w.data.shapes),
                                    (w.data.ip = 0),
                                    (w.data.op = 99999),
                                    (w.data.st = 0),
                                    (w.data.sr = 1),
                                    (w.data.ks = {
                                      p: { k: [0, 0], a: 0 },
                                      s: { k: [100, 100], a: 0 },
                                      a: { k: [0, 0], a: 0 },
                                      r: { k: 0, a: 0 },
                                      o: { k: 100, a: 0 },
                                    }),
                                    S.chars[A].t ||
                                      (w.data.shapes.push({ ty: "no" }),
                                      w.data.shapes[0].it.push({
                                        p: { k: [0, 0], a: 0 },
                                        s: { k: [100, 100], a: 0 },
                                        a: { k: [0, 0], a: 0 },
                                        r: { k: 0, a: 0 },
                                        o: { k: 100, a: 0 },
                                        sk: { k: 0, a: 0 },
                                        sa: { k: 0, a: 0 },
                                        ty: "tr",
                                      })));
                                }
                              }
                            }),
                          y = (function () {
                            var S = [5, 7, 15];
                            function A(R) {
                              var w,
                                C,
                                D = R.length;
                              for (w = 0; w < D; w += 1)
                                R[w].ty === 5 &&
                                  ((C = void 0),
                                  typeof (C = R[w].t.p).a == "number" &&
                                    (C.a = { a: 0, k: C.a }),
                                  typeof C.p == "number" &&
                                    (C.p = { a: 0, k: C.p }),
                                  typeof C.r == "number" &&
                                    (C.r = { a: 0, k: C.r }));
                            }
                            return function (R) {
                              if (p(S, R.v) && (A(R.layers), R.assets)) {
                                var w,
                                  C = R.assets.length;
                                for (w = 0; w < C; w += 1)
                                  R.assets[w].layers && A(R.assets[w].layers);
                              }
                            };
                          })(),
                          _ = (function () {
                            var S = [4, 1, 9];
                            function A(w) {
                              var C,
                                D,
                                M,
                                O = w.length;
                              for (C = 0; C < O; C += 1)
                                if (w[C].ty === "gr") A(w[C].it);
                                else if (w[C].ty === "fl" || w[C].ty === "st")
                                  if (w[C].c.k && w[C].c.k[0].i)
                                    for (
                                      M = w[C].c.k.length, D = 0;
                                      D < M;
                                      D += 1
                                    )
                                      w[C].c.k[D].s &&
                                        ((w[C].c.k[D].s[0] /= 255),
                                        (w[C].c.k[D].s[1] /= 255),
                                        (w[C].c.k[D].s[2] /= 255),
                                        (w[C].c.k[D].s[3] /= 255)),
                                        w[C].c.k[D].e &&
                                          ((w[C].c.k[D].e[0] /= 255),
                                          (w[C].c.k[D].e[1] /= 255),
                                          (w[C].c.k[D].e[2] /= 255),
                                          (w[C].c.k[D].e[3] /= 255));
                                  else
                                    (w[C].c.k[0] /= 255),
                                      (w[C].c.k[1] /= 255),
                                      (w[C].c.k[2] /= 255),
                                      (w[C].c.k[3] /= 255);
                            }
                            function R(w) {
                              var C,
                                D = w.length;
                              for (C = 0; C < D; C += 1)
                                w[C].ty === 4 && A(w[C].shapes);
                            }
                            return function (w) {
                              if (p(S, w.v) && (R(w.layers), w.assets)) {
                                var C,
                                  D = w.assets.length;
                                for (C = 0; C < D; C += 1)
                                  w.assets[C].layers && R(w.assets[C].layers);
                              }
                            };
                          })(),
                          b = (function () {
                            var S = [4, 4, 18];
                            function A(w) {
                              var C, D, M;
                              for (C = w.length - 1; C >= 0; C -= 1)
                                if (w[C].ty === "sh")
                                  if (w[C].ks.k.i) w[C].ks.k.c = w[C].closed;
                                  else
                                    for (
                                      M = w[C].ks.k.length, D = 0;
                                      D < M;
                                      D += 1
                                    )
                                      w[C].ks.k[D].s &&
                                        (w[C].ks.k[D].s[0].c = w[C].closed),
                                        w[C].ks.k[D].e &&
                                          (w[C].ks.k[D].e[0].c = w[C].closed);
                                else w[C].ty === "gr" && A(w[C].it);
                            }
                            function R(w) {
                              var C,
                                D,
                                M,
                                O,
                                q,
                                B,
                                H = w.length;
                              for (D = 0; D < H; D += 1) {
                                if ((C = w[D]).hasMask) {
                                  var x = C.masksProperties;
                                  for (O = x.length, M = 0; M < O; M += 1)
                                    if (x[M].pt.k.i) x[M].pt.k.c = x[M].cl;
                                    else
                                      for (
                                        B = x[M].pt.k.length, q = 0;
                                        q < B;
                                        q += 1
                                      )
                                        x[M].pt.k[q].s &&
                                          (x[M].pt.k[q].s[0].c = x[M].cl),
                                          x[M].pt.k[q].e &&
                                            (x[M].pt.k[q].e[0].c = x[M].cl);
                                }
                                C.ty === 4 && A(C.shapes);
                              }
                            }
                            return function (w) {
                              if (p(S, w.v) && (R(w.layers), w.assets)) {
                                var C,
                                  D = w.assets.length;
                                for (C = 0; C < D; C += 1)
                                  w.assets[C].layers && R(w.assets[C].layers);
                              }
                            };
                          })();
                        function I(S) {
                          S.t.a.length === 0 && S.t.p;
                        }
                        var P = {
                          completeData: function (S) {
                            S.__complete ||
                              (_(S),
                              h(S),
                              g(S),
                              y(S),
                              b(S),
                              u(S.layers, S.assets),
                              (function (A, R) {
                                if (A) {
                                  var w = 0,
                                    C = A.length;
                                  for (w = 0; w < C; w += 1)
                                    A[w].t === 1 &&
                                      ((A[w].data.layers = c(
                                        A[w].data.refId,
                                        R,
                                      )),
                                      u(A[w].data.layers, R));
                                }
                              })(S.chars, S.assets),
                              (S.__complete = !0));
                          },
                        };
                        return (
                          (P.checkColors = _),
                          (P.checkChars = g),
                          (P.checkPathProperties = y),
                          (P.checkShapes = b),
                          (P.completeLayers = u),
                          P
                        );
                      })()),
                    a.assetLoader ||
                      (a.assetLoader = (function () {
                        function u(c) {
                          var v = c.getResponseHeader("content-type");
                          return (v &&
                            c.responseType === "json" &&
                            v.indexOf("json") !== -1) ||
                            (c.response && _typeof$5(c.response) === "object")
                            ? c.response
                            : c.response && typeof c.response == "string"
                              ? JSON.parse(c.response)
                              : c.responseText
                                ? JSON.parse(c.responseText)
                                : null;
                        }
                        return {
                          load: function (c, v, d, p) {
                            var m,
                              h = new XMLHttpRequest();
                            try {
                              h.responseType = "json";
                            } catch {}
                            h.onreadystatechange = function () {
                              if (h.readyState === 4)
                                if (h.status === 200) (m = u(h)), d(m);
                                else
                                  try {
                                    (m = u(h)), d(m);
                                  } catch (g) {
                                    p && p(g);
                                  }
                            };
                            try {
                              h.open(["G", "E", "T"].join(""), c, !0);
                            } catch {
                              h.open(["G", "E", "T"].join(""), v + "/" + c, !0);
                            }
                            h.send();
                          },
                        };
                      })()),
                    l.data.type === "loadAnimation")
                  )
                    a.assetLoader.load(
                      l.data.path,
                      l.data.fullPath,
                      function (u) {
                        a.dataManager.completeData(u),
                          a.postMessage({
                            id: l.data.id,
                            payload: u,
                            status: "success",
                          });
                      },
                      function () {
                        a.postMessage({ id: l.data.id, status: "error" });
                      },
                    );
                  else if (l.data.type === "complete") {
                    var f = l.data.animation;
                    a.dataManager.completeData(f),
                      a.postMessage({
                        id: l.data.id,
                        payload: f,
                        status: "success",
                      });
                  } else
                    l.data.type === "loadData" &&
                      a.assetLoader.load(
                        l.data.path,
                        l.data.fullPath,
                        function (u) {
                          a.postMessage({
                            id: l.data.id,
                            payload: u,
                            status: "success",
                          });
                        },
                        function () {
                          a.postMessage({ id: l.data.id, status: "error" });
                        },
                      );
                })),
                (t.onmessage = function (l) {
                  var f = l.data,
                    u = f.id,
                    c = n[u];
                  (n[u] = null),
                    f.status === "success"
                      ? c.onComplete(f.payload)
                      : c.onError && c.onError();
                }));
            }
            function o(l, f) {
              var u = "processId_" + (r += 1);
              return (n[u] = { onComplete: l, onError: f }), u;
            }
            return {
              loadAnimation: function (l, f, u) {
                s();
                var c = o(f, u);
                t.postMessage({
                  type: "loadAnimation",
                  path: l,
                  fullPath: window.location.origin + window.location.pathname,
                  id: c,
                });
              },
              loadData: function (l, f, u) {
                s();
                var c = o(f, u);
                t.postMessage({
                  type: "loadData",
                  path: l,
                  fullPath: window.location.origin + window.location.pathname,
                  id: c,
                });
              },
              completeAnimation: function (l, f, u) {
                s();
                var c = o(f, u);
                t.postMessage({ type: "complete", animation: l, id: c });
              },
            };
          })(),
          ImagePreloader = (function () {
            var e = (function () {
              var o = createTag("canvas");
              (o.width = 1), (o.height = 1);
              var l = o.getContext("2d");
              return (l.fillStyle = "rgba(0,0,0,0)"), l.fillRect(0, 0, 1, 1), o;
            })();
            function t() {
              (this.loadedAssets += 1),
                this.loadedAssets === this.totalImages &&
                  this.loadedFootagesCount === this.totalFootages &&
                  this.imagesLoadedCb &&
                  this.imagesLoadedCb(null);
            }
            function r() {
              (this.loadedFootagesCount += 1),
                this.loadedAssets === this.totalImages &&
                  this.loadedFootagesCount === this.totalFootages &&
                  this.imagesLoadedCb &&
                  this.imagesLoadedCb(null);
            }
            function n(o, l, f) {
              var u = "";
              if (o.e) u = o.p;
              else if (l) {
                var c = o.p;
                c.indexOf("images/") !== -1 && (c = c.split("/")[1]),
                  (u = l + c);
              } else (u = f), (u += o.u ? o.u : ""), (u += o.p);
              return u;
            }
            function i(o) {
              var l = 0,
                f = setInterval(
                  function () {
                    (o.getBBox().width || l > 500) &&
                      (this._imageLoaded(), clearInterval(f)),
                      (l += 1);
                  }.bind(this),
                  50,
                );
            }
            function a(o) {
              var l = { assetData: o },
                f = n(o, this.assetsPath, this.path);
              return (
                dataManager.loadData(
                  f,
                  function (u) {
                    (l.img = u), this._footageLoaded();
                  }.bind(this),
                  function () {
                    (l.img = {}), this._footageLoaded();
                  }.bind(this),
                ),
                l
              );
            }
            function s() {
              (this._imageLoaded = t.bind(this)),
                (this._footageLoaded = r.bind(this)),
                (this.testImageLoaded = i.bind(this)),
                (this.createFootageData = a.bind(this)),
                (this.assetsPath = ""),
                (this.path = ""),
                (this.totalImages = 0),
                (this.totalFootages = 0),
                (this.loadedAssets = 0),
                (this.loadedFootagesCount = 0),
                (this.imagesLoadedCb = null),
                (this.images = []);
            }
            return (
              (s.prototype = {
                loadAssets: function (o, l) {
                  var f;
                  this.imagesLoadedCb = l;
                  var u = o.length;
                  for (f = 0; f < u; f += 1)
                    o[f].layers ||
                      (o[f].t && o[f].t !== "seq"
                        ? o[f].t === 3 &&
                          ((this.totalFootages += 1),
                          this.images.push(this.createFootageData(o[f])))
                        : ((this.totalImages += 1),
                          this.images.push(this._createImageData(o[f]))));
                },
                setAssetsPath: function (o) {
                  this.assetsPath = o || "";
                },
                setPath: function (o) {
                  this.path = o || "";
                },
                loadedImages: function () {
                  return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function () {
                  return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function () {
                  (this.imagesLoadedCb = null), (this.images.length = 0);
                },
                getAsset: function (o) {
                  for (var l = 0, f = this.images.length; l < f; ) {
                    if (this.images[l].assetData === o)
                      return this.images[l].img;
                    l += 1;
                  }
                  return null;
                },
                createImgData: function (o) {
                  var l = n(o, this.assetsPath, this.path),
                    f = createTag("img");
                  (f.crossOrigin = "anonymous"),
                    f.addEventListener("load", this._imageLoaded, !1),
                    f.addEventListener(
                      "error",
                      function () {
                        (u.img = e), this._imageLoaded();
                      }.bind(this),
                      !1,
                    ),
                    (f.src = l);
                  var u = { img: f, assetData: o };
                  return u;
                },
                createImageData: function (o) {
                  var l = n(o, this.assetsPath, this.path),
                    f = createNS("image");
                  isSafari
                    ? this.testImageLoaded(f)
                    : f.addEventListener("load", this._imageLoaded, !1),
                    f.addEventListener(
                      "error",
                      function () {
                        (u.img = e), this._imageLoaded();
                      }.bind(this),
                      !1,
                    ),
                    f.setAttributeNS("http://www.w3.org/1999/xlink", "href", l),
                    this._elementHelper.append
                      ? this._elementHelper.append(f)
                      : this._elementHelper.appendChild(f);
                  var u = { img: f, assetData: o };
                  return u;
                },
                imageLoaded: t,
                footageLoaded: r,
                setCacheType: function (o, l) {
                  o === "svg"
                    ? ((this._elementHelper = l),
                      (this._createImageData = this.createImageData.bind(this)))
                    : (this._createImageData = this.createImgData.bind(this));
                },
              }),
              s
            );
          })();
        function BaseEvent() {}
        BaseEvent.prototype = {
          triggerEvent: function (e, t) {
            if (this._cbs[e])
              for (var r = this._cbs[e], n = 0; n < r.length; n += 1) r[n](t);
          },
          addEventListener: function (e, t) {
            return (
              this._cbs[e] || (this._cbs[e] = []),
              this._cbs[e].push(t),
              function () {
                this.removeEventListener(e, t);
              }.bind(this)
            );
          },
          removeEventListener: function (e, t) {
            if (t) {
              if (this._cbs[e]) {
                for (var r = 0, n = this._cbs[e].length; r < n; )
                  this._cbs[e][r] === t &&
                    (this._cbs[e].splice(r, 1), (r -= 1), (n -= 1)),
                    (r += 1);
                this._cbs[e].length || (this._cbs[e] = null);
              }
            } else this._cbs[e] = null;
          },
        };
        var markerParser = (function () {
            function e(t) {
              for (
                var r,
                  n = t.split(`\r
`),
                  i = {},
                  a = 0,
                  s = 0;
                s < n.length;
                s += 1
              )
                (r = n[s].split(":")).length === 2 &&
                  ((i[r[0]] = r[1].trim()), (a += 1));
              if (a === 0) throw new Error();
              return i;
            }
            return function (t) {
              for (var r = [], n = 0; n < t.length; n += 1) {
                var i = t[n],
                  a = { time: i.tm, duration: i.dr };
                try {
                  a.payload = JSON.parse(t[n].cm);
                } catch {
                  try {
                    a.payload = e(t[n].cm);
                  } catch {
                    a.payload = { name: t[n].cm };
                  }
                }
                r.push(a);
              }
              return r;
            };
          })(),
          ProjectInterface = (function () {
            function e(t) {
              this.compositions.push(t);
            }
            return function () {
              function t(r) {
                for (var n = 0, i = this.compositions.length; n < i; ) {
                  if (
                    this.compositions[n].data &&
                    this.compositions[n].data.nm === r
                  )
                    return (
                      this.compositions[n].prepareFrame &&
                        this.compositions[n].data.xt &&
                        this.compositions[n].prepareFrame(this.currentFrame),
                      this.compositions[n].compInterface
                    );
                  n += 1;
                }
                return null;
              }
              return (
                (t.compositions = []),
                (t.currentFrame = 0),
                (t.registerComposition = e),
                t
              );
            };
          })(),
          renderers = {},
          registerRenderer = function (e, t) {
            renderers[e] = t;
          };
        function getRenderer(e) {
          return renderers[e];
        }
        function getRegisteredRenderer() {
          if (renderers.canvas) return "canvas";
          for (var e in renderers) if (renderers[e]) return e;
          return "";
        }
        function _typeof$4(e) {
          return (
            (_typeof$4 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$4(e)
          );
        }
        var AnimationItem = function () {
          (this._cbs = []),
            (this.name = ""),
            (this.path = ""),
            (this.isLoaded = !1),
            (this.currentFrame = 0),
            (this.currentRawFrame = 0),
            (this.firstFrame = 0),
            (this.totalFrames = 0),
            (this.frameRate = 0),
            (this.frameMult = 0),
            (this.playSpeed = 1),
            (this.playDirection = 1),
            (this.playCount = 0),
            (this.animationData = {}),
            (this.assets = []),
            (this.isPaused = !0),
            (this.autoplay = !1),
            (this.loop = !0),
            (this.renderer = null),
            (this.animationID = createElementID()),
            (this.assetsPath = ""),
            (this.timeCompleted = 0),
            (this.segmentPos = 0),
            (this.isSubframeEnabled = getSubframeEnabled()),
            (this.segments = []),
            (this._idle = !0),
            (this._completedLoop = !1),
            (this.projectInterface = ProjectInterface()),
            (this.imagePreloader = new ImagePreloader()),
            (this.audioController = audioControllerFactory()),
            (this.markers = []),
            (this.configAnimation = this.configAnimation.bind(this)),
            (this.onSetupError = this.onSetupError.bind(this)),
            (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
            (this.drawnFrameEvent = new BMEnterFrameEvent(
              "drawnFrame",
              0,
              0,
              0,
            )),
            (this.expressionsPlugin = getExpressionsPlugin());
        };
        extendPrototype([BaseEvent], AnimationItem),
          (AnimationItem.prototype.setParams = function (e) {
            (e.wrapper || e.container) &&
              (this.wrapper = e.wrapper || e.container);
            var t = "svg";
            e.animType ? (t = e.animType) : e.renderer && (t = e.renderer);
            var r = getRenderer(t);
            (this.renderer = new r(this, e.rendererSettings)),
              this.imagePreloader.setCacheType(
                t,
                this.renderer.globalData.defs,
              ),
              this.renderer.setProjectInterface(this.projectInterface),
              (this.animType = t),
              e.loop === "" ||
              e.loop === null ||
              e.loop === void 0 ||
              e.loop === !0
                ? (this.loop = !0)
                : e.loop === !1
                  ? (this.loop = !1)
                  : (this.loop = parseInt(e.loop, 10)),
              (this.autoplay = !("autoplay" in e) || e.autoplay),
              (this.name = e.name ? e.name : ""),
              (this.autoloadSegments =
                !Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ||
                e.autoloadSegments),
              (this.assetsPath = e.assetsPath),
              (this.initialSegment = e.initialSegment),
              e.audioFactory &&
                this.audioController.setAudioFactory(e.audioFactory),
              e.animationData
                ? this.setupAnimation(e.animationData)
                : e.path &&
                  (e.path.lastIndexOf("\\") !== -1
                    ? (this.path = e.path.substr(
                        0,
                        e.path.lastIndexOf("\\") + 1,
                      ))
                    : (this.path = e.path.substr(
                        0,
                        e.path.lastIndexOf("/") + 1,
                      )),
                  (this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1)),
                  (this.fileName = this.fileName.substr(
                    0,
                    this.fileName.lastIndexOf(".json"),
                  )),
                  dataManager.loadAnimation(
                    e.path,
                    this.configAnimation,
                    this.onSetupError,
                  ));
          }),
          (AnimationItem.prototype.onSetupError = function () {
            this.trigger("data_failed");
          }),
          (AnimationItem.prototype.setupAnimation = function (e) {
            dataManager.completeAnimation(e, this.configAnimation);
          }),
          (AnimationItem.prototype.setData = function (e, t) {
            t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
            var r = { wrapper: e, animationData: t },
              n = e.attributes;
            (r.path = n.getNamedItem("data-animation-path")
              ? n.getNamedItem("data-animation-path").value
              : n.getNamedItem("data-bm-path")
                ? n.getNamedItem("data-bm-path").value
                : n.getNamedItem("bm-path")
                  ? n.getNamedItem("bm-path").value
                  : ""),
              (r.animType = n.getNamedItem("data-anim-type")
                ? n.getNamedItem("data-anim-type").value
                : n.getNamedItem("data-bm-type")
                  ? n.getNamedItem("data-bm-type").value
                  : n.getNamedItem("bm-type")
                    ? n.getNamedItem("bm-type").value
                    : n.getNamedItem("data-bm-renderer")
                      ? n.getNamedItem("data-bm-renderer").value
                      : n.getNamedItem("bm-renderer")
                        ? n.getNamedItem("bm-renderer").value
                        : getRegisteredRenderer() || "canvas");
            var i = n.getNamedItem("data-anim-loop")
              ? n.getNamedItem("data-anim-loop").value
              : n.getNamedItem("data-bm-loop")
                ? n.getNamedItem("data-bm-loop").value
                : n.getNamedItem("bm-loop")
                  ? n.getNamedItem("bm-loop").value
                  : "";
            i === "false"
              ? (r.loop = !1)
              : i === "true"
                ? (r.loop = !0)
                : i !== "" && (r.loop = parseInt(i, 10));
            var a = n.getNamedItem("data-anim-autoplay")
              ? n.getNamedItem("data-anim-autoplay").value
              : n.getNamedItem("data-bm-autoplay")
                ? n.getNamedItem("data-bm-autoplay").value
                : !n.getNamedItem("bm-autoplay") ||
                  n.getNamedItem("bm-autoplay").value;
            (r.autoplay = a !== "false"),
              (r.name = n.getNamedItem("data-name")
                ? n.getNamedItem("data-name").value
                : n.getNamedItem("data-bm-name")
                  ? n.getNamedItem("data-bm-name").value
                  : n.getNamedItem("bm-name")
                    ? n.getNamedItem("bm-name").value
                    : ""),
              (n.getNamedItem("data-anim-prerender")
                ? n.getNamedItem("data-anim-prerender").value
                : n.getNamedItem("data-bm-prerender")
                  ? n.getNamedItem("data-bm-prerender").value
                  : n.getNamedItem("bm-prerender")
                    ? n.getNamedItem("bm-prerender").value
                    : "") === "false" && (r.prerender = !1),
              r.path ? this.setParams(r) : this.trigger("destroy");
          }),
          (AnimationItem.prototype.includeLayers = function (e) {
            e.op > this.animationData.op &&
              ((this.animationData.op = e.op),
              (this.totalFrames = Math.floor(e.op - this.animationData.ip)));
            var t,
              r,
              n = this.animationData.layers,
              i = n.length,
              a = e.layers,
              s = a.length;
            for (r = 0; r < s; r += 1)
              for (t = 0; t < i; ) {
                if (n[t].id === a[r].id) {
                  n[t] = a[r];
                  break;
                }
                t += 1;
              }
            if (
              ((e.chars || e.fonts) &&
                (this.renderer.globalData.fontManager.addChars(e.chars),
                this.renderer.globalData.fontManager.addFonts(
                  e.fonts,
                  this.renderer.globalData.defs,
                )),
              e.assets)
            )
              for (i = e.assets.length, t = 0; t < i; t += 1)
                this.animationData.assets.push(e.assets[t]);
            (this.animationData.__complete = !1),
              dataManager.completeAnimation(
                this.animationData,
                this.onSegmentComplete,
              );
          }),
          (AnimationItem.prototype.onSegmentComplete = function (e) {
            this.animationData = e;
            var t = getExpressionsPlugin();
            t && t.initExpressions(this), this.loadNextSegment();
          }),
          (AnimationItem.prototype.loadNextSegment = function () {
            var e = this.animationData.segments;
            if (!e || e.length === 0 || !this.autoloadSegments)
              return (
                this.trigger("data_ready"),
                void (this.timeCompleted = this.totalFrames)
              );
            var t = e.shift();
            this.timeCompleted = t.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            (this.segmentPos += 1),
              dataManager.loadData(
                r,
                this.includeLayers.bind(this),
                function () {
                  this.trigger("data_failed");
                }.bind(this),
              );
          }),
          (AnimationItem.prototype.loadSegments = function () {
            this.animationData.segments ||
              (this.timeCompleted = this.totalFrames),
              this.loadNextSegment();
          }),
          (AnimationItem.prototype.imagesLoaded = function () {
            this.trigger("loaded_images"), this.checkLoaded();
          }),
          (AnimationItem.prototype.preloadImages = function () {
            this.imagePreloader.setAssetsPath(this.assetsPath),
              this.imagePreloader.setPath(this.path),
              this.imagePreloader.loadAssets(
                this.animationData.assets,
                this.imagesLoaded.bind(this),
              );
          }),
          (AnimationItem.prototype.configAnimation = function (e) {
            if (this.renderer)
              try {
                (this.animationData = e),
                  this.initialSegment
                    ? ((this.totalFrames = Math.floor(
                        this.initialSegment[1] - this.initialSegment[0],
                      )),
                      (this.firstFrame = Math.round(this.initialSegment[0])))
                    : ((this.totalFrames = Math.floor(
                        this.animationData.op - this.animationData.ip,
                      )),
                      (this.firstFrame = Math.round(this.animationData.ip))),
                  this.renderer.configAnimation(e),
                  e.assets || (e.assets = []),
                  (this.assets = this.animationData.assets),
                  (this.frameRate = this.animationData.fr),
                  (this.frameMult = this.animationData.fr / 1e3),
                  this.renderer.searchExtraCompositions(e.assets),
                  (this.markers = markerParser(e.markers || [])),
                  this.trigger("config_ready"),
                  this.preloadImages(),
                  this.loadSegments(),
                  this.updaFrameModifier(),
                  this.waitForFontsLoaded(),
                  this.isPaused && this.audioController.pause();
              } catch (t) {
                this.triggerConfigError(t);
              }
          }),
          (AnimationItem.prototype.waitForFontsLoaded = function () {
            this.renderer &&
              (this.renderer.globalData.fontManager.isLoaded
                ? this.checkLoaded()
                : setTimeout(this.waitForFontsLoaded.bind(this), 20));
          }),
          (AnimationItem.prototype.checkLoaded = function () {
            if (
              !this.isLoaded &&
              this.renderer.globalData.fontManager.isLoaded &&
              (this.imagePreloader.loadedImages() ||
                this.renderer.rendererType !== "canvas") &&
              this.imagePreloader.loadedFootages()
            ) {
              this.isLoaded = !0;
              var e = getExpressionsPlugin();
              e && e.initExpressions(this),
                this.renderer.initItems(),
                setTimeout(
                  function () {
                    this.trigger("DOMLoaded");
                  }.bind(this),
                  0,
                ),
                this.gotoFrame(),
                this.autoplay && this.play();
            }
          }),
          (AnimationItem.prototype.resize = function (e, t) {
            var r = typeof e == "number" ? e : void 0,
              n = typeof t == "number" ? t : void 0;
            this.renderer.updateContainerSize(r, n);
          }),
          (AnimationItem.prototype.setSubframe = function (e) {
            this.isSubframeEnabled = !!e;
          }),
          (AnimationItem.prototype.gotoFrame = function () {
            (this.currentFrame = this.isSubframeEnabled
              ? this.currentRawFrame
              : ~~this.currentRawFrame),
              this.timeCompleted !== this.totalFrames &&
                this.currentFrame > this.timeCompleted &&
                (this.currentFrame = this.timeCompleted),
              this.trigger("enterFrame"),
              this.renderFrame(),
              this.trigger("drawnFrame");
          }),
          (AnimationItem.prototype.renderFrame = function () {
            if (this.isLoaded !== !1 && this.renderer)
              try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(),
                  this.renderer.renderFrame(
                    this.currentFrame + this.firstFrame,
                  );
              } catch (e) {
                this.triggerRenderFrameError(e);
              }
          }),
          (AnimationItem.prototype.play = function (e) {
            (e && this.name !== e) ||
              (this.isPaused === !0 &&
                ((this.isPaused = !1),
                this.trigger("_play"),
                this.audioController.resume(),
                this._idle && ((this._idle = !1), this.trigger("_active"))));
          }),
          (AnimationItem.prototype.pause = function (e) {
            (e && this.name !== e) ||
              (this.isPaused === !1 &&
                ((this.isPaused = !0),
                this.trigger("_pause"),
                (this._idle = !0),
                this.trigger("_idle"),
                this.audioController.pause()));
          }),
          (AnimationItem.prototype.togglePause = function (e) {
            (e && this.name !== e) ||
              (this.isPaused === !0 ? this.play() : this.pause());
          }),
          (AnimationItem.prototype.stop = function (e) {
            (e && this.name !== e) ||
              (this.pause(),
              (this.playCount = 0),
              (this._completedLoop = !1),
              this.setCurrentRawFrameValue(0));
          }),
          (AnimationItem.prototype.getMarkerData = function (e) {
            for (var t, r = 0; r < this.markers.length; r += 1)
              if ((t = this.markers[r]).payload && t.payload.name === e)
                return t;
            return null;
          }),
          (AnimationItem.prototype.goToAndStop = function (e, t, r) {
            if (!r || this.name === r) {
              var n = Number(e);
              if (isNaN(n)) {
                var i = this.getMarkerData(e);
                i && this.goToAndStop(i.time, !0);
              } else
                t
                  ? this.setCurrentRawFrameValue(e)
                  : this.setCurrentRawFrameValue(e * this.frameModifier);
              this.pause();
            }
          }),
          (AnimationItem.prototype.goToAndPlay = function (e, t, r) {
            if (!r || this.name === r) {
              var n = Number(e);
              if (isNaN(n)) {
                var i = this.getMarkerData(e);
                i &&
                  (i.duration
                    ? this.playSegments([i.time, i.time + i.duration], !0)
                    : this.goToAndStop(i.time, !0));
              } else this.goToAndStop(n, t, r);
              this.play();
            }
          }),
          (AnimationItem.prototype.advanceTime = function (e) {
            if (this.isPaused !== !0 && this.isLoaded !== !1) {
              var t = this.currentRawFrame + e * this.frameModifier,
                r = !1;
              t >= this.totalFrames - 1 && this.frameModifier > 0
                ? this.loop && this.playCount !== this.loop
                  ? t >= this.totalFrames
                    ? ((this.playCount += 1),
                      this.checkSegments(t % this.totalFrames) ||
                        (this.setCurrentRawFrameValue(t % this.totalFrames),
                        (this._completedLoop = !0),
                        this.trigger("loopComplete")))
                    : this.setCurrentRawFrameValue(t)
                  : this.checkSegments(
                      t > this.totalFrames ? t % this.totalFrames : 0,
                    ) || ((r = !0), (t = this.totalFrames - 1))
                : t < 0
                  ? this.checkSegments(t % this.totalFrames) ||
                    (!this.loop || (this.playCount-- <= 0 && this.loop !== !0)
                      ? ((r = !0), (t = 0))
                      : (this.setCurrentRawFrameValue(
                          this.totalFrames + (t % this.totalFrames),
                        ),
                        this._completedLoop
                          ? this.trigger("loopComplete")
                          : (this._completedLoop = !0)))
                  : this.setCurrentRawFrameValue(t),
                r &&
                  (this.setCurrentRawFrameValue(t),
                  this.pause(),
                  this.trigger("complete"));
            }
          }),
          (AnimationItem.prototype.adjustSegment = function (e, t) {
            (this.playCount = 0),
              e[1] < e[0]
                ? (this.frameModifier > 0 &&
                    (this.playSpeed < 0
                      ? this.setSpeed(-this.playSpeed)
                      : this.setDirection(-1)),
                  (this.totalFrames = e[0] - e[1]),
                  (this.timeCompleted = this.totalFrames),
                  (this.firstFrame = e[1]),
                  this.setCurrentRawFrameValue(this.totalFrames - 0.001 - t))
                : e[1] > e[0] &&
                  (this.frameModifier < 0 &&
                    (this.playSpeed < 0
                      ? this.setSpeed(-this.playSpeed)
                      : this.setDirection(1)),
                  (this.totalFrames = e[1] - e[0]),
                  (this.timeCompleted = this.totalFrames),
                  (this.firstFrame = e[0]),
                  this.setCurrentRawFrameValue(0.001 + t)),
              this.trigger("segmentStart");
          }),
          (AnimationItem.prototype.setSegment = function (e, t) {
            var r = -1;
            this.isPaused &&
              (this.currentRawFrame + this.firstFrame < e
                ? (r = e)
                : this.currentRawFrame + this.firstFrame > t && (r = t - e)),
              (this.firstFrame = e),
              (this.totalFrames = t - e),
              (this.timeCompleted = this.totalFrames),
              r !== -1 && this.goToAndStop(r, !0);
          }),
          (AnimationItem.prototype.playSegments = function (e, t) {
            if (
              (t && (this.segments.length = 0), _typeof$4(e[0]) === "object")
            ) {
              var r,
                n = e.length;
              for (r = 0; r < n; r += 1) this.segments.push(e[r]);
            } else this.segments.push(e);
            this.segments.length &&
              t &&
              this.adjustSegment(this.segments.shift(), 0),
              this.isPaused && this.play();
          }),
          (AnimationItem.prototype.resetSegments = function (e) {
            (this.segments.length = 0),
              this.segments.push([
                this.animationData.ip,
                this.animationData.op,
              ]),
              e && this.checkSegments(0);
          }),
          (AnimationItem.prototype.checkSegments = function (e) {
            return (
              !!this.segments.length &&
              (this.adjustSegment(this.segments.shift(), e), !0)
            );
          }),
          (AnimationItem.prototype.destroy = function (e) {
            (e && this.name !== e) ||
              !this.renderer ||
              (this.renderer.destroy(),
              this.imagePreloader.destroy(),
              this.trigger("destroy"),
              (this._cbs = null),
              (this.onEnterFrame = null),
              (this.onLoopComplete = null),
              (this.onComplete = null),
              (this.onSegmentStart = null),
              (this.onDestroy = null),
              (this.renderer = null),
              (this.expressionsPlugin = null),
              (this.imagePreloader = null),
              (this.projectInterface = null));
          }),
          (AnimationItem.prototype.setCurrentRawFrameValue = function (e) {
            (this.currentRawFrame = e), this.gotoFrame();
          }),
          (AnimationItem.prototype.setSpeed = function (e) {
            (this.playSpeed = e), this.updaFrameModifier();
          }),
          (AnimationItem.prototype.setDirection = function (e) {
            (this.playDirection = e < 0 ? -1 : 1), this.updaFrameModifier();
          }),
          (AnimationItem.prototype.setLoop = function (e) {
            this.loop = e;
          }),
          (AnimationItem.prototype.setVolume = function (e, t) {
            (t && this.name !== t) || this.audioController.setVolume(e);
          }),
          (AnimationItem.prototype.getVolume = function () {
            return this.audioController.getVolume();
          }),
          (AnimationItem.prototype.mute = function (e) {
            (e && this.name !== e) || this.audioController.mute();
          }),
          (AnimationItem.prototype.unmute = function (e) {
            (e && this.name !== e) || this.audioController.unmute();
          }),
          (AnimationItem.prototype.updaFrameModifier = function () {
            (this.frameModifier =
              this.frameMult * this.playSpeed * this.playDirection),
              this.audioController.setRate(this.playSpeed * this.playDirection);
          }),
          (AnimationItem.prototype.getPath = function () {
            return this.path;
          }),
          (AnimationItem.prototype.getAssetsPath = function (e) {
            var t = "";
            if (e.e) t = e.p;
            else if (this.assetsPath) {
              var r = e.p;
              r.indexOf("images/") !== -1 && (r = r.split("/")[1]),
                (t = this.assetsPath + r);
            } else (t = this.path), (t += e.u ? e.u : ""), (t += e.p);
            return t;
          }),
          (AnimationItem.prototype.getAssetData = function (e) {
            for (var t = 0, r = this.assets.length; t < r; ) {
              if (e === this.assets[t].id) return this.assets[t];
              t += 1;
            }
            return null;
          }),
          (AnimationItem.prototype.hide = function () {
            this.renderer.hide();
          }),
          (AnimationItem.prototype.show = function () {
            this.renderer.show();
          }),
          (AnimationItem.prototype.getDuration = function (e) {
            return e ? this.totalFrames : this.totalFrames / this.frameRate;
          }),
          (AnimationItem.prototype.updateDocumentData = function (e, t, r) {
            try {
              this.renderer.getElementByPath(e).updateDocumentData(t, r);
            } catch {}
          }),
          (AnimationItem.prototype.trigger = function (e) {
            if (this._cbs && this._cbs[e])
              switch (e) {
                case "enterFrame":
                  this.triggerEvent(
                    e,
                    new BMEnterFrameEvent(
                      e,
                      this.currentFrame,
                      this.totalFrames,
                      this.frameModifier,
                    ),
                  );
                  break;
                case "drawnFrame":
                  (this.drawnFrameEvent.currentTime = this.currentFrame),
                    (this.drawnFrameEvent.totalTime = this.totalFrames),
                    (this.drawnFrameEvent.direction = this.frameModifier),
                    this.triggerEvent(e, this.drawnFrameEvent);
                  break;
                case "loopComplete":
                  this.triggerEvent(
                    e,
                    new BMCompleteLoopEvent(
                      e,
                      this.loop,
                      this.playCount,
                      this.frameMult,
                    ),
                  );
                  break;
                case "complete":
                  this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
                  break;
                case "segmentStart":
                  this.triggerEvent(
                    e,
                    new BMSegmentStartEvent(
                      e,
                      this.firstFrame,
                      this.totalFrames,
                    ),
                  );
                  break;
                case "destroy":
                  this.triggerEvent(e, new BMDestroyEvent(e, this));
                  break;
                default:
                  this.triggerEvent(e);
              }
            e === "enterFrame" &&
              this.onEnterFrame &&
              this.onEnterFrame.call(
                this,
                new BMEnterFrameEvent(
                  e,
                  this.currentFrame,
                  this.totalFrames,
                  this.frameMult,
                ),
              ),
              e === "loopComplete" &&
                this.onLoopComplete &&
                this.onLoopComplete.call(
                  this,
                  new BMCompleteLoopEvent(
                    e,
                    this.loop,
                    this.playCount,
                    this.frameMult,
                  ),
                ),
              e === "complete" &&
                this.onComplete &&
                this.onComplete.call(
                  this,
                  new BMCompleteEvent(e, this.frameMult),
                ),
              e === "segmentStart" &&
                this.onSegmentStart &&
                this.onSegmentStart.call(
                  this,
                  new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames),
                ),
              e === "destroy" &&
                this.onDestroy &&
                this.onDestroy.call(this, new BMDestroyEvent(e, this));
          }),
          (AnimationItem.prototype.triggerRenderFrameError = function (e) {
            var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
            this.triggerEvent("error", t),
              this.onError && this.onError.call(this, t);
          }),
          (AnimationItem.prototype.triggerConfigError = function (e) {
            var t = new BMConfigErrorEvent(e, this.currentFrame);
            this.triggerEvent("error", t),
              this.onError && this.onError.call(this, t);
          });
        var animationManager = (function () {
            var e = {},
              t = [],
              r = 0,
              n = 0,
              i = 0,
              a = !0,
              s = !1;
            function o(m) {
              for (var h = 0, g = m.target; h < n; )
                t[h].animation === g &&
                  (t.splice(h, 1), (h -= 1), (n -= 1), g.isPaused || u()),
                  (h += 1);
            }
            function l(m, h) {
              if (!m) return null;
              for (var g = 0; g < n; ) {
                if (t[g].elem === m && t[g].elem !== null)
                  return t[g].animation;
                g += 1;
              }
              var y = new AnimationItem();
              return c(y, m), y.setData(m, h), y;
            }
            function f() {
              (i += 1), p();
            }
            function u() {
              i -= 1;
            }
            function c(m, h) {
              m.addEventListener("destroy", o),
                m.addEventListener("_active", f),
                m.addEventListener("_idle", u),
                t.push({ elem: h, animation: m }),
                (n += 1);
            }
            function v(m) {
              var h,
                g = m - r;
              for (h = 0; h < n; h += 1) t[h].animation.advanceTime(g);
              (r = m), i && !s ? window.requestAnimationFrame(v) : (a = !0);
            }
            function d(m) {
              (r = m), window.requestAnimationFrame(v);
            }
            function p() {
              !s && i && a && (window.requestAnimationFrame(d), (a = !1));
            }
            return (
              (e.registerAnimation = l),
              (e.loadAnimation = function (m) {
                var h = new AnimationItem();
                return c(h, null), h.setParams(m), h;
              }),
              (e.setSpeed = function (m, h) {
                var g;
                for (g = 0; g < n; g += 1) t[g].animation.setSpeed(m, h);
              }),
              (e.setDirection = function (m, h) {
                var g;
                for (g = 0; g < n; g += 1) t[g].animation.setDirection(m, h);
              }),
              (e.play = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.play(m);
              }),
              (e.pause = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.pause(m);
              }),
              (e.stop = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.stop(m);
              }),
              (e.togglePause = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.togglePause(m);
              }),
              (e.searchAnimations = function (m, h, g) {
                var y,
                  _ = [].concat(
                    [].slice.call(document.getElementsByClassName("lottie")),
                    [].slice.call(document.getElementsByClassName("bodymovin")),
                  ),
                  b = _.length;
                for (y = 0; y < b; y += 1)
                  g && _[y].setAttribute("data-bm-type", g), l(_[y], m);
                if (h && b === 0) {
                  g || (g = "svg");
                  var I = document.getElementsByTagName("body")[0];
                  I.innerText = "";
                  var P = createTag("div");
                  (P.style.width = "100%"),
                    (P.style.height = "100%"),
                    P.setAttribute("data-bm-type", g),
                    I.appendChild(P),
                    l(P, m);
                }
              }),
              (e.resize = function () {
                var m;
                for (m = 0; m < n; m += 1) t[m].animation.resize();
              }),
              (e.goToAndStop = function (m, h, g) {
                var y;
                for (y = 0; y < n; y += 1) t[y].animation.goToAndStop(m, h, g);
              }),
              (e.destroy = function (m) {
                var h;
                for (h = n - 1; h >= 0; h -= 1) t[h].animation.destroy(m);
              }),
              (e.freeze = function () {
                s = !0;
              }),
              (e.unfreeze = function () {
                (s = !1), p();
              }),
              (e.setVolume = function (m, h) {
                var g;
                for (g = 0; g < n; g += 1) t[g].animation.setVolume(m, h);
              }),
              (e.mute = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.mute(m);
              }),
              (e.unmute = function (m) {
                var h;
                for (h = 0; h < n; h += 1) t[h].animation.unmute(m);
              }),
              (e.getRegisteredAnimations = function () {
                var m,
                  h = t.length,
                  g = [];
                for (m = 0; m < h; m += 1) g.push(t[m].animation);
                return g;
              }),
              e
            );
          })(),
          BezierFactory = (function () {
            var e = {
                getBezierEasing: function (u, c, v, d, p) {
                  var m =
                    p ||
                    ("bez_" + u + "_" + c + "_" + v + "_" + d).replace(
                      /\./g,
                      "p",
                    );
                  if (t[m]) return t[m];
                  var h = new f([u, c, v, d]);
                  return (t[m] = h), h;
                },
              },
              t = {},
              r = 0.1,
              n = typeof Float32Array == "function";
            function i(u, c) {
              return 1 - 3 * c + 3 * u;
            }
            function a(u, c) {
              return 3 * c - 6 * u;
            }
            function s(u) {
              return 3 * u;
            }
            function o(u, c, v) {
              return ((i(c, v) * u + a(c, v)) * u + s(c)) * u;
            }
            function l(u, c, v) {
              return 3 * i(c, v) * u * u + 2 * a(c, v) * u + s(c);
            }
            function f(u) {
              (this._p = u),
                (this._mSampleValues = n
                  ? new Float32Array(11)
                  : new Array(11)),
                (this._precomputed = !1),
                (this.get = this.get.bind(this));
            }
            return (
              (f.prototype = {
                get: function (u) {
                  var c = this._p[0],
                    v = this._p[1],
                    d = this._p[2],
                    p = this._p[3];
                  return (
                    this._precomputed || this._precompute(),
                    c === v && d === p
                      ? u
                      : u === 0
                        ? 0
                        : u === 1
                          ? 1
                          : o(this._getTForX(u), v, p)
                  );
                },
                _precompute: function () {
                  var u = this._p[0],
                    c = this._p[1],
                    v = this._p[2],
                    d = this._p[3];
                  (this._precomputed = !0),
                    (u === c && v === d) || this._calcSampleValues();
                },
                _calcSampleValues: function () {
                  for (var u = this._p[0], c = this._p[2], v = 0; v < 11; ++v)
                    this._mSampleValues[v] = o(v * r, u, c);
                },
                _getTForX: function (u) {
                  for (
                    var c = this._p[0],
                      v = this._p[2],
                      d = this._mSampleValues,
                      p = 0,
                      m = 1;
                    m !== 10 && d[m] <= u;
                    ++m
                  )
                    p += r;
                  var h = p + ((u - d[--m]) / (d[m + 1] - d[m])) * r,
                    g = l(h, c, v);
                  return g >= 0.001
                    ? (function (y, _, b, I) {
                        for (var P = 0; P < 4; ++P) {
                          var S = l(_, b, I);
                          if (S === 0) return _;
                          _ -= (o(_, b, I) - y) / S;
                        }
                        return _;
                      })(u, h, c, v)
                    : g === 0
                      ? h
                      : (function (y, _, b, I, P) {
                          var S,
                            A,
                            R = 0;
                          do
                            (S = o((A = _ + (b - _) / 2), I, P) - y) > 0
                              ? (b = A)
                              : (_ = A);
                          while (Math.abs(S) > 1e-7 && ++R < 10);
                          return A;
                        })(u, p, p + r, c, v);
                },
              }),
              e
            );
          })(),
          pooling = {
            double: function (e) {
              return e.concat(createSizedArray(e.length));
            },
          },
          poolFactory = function (e, t, r) {
            var n = 0,
              i = e,
              a = createSizedArray(i);
            return {
              newElement: function () {
                return n ? a[(n -= 1)] : t();
              },
              release: function (s) {
                n === i && ((a = pooling.double(a)), (i *= 2)),
                  r && r(s),
                  (a[n] = s),
                  (n += 1);
              },
            };
          },
          bezierLengthPool = poolFactory(8, function () {
            return {
              addedLength: 0,
              percents: createTypedArray("float32", getDefaultCurveSegments()),
              lengths: createTypedArray("float32", getDefaultCurveSegments()),
            };
          }),
          segmentsLengthPool = poolFactory(
            8,
            function () {
              return { lengths: [], totalLength: 0 };
            },
            function (e) {
              var t,
                r = e.lengths.length;
              for (t = 0; t < r; t += 1) bezierLengthPool.release(e.lengths[t]);
              e.lengths.length = 0;
            },
          );
        function bezFunction() {
          var e = Math;
          function t(f, u, c, v, d, p) {
            var m = f * v + u * d + c * p - d * v - p * f - c * u;
            return m > -0.001 && m < 0.001;
          }
          var r = function (f, u, c, v) {
            var d,
              p,
              m,
              h,
              g,
              y,
              _ = getDefaultCurveSegments(),
              b = 0,
              I = [],
              P = [],
              S = bezierLengthPool.newElement();
            for (m = c.length, d = 0; d < _; d += 1) {
              for (g = d / (_ - 1), y = 0, p = 0; p < m; p += 1)
                (h =
                  bmPow(1 - g, 3) * f[p] +
                  3 * bmPow(1 - g, 2) * g * c[p] +
                  3 * (1 - g) * bmPow(g, 2) * v[p] +
                  bmPow(g, 3) * u[p]),
                  (I[p] = h),
                  P[p] !== null && (y += bmPow(I[p] - P[p], 2)),
                  (P[p] = I[p]);
              y && (b += y = bmSqrt(y)),
                (S.percents[d] = g),
                (S.lengths[d] = b);
            }
            return (S.addedLength = b), S;
          };
          function n(f) {
            (this.segmentLength = 0), (this.points = new Array(f));
          }
          function i(f, u) {
            (this.partialLength = f), (this.point = u);
          }
          var a,
            s =
              ((a = {}),
              function (f, u, c, v) {
                var d = (
                  f[0] +
                  "_" +
                  f[1] +
                  "_" +
                  u[0] +
                  "_" +
                  u[1] +
                  "_" +
                  c[0] +
                  "_" +
                  c[1] +
                  "_" +
                  v[0] +
                  "_" +
                  v[1]
                ).replace(/\./g, "p");
                if (!a[d]) {
                  var p,
                    m,
                    h,
                    g,
                    y,
                    _,
                    b,
                    I = getDefaultCurveSegments(),
                    P = 0,
                    S = null;
                  f.length === 2 &&
                    (f[0] !== u[0] || f[1] !== u[1]) &&
                    t(f[0], f[1], u[0], u[1], f[0] + c[0], f[1] + c[1]) &&
                    t(f[0], f[1], u[0], u[1], u[0] + v[0], u[1] + v[1]) &&
                    (I = 2);
                  var A = new n(I);
                  for (h = c.length, p = 0; p < I; p += 1) {
                    for (
                      b = createSizedArray(h), y = p / (I - 1), _ = 0, m = 0;
                      m < h;
                      m += 1
                    )
                      (g =
                        bmPow(1 - y, 3) * f[m] +
                        3 * bmPow(1 - y, 2) * y * (f[m] + c[m]) +
                        3 * (1 - y) * bmPow(y, 2) * (u[m] + v[m]) +
                        bmPow(y, 3) * u[m]),
                        (b[m] = g),
                        S !== null && (_ += bmPow(b[m] - S[m], 2));
                    (P += _ = bmSqrt(_)), (A.points[p] = new i(_, b)), (S = b);
                  }
                  (A.segmentLength = P), (a[d] = A);
                }
                return a[d];
              });
          function o(f, u) {
            var c = u.percents,
              v = u.lengths,
              d = c.length,
              p = bmFloor((d - 1) * f),
              m = f * u.addedLength,
              h = 0;
            if (p === d - 1 || p === 0 || m === v[p]) return c[p];
            for (var g = v[p] > m ? -1 : 1, y = !0; y; )
              if (
                (v[p] <= m && v[p + 1] > m
                  ? ((h = (m - v[p]) / (v[p + 1] - v[p])), (y = !1))
                  : (p += g),
                p < 0 || p >= d - 1)
              ) {
                if (p === d - 1) return c[p];
                y = !1;
              }
            return c[p] + (c[p + 1] - c[p]) * h;
          }
          var l = createTypedArray("float32", 8);
          return {
            getSegmentsLength: function (f) {
              var u,
                c = segmentsLengthPool.newElement(),
                v = f.c,
                d = f.v,
                p = f.o,
                m = f.i,
                h = f._length,
                g = c.lengths,
                y = 0;
              for (u = 0; u < h - 1; u += 1)
                (g[u] = r(d[u], d[u + 1], p[u], m[u + 1])),
                  (y += g[u].addedLength);
              return (
                v &&
                  h &&
                  ((g[u] = r(d[u], d[0], p[u], m[0])), (y += g[u].addedLength)),
                (c.totalLength = y),
                c
              );
            },
            getNewSegment: function (f, u, c, v, d, p, m) {
              d < 0 ? (d = 0) : d > 1 && (d = 1);
              var h,
                g = o(d, m),
                y = o((p = p > 1 ? 1 : p), m),
                _ = f.length,
                b = 1 - g,
                I = 1 - y,
                P = b * b * b,
                S = g * b * b * 3,
                A = g * g * b * 3,
                R = g * g * g,
                w = b * b * I,
                C = g * b * I + b * g * I + b * b * y,
                D = g * g * I + b * g * y + g * b * y,
                M = g * g * y,
                O = b * I * I,
                q = g * I * I + b * y * I + b * I * y,
                B = g * y * I + b * y * y + g * I * y,
                H = g * y * y,
                x = I * I * I,
                L = y * I * I + I * y * I + I * I * y,
                j = y * y * I + I * y * y + y * I * y,
                Y = y * y * y;
              for (h = 0; h < _; h += 1)
                (l[4 * h] =
                  e.round(1e3 * (P * f[h] + S * c[h] + A * v[h] + R * u[h])) /
                  1e3),
                  (l[4 * h + 1] =
                    e.round(1e3 * (w * f[h] + C * c[h] + D * v[h] + M * u[h])) /
                    1e3),
                  (l[4 * h + 2] =
                    e.round(1e3 * (O * f[h] + q * c[h] + B * v[h] + H * u[h])) /
                    1e3),
                  (l[4 * h + 3] =
                    e.round(1e3 * (x * f[h] + L * c[h] + j * v[h] + Y * u[h])) /
                    1e3);
              return l;
            },
            getPointInSegment: function (f, u, c, v, d, p) {
              var m = o(d, p),
                h = 1 - m;
              return [
                e.round(
                  1e3 *
                    (h * h * h * f[0] +
                      (m * h * h + h * m * h + h * h * m) * c[0] +
                      (m * m * h + h * m * m + m * h * m) * v[0] +
                      m * m * m * u[0]),
                ) / 1e3,
                e.round(
                  1e3 *
                    (h * h * h * f[1] +
                      (m * h * h + h * m * h + h * h * m) * c[1] +
                      (m * m * h + h * m * m + m * h * m) * v[1] +
                      m * m * m * u[1]),
                ) / 1e3,
              ];
            },
            buildBezierData: s,
            pointOnLine2D: t,
            pointOnLine3D: function (f, u, c, v, d, p, m, h, g) {
              if (c === 0 && p === 0 && g === 0) return t(f, u, v, d, m, h);
              var y,
                _ = e.sqrt(e.pow(v - f, 2) + e.pow(d - u, 2) + e.pow(p - c, 2)),
                b = e.sqrt(e.pow(m - f, 2) + e.pow(h - u, 2) + e.pow(g - c, 2)),
                I = e.sqrt(e.pow(m - v, 2) + e.pow(h - d, 2) + e.pow(g - p, 2));
              return (
                (y =
                  _ > b
                    ? _ > I
                      ? _ - b - I
                      : I - b - _
                    : I > b
                      ? I - b - _
                      : b - _ - I) > -1e-4 && y < 1e-4
              );
            },
          };
        }
        var bez = bezFunction(),
          initFrame = initialDefaultFrame,
          mathAbs = Math.abs;
        function interpolateValue(e, t) {
          var r,
            n = this.offsetTime;
          this.propType === "multidimensional" &&
            (r = createTypedArray("float32", this.pv.length));
          for (
            var i,
              a,
              s,
              o,
              l,
              f,
              u,
              c,
              v,
              d = t.lastIndex,
              p = d,
              m = this.keyframes.length - 1,
              h = !0;
            h;

          ) {
            if (
              ((i = this.keyframes[p]),
              (a = this.keyframes[p + 1]),
              p === m - 1 && e >= a.t - n)
            ) {
              i.h && (i = a), (d = 0);
              break;
            }
            if (a.t - n > e) {
              d = p;
              break;
            }
            p < m - 1 ? (p += 1) : ((d = 0), (h = !1));
          }
          s = this.keyframesMetadata[p] || {};
          var g,
            y = a.t - n,
            _ = i.t - n;
          if (i.to) {
            s.bezierData ||
              (s.bezierData = bez.buildBezierData(i.s, a.s || i.e, i.to, i.ti));
            var b = s.bezierData;
            if (e >= y || e < _) {
              var I = e >= y ? b.points.length - 1 : 0;
              for (l = b.points[I].point.length, o = 0; o < l; o += 1)
                r[o] = b.points[I].point[o];
            } else {
              s.__fnct
                ? (v = s.__fnct)
                : ((v = BezierFactory.getBezierEasing(
                    i.o.x,
                    i.o.y,
                    i.i.x,
                    i.i.y,
                    i.n,
                  ).get),
                  (s.__fnct = v)),
                (f = v((e - _) / (y - _)));
              var P,
                S = b.segmentLength * f,
                A =
                  t.lastFrame < e && t._lastKeyframeIndex === p
                    ? t._lastAddedLength
                    : 0;
              for (
                c =
                  t.lastFrame < e && t._lastKeyframeIndex === p
                    ? t._lastPoint
                    : 0,
                  h = !0,
                  u = b.points.length;
                h;

              ) {
                if (
                  ((A += b.points[c].partialLength),
                  S === 0 || f === 0 || c === b.points.length - 1)
                ) {
                  for (l = b.points[c].point.length, o = 0; o < l; o += 1)
                    r[o] = b.points[c].point[o];
                  break;
                }
                if (S >= A && S < A + b.points[c + 1].partialLength) {
                  for (
                    P = (S - A) / b.points[c + 1].partialLength,
                      l = b.points[c].point.length,
                      o = 0;
                    o < l;
                    o += 1
                  )
                    r[o] =
                      b.points[c].point[o] +
                      (b.points[c + 1].point[o] - b.points[c].point[o]) * P;
                  break;
                }
                c < u - 1 ? (c += 1) : (h = !1);
              }
              (t._lastPoint = c),
                (t._lastAddedLength = A - b.points[c].partialLength),
                (t._lastKeyframeIndex = p);
            }
          } else {
            var R, w, C, D, M;
            if (((m = i.s.length), (g = a.s || i.e), this.sh && i.h !== 1))
              e >= y
                ? ((r[0] = g[0]), (r[1] = g[1]), (r[2] = g[2]))
                : e <= _
                  ? ((r[0] = i.s[0]), (r[1] = i.s[1]), (r[2] = i.s[2]))
                  : quaternionToEuler(
                      r,
                      slerp(
                        createQuaternion(i.s),
                        createQuaternion(g),
                        (e - _) / (y - _),
                      ),
                    );
            else
              for (p = 0; p < m; p += 1)
                i.h !== 1 &&
                  (e >= y
                    ? (f = 1)
                    : e < _
                      ? (f = 0)
                      : (i.o.x.constructor === Array
                          ? (s.__fnct || (s.__fnct = []),
                            s.__fnct[p]
                              ? (v = s.__fnct[p])
                              : ((R =
                                  i.o.x[p] === void 0 ? i.o.x[0] : i.o.x[p]),
                                (w = i.o.y[p] === void 0 ? i.o.y[0] : i.o.y[p]),
                                (C = i.i.x[p] === void 0 ? i.i.x[0] : i.i.x[p]),
                                (D = i.i.y[p] === void 0 ? i.i.y[0] : i.i.y[p]),
                                (v = BezierFactory.getBezierEasing(
                                  R,
                                  w,
                                  C,
                                  D,
                                ).get),
                                (s.__fnct[p] = v)))
                          : s.__fnct
                            ? (v = s.__fnct)
                            : ((R = i.o.x),
                              (w = i.o.y),
                              (C = i.i.x),
                              (D = i.i.y),
                              (v = BezierFactory.getBezierEasing(
                                R,
                                w,
                                C,
                                D,
                              ).get),
                              (i.keyframeMetadata = v)),
                        (f = v((e - _) / (y - _))))),
                  (g = a.s || i.e),
                  (M = i.h === 1 ? i.s[p] : i.s[p] + (g[p] - i.s[p]) * f),
                  this.propType === "multidimensional" ? (r[p] = M) : (r = M);
          }
          return (t.lastIndex = d), r;
        }
        function slerp(e, t, r) {
          var n,
            i,
            a,
            s,
            o,
            l = [],
            f = e[0],
            u = e[1],
            c = e[2],
            v = e[3],
            d = t[0],
            p = t[1],
            m = t[2],
            h = t[3];
          return (
            (i = f * d + u * p + c * m + v * h) < 0 &&
              ((i = -i), (d = -d), (p = -p), (m = -m), (h = -h)),
            1 - i > 1e-6
              ? ((n = Math.acos(i)),
                (a = Math.sin(n)),
                (s = Math.sin((1 - r) * n) / a),
                (o = Math.sin(r * n) / a))
              : ((s = 1 - r), (o = r)),
            (l[0] = s * f + o * d),
            (l[1] = s * u + o * p),
            (l[2] = s * c + o * m),
            (l[3] = s * v + o * h),
            l
          );
        }
        function quaternionToEuler(e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            s = Math.atan2(2 * n * a - 2 * r * i, 1 - 2 * n * n - 2 * i * i),
            o = Math.asin(2 * r * n + 2 * i * a),
            l = Math.atan2(2 * r * a - 2 * n * i, 1 - 2 * r * r - 2 * i * i);
          (e[0] = s / degToRads),
            (e[1] = o / degToRads),
            (e[2] = l / degToRads);
        }
        function createQuaternion(e) {
          var t = e[0] * degToRads,
            r = e[1] * degToRads,
            n = e[2] * degToRads,
            i = Math.cos(t / 2),
            a = Math.cos(r / 2),
            s = Math.cos(n / 2),
            o = Math.sin(t / 2),
            l = Math.sin(r / 2),
            f = Math.sin(n / 2);
          return [
            o * l * s + i * a * f,
            o * a * s + i * l * f,
            i * l * s - o * a * f,
            i * a * s - o * l * f,
          ];
        }
        function getValueAtCurrentTime() {
          var e = this.comp.renderedFrame - this.offsetTime,
            t = this.keyframes[0].t - this.offsetTime,
            r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
          if (
            !(
              e === this._caching.lastFrame ||
              (this._caching.lastFrame !== initFrame &&
                ((this._caching.lastFrame >= r && e >= r) ||
                  (this._caching.lastFrame < t && e < t)))
            )
          ) {
            this._caching.lastFrame >= e &&
              ((this._caching._lastKeyframeIndex = -1),
              (this._caching.lastIndex = 0));
            var n = this.interpolateValue(e, this._caching);
            this.pv = n;
          }
          return (this._caching.lastFrame = e), this.pv;
        }
        function setVValue(e) {
          var t;
          if (this.propType === "unidimensional")
            (t = e * this.mult),
              mathAbs(this.v - t) > 1e-5 && ((this.v = t), (this._mdf = !0));
          else
            for (var r = 0, n = this.v.length; r < n; )
              (t = e[r] * this.mult),
                mathAbs(this.v[r] - t) > 1e-5 &&
                  ((this.v[r] = t), (this._mdf = !0)),
                (r += 1);
        }
        function processEffectsSequence() {
          if (
            this.elem.globalData.frameId !== this.frameId &&
            this.effectsSequence.length
          )
            if (this.lock) this.setVValue(this.pv);
            else {
              var e;
              (this.lock = !0), (this._mdf = this._isFirstFrame);
              var t = this.effectsSequence.length,
                r = this.kf ? this.pv : this.data.k;
              for (e = 0; e < t; e += 1) r = this.effectsSequence[e](r);
              this.setVValue(r),
                (this._isFirstFrame = !1),
                (this.lock = !1),
                (this.frameId = this.elem.globalData.frameId);
            }
        }
        function addEffect(e) {
          this.effectsSequence.push(e), this.container.addDynamicProperty(this);
        }
        function ValueProperty(e, t, r, n) {
          (this.propType = "unidimensional"),
            (this.mult = r || 1),
            (this.data = t),
            (this.v = r ? t.k * r : t.k),
            (this.pv = t.k),
            (this._mdf = !1),
            (this.elem = e),
            (this.container = n),
            (this.comp = e.comp),
            (this.k = !1),
            (this.kf = !1),
            (this.vel = 0),
            (this.effectsSequence = []),
            (this._isFirstFrame = !0),
            (this.getValue = processEffectsSequence),
            (this.setVValue = setVValue),
            (this.addEffect = addEffect);
        }
        function MultiDimensionalProperty(e, t, r, n) {
          var i;
          (this.propType = "multidimensional"),
            (this.mult = r || 1),
            (this.data = t),
            (this._mdf = !1),
            (this.elem = e),
            (this.container = n),
            (this.comp = e.comp),
            (this.k = !1),
            (this.kf = !1),
            (this.frameId = -1);
          var a = t.k.length;
          for (
            this.v = createTypedArray("float32", a),
              this.pv = createTypedArray("float32", a),
              this.vel = createTypedArray("float32", a),
              i = 0;
            i < a;
            i += 1
          )
            (this.v[i] = t.k[i] * this.mult), (this.pv[i] = t.k[i]);
          (this._isFirstFrame = !0),
            (this.effectsSequence = []),
            (this.getValue = processEffectsSequence),
            (this.setVValue = setVValue),
            (this.addEffect = addEffect);
        }
        function KeyframedValueProperty(e, t, r, n) {
          (this.propType = "unidimensional"),
            (this.keyframes = t.k),
            (this.keyframesMetadata = []),
            (this.offsetTime = e.data.st),
            (this.frameId = -1),
            (this._caching = {
              lastFrame: initFrame,
              lastIndex: 0,
              value: 0,
              _lastKeyframeIndex: -1,
            }),
            (this.k = !0),
            (this.kf = !0),
            (this.data = t),
            (this.mult = r || 1),
            (this.elem = e),
            (this.container = n),
            (this.comp = e.comp),
            (this.v = initFrame),
            (this.pv = initFrame),
            (this._isFirstFrame = !0),
            (this.getValue = processEffectsSequence),
            (this.setVValue = setVValue),
            (this.interpolateValue = interpolateValue),
            (this.effectsSequence = [getValueAtCurrentTime.bind(this)]),
            (this.addEffect = addEffect);
        }
        function KeyframedMultidimensionalProperty(e, t, r, n) {
          var i;
          this.propType = "multidimensional";
          var a,
            s,
            o,
            l,
            f = t.k.length;
          for (i = 0; i < f - 1; i += 1)
            t.k[i].to &&
              t.k[i].s &&
              t.k[i + 1] &&
              t.k[i + 1].s &&
              ((a = t.k[i].s),
              (s = t.k[i + 1].s),
              (o = t.k[i].to),
              (l = t.k[i].ti),
              ((a.length === 2 &&
                (a[0] !== s[0] || a[1] !== s[1]) &&
                bez.pointOnLine2D(
                  a[0],
                  a[1],
                  s[0],
                  s[1],
                  a[0] + o[0],
                  a[1] + o[1],
                ) &&
                bez.pointOnLine2D(
                  a[0],
                  a[1],
                  s[0],
                  s[1],
                  s[0] + l[0],
                  s[1] + l[1],
                )) ||
                (a.length === 3 &&
                  (a[0] !== s[0] || a[1] !== s[1] || a[2] !== s[2]) &&
                  bez.pointOnLine3D(
                    a[0],
                    a[1],
                    a[2],
                    s[0],
                    s[1],
                    s[2],
                    a[0] + o[0],
                    a[1] + o[1],
                    a[2] + o[2],
                  ) &&
                  bez.pointOnLine3D(
                    a[0],
                    a[1],
                    a[2],
                    s[0],
                    s[1],
                    s[2],
                    s[0] + l[0],
                    s[1] + l[1],
                    s[2] + l[2],
                  ))) &&
                ((t.k[i].to = null), (t.k[i].ti = null)),
              a[0] === s[0] &&
                a[1] === s[1] &&
                o[0] === 0 &&
                o[1] === 0 &&
                l[0] === 0 &&
                l[1] === 0 &&
                (a.length === 2 ||
                  (a[2] === s[2] && o[2] === 0 && l[2] === 0)) &&
                ((t.k[i].to = null), (t.k[i].ti = null)));
          (this.effectsSequence = [getValueAtCurrentTime.bind(this)]),
            (this.data = t),
            (this.keyframes = t.k),
            (this.keyframesMetadata = []),
            (this.offsetTime = e.data.st),
            (this.k = !0),
            (this.kf = !0),
            (this._isFirstFrame = !0),
            (this.mult = r || 1),
            (this.elem = e),
            (this.container = n),
            (this.comp = e.comp),
            (this.getValue = processEffectsSequence),
            (this.setVValue = setVValue),
            (this.interpolateValue = interpolateValue),
            (this.frameId = -1);
          var u = t.k[0].s.length;
          for (
            this.v = createTypedArray("float32", u),
              this.pv = createTypedArray("float32", u),
              i = 0;
            i < u;
            i += 1
          )
            (this.v[i] = initFrame), (this.pv[i] = initFrame);
          (this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray("float32", u),
          }),
            (this.addEffect = addEffect);
        }
        var PropertyFactory = {
          getProp: function (e, t, r, n, i) {
            var a;
            if (
              (t.sid && (t = e.globalData.slotManager.getProp(t)), t.k.length)
            )
              if (typeof t.k[0] == "number")
                a = new MultiDimensionalProperty(e, t, n, i);
              else
                switch (r) {
                  case 0:
                    a = new KeyframedValueProperty(e, t, n, i);
                    break;
                  case 1:
                    a = new KeyframedMultidimensionalProperty(e, t, n, i);
                }
            else a = new ValueProperty(e, t, n, i);
            return a.effectsSequence.length && i.addDynamicProperty(a), a;
          },
        };
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
          addDynamicProperty: function (e) {
            this.dynamicProperties.indexOf(e) === -1 &&
              (this.dynamicProperties.push(e),
              this.container.addDynamicProperty(this),
              (this._isAnimated = !0));
          },
          iterateDynamicProperties: function () {
            var e;
            this._mdf = !1;
            var t = this.dynamicProperties.length;
            for (e = 0; e < t; e += 1)
              this.dynamicProperties[e].getValue(),
                this.dynamicProperties[e]._mdf && (this._mdf = !0);
          },
          initDynamicPropertyContainer: function (e) {
            (this.container = e),
              (this.dynamicProperties = []),
              (this._mdf = !1),
              (this._isAnimated = !1);
          },
        };
        var pointPool = poolFactory(8, function () {
          return createTypedArray("float32", 2);
        });
        function ShapePath() {
          (this.c = !1),
            (this._length = 0),
            (this._maxLength = 8),
            (this.v = createSizedArray(this._maxLength)),
            (this.o = createSizedArray(this._maxLength)),
            (this.i = createSizedArray(this._maxLength));
        }
        (ShapePath.prototype.setPathData = function (e, t) {
          (this.c = e), this.setLength(t);
          for (var r = 0; r < t; )
            (this.v[r] = pointPool.newElement()),
              (this.o[r] = pointPool.newElement()),
              (this.i[r] = pointPool.newElement()),
              (r += 1);
        }),
          (ShapePath.prototype.setLength = function (e) {
            for (; this._maxLength < e; ) this.doubleArrayLength();
            this._length = e;
          }),
          (ShapePath.prototype.doubleArrayLength = function () {
            (this.v = this.v.concat(createSizedArray(this._maxLength))),
              (this.i = this.i.concat(createSizedArray(this._maxLength))),
              (this.o = this.o.concat(createSizedArray(this._maxLength))),
              (this._maxLength *= 2);
          }),
          (ShapePath.prototype.setXYAt = function (e, t, r, n, i) {
            var a;
            switch (
              ((this._length = Math.max(this._length, n + 1)),
              this._length >= this._maxLength && this.doubleArrayLength(),
              r)
            ) {
              case "v":
                a = this.v;
                break;
              case "i":
                a = this.i;
                break;
              case "o":
                a = this.o;
                break;
              default:
                a = [];
            }
            (!a[n] || (a[n] && !i)) && (a[n] = pointPool.newElement()),
              (a[n][0] = e),
              (a[n][1] = t);
          }),
          (ShapePath.prototype.setTripleAt = function (e, t, r, n, i, a, s, o) {
            this.setXYAt(e, t, "v", s, o),
              this.setXYAt(r, n, "o", s, o),
              this.setXYAt(i, a, "i", s, o);
          }),
          (ShapePath.prototype.reverse = function () {
            var e = new ShapePath();
            e.setPathData(this.c, this._length);
            var t = this.v,
              r = this.o,
              n = this.i,
              i = 0;
            this.c &&
              (e.setTripleAt(
                t[0][0],
                t[0][1],
                n[0][0],
                n[0][1],
                r[0][0],
                r[0][1],
                0,
                !1,
              ),
              (i = 1));
            var a,
              s = this._length - 1,
              o = this._length;
            for (a = i; a < o; a += 1)
              e.setTripleAt(
                t[s][0],
                t[s][1],
                n[s][0],
                n[s][1],
                r[s][0],
                r[s][1],
                a,
                !1,
              ),
                (s -= 1);
            return e;
          }),
          (ShapePath.prototype.length = function () {
            return this._length;
          });
        var shapePool =
            ((factory = poolFactory(
              4,
              function () {
                return new ShapePath();
              },
              function (e) {
                var t,
                  r = e._length;
                for (t = 0; t < r; t += 1)
                  pointPool.release(e.v[t]),
                    pointPool.release(e.i[t]),
                    pointPool.release(e.o[t]),
                    (e.v[t] = null),
                    (e.i[t] = null),
                    (e.o[t] = null);
                (e._length = 0), (e.c = !1);
              },
            )),
            (factory.clone = function (e) {
              var t,
                r = factory.newElement(),
                n = e._length === void 0 ? e.v.length : e._length;
              for (r.setLength(n), r.c = e.c, t = 0; t < n; t += 1)
                r.setTripleAt(
                  e.v[t][0],
                  e.v[t][1],
                  e.o[t][0],
                  e.o[t][1],
                  e.i[t][0],
                  e.i[t][1],
                  t,
                );
              return r;
            }),
            factory),
          factory;
        function ShapeCollection() {
          (this._length = 0),
            (this._maxLength = 4),
            (this.shapes = createSizedArray(this._maxLength));
        }
        (ShapeCollection.prototype.addShape = function (e) {
          this._length === this._maxLength &&
            ((this.shapes = this.shapes.concat(
              createSizedArray(this._maxLength),
            )),
            (this._maxLength *= 2)),
            (this.shapes[this._length] = e),
            (this._length += 1);
        }),
          (ShapeCollection.prototype.releaseShapes = function () {
            var e;
            for (e = 0; e < this._length; e += 1)
              shapePool.release(this.shapes[e]);
            this._length = 0;
          });
        var shapeCollectionPool =
            ((ob = {
              newShapeCollection: function () {
                return _length ? pool[(_length -= 1)] : new ShapeCollection();
              },
              release: function (e) {
                var t,
                  r = e._length;
                for (t = 0; t < r; t += 1) shapePool.release(e.shapes[t]);
                (e._length = 0),
                  _length === _maxLength &&
                    ((pool = pooling.double(pool)), (_maxLength *= 2)),
                  (pool[_length] = e),
                  (_length += 1);
              },
            }),
            (_length = 0),
            (_maxLength = 4),
            (pool = createSizedArray(_maxLength)),
            ob),
          ob,
          _length,
          _maxLength,
          pool,
          ShapePropertyFactory = (function () {
            var e = -999999;
            function t(d, p, m) {
              var h,
                g,
                y,
                _,
                b,
                I,
                P,
                S,
                A,
                R = m.lastIndex,
                w = this.keyframes;
              if (d < w[0].t - this.offsetTime)
                (h = w[0].s[0]), (y = !0), (R = 0);
              else if (d >= w[w.length - 1].t - this.offsetTime)
                (h = w[w.length - 1].s
                  ? w[w.length - 1].s[0]
                  : w[w.length - 2].e[0]),
                  (y = !0);
              else {
                for (
                  var C, D, M, O = R, q = w.length - 1, B = !0;
                  B && ((C = w[O]), !((D = w[O + 1]).t - this.offsetTime > d));

                )
                  O < q - 1 ? (O += 1) : (B = !1);
                if (
                  ((M = this.keyframesMetadata[O] || {}),
                  (R = O),
                  !(y = C.h === 1))
                ) {
                  if (d >= D.t - this.offsetTime) S = 1;
                  else if (d < C.t - this.offsetTime) S = 0;
                  else {
                    var H;
                    M.__fnct
                      ? (H = M.__fnct)
                      : ((H = BezierFactory.getBezierEasing(
                          C.o.x,
                          C.o.y,
                          C.i.x,
                          C.i.y,
                        ).get),
                        (M.__fnct = H)),
                      (S = H(
                        (d - (C.t - this.offsetTime)) /
                          (D.t - this.offsetTime - (C.t - this.offsetTime)),
                      ));
                  }
                  g = D.s ? D.s[0] : C.e[0];
                }
                h = C.s[0];
              }
              for (
                I = p._length, P = h.i[0].length, m.lastIndex = R, _ = 0;
                _ < I;
                _ += 1
              )
                for (b = 0; b < P; b += 1)
                  (A = y ? h.i[_][b] : h.i[_][b] + (g.i[_][b] - h.i[_][b]) * S),
                    (p.i[_][b] = A),
                    (A = y
                      ? h.o[_][b]
                      : h.o[_][b] + (g.o[_][b] - h.o[_][b]) * S),
                    (p.o[_][b] = A),
                    (A = y
                      ? h.v[_][b]
                      : h.v[_][b] + (g.v[_][b] - h.v[_][b]) * S),
                    (p.v[_][b] = A);
            }
            function r() {
              var d = this.comp.renderedFrame - this.offsetTime,
                p = this.keyframes[0].t - this.offsetTime,
                m =
                  this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                h = this._caching.lastFrame;
              return (
                (h !== e && ((h < p && d < p) || (h > m && d > m))) ||
                  ((this._caching.lastIndex =
                    h < d ? this._caching.lastIndex : 0),
                  this.interpolateShape(d, this.pv, this._caching)),
                (this._caching.lastFrame = d),
                this.pv
              );
            }
            function n() {
              this.paths = this.localShapeCollection;
            }
            function i(d) {
              (function (p, m) {
                if (p._length !== m._length || p.c !== m.c) return !1;
                var h,
                  g = p._length;
                for (h = 0; h < g; h += 1)
                  if (
                    p.v[h][0] !== m.v[h][0] ||
                    p.v[h][1] !== m.v[h][1] ||
                    p.o[h][0] !== m.o[h][0] ||
                    p.o[h][1] !== m.o[h][1] ||
                    p.i[h][0] !== m.i[h][0] ||
                    p.i[h][1] !== m.i[h][1]
                  )
                    return !1;
                return !0;
              })(this.v, d) ||
                ((this.v = shapePool.clone(d)),
                this.localShapeCollection.releaseShapes(),
                this.localShapeCollection.addShape(this.v),
                (this._mdf = !0),
                (this.paths = this.localShapeCollection));
            }
            function a() {
              if (this.elem.globalData.frameId !== this.frameId)
                if (this.effectsSequence.length)
                  if (this.lock) this.setVValue(this.pv);
                  else {
                    var d, p;
                    (this.lock = !0),
                      (this._mdf = !1),
                      (d = this.kf
                        ? this.pv
                        : this.data.ks
                          ? this.data.ks.k
                          : this.data.pt.k);
                    var m = this.effectsSequence.length;
                    for (p = 0; p < m; p += 1) d = this.effectsSequence[p](d);
                    this.setVValue(d),
                      (this.lock = !1),
                      (this.frameId = this.elem.globalData.frameId);
                  }
                else this._mdf = !1;
            }
            function s(d, p, m) {
              (this.propType = "shape"),
                (this.comp = d.comp),
                (this.container = d),
                (this.elem = d),
                (this.data = p),
                (this.k = !1),
                (this.kf = !1),
                (this._mdf = !1);
              var h = m === 3 ? p.pt.k : p.ks.k;
              (this.v = shapePool.clone(h)),
                (this.pv = shapePool.clone(this.v)),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                (this.paths = this.localShapeCollection),
                this.paths.addShape(this.v),
                (this.reset = n),
                (this.effectsSequence = []);
            }
            function o(d) {
              this.effectsSequence.push(d),
                this.container.addDynamicProperty(this);
            }
            function l(d, p, m) {
              (this.propType = "shape"),
                (this.comp = d.comp),
                (this.elem = d),
                (this.container = d),
                (this.offsetTime = d.data.st),
                (this.keyframes = m === 3 ? p.pt.k : p.ks.k),
                (this.keyframesMetadata = []),
                (this.k = !0),
                (this.kf = !0);
              var h = this.keyframes[0].s[0].i.length;
              (this.v = shapePool.newElement()),
                this.v.setPathData(this.keyframes[0].s[0].c, h),
                (this.pv = shapePool.clone(this.v)),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                (this.paths = this.localShapeCollection),
                this.paths.addShape(this.v),
                (this.lastFrame = e),
                (this.reset = n),
                (this._caching = { lastFrame: e, lastIndex: 0 }),
                (this.effectsSequence = [r.bind(this)]);
            }
            (s.prototype.interpolateShape = t),
              (s.prototype.getValue = a),
              (s.prototype.setVValue = i),
              (s.prototype.addEffect = o),
              (l.prototype.getValue = a),
              (l.prototype.interpolateShape = t),
              (l.prototype.setVValue = i),
              (l.prototype.addEffect = o);
            var f = (function () {
                var d = roundCorner;
                function p(m, h) {
                  (this.v = shapePool.newElement()),
                    this.v.setPathData(!0, 4),
                    (this.localShapeCollection =
                      shapeCollectionPool.newShapeCollection()),
                    (this.paths = this.localShapeCollection),
                    this.localShapeCollection.addShape(this.v),
                    (this.d = h.d),
                    (this.elem = m),
                    (this.comp = m.comp),
                    (this.frameId = -1),
                    this.initDynamicPropertyContainer(m),
                    (this.p = PropertyFactory.getProp(m, h.p, 1, 0, this)),
                    (this.s = PropertyFactory.getProp(m, h.s, 1, 0, this)),
                    this.dynamicProperties.length
                      ? (this.k = !0)
                      : ((this.k = !1), this.convertEllToPath());
                }
                return (
                  (p.prototype = {
                    reset: n,
                    getValue: function () {
                      this.elem.globalData.frameId !== this.frameId &&
                        ((this.frameId = this.elem.globalData.frameId),
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function () {
                      var m = this.p.v[0],
                        h = this.p.v[1],
                        g = this.s.v[0] / 2,
                        y = this.s.v[1] / 2,
                        _ = this.d !== 3,
                        b = this.v;
                      (b.v[0][0] = m),
                        (b.v[0][1] = h - y),
                        (b.v[1][0] = _ ? m + g : m - g),
                        (b.v[1][1] = h),
                        (b.v[2][0] = m),
                        (b.v[2][1] = h + y),
                        (b.v[3][0] = _ ? m - g : m + g),
                        (b.v[3][1] = h),
                        (b.i[0][0] = _ ? m - g * d : m + g * d),
                        (b.i[0][1] = h - y),
                        (b.i[1][0] = _ ? m + g : m - g),
                        (b.i[1][1] = h - y * d),
                        (b.i[2][0] = _ ? m + g * d : m - g * d),
                        (b.i[2][1] = h + y),
                        (b.i[3][0] = _ ? m - g : m + g),
                        (b.i[3][1] = h + y * d),
                        (b.o[0][0] = _ ? m + g * d : m - g * d),
                        (b.o[0][1] = h - y),
                        (b.o[1][0] = _ ? m + g : m - g),
                        (b.o[1][1] = h + y * d),
                        (b.o[2][0] = _ ? m - g * d : m + g * d),
                        (b.o[2][1] = h + y),
                        (b.o[3][0] = _ ? m - g : m + g),
                        (b.o[3][1] = h - y * d);
                    },
                  }),
                  extendPrototype([DynamicPropertyContainer], p),
                  p
                );
              })(),
              u = (function () {
                function d(p, m) {
                  (this.v = shapePool.newElement()),
                    this.v.setPathData(!0, 0),
                    (this.elem = p),
                    (this.comp = p.comp),
                    (this.data = m),
                    (this.frameId = -1),
                    (this.d = m.d),
                    this.initDynamicPropertyContainer(p),
                    m.sy === 1
                      ? ((this.ir = PropertyFactory.getProp(
                          p,
                          m.ir,
                          0,
                          0,
                          this,
                        )),
                        (this.is = PropertyFactory.getProp(
                          p,
                          m.is,
                          0,
                          0.01,
                          this,
                        )),
                        (this.convertToPath = this.convertStarToPath))
                      : (this.convertToPath = this.convertPolygonToPath),
                    (this.pt = PropertyFactory.getProp(p, m.pt, 0, 0, this)),
                    (this.p = PropertyFactory.getProp(p, m.p, 1, 0, this)),
                    (this.r = PropertyFactory.getProp(
                      p,
                      m.r,
                      0,
                      degToRads,
                      this,
                    )),
                    (this.or = PropertyFactory.getProp(p, m.or, 0, 0, this)),
                    (this.os = PropertyFactory.getProp(p, m.os, 0, 0.01, this)),
                    (this.localShapeCollection =
                      shapeCollectionPool.newShapeCollection()),
                    this.localShapeCollection.addShape(this.v),
                    (this.paths = this.localShapeCollection),
                    this.dynamicProperties.length
                      ? (this.k = !0)
                      : ((this.k = !1), this.convertToPath());
                }
                return (
                  (d.prototype = {
                    reset: n,
                    getValue: function () {
                      this.elem.globalData.frameId !== this.frameId &&
                        ((this.frameId = this.elem.globalData.frameId),
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function () {
                      var p,
                        m,
                        h,
                        g,
                        y = 2 * Math.floor(this.pt.v),
                        _ = (2 * Math.PI) / y,
                        b = !0,
                        I = this.or.v,
                        P = this.ir.v,
                        S = this.os.v,
                        A = this.is.v,
                        R = (2 * Math.PI * I) / (2 * y),
                        w = (2 * Math.PI * P) / (2 * y),
                        C = -Math.PI / 2;
                      C += this.r.v;
                      var D = this.data.d === 3 ? -1 : 1;
                      for (this.v._length = 0, p = 0; p < y; p += 1) {
                        (h = b ? S : A), (g = b ? R : w);
                        var M = (m = b ? I : P) * Math.cos(C),
                          O = m * Math.sin(C),
                          q =
                            M === 0 && O === 0
                              ? 0
                              : O / Math.sqrt(M * M + O * O),
                          B =
                            M === 0 && O === 0
                              ? 0
                              : -M / Math.sqrt(M * M + O * O);
                        (M += +this.p.v[0]),
                          (O += +this.p.v[1]),
                          this.v.setTripleAt(
                            M,
                            O,
                            M - q * g * h * D,
                            O - B * g * h * D,
                            M + q * g * h * D,
                            O + B * g * h * D,
                            p,
                            !0,
                          ),
                          (b = !b),
                          (C += _ * D);
                      }
                    },
                    convertPolygonToPath: function () {
                      var p,
                        m = Math.floor(this.pt.v),
                        h = (2 * Math.PI) / m,
                        g = this.or.v,
                        y = this.os.v,
                        _ = (2 * Math.PI * g) / (4 * m),
                        b = 0.5 * -Math.PI,
                        I = this.data.d === 3 ? -1 : 1;
                      for (
                        b += this.r.v, this.v._length = 0, p = 0;
                        p < m;
                        p += 1
                      ) {
                        var P = g * Math.cos(b),
                          S = g * Math.sin(b),
                          A =
                            P === 0 && S === 0
                              ? 0
                              : S / Math.sqrt(P * P + S * S),
                          R =
                            P === 0 && S === 0
                              ? 0
                              : -P / Math.sqrt(P * P + S * S);
                        (P += +this.p.v[0]),
                          (S += +this.p.v[1]),
                          this.v.setTripleAt(
                            P,
                            S,
                            P - A * _ * y * I,
                            S - R * _ * y * I,
                            P + A * _ * y * I,
                            S + R * _ * y * I,
                            p,
                            !0,
                          ),
                          (b += h * I);
                      }
                      (this.paths.length = 0), (this.paths[0] = this.v);
                    },
                  }),
                  extendPrototype([DynamicPropertyContainer], d),
                  d
                );
              })(),
              c = (function () {
                function d(p, m) {
                  (this.v = shapePool.newElement()),
                    (this.v.c = !0),
                    (this.localShapeCollection =
                      shapeCollectionPool.newShapeCollection()),
                    this.localShapeCollection.addShape(this.v),
                    (this.paths = this.localShapeCollection),
                    (this.elem = p),
                    (this.comp = p.comp),
                    (this.frameId = -1),
                    (this.d = m.d),
                    this.initDynamicPropertyContainer(p),
                    (this.p = PropertyFactory.getProp(p, m.p, 1, 0, this)),
                    (this.s = PropertyFactory.getProp(p, m.s, 1, 0, this)),
                    (this.r = PropertyFactory.getProp(p, m.r, 0, 0, this)),
                    this.dynamicProperties.length
                      ? (this.k = !0)
                      : ((this.k = !1), this.convertRectToPath());
                }
                return (
                  (d.prototype = {
                    convertRectToPath: function () {
                      var p = this.p.v[0],
                        m = this.p.v[1],
                        h = this.s.v[0] / 2,
                        g = this.s.v[1] / 2,
                        y = bmMin(h, g, this.r.v),
                        _ = y * (1 - roundCorner);
                      (this.v._length = 0),
                        this.d === 2 || this.d === 1
                          ? (this.v.setTripleAt(
                              p + h,
                              m - g + y,
                              p + h,
                              m - g + y,
                              p + h,
                              m - g + _,
                              0,
                              !0,
                            ),
                            this.v.setTripleAt(
                              p + h,
                              m + g - y,
                              p + h,
                              m + g - _,
                              p + h,
                              m + g - y,
                              1,
                              !0,
                            ),
                            y !== 0
                              ? (this.v.setTripleAt(
                                  p + h - y,
                                  m + g,
                                  p + h - y,
                                  m + g,
                                  p + h - _,
                                  m + g,
                                  2,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h + y,
                                  m + g,
                                  p - h + _,
                                  m + g,
                                  p - h + y,
                                  m + g,
                                  3,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m + g - y,
                                  p - h,
                                  m + g - y,
                                  p - h,
                                  m + g - _,
                                  4,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m - g + y,
                                  p - h,
                                  m - g + _,
                                  p - h,
                                  m - g + y,
                                  5,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h + y,
                                  m - g,
                                  p - h + y,
                                  m - g,
                                  p - h + _,
                                  m - g,
                                  6,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p + h - y,
                                  m - g,
                                  p + h - _,
                                  m - g,
                                  p + h - y,
                                  m - g,
                                  7,
                                  !0,
                                ))
                              : (this.v.setTripleAt(
                                  p - h,
                                  m + g,
                                  p - h + _,
                                  m + g,
                                  p - h,
                                  m + g,
                                  2,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m - g,
                                  p - h,
                                  m - g + _,
                                  p - h,
                                  m - g,
                                  3,
                                )))
                          : (this.v.setTripleAt(
                              p + h,
                              m - g + y,
                              p + h,
                              m - g + _,
                              p + h,
                              m - g + y,
                              0,
                              !0,
                            ),
                            y !== 0
                              ? (this.v.setTripleAt(
                                  p + h - y,
                                  m - g,
                                  p + h - y,
                                  m - g,
                                  p + h - _,
                                  m - g,
                                  1,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h + y,
                                  m - g,
                                  p - h + _,
                                  m - g,
                                  p - h + y,
                                  m - g,
                                  2,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m - g + y,
                                  p - h,
                                  m - g + y,
                                  p - h,
                                  m - g + _,
                                  3,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m + g - y,
                                  p - h,
                                  m + g - _,
                                  p - h,
                                  m + g - y,
                                  4,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h + y,
                                  m + g,
                                  p - h + y,
                                  m + g,
                                  p - h + _,
                                  m + g,
                                  5,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p + h - y,
                                  m + g,
                                  p + h - _,
                                  m + g,
                                  p + h - y,
                                  m + g,
                                  6,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p + h,
                                  m + g - y,
                                  p + h,
                                  m + g - y,
                                  p + h,
                                  m + g - _,
                                  7,
                                  !0,
                                ))
                              : (this.v.setTripleAt(
                                  p - h,
                                  m - g,
                                  p - h + _,
                                  m - g,
                                  p - h,
                                  m - g,
                                  1,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p - h,
                                  m + g,
                                  p - h,
                                  m + g - _,
                                  p - h,
                                  m + g,
                                  2,
                                  !0,
                                ),
                                this.v.setTripleAt(
                                  p + h,
                                  m + g,
                                  p + h - _,
                                  m + g,
                                  p + h,
                                  m + g,
                                  3,
                                  !0,
                                )));
                    },
                    getValue: function () {
                      this.elem.globalData.frameId !== this.frameId &&
                        ((this.frameId = this.elem.globalData.frameId),
                        this.iterateDynamicProperties(),
                        this._mdf && this.convertRectToPath());
                    },
                    reset: n,
                  }),
                  extendPrototype([DynamicPropertyContainer], d),
                  d
                );
              })(),
              v = {
                getShapeProp: function (d, p, m) {
                  var h;
                  return (
                    m === 3 || m === 4
                      ? (h = (m === 3 ? p.pt : p.ks).k.length
                          ? new l(d, p, m)
                          : new s(d, p, m))
                      : m === 5
                        ? (h = new c(d, p))
                        : m === 6
                          ? (h = new f(d, p))
                          : m === 7 && (h = new u(d, p)),
                    h.k && d.addDynamicProperty(h),
                    h
                  );
                },
                getConstructorFunction: function () {
                  return s;
                },
                getKeyframedConstructorFunction: function () {
                  return l;
                },
              };
            return v;
          })(),
          Matrix = (function () {
            var e = Math.cos,
              t = Math.sin,
              r = Math.tan,
              n = Math.round;
            function i() {
              return (
                (this.props[0] = 1),
                (this.props[1] = 0),
                (this.props[2] = 0),
                (this.props[3] = 0),
                (this.props[4] = 0),
                (this.props[5] = 1),
                (this.props[6] = 0),
                (this.props[7] = 0),
                (this.props[8] = 0),
                (this.props[9] = 0),
                (this.props[10] = 1),
                (this.props[11] = 0),
                (this.props[12] = 0),
                (this.props[13] = 0),
                (this.props[14] = 0),
                (this.props[15] = 1),
                this
              );
            }
            function a(x) {
              if (x === 0) return this;
              var L = e(x),
                j = t(x);
              return this._t(L, -j, 0, 0, j, L, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function s(x) {
              if (x === 0) return this;
              var L = e(x),
                j = t(x);
              return this._t(1, 0, 0, 0, 0, L, -j, 0, 0, j, L, 0, 0, 0, 0, 1);
            }
            function o(x) {
              if (x === 0) return this;
              var L = e(x),
                j = t(x);
              return this._t(L, 0, j, 0, 0, 1, 0, 0, -j, 0, L, 0, 0, 0, 0, 1);
            }
            function l(x) {
              if (x === 0) return this;
              var L = e(x),
                j = t(x);
              return this._t(L, -j, 0, 0, j, L, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function f(x, L) {
              return this._t(1, L, x, 1, 0, 0);
            }
            function u(x, L) {
              return this.shear(r(x), r(L));
            }
            function c(x, L) {
              var j = e(L),
                Y = t(L);
              return this._t(j, Y, 0, 0, -Y, j, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                ._t(1, 0, 0, 0, r(x), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                ._t(j, -Y, 0, 0, Y, j, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function v(x, L, j) {
              return (
                j || j === 0 || (j = 1),
                x === 1 && L === 1 && j === 1
                  ? this
                  : this._t(x, 0, 0, 0, 0, L, 0, 0, 0, 0, j, 0, 0, 0, 0, 1)
              );
            }
            function d(
              x,
              L,
              j,
              Y,
              oe,
              U,
              ue,
              le,
              be,
              se,
              he,
              je,
              ge,
              we,
              He,
              qe,
            ) {
              return (
                (this.props[0] = x),
                (this.props[1] = L),
                (this.props[2] = j),
                (this.props[3] = Y),
                (this.props[4] = oe),
                (this.props[5] = U),
                (this.props[6] = ue),
                (this.props[7] = le),
                (this.props[8] = be),
                (this.props[9] = se),
                (this.props[10] = he),
                (this.props[11] = je),
                (this.props[12] = ge),
                (this.props[13] = we),
                (this.props[14] = He),
                (this.props[15] = qe),
                this
              );
            }
            function p(x, L, j) {
              return (
                (j = j || 0),
                x !== 0 || L !== 0 || j !== 0
                  ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, L, j, 1)
                  : this
              );
            }
            function m(
              x,
              L,
              j,
              Y,
              oe,
              U,
              ue,
              le,
              be,
              se,
              he,
              je,
              ge,
              we,
              He,
              qe,
            ) {
              var J = this.props;
              if (
                x === 1 &&
                L === 0 &&
                j === 0 &&
                Y === 0 &&
                oe === 0 &&
                U === 1 &&
                ue === 0 &&
                le === 0 &&
                be === 0 &&
                se === 0 &&
                he === 1 &&
                je === 0
              )
                return (
                  (J[12] = J[12] * x + J[15] * ge),
                  (J[13] = J[13] * U + J[15] * we),
                  (J[14] = J[14] * he + J[15] * He),
                  (J[15] *= qe),
                  (this._identityCalculated = !1),
                  this
                );
              var We = J[0],
                tr = J[1],
                Ct = J[2],
                T = J[3],
                F = J[4],
                N = J[5],
                k = J[6],
                z = J[7],
                V = J[8],
                X = J[9],
                K = J[10],
                ce = J[11],
                W = J[12],
                ee = J[13],
                ie = J[14],
                _e = J[15];
              return (
                (J[0] = We * x + tr * oe + Ct * be + T * ge),
                (J[1] = We * L + tr * U + Ct * se + T * we),
                (J[2] = We * j + tr * ue + Ct * he + T * He),
                (J[3] = We * Y + tr * le + Ct * je + T * qe),
                (J[4] = F * x + N * oe + k * be + z * ge),
                (J[5] = F * L + N * U + k * se + z * we),
                (J[6] = F * j + N * ue + k * he + z * He),
                (J[7] = F * Y + N * le + k * je + z * qe),
                (J[8] = V * x + X * oe + K * be + ce * ge),
                (J[9] = V * L + X * U + K * se + ce * we),
                (J[10] = V * j + X * ue + K * he + ce * He),
                (J[11] = V * Y + X * le + K * je + ce * qe),
                (J[12] = W * x + ee * oe + ie * be + _e * ge),
                (J[13] = W * L + ee * U + ie * se + _e * we),
                (J[14] = W * j + ee * ue + ie * he + _e * He),
                (J[15] = W * Y + ee * le + ie * je + _e * qe),
                (this._identityCalculated = !1),
                this
              );
            }
            function h(x) {
              var L = x.props;
              return this.transform(
                L[0],
                L[1],
                L[2],
                L[3],
                L[4],
                L[5],
                L[6],
                L[7],
                L[8],
                L[9],
                L[10],
                L[11],
                L[12],
                L[13],
                L[14],
                L[15],
              );
            }
            function g() {
              return (
                this._identityCalculated ||
                  ((this._identity = !(
                    this.props[0] !== 1 ||
                    this.props[1] !== 0 ||
                    this.props[2] !== 0 ||
                    this.props[3] !== 0 ||
                    this.props[4] !== 0 ||
                    this.props[5] !== 1 ||
                    this.props[6] !== 0 ||
                    this.props[7] !== 0 ||
                    this.props[8] !== 0 ||
                    this.props[9] !== 0 ||
                    this.props[10] !== 1 ||
                    this.props[11] !== 0 ||
                    this.props[12] !== 0 ||
                    this.props[13] !== 0 ||
                    this.props[14] !== 0 ||
                    this.props[15] !== 1
                  )),
                  (this._identityCalculated = !0)),
                this._identity
              );
            }
            function y(x) {
              for (var L = 0; L < 16; ) {
                if (x.props[L] !== this.props[L]) return !1;
                L += 1;
              }
              return !0;
            }
            function _(x) {
              var L;
              for (L = 0; L < 16; L += 1) x.props[L] = this.props[L];
              return x;
            }
            function b(x) {
              var L;
              for (L = 0; L < 16; L += 1) this.props[L] = x[L];
            }
            function I(x, L, j) {
              return {
                x:
                  x * this.props[0] +
                  L * this.props[4] +
                  j * this.props[8] +
                  this.props[12],
                y:
                  x * this.props[1] +
                  L * this.props[5] +
                  j * this.props[9] +
                  this.props[13],
                z:
                  x * this.props[2] +
                  L * this.props[6] +
                  j * this.props[10] +
                  this.props[14],
              };
            }
            function P(x, L, j) {
              return (
                x * this.props[0] +
                L * this.props[4] +
                j * this.props[8] +
                this.props[12]
              );
            }
            function S(x, L, j) {
              return (
                x * this.props[1] +
                L * this.props[5] +
                j * this.props[9] +
                this.props[13]
              );
            }
            function A(x, L, j) {
              return (
                x * this.props[2] +
                L * this.props[6] +
                j * this.props[10] +
                this.props[14]
              );
            }
            function R() {
              var x =
                  this.props[0] * this.props[5] - this.props[1] * this.props[4],
                L = this.props[5] / x,
                j = -this.props[1] / x,
                Y = -this.props[4] / x,
                oe = this.props[0] / x,
                U =
                  (this.props[4] * this.props[13] -
                    this.props[5] * this.props[12]) /
                  x,
                ue =
                  -(
                    this.props[0] * this.props[13] -
                    this.props[1] * this.props[12]
                  ) / x,
                le = new Matrix();
              return (
                (le.props[0] = L),
                (le.props[1] = j),
                (le.props[4] = Y),
                (le.props[5] = oe),
                (le.props[12] = U),
                (le.props[13] = ue),
                le
              );
            }
            function w(x) {
              return this.getInverseMatrix().applyToPointArray(
                x[0],
                x[1],
                x[2] || 0,
              );
            }
            function C(x) {
              var L,
                j = x.length,
                Y = [];
              for (L = 0; L < j; L += 1) Y[L] = w(x[L]);
              return Y;
            }
            function D(x, L, j) {
              var Y = createTypedArray("float32", 6);
              if (this.isIdentity())
                (Y[0] = x[0]),
                  (Y[1] = x[1]),
                  (Y[2] = L[0]),
                  (Y[3] = L[1]),
                  (Y[4] = j[0]),
                  (Y[5] = j[1]);
              else {
                var oe = this.props[0],
                  U = this.props[1],
                  ue = this.props[4],
                  le = this.props[5],
                  be = this.props[12],
                  se = this.props[13];
                (Y[0] = x[0] * oe + x[1] * ue + be),
                  (Y[1] = x[0] * U + x[1] * le + se),
                  (Y[2] = L[0] * oe + L[1] * ue + be),
                  (Y[3] = L[0] * U + L[1] * le + se),
                  (Y[4] = j[0] * oe + j[1] * ue + be),
                  (Y[5] = j[0] * U + j[1] * le + se);
              }
              return Y;
            }
            function M(x, L, j) {
              return this.isIdentity()
                ? [x, L, j]
                : [
                    x * this.props[0] +
                      L * this.props[4] +
                      j * this.props[8] +
                      this.props[12],
                    x * this.props[1] +
                      L * this.props[5] +
                      j * this.props[9] +
                      this.props[13],
                    x * this.props[2] +
                      L * this.props[6] +
                      j * this.props[10] +
                      this.props[14],
                  ];
            }
            function O(x, L) {
              if (this.isIdentity()) return x + "," + L;
              var j = this.props;
              return (
                Math.round(100 * (x * j[0] + L * j[4] + j[12])) / 100 +
                "," +
                Math.round(100 * (x * j[1] + L * j[5] + j[13])) / 100
              );
            }
            function q() {
              for (var x = 0, L = this.props, j = "matrix3d("; x < 16; )
                (j += n(1e4 * L[x]) / 1e4),
                  (j += x === 15 ? ")" : ","),
                  (x += 1);
              return j;
            }
            function B(x) {
              return (x < 1e-6 && x > 0) || (x > -1e-6 && x < 0)
                ? n(1e4 * x) / 1e4
                : x;
            }
            function H() {
              var x = this.props;
              return (
                "matrix(" +
                B(x[0]) +
                "," +
                B(x[1]) +
                "," +
                B(x[4]) +
                "," +
                B(x[5]) +
                "," +
                B(x[12]) +
                "," +
                B(x[13]) +
                ")"
              );
            }
            return function () {
              (this.reset = i),
                (this.rotate = a),
                (this.rotateX = s),
                (this.rotateY = o),
                (this.rotateZ = l),
                (this.skew = u),
                (this.skewFromAxis = c),
                (this.shear = f),
                (this.scale = v),
                (this.setTransform = d),
                (this.translate = p),
                (this.transform = m),
                (this.multiply = h),
                (this.applyToPoint = I),
                (this.applyToX = P),
                (this.applyToY = S),
                (this.applyToZ = A),
                (this.applyToPointArray = M),
                (this.applyToTriplePoints = D),
                (this.applyToPointStringified = O),
                (this.toCSS = q),
                (this.to2dCSS = H),
                (this.clone = _),
                (this.cloneFromProps = b),
                (this.equals = y),
                (this.inversePoints = C),
                (this.inversePoint = w),
                (this.getInverseMatrix = R),
                (this._t = this.transform),
                (this.isIdentity = g),
                (this._identity = !0),
                (this._identityCalculated = !1),
                (this.props = createTypedArray("float32", 16)),
                this.reset();
            };
          })();
        function _typeof$3(e) {
          return (
            (_typeof$3 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$3(e)
          );
        }
        var lottie = {},
          standalone = "__[STANDALONE]__",
          animationData = "__[ANIMATIONDATA]__",
          renderer = "";
        function setLocation(e) {
          setLocationHref(e);
        }
        function searchAnimations() {
          standalone === !0
            ? animationManager.searchAnimations(
                animationData,
                standalone,
                renderer,
              )
            : animationManager.searchAnimations();
        }
        function setSubframeRendering(e) {
          setSubframeEnabled(e);
        }
        function setPrefix(e) {
          setIdPrefix(e);
        }
        function loadAnimation(e) {
          return (
            standalone === !0 && (e.animationData = JSON.parse(animationData)),
            animationManager.loadAnimation(e)
          );
        }
        function setQuality(e) {
          if (typeof e == "string")
            switch (e) {
              case "high":
                setDefaultCurveSegments(200);
                break;
              default:
              case "medium":
                setDefaultCurveSegments(50);
                break;
              case "low":
                setDefaultCurveSegments(10);
            }
          else !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
          getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
          return typeof navigator < "u";
        }
        function installPlugin(e, t) {
          e === "expressions" && setExpressionsPlugin(t);
        }
        function getFactory(e) {
          switch (e) {
            case "propertyFactory":
              return PropertyFactory;
            case "shapePropertyFactory":
              return ShapePropertyFactory;
            case "matrix":
              return Matrix;
            default:
              return null;
          }
        }
        function checkReady() {
          document.readyState === "complete" &&
            (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(e) {
          for (var t = queryString.split("&"), r = 0; r < t.length; r += 1) {
            var n = t[r].split("=");
            if (decodeURIComponent(n[0]) == e) return decodeURIComponent(n[1]);
          }
          return null;
        }
        (lottie.play = animationManager.play),
          (lottie.pause = animationManager.pause),
          (lottie.setLocationHref = setLocation),
          (lottie.togglePause = animationManager.togglePause),
          (lottie.setSpeed = animationManager.setSpeed),
          (lottie.setDirection = animationManager.setDirection),
          (lottie.stop = animationManager.stop),
          (lottie.searchAnimations = searchAnimations),
          (lottie.registerAnimation = animationManager.registerAnimation),
          (lottie.loadAnimation = loadAnimation),
          (lottie.setSubframeRendering = setSubframeRendering),
          (lottie.resize = animationManager.resize),
          (lottie.goToAndStop = animationManager.goToAndStop),
          (lottie.destroy = animationManager.destroy),
          (lottie.setQuality = setQuality),
          (lottie.inBrowser = inBrowser),
          (lottie.installPlugin = installPlugin),
          (lottie.freeze = animationManager.freeze),
          (lottie.unfreeze = animationManager.unfreeze),
          (lottie.setVolume = animationManager.setVolume),
          (lottie.mute = animationManager.mute),
          (lottie.unmute = animationManager.unmute),
          (lottie.getRegisteredAnimations =
            animationManager.getRegisteredAnimations),
          (lottie.useWebWorker = setWebWorker),
          (lottie.setIDPrefix = setPrefix),
          (lottie.__getFactory = getFactory),
          (lottie.version = "5.12.2");
        var queryString = "";
        if (standalone) {
          var scripts = document.getElementsByTagName("script"),
            index = scripts.length - 1,
            myScript = scripts[index] || { src: "" };
          (queryString = myScript.src
            ? myScript.src.replace(/^[^\?]+\??/, "")
            : ""),
            (renderer = getQueryVariable("renderer"));
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
          ((typeof exports > "u" ? "undefined" : _typeof$3(exports)) ===
            "object" &&
            typeof module < "u") ||
            (typeof define == "function" && define.amd) ||
            (window.bodymovin = lottie);
        } catch (e) {}
        var ShapeModifiers = (function () {
          var e = {},
            t = {};
          return (
            (e.registerModifier = function (r, n) {
              t[r] || (t[r] = n);
            }),
            (e.getModifier = function (r, n, i) {
              return new t[r](n, i);
            }),
            e
          );
        })();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        (ShapeModifier.prototype.initModifierProperties = function () {}),
          (ShapeModifier.prototype.addShapeToModifier = function () {}),
          (ShapeModifier.prototype.addShape = function (e) {
            if (!this.closed) {
              e.sh.container.addDynamicProperty(e.sh);
              var t = {
                shape: e.sh,
                data: e,
                localShapeCollection: shapeCollectionPool.newShapeCollection(),
              };
              this.shapes.push(t),
                this.addShapeToModifier(t),
                this._isAnimated && e.setAsAnimated();
            }
          }),
          (ShapeModifier.prototype.init = function (e, t) {
            (this.shapes = []),
              (this.elem = e),
              this.initDynamicPropertyContainer(e),
              this.initModifierProperties(e, t),
              (this.frameId = initialDefaultFrame),
              (this.closed = !1),
              (this.k = !1),
              this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
          }),
          (ShapeModifier.prototype.processKeys = function () {
            this.elem.globalData.frameId !== this.frameId &&
              ((this.frameId = this.elem.globalData.frameId),
              this.iterateDynamicProperties());
          }),
          extendPrototype([DynamicPropertyContainer], ShapeModifier),
          extendPrototype([ShapeModifier], TrimModifier),
          (TrimModifier.prototype.initModifierProperties = function (e, t) {
            (this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this)),
              (this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this)),
              (this.o = PropertyFactory.getProp(e, t.o, 0, 0, this)),
              (this.sValue = 0),
              (this.eValue = 0),
              (this.getValue = this.processKeys),
              (this.m = t.m),
              (this._isAnimated =
                !!this.s.effectsSequence.length ||
                !!this.e.effectsSequence.length ||
                !!this.o.effectsSequence.length);
          }),
          (TrimModifier.prototype.addShapeToModifier = function (e) {
            e.pathsData = [];
          }),
          (TrimModifier.prototype.calculateShapeEdges = function (
            e,
            t,
            r,
            n,
            i,
          ) {
            var a = [];
            t <= 1
              ? a.push({ s: e, e: t })
              : e >= 1
                ? a.push({ s: e - 1, e: t - 1 })
                : (a.push({ s: e, e: 1 }), a.push({ s: 0, e: t - 1 }));
            var s,
              o,
              l = [],
              f = a.length;
            for (s = 0; s < f; s += 1) {
              var u, c;
              (o = a[s]).e * i < n ||
                o.s * i > n + r ||
                ((u = o.s * i <= n ? 0 : (o.s * i - n) / r),
                (c = o.e * i >= n + r ? 1 : (o.e * i - n) / r),
                l.push([u, c]));
            }
            return l.length || l.push([0, 0]), l;
          }),
          (TrimModifier.prototype.releasePathsData = function (e) {
            var t,
              r = e.length;
            for (t = 0; t < r; t += 1) segmentsLengthPool.release(e[t]);
            return (e.length = 0), e;
          }),
          (TrimModifier.prototype.processShapes = function (e) {
            var t, r, n, i;
            if (this._mdf || e) {
              var a = (this.o.v % 360) / 360;
              if (
                (a < 0 && (a += 1),
                (t =
                  this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) >
                  (r =
                    this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a))
              ) {
                var s = t;
                (t = r), (r = s);
              }
              (t = 1e-4 * Math.round(1e4 * t)),
                (r = 1e-4 * Math.round(1e4 * r)),
                (this.sValue = t),
                (this.eValue = r);
            } else (t = this.sValue), (r = this.eValue);
            var o,
              l,
              f,
              u,
              c,
              v = this.shapes.length,
              d = 0;
            if (r === t)
              for (i = 0; i < v; i += 1)
                this.shapes[i].localShapeCollection.releaseShapes(),
                  (this.shapes[i].shape._mdf = !0),
                  (this.shapes[i].shape.paths =
                    this.shapes[i].localShapeCollection),
                  this._mdf && (this.shapes[i].pathsData.length = 0);
            else if ((r === 1 && t === 0) || (r === 0 && t === 1)) {
              if (this._mdf)
                for (i = 0; i < v; i += 1)
                  (this.shapes[i].pathsData.length = 0),
                    (this.shapes[i].shape._mdf = !0);
            } else {
              var p,
                m,
                h = [];
              for (i = 0; i < v; i += 1)
                if (
                  (p = this.shapes[i]).shape._mdf ||
                  this._mdf ||
                  e ||
                  this.m === 2
                ) {
                  if (
                    ((l = (n = p.shape.paths)._length),
                    (c = 0),
                    !p.shape._mdf && p.pathsData.length)
                  )
                    c = p.totalShapeLength;
                  else {
                    for (
                      f = this.releasePathsData(p.pathsData), o = 0;
                      o < l;
                      o += 1
                    )
                      (u = bez.getSegmentsLength(n.shapes[o])),
                        f.push(u),
                        (c += u.totalLength);
                    (p.totalShapeLength = c), (p.pathsData = f);
                  }
                  (d += c), (p.shape._mdf = !0);
                } else p.shape.paths = p.localShapeCollection;
              var g,
                y = t,
                _ = r,
                b = 0;
              for (i = v - 1; i >= 0; i -= 1)
                if ((p = this.shapes[i]).shape._mdf) {
                  for (
                    (m = p.localShapeCollection).releaseShapes(),
                      this.m === 2 && v > 1
                        ? ((g = this.calculateShapeEdges(
                            t,
                            r,
                            p.totalShapeLength,
                            b,
                            d,
                          )),
                          (b += p.totalShapeLength))
                        : (g = [[y, _]]),
                      l = g.length,
                      o = 0;
                    o < l;
                    o += 1
                  ) {
                    (y = g[o][0]),
                      (_ = g[o][1]),
                      (h.length = 0),
                      _ <= 1
                        ? h.push({
                            s: p.totalShapeLength * y,
                            e: p.totalShapeLength * _,
                          })
                        : y >= 1
                          ? h.push({
                              s: p.totalShapeLength * (y - 1),
                              e: p.totalShapeLength * (_ - 1),
                            })
                          : (h.push({
                              s: p.totalShapeLength * y,
                              e: p.totalShapeLength,
                            }),
                            h.push({ s: 0, e: p.totalShapeLength * (_ - 1) }));
                    var I = this.addShapes(p, h[0]);
                    if (h[0].s !== h[0].e) {
                      if (h.length > 1)
                        if (p.shape.paths.shapes[p.shape.paths._length - 1].c) {
                          var P = I.pop();
                          this.addPaths(I, m), (I = this.addShapes(p, h[1], P));
                        } else
                          this.addPaths(I, m), (I = this.addShapes(p, h[1]));
                      this.addPaths(I, m);
                    }
                  }
                  p.shape.paths = m;
                }
            }
          }),
          (TrimModifier.prototype.addPaths = function (e, t) {
            var r,
              n = e.length;
            for (r = 0; r < n; r += 1) t.addShape(e[r]);
          }),
          (TrimModifier.prototype.addSegment = function (e, t, r, n, i, a, s) {
            i.setXYAt(t[0], t[1], "o", a),
              i.setXYAt(r[0], r[1], "i", a + 1),
              s && i.setXYAt(e[0], e[1], "v", a),
              i.setXYAt(n[0], n[1], "v", a + 1);
          }),
          (TrimModifier.prototype.addSegmentFromArray = function (e, t, r, n) {
            t.setXYAt(e[1], e[5], "o", r),
              t.setXYAt(e[2], e[6], "i", r + 1),
              n && t.setXYAt(e[0], e[4], "v", r),
              t.setXYAt(e[3], e[7], "v", r + 1);
          }),
          (TrimModifier.prototype.addShapes = function (e, t, r) {
            var n,
              i,
              a,
              s,
              o,
              l,
              f,
              u,
              c = e.pathsData,
              v = e.shape.paths.shapes,
              d = e.shape.paths._length,
              p = 0,
              m = [],
              h = !0;
            for (
              r
                ? ((o = r._length), (u = r._length))
                : ((r = shapePool.newElement()), (o = 0), (u = 0)),
                m.push(r),
                n = 0;
              n < d;
              n += 1
            ) {
              for (
                l = c[n].lengths,
                  r.c = v[n].c,
                  a = v[n].c ? l.length : l.length + 1,
                  i = 1;
                i < a;
                i += 1
              )
                if (p + (s = l[i - 1]).addedLength < t.s)
                  (p += s.addedLength), (r.c = !1);
                else {
                  if (p > t.e) {
                    r.c = !1;
                    break;
                  }
                  t.s <= p && t.e >= p + s.addedLength
                    ? (this.addSegment(
                        v[n].v[i - 1],
                        v[n].o[i - 1],
                        v[n].i[i],
                        v[n].v[i],
                        r,
                        o,
                        h,
                      ),
                      (h = !1))
                    : ((f = bez.getNewSegment(
                        v[n].v[i - 1],
                        v[n].v[i],
                        v[n].o[i - 1],
                        v[n].i[i],
                        (t.s - p) / s.addedLength,
                        (t.e - p) / s.addedLength,
                        l[i - 1],
                      )),
                      this.addSegmentFromArray(f, r, o, h),
                      (h = !1),
                      (r.c = !1)),
                    (p += s.addedLength),
                    (o += 1);
                }
              if (v[n].c && l.length) {
                if (((s = l[i - 1]), p <= t.e)) {
                  var g = l[i - 1].addedLength;
                  t.s <= p && t.e >= p + g
                    ? (this.addSegment(
                        v[n].v[i - 1],
                        v[n].o[i - 1],
                        v[n].i[0],
                        v[n].v[0],
                        r,
                        o,
                        h,
                      ),
                      (h = !1))
                    : ((f = bez.getNewSegment(
                        v[n].v[i - 1],
                        v[n].v[0],
                        v[n].o[i - 1],
                        v[n].i[0],
                        (t.s - p) / g,
                        (t.e - p) / g,
                        l[i - 1],
                      )),
                      this.addSegmentFromArray(f, r, o, h),
                      (h = !1),
                      (r.c = !1));
                } else r.c = !1;
                (p += s.addedLength), (o += 1);
              }
              if (
                (r._length &&
                  (r.setXYAt(r.v[u][0], r.v[u][1], "i", u),
                  r.setXYAt(
                    r.v[r._length - 1][0],
                    r.v[r._length - 1][1],
                    "o",
                    r._length - 1,
                  )),
                p > t.e)
              )
                break;
              n < d - 1 &&
                ((r = shapePool.newElement()), (h = !0), m.push(r), (o = 0));
            }
            return m;
          }),
          extendPrototype([ShapeModifier], PuckerAndBloatModifier),
          (PuckerAndBloatModifier.prototype.initModifierProperties = function (
            e,
            t,
          ) {
            (this.getValue = this.processKeys),
              (this.amount = PropertyFactory.getProp(e, t.a, 0, null, this)),
              (this._isAnimated = !!this.amount.effectsSequence.length);
          }),
          (PuckerAndBloatModifier.prototype.processPath = function (e, t) {
            var r = t / 100,
              n = [0, 0],
              i = e._length,
              a = 0;
            for (a = 0; a < i; a += 1) (n[0] += e.v[a][0]), (n[1] += e.v[a][1]);
            (n[0] /= i), (n[1] /= i);
            var s,
              o,
              l,
              f,
              u,
              c,
              v = shapePool.newElement();
            for (v.c = e.c, a = 0; a < i; a += 1)
              (s = e.v[a][0] + (n[0] - e.v[a][0]) * r),
                (o = e.v[a][1] + (n[1] - e.v[a][1]) * r),
                (l = e.o[a][0] + (n[0] - e.o[a][0]) * -r),
                (f = e.o[a][1] + (n[1] - e.o[a][1]) * -r),
                (u = e.i[a][0] + (n[0] - e.i[a][0]) * -r),
                (c = e.i[a][1] + (n[1] - e.i[a][1]) * -r),
                v.setTripleAt(s, o, l, f, u, c, a);
            return v;
          }),
          (PuckerAndBloatModifier.prototype.processShapes = function (e) {
            var t,
              r,
              n,
              i,
              a,
              s,
              o = this.shapes.length,
              l = this.amount.v;
            if (l !== 0)
              for (r = 0; r < o; r += 1) {
                if (
                  ((s = (a = this.shapes[r]).localShapeCollection),
                  a.shape._mdf || this._mdf || e)
                )
                  for (
                    s.releaseShapes(),
                      a.shape._mdf = !0,
                      t = a.shape.paths.shapes,
                      i = a.shape.paths._length,
                      n = 0;
                    n < i;
                    n += 1
                  )
                    s.addShape(this.processPath(t[n], l));
                a.shape.paths = a.localShapeCollection;
              }
            this.dynamicProperties.length || (this._mdf = !1);
          });
        var TransformPropertyFactory = (function () {
          var e = [0, 0];
          function t(r, n, i) {
            if (
              ((this.elem = r),
              (this.frameId = -1),
              (this.propType = "transform"),
              (this.data = n),
              (this.v = new Matrix()),
              (this.pre = new Matrix()),
              (this.appliedTransformations = 0),
              this.initDynamicPropertyContainer(i || r),
              n.p && n.p.s
                ? ((this.px = PropertyFactory.getProp(r, n.p.x, 0, 0, this)),
                  (this.py = PropertyFactory.getProp(r, n.p.y, 0, 0, this)),
                  n.p.z &&
                    (this.pz = PropertyFactory.getProp(r, n.p.z, 0, 0, this)))
                : (this.p = PropertyFactory.getProp(
                    r,
                    n.p || { k: [0, 0, 0] },
                    1,
                    0,
                    this,
                  )),
              n.rx)
            ) {
              if (
                ((this.rx = PropertyFactory.getProp(
                  r,
                  n.rx,
                  0,
                  degToRads,
                  this,
                )),
                (this.ry = PropertyFactory.getProp(
                  r,
                  n.ry,
                  0,
                  degToRads,
                  this,
                )),
                (this.rz = PropertyFactory.getProp(
                  r,
                  n.rz,
                  0,
                  degToRads,
                  this,
                )),
                n.or.k[0].ti)
              ) {
                var a,
                  s = n.or.k.length;
                for (a = 0; a < s; a += 1)
                  (n.or.k[a].to = null), (n.or.k[a].ti = null);
              }
              (this.or = PropertyFactory.getProp(r, n.or, 1, degToRads, this)),
                (this.or.sh = !0);
            } else
              this.r = PropertyFactory.getProp(
                r,
                n.r || { k: 0 },
                0,
                degToRads,
                this,
              );
            n.sk &&
              ((this.sk = PropertyFactory.getProp(r, n.sk, 0, degToRads, this)),
              (this.sa = PropertyFactory.getProp(r, n.sa, 0, degToRads, this))),
              (this.a = PropertyFactory.getProp(
                r,
                n.a || { k: [0, 0, 0] },
                1,
                0,
                this,
              )),
              (this.s = PropertyFactory.getProp(
                r,
                n.s || { k: [100, 100, 100] },
                1,
                0.01,
                this,
              )),
              n.o
                ? (this.o = PropertyFactory.getProp(r, n.o, 0, 0.01, r))
                : (this.o = { _mdf: !1, v: 1 }),
              (this._isDirty = !0),
              this.dynamicProperties.length || this.getValue(!0);
          }
          return (
            (t.prototype = {
              applyToMatrix: function (r) {
                var n = this._mdf;
                this.iterateDynamicProperties(),
                  (this._mdf = this._mdf || n),
                  this.a &&
                    r.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                  this.s && r.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                  this.sk && r.skewFromAxis(-this.sk.v, this.sa.v),
                  this.r
                    ? r.rotate(-this.r.v)
                    : r
                        .rotateZ(-this.rz.v)
                        .rotateY(this.ry.v)
                        .rotateX(this.rx.v)
                        .rotateZ(-this.or.v[2])
                        .rotateY(this.or.v[1])
                        .rotateX(this.or.v[0]),
                  this.data.p.s
                    ? this.data.p.z
                      ? r.translate(this.px.v, this.py.v, -this.pz.v)
                      : r.translate(this.px.v, this.py.v, 0)
                    : r.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
              },
              getValue: function (r) {
                if (this.elem.globalData.frameId !== this.frameId) {
                  if (
                    (this._isDirty &&
                      (this.precalculateMatrix(), (this._isDirty = !1)),
                    this.iterateDynamicProperties(),
                    this._mdf || r)
                  ) {
                    var n;
                    if (
                      (this.v.cloneFromProps(this.pre.props),
                      this.appliedTransformations < 1 &&
                        this.v.translate(
                          -this.a.v[0],
                          -this.a.v[1],
                          this.a.v[2],
                        ),
                      this.appliedTransformations < 2 &&
                        this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                      this.sk &&
                        this.appliedTransformations < 3 &&
                        this.v.skewFromAxis(-this.sk.v, this.sa.v),
                      this.r && this.appliedTransformations < 4
                        ? this.v.rotate(-this.r.v)
                        : !this.r &&
                          this.appliedTransformations < 4 &&
                          this.v
                            .rotateZ(-this.rz.v)
                            .rotateY(this.ry.v)
                            .rotateX(this.rx.v)
                            .rotateZ(-this.or.v[2])
                            .rotateY(this.or.v[1])
                            .rotateX(this.or.v[0]),
                      this.autoOriented)
                    ) {
                      var i, a;
                      if (
                        ((n = this.elem.globalData.frameRate),
                        this.p && this.p.keyframes && this.p.getValueAtTime)
                      )
                        this.p._caching.lastFrame + this.p.offsetTime <=
                        this.p.keyframes[0].t
                          ? ((i = this.p.getValueAtTime(
                              (this.p.keyframes[0].t + 0.01) / n,
                              0,
                            )),
                            (a = this.p.getValueAtTime(
                              this.p.keyframes[0].t / n,
                              0,
                            )))
                          : this.p._caching.lastFrame + this.p.offsetTime >=
                              this.p.keyframes[this.p.keyframes.length - 1].t
                            ? ((i = this.p.getValueAtTime(
                                this.p.keyframes[this.p.keyframes.length - 1]
                                  .t / n,
                                0,
                              )),
                              (a = this.p.getValueAtTime(
                                (this.p.keyframes[this.p.keyframes.length - 1]
                                  .t -
                                  0.05) /
                                  n,
                                0,
                              )))
                            : ((i = this.p.pv),
                              (a = this.p.getValueAtTime(
                                (this.p._caching.lastFrame +
                                  this.p.offsetTime -
                                  0.01) /
                                  n,
                                this.p.offsetTime,
                              )));
                      else if (
                        this.px &&
                        this.px.keyframes &&
                        this.py.keyframes &&
                        this.px.getValueAtTime &&
                        this.py.getValueAtTime
                      ) {
                        (i = []), (a = []);
                        var s = this.px,
                          o = this.py;
                        s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t
                          ? ((i[0] = s.getValueAtTime(
                              (s.keyframes[0].t + 0.01) / n,
                              0,
                            )),
                            (i[1] = o.getValueAtTime(
                              (o.keyframes[0].t + 0.01) / n,
                              0,
                            )),
                            (a[0] = s.getValueAtTime(s.keyframes[0].t / n, 0)),
                            (a[1] = o.getValueAtTime(o.keyframes[0].t / n, 0)))
                          : s._caching.lastFrame + s.offsetTime >=
                              s.keyframes[s.keyframes.length - 1].t
                            ? ((i[0] = s.getValueAtTime(
                                s.keyframes[s.keyframes.length - 1].t / n,
                                0,
                              )),
                              (i[1] = o.getValueAtTime(
                                o.keyframes[o.keyframes.length - 1].t / n,
                                0,
                              )),
                              (a[0] = s.getValueAtTime(
                                (s.keyframes[s.keyframes.length - 1].t - 0.01) /
                                  n,
                                0,
                              )),
                              (a[1] = o.getValueAtTime(
                                (o.keyframes[o.keyframes.length - 1].t - 0.01) /
                                  n,
                                0,
                              )))
                            : ((i = [s.pv, o.pv]),
                              (a[0] = s.getValueAtTime(
                                (s._caching.lastFrame + s.offsetTime - 0.01) /
                                  n,
                                s.offsetTime,
                              )),
                              (a[1] = o.getValueAtTime(
                                (o._caching.lastFrame + o.offsetTime - 0.01) /
                                  n,
                                o.offsetTime,
                              )));
                      } else i = a = e;
                      this.v.rotate(-Math.atan2(i[1] - a[1], i[0] - a[0]));
                    }
                    this.data.p && this.data.p.s
                      ? this.data.p.z
                        ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                        : this.v.translate(this.px.v, this.py.v, 0)
                      : this.v.translate(
                          this.p.v[0],
                          this.p.v[1],
                          -this.p.v[2],
                        );
                  }
                  this.frameId = this.elem.globalData.frameId;
                }
              },
              precalculateMatrix: function () {
                if (
                  ((this.appliedTransformations = 0),
                  this.pre.reset(),
                  !this.a.effectsSequence.length &&
                    (this.pre.translate(
                      -this.a.v[0],
                      -this.a.v[1],
                      this.a.v[2],
                    ),
                    (this.appliedTransformations = 1),
                    !this.s.effectsSequence.length))
                ) {
                  if (
                    (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                    (this.appliedTransformations = 2),
                    this.sk)
                  ) {
                    if (
                      this.sk.effectsSequence.length ||
                      this.sa.effectsSequence.length
                    )
                      return;
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v),
                      (this.appliedTransformations = 3);
                  }
                  this.r
                    ? this.r.effectsSequence.length ||
                      (this.pre.rotate(-this.r.v),
                      (this.appliedTransformations = 4))
                    : this.rz.effectsSequence.length ||
                      this.ry.effectsSequence.length ||
                      this.rx.effectsSequence.length ||
                      this.or.effectsSequence.length ||
                      (this.pre
                        .rotateZ(-this.rz.v)
                        .rotateY(this.ry.v)
                        .rotateX(this.rx.v)
                        .rotateZ(-this.or.v[2])
                        .rotateY(this.or.v[1])
                        .rotateX(this.or.v[0]),
                      (this.appliedTransformations = 4));
                }
              },
              autoOrient: function () {},
            }),
            extendPrototype([DynamicPropertyContainer], t),
            (t.prototype.addDynamicProperty = function (r) {
              this._addDynamicProperty(r),
                this.elem.addDynamicProperty(r),
                (this._isDirty = !0);
            }),
            (t.prototype._addDynamicProperty =
              DynamicPropertyContainer.prototype.addDynamicProperty),
            {
              getTransformProperty: function (r, n, i) {
                return new t(r, n, i);
              },
            }
          );
        })();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(e, t) {
          return 1e5 * Math.abs(e - t) <= Math.min(Math.abs(e), Math.abs(t));
        }
        function floatZero(e) {
          return Math.abs(e) <= 1e-5;
        }
        function lerp(e, t, r) {
          return e * (1 - r) + t * r;
        }
        function lerpPoint(e, t, r) {
          return [lerp(e[0], t[0], r), lerp(e[1], t[1], r)];
        }
        function quadRoots(e, t, r) {
          if (e === 0) return [];
          var n = t * t - 4 * e * r;
          if (n < 0) return [];
          var i = -t / (2 * e);
          if (n === 0) return [i];
          var a = Math.sqrt(n) / (2 * e);
          return [i - a, i + a];
        }
        function polynomialCoefficients(e, t, r, n) {
          return [
            3 * t - e - 3 * r + n,
            3 * e - 6 * t + 3 * r,
            -3 * e + 3 * t,
            e,
          ];
        }
        function singlePoint(e) {
          return new PolynomialBezier(e, e, e, e, !1);
        }
        function PolynomialBezier(e, t, r, n, i) {
          i && pointEqual(e, t) && (t = lerpPoint(e, n, 1 / 3)),
            i && pointEqual(r, n) && (r = lerpPoint(e, n, 2 / 3));
          var a = polynomialCoefficients(e[0], t[0], r[0], n[0]),
            s = polynomialCoefficients(e[1], t[1], r[1], n[1]);
          (this.a = [a[0], s[0]]),
            (this.b = [a[1], s[1]]),
            (this.c = [a[2], s[2]]),
            (this.d = [a[3], s[3]]),
            (this.points = [e, t, r, n]);
        }
        function extrema(e, t) {
          var r = e.points[0][t],
            n = e.points[e.points.length - 1][t];
          if (r > n) {
            var i = n;
            (n = r), (r = i);
          }
          for (
            var a = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), s = 0;
            s < a.length;
            s += 1
          )
            if (a[s] > 0 && a[s] < 1) {
              var o = e.point(a[s])[t];
              o < r ? (r = o) : o > n && (n = o);
            }
          return { min: r, max: n };
        }
        function intersectData(e, t, r) {
          var n = e.boundingBox();
          return {
            cx: n.cx,
            cy: n.cy,
            width: n.width,
            height: n.height,
            bez: e,
            t: (t + r) / 2,
            t1: t,
            t2: r,
          };
        }
        function splitData(e) {
          var t = e.bez.split(0.5);
          return [
            intersectData(t[0], e.t1, e.t),
            intersectData(t[1], e.t, e.t2),
          ];
        }
        function boxIntersect(e, t) {
          return (
            2 * Math.abs(e.cx - t.cx) < e.width + t.width &&
            2 * Math.abs(e.cy - t.cy) < e.height + t.height
          );
        }
        function intersectsImpl(e, t, r, n, i, a) {
          if (boxIntersect(e, t))
            if (
              r >= a ||
              (e.width <= n && e.height <= n && t.width <= n && t.height <= n)
            )
              i.push([e.t, t.t]);
            else {
              var s = splitData(e),
                o = splitData(t);
              intersectsImpl(s[0], o[0], r + 1, n, i, a),
                intersectsImpl(s[0], o[1], r + 1, n, i, a),
                intersectsImpl(s[1], o[0], r + 1, n, i, a),
                intersectsImpl(s[1], o[1], r + 1, n, i, a);
            }
        }
        function crossProduct(e, t) {
          return [
            e[1] * t[2] - e[2] * t[1],
            e[2] * t[0] - e[0] * t[2],
            e[0] * t[1] - e[1] * t[0],
          ];
        }
        function lineIntersection(e, t, r, n) {
          var i = [e[0], e[1], 1],
            a = [t[0], t[1], 1],
            s = [r[0], r[1], 1],
            o = [n[0], n[1], 1],
            l = crossProduct(crossProduct(i, a), crossProduct(s, o));
          return floatZero(l[2]) ? null : [l[0] / l[2], l[1] / l[2]];
        }
        function polarOffset(e, t, r) {
          return [e[0] + Math.cos(t) * r, e[1] - Math.sin(t) * r];
        }
        function pointDistance(e, t) {
          return Math.hypot(e[0] - t[0], e[1] - t[1]);
        }
        function pointEqual(e, t) {
          return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
        }
        function ZigZagModifier() {}
        function setPoint(e, t, r, n, i, a, s) {
          var o = r - Math.PI / 2,
            l = r + Math.PI / 2,
            f = t[0] + Math.cos(r) * n * i,
            u = t[1] - Math.sin(r) * n * i;
          e.setTripleAt(
            f,
            u,
            f + Math.cos(o) * a,
            u - Math.sin(o) * a,
            f + Math.cos(l) * s,
            u - Math.sin(l) * s,
            e.length(),
          );
        }
        function getPerpendicularVector(e, t) {
          var r = [t[0] - e[0], t[1] - e[1]],
            n = 0.5 * -Math.PI;
          return [
            Math.cos(n) * r[0] - Math.sin(n) * r[1],
            Math.sin(n) * r[0] + Math.cos(n) * r[1],
          ];
        }
        function getProjectingAngle(e, t) {
          var r = t === 0 ? e.length() - 1 : t - 1,
            n = (t + 1) % e.length(),
            i = getPerpendicularVector(e.v[r], e.v[n]);
          return Math.atan2(0, 1) - Math.atan2(i[1], i[0]);
        }
        function zigZagCorner(e, t, r, n, i, a, s) {
          var o = getProjectingAngle(t, r),
            l = t.v[r % t._length],
            f = t.v[r === 0 ? t._length - 1 : r - 1],
            u = t.v[(r + 1) % t._length],
            c =
              a === 2
                ? Math.sqrt(Math.pow(l[0] - f[0], 2) + Math.pow(l[1] - f[1], 2))
                : 0,
            v =
              a === 2
                ? Math.sqrt(Math.pow(l[0] - u[0], 2) + Math.pow(l[1] - u[1], 2))
                : 0;
          setPoint(
            e,
            t.v[r % t._length],
            o,
            s,
            n,
            v / (2 * (i + 1)),
            c / (2 * (i + 1)),
            a,
          );
        }
        function zigZagSegment(e, t, r, n, i, a) {
          for (var s = 0; s < n; s += 1) {
            var o = (s + 1) / (n + 1),
              l =
                i === 2
                  ? Math.sqrt(
                      Math.pow(t.points[3][0] - t.points[0][0], 2) +
                        Math.pow(t.points[3][1] - t.points[0][1], 2),
                    )
                  : 0,
              f = t.normalAngle(o);
            setPoint(
              e,
              t.point(o),
              f,
              a,
              r,
              l / (2 * (n + 1)),
              l / (2 * (n + 1)),
              i,
            ),
              (a = -a);
          }
          return a;
        }
        function linearOffset(e, t, r) {
          var n = Math.atan2(t[0] - e[0], t[1] - e[1]);
          return [polarOffset(e, n, r), polarOffset(t, n, r)];
        }
        function offsetSegment(e, t) {
          var r, n, i, a, s, o, l;
          (r = (l = linearOffset(e.points[0], e.points[1], t))[0]),
            (n = l[1]),
            (i = (l = linearOffset(e.points[1], e.points[2], t))[0]),
            (a = l[1]),
            (s = (l = linearOffset(e.points[2], e.points[3], t))[0]),
            (o = l[1]);
          var f = lineIntersection(r, n, i, a);
          f === null && (f = n);
          var u = lineIntersection(s, o, i, a);
          return u === null && (u = s), new PolynomialBezier(r, f, u, o);
        }
        function joinLines(e, t, r, n, i) {
          var a = t.points[3],
            s = r.points[0];
          if (n === 3 || pointEqual(a, s)) return a;
          if (n === 2) {
            var o = -t.tangentAngle(1),
              l = -r.tangentAngle(0) + Math.PI,
              f = lineIntersection(
                a,
                polarOffset(a, o + Math.PI / 2, 100),
                s,
                polarOffset(s, o + Math.PI / 2, 100),
              ),
              u = f ? pointDistance(f, a) : pointDistance(a, s) / 2,
              c = polarOffset(a, o, 2 * u * roundCorner);
            return (
              e.setXYAt(c[0], c[1], "o", e.length() - 1),
              (c = polarOffset(s, l, 2 * u * roundCorner)),
              e.setTripleAt(s[0], s[1], s[0], s[1], c[0], c[1], e.length()),
              s
            );
          }
          var v = lineIntersection(
            pointEqual(a, t.points[2]) ? t.points[0] : t.points[2],
            a,
            s,
            pointEqual(s, r.points[1]) ? r.points[3] : r.points[1],
          );
          return v && pointDistance(v, a) < i
            ? (e.setTripleAt(v[0], v[1], v[0], v[1], v[0], v[1], e.length()), v)
            : a;
        }
        function getIntersection(e, t) {
          var r = e.intersections(t);
          return (
            r.length && floatEqual(r[0][0], 1) && r.shift(),
            r.length ? r[0] : null
          );
        }
        function pruneSegmentIntersection(e, t) {
          var r = e.slice(),
            n = t.slice(),
            i = getIntersection(e[e.length - 1], t[0]);
          return (
            i &&
              ((r[e.length - 1] = e[e.length - 1].split(i[0])[0]),
              (n[0] = t[0].split(i[1])[1])),
            e.length > 1 &&
            t.length > 1 &&
            (i = getIntersection(e[0], t[t.length - 1]))
              ? [[e[0].split(i[0])[0]], [t[t.length - 1].split(i[1])[1]]]
              : [r, n]
          );
        }
        function pruneIntersections(e) {
          for (var t, r = 1; r < e.length; r += 1)
            (t = pruneSegmentIntersection(e[r - 1], e[r])),
              (e[r - 1] = t[0]),
              (e[r] = t[1]);
          return (
            e.length > 1 &&
              ((t = pruneSegmentIntersection(e[e.length - 1], e[0])),
              (e[e.length - 1] = t[0]),
              (e[0] = t[1])),
            e
          );
        }
        function offsetSegmentSplit(e, t) {
          var r,
            n,
            i,
            a,
            s = e.inflectionPoints();
          if (s.length === 0) return [offsetSegment(e, t)];
          if (s.length === 1 || floatEqual(s[1], 1))
            return (
              (r = (i = e.split(s[0]))[0]),
              (n = i[1]),
              [offsetSegment(r, t), offsetSegment(n, t)]
            );
          r = (i = e.split(s[0]))[0];
          var o = (s[1] - s[0]) / (1 - s[0]);
          return (
            (a = (i = i[1].split(o))[0]),
            (n = i[1]),
            [offsetSegment(r, t), offsetSegment(a, t), offsetSegment(n, t)]
          );
        }
        function OffsetPathModifier() {}
        function getFontProperties(e) {
          for (
            var t = e.fStyle ? e.fStyle.split(" ") : [],
              r = "normal",
              n = "normal",
              i = t.length,
              a = 0;
            a < i;
            a += 1
          )
            switch (t[a].toLowerCase()) {
              case "italic":
                n = "italic";
                break;
              case "bold":
                r = "700";
                break;
              case "black":
                r = "900";
                break;
              case "medium":
                r = "500";
                break;
              case "regular":
              case "normal":
                r = "400";
                break;
              case "light":
              case "thin":
                r = "200";
            }
          return { style: n, weight: e.fWeight || r };
        }
        extendPrototype([ShapeModifier], RepeaterModifier),
          (RepeaterModifier.prototype.initModifierProperties = function (e, t) {
            (this.getValue = this.processKeys),
              (this.c = PropertyFactory.getProp(e, t.c, 0, null, this)),
              (this.o = PropertyFactory.getProp(e, t.o, 0, null, this)),
              (this.tr = TransformPropertyFactory.getTransformProperty(
                e,
                t.tr,
                this,
              )),
              (this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this)),
              (this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this)),
              (this.data = t),
              this.dynamicProperties.length || this.getValue(!0),
              (this._isAnimated = !!this.dynamicProperties.length),
              (this.pMatrix = new Matrix()),
              (this.rMatrix = new Matrix()),
              (this.sMatrix = new Matrix()),
              (this.tMatrix = new Matrix()),
              (this.matrix = new Matrix());
          }),
          (RepeaterModifier.prototype.applyTransforms = function (
            e,
            t,
            r,
            n,
            i,
            a,
          ) {
            var s = a ? -1 : 1,
              o = n.s.v[0] + (1 - n.s.v[0]) * (1 - i),
              l = n.s.v[1] + (1 - n.s.v[1]) * (1 - i);
            e.translate(n.p.v[0] * s * i, n.p.v[1] * s * i, n.p.v[2]),
              t.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]),
              t.rotate(-n.r.v * s * i),
              t.translate(n.a.v[0], n.a.v[1], n.a.v[2]),
              r.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]),
              r.scale(a ? 1 / o : o, a ? 1 / l : l),
              r.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
          }),
          (RepeaterModifier.prototype.init = function (e, t, r, n) {
            for (
              this.elem = e,
                this.arr = t,
                this.pos = r,
                this.elemsData = n,
                this._currentCopies = 0,
                this._elements = [],
                this._groups = [],
                this.frameId = -1,
                this.initDynamicPropertyContainer(e),
                this.initModifierProperties(e, t[r]);
              r > 0;

            )
              (r -= 1), this._elements.unshift(t[r]);
            this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
          }),
          (RepeaterModifier.prototype.resetElements = function (e) {
            var t,
              r = e.length;
            for (t = 0; t < r; t += 1)
              (e[t]._processed = !1),
                e[t].ty === "gr" && this.resetElements(e[t].it);
          }),
          (RepeaterModifier.prototype.cloneElements = function (e) {
            var t = JSON.parse(JSON.stringify(e));
            return this.resetElements(t), t;
          }),
          (RepeaterModifier.prototype.changeGroupRender = function (e, t) {
            var r,
              n = e.length;
            for (r = 0; r < n; r += 1)
              (e[r]._render = t),
                e[r].ty === "gr" && this.changeGroupRender(e[r].it, t);
          }),
          (RepeaterModifier.prototype.processShapes = function (e) {
            var t,
              r,
              n,
              i,
              a,
              s = !1;
            if (this._mdf || e) {
              var o,
                l = Math.ceil(this.c.v);
              if (this._groups.length < l) {
                for (; this._groups.length < l; ) {
                  var f = { it: this.cloneElements(this._elements), ty: "gr" };
                  f.it.push({
                    a: { a: 0, ix: 1, k: [0, 0] },
                    nm: "Transform",
                    o: { a: 0, ix: 7, k: 100 },
                    p: { a: 0, ix: 2, k: [0, 0] },
                    r: {
                      a: 1,
                      ix: 6,
                      k: [
                        { s: 0, e: 0, t: 0 },
                        { s: 0, e: 0, t: 1 },
                      ],
                    },
                    s: { a: 0, ix: 3, k: [100, 100] },
                    sa: { a: 0, ix: 5, k: 0 },
                    sk: { a: 0, ix: 4, k: 0 },
                    ty: "tr",
                  }),
                    this.arr.splice(0, 0, f),
                    this._groups.splice(0, 0, f),
                    (this._currentCopies += 1);
                }
                this.elem.reloadShapes(), (s = !0);
              }
              for (a = 0, n = 0; n <= this._groups.length - 1; n += 1) {
                if (
                  ((o = a < l),
                  (this._groups[n]._render = o),
                  this.changeGroupRender(this._groups[n].it, o),
                  !o)
                ) {
                  var u = this.elemsData[n].it,
                    c = u[u.length - 1];
                  c.transform.op.v !== 0
                    ? ((c.transform.op._mdf = !0), (c.transform.op.v = 0))
                    : (c.transform.op._mdf = !1);
                }
                a += 1;
              }
              this._currentCopies = l;
              var v = this.o.v,
                d = v % 1,
                p = v > 0 ? Math.floor(v) : Math.ceil(v),
                m = this.pMatrix.props,
                h = this.rMatrix.props,
                g = this.sMatrix.props;
              this.pMatrix.reset(),
                this.rMatrix.reset(),
                this.sMatrix.reset(),
                this.tMatrix.reset(),
                this.matrix.reset();
              var y,
                _,
                b = 0;
              if (v > 0) {
                for (; b < p; )
                  this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    1,
                    !1,
                  ),
                    (b += 1);
                d &&
                  (this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    d,
                    !1,
                  ),
                  (b += d));
              } else if (v < 0) {
                for (; b > p; )
                  this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    1,
                    !0,
                  ),
                    (b -= 1);
                d &&
                  (this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    -d,
                    !0,
                  ),
                  (b -= d));
              }
              for (
                n = this.data.m === 1 ? 0 : this._currentCopies - 1,
                  i = this.data.m === 1 ? 1 : -1,
                  a = this._currentCopies;
                a;

              ) {
                if (
                  ((_ = (r = (t = this.elemsData[n].it)[t.length - 1].transform
                    .mProps.v.props).length),
                  (t[t.length - 1].transform.mProps._mdf = !0),
                  (t[t.length - 1].transform.op._mdf = !0),
                  (t[t.length - 1].transform.op.v =
                    this._currentCopies === 1
                      ? this.so.v
                      : this.so.v +
                        (this.eo.v - this.so.v) *
                          (n / (this._currentCopies - 1))),
                  b !== 0)
                ) {
                  for (
                    ((n !== 0 && i === 1) ||
                      (n !== this._currentCopies - 1 && i === -1)) &&
                      this.applyTransforms(
                        this.pMatrix,
                        this.rMatrix,
                        this.sMatrix,
                        this.tr,
                        1,
                        !1,
                      ),
                      this.matrix.transform(
                        h[0],
                        h[1],
                        h[2],
                        h[3],
                        h[4],
                        h[5],
                        h[6],
                        h[7],
                        h[8],
                        h[9],
                        h[10],
                        h[11],
                        h[12],
                        h[13],
                        h[14],
                        h[15],
                      ),
                      this.matrix.transform(
                        g[0],
                        g[1],
                        g[2],
                        g[3],
                        g[4],
                        g[5],
                        g[6],
                        g[7],
                        g[8],
                        g[9],
                        g[10],
                        g[11],
                        g[12],
                        g[13],
                        g[14],
                        g[15],
                      ),
                      this.matrix.transform(
                        m[0],
                        m[1],
                        m[2],
                        m[3],
                        m[4],
                        m[5],
                        m[6],
                        m[7],
                        m[8],
                        m[9],
                        m[10],
                        m[11],
                        m[12],
                        m[13],
                        m[14],
                        m[15],
                      ),
                      y = 0;
                    y < _;
                    y += 1
                  )
                    r[y] = this.matrix.props[y];
                  this.matrix.reset();
                } else
                  for (this.matrix.reset(), y = 0; y < _; y += 1)
                    r[y] = this.matrix.props[y];
                (b += 1), (a -= 1), (n += i);
              }
            } else
              for (a = this._currentCopies, n = 0, i = 1; a; )
                (r = (t = this.elemsData[n].it)[t.length - 1].transform.mProps.v
                  .props),
                  (t[t.length - 1].transform.mProps._mdf = !1),
                  (t[t.length - 1].transform.op._mdf = !1),
                  (a -= 1),
                  (n += i);
            return s;
          }),
          (RepeaterModifier.prototype.addShape = function () {}),
          extendPrototype([ShapeModifier], RoundCornersModifier),
          (RoundCornersModifier.prototype.initModifierProperties = function (
            e,
            t,
          ) {
            (this.getValue = this.processKeys),
              (this.rd = PropertyFactory.getProp(e, t.r, 0, null, this)),
              (this._isAnimated = !!this.rd.effectsSequence.length);
          }),
          (RoundCornersModifier.prototype.processPath = function (e, t) {
            var r,
              n = shapePool.newElement();
            n.c = e.c;
            var i,
              a,
              s,
              o,
              l,
              f,
              u,
              c,
              v,
              d,
              p,
              m,
              h = e._length,
              g = 0;
            for (r = 0; r < h; r += 1)
              (i = e.v[r]),
                (s = e.o[r]),
                (a = e.i[r]),
                i[0] === s[0] && i[1] === s[1] && i[0] === a[0] && i[1] === a[1]
                  ? (r !== 0 && r !== h - 1) || e.c
                    ? ((o = r === 0 ? e.v[h - 1] : e.v[r - 1]),
                      (f = (l = Math.sqrt(
                        Math.pow(i[0] - o[0], 2) + Math.pow(i[1] - o[1], 2),
                      ))
                        ? Math.min(l / 2, t) / l
                        : 0),
                      (u = p = i[0] + (o[0] - i[0]) * f),
                      (c = m = i[1] - (i[1] - o[1]) * f),
                      (v = u - (u - i[0]) * roundCorner),
                      (d = c - (c - i[1]) * roundCorner),
                      n.setTripleAt(u, c, v, d, p, m, g),
                      (g += 1),
                      (o = r === h - 1 ? e.v[0] : e.v[r + 1]),
                      (f = (l = Math.sqrt(
                        Math.pow(i[0] - o[0], 2) + Math.pow(i[1] - o[1], 2),
                      ))
                        ? Math.min(l / 2, t) / l
                        : 0),
                      (u = v = i[0] + (o[0] - i[0]) * f),
                      (c = d = i[1] + (o[1] - i[1]) * f),
                      (p = u - (u - i[0]) * roundCorner),
                      (m = c - (c - i[1]) * roundCorner),
                      n.setTripleAt(u, c, v, d, p, m, g),
                      (g += 1))
                    : (n.setTripleAt(i[0], i[1], s[0], s[1], a[0], a[1], g),
                      (g += 1))
                  : (n.setTripleAt(
                      e.v[r][0],
                      e.v[r][1],
                      e.o[r][0],
                      e.o[r][1],
                      e.i[r][0],
                      e.i[r][1],
                      g,
                    ),
                    (g += 1));
            return n;
          }),
          (RoundCornersModifier.prototype.processShapes = function (e) {
            var t,
              r,
              n,
              i,
              a,
              s,
              o = this.shapes.length,
              l = this.rd.v;
            if (l !== 0)
              for (r = 0; r < o; r += 1) {
                if (
                  ((s = (a = this.shapes[r]).localShapeCollection),
                  a.shape._mdf || this._mdf || e)
                )
                  for (
                    s.releaseShapes(),
                      a.shape._mdf = !0,
                      t = a.shape.paths.shapes,
                      i = a.shape.paths._length,
                      n = 0;
                    n < i;
                    n += 1
                  )
                    s.addShape(this.processPath(t[n], l));
                a.shape.paths = a.localShapeCollection;
              }
            this.dynamicProperties.length || (this._mdf = !1);
          }),
          (PolynomialBezier.prototype.point = function (e) {
            return [
              ((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0],
              ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1],
            ];
          }),
          (PolynomialBezier.prototype.derivative = function (e) {
            return [
              (3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0],
              (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1],
            ];
          }),
          (PolynomialBezier.prototype.tangentAngle = function (e) {
            var t = this.derivative(e);
            return Math.atan2(t[1], t[0]);
          }),
          (PolynomialBezier.prototype.normalAngle = function (e) {
            var t = this.derivative(e);
            return Math.atan2(t[0], t[1]);
          }),
          (PolynomialBezier.prototype.inflectionPoints = function () {
            var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(e)) return [];
            var t =
                (-0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1])) / e,
              r =
                t * t -
                ((1 / 3) * (this.b[1] * this.c[0] - this.b[0] * this.c[1])) / e;
            if (r < 0) return [];
            var n = Math.sqrt(r);
            return floatZero(n)
              ? n > 0 && n < 1
                ? [t]
                : []
              : [t - n, t + n].filter(function (i) {
                  return i > 0 && i < 1;
                });
          }),
          (PolynomialBezier.prototype.split = function (e) {
            if (e <= 0) return [singlePoint(this.points[0]), this];
            if (e >= 1)
              return [this, singlePoint(this.points[this.points.length - 1])];
            var t = lerpPoint(this.points[0], this.points[1], e),
              r = lerpPoint(this.points[1], this.points[2], e),
              n = lerpPoint(this.points[2], this.points[3], e),
              i = lerpPoint(t, r, e),
              a = lerpPoint(r, n, e),
              s = lerpPoint(i, a, e);
            return [
              new PolynomialBezier(this.points[0], t, i, s, !0),
              new PolynomialBezier(s, a, n, this.points[3], !0),
            ];
          }),
          (PolynomialBezier.prototype.bounds = function () {
            return { x: extrema(this, 0), y: extrema(this, 1) };
          }),
          (PolynomialBezier.prototype.boundingBox = function () {
            var e = this.bounds();
            return {
              left: e.x.min,
              right: e.x.max,
              top: e.y.min,
              bottom: e.y.max,
              width: e.x.max - e.x.min,
              height: e.y.max - e.y.min,
              cx: (e.x.max + e.x.min) / 2,
              cy: (e.y.max + e.y.min) / 2,
            };
          }),
          (PolynomialBezier.prototype.intersections = function (e, t, r) {
            t === void 0 && (t = 2), r === void 0 && (r = 7);
            var n = [];
            return (
              intersectsImpl(
                intersectData(this, 0, 1),
                intersectData(e, 0, 1),
                0,
                t,
                n,
                r,
              ),
              n
            );
          }),
          (PolynomialBezier.shapeSegment = function (e, t) {
            var r = (t + 1) % e.length();
            return new PolynomialBezier(e.v[t], e.o[t], e.i[r], e.v[r], !0);
          }),
          (PolynomialBezier.shapeSegmentInverted = function (e, t) {
            var r = (t + 1) % e.length();
            return new PolynomialBezier(e.v[r], e.i[r], e.o[t], e.v[t], !0);
          }),
          extendPrototype([ShapeModifier], ZigZagModifier),
          (ZigZagModifier.prototype.initModifierProperties = function (e, t) {
            (this.getValue = this.processKeys),
              (this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this)),
              (this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this)),
              (this.pointsType = PropertyFactory.getProp(
                e,
                t.pt,
                0,
                null,
                this,
              )),
              (this._isAnimated =
                this.amplitude.effectsSequence.length !== 0 ||
                this.frequency.effectsSequence.length !== 0 ||
                this.pointsType.effectsSequence.length !== 0);
          }),
          (ZigZagModifier.prototype.processPath = function (e, t, r, n) {
            var i = e._length,
              a = shapePool.newElement();
            if (((a.c = e.c), e.c || (i -= 1), i === 0)) return a;
            var s = -1,
              o = PolynomialBezier.shapeSegment(e, 0);
            zigZagCorner(a, e, 0, t, r, n, s);
            for (var l = 0; l < i; l += 1)
              (s = zigZagSegment(a, o, t, r, n, -s)),
                (o =
                  l !== i - 1 || e.c
                    ? PolynomialBezier.shapeSegment(e, (l + 1) % i)
                    : null),
                zigZagCorner(a, e, l + 1, t, r, n, s);
            return a;
          }),
          (ZigZagModifier.prototype.processShapes = function (e) {
            var t,
              r,
              n,
              i,
              a,
              s,
              o = this.shapes.length,
              l = this.amplitude.v,
              f = Math.max(0, Math.round(this.frequency.v)),
              u = this.pointsType.v;
            if (l !== 0)
              for (r = 0; r < o; r += 1) {
                if (
                  ((s = (a = this.shapes[r]).localShapeCollection),
                  a.shape._mdf || this._mdf || e)
                )
                  for (
                    s.releaseShapes(),
                      a.shape._mdf = !0,
                      t = a.shape.paths.shapes,
                      i = a.shape.paths._length,
                      n = 0;
                    n < i;
                    n += 1
                  )
                    s.addShape(this.processPath(t[n], l, f, u));
                a.shape.paths = a.localShapeCollection;
              }
            this.dynamicProperties.length || (this._mdf = !1);
          }),
          extendPrototype([ShapeModifier], OffsetPathModifier),
          (OffsetPathModifier.prototype.initModifierProperties = function (
            e,
            t,
          ) {
            (this.getValue = this.processKeys),
              (this.amount = PropertyFactory.getProp(e, t.a, 0, null, this)),
              (this.miterLimit = PropertyFactory.getProp(
                e,
                t.ml,
                0,
                null,
                this,
              )),
              (this.lineJoin = t.lj),
              (this._isAnimated = this.amount.effectsSequence.length !== 0);
          }),
          (OffsetPathModifier.prototype.processPath = function (e, t, r, n) {
            var i = shapePool.newElement();
            i.c = e.c;
            var a,
              s,
              o,
              l = e.length();
            e.c || (l -= 1);
            var f = [];
            for (a = 0; a < l; a += 1)
              (o = PolynomialBezier.shapeSegment(e, a)),
                f.push(offsetSegmentSplit(o, t));
            if (!e.c)
              for (a = l - 1; a >= 0; a -= 1)
                (o = PolynomialBezier.shapeSegmentInverted(e, a)),
                  f.push(offsetSegmentSplit(o, t));
            f = pruneIntersections(f);
            var u = null,
              c = null;
            for (a = 0; a < f.length; a += 1) {
              var v = f[a];
              for (
                c && (u = joinLines(i, c, v[0], r, n)),
                  c = v[v.length - 1],
                  s = 0;
                s < v.length;
                s += 1
              )
                (o = v[s]),
                  u && pointEqual(o.points[0], u)
                    ? i.setXYAt(
                        o.points[1][0],
                        o.points[1][1],
                        "o",
                        i.length() - 1,
                      )
                    : i.setTripleAt(
                        o.points[0][0],
                        o.points[0][1],
                        o.points[1][0],
                        o.points[1][1],
                        o.points[0][0],
                        o.points[0][1],
                        i.length(),
                      ),
                  i.setTripleAt(
                    o.points[3][0],
                    o.points[3][1],
                    o.points[3][0],
                    o.points[3][1],
                    o.points[2][0],
                    o.points[2][1],
                    i.length(),
                  ),
                  (u = o.points[3]);
            }
            return f.length && joinLines(i, c, f[0][0], r, n), i;
          }),
          (OffsetPathModifier.prototype.processShapes = function (e) {
            var t,
              r,
              n,
              i,
              a,
              s,
              o = this.shapes.length,
              l = this.amount.v,
              f = this.miterLimit.v,
              u = this.lineJoin;
            if (l !== 0)
              for (r = 0; r < o; r += 1) {
                if (
                  ((s = (a = this.shapes[r]).localShapeCollection),
                  a.shape._mdf || this._mdf || e)
                )
                  for (
                    s.releaseShapes(),
                      a.shape._mdf = !0,
                      t = a.shape.paths.shapes,
                      i = a.shape.paths._length,
                      n = 0;
                    n < i;
                    n += 1
                  )
                    s.addShape(this.processPath(t[n], l, u, f));
                a.shape.paths = a.localShapeCollection;
              }
            this.dynamicProperties.length || (this._mdf = !1);
          });
        var FontManager = (function () {
          var e = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
            t = [];
          t = t.concat([
            2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368,
            2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379,
            2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403,
          ]);
          var r = 127988,
            n = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
          function i(u, c) {
            var v = createTag("span");
            v.setAttribute("aria-hidden", !0), (v.style.fontFamily = c);
            var d = createTag("span");
            (d.innerText = "giItT1WQy@!-/#"),
              (v.style.position = "absolute"),
              (v.style.left = "-10000px"),
              (v.style.top = "-10000px"),
              (v.style.fontSize = "300px"),
              (v.style.fontVariant = "normal"),
              (v.style.fontStyle = "normal"),
              (v.style.fontWeight = "normal"),
              (v.style.letterSpacing = "0"),
              v.appendChild(d),
              document.body.appendChild(v);
            var p = d.offsetWidth;
            return (
              (d.style.fontFamily =
                (function (m) {
                  var h,
                    g = m.split(","),
                    y = g.length,
                    _ = [];
                  for (h = 0; h < y; h += 1)
                    g[h] !== "sans-serif" &&
                      g[h] !== "monospace" &&
                      _.push(g[h]);
                  return _.join(",");
                })(u) +
                ", " +
                c),
              { node: d, w: p, parent: v }
            );
          }
          function a(u, c) {
            var v,
              d = document.body && c ? "svg" : "canvas",
              p = getFontProperties(u);
            if (d === "svg") {
              var m = createNS("text");
              (m.style.fontSize = "100px"),
                m.setAttribute("font-family", u.fFamily),
                m.setAttribute("font-style", p.style),
                m.setAttribute("font-weight", p.weight),
                (m.textContent = "1"),
                u.fClass
                  ? ((m.style.fontFamily = "inherit"),
                    m.setAttribute("class", u.fClass))
                  : (m.style.fontFamily = u.fFamily),
                c.appendChild(m),
                (v = m);
            } else {
              var h = new OffscreenCanvas(500, 500).getContext("2d");
              (h.font = p.style + " " + p.weight + " 100px " + u.fFamily),
                (v = h);
            }
            return {
              measureText: function (g) {
                return d === "svg"
                  ? ((v.textContent = g), v.getComputedTextLength())
                  : v.measureText(g).width;
              },
            };
          }
          function s(u) {
            var c = 0,
              v = u.charCodeAt(0);
            if (v >= 55296 && v <= 56319) {
              var d = u.charCodeAt(1);
              d >= 56320 &&
                d <= 57343 &&
                (c = 1024 * (v - 55296) + d - 56320 + 65536);
            }
            return c;
          }
          function o(u) {
            var c = s(u);
            return c >= 127462 && c <= 127487;
          }
          var l = function () {
            (this.fonts = []),
              (this.chars = null),
              (this.typekitLoaded = 0),
              (this.isLoaded = !1),
              (this._warned = !1),
              (this.initTime = Date.now()),
              (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
              (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
          };
          (l.isModifier = function (u, c) {
            var v = u.toString(16) + c.toString(16);
            return n.indexOf(v) !== -1;
          }),
            (l.isZeroWidthJoiner = function (u) {
              return u === 8205;
            }),
            (l.isFlagEmoji = function (u) {
              return o(u.substr(0, 2)) && o(u.substr(2, 2));
            }),
            (l.isRegionalCode = o),
            (l.isCombinedCharacter = function (u) {
              return t.indexOf(u) !== -1;
            }),
            (l.isRegionalFlag = function (u, c) {
              var v = s(u.substr(c, 2));
              if (v !== r) return !1;
              var d = 0;
              for (c += 2; d < 5; ) {
                if ((v = s(u.substr(c, 2))) < 917601 || v > 917626) return !1;
                (d += 1), (c += 2);
              }
              return s(u.substr(c, 2)) === 917631;
            }),
            (l.isVariationSelector = function (u) {
              return u === 65039;
            }),
            (l.BLACK_FLAG_CODE_POINT = r);
          var f = {
            addChars: function (u) {
              if (u) {
                var c;
                this.chars || (this.chars = []);
                var v,
                  d,
                  p = u.length,
                  m = this.chars.length;
                for (c = 0; c < p; c += 1) {
                  for (v = 0, d = !1; v < m; )
                    this.chars[v].style === u[c].style &&
                      this.chars[v].fFamily === u[c].fFamily &&
                      this.chars[v].ch === u[c].ch &&
                      (d = !0),
                      (v += 1);
                  d || (this.chars.push(u[c]), (m += 1));
                }
              }
            },
            addFonts: function (u, c) {
              if (u) {
                if (this.chars)
                  return (this.isLoaded = !0), void (this.fonts = u.list);
                if (!document.body)
                  return (
                    (this.isLoaded = !0),
                    u.list.forEach(function (P) {
                      (P.helper = a(P)), (P.cache = {});
                    }),
                    void (this.fonts = u.list)
                  );
                var v,
                  d = u.list,
                  p = d.length,
                  m = p;
                for (v = 0; v < p; v += 1) {
                  var h,
                    g,
                    y = !0;
                  if (
                    ((d[v].loaded = !1),
                    (d[v].monoCase = i(d[v].fFamily, "monospace")),
                    (d[v].sansCase = i(d[v].fFamily, "sans-serif")),
                    d[v].fPath)
                  ) {
                    if (d[v].fOrigin === "p" || d[v].origin === 3) {
                      if (
                        ((h = document.querySelectorAll(
                          'style[f-forigin="p"][f-family="' +
                            d[v].fFamily +
                            '"], style[f-origin="3"][f-family="' +
                            d[v].fFamily +
                            '"]',
                        )).length > 0 && (y = !1),
                        y)
                      ) {
                        var _ = createTag("style");
                        _.setAttribute("f-forigin", d[v].fOrigin),
                          _.setAttribute("f-origin", d[v].origin),
                          _.setAttribute("f-family", d[v].fFamily),
                          (_.type = "text/css"),
                          (_.innerText =
                            "@font-face {font-family: " +
                            d[v].fFamily +
                            "; font-style: normal; src: url('" +
                            d[v].fPath +
                            "');}"),
                          c.appendChild(_);
                      }
                    } else if (d[v].fOrigin === "g" || d[v].origin === 1) {
                      for (
                        h = document.querySelectorAll(
                          'link[f-forigin="g"], link[f-origin="1"]',
                        ),
                          g = 0;
                        g < h.length;
                        g += 1
                      )
                        h[g].href.indexOf(d[v].fPath) !== -1 && (y = !1);
                      if (y) {
                        var b = createTag("link");
                        b.setAttribute("f-forigin", d[v].fOrigin),
                          b.setAttribute("f-origin", d[v].origin),
                          (b.type = "text/css"),
                          (b.rel = "stylesheet"),
                          (b.href = d[v].fPath),
                          document.body.appendChild(b);
                      }
                    } else if (d[v].fOrigin === "t" || d[v].origin === 2) {
                      for (
                        h = document.querySelectorAll(
                          'script[f-forigin="t"], script[f-origin="2"]',
                        ),
                          g = 0;
                        g < h.length;
                        g += 1
                      )
                        d[v].fPath === h[g].src && (y = !1);
                      if (y) {
                        var I = createTag("link");
                        I.setAttribute("f-forigin", d[v].fOrigin),
                          I.setAttribute("f-origin", d[v].origin),
                          I.setAttribute("rel", "stylesheet"),
                          I.setAttribute("href", d[v].fPath),
                          c.appendChild(I);
                      }
                    }
                  } else (d[v].loaded = !0), (m -= 1);
                  (d[v].helper = a(d[v], c)),
                    (d[v].cache = {}),
                    this.fonts.push(d[v]);
                }
                m === 0
                  ? (this.isLoaded = !0)
                  : setTimeout(this.checkLoadedFonts.bind(this), 100);
              } else this.isLoaded = !0;
            },
            getCharData: function (u, c, v) {
              for (var d = 0, p = this.chars.length; d < p; ) {
                if (
                  this.chars[d].ch === u &&
                  this.chars[d].style === c &&
                  this.chars[d].fFamily === v
                )
                  return this.chars[d];
                d += 1;
              }
              return (
                ((typeof u == "string" && u.charCodeAt(0) !== 13) || !u) &&
                  console &&
                  console.warn &&
                  !this._warned &&
                  ((this._warned = !0),
                  console.warn(
                    "Missing character from exported characters list: ",
                    u,
                    c,
                    v,
                  )),
                e
              );
            },
            getFontByName: function (u) {
              for (var c = 0, v = this.fonts.length; c < v; ) {
                if (this.fonts[c].fName === u) return this.fonts[c];
                c += 1;
              }
              return this.fonts[0];
            },
            measureText: function (u, c, v) {
              var d = this.getFontByName(c),
                p = u;
              if (!d.cache[p]) {
                var m = d.helper;
                if (u === " ") {
                  var h = m.measureText("|" + u + "|"),
                    g = m.measureText("||");
                  d.cache[p] = (h - g) / 100;
                } else d.cache[p] = m.measureText(u) / 100;
              }
              return d.cache[p] * v;
            },
            checkLoadedFonts: function () {
              var u,
                c,
                v,
                d = this.fonts.length,
                p = d;
              for (u = 0; u < d; u += 1)
                this.fonts[u].loaded
                  ? (p -= 1)
                  : this.fonts[u].fOrigin === "n" || this.fonts[u].origin === 0
                    ? (this.fonts[u].loaded = !0)
                    : ((c = this.fonts[u].monoCase.node),
                      (v = this.fonts[u].monoCase.w),
                      c.offsetWidth !== v
                        ? ((p -= 1), (this.fonts[u].loaded = !0))
                        : ((c = this.fonts[u].sansCase.node),
                          (v = this.fonts[u].sansCase.w),
                          c.offsetWidth !== v &&
                            ((p -= 1), (this.fonts[u].loaded = !0))),
                      this.fonts[u].loaded &&
                        (this.fonts[u].sansCase.parent.parentNode.removeChild(
                          this.fonts[u].sansCase.parent,
                        ),
                        this.fonts[u].monoCase.parent.parentNode.removeChild(
                          this.fonts[u].monoCase.parent,
                        )));
              p !== 0 && Date.now() - this.initTime < 5e3
                ? setTimeout(this.checkLoadedFontsBinded, 20)
                : setTimeout(this.setIsLoadedBinded, 10);
            },
            setIsLoaded: function () {
              this.isLoaded = !0;
            },
          };
          return (l.prototype = f), l;
        })();
        function SlotManager(e) {
          this.animationData = e;
        }
        function slotFactory(e) {
          return new SlotManager(e);
        }
        function RenderableElement() {}
        (SlotManager.prototype.getProp = function (e) {
          return this.animationData.slots && this.animationData.slots[e.sid]
            ? Object.assign(e, this.animationData.slots[e.sid].p)
            : e;
        }),
          (RenderableElement.prototype = {
            initRenderable: function () {
              (this.isInRange = !1),
                (this.hidden = !1),
                (this.isTransparent = !1),
                (this.renderableComponents = []);
            },
            addRenderableComponent: function (e) {
              this.renderableComponents.indexOf(e) === -1 &&
                this.renderableComponents.push(e);
            },
            removeRenderableComponent: function (e) {
              this.renderableComponents.indexOf(e) !== -1 &&
                this.renderableComponents.splice(
                  this.renderableComponents.indexOf(e),
                  1,
                );
            },
            prepareRenderableFrame: function (e) {
              this.checkLayerLimits(e);
            },
            checkTransparency: function () {
              this.finalTransform.mProp.o.v <= 0
                ? !this.isTransparent &&
                  this.globalData.renderConfig.hideOnTransparent &&
                  ((this.isTransparent = !0), this.hide())
                : this.isTransparent &&
                  ((this.isTransparent = !1), this.show());
            },
            checkLayerLimits: function (e) {
              this.data.ip - this.data.st <= e &&
              this.data.op - this.data.st > e
                ? this.isInRange !== !0 &&
                  ((this.globalData._mdf = !0),
                  (this._mdf = !0),
                  (this.isInRange = !0),
                  this.show())
                : this.isInRange !== !1 &&
                  ((this.globalData._mdf = !0),
                  (this.isInRange = !1),
                  this.hide());
            },
            renderRenderable: function () {
              var e,
                t = this.renderableComponents.length;
              for (e = 0; e < t; e += 1)
                this.renderableComponents[e].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function () {
              return { top: 0, left: 0, width: 100, height: 100 };
            },
            getLayerSize: function () {
              return this.data.ty === 5
                ? { w: this.data.textData.width, h: this.data.textData.height }
                : { w: this.data.width, h: this.data.height };
            },
          });
        var getBlendMode =
            ((blendModeEnums = {
              0: "source-over",
              1: "multiply",
              2: "screen",
              3: "overlay",
              4: "darken",
              5: "lighten",
              6: "color-dodge",
              7: "color-burn",
              8: "hard-light",
              9: "soft-light",
              10: "difference",
              11: "exclusion",
              12: "hue",
              13: "saturation",
              14: "color",
              15: "luminosity",
            }),
            function (e) {
              return blendModeEnums[e] || "";
            }),
          blendModeEnums;
        function SliderEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
        }
        function AngleEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
        }
        function ColorEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
        }
        function PointEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
        }
        function LayerIndexEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
        }
        function MaskIndexEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
        }
        function CheckboxEffect(e, t, r) {
          this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
        }
        function NoValueEffect() {
          this.p = {};
        }
        function EffectsManager(e, t) {
          var r,
            n = e.ef || [];
          this.effectElements = [];
          var i,
            a = n.length;
          for (r = 0; r < a; r += 1)
            (i = new GroupEffect(n[r], t)), this.effectElements.push(i);
        }
        function GroupEffect(e, t) {
          this.init(e, t);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(e, t, r) {
          this.initFrame(),
            this.initRenderable(),
            (this.assetData = t.getAssetData(e.refId)),
            (this.footageData = t.imageLoader.getAsset(this.assetData)),
            this.initBaseData(e, t, r);
        }
        function AudioElement(e, t, r) {
          this.initFrame(),
            this.initRenderable(),
            (this.assetData = t.getAssetData(e.refId)),
            this.initBaseData(e, t, r),
            (this._isPlaying = !1),
            (this._canPlay = !1);
          var n = this.globalData.getAssetsPath(this.assetData);
          (this.audio = this.globalData.audioController.createAudio(n)),
            (this._currentTime = 0),
            this.globalData.audioController.addAudio(this),
            (this._volumeMultiplier = 1),
            (this._volume = 1),
            (this._previousVolume = null),
            (this.tm = e.tm
              ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this)
              : { _placeholder: !0 }),
            (this.lv = PropertyFactory.getProp(
              this,
              e.au && e.au.lv ? e.au.lv : { k: [100] },
              1,
              0.01,
              this,
            ));
        }
        function BaseRenderer() {}
        extendPrototype([DynamicPropertyContainer], GroupEffect),
          (GroupEffect.prototype.getValue =
            GroupEffect.prototype.iterateDynamicProperties),
          (GroupEffect.prototype.init = function (e, t) {
            var r;
            (this.data = e),
              (this.effectElements = []),
              this.initDynamicPropertyContainer(t);
            var n,
              i = this.data.ef.length,
              a = this.data.ef;
            for (r = 0; r < i; r += 1) {
              switch (((n = null), a[r].ty)) {
                case 0:
                  n = new SliderEffect(a[r], t, this);
                  break;
                case 1:
                  n = new AngleEffect(a[r], t, this);
                  break;
                case 2:
                  n = new ColorEffect(a[r], t, this);
                  break;
                case 3:
                  n = new PointEffect(a[r], t, this);
                  break;
                case 4:
                case 7:
                  n = new CheckboxEffect(a[r], t, this);
                  break;
                case 10:
                  n = new LayerIndexEffect(a[r], t, this);
                  break;
                case 11:
                  n = new MaskIndexEffect(a[r], t, this);
                  break;
                case 5:
                  n = new EffectsManager(a[r], t, this);
                  break;
                default:
                  n = new NoValueEffect(a[r], t, this);
              }
              n && this.effectElements.push(n);
            }
          }),
          (BaseElement.prototype = {
            checkMasks: function () {
              if (!this.data.hasMask) return !1;
              for (var e = 0, t = this.data.masksProperties.length; e < t; ) {
                if (
                  this.data.masksProperties[e].mode !== "n" &&
                  this.data.masksProperties[e].cl !== !1
                )
                  return !0;
                e += 1;
              }
              return !1;
            },
            initExpressions: function () {
              var e = getExpressionInterfaces();
              if (e) {
                var t = e("layer"),
                  r = e("effects"),
                  n = e("shape"),
                  i = e("text"),
                  a = e("comp");
                (this.layerInterface = t(this)),
                  this.data.hasMask &&
                    this.maskManager &&
                    this.layerInterface.registerMaskInterface(this.maskManager);
                var s = r.createEffectsInterface(this, this.layerInterface);
                this.layerInterface.registerEffectsInterface(s),
                  this.data.ty === 0 || this.data.xt
                    ? (this.compInterface = a(this))
                    : this.data.ty === 4
                      ? ((this.layerInterface.shapeInterface = n(
                          this.shapesData,
                          this.itemsData,
                          this.layerInterface,
                        )),
                        (this.layerInterface.content =
                          this.layerInterface.shapeInterface))
                      : this.data.ty === 5 &&
                        ((this.layerInterface.textInterface = i(this)),
                        (this.layerInterface.text =
                          this.layerInterface.textInterface));
              }
            },
            setBlendMode: function () {
              var e = getBlendMode(this.data.bm);
              (this.baseElement || this.layerElement).style["mix-blend-mode"] =
                e;
            },
            initBaseData: function (e, t, r) {
              (this.globalData = t),
                (this.comp = r),
                (this.data = e),
                (this.layerId = createElementID()),
                this.data.sr || (this.data.sr = 1),
                (this.effectsManager = new EffectsManager(
                  this.data,
                  this,
                  this.dynamicProperties,
                ));
            },
            getType: function () {
              return this.type;
            },
            sourceRectAtTime: function () {},
          }),
          (FrameElement.prototype = {
            initFrame: function () {
              (this._isFirstFrame = !1),
                (this.dynamicProperties = []),
                (this._mdf = !1);
            },
            prepareProperties: function (e, t) {
              var r,
                n = this.dynamicProperties.length;
              for (r = 0; r < n; r += 1)
                (t ||
                  (this._isParent &&
                    this.dynamicProperties[r].propType === "transform")) &&
                  (this.dynamicProperties[r].getValue(),
                  this.dynamicProperties[r]._mdf &&
                    ((this.globalData._mdf = !0), (this._mdf = !0)));
            },
            addDynamicProperty: function (e) {
              this.dynamicProperties.indexOf(e) === -1 &&
                this.dynamicProperties.push(e);
            },
          }),
          (FootageElement.prototype.prepareFrame = function () {}),
          extendPrototype(
            [RenderableElement, BaseElement, FrameElement],
            FootageElement,
          ),
          (FootageElement.prototype.getBaseElement = function () {
            return null;
          }),
          (FootageElement.prototype.renderFrame = function () {}),
          (FootageElement.prototype.destroy = function () {}),
          (FootageElement.prototype.initExpressions = function () {
            var e = getExpressionInterfaces();
            if (e) {
              var t = e("footage");
              this.layerInterface = t(this);
            }
          }),
          (FootageElement.prototype.getFootageData = function () {
            return this.footageData;
          }),
          (AudioElement.prototype.prepareFrame = function (e) {
            if (
              (this.prepareRenderableFrame(e, !0),
              this.prepareProperties(e, !0),
              this.tm._placeholder)
            )
              this._currentTime = e / this.data.sr;
            else {
              var t = this.tm.v;
              this._currentTime = t;
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r &&
              ((this._previousVolume = r), this.audio.volume(r));
          }),
          extendPrototype(
            [RenderableElement, BaseElement, FrameElement],
            AudioElement,
          ),
          (AudioElement.prototype.renderFrame = function () {
            this.isInRange &&
              this._canPlay &&
              (this._isPlaying
                ? (!this.audio.playing() ||
                    Math.abs(
                      this._currentTime / this.globalData.frameRate -
                        this.audio.seek(),
                    ) > 0.1) &&
                  this.audio.seek(this._currentTime / this.globalData.frameRate)
                : (this.audio.play(),
                  this.audio.seek(
                    this._currentTime / this.globalData.frameRate,
                  ),
                  (this._isPlaying = !0)));
          }),
          (AudioElement.prototype.show = function () {}),
          (AudioElement.prototype.hide = function () {
            this.audio.pause(), (this._isPlaying = !1);
          }),
          (AudioElement.prototype.pause = function () {
            this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
          }),
          (AudioElement.prototype.resume = function () {
            this._canPlay = !0;
          }),
          (AudioElement.prototype.setRate = function (e) {
            this.audio.rate(e);
          }),
          (AudioElement.prototype.volume = function (e) {
            (this._volumeMultiplier = e),
              (this._previousVolume = e * this._volume),
              this.audio.volume(this._previousVolume);
          }),
          (AudioElement.prototype.getBaseElement = function () {
            return null;
          }),
          (AudioElement.prototype.destroy = function () {}),
          (AudioElement.prototype.sourceRectAtTime = function () {}),
          (AudioElement.prototype.initExpressions = function () {}),
          (BaseRenderer.prototype.checkLayers = function (e) {
            var t,
              r,
              n = this.layers.length;
            for (this.completeLayers = !0, t = n - 1; t >= 0; t -= 1)
              this.elements[t] ||
                ((r = this.layers[t]).ip - r.st <= e - this.layers[t].st &&
                  r.op - r.st > e - this.layers[t].st &&
                  this.buildItem(t)),
                (this.completeLayers =
                  !!this.elements[t] && this.completeLayers);
            this.checkPendingElements();
          }),
          (BaseRenderer.prototype.createItem = function (e) {
            switch (e.ty) {
              case 2:
                return this.createImage(e);
              case 0:
                return this.createComp(e);
              case 1:
                return this.createSolid(e);
              case 3:
              default:
                return this.createNull(e);
              case 4:
                return this.createShape(e);
              case 5:
                return this.createText(e);
              case 6:
                return this.createAudio(e);
              case 13:
                return this.createCamera(e);
              case 15:
                return this.createFootage(e);
            }
          }),
          (BaseRenderer.prototype.createCamera = function () {
            throw new Error("You're using a 3d camera. Try the html renderer.");
          }),
          (BaseRenderer.prototype.createAudio = function (e) {
            return new AudioElement(e, this.globalData, this);
          }),
          (BaseRenderer.prototype.createFootage = function (e) {
            return new FootageElement(e, this.globalData, this);
          }),
          (BaseRenderer.prototype.buildAllItems = function () {
            var e,
              t = this.layers.length;
            for (e = 0; e < t; e += 1) this.buildItem(e);
            this.checkPendingElements();
          }),
          (BaseRenderer.prototype.includeLayers = function (e) {
            var t;
            this.completeLayers = !1;
            var r,
              n = e.length,
              i = this.layers.length;
            for (t = 0; t < n; t += 1)
              for (r = 0; r < i; ) {
                if (this.layers[r].id === e[t].id) {
                  this.layers[r] = e[t];
                  break;
                }
                r += 1;
              }
          }),
          (BaseRenderer.prototype.setProjectInterface = function (e) {
            this.globalData.projectInterface = e;
          }),
          (BaseRenderer.prototype.initItems = function () {
            this.globalData.progressiveLoad || this.buildAllItems();
          }),
          (BaseRenderer.prototype.buildElementParenting = function (e, t, r) {
            for (
              var n = this.elements, i = this.layers, a = 0, s = i.length;
              a < s;

            )
              i[a].ind == t &&
                (n[a] && n[a] !== !0
                  ? (r.push(n[a]),
                    n[a].setAsParent(),
                    i[a].parent !== void 0
                      ? this.buildElementParenting(e, i[a].parent, r)
                      : e.setHierarchy(r))
                  : (this.buildItem(a), this.addPendingElement(e))),
                (a += 1);
          }),
          (BaseRenderer.prototype.addPendingElement = function (e) {
            this.pendingElements.push(e);
          }),
          (BaseRenderer.prototype.searchExtraCompositions = function (e) {
            var t,
              r = e.length;
            for (t = 0; t < r; t += 1)
              if (e[t].xt) {
                var n = this.createComp(e[t]);
                n.initExpressions(),
                  this.globalData.projectInterface.registerComposition(n);
              }
          }),
          (BaseRenderer.prototype.getElementById = function (e) {
            var t,
              r = this.elements.length;
            for (t = 0; t < r; t += 1)
              if (this.elements[t].data.ind === e) return this.elements[t];
            return null;
          }),
          (BaseRenderer.prototype.getElementByPath = function (e) {
            var t,
              r = e.shift();
            if (typeof r == "number") t = this.elements[r];
            else {
              var n,
                i = this.elements.length;
              for (n = 0; n < i; n += 1)
                if (this.elements[n].data.nm === r) {
                  t = this.elements[n];
                  break;
                }
            }
            return e.length === 0 ? t : t.getElementByPath(e);
          }),
          (BaseRenderer.prototype.setupGlobalData = function (e, t) {
            (this.globalData.fontManager = new FontManager()),
              (this.globalData.slotManager = slotFactory(e)),
              this.globalData.fontManager.addChars(e.chars),
              this.globalData.fontManager.addFonts(e.fonts, t),
              (this.globalData.getAssetData =
                this.animationItem.getAssetData.bind(this.animationItem)),
              (this.globalData.getAssetsPath =
                this.animationItem.getAssetsPath.bind(this.animationItem)),
              (this.globalData.imageLoader = this.animationItem.imagePreloader),
              (this.globalData.audioController =
                this.animationItem.audioController),
              (this.globalData.frameId = 0),
              (this.globalData.frameRate = e.fr),
              (this.globalData.nm = e.nm),
              (this.globalData.compSize = { w: e.w, h: e.h });
          });
        var effectTypes = { TRANSFORM_EFFECT: "transformEFfect" };
        function TransformElement() {}
        function MaskElement(e, t, r) {
          (this.data = e),
            (this.element = t),
            (this.globalData = r),
            (this.storedData = []),
            (this.masksProperties = this.data.masksProperties || []),
            (this.maskElement = null);
          var n,
            i,
            a = this.globalData.defs,
            s = this.masksProperties ? this.masksProperties.length : 0;
          (this.viewData = createSizedArray(s)), (this.solidPath = "");
          var o,
            l,
            f,
            u,
            c,
            v,
            d = this.masksProperties,
            p = 0,
            m = [],
            h = createElementID(),
            g = "clipPath",
            y = "clip-path";
          for (n = 0; n < s; n += 1)
            if (
              (((d[n].mode !== "a" && d[n].mode !== "n") ||
                d[n].inv ||
                d[n].o.k !== 100 ||
                d[n].o.x) &&
                ((g = "mask"), (y = "mask")),
              (d[n].mode !== "s" && d[n].mode !== "i") || p !== 0
                ? (f = null)
                : ((f = createNS("rect")).setAttribute("fill", "#ffffff"),
                  f.setAttribute("width", this.element.comp.data.w || 0),
                  f.setAttribute("height", this.element.comp.data.h || 0),
                  m.push(f)),
              (i = createNS("path")),
              d[n].mode === "n")
            )
              (this.viewData[n] = {
                op: PropertyFactory.getProp(
                  this.element,
                  d[n].o,
                  0,
                  0.01,
                  this.element,
                ),
                prop: ShapePropertyFactory.getShapeProp(this.element, d[n], 3),
                elem: i,
                lastPath: "",
              }),
                a.appendChild(i);
            else {
              var _;
              if (
                ((p += 1),
                i.setAttribute(
                  "fill",
                  d[n].mode === "s" ? "#000000" : "#ffffff",
                ),
                i.setAttribute("clip-rule", "nonzero"),
                d[n].x.k !== 0
                  ? ((g = "mask"),
                    (y = "mask"),
                    (v = PropertyFactory.getProp(
                      this.element,
                      d[n].x,
                      0,
                      null,
                      this.element,
                    )),
                    (_ = createElementID()),
                    (u = createNS("filter")).setAttribute("id", _),
                    (c = createNS("feMorphology")).setAttribute(
                      "operator",
                      "erode",
                    ),
                    c.setAttribute("in", "SourceGraphic"),
                    c.setAttribute("radius", "0"),
                    u.appendChild(c),
                    a.appendChild(u),
                    i.setAttribute(
                      "stroke",
                      d[n].mode === "s" ? "#000000" : "#ffffff",
                    ))
                  : ((c = null), (v = null)),
                (this.storedData[n] = {
                  elem: i,
                  x: v,
                  expan: c,
                  lastPath: "",
                  lastOperator: "",
                  filterId: _,
                  lastRadius: 0,
                }),
                d[n].mode === "i")
              ) {
                l = m.length;
                var b = createNS("g");
                for (o = 0; o < l; o += 1) b.appendChild(m[o]);
                var I = createNS("mask");
                I.setAttribute("mask-type", "alpha"),
                  I.setAttribute("id", h + "_" + p),
                  I.appendChild(i),
                  a.appendChild(I),
                  b.setAttribute(
                    "mask",
                    "url(" + getLocationHref() + "#" + h + "_" + p + ")",
                  ),
                  (m.length = 0),
                  m.push(b);
              } else m.push(i);
              d[n].inv &&
                !this.solidPath &&
                (this.solidPath = this.createLayerSolidPath()),
                (this.viewData[n] = {
                  elem: i,
                  lastPath: "",
                  op: PropertyFactory.getProp(
                    this.element,
                    d[n].o,
                    0,
                    0.01,
                    this.element,
                  ),
                  prop: ShapePropertyFactory.getShapeProp(
                    this.element,
                    d[n],
                    3,
                  ),
                  invRect: f,
                }),
                this.viewData[n].prop.k ||
                  this.drawPath(
                    d[n],
                    this.viewData[n].prop.v,
                    this.viewData[n],
                  );
            }
          for (
            this.maskElement = createNS(g), s = m.length, n = 0;
            n < s;
            n += 1
          )
            this.maskElement.appendChild(m[n]);
          p > 0 &&
            (this.maskElement.setAttribute("id", h),
            this.element.maskedElement.setAttribute(
              y,
              "url(" + getLocationHref() + "#" + h + ")",
            ),
            a.appendChild(this.maskElement)),
            this.viewData.length && this.element.addRenderableComponent(this);
        }
        (TransformElement.prototype = {
          initTransform: function () {
            var e = new Matrix();
            (this.finalTransform = {
              mProp: this.data.ks
                ? TransformPropertyFactory.getTransformProperty(
                    this,
                    this.data.ks,
                    this,
                  )
                : { o: 0 },
              _matMdf: !1,
              _localMatMdf: !1,
              _opMdf: !1,
              mat: e,
              localMat: e,
              localOpacity: 1,
            }),
              this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
              this.data.ty;
          },
          renderTransform: function () {
            if (
              ((this.finalTransform._opMdf =
                this.finalTransform.mProp.o._mdf || this._isFirstFrame),
              (this.finalTransform._matMdf =
                this.finalTransform.mProp._mdf || this._isFirstFrame),
              this.hierarchy)
            ) {
              var e,
                t = this.finalTransform.mat,
                r = 0,
                n = this.hierarchy.length;
              if (!this.finalTransform._matMdf)
                for (; r < n; ) {
                  if (this.hierarchy[r].finalTransform.mProp._mdf) {
                    this.finalTransform._matMdf = !0;
                    break;
                  }
                  r += 1;
                }
              if (this.finalTransform._matMdf)
                for (
                  e = this.finalTransform.mProp.v.props,
                    t.cloneFromProps(e),
                    r = 0;
                  r < n;
                  r += 1
                )
                  t.multiply(this.hierarchy[r].finalTransform.mProp.v);
            }
            this.finalTransform._matMdf &&
              (this.finalTransform._localMatMdf = this.finalTransform._matMdf),
              this.finalTransform._opMdf &&
                (this.finalTransform.localOpacity =
                  this.finalTransform.mProp.o.v);
          },
          renderLocalTransform: function () {
            if (this.localTransforms) {
              var e = 0,
                t = this.localTransforms.length;
              if (
                ((this.finalTransform._localMatMdf =
                  this.finalTransform._matMdf),
                !this.finalTransform._localMatMdf ||
                  !this.finalTransform._opMdf)
              )
                for (; e < t; )
                  this.localTransforms[e]._mdf &&
                    (this.finalTransform._localMatMdf = !0),
                    this.localTransforms[e]._opMdf &&
                      !this.finalTransform._opMdf &&
                      ((this.finalTransform.localOpacity =
                        this.finalTransform.mProp.o.v),
                      (this.finalTransform._opMdf = !0)),
                    (e += 1);
              if (this.finalTransform._localMatMdf) {
                var r = this.finalTransform.localMat;
                for (
                  this.localTransforms[0].matrix.clone(r), e = 1;
                  e < t;
                  e += 1
                ) {
                  var n = this.localTransforms[e].matrix;
                  r.multiply(n);
                }
                r.multiply(this.finalTransform.mat);
              }
              if (this.finalTransform._opMdf) {
                var i = this.finalTransform.localOpacity;
                for (e = 0; e < t; e += 1)
                  i *= 0.01 * this.localTransforms[e].opacity;
                this.finalTransform.localOpacity = i;
              }
            }
          },
          searchEffectTransforms: function () {
            if (this.renderableEffectsManager) {
              var e = this.renderableEffectsManager.getEffects(
                effectTypes.TRANSFORM_EFFECT,
              );
              if (e.length) {
                (this.localTransforms = []),
                  (this.finalTransform.localMat = new Matrix());
                var t = 0,
                  r = e.length;
                for (t = 0; t < r; t += 1) this.localTransforms.push(e[t]);
              }
            }
          },
          globalToLocal: function (e) {
            var t = [];
            t.push(this.finalTransform);
            for (var r, n = !0, i = this.comp; n; )
              i.finalTransform
                ? (i.data.hasMask && t.splice(0, 0, i.finalTransform),
                  (i = i.comp))
                : (n = !1);
            var a,
              s = t.length;
            for (r = 0; r < s; r += 1)
              (a = t[r].mat.applyToPointArray(0, 0, 0)),
                (e = [e[0] - a[0], e[1] - a[1], 0]);
            return e;
          },
          mHelper: new Matrix(),
        }),
          (MaskElement.prototype.getMaskProperty = function (e) {
            return this.viewData[e].prop;
          }),
          (MaskElement.prototype.renderFrame = function (e) {
            var t,
              r = this.element.finalTransform.mat,
              n = this.masksProperties.length;
            for (t = 0; t < n; t += 1)
              if (
                ((this.viewData[t].prop._mdf || e) &&
                  this.drawPath(
                    this.masksProperties[t],
                    this.viewData[t].prop.v,
                    this.viewData[t],
                  ),
                (this.viewData[t].op._mdf || e) &&
                  this.viewData[t].elem.setAttribute(
                    "fill-opacity",
                    this.viewData[t].op.v,
                  ),
                this.masksProperties[t].mode !== "n" &&
                  (this.viewData[t].invRect &&
                    (this.element.finalTransform.mProp._mdf || e) &&
                    this.viewData[t].invRect.setAttribute(
                      "transform",
                      r.getInverseMatrix().to2dCSS(),
                    ),
                  this.storedData[t].x && (this.storedData[t].x._mdf || e)))
              ) {
                var i = this.storedData[t].expan;
                this.storedData[t].x.v < 0
                  ? (this.storedData[t].lastOperator !== "erode" &&
                      ((this.storedData[t].lastOperator = "erode"),
                      this.storedData[t].elem.setAttribute(
                        "filter",
                        "url(" +
                          getLocationHref() +
                          "#" +
                          this.storedData[t].filterId +
                          ")",
                      )),
                    i.setAttribute("radius", -this.storedData[t].x.v))
                  : (this.storedData[t].lastOperator !== "dilate" &&
                      ((this.storedData[t].lastOperator = "dilate"),
                      this.storedData[t].elem.setAttribute("filter", null)),
                    this.storedData[t].elem.setAttribute(
                      "stroke-width",
                      2 * this.storedData[t].x.v,
                    ));
              }
          }),
          (MaskElement.prototype.getMaskelement = function () {
            return this.maskElement;
          }),
          (MaskElement.prototype.createLayerSolidPath = function () {
            var e = "M0,0 ";
            return (
              (e += " h" + this.globalData.compSize.w),
              (e += " v" + this.globalData.compSize.h),
              (e += " h-" + this.globalData.compSize.w),
              (e += " v-" + this.globalData.compSize.h + " ")
            );
          }),
          (MaskElement.prototype.drawPath = function (e, t, r) {
            var n,
              i,
              a = " M" + t.v[0][0] + "," + t.v[0][1];
            for (i = t._length, n = 1; n < i; n += 1)
              a +=
                " C" +
                t.o[n - 1][0] +
                "," +
                t.o[n - 1][1] +
                " " +
                t.i[n][0] +
                "," +
                t.i[n][1] +
                " " +
                t.v[n][0] +
                "," +
                t.v[n][1];
            if (
              (t.c &&
                i > 1 &&
                (a +=
                  " C" +
                  t.o[n - 1][0] +
                  "," +
                  t.o[n - 1][1] +
                  " " +
                  t.i[0][0] +
                  "," +
                  t.i[0][1] +
                  " " +
                  t.v[0][0] +
                  "," +
                  t.v[0][1]),
              r.lastPath !== a)
            ) {
              var s = "";
              r.elem &&
                (t.c && (s = e.inv ? this.solidPath + a : a),
                r.elem.setAttribute("d", s)),
                (r.lastPath = a);
            }
          }),
          (MaskElement.prototype.destroy = function () {
            (this.element = null),
              (this.globalData = null),
              (this.maskElement = null),
              (this.data = null),
              (this.masksProperties = null);
          });
        var filtersFactory = (function () {
            var e = {};
            return (
              (e.createFilter = function (t, r) {
                var n = createNS("filter");
                return (
                  n.setAttribute("id", t),
                  r !== !0 &&
                    (n.setAttribute("filterUnits", "objectBoundingBox"),
                    n.setAttribute("x", "0%"),
                    n.setAttribute("y", "0%"),
                    n.setAttribute("width", "100%"),
                    n.setAttribute("height", "100%")),
                  n
                );
              }),
              (e.createAlphaToLuminanceFilter = function () {
                var t = createNS("feColorMatrix");
                return (
                  t.setAttribute("type", "matrix"),
                  t.setAttribute("color-interpolation-filters", "sRGB"),
                  t.setAttribute(
                    "values",
                    "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1",
                  ),
                  t
                );
              }),
              e
            );
          })(),
          featureSupport = (function () {
            var e = {
              maskType: !0,
              svgLumaHidden: !0,
              offscreenCanvas: typeof OffscreenCanvas < "u",
            };
            return (
              (/MSIE 10/i.test(navigator.userAgent) ||
                /MSIE 9/i.test(navigator.userAgent) ||
                /rv:11.0/i.test(navigator.userAgent) ||
                /Edge\/\d./i.test(navigator.userAgent)) &&
                (e.maskType = !1),
              /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1),
              e
            );
          })(),
          registeredEffects$1 = {},
          idPrefix = "filter_result_";
        function SVGEffects(e) {
          var t,
            r,
            n = "SourceGraphic",
            i = e.data.ef ? e.data.ef.length : 0,
            a = createElementID(),
            s = filtersFactory.createFilter(a, !0),
            o = 0;
          for (this.filters = [], t = 0; t < i; t += 1) {
            r = null;
            var l = e.data.ef[t].ty;
            registeredEffects$1[l] &&
              ((r = new registeredEffects$1[l].effect(
                s,
                e.effectsManager.effectElements[t],
                e,
                idPrefix + o,
                n,
              )),
              (n = idPrefix + o),
              registeredEffects$1[l].countsAsEffect && (o += 1)),
              r && this.filters.push(r);
          }
          o &&
            (e.globalData.defs.appendChild(s),
            e.layerElement.setAttribute(
              "filter",
              "url(" + getLocationHref() + "#" + a + ")",
            )),
            this.filters.length && e.addRenderableComponent(this);
        }
        function registerEffect$1(e, t, r) {
          registeredEffects$1[e] = { effect: t, countsAsEffect: r };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(e, t, r) {
          (this.assetData = t.getAssetData(e.refId)),
            this.assetData &&
              this.assetData.sid &&
              (this.assetData = t.slotManager.getProp(this.assetData)),
            this.initElement(e, t, r),
            (this.sourceRect = {
              top: 0,
              left: 0,
              width: this.assetData.w,
              height: this.assetData.h,
            });
        }
        function ProcessedElement(e, t) {
          (this.elem = e), (this.pos = t);
        }
        function IShapeElement() {}
        (SVGEffects.prototype.renderFrame = function (e) {
          var t,
            r = this.filters.length;
          for (t = 0; t < r; t += 1) this.filters[t].renderFrame(e);
        }),
          (SVGEffects.prototype.getEffects = function (e) {
            var t,
              r = this.filters.length,
              n = [];
            for (t = 0; t < r; t += 1)
              this.filters[t].type === e && n.push(this.filters[t]);
            return n;
          }),
          (SVGBaseElement.prototype = {
            initRendererElement: function () {
              this.layerElement = createNS("g");
            },
            createContainerElements: function () {
              (this.matteElement = createNS("g")),
                (this.transformedElement = this.layerElement),
                (this.maskedElement = this.layerElement),
                (this._sizeChanged = !1);
              var e = null;
              if (this.data.td) {
                this.matteMasks = {};
                var t = createNS("g");
                t.setAttribute("id", this.layerId),
                  t.appendChild(this.layerElement),
                  (e = t),
                  this.globalData.defs.appendChild(t);
              } else
                this.data.tt
                  ? (this.matteElement.appendChild(this.layerElement),
                    (e = this.matteElement),
                    (this.baseElement = this.matteElement))
                  : (this.baseElement = this.layerElement);
              if (
                (this.data.ln &&
                  this.layerElement.setAttribute("id", this.data.ln),
                this.data.cl &&
                  this.layerElement.setAttribute("class", this.data.cl),
                this.data.ty === 0 && !this.data.hd)
              ) {
                var r = createNS("clipPath"),
                  n = createNS("path");
                n.setAttribute(
                  "d",
                  "M0,0 L" +
                    this.data.w +
                    ",0 L" +
                    this.data.w +
                    "," +
                    this.data.h +
                    " L0," +
                    this.data.h +
                    "z",
                );
                var i = createElementID();
                if (
                  (r.setAttribute("id", i),
                  r.appendChild(n),
                  this.globalData.defs.appendChild(r),
                  this.checkMasks())
                ) {
                  var a = createNS("g");
                  a.setAttribute(
                    "clip-path",
                    "url(" + getLocationHref() + "#" + i + ")",
                  ),
                    a.appendChild(this.layerElement),
                    (this.transformedElement = a),
                    e
                      ? e.appendChild(this.transformedElement)
                      : (this.baseElement = this.transformedElement);
                } else
                  this.layerElement.setAttribute(
                    "clip-path",
                    "url(" + getLocationHref() + "#" + i + ")",
                  );
              }
              this.data.bm !== 0 && this.setBlendMode();
            },
            renderElement: function () {
              this.finalTransform._localMatMdf &&
                this.transformedElement.setAttribute(
                  "transform",
                  this.finalTransform.localMat.to2dCSS(),
                ),
                this.finalTransform._opMdf &&
                  this.transformedElement.setAttribute(
                    "opacity",
                    this.finalTransform.localOpacity,
                  );
            },
            destroyBaseElement: function () {
              (this.layerElement = null),
                (this.matteElement = null),
                this.maskManager.destroy();
            },
            getBaseElement: function () {
              return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function () {
              (this.maskManager = new MaskElement(
                this.data,
                this,
                this.globalData,
              )),
                (this.renderableEffectsManager = new SVGEffects(this)),
                this.searchEffectTransforms();
            },
            getMatte: function (e) {
              if (
                (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[e])
              ) {
                var t,
                  r,
                  n,
                  i,
                  a = this.layerId + "_" + e;
                if (e === 1 || e === 3) {
                  var s = createNS("mask");
                  s.setAttribute("id", a),
                    s.setAttribute(
                      "mask-type",
                      e === 3 ? "luminance" : "alpha",
                    ),
                    (n = createNS("use")).setAttributeNS(
                      "http://www.w3.org/1999/xlink",
                      "href",
                      "#" + this.layerId,
                    ),
                    s.appendChild(n),
                    this.globalData.defs.appendChild(s),
                    featureSupport.maskType ||
                      e !== 1 ||
                      (s.setAttribute("mask-type", "luminance"),
                      (t = createElementID()),
                      (r = filtersFactory.createFilter(t)),
                      this.globalData.defs.appendChild(r),
                      r.appendChild(
                        filtersFactory.createAlphaToLuminanceFilter(),
                      ),
                      (i = createNS("g")).appendChild(n),
                      s.appendChild(i),
                      i.setAttribute(
                        "filter",
                        "url(" + getLocationHref() + "#" + t + ")",
                      ));
                } else if (e === 2) {
                  var o = createNS("mask");
                  o.setAttribute("id", a), o.setAttribute("mask-type", "alpha");
                  var l = createNS("g");
                  o.appendChild(l),
                    (t = createElementID()),
                    (r = filtersFactory.createFilter(t));
                  var f = createNS("feComponentTransfer");
                  f.setAttribute("in", "SourceGraphic"), r.appendChild(f);
                  var u = createNS("feFuncA");
                  u.setAttribute("type", "table"),
                    u.setAttribute("tableValues", "1.0 0.0"),
                    f.appendChild(u),
                    this.globalData.defs.appendChild(r);
                  var c = createNS("rect");
                  c.setAttribute("width", this.comp.data.w),
                    c.setAttribute("height", this.comp.data.h),
                    c.setAttribute("x", "0"),
                    c.setAttribute("y", "0"),
                    c.setAttribute("fill", "#ffffff"),
                    c.setAttribute("opacity", "0"),
                    l.setAttribute(
                      "filter",
                      "url(" + getLocationHref() + "#" + t + ")",
                    ),
                    l.appendChild(c),
                    (n = createNS("use")).setAttributeNS(
                      "http://www.w3.org/1999/xlink",
                      "href",
                      "#" + this.layerId,
                    ),
                    l.appendChild(n),
                    featureSupport.maskType ||
                      (o.setAttribute("mask-type", "luminance"),
                      r.appendChild(
                        filtersFactory.createAlphaToLuminanceFilter(),
                      ),
                      (i = createNS("g")),
                      l.appendChild(c),
                      i.appendChild(this.layerElement),
                      l.appendChild(i)),
                    this.globalData.defs.appendChild(o);
                }
                this.matteMasks[e] = a;
              }
              return this.matteMasks[e];
            },
            setMatte: function (e) {
              this.matteElement &&
                this.matteElement.setAttribute(
                  "mask",
                  "url(" + getLocationHref() + "#" + e + ")",
                );
            },
          }),
          (HierarchyElement.prototype = {
            initHierarchy: function () {
              (this.hierarchy = []),
                (this._isParent = !1),
                this.checkParenting();
            },
            setHierarchy: function (e) {
              this.hierarchy = e;
            },
            setAsParent: function () {
              this._isParent = !0;
            },
            checkParenting: function () {
              this.data.parent !== void 0 &&
                this.comp.buildElementParenting(this, this.data.parent, []);
            },
          }),
          extendPrototype(
            [
              RenderableElement,
              createProxyFunction({
                initElement: function (e, t, r) {
                  this.initFrame(),
                    this.initBaseData(e, t, r),
                    this.initTransform(e, t, r),
                    this.initHierarchy(),
                    this.initRenderable(),
                    this.initRendererElement(),
                    this.createContainerElements(),
                    this.createRenderableComponents(),
                    this.createContent(),
                    this.hide();
                },
                hide: function () {
                  this.hidden ||
                    (this.isInRange && !this.isTransparent) ||
                    (((this.baseElement || this.layerElement).style.display =
                      "none"),
                    (this.hidden = !0));
                },
                show: function () {
                  this.isInRange &&
                    !this.isTransparent &&
                    (this.data.hd ||
                      ((this.baseElement || this.layerElement).style.display =
                        "block"),
                    (this.hidden = !1),
                    (this._isFirstFrame = !0));
                },
                renderFrame: function () {
                  this.data.hd ||
                    this.hidden ||
                    (this.renderTransform(),
                    this.renderRenderable(),
                    this.renderLocalTransform(),
                    this.renderElement(),
                    this.renderInnerContent(),
                    this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function () {},
                prepareFrame: function (e) {
                  (this._mdf = !1),
                    this.prepareRenderableFrame(e),
                    this.prepareProperties(e, this.isInRange),
                    this.checkTransparency();
                },
                destroy: function () {
                  (this.innerElem = null), this.destroyBaseElement();
                },
              }),
            ],
            RenderableDOMElement,
          ),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              SVGBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableDOMElement,
            ],
            IImageElement,
          ),
          (IImageElement.prototype.createContent = function () {
            var e = this.globalData.getAssetsPath(this.assetData);
            (this.innerElem = createNS("image")),
              this.innerElem.setAttribute("width", this.assetData.w + "px"),
              this.innerElem.setAttribute("height", this.assetData.h + "px"),
              this.innerElem.setAttribute(
                "preserveAspectRatio",
                this.assetData.pr ||
                  this.globalData.renderConfig.imagePreserveAspectRatio,
              ),
              this.innerElem.setAttributeNS(
                "http://www.w3.org/1999/xlink",
                "href",
                e,
              ),
              this.layerElement.appendChild(this.innerElem);
          }),
          (IImageElement.prototype.sourceRectAtTime = function () {
            return this.sourceRect;
          }),
          (IShapeElement.prototype = {
            addShapeToModifiers: function (e) {
              var t,
                r = this.shapeModifiers.length;
              for (t = 0; t < r; t += 1) this.shapeModifiers[t].addShape(e);
            },
            isShapeInAnimatedModifiers: function (e) {
              for (var t = this.shapeModifiers.length; 0 < t; )
                if (this.shapeModifiers[0].isAnimatedWithShape(e)) return !0;
              return !1;
            },
            renderModifiers: function () {
              if (this.shapeModifiers.length) {
                var e,
                  t = this.shapes.length;
                for (e = 0; e < t; e += 1) this.shapes[e].sh.reset();
                for (
                  e = (t = this.shapeModifiers.length) - 1;
                  e >= 0 &&
                  !this.shapeModifiers[e].processShapes(this._isFirstFrame);
                  e -= 1
                );
              }
            },
            searchProcessedElement: function (e) {
              for (
                var t = this.processedElements, r = 0, n = t.length;
                r < n;

              ) {
                if (t[r].elem === e) return t[r].pos;
                r += 1;
              }
              return 0;
            },
            addProcessedElement: function (e, t) {
              for (var r = this.processedElements, n = r.length; n; )
                if (r[(n -= 1)].elem === e) return void (r[n].pos = t);
              r.push(new ProcessedElement(e, t));
            },
            prepareFrame: function (e) {
              this.prepareRenderableFrame(e),
                this.prepareProperties(e, this.isInRange);
            },
          });
        var lineCapEnum = { 1: "butt", 2: "round", 3: "square" },
          lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
        function SVGShapeData(e, t, r) {
          (this.caches = []),
            (this.styles = []),
            (this.transformers = e),
            (this.lStr = ""),
            (this.sh = r),
            (this.lvl = t),
            (this._isAnimated = !!r.k);
          for (var n = 0, i = e.length; n < i; ) {
            if (e[n].mProps.dynamicProperties.length) {
              this._isAnimated = !0;
              break;
            }
            n += 1;
          }
        }
        function SVGStyleData(e, t) {
          (this.data = e),
            (this.type = e.ty),
            (this.d = ""),
            (this.lvl = t),
            (this._mdf = !1),
            (this.closed = e.hd === !0),
            (this.pElem = createNS("path")),
            (this.msElem = null);
        }
        function DashProperty(e, t, r, n) {
          var i;
          (this.elem = e),
            (this.frameId = -1),
            (this.dataProps = createSizedArray(t.length)),
            (this.renderer = r),
            (this.k = !1),
            (this.dashStr = ""),
            (this.dashArray = createTypedArray(
              "float32",
              t.length ? t.length - 1 : 0,
            )),
            (this.dashoffset = createTypedArray("float32", 1)),
            this.initDynamicPropertyContainer(n);
          var a,
            s = t.length || 0;
          for (i = 0; i < s; i += 1)
            (a = PropertyFactory.getProp(e, t[i].v, 0, 0, this)),
              (this.k = a.k || this.k),
              (this.dataProps[i] = { n: t[i].n, p: a });
          this.k || this.getValue(!0), (this._isAnimated = this.k);
        }
        function SVGStrokeStyleData(e, t, r) {
          this.initDynamicPropertyContainer(e),
            (this.getValue = this.iterateDynamicProperties),
            (this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this)),
            (this.w = PropertyFactory.getProp(e, t.w, 0, null, this)),
            (this.d = new DashProperty(e, t.d || {}, "svg", this)),
            (this.c = PropertyFactory.getProp(e, t.c, 1, 255, this)),
            (this.style = r),
            (this._isAnimated = !!this._isAnimated);
        }
        function SVGFillStyleData(e, t, r) {
          this.initDynamicPropertyContainer(e),
            (this.getValue = this.iterateDynamicProperties),
            (this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this)),
            (this.c = PropertyFactory.getProp(e, t.c, 1, 255, this)),
            (this.style = r);
        }
        function SVGNoStyleData(e, t, r) {
          this.initDynamicPropertyContainer(e),
            (this.getValue = this.iterateDynamicProperties),
            (this.style = r);
        }
        function GradientProperty(e, t, r) {
          (this.data = t), (this.c = createTypedArray("uint8c", 4 * t.p));
          var n = t.k.k[0].s
            ? t.k.k[0].s.length - 4 * t.p
            : t.k.k.length - 4 * t.p;
          (this.o = createTypedArray("float32", n)),
            (this._cmdf = !1),
            (this._omdf = !1),
            (this._collapsable = this.checkCollapsable()),
            (this._hasOpacity = n),
            this.initDynamicPropertyContainer(r),
            (this.prop = PropertyFactory.getProp(e, t.k, 1, null, this)),
            (this.k = this.prop.k),
            this.getValue(!0);
        }
        function SVGGradientFillStyleData(e, t, r) {
          this.initDynamicPropertyContainer(e),
            (this.getValue = this.iterateDynamicProperties),
            this.initGradientData(e, t, r);
        }
        function SVGGradientStrokeStyleData(e, t, r) {
          this.initDynamicPropertyContainer(e),
            (this.getValue = this.iterateDynamicProperties),
            (this.w = PropertyFactory.getProp(e, t.w, 0, null, this)),
            (this.d = new DashProperty(e, t.d || {}, "svg", this)),
            this.initGradientData(e, t, r),
            (this._isAnimated = !!this._isAnimated);
        }
        function ShapeGroupData() {
          (this.it = []), (this.prevViewData = []), (this.gr = createNS("g"));
        }
        function SVGTransformData(e, t, r) {
          (this.transform = { mProps: e, op: t, container: r }),
            (this.elements = []),
            (this._isAnimated =
              this.transform.mProps.dynamicProperties.length ||
              this.transform.op.effectsSequence.length);
        }
        (SVGShapeData.prototype.setAsAnimated = function () {
          this._isAnimated = !0;
        }),
          (SVGStyleData.prototype.reset = function () {
            (this.d = ""), (this._mdf = !1);
          }),
          (DashProperty.prototype.getValue = function (e) {
            if (
              (this.elem.globalData.frameId !== this.frameId || e) &&
              ((this.frameId = this.elem.globalData.frameId),
              this.iterateDynamicProperties(),
              (this._mdf = this._mdf || e),
              this._mdf)
            ) {
              var t = 0,
                r = this.dataProps.length;
              for (
                this.renderer === "svg" && (this.dashStr = ""), t = 0;
                t < r;
                t += 1
              )
                this.dataProps[t].n !== "o"
                  ? this.renderer === "svg"
                    ? (this.dashStr += " " + this.dataProps[t].p.v)
                    : (this.dashArray[t] = this.dataProps[t].p.v)
                  : (this.dashoffset[0] = this.dataProps[t].p.v);
            }
          }),
          extendPrototype([DynamicPropertyContainer], DashProperty),
          extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
          extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
          extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
          (GradientProperty.prototype.comparePoints = function (e, t) {
            for (var r = 0, n = this.o.length / 2; r < n; ) {
              if (Math.abs(e[4 * r] - e[4 * t + 2 * r]) > 0.01) return !1;
              r += 1;
            }
            return !0;
          }),
          (GradientProperty.prototype.checkCollapsable = function () {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s)
              for (var e = 0, t = this.data.k.k.length; e < t; ) {
                if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
                  return !1;
                e += 1;
              }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
          }),
          (GradientProperty.prototype.getValue = function (e) {
            if (
              (this.prop.getValue(),
              (this._mdf = !1),
              (this._cmdf = !1),
              (this._omdf = !1),
              this.prop._mdf || e)
            ) {
              var t,
                r,
                n,
                i = 4 * this.data.p;
              for (t = 0; t < i; t += 1)
                (r = t % 4 == 0 ? 100 : 255),
                  (n = Math.round(this.prop.v[t] * r)),
                  this.c[t] !== n && ((this.c[t] = n), (this._cmdf = !e));
              if (this.o.length)
                for (i = this.prop.v.length, t = 4 * this.data.p; t < i; t += 1)
                  (r = t % 2 == 0 ? 100 : 1),
                    (n =
                      t % 2 == 0
                        ? Math.round(100 * this.prop.v[t])
                        : this.prop.v[t]),
                    this.o[t - 4 * this.data.p] !== n &&
                      ((this.o[t - 4 * this.data.p] = n), (this._omdf = !e));
              this._mdf = !e;
            }
          }),
          extendPrototype([DynamicPropertyContainer], GradientProperty),
          (SVGGradientFillStyleData.prototype.initGradientData = function (
            e,
            t,
            r,
          ) {
            (this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this)),
              (this.s = PropertyFactory.getProp(e, t.s, 1, null, this)),
              (this.e = PropertyFactory.getProp(e, t.e, 1, null, this)),
              (this.h = PropertyFactory.getProp(
                e,
                t.h || { k: 0 },
                0,
                0.01,
                this,
              )),
              (this.a = PropertyFactory.getProp(
                e,
                t.a || { k: 0 },
                0,
                degToRads,
                this,
              )),
              (this.g = new GradientProperty(e, t.g, this)),
              (this.style = r),
              (this.stops = []),
              this.setGradientData(r.pElem, t),
              this.setGradientOpacity(t, r),
              (this._isAnimated = !!this._isAnimated);
          }),
          (SVGGradientFillStyleData.prototype.setGradientData = function (
            e,
            t,
          ) {
            var r = createElementID(),
              n = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
            n.setAttribute("id", r),
              n.setAttribute("spreadMethod", "pad"),
              n.setAttribute("gradientUnits", "userSpaceOnUse");
            var i,
              a,
              s,
              o = [];
            for (s = 4 * t.g.p, a = 0; a < s; a += 4)
              (i = createNS("stop")), n.appendChild(i), o.push(i);
            e.setAttribute(
              t.ty === "gf" ? "fill" : "stroke",
              "url(" + getLocationHref() + "#" + r + ")",
            ),
              (this.gf = n),
              (this.cst = o);
          }),
          (SVGGradientFillStyleData.prototype.setGradientOpacity = function (
            e,
            t,
          ) {
            if (this.g._hasOpacity && !this.g._collapsable) {
              var r,
                n,
                i,
                a = createNS("mask"),
                s = createNS("path");
              a.appendChild(s);
              var o = createElementID(),
                l = createElementID();
              a.setAttribute("id", l);
              var f = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
              f.setAttribute("id", o),
                f.setAttribute("spreadMethod", "pad"),
                f.setAttribute("gradientUnits", "userSpaceOnUse"),
                (i = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length);
              var u = this.stops;
              for (n = 4 * e.g.p; n < i; n += 2)
                (r = createNS("stop")).setAttribute(
                  "stop-color",
                  "rgb(255,255,255)",
                ),
                  f.appendChild(r),
                  u.push(r);
              s.setAttribute(
                e.ty === "gf" ? "fill" : "stroke",
                "url(" + getLocationHref() + "#" + o + ")",
              ),
                e.ty === "gs" &&
                  (s.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]),
                  s.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]),
                  e.lj === 1 && s.setAttribute("stroke-miterlimit", e.ml)),
                (this.of = f),
                (this.ms = a),
                (this.ost = u),
                (this.maskId = l),
                (t.msElem = s);
            }
          }),
          extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
          extendPrototype(
            [SVGGradientFillStyleData, DynamicPropertyContainer],
            SVGGradientStrokeStyleData,
          );
        var buildShapeString = function (e, t, r, n) {
            if (t === 0) return "";
            var i,
              a = e.o,
              s = e.i,
              o = e.v,
              l = " M" + n.applyToPointStringified(o[0][0], o[0][1]);
            for (i = 1; i < t; i += 1)
              l +=
                " C" +
                n.applyToPointStringified(a[i - 1][0], a[i - 1][1]) +
                " " +
                n.applyToPointStringified(s[i][0], s[i][1]) +
                " " +
                n.applyToPointStringified(o[i][0], o[i][1]);
            return (
              r &&
                t &&
                ((l +=
                  " C" +
                  n.applyToPointStringified(a[i - 1][0], a[i - 1][1]) +
                  " " +
                  n.applyToPointStringified(s[0][0], s[0][1]) +
                  " " +
                  n.applyToPointStringified(o[0][0], o[0][1])),
                (l += "z")),
              l
            );
          },
          SVGElementsRenderer = (function () {
            var e = new Matrix(),
              t = new Matrix();
            function r(f, u, c) {
              (c || u.transform.op._mdf) &&
                u.transform.container.setAttribute("opacity", u.transform.op.v),
                (c || u.transform.mProps._mdf) &&
                  u.transform.container.setAttribute(
                    "transform",
                    u.transform.mProps.v.to2dCSS(),
                  );
            }
            function n() {}
            function i(f, u, c) {
              var v,
                d,
                p,
                m,
                h,
                g,
                y,
                _,
                b,
                I,
                P = u.styles.length,
                S = u.lvl;
              for (g = 0; g < P; g += 1) {
                if (((m = u.sh._mdf || c), u.styles[g].lvl < S)) {
                  for (
                    _ = t.reset(),
                      b = S - u.styles[g].lvl,
                      I = u.transformers.length - 1;
                    !m && b > 0;

                  )
                    (m = u.transformers[I].mProps._mdf || m),
                      (b -= 1),
                      (I -= 1);
                  if (m)
                    for (
                      b = S - u.styles[g].lvl, I = u.transformers.length - 1;
                      b > 0;

                    )
                      _.multiply(u.transformers[I].mProps.v),
                        (b -= 1),
                        (I -= 1);
                } else _ = e;
                if (((d = (y = u.sh.paths)._length), m)) {
                  for (p = "", v = 0; v < d; v += 1)
                    (h = y.shapes[v]) &&
                      h._length &&
                      (p += buildShapeString(h, h._length, h.c, _));
                  u.caches[g] = p;
                } else p = u.caches[g];
                (u.styles[g].d += f.hd === !0 ? "" : p),
                  (u.styles[g]._mdf = m || u.styles[g]._mdf);
              }
            }
            function a(f, u, c) {
              var v = u.style;
              (u.c._mdf || c) &&
                v.pElem.setAttribute(
                  "fill",
                  "rgb(" +
                    bmFloor(u.c.v[0]) +
                    "," +
                    bmFloor(u.c.v[1]) +
                    "," +
                    bmFloor(u.c.v[2]) +
                    ")",
                ),
                (u.o._mdf || c) && v.pElem.setAttribute("fill-opacity", u.o.v);
            }
            function s(f, u, c) {
              o(f, u, c), l(f, u, c);
            }
            function o(f, u, c) {
              var v,
                d,
                p,
                m,
                h,
                g = u.gf,
                y = u.g._hasOpacity,
                _ = u.s.v,
                b = u.e.v;
              if (u.o._mdf || c) {
                var I = f.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                u.style.pElem.setAttribute(I, u.o.v);
              }
              if (u.s._mdf || c) {
                var P = f.t === 1 ? "x1" : "cx",
                  S = P === "x1" ? "y1" : "cy";
                g.setAttribute(P, _[0]),
                  g.setAttribute(S, _[1]),
                  y &&
                    !u.g._collapsable &&
                    (u.of.setAttribute(P, _[0]), u.of.setAttribute(S, _[1]));
              }
              if (u.g._cmdf || c) {
                v = u.cst;
                var A = u.g.c;
                for (p = v.length, d = 0; d < p; d += 1)
                  (m = v[d]).setAttribute("offset", A[4 * d] + "%"),
                    m.setAttribute(
                      "stop-color",
                      "rgb(" +
                        A[4 * d + 1] +
                        "," +
                        A[4 * d + 2] +
                        "," +
                        A[4 * d + 3] +
                        ")",
                    );
              }
              if (y && (u.g._omdf || c)) {
                var R = u.g.o;
                for (
                  p = (v = u.g._collapsable ? u.cst : u.ost).length, d = 0;
                  d < p;
                  d += 1
                )
                  (m = v[d]),
                    u.g._collapsable ||
                      m.setAttribute("offset", R[2 * d] + "%"),
                    m.setAttribute("stop-opacity", R[2 * d + 1]);
              }
              if (f.t === 1)
                (u.e._mdf || c) &&
                  (g.setAttribute("x2", b[0]),
                  g.setAttribute("y2", b[1]),
                  y &&
                    !u.g._collapsable &&
                    (u.of.setAttribute("x2", b[0]),
                    u.of.setAttribute("y2", b[1])));
              else if (
                ((u.s._mdf || u.e._mdf || c) &&
                  ((h = Math.sqrt(
                    Math.pow(_[0] - b[0], 2) + Math.pow(_[1] - b[1], 2),
                  )),
                  g.setAttribute("r", h),
                  y && !u.g._collapsable && u.of.setAttribute("r", h)),
                u.e._mdf || u.h._mdf || u.a._mdf || c)
              ) {
                h ||
                  (h = Math.sqrt(
                    Math.pow(_[0] - b[0], 2) + Math.pow(_[1] - b[1], 2),
                  ));
                var w = Math.atan2(b[1] - _[1], b[0] - _[0]),
                  C = u.h.v;
                C >= 1 ? (C = 0.99) : C <= -1 && (C = -0.99);
                var D = h * C,
                  M = Math.cos(w + u.a.v) * D + _[0],
                  O = Math.sin(w + u.a.v) * D + _[1];
                g.setAttribute("fx", M),
                  g.setAttribute("fy", O),
                  y &&
                    !u.g._collapsable &&
                    (u.of.setAttribute("fx", M), u.of.setAttribute("fy", O));
              }
            }
            function l(f, u, c) {
              var v = u.style,
                d = u.d;
              d &&
                (d._mdf || c) &&
                d.dashStr &&
                (v.pElem.setAttribute("stroke-dasharray", d.dashStr),
                v.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0])),
                u.c &&
                  (u.c._mdf || c) &&
                  v.pElem.setAttribute(
                    "stroke",
                    "rgb(" +
                      bmFloor(u.c.v[0]) +
                      "," +
                      bmFloor(u.c.v[1]) +
                      "," +
                      bmFloor(u.c.v[2]) +
                      ")",
                  ),
                (u.o._mdf || c) &&
                  v.pElem.setAttribute("stroke-opacity", u.o.v),
                (u.w._mdf || c) &&
                  (v.pElem.setAttribute("stroke-width", u.w.v),
                  v.msElem && v.msElem.setAttribute("stroke-width", u.w.v));
            }
            return {
              createRenderFunction: function (f) {
                switch (f.ty) {
                  case "fl":
                    return a;
                  case "gf":
                    return o;
                  case "gs":
                    return s;
                  case "st":
                    return l;
                  case "sh":
                  case "el":
                  case "rc":
                  case "sr":
                    return i;
                  case "tr":
                    return r;
                  case "no":
                    return n;
                  default:
                    return null;
                }
              },
            };
          })();
        function SVGShapeElement(e, t, r) {
          (this.shapes = []),
            (this.shapesData = e.shapes),
            (this.stylesList = []),
            (this.shapeModifiers = []),
            (this.itemsData = []),
            (this.processedElements = []),
            (this.animatedContents = []),
            this.initElement(e, t, r),
            (this.prevViewData = []);
        }
        function LetterProps(e, t, r, n, i, a) {
          (this.o = e),
            (this.sw = t),
            (this.sc = r),
            (this.fc = n),
            (this.m = i),
            (this.p = a),
            (this._mdf = { o: !0, sw: !!t, sc: !!r, fc: !!n, m: !0, p: !0 });
        }
        function TextProperty(e, t) {
          (this._frameId = initialDefaultFrame),
            (this.pv = ""),
            (this.v = ""),
            (this.kf = !1),
            (this._isFirstFrame = !0),
            (this._mdf = !1),
            t.d && t.d.sid && (t.d = e.globalData.slotManager.getProp(t.d)),
            (this.data = t),
            (this.elem = e),
            (this.comp = this.elem.comp),
            (this.keysIndex = 0),
            (this.canResize = !1),
            (this.minimumFontSize = 1),
            (this.effectsSequence = []),
            (this.currentData = {
              ascent: 0,
              boxWidth: this.defaultBoxWidth,
              f: "",
              fStyle: "",
              fWeight: "",
              fc: "",
              j: "",
              justifyOffset: "",
              l: [],
              lh: 0,
              lineWidths: [],
              ls: "",
              of: "",
              s: "",
              sc: "",
              sw: 0,
              t: 0,
              tr: 0,
              sz: 0,
              ps: null,
              fillColorAnim: !1,
              strokeColorAnim: !1,
              strokeWidthAnim: !1,
              yOffset: 0,
              finalSize: 0,
              finalText: [],
              finalLineHeight: 0,
              __complete: !1,
            }),
            this.copyData(this.currentData, this.data.d.k[0].s),
            this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype(
          [
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
          ],
          SVGShapeElement,
        ),
          (SVGShapeElement.prototype.initSecondaryElement = function () {}),
          (SVGShapeElement.prototype.identityMatrix = new Matrix()),
          (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
          (SVGShapeElement.prototype.createContent = function () {
            this.searchShapes(
              this.shapesData,
              this.itemsData,
              this.prevViewData,
              this.layerElement,
              0,
              [],
              !0,
            ),
              this.filterUniqueShapes();
          }),
          (SVGShapeElement.prototype.filterUniqueShapes = function () {
            var e,
              t,
              r,
              n,
              i = this.shapes.length,
              a = this.stylesList.length,
              s = [],
              o = !1;
            for (r = 0; r < a; r += 1) {
              for (
                n = this.stylesList[r], o = !1, s.length = 0, e = 0;
                e < i;
                e += 1
              )
                (t = this.shapes[e]).styles.indexOf(n) !== -1 &&
                  (s.push(t), (o = t._isAnimated || o));
              s.length > 1 && o && this.setShapesAsAnimated(s);
            }
          }),
          (SVGShapeElement.prototype.setShapesAsAnimated = function (e) {
            var t,
              r = e.length;
            for (t = 0; t < r; t += 1) e[t].setAsAnimated();
          }),
          (SVGShapeElement.prototype.createStyleElement = function (e, t) {
            var r,
              n = new SVGStyleData(e, t),
              i = n.pElem;
            return (
              e.ty === "st"
                ? (r = new SVGStrokeStyleData(this, e, n))
                : e.ty === "fl"
                  ? (r = new SVGFillStyleData(this, e, n))
                  : e.ty === "gf" || e.ty === "gs"
                    ? ((r = new (
                        e.ty === "gf"
                          ? SVGGradientFillStyleData
                          : SVGGradientStrokeStyleData
                      )(this, e, n)),
                      this.globalData.defs.appendChild(r.gf),
                      r.maskId &&
                        (this.globalData.defs.appendChild(r.ms),
                        this.globalData.defs.appendChild(r.of),
                        i.setAttribute(
                          "mask",
                          "url(" + getLocationHref() + "#" + r.maskId + ")",
                        )))
                    : e.ty === "no" && (r = new SVGNoStyleData(this, e, n)),
              (e.ty !== "st" && e.ty !== "gs") ||
                (i.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]),
                i.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]),
                i.setAttribute("fill-opacity", "0"),
                e.lj === 1 && i.setAttribute("stroke-miterlimit", e.ml)),
              e.r === 2 && i.setAttribute("fill-rule", "evenodd"),
              e.ln && i.setAttribute("id", e.ln),
              e.cl && i.setAttribute("class", e.cl),
              e.bm && (i.style["mix-blend-mode"] = getBlendMode(e.bm)),
              this.stylesList.push(n),
              this.addToAnimatedContents(e, r),
              r
            );
          }),
          (SVGShapeElement.prototype.createGroupElement = function (e) {
            var t = new ShapeGroupData();
            return (
              e.ln && t.gr.setAttribute("id", e.ln),
              e.cl && t.gr.setAttribute("class", e.cl),
              e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)),
              t
            );
          }),
          (SVGShapeElement.prototype.createTransformElement = function (e, t) {
            var r = TransformPropertyFactory.getTransformProperty(
                this,
                e,
                this,
              ),
              n = new SVGTransformData(r, r.o, t);
            return this.addToAnimatedContents(e, n), n;
          }),
          (SVGShapeElement.prototype.createShapeElement = function (e, t, r) {
            var n = 4;
            e.ty === "rc"
              ? (n = 5)
              : e.ty === "el"
                ? (n = 6)
                : e.ty === "sr" && (n = 7);
            var i = new SVGShapeData(
              t,
              r,
              ShapePropertyFactory.getShapeProp(this, e, n, this),
            );
            return (
              this.shapes.push(i),
              this.addShapeToModifiers(i),
              this.addToAnimatedContents(e, i),
              i
            );
          }),
          (SVGShapeElement.prototype.addToAnimatedContents = function (e, t) {
            for (var r = 0, n = this.animatedContents.length; r < n; ) {
              if (this.animatedContents[r].element === t) return;
              r += 1;
            }
            this.animatedContents.push({
              fn: SVGElementsRenderer.createRenderFunction(e),
              element: t,
              data: e,
            });
          }),
          (SVGShapeElement.prototype.setElementStyles = function (e) {
            var t,
              r = e.styles,
              n = this.stylesList.length;
            for (t = 0; t < n; t += 1)
              this.stylesList[t].closed || r.push(this.stylesList[t]);
          }),
          (SVGShapeElement.prototype.reloadShapes = function () {
            var e;
            this._isFirstFrame = !0;
            var t = this.itemsData.length;
            for (e = 0; e < t; e += 1) this.prevViewData[e] = this.itemsData[e];
            for (
              this.searchShapes(
                this.shapesData,
                this.itemsData,
                this.prevViewData,
                this.layerElement,
                0,
                [],
                !0,
              ),
                this.filterUniqueShapes(),
                t = this.dynamicProperties.length,
                e = 0;
              e < t;
              e += 1
            )
              this.dynamicProperties[e].getValue();
            this.renderModifiers();
          }),
          (SVGShapeElement.prototype.searchShapes = function (
            e,
            t,
            r,
            n,
            i,
            a,
            s,
          ) {
            var o,
              l,
              f,
              u,
              c,
              v,
              d = [].concat(a),
              p = e.length - 1,
              m = [],
              h = [];
            for (o = p; o >= 0; o -= 1) {
              if (
                ((v = this.searchProcessedElement(e[o]))
                  ? (t[o] = r[v - 1])
                  : (e[o]._render = s),
                e[o].ty === "fl" ||
                  e[o].ty === "st" ||
                  e[o].ty === "gf" ||
                  e[o].ty === "gs" ||
                  e[o].ty === "no")
              )
                v
                  ? (t[o].style.closed = !1)
                  : (t[o] = this.createStyleElement(e[o], i)),
                  e[o]._render &&
                    t[o].style.pElem.parentNode !== n &&
                    n.appendChild(t[o].style.pElem),
                  m.push(t[o].style);
              else if (e[o].ty === "gr") {
                if (v)
                  for (f = t[o].it.length, l = 0; l < f; l += 1)
                    t[o].prevViewData[l] = t[o].it[l];
                else t[o] = this.createGroupElement(e[o]);
                this.searchShapes(
                  e[o].it,
                  t[o].it,
                  t[o].prevViewData,
                  t[o].gr,
                  i + 1,
                  d,
                  s,
                ),
                  e[o]._render &&
                    t[o].gr.parentNode !== n &&
                    n.appendChild(t[o].gr);
              } else
                e[o].ty === "tr"
                  ? (v || (t[o] = this.createTransformElement(e[o], n)),
                    (u = t[o].transform),
                    d.push(u))
                  : e[o].ty === "sh" ||
                      e[o].ty === "rc" ||
                      e[o].ty === "el" ||
                      e[o].ty === "sr"
                    ? (v || (t[o] = this.createShapeElement(e[o], d, i)),
                      this.setElementStyles(t[o]))
                    : e[o].ty === "tm" ||
                        e[o].ty === "rd" ||
                        e[o].ty === "ms" ||
                        e[o].ty === "pb" ||
                        e[o].ty === "zz" ||
                        e[o].ty === "op"
                      ? (v
                          ? ((c = t[o]).closed = !1)
                          : ((c = ShapeModifiers.getModifier(e[o].ty)).init(
                              this,
                              e[o],
                            ),
                            (t[o] = c),
                            this.shapeModifiers.push(c)),
                        h.push(c))
                      : e[o].ty === "rp" &&
                        (v
                          ? ((c = t[o]).closed = !0)
                          : ((c = ShapeModifiers.getModifier(e[o].ty)),
                            (t[o] = c),
                            c.init(this, e, o, t),
                            this.shapeModifiers.push(c),
                            (s = !1)),
                        h.push(c));
              this.addProcessedElement(e[o], o + 1);
            }
            for (p = m.length, o = 0; o < p; o += 1) m[o].closed = !0;
            for (p = h.length, o = 0; o < p; o += 1) h[o].closed = !0;
          }),
          (SVGShapeElement.prototype.renderInnerContent = function () {
            var e;
            this.renderModifiers();
            var t = this.stylesList.length;
            for (e = 0; e < t; e += 1) this.stylesList[e].reset();
            for (this.renderShape(), e = 0; e < t; e += 1)
              (this.stylesList[e]._mdf || this._isFirstFrame) &&
                (this.stylesList[e].msElem &&
                  (this.stylesList[e].msElem.setAttribute(
                    "d",
                    this.stylesList[e].d,
                  ),
                  (this.stylesList[e].d = "M0 0" + this.stylesList[e].d)),
                this.stylesList[e].pElem.setAttribute(
                  "d",
                  this.stylesList[e].d || "M0 0",
                ));
          }),
          (SVGShapeElement.prototype.renderShape = function () {
            var e,
              t,
              r = this.animatedContents.length;
            for (e = 0; e < r; e += 1)
              (t = this.animatedContents[e]),
                (this._isFirstFrame || t.element._isAnimated) &&
                  t.data !== !0 &&
                  t.fn(t.data, t.element, this._isFirstFrame);
          }),
          (SVGShapeElement.prototype.destroy = function () {
            this.destroyBaseElement(),
              (this.shapesData = null),
              (this.itemsData = null);
          }),
          (LetterProps.prototype.update = function (e, t, r, n, i, a) {
            (this._mdf.o = !1),
              (this._mdf.sw = !1),
              (this._mdf.sc = !1),
              (this._mdf.fc = !1),
              (this._mdf.m = !1),
              (this._mdf.p = !1);
            var s = !1;
            return (
              this.o !== e && ((this.o = e), (this._mdf.o = !0), (s = !0)),
              this.sw !== t && ((this.sw = t), (this._mdf.sw = !0), (s = !0)),
              this.sc !== r && ((this.sc = r), (this._mdf.sc = !0), (s = !0)),
              this.fc !== n && ((this.fc = n), (this._mdf.fc = !0), (s = !0)),
              this.m !== i && ((this.m = i), (this._mdf.m = !0), (s = !0)),
              !a.length ||
                (this.p[0] === a[0] &&
                  this.p[1] === a[1] &&
                  this.p[4] === a[4] &&
                  this.p[5] === a[5] &&
                  this.p[12] === a[12] &&
                  this.p[13] === a[13]) ||
                ((this.p = a), (this._mdf.p = !0), (s = !0)),
              s
            );
          }),
          (TextProperty.prototype.defaultBoxWidth = [0, 0]),
          (TextProperty.prototype.copyData = function (e, t) {
            for (var r in t)
              Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            return e;
          }),
          (TextProperty.prototype.setCurrentData = function (e) {
            e.__complete || this.completeTextData(e),
              (this.currentData = e),
              (this.currentData.boxWidth =
                this.currentData.boxWidth || this.defaultBoxWidth),
              (this._mdf = !0);
          }),
          (TextProperty.prototype.searchProperty = function () {
            return this.searchKeyframes();
          }),
          (TextProperty.prototype.searchKeyframes = function () {
            return (
              (this.kf = this.data.d.k.length > 1),
              this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
              this.kf
            );
          }),
          (TextProperty.prototype.addEffect = function (e) {
            this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
          }),
          (TextProperty.prototype.getValue = function (e) {
            if (
              (this.elem.globalData.frameId !== this.frameId &&
                this.effectsSequence.length) ||
              e
            ) {
              this.currentData.t = this.data.d.k[this.keysIndex].s.t;
              var t = this.currentData,
                r = this.keysIndex;
              if (this.lock) this.setCurrentData(this.currentData);
              else {
                var n;
                (this.lock = !0), (this._mdf = !1);
                var i = this.effectsSequence.length,
                  a = e || this.data.d.k[this.keysIndex].s;
                for (n = 0; n < i; n += 1)
                  a =
                    r !== this.keysIndex
                      ? this.effectsSequence[n](a, a.t)
                      : this.effectsSequence[n](this.currentData, a.t);
                t !== a && this.setCurrentData(a),
                  (this.v = this.currentData),
                  (this.pv = this.v),
                  (this.lock = !1),
                  (this.frameId = this.elem.globalData.frameId);
              }
            }
          }),
          (TextProperty.prototype.getKeyframeValue = function () {
            for (
              var e = this.data.d.k,
                t = this.elem.comp.renderedFrame,
                r = 0,
                n = e.length;
              r <= n - 1 && !(r === n - 1 || e[r + 1].t > t);

            )
              r += 1;
            return (
              this.keysIndex !== r && (this.keysIndex = r),
              this.data.d.k[this.keysIndex].s
            );
          }),
          (TextProperty.prototype.buildFinalText = function (e) {
            for (
              var t, r, n = [], i = 0, a = e.length, s = !1, o = !1, l = "";
              i < a;

            )
              (s = o),
                (o = !1),
                (t = e.charCodeAt(i)),
                (l = e.charAt(i)),
                FontManager.isCombinedCharacter(t)
                  ? (s = !0)
                  : t >= 55296 && t <= 56319
                    ? FontManager.isRegionalFlag(e, i)
                      ? (l = e.substr(i, 14))
                      : (r = e.charCodeAt(i + 1)) >= 56320 &&
                        r <= 57343 &&
                        (FontManager.isModifier(t, r)
                          ? ((l = e.substr(i, 2)), (s = !0))
                          : (l = FontManager.isFlagEmoji(e.substr(i, 4))
                              ? e.substr(i, 4)
                              : e.substr(i, 2)))
                    : t > 56319
                      ? ((r = e.charCodeAt(i + 1)),
                        FontManager.isVariationSelector(t) && (s = !0))
                      : FontManager.isZeroWidthJoiner(t) &&
                        ((s = !0), (o = !0)),
                s ? ((n[n.length - 1] += l), (s = !1)) : n.push(l),
                (i += l.length);
            return n;
          }),
          (TextProperty.prototype.completeTextData = function (e) {
            e.__complete = !0;
            var t,
              r,
              n,
              i,
              a,
              s,
              o,
              l = this.elem.globalData.fontManager,
              f = this.data,
              u = [],
              c = 0,
              v = f.m.g,
              d = 0,
              p = 0,
              m = 0,
              h = [],
              g = 0,
              y = 0,
              _ = l.getFontByName(e.f),
              b = 0,
              I = getFontProperties(_);
            (e.fWeight = I.weight),
              (e.fStyle = I.style),
              (e.finalSize = e.s),
              (e.finalText = this.buildFinalText(e.t)),
              (r = e.finalText.length),
              (e.finalLineHeight = e.lh);
            var P,
              S = (e.tr / 1e3) * e.finalSize;
            if (e.sz)
              for (var A, R, w = !0, C = e.sz[0], D = e.sz[1]; w; ) {
                (A = 0),
                  (g = 0),
                  (r = (R = this.buildFinalText(e.t)).length),
                  (S = (e.tr / 1e3) * e.finalSize);
                var M = -1;
                for (t = 0; t < r; t += 1)
                  (P = R[t].charCodeAt(0)),
                    (n = !1),
                    R[t] === " "
                      ? (M = t)
                      : (P !== 13 && P !== 3) ||
                        ((g = 0),
                        (n = !0),
                        (A += e.finalLineHeight || 1.2 * e.finalSize)),
                    l.chars
                      ? ((o = l.getCharData(R[t], _.fStyle, _.fFamily)),
                        (b = n ? 0 : (o.w * e.finalSize) / 100))
                      : (b = l.measureText(R[t], e.f, e.finalSize)),
                    g + b > C && R[t] !== " "
                      ? (M === -1 ? (r += 1) : (t = M),
                        (A += e.finalLineHeight || 1.2 * e.finalSize),
                        R.splice(t, M === t ? 1 : 0, "\r"),
                        (M = -1),
                        (g = 0))
                      : ((g += b), (g += S));
                (A += (_.ascent * e.finalSize) / 100),
                  this.canResize && e.finalSize > this.minimumFontSize && D < A
                    ? ((e.finalSize -= 1),
                      (e.finalLineHeight = (e.finalSize * e.lh) / e.s))
                    : ((e.finalText = R), (r = e.finalText.length), (w = !1));
              }
            (g = -S), (b = 0);
            var O,
              q = 0;
            for (t = 0; t < r; t += 1)
              if (
                ((n = !1),
                (P = (O = e.finalText[t]).charCodeAt(0)) === 13 || P === 3
                  ? ((q = 0),
                    h.push(g),
                    (y = g > y ? g : y),
                    (g = -2 * S),
                    (i = ""),
                    (n = !0),
                    (m += 1))
                  : (i = O),
                l.chars
                  ? ((o = l.getCharData(
                      O,
                      _.fStyle,
                      l.getFontByName(e.f).fFamily,
                    )),
                    (b = n ? 0 : (o.w * e.finalSize) / 100))
                  : (b = l.measureText(i, e.f, e.finalSize)),
                O === " " ? (q += b + S) : ((g += b + S + q), (q = 0)),
                u.push({
                  l: b,
                  an: b,
                  add: d,
                  n,
                  anIndexes: [],
                  val: i,
                  line: m,
                  animatorJustifyOffset: 0,
                }),
                v == 2)
              ) {
                if (((d += b), i === "" || i === " " || t === r - 1)) {
                  for ((i !== "" && i !== " ") || (d -= b); p <= t; )
                    (u[p].an = d), (u[p].ind = c), (u[p].extra = b), (p += 1);
                  (c += 1), (d = 0);
                }
              } else if (v == 3) {
                if (((d += b), i === "" || t === r - 1)) {
                  for (i === "" && (d -= b); p <= t; )
                    (u[p].an = d), (u[p].ind = c), (u[p].extra = b), (p += 1);
                  (d = 0), (c += 1);
                }
              } else (u[c].ind = c), (u[c].extra = 0), (c += 1);
            if (((e.l = u), (y = g > y ? g : y), h.push(g), e.sz))
              (e.boxWidth = e.sz[0]), (e.justifyOffset = 0);
            else
              switch (((e.boxWidth = y), e.j)) {
                case 1:
                  e.justifyOffset = -e.boxWidth;
                  break;
                case 2:
                  e.justifyOffset = -e.boxWidth / 2;
                  break;
                default:
                  e.justifyOffset = 0;
              }
            e.lineWidths = h;
            var B,
              H,
              x,
              L,
              j = f.a;
            s = j.length;
            var Y = [];
            for (a = 0; a < s; a += 1) {
              for (
                (B = j[a]).a.sc && (e.strokeColorAnim = !0),
                  B.a.sw && (e.strokeWidthAnim = !0),
                  (B.a.fc || B.a.fh || B.a.fs || B.a.fb) &&
                    (e.fillColorAnim = !0),
                  L = 0,
                  x = B.s.b,
                  t = 0;
                t < r;
                t += 1
              )
                ((H = u[t]).anIndexes[a] = L),
                  ((x == 1 && H.val !== "") ||
                    (x == 2 && H.val !== "" && H.val !== " ") ||
                    (x == 3 && (H.n || H.val == " " || t == r - 1)) ||
                    (x == 4 && (H.n || t == r - 1))) &&
                    (B.s.rn === 1 && Y.push(L), (L += 1));
              f.a[a].s.totalChars = L;
              var oe,
                U = -1;
              if (B.s.rn === 1)
                for (t = 0; t < r; t += 1)
                  U != (H = u[t]).anIndexes[a] &&
                    ((U = H.anIndexes[a]),
                    (oe = Y.splice(
                      Math.floor(Math.random() * Y.length),
                      1,
                    )[0])),
                    (H.anIndexes[a] = oe);
            }
            (e.yOffset = e.finalLineHeight || 1.2 * e.finalSize),
              (e.ls = e.ls || 0),
              (e.ascent = (_.ascent * e.finalSize) / 100);
          }),
          (TextProperty.prototype.updateDocumentData = function (e, t) {
            t = t === void 0 ? this.keysIndex : t;
            var r = this.copyData({}, this.data.d.k[t].s);
            (r = this.copyData(r, e)),
              (this.data.d.k[t].s = r),
              this.recalculate(t),
              this.setCurrentData(r),
              this.elem.addDynamicProperty(this);
          }),
          (TextProperty.prototype.recalculate = function (e) {
            var t = this.data.d.k[e].s;
            (t.__complete = !1),
              (this.keysIndex = 0),
              (this._isFirstFrame = !0),
              this.getValue(t);
          }),
          (TextProperty.prototype.canResizeFont = function (e) {
            (this.canResize = e),
              this.recalculate(this.keysIndex),
              this.elem.addDynamicProperty(this);
          }),
          (TextProperty.prototype.setMinimumFontSize = function (e) {
            (this.minimumFontSize = Math.floor(e) || 1),
              this.recalculate(this.keysIndex),
              this.elem.addDynamicProperty(this);
          });
        var TextSelectorProp = (function () {
          var e = Math.max,
            t = Math.min,
            r = Math.floor;
          function n(i, a) {
            (this._currentTextLength = -1),
              (this.k = !1),
              (this.data = a),
              (this.elem = i),
              (this.comp = i.comp),
              (this.finalS = 0),
              (this.finalE = 0),
              this.initDynamicPropertyContainer(i),
              (this.s = PropertyFactory.getProp(
                i,
                a.s || { k: 0 },
                0,
                0,
                this,
              )),
              (this.e =
                "e" in a
                  ? PropertyFactory.getProp(i, a.e, 0, 0, this)
                  : { v: 100 }),
              (this.o = PropertyFactory.getProp(
                i,
                a.o || { k: 0 },
                0,
                0,
                this,
              )),
              (this.xe = PropertyFactory.getProp(
                i,
                a.xe || { k: 0 },
                0,
                0,
                this,
              )),
              (this.ne = PropertyFactory.getProp(
                i,
                a.ne || { k: 0 },
                0,
                0,
                this,
              )),
              (this.sm = PropertyFactory.getProp(
                i,
                a.sm || { k: 100 },
                0,
                0,
                this,
              )),
              (this.a = PropertyFactory.getProp(i, a.a, 0, 0.01, this)),
              this.dynamicProperties.length || this.getValue();
          }
          return (
            (n.prototype = {
              getMult: function (i) {
                this._currentTextLength !==
                  this.elem.textProperty.currentData.l.length &&
                  this.getValue();
                var a = 0,
                  s = 0,
                  o = 1,
                  l = 1;
                this.ne.v > 0 ? (a = this.ne.v / 100) : (s = -this.ne.v / 100),
                  this.xe.v > 0
                    ? (o = 1 - this.xe.v / 100)
                    : (l = 1 + this.xe.v / 100);
                var f = BezierFactory.getBezierEasing(a, s, o, l).get,
                  u = 0,
                  c = this.finalS,
                  v = this.finalE,
                  d = this.data.sh;
                if (d === 2)
                  u = f(
                    (u =
                      v === c
                        ? i >= v
                          ? 1
                          : 0
                        : e(0, t(0.5 / (v - c) + (i - c) / (v - c), 1))),
                  );
                else if (d === 3)
                  u = f(
                    (u =
                      v === c
                        ? i >= v
                          ? 0
                          : 1
                        : 1 - e(0, t(0.5 / (v - c) + (i - c) / (v - c), 1))),
                  );
                else if (d === 4)
                  v === c
                    ? (u = 0)
                    : (u = e(0, t(0.5 / (v - c) + (i - c) / (v - c), 1))) < 0.5
                      ? (u *= 2)
                      : (u = 1 - 2 * (u - 0.5)),
                    (u = f(u));
                else if (d === 5) {
                  if (v === c) u = 0;
                  else {
                    var p = v - c,
                      m = -p / 2 + (i = t(e(0, i + 0.5 - c), v - c)),
                      h = p / 2;
                    u = Math.sqrt(1 - (m * m) / (h * h));
                  }
                  u = f(u);
                } else
                  d === 6
                    ? (v === c
                        ? (u = 0)
                        : ((i = t(e(0, i + 0.5 - c), v - c)),
                          (u =
                            (1 +
                              Math.cos(Math.PI + (2 * Math.PI * i) / (v - c))) /
                            2)),
                      (u = f(u)))
                    : (i >= r(c) &&
                        (u = e(0, t(i - c < 0 ? t(v, 1) - (c - i) : v - i, 1))),
                      (u = f(u)));
                if (this.sm.v !== 100) {
                  var g = 0.01 * this.sm.v;
                  g === 0 && (g = 1e-8);
                  var y = 0.5 - 0.5 * g;
                  u < y ? (u = 0) : (u = (u - y) / g) > 1 && (u = 1);
                }
                return u * this.a.v;
              },
              getValue: function (i) {
                this.iterateDynamicProperties(),
                  (this._mdf = i || this._mdf),
                  (this._currentTextLength =
                    this.elem.textProperty.currentData.l.length || 0),
                  i &&
                    this.data.r === 2 &&
                    (this.e.v = this._currentTextLength);
                var a = this.data.r === 2 ? 1 : 100 / this.data.totalChars,
                  s = this.o.v / a,
                  o = this.s.v / a + s,
                  l = this.e.v / a + s;
                if (o > l) {
                  var f = o;
                  (o = l), (l = f);
                }
                (this.finalS = o), (this.finalE = l);
              },
            }),
            extendPrototype([DynamicPropertyContainer], n),
            {
              getTextSelectorProp: function (i, a, s) {
                return new n(i, a, s);
              },
            }
          );
        })();
        function TextAnimatorDataProperty(e, t, r) {
          var n = { propType: !1 },
            i = PropertyFactory.getProp,
            a = t.a;
          (this.a = {
            r: a.r ? i(e, a.r, 0, degToRads, r) : n,
            rx: a.rx ? i(e, a.rx, 0, degToRads, r) : n,
            ry: a.ry ? i(e, a.ry, 0, degToRads, r) : n,
            sk: a.sk ? i(e, a.sk, 0, degToRads, r) : n,
            sa: a.sa ? i(e, a.sa, 0, degToRads, r) : n,
            s: a.s ? i(e, a.s, 1, 0.01, r) : n,
            a: a.a ? i(e, a.a, 1, 0, r) : n,
            o: a.o ? i(e, a.o, 0, 0.01, r) : n,
            p: a.p ? i(e, a.p, 1, 0, r) : n,
            sw: a.sw ? i(e, a.sw, 0, 0, r) : n,
            sc: a.sc ? i(e, a.sc, 1, 0, r) : n,
            fc: a.fc ? i(e, a.fc, 1, 0, r) : n,
            fh: a.fh ? i(e, a.fh, 0, 0, r) : n,
            fs: a.fs ? i(e, a.fs, 0, 0.01, r) : n,
            fb: a.fb ? i(e, a.fb, 0, 0.01, r) : n,
            t: a.t ? i(e, a.t, 0, 0, r) : n,
          }),
            (this.s = TextSelectorProp.getTextSelectorProp(e, t.s, r)),
            (this.s.t = t.s.t);
        }
        function TextAnimatorProperty(e, t, r) {
          (this._isFirstFrame = !0),
            (this._hasMaskedPath = !1),
            (this._frameId = -1),
            (this._textData = e),
            (this._renderType = t),
            (this._elem = r),
            (this._animatorsData = createSizedArray(this._textData.a.length)),
            (this._pathData = {}),
            (this._moreOptions = { alignment: {} }),
            (this.renderedLetters = []),
            (this.lettersChangedFlag = !1),
            this.initDynamicPropertyContainer(r);
        }
        function ITextElement() {}
        (TextAnimatorProperty.prototype.searchProperties = function () {
          var e,
            t,
            r = this._textData.a.length,
            n = PropertyFactory.getProp;
          for (e = 0; e < r; e += 1)
            (t = this._textData.a[e]),
              (this._animatorsData[e] = new TextAnimatorDataProperty(
                this._elem,
                t,
                this,
              ));
          this._textData.p && "m" in this._textData.p
            ? ((this._pathData = {
                a: n(this._elem, this._textData.p.a, 0, 0, this),
                f: n(this._elem, this._textData.p.f, 0, 0, this),
                l: n(this._elem, this._textData.p.l, 0, 0, this),
                r: n(this._elem, this._textData.p.r, 0, 0, this),
                p: n(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
              }),
              (this._hasMaskedPath = !0))
            : (this._hasMaskedPath = !1),
            (this._moreOptions.alignment = n(
              this._elem,
              this._textData.m.a,
              1,
              0,
              this,
            ));
        }),
          (TextAnimatorProperty.prototype.getMeasures = function (e, t) {
            if (
              ((this.lettersChangedFlag = t),
              this._mdf ||
                this._isFirstFrame ||
                t ||
                (this._hasMaskedPath && this._pathData.m._mdf))
            ) {
              this._isFirstFrame = !1;
              var r,
                n,
                i,
                a,
                s,
                o,
                l,
                f,
                u,
                c,
                v,
                d,
                p,
                m,
                h,
                g,
                y,
                _,
                b,
                I = this._moreOptions.alignment.v,
                P = this._animatorsData,
                S = this._textData,
                A = this.mHelper,
                R = this._renderType,
                w = this.renderedLetters.length,
                C = e.l;
              if (this._hasMaskedPath) {
                if (
                  ((b = this._pathData.m),
                  !this._pathData.n || this._pathData._mdf)
                ) {
                  var D,
                    M = b.v;
                  for (
                    this._pathData.r.v && (M = M.reverse()),
                      s = { tLength: 0, segments: [] },
                      a = M._length - 1,
                      g = 0,
                      i = 0;
                    i < a;
                    i += 1
                  )
                    (D = bez.buildBezierData(
                      M.v[i],
                      M.v[i + 1],
                      [M.o[i][0] - M.v[i][0], M.o[i][1] - M.v[i][1]],
                      [
                        M.i[i + 1][0] - M.v[i + 1][0],
                        M.i[i + 1][1] - M.v[i + 1][1],
                      ],
                    )),
                      (s.tLength += D.segmentLength),
                      s.segments.push(D),
                      (g += D.segmentLength);
                  (i = a),
                    b.v.c &&
                      ((D = bez.buildBezierData(
                        M.v[i],
                        M.v[0],
                        [M.o[i][0] - M.v[i][0], M.o[i][1] - M.v[i][1]],
                        [M.i[0][0] - M.v[0][0], M.i[0][1] - M.v[0][1]],
                      )),
                      (s.tLength += D.segmentLength),
                      s.segments.push(D),
                      (g += D.segmentLength)),
                    (this._pathData.pi = s);
                }
                if (
                  ((s = this._pathData.pi),
                  (o = this._pathData.f.v),
                  (v = 0),
                  (c = 1),
                  (f = 0),
                  (u = !0),
                  (m = s.segments),
                  o < 0 && b.v.c)
                )
                  for (
                    s.tLength < Math.abs(o) && (o = -Math.abs(o) % s.tLength),
                      c = (p = m[(v = m.length - 1)].points).length - 1;
                    o < 0;

                  )
                    (o += p[c].partialLength),
                      (c -= 1) < 0 && (c = (p = m[(v -= 1)].points).length - 1);
                (d = (p = m[v].points)[c - 1]), (h = (l = p[c]).partialLength);
              }
              (a = C.length), (r = 0), (n = 0);
              var O,
                q,
                B,
                H,
                x,
                L = 1.2 * e.finalSize * 0.714,
                j = !0;
              B = P.length;
              var Y,
                oe,
                U,
                ue,
                le,
                be,
                se,
                he,
                je,
                ge,
                we,
                He,
                qe = -1,
                J = o,
                We = v,
                tr = c,
                Ct = -1,
                T = "",
                F = this.defaultPropsArray;
              if (e.j === 2 || e.j === 1) {
                var N = 0,
                  k = 0,
                  z = e.j === 2 ? -0.5 : -1,
                  V = 0,
                  X = !0;
                for (i = 0; i < a; i += 1)
                  if (C[i].n) {
                    for (N && (N += k); V < i; )
                      (C[V].animatorJustifyOffset = N), (V += 1);
                    (N = 0), (X = !0);
                  } else {
                    for (q = 0; q < B; q += 1)
                      (O = P[q].a).t.propType &&
                        (X && e.j === 2 && (k += O.t.v * z),
                        (x = P[q].s.getMult(
                          C[i].anIndexes[q],
                          S.a[q].s.totalChars,
                        )).length
                          ? (N += O.t.v * x[0] * z)
                          : (N += O.t.v * x * z));
                    X = !1;
                  }
                for (N && (N += k); V < i; )
                  (C[V].animatorJustifyOffset = N), (V += 1);
              }
              for (i = 0; i < a; i += 1) {
                if ((A.reset(), (ue = 1), C[i].n))
                  (r = 0),
                    (n += e.yOffset),
                    (n += j ? 1 : 0),
                    (o = J),
                    (j = !1),
                    this._hasMaskedPath &&
                      ((c = tr),
                      (d = (p = m[(v = We)].points)[c - 1]),
                      (h = (l = p[c]).partialLength),
                      (f = 0)),
                    (T = ""),
                    (we = ""),
                    (je = ""),
                    (He = ""),
                    (F = this.defaultPropsArray);
                else {
                  if (this._hasMaskedPath) {
                    if (Ct !== C[i].line) {
                      switch (e.j) {
                        case 1:
                          o += g - e.lineWidths[C[i].line];
                          break;
                        case 2:
                          o += (g - e.lineWidths[C[i].line]) / 2;
                      }
                      Ct = C[i].line;
                    }
                    qe !== C[i].ind &&
                      (C[qe] && (o += C[qe].extra),
                      (o += C[i].an / 2),
                      (qe = C[i].ind)),
                      (o += I[0] * C[i].an * 0.005);
                    var K = 0;
                    for (q = 0; q < B; q += 1)
                      (O = P[q].a).p.propType &&
                        ((x = P[q].s.getMult(
                          C[i].anIndexes[q],
                          S.a[q].s.totalChars,
                        )).length
                          ? (K += O.p.v[0] * x[0])
                          : (K += O.p.v[0] * x)),
                        O.a.propType &&
                          ((x = P[q].s.getMult(
                            C[i].anIndexes[q],
                            S.a[q].s.totalChars,
                          )).length
                            ? (K += O.a.v[0] * x[0])
                            : (K += O.a.v[0] * x));
                    for (
                      u = !0,
                        this._pathData.a.v &&
                          ((o =
                            0.5 * C[0].an +
                            ((g -
                              this._pathData.f.v -
                              0.5 * C[0].an -
                              0.5 * C[C.length - 1].an) *
                              qe) /
                              (a - 1)),
                          (o += this._pathData.f.v));
                      u;

                    )
                      f + h >= o + K || !p
                        ? ((y = (o + K - f) / l.partialLength),
                          (oe = d.point[0] + (l.point[0] - d.point[0]) * y),
                          (U = d.point[1] + (l.point[1] - d.point[1]) * y),
                          A.translate(
                            -I[0] * C[i].an * 0.005,
                            -I[1] * L * 0.01,
                          ),
                          (u = !1))
                        : p &&
                          ((f += l.partialLength),
                          (c += 1) >= p.length &&
                            ((c = 0),
                            m[(v += 1)]
                              ? (p = m[v].points)
                              : b.v.c
                                ? ((c = 0), (p = m[(v = 0)].points))
                                : ((f -= l.partialLength), (p = null))),
                          p && ((d = l), (h = (l = p[c]).partialLength)));
                    (Y = C[i].an / 2 - C[i].add), A.translate(-Y, 0, 0);
                  } else
                    (Y = C[i].an / 2 - C[i].add),
                      A.translate(-Y, 0, 0),
                      A.translate(-I[0] * C[i].an * 0.005, -I[1] * L * 0.01, 0);
                  for (q = 0; q < B; q += 1)
                    (O = P[q].a).t.propType &&
                      ((x = P[q].s.getMult(
                        C[i].anIndexes[q],
                        S.a[q].s.totalChars,
                      )),
                      (r === 0 && e.j === 0) ||
                        (this._hasMaskedPath
                          ? x.length
                            ? (o += O.t.v * x[0])
                            : (o += O.t.v * x)
                          : x.length
                            ? (r += O.t.v * x[0])
                            : (r += O.t.v * x)));
                  for (
                    e.strokeWidthAnim && (be = e.sw || 0),
                      e.strokeColorAnim &&
                        (le = e.sc ? [e.sc[0], e.sc[1], e.sc[2]] : [0, 0, 0]),
                      e.fillColorAnim &&
                        e.fc &&
                        (se = [e.fc[0], e.fc[1], e.fc[2]]),
                      q = 0;
                    q < B;
                    q += 1
                  )
                    (O = P[q].a).a.propType &&
                      ((x = P[q].s.getMult(
                        C[i].anIndexes[q],
                        S.a[q].s.totalChars,
                      )).length
                        ? A.translate(
                            -O.a.v[0] * x[0],
                            -O.a.v[1] * x[1],
                            O.a.v[2] * x[2],
                          )
                        : A.translate(
                            -O.a.v[0] * x,
                            -O.a.v[1] * x,
                            O.a.v[2] * x,
                          ));
                  for (q = 0; q < B; q += 1)
                    (O = P[q].a).s.propType &&
                      ((x = P[q].s.getMult(
                        C[i].anIndexes[q],
                        S.a[q].s.totalChars,
                      )).length
                        ? A.scale(
                            1 + (O.s.v[0] - 1) * x[0],
                            1 + (O.s.v[1] - 1) * x[1],
                            1,
                          )
                        : A.scale(
                            1 + (O.s.v[0] - 1) * x,
                            1 + (O.s.v[1] - 1) * x,
                            1,
                          ));
                  for (q = 0; q < B; q += 1) {
                    if (
                      ((O = P[q].a),
                      (x = P[q].s.getMult(
                        C[i].anIndexes[q],
                        S.a[q].s.totalChars,
                      )),
                      O.sk.propType &&
                        (x.length
                          ? A.skewFromAxis(-O.sk.v * x[0], O.sa.v * x[1])
                          : A.skewFromAxis(-O.sk.v * x, O.sa.v * x)),
                      O.r.propType &&
                        (x.length
                          ? A.rotateZ(-O.r.v * x[2])
                          : A.rotateZ(-O.r.v * x)),
                      O.ry.propType &&
                        (x.length
                          ? A.rotateY(O.ry.v * x[1])
                          : A.rotateY(O.ry.v * x)),
                      O.rx.propType &&
                        (x.length
                          ? A.rotateX(O.rx.v * x[0])
                          : A.rotateX(O.rx.v * x)),
                      O.o.propType &&
                        (x.length
                          ? (ue += (O.o.v * x[0] - ue) * x[0])
                          : (ue += (O.o.v * x - ue) * x)),
                      e.strokeWidthAnim &&
                        O.sw.propType &&
                        (x.length ? (be += O.sw.v * x[0]) : (be += O.sw.v * x)),
                      e.strokeColorAnim && O.sc.propType)
                    )
                      for (he = 0; he < 3; he += 1)
                        x.length
                          ? (le[he] += (O.sc.v[he] - le[he]) * x[0])
                          : (le[he] += (O.sc.v[he] - le[he]) * x);
                    if (e.fillColorAnim && e.fc) {
                      if (O.fc.propType)
                        for (he = 0; he < 3; he += 1)
                          x.length
                            ? (se[he] += (O.fc.v[he] - se[he]) * x[0])
                            : (se[he] += (O.fc.v[he] - se[he]) * x);
                      O.fh.propType &&
                        (se = x.length
                          ? addHueToRGB(se, O.fh.v * x[0])
                          : addHueToRGB(se, O.fh.v * x)),
                        O.fs.propType &&
                          (se = x.length
                            ? addSaturationToRGB(se, O.fs.v * x[0])
                            : addSaturationToRGB(se, O.fs.v * x)),
                        O.fb.propType &&
                          (se = x.length
                            ? addBrightnessToRGB(se, O.fb.v * x[0])
                            : addBrightnessToRGB(se, O.fb.v * x));
                    }
                  }
                  for (q = 0; q < B; q += 1)
                    (O = P[q].a).p.propType &&
                      ((x = P[q].s.getMult(
                        C[i].anIndexes[q],
                        S.a[q].s.totalChars,
                      )),
                      this._hasMaskedPath
                        ? x.length
                          ? A.translate(0, O.p.v[1] * x[0], -O.p.v[2] * x[1])
                          : A.translate(0, O.p.v[1] * x, -O.p.v[2] * x)
                        : x.length
                          ? A.translate(
                              O.p.v[0] * x[0],
                              O.p.v[1] * x[1],
                              -O.p.v[2] * x[2],
                            )
                          : A.translate(
                              O.p.v[0] * x,
                              O.p.v[1] * x,
                              -O.p.v[2] * x,
                            ));
                  if (
                    (e.strokeWidthAnim && (je = be < 0 ? 0 : be),
                    e.strokeColorAnim &&
                      (ge =
                        "rgb(" +
                        Math.round(255 * le[0]) +
                        "," +
                        Math.round(255 * le[1]) +
                        "," +
                        Math.round(255 * le[2]) +
                        ")"),
                    e.fillColorAnim &&
                      e.fc &&
                      (we =
                        "rgb(" +
                        Math.round(255 * se[0]) +
                        "," +
                        Math.round(255 * se[1]) +
                        "," +
                        Math.round(255 * se[2]) +
                        ")"),
                    this._hasMaskedPath)
                  ) {
                    if (
                      (A.translate(0, -e.ls),
                      A.translate(0, I[1] * L * 0.01 + n, 0),
                      this._pathData.p.v)
                    ) {
                      _ = (l.point[1] - d.point[1]) / (l.point[0] - d.point[0]);
                      var ce = (180 * Math.atan(_)) / Math.PI;
                      l.point[0] < d.point[0] && (ce += 180),
                        A.rotate((-ce * Math.PI) / 180);
                    }
                    A.translate(oe, U, 0),
                      (o -= I[0] * C[i].an * 0.005),
                      C[i + 1] &&
                        qe !== C[i + 1].ind &&
                        ((o += C[i].an / 2), (o += 0.001 * e.tr * e.finalSize));
                  } else {
                    switch (
                      (A.translate(r, n, 0),
                      e.ps && A.translate(e.ps[0], e.ps[1] + e.ascent, 0),
                      e.j)
                    ) {
                      case 1:
                        A.translate(
                          C[i].animatorJustifyOffset +
                            e.justifyOffset +
                            (e.boxWidth - e.lineWidths[C[i].line]),
                          0,
                          0,
                        );
                        break;
                      case 2:
                        A.translate(
                          C[i].animatorJustifyOffset +
                            e.justifyOffset +
                            (e.boxWidth - e.lineWidths[C[i].line]) / 2,
                          0,
                          0,
                        );
                    }
                    A.translate(0, -e.ls),
                      A.translate(Y, 0, 0),
                      A.translate(I[0] * C[i].an * 0.005, I[1] * L * 0.01, 0),
                      (r += C[i].l + 0.001 * e.tr * e.finalSize);
                  }
                  R === "html"
                    ? (T = A.toCSS())
                    : R === "svg"
                      ? (T = A.to2dCSS())
                      : (F = [
                          A.props[0],
                          A.props[1],
                          A.props[2],
                          A.props[3],
                          A.props[4],
                          A.props[5],
                          A.props[6],
                          A.props[7],
                          A.props[8],
                          A.props[9],
                          A.props[10],
                          A.props[11],
                          A.props[12],
                          A.props[13],
                          A.props[14],
                          A.props[15],
                        ]),
                    (He = ue);
                }
                w <= i
                  ? ((H = new LetterProps(He, je, ge, we, T, F)),
                    this.renderedLetters.push(H),
                    (w += 1),
                    (this.lettersChangedFlag = !0))
                  : ((H = this.renderedLetters[i]),
                    (this.lettersChangedFlag =
                      H.update(He, je, ge, we, T, F) ||
                      this.lettersChangedFlag));
              }
            }
          }),
          (TextAnimatorProperty.prototype.getValue = function () {
            this._elem.globalData.frameId !== this._frameId &&
              ((this._frameId = this._elem.globalData.frameId),
              this.iterateDynamicProperties());
          }),
          (TextAnimatorProperty.prototype.mHelper = new Matrix()),
          (TextAnimatorProperty.prototype.defaultPropsArray = []),
          extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
          (ITextElement.prototype.initElement = function (e, t, r) {
            (this.lettersChangedFlag = !0),
              this.initFrame(),
              this.initBaseData(e, t, r),
              (this.textProperty = new TextProperty(
                this,
                e.t,
                this.dynamicProperties,
              )),
              (this.textAnimator = new TextAnimatorProperty(
                e.t,
                this.renderType,
                this,
              )),
              this.initTransform(e, t, r),
              this.initHierarchy(),
              this.initRenderable(),
              this.initRendererElement(),
              this.createContainerElements(),
              this.createRenderableComponents(),
              this.createContent(),
              this.hide(),
              this.textAnimator.searchProperties(this.dynamicProperties);
          }),
          (ITextElement.prototype.prepareFrame = function (e) {
            (this._mdf = !1),
              this.prepareRenderableFrame(e),
              this.prepareProperties(e, this.isInRange);
          }),
          (ITextElement.prototype.createPathShape = function (e, t) {
            var r,
              n,
              i = t.length,
              a = "";
            for (r = 0; r < i; r += 1)
              t[r].ty === "sh" &&
                ((n = t[r].ks.k),
                (a += buildShapeString(n, n.i.length, !0, e)));
            return a;
          }),
          (ITextElement.prototype.updateDocumentData = function (e, t) {
            this.textProperty.updateDocumentData(e, t);
          }),
          (ITextElement.prototype.canResizeFont = function (e) {
            this.textProperty.canResizeFont(e);
          }),
          (ITextElement.prototype.setMinimumFontSize = function (e) {
            this.textProperty.setMinimumFontSize(e);
          }),
          (ITextElement.prototype.applyTextPropertiesToMatrix = function (
            e,
            t,
            r,
            n,
            i,
          ) {
            switch (
              (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0),
              t.translate(0, -e.ls, 0),
              e.j)
            ) {
              case 1:
                t.translate(
                  e.justifyOffset + (e.boxWidth - e.lineWidths[r]),
                  0,
                  0,
                );
                break;
              case 2:
                t.translate(
                  e.justifyOffset + (e.boxWidth - e.lineWidths[r]) / 2,
                  0,
                  0,
                );
            }
            t.translate(n, i, 0);
          }),
          (ITextElement.prototype.buildColor = function (e) {
            return (
              "rgb(" +
              Math.round(255 * e[0]) +
              "," +
              Math.round(255 * e[1]) +
              "," +
              Math.round(255 * e[2]) +
              ")"
            );
          }),
          (ITextElement.prototype.emptyProp = new LetterProps()),
          (ITextElement.prototype.destroy = function () {}),
          (ITextElement.prototype.validateText = function () {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) &&
              (this.buildNewText(),
              (this.textProperty._isFirstFrame = !1),
              (this.textProperty._mdf = !1));
          });
        var emptyShapeData = { shapes: [] };
        function SVGTextLottieElement(e, t, r) {
          (this.textSpans = []),
            (this.renderType = "svg"),
            this.initElement(e, t, r);
        }
        function ISolidElement(e, t, r) {
          this.initElement(e, t, r);
        }
        function NullElement(e, t, r) {
          this.initFrame(),
            this.initBaseData(e, t, r),
            this.initFrame(),
            this.initTransform(e, t, r),
            this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(e, t, r) {
          (this.layers = e.layers),
            (this.supports3d = !0),
            (this.completeLayers = !1),
            (this.pendingElements = []),
            (this.elements = this.layers
              ? createSizedArray(this.layers.length)
              : []),
            this.initElement(e, t, r),
            (this.tm = e.tm
              ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this)
              : { _placeholder: !0 });
        }
        function SVGRenderer(e, t) {
          (this.animationItem = e),
            (this.layers = null),
            (this.renderedFrame = -1),
            (this.svgElement = createNS("svg"));
          var r = "";
          if (t && t.title) {
            var n = createNS("title"),
              i = createElementID();
            n.setAttribute("id", i),
              (n.textContent = t.title),
              this.svgElement.appendChild(n),
              (r += i);
          }
          if (t && t.description) {
            var a = createNS("desc"),
              s = createElementID();
            a.setAttribute("id", s),
              (a.textContent = t.description),
              this.svgElement.appendChild(a),
              (r += " " + s);
          }
          r && this.svgElement.setAttribute("aria-labelledby", r);
          var o = createNS("defs");
          this.svgElement.appendChild(o);
          var l = createNS("g");
          this.svgElement.appendChild(l),
            (this.layerElement = l),
            (this.renderConfig = {
              preserveAspectRatio:
                (t && t.preserveAspectRatio) || "xMidYMid meet",
              imagePreserveAspectRatio:
                (t && t.imagePreserveAspectRatio) || "xMidYMid slice",
              contentVisibility: (t && t.contentVisibility) || "visible",
              progressiveLoad: (t && t.progressiveLoad) || !1,
              hideOnTransparent: !(t && t.hideOnTransparent === !1),
              viewBoxOnly: (t && t.viewBoxOnly) || !1,
              viewBoxSize: (t && t.viewBoxSize) || !1,
              className: (t && t.className) || "",
              id: (t && t.id) || "",
              focusable: t && t.focusable,
              filterSize: {
                width: (t && t.filterSize && t.filterSize.width) || "100%",
                height: (t && t.filterSize && t.filterSize.height) || "100%",
                x: (t && t.filterSize && t.filterSize.x) || "0%",
                y: (t && t.filterSize && t.filterSize.y) || "0%",
              },
              width: t && t.width,
              height: t && t.height,
              runExpressions:
                !t || t.runExpressions === void 0 || t.runExpressions,
            }),
            (this.globalData = {
              _mdf: !1,
              frameNum: -1,
              defs: o,
              renderConfig: this.renderConfig,
            }),
            (this.elements = []),
            (this.pendingElements = []),
            (this.destroyed = !1),
            (this.rendererType = "svg");
        }
        function ShapeTransformManager() {
          (this.sequences = {}),
            (this.sequenceList = []),
            (this.transform_key_count = 0);
        }
        extendPrototype(
          [
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement,
          ],
          SVGTextLottieElement,
        ),
          (SVGTextLottieElement.prototype.createContent = function () {
            this.data.singleShape &&
              !this.globalData.fontManager.chars &&
              (this.textContainer = createNS("text"));
          }),
          (SVGTextLottieElement.prototype.buildTextContents = function (e) {
            for (var t = 0, r = e.length, n = [], i = ""; t < r; )
              e[t] === String.fromCharCode(13) ||
              e[t] === String.fromCharCode(3)
                ? (n.push(i), (i = ""))
                : (i += e[t]),
                (t += 1);
            return n.push(i), n;
          }),
          (SVGTextLottieElement.prototype.buildShapeData = function (e, t) {
            if (e.shapes && e.shapes.length) {
              var r = e.shapes[0];
              if (r.it) {
                var n = r.it[r.it.length - 1];
                n.s && ((n.s.k[0] = t), (n.s.k[1] = t));
              }
            }
            return e;
          }),
          (SVGTextLottieElement.prototype.buildNewText = function () {
            var e, t;
            this.addDynamicProperty(this);
            var r = this.textProperty.currentData;
            (this.renderedLetters = createSizedArray(r ? r.l.length : 0)),
              r.fc
                ? this.layerElement.setAttribute("fill", this.buildColor(r.fc))
                : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
              r.sc &&
                (this.layerElement.setAttribute(
                  "stroke",
                  this.buildColor(r.sc),
                ),
                this.layerElement.setAttribute("stroke-width", r.sw)),
              this.layerElement.setAttribute("font-size", r.finalSize);
            var n = this.globalData.fontManager.getFontByName(r.f);
            if (n.fClass) this.layerElement.setAttribute("class", n.fClass);
            else {
              this.layerElement.setAttribute("font-family", n.fFamily);
              var i = r.fWeight,
                a = r.fStyle;
              this.layerElement.setAttribute("font-style", a),
                this.layerElement.setAttribute("font-weight", i);
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var s,
              o = r.l || [],
              l = !!this.globalData.fontManager.chars;
            t = o.length;
            var f = this.mHelper,
              u = this.data.singleShape,
              c = 0,
              v = 0,
              d = !0,
              p = 0.001 * r.tr * r.finalSize;
            if (!u || l || r.sz) {
              var m,
                h = this.textSpans.length;
              for (e = 0; e < t; e += 1) {
                if (
                  (this.textSpans[e] ||
                    (this.textSpans[e] = {
                      span: null,
                      childSpan: null,
                      glyph: null,
                    }),
                  !l || !u || e === 0)
                ) {
                  if (
                    ((s =
                      h > e
                        ? this.textSpans[e].span
                        : createNS(l ? "g" : "text")),
                    h <= e)
                  ) {
                    if (
                      (s.setAttribute("stroke-linecap", "butt"),
                      s.setAttribute("stroke-linejoin", "round"),
                      s.setAttribute("stroke-miterlimit", "4"),
                      (this.textSpans[e].span = s),
                      l)
                    ) {
                      var g = createNS("g");
                      s.appendChild(g), (this.textSpans[e].childSpan = g);
                    }
                    (this.textSpans[e].span = s),
                      this.layerElement.appendChild(s);
                  }
                  s.style.display = "inherit";
                }
                if (
                  (f.reset(),
                  u &&
                    (o[e].n &&
                      ((c = -p), (v += r.yOffset), (v += d ? 1 : 0), (d = !1)),
                    this.applyTextPropertiesToMatrix(r, f, o[e].line, c, v),
                    (c += o[e].l || 0),
                    (c += p)),
                  l)
                ) {
                  var y;
                  if (
                    (m = this.globalData.fontManager.getCharData(
                      r.finalText[e],
                      n.fStyle,
                      this.globalData.fontManager.getFontByName(r.f).fFamily,
                    )).t === 1
                  )
                    y = new SVGCompElement(m.data, this.globalData, this);
                  else {
                    var _ = emptyShapeData;
                    m.data &&
                      m.data.shapes &&
                      (_ = this.buildShapeData(m.data, r.finalSize)),
                      (y = new SVGShapeElement(_, this.globalData, this));
                  }
                  if (this.textSpans[e].glyph) {
                    var b = this.textSpans[e].glyph;
                    this.textSpans[e].childSpan.removeChild(b.layerElement),
                      b.destroy();
                  }
                  (this.textSpans[e].glyph = y),
                    (y._debug = !0),
                    y.prepareFrame(0),
                    y.renderFrame(),
                    this.textSpans[e].childSpan.appendChild(y.layerElement),
                    m.t === 1 &&
                      this.textSpans[e].childSpan.setAttribute(
                        "transform",
                        "scale(" +
                          r.finalSize / 100 +
                          "," +
                          r.finalSize / 100 +
                          ")",
                      );
                } else
                  u &&
                    s.setAttribute(
                      "transform",
                      "translate(" + f.props[12] + "," + f.props[13] + ")",
                    ),
                    (s.textContent = o[e].val),
                    s.setAttributeNS(
                      "http://www.w3.org/XML/1998/namespace",
                      "xml:space",
                      "preserve",
                    );
              }
              u && s && s.setAttribute("d", "");
            } else {
              var I = this.textContainer,
                P = "start";
              switch (r.j) {
                case 1:
                  P = "end";
                  break;
                case 2:
                  P = "middle";
                  break;
                default:
                  P = "start";
              }
              I.setAttribute("text-anchor", P),
                I.setAttribute("letter-spacing", p);
              var S = this.buildTextContents(r.finalText);
              for (
                t = S.length, v = r.ps ? r.ps[1] + r.ascent : 0, e = 0;
                e < t;
                e += 1
              )
                ((s = this.textSpans[e].span || createNS("tspan")).textContent =
                  S[e]),
                  s.setAttribute("x", 0),
                  s.setAttribute("y", v),
                  (s.style.display = "inherit"),
                  I.appendChild(s),
                  this.textSpans[e] ||
                    (this.textSpans[e] = { span: null, glyph: null }),
                  (this.textSpans[e].span = s),
                  (v += r.finalLineHeight);
              this.layerElement.appendChild(I);
            }
            for (; e < this.textSpans.length; )
              (this.textSpans[e].span.style.display = "none"), (e += 1);
            this._sizeChanged = !0;
          }),
          (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
            if (
              (this.prepareFrame(this.comp.renderedFrame - this.data.st),
              this.renderInnerContent(),
              this._sizeChanged)
            ) {
              this._sizeChanged = !1;
              var e = this.layerElement.getBBox();
              this.bbox = {
                top: e.y,
                left: e.x,
                width: e.width,
                height: e.height,
              };
            }
            return this.bbox;
          }),
          (SVGTextLottieElement.prototype.getValue = function () {
            var e,
              t,
              r = this.textSpans.length;
            for (
              this.renderedFrame = this.comp.renderedFrame, e = 0;
              e < r;
              e += 1
            )
              (t = this.textSpans[e].glyph) &&
                (t.prepareFrame(this.comp.renderedFrame - this.data.st),
                t._mdf && (this._mdf = !0));
          }),
          (SVGTextLottieElement.prototype.renderInnerContent = function () {
            if (
              (this.validateText(),
              (!this.data.singleShape || this._mdf) &&
                (this.textAnimator.getMeasures(
                  this.textProperty.currentData,
                  this.lettersChangedFlag,
                ),
                this.lettersChangedFlag ||
                  this.textAnimator.lettersChangedFlag))
            ) {
              var e, t;
              this._sizeChanged = !0;
              var r,
                n,
                i,
                a = this.textAnimator.renderedLetters,
                s = this.textProperty.currentData.l;
              for (t = s.length, e = 0; e < t; e += 1)
                s[e].n ||
                  ((r = a[e]),
                  (n = this.textSpans[e].span),
                  (i = this.textSpans[e].glyph) && i.renderFrame(),
                  r._mdf.m && n.setAttribute("transform", r.m),
                  r._mdf.o && n.setAttribute("opacity", r.o),
                  r._mdf.sw && n.setAttribute("stroke-width", r.sw),
                  r._mdf.sc && n.setAttribute("stroke", r.sc),
                  r._mdf.fc && n.setAttribute("fill", r.fc));
            }
          }),
          extendPrototype([IImageElement], ISolidElement),
          (ISolidElement.prototype.createContent = function () {
            var e = createNS("rect");
            e.setAttribute("width", this.data.sw),
              e.setAttribute("height", this.data.sh),
              e.setAttribute("fill", this.data.sc),
              this.layerElement.appendChild(e);
          }),
          (NullElement.prototype.prepareFrame = function (e) {
            this.prepareProperties(e, !0);
          }),
          (NullElement.prototype.renderFrame = function () {}),
          (NullElement.prototype.getBaseElement = function () {
            return null;
          }),
          (NullElement.prototype.destroy = function () {}),
          (NullElement.prototype.sourceRectAtTime = function () {}),
          (NullElement.prototype.hide = function () {}),
          extendPrototype(
            [BaseElement, TransformElement, HierarchyElement, FrameElement],
            NullElement,
          ),
          extendPrototype([BaseRenderer], SVGRendererBase),
          (SVGRendererBase.prototype.createNull = function (e) {
            return new NullElement(e, this.globalData, this);
          }),
          (SVGRendererBase.prototype.createShape = function (e) {
            return new SVGShapeElement(e, this.globalData, this);
          }),
          (SVGRendererBase.prototype.createText = function (e) {
            return new SVGTextLottieElement(e, this.globalData, this);
          }),
          (SVGRendererBase.prototype.createImage = function (e) {
            return new IImageElement(e, this.globalData, this);
          }),
          (SVGRendererBase.prototype.createSolid = function (e) {
            return new ISolidElement(e, this.globalData, this);
          }),
          (SVGRendererBase.prototype.configAnimation = function (e) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
              this.svgElement.setAttribute(
                "xmlns:xlink",
                "http://www.w3.org/1999/xlink",
              ),
              this.renderConfig.viewBoxSize
                ? this.svgElement.setAttribute(
                    "viewBox",
                    this.renderConfig.viewBoxSize,
                  )
                : this.svgElement.setAttribute(
                    "viewBox",
                    "0 0 " + e.w + " " + e.h,
                  ),
              this.renderConfig.viewBoxOnly ||
                (this.svgElement.setAttribute("width", e.w),
                this.svgElement.setAttribute("height", e.h),
                (this.svgElement.style.width = "100%"),
                (this.svgElement.style.height = "100%"),
                (this.svgElement.style.transform = "translate3d(0,0,0)"),
                (this.svgElement.style.contentVisibility =
                  this.renderConfig.contentVisibility)),
              this.renderConfig.width &&
                this.svgElement.setAttribute("width", this.renderConfig.width),
              this.renderConfig.height &&
                this.svgElement.setAttribute(
                  "height",
                  this.renderConfig.height,
                ),
              this.renderConfig.className &&
                this.svgElement.setAttribute(
                  "class",
                  this.renderConfig.className,
                ),
              this.renderConfig.id &&
                this.svgElement.setAttribute("id", this.renderConfig.id),
              this.renderConfig.focusable !== void 0 &&
                this.svgElement.setAttribute(
                  "focusable",
                  this.renderConfig.focusable,
                ),
              this.svgElement.setAttribute(
                "preserveAspectRatio",
                this.renderConfig.preserveAspectRatio,
              ),
              this.animationItem.wrapper.appendChild(this.svgElement);
            var t = this.globalData.defs;
            this.setupGlobalData(e, t),
              (this.globalData.progressiveLoad =
                this.renderConfig.progressiveLoad),
              (this.data = e);
            var r = createNS("clipPath"),
              n = createNS("rect");
            n.setAttribute("width", e.w),
              n.setAttribute("height", e.h),
              n.setAttribute("x", 0),
              n.setAttribute("y", 0);
            var i = createElementID();
            r.setAttribute("id", i),
              r.appendChild(n),
              this.layerElement.setAttribute(
                "clip-path",
                "url(" + getLocationHref() + "#" + i + ")",
              ),
              t.appendChild(r),
              (this.layers = e.layers),
              (this.elements = createSizedArray(e.layers.length));
          }),
          (SVGRendererBase.prototype.destroy = function () {
            var e;
            this.animationItem.wrapper &&
              (this.animationItem.wrapper.innerText = ""),
              (this.layerElement = null),
              (this.globalData.defs = null);
            var t = this.layers ? this.layers.length : 0;
            for (e = 0; e < t; e += 1)
              this.elements[e] &&
                this.elements[e].destroy &&
                this.elements[e].destroy();
            (this.elements.length = 0),
              (this.destroyed = !0),
              (this.animationItem = null);
          }),
          (SVGRendererBase.prototype.updateContainerSize = function () {}),
          (SVGRendererBase.prototype.findIndexByInd = function (e) {
            var t = 0,
              r = this.layers.length;
            for (t = 0; t < r; t += 1) if (this.layers[t].ind === e) return t;
            return -1;
          }),
          (SVGRendererBase.prototype.buildItem = function (e) {
            var t = this.elements;
            if (!t[e] && this.layers[e].ty !== 99) {
              t[e] = !0;
              var r = this.createItem(this.layers[e]);
              if (
                ((t[e] = r),
                getExpressionsPlugin() &&
                  (this.layers[e].ty === 0 &&
                    this.globalData.projectInterface.registerComposition(r),
                  r.initExpressions()),
                this.appendElementInPos(r, e),
                this.layers[e].tt)
              ) {
                var n =
                  "tp" in this.layers[e]
                    ? this.findIndexByInd(this.layers[e].tp)
                    : e - 1;
                if (n === -1) return;
                if (this.elements[n] && this.elements[n] !== !0) {
                  var i = t[n].getMatte(this.layers[e].tt);
                  r.setMatte(i);
                } else this.buildItem(n), this.addPendingElement(r);
              }
            }
          }),
          (SVGRendererBase.prototype.checkPendingElements = function () {
            for (; this.pendingElements.length; ) {
              var e = this.pendingElements.pop();
              if ((e.checkParenting(), e.data.tt))
                for (var t = 0, r = this.elements.length; t < r; ) {
                  if (this.elements[t] === e) {
                    var n =
                        "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1,
                      i = this.elements[n].getMatte(this.layers[t].tt);
                    e.setMatte(i);
                    break;
                  }
                  t += 1;
                }
            }
          }),
          (SVGRendererBase.prototype.renderFrame = function (e) {
            if (this.renderedFrame !== e && !this.destroyed) {
              var t;
              e === null ? (e = this.renderedFrame) : (this.renderedFrame = e),
                (this.globalData.frameNum = e),
                (this.globalData.frameId += 1),
                (this.globalData.projectInterface.currentFrame = e),
                (this.globalData._mdf = !1);
              var r = this.layers.length;
              for (
                this.completeLayers || this.checkLayers(e), t = r - 1;
                t >= 0;
                t -= 1
              )
                (this.completeLayers || this.elements[t]) &&
                  this.elements[t].prepareFrame(e - this.layers[t].st);
              if (this.globalData._mdf)
                for (t = 0; t < r; t += 1)
                  (this.completeLayers || this.elements[t]) &&
                    this.elements[t].renderFrame();
            }
          }),
          (SVGRendererBase.prototype.appendElementInPos = function (e, t) {
            var r = e.getBaseElement();
            if (r) {
              for (var n, i = 0; i < t; )
                this.elements[i] &&
                  this.elements[i] !== !0 &&
                  this.elements[i].getBaseElement() &&
                  (n = this.elements[i].getBaseElement()),
                  (i += 1);
              n
                ? this.layerElement.insertBefore(r, n)
                : this.layerElement.appendChild(r);
            }
          }),
          (SVGRendererBase.prototype.hide = function () {
            this.layerElement.style.display = "none";
          }),
          (SVGRendererBase.prototype.show = function () {
            this.layerElement.style.display = "block";
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              HierarchyElement,
              FrameElement,
              RenderableDOMElement,
            ],
            ICompElement,
          ),
          (ICompElement.prototype.initElement = function (e, t, r) {
            this.initFrame(),
              this.initBaseData(e, t, r),
              this.initTransform(e, t, r),
              this.initRenderable(),
              this.initHierarchy(),
              this.initRendererElement(),
              this.createContainerElements(),
              this.createRenderableComponents(),
              (!this.data.xt && t.progressiveLoad) || this.buildAllItems(),
              this.hide();
          }),
          (ICompElement.prototype.prepareFrame = function (e) {
            if (
              ((this._mdf = !1),
              this.prepareRenderableFrame(e),
              this.prepareProperties(e, this.isInRange),
              this.isInRange || this.data.xt)
            ) {
              if (this.tm._placeholder) this.renderedFrame = e / this.data.sr;
              else {
                var t = this.tm.v;
                t === this.data.op && (t = this.data.op - 1),
                  (this.renderedFrame = t);
              }
              var r,
                n = this.elements.length;
              for (
                this.completeLayers || this.checkLayers(this.renderedFrame),
                  r = n - 1;
                r >= 0;
                r -= 1
              )
                (this.completeLayers || this.elements[r]) &&
                  (this.elements[r].prepareFrame(
                    this.renderedFrame - this.layers[r].st,
                  ),
                  this.elements[r]._mdf && (this._mdf = !0));
            }
          }),
          (ICompElement.prototype.renderInnerContent = function () {
            var e,
              t = this.layers.length;
            for (e = 0; e < t; e += 1)
              (this.completeLayers || this.elements[e]) &&
                this.elements[e].renderFrame();
          }),
          (ICompElement.prototype.setElements = function (e) {
            this.elements = e;
          }),
          (ICompElement.prototype.getElements = function () {
            return this.elements;
          }),
          (ICompElement.prototype.destroyElements = function () {
            var e,
              t = this.layers.length;
            for (e = 0; e < t; e += 1)
              this.elements[e] && this.elements[e].destroy();
          }),
          (ICompElement.prototype.destroy = function () {
            this.destroyElements(), this.destroyBaseElement();
          }),
          extendPrototype(
            [SVGRendererBase, ICompElement, SVGBaseElement],
            SVGCompElement,
          ),
          (SVGCompElement.prototype.createComp = function (e) {
            return new SVGCompElement(e, this.globalData, this);
          }),
          extendPrototype([SVGRendererBase], SVGRenderer),
          (SVGRenderer.prototype.createComp = function (e) {
            return new SVGCompElement(e, this.globalData, this);
          }),
          (ShapeTransformManager.prototype = {
            addTransformSequence: function (e) {
              var t,
                r = e.length,
                n = "_";
              for (t = 0; t < r; t += 1) n += e[t].transform.key + "_";
              var i = this.sequences[n];
              return (
                i ||
                  ((i = {
                    transforms: [].concat(e),
                    finalTransform: new Matrix(),
                    _mdf: !1,
                  }),
                  (this.sequences[n] = i),
                  this.sequenceList.push(i)),
                i
              );
            },
            processSequence: function (e, t) {
              for (var r = 0, n = e.transforms.length, i = t; r < n && !t; ) {
                if (e.transforms[r].transform.mProps._mdf) {
                  i = !0;
                  break;
                }
                r += 1;
              }
              if (i)
                for (e.finalTransform.reset(), r = n - 1; r >= 0; r -= 1)
                  e.finalTransform.multiply(e.transforms[r].transform.mProps.v);
              e._mdf = i;
            },
            processSequences: function (e) {
              var t,
                r = this.sequenceList.length;
              for (t = 0; t < r; t += 1)
                this.processSequence(this.sequenceList[t], e);
            },
            getNewKey: function () {
              return (
                (this.transform_key_count += 1), "_" + this.transform_key_count
              );
            },
          });
        var lumaLoader = function () {
          var e = "__lottie_element_luma_buffer",
            t = null,
            r = null,
            n = null;
          function i() {
            var a, s, o;
            t ||
              ((a = createNS("svg")),
              (s = createNS("filter")),
              (o = createNS("feColorMatrix")),
              s.setAttribute("id", e),
              o.setAttribute("type", "matrix"),
              o.setAttribute("color-interpolation-filters", "sRGB"),
              o.setAttribute(
                "values",
                "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0",
              ),
              s.appendChild(o),
              a.appendChild(s),
              a.setAttribute("id", e + "_svg"),
              featureSupport.svgLumaHidden && (a.style.display = "none"),
              (n = a),
              document.body.appendChild(n),
              (t = createTag("canvas")),
              ((r = t.getContext("2d")).filter = "url(#" + e + ")"),
              (r.fillStyle = "rgba(0,0,0,0)"),
              r.fillRect(0, 0, 1, 1));
          }
          return {
            load: i,
            get: function (a) {
              return (
                t || i(),
                (t.width = a.width),
                (t.height = a.height),
                (r.filter = "url(#" + e + ")"),
                t
              );
            },
          };
        };
        function createCanvas(e, t) {
          if (featureSupport.offscreenCanvas) return new OffscreenCanvas(e, t);
          var r = createTag("canvas");
          return (r.width = e), (r.height = t), r;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas,
          },
          registeredEffects = {};
        function CVEffects(e) {
          var t,
            r,
            n = e.data.ef ? e.data.ef.length : 0;
          for (this.filters = [], t = 0; t < n; t += 1) {
            r = null;
            var i = e.data.ef[t].ty;
            registeredEffects[i] &&
              (r = new registeredEffects[i].effect(
                e.effectsManager.effectElements[t],
                e,
              )),
              r && this.filters.push(r);
          }
          this.filters.length && e.addRenderableComponent(this);
        }
        function registerEffect(e, t) {
          registeredEffects[e] = { effect: t };
        }
        function CVMaskElement(e, t) {
          var r;
          (this.data = e),
            (this.element = t),
            (this.masksProperties = this.data.masksProperties || []),
            (this.viewData = createSizedArray(this.masksProperties.length));
          var n = this.masksProperties.length,
            i = !1;
          for (r = 0; r < n; r += 1)
            this.masksProperties[r].mode !== "n" && (i = !0),
              (this.viewData[r] = ShapePropertyFactory.getShapeProp(
                this.element,
                this.masksProperties[r],
                3,
              ));
          (this.hasMasks = i), i && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        (CVEffects.prototype.renderFrame = function (e) {
          var t,
            r = this.filters.length;
          for (t = 0; t < r; t += 1) this.filters[t].renderFrame(e);
        }),
          (CVEffects.prototype.getEffects = function (e) {
            var t,
              r = this.filters.length,
              n = [];
            for (t = 0; t < r; t += 1)
              this.filters[t].type === e && n.push(this.filters[t]);
            return n;
          }),
          (CVMaskElement.prototype.renderFrame = function () {
            if (this.hasMasks) {
              var e,
                t,
                r,
                n,
                i = this.element.finalTransform.mat,
                a = this.element.canvasContext,
                s = this.masksProperties.length;
              for (a.beginPath(), e = 0; e < s; e += 1)
                if (this.masksProperties[e].mode !== "n") {
                  var o;
                  this.masksProperties[e].inv &&
                    (a.moveTo(0, 0),
                    a.lineTo(this.element.globalData.compSize.w, 0),
                    a.lineTo(
                      this.element.globalData.compSize.w,
                      this.element.globalData.compSize.h,
                    ),
                    a.lineTo(0, this.element.globalData.compSize.h),
                    a.lineTo(0, 0)),
                    (n = this.viewData[e].v),
                    (t = i.applyToPointArray(n.v[0][0], n.v[0][1], 0)),
                    a.moveTo(t[0], t[1]);
                  var l = n._length;
                  for (o = 1; o < l; o += 1)
                    (r = i.applyToTriplePoints(n.o[o - 1], n.i[o], n.v[o])),
                      a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                  (r = i.applyToTriplePoints(n.o[o - 1], n.i[0], n.v[0])),
                    a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                }
              this.element.globalData.renderer.save(!0), a.clip();
            }
          }),
          (CVMaskElement.prototype.getMaskProperty =
            MaskElement.prototype.getMaskProperty),
          (CVMaskElement.prototype.destroy = function () {
            this.element = null;
          });
        var operationsMap = {
          1: "source-in",
          2: "source-out",
          3: "source-in",
          4: "source-out",
        };
        function CVShapeData(e, t, r, n) {
          (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
          var i,
            a = 4;
          t.ty === "rc"
            ? (a = 5)
            : t.ty === "el"
              ? (a = 6)
              : t.ty === "sr" && (a = 7),
            (this.sh = ShapePropertyFactory.getShapeProp(e, t, a, e));
          var s,
            o = r.length;
          for (i = 0; i < o; i += 1)
            r[i].closed ||
              ((s = {
                transforms: n.addTransformSequence(r[i].transforms),
                trNodes: [],
              }),
              this.styledShapes.push(s),
              r[i].elements.push(s));
        }
        function CVShapeElement(e, t, r) {
          (this.shapes = []),
            (this.shapesData = e.shapes),
            (this.stylesList = []),
            (this.itemsData = []),
            (this.prevViewData = []),
            (this.shapeModifiers = []),
            (this.processedElements = []),
            (this.transformsManager = new ShapeTransformManager()),
            this.initElement(e, t, r);
        }
        function CVTextElement(e, t, r) {
          (this.textSpans = []),
            (this.yOffset = 0),
            (this.fillColorAnim = !1),
            (this.strokeColorAnim = !1),
            (this.strokeWidthAnim = !1),
            (this.stroke = !1),
            (this.fill = !1),
            (this.justifyOffset = 0),
            (this.currentRender = null),
            (this.renderType = "canvas"),
            (this.values = {
              fill: "rgba(0,0,0,0)",
              stroke: "rgba(0,0,0,0)",
              sWidth: 0,
              fValue: "",
            }),
            this.initElement(e, t, r);
        }
        function CVImageElement(e, t, r) {
          (this.assetData = t.getAssetData(e.refId)),
            (this.img = t.imageLoader.getAsset(this.assetData)),
            this.initElement(e, t, r);
        }
        function CVSolidElement(e, t, r) {
          this.initElement(e, t, r);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
          (this.opacity = -1),
            (this.transform = createTypedArray("float32", 16)),
            (this.fillStyle = ""),
            (this.strokeStyle = ""),
            (this.lineWidth = ""),
            (this.lineCap = ""),
            (this.lineJoin = ""),
            (this.miterLimit = ""),
            (this.id = Math.random());
        }
        function CVContextData() {
          var e;
          for (
            this.stack = [], this.cArrPos = 0, this.cTr = new Matrix(), e = 0;
            e < 15;
            e += 1
          ) {
            var t = new CanvasContext();
            this.stack[e] = t;
          }
          (this._length = 15),
            (this.nativeContext = null),
            (this.transformMat = new Matrix()),
            (this.currentOpacity = 1),
            (this.currentFillStyle = ""),
            (this.appliedFillStyle = ""),
            (this.currentStrokeStyle = ""),
            (this.appliedStrokeStyle = ""),
            (this.currentLineWidth = ""),
            (this.appliedLineWidth = ""),
            (this.currentLineCap = ""),
            (this.appliedLineCap = ""),
            (this.currentLineJoin = ""),
            (this.appliedLineJoin = ""),
            (this.appliedMiterLimit = ""),
            (this.currentMiterLimit = "");
        }
        function CVCompElement(e, t, r) {
          (this.completeLayers = !1),
            (this.layers = e.layers),
            (this.pendingElements = []),
            (this.elements = createSizedArray(this.layers.length)),
            this.initElement(e, t, r),
            (this.tm = e.tm
              ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this)
              : { _placeholder: !0 });
        }
        function CanvasRenderer(e, t) {
          (this.animationItem = e),
            (this.renderConfig = {
              clearCanvas: !t || t.clearCanvas === void 0 || t.clearCanvas,
              context: (t && t.context) || null,
              progressiveLoad: (t && t.progressiveLoad) || !1,
              preserveAspectRatio:
                (t && t.preserveAspectRatio) || "xMidYMid meet",
              imagePreserveAspectRatio:
                (t && t.imagePreserveAspectRatio) || "xMidYMid slice",
              contentVisibility: (t && t.contentVisibility) || "visible",
              className: (t && t.className) || "",
              id: (t && t.id) || "",
              runExpressions:
                !t || t.runExpressions === void 0 || t.runExpressions,
            }),
            (this.renderConfig.dpr = (t && t.dpr) || 1),
            this.animationItem.wrapper &&
              (this.renderConfig.dpr =
                (t && t.dpr) || window.devicePixelRatio || 1),
            (this.renderedFrame = -1),
            (this.globalData = {
              frameNum: -1,
              _mdf: !1,
              renderConfig: this.renderConfig,
              currentGlobalAlpha: -1,
            }),
            (this.contextData = new CVContextData()),
            (this.elements = []),
            (this.pendingElements = []),
            (this.transformMat = new Matrix()),
            (this.completeLayers = !1),
            (this.rendererType = "canvas"),
            this.renderConfig.clearCanvas &&
              ((this.ctxTransform = this.contextData.transform.bind(
                this.contextData,
              )),
              (this.ctxOpacity = this.contextData.opacity.bind(
                this.contextData,
              )),
              (this.ctxFillStyle = this.contextData.fillStyle.bind(
                this.contextData,
              )),
              (this.ctxStrokeStyle = this.contextData.strokeStyle.bind(
                this.contextData,
              )),
              (this.ctxLineWidth = this.contextData.lineWidth.bind(
                this.contextData,
              )),
              (this.ctxLineCap = this.contextData.lineCap.bind(
                this.contextData,
              )),
              (this.ctxLineJoin = this.contextData.lineJoin.bind(
                this.contextData,
              )),
              (this.ctxMiterLimit = this.contextData.miterLimit.bind(
                this.contextData,
              )),
              (this.ctxFill = this.contextData.fill.bind(this.contextData)),
              (this.ctxFillRect = this.contextData.fillRect.bind(
                this.contextData,
              )),
              (this.ctxStroke = this.contextData.stroke.bind(this.contextData)),
              (this.save = this.contextData.save.bind(this.contextData)));
        }
        function HBaseElement() {}
        function HSolidElement(e, t, r) {
          this.initElement(e, t, r);
        }
        function HShapeElement(e, t, r) {
          (this.shapes = []),
            (this.shapesData = e.shapes),
            (this.stylesList = []),
            (this.shapeModifiers = []),
            (this.itemsData = []),
            (this.processedElements = []),
            (this.animatedContents = []),
            (this.shapesContainer = createNS("g")),
            this.initElement(e, t, r),
            (this.prevViewData = []),
            (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
        }
        function HTextElement(e, t, r) {
          (this.textSpans = []),
            (this.textPaths = []),
            (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }),
            (this.renderType = "svg"),
            (this.isMasked = !1),
            this.initElement(e, t, r);
        }
        function HCameraElement(e, t, r) {
          this.initFrame(), this.initBaseData(e, t, r), this.initHierarchy();
          var n = PropertyFactory.getProp;
          if (
            ((this.pe = n(this, e.pe, 0, 0, this)),
            e.ks.p.s
              ? ((this.px = n(this, e.ks.p.x, 1, 0, this)),
                (this.py = n(this, e.ks.p.y, 1, 0, this)),
                (this.pz = n(this, e.ks.p.z, 1, 0, this)))
              : (this.p = n(this, e.ks.p, 1, 0, this)),
            e.ks.a && (this.a = n(this, e.ks.a, 1, 0, this)),
            e.ks.or.k.length && e.ks.or.k[0].to)
          ) {
            var i,
              a = e.ks.or.k.length;
            for (i = 0; i < a; i += 1)
              (e.ks.or.k[i].to = null), (e.ks.or.k[i].ti = null);
          }
          (this.or = n(this, e.ks.or, 1, degToRads, this)),
            (this.or.sh = !0),
            (this.rx = n(this, e.ks.rx, 0, degToRads, this)),
            (this.ry = n(this, e.ks.ry, 0, degToRads, this)),
            (this.rz = n(this, e.ks.rz, 0, degToRads, this)),
            (this.mat = new Matrix()),
            (this._prevMat = new Matrix()),
            (this._isFirstFrame = !0),
            (this.finalTransform = { mProp: this });
        }
        function HImageElement(e, t, r) {
          (this.assetData = t.getAssetData(e.refId)), this.initElement(e, t, r);
        }
        function HybridRendererBase(e, t) {
          (this.animationItem = e),
            (this.layers = null),
            (this.renderedFrame = -1),
            (this.renderConfig = {
              className: (t && t.className) || "",
              imagePreserveAspectRatio:
                (t && t.imagePreserveAspectRatio) || "xMidYMid slice",
              hideOnTransparent: !(t && t.hideOnTransparent === !1),
              filterSize: {
                width: (t && t.filterSize && t.filterSize.width) || "400%",
                height: (t && t.filterSize && t.filterSize.height) || "400%",
                x: (t && t.filterSize && t.filterSize.x) || "-100%",
                y: (t && t.filterSize && t.filterSize.y) || "-100%",
              },
            }),
            (this.globalData = {
              _mdf: !1,
              frameNum: -1,
              renderConfig: this.renderConfig,
            }),
            (this.pendingElements = []),
            (this.elements = []),
            (this.threeDElements = []),
            (this.destroyed = !1),
            (this.camera = null),
            (this.supports3d = !0),
            (this.rendererType = "html");
        }
        function HCompElement(e, t, r) {
          (this.layers = e.layers),
            (this.supports3d = !e.hasMask),
            (this.completeLayers = !1),
            (this.pendingElements = []),
            (this.elements = this.layers
              ? createSizedArray(this.layers.length)
              : []),
            this.initElement(e, t, r),
            (this.tm = e.tm
              ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this)
              : { _placeholder: !0 });
        }
        function HybridRenderer(e, t) {
          (this.animationItem = e),
            (this.layers = null),
            (this.renderedFrame = -1),
            (this.renderConfig = {
              className: (t && t.className) || "",
              imagePreserveAspectRatio:
                (t && t.imagePreserveAspectRatio) || "xMidYMid slice",
              hideOnTransparent: !(t && t.hideOnTransparent === !1),
              filterSize: {
                width: (t && t.filterSize && t.filterSize.width) || "400%",
                height: (t && t.filterSize && t.filterSize.height) || "400%",
                x: (t && t.filterSize && t.filterSize.x) || "-100%",
                y: (t && t.filterSize && t.filterSize.y) || "-100%",
              },
              runExpressions:
                !t || t.runExpressions === void 0 || t.runExpressions,
            }),
            (this.globalData = {
              _mdf: !1,
              frameNum: -1,
              renderConfig: this.renderConfig,
            }),
            (this.pendingElements = []),
            (this.elements = []),
            (this.threeDElements = []),
            (this.destroyed = !1),
            (this.camera = null),
            (this.supports3d = !0),
            (this.rendererType = "html");
        }
        (CVBaseElement.prototype = {
          createElements: function () {},
          initRendererElement: function () {},
          createContainerElements: function () {
            if (this.data.tt >= 1) {
              this.buffers = [];
              var e = this.globalData.canvasContext,
                t = assetLoader.createCanvas(e.canvas.width, e.canvas.height);
              this.buffers.push(t);
              var r = assetLoader.createCanvas(e.canvas.width, e.canvas.height);
              this.buffers.push(r),
                this.data.tt >= 3 &&
                  !document._isProxy &&
                  assetLoader.loadLumaCanvas();
            }
            (this.canvasContext = this.globalData.canvasContext),
              (this.transformCanvas = this.globalData.transformCanvas),
              (this.renderableEffectsManager = new CVEffects(this)),
              this.searchEffectTransforms();
          },
          createContent: function () {},
          setBlendMode: function () {
            var e = this.globalData;
            if (e.blendMode !== this.data.bm) {
              e.blendMode = this.data.bm;
              var t = getBlendMode(this.data.bm);
              e.canvasContext.globalCompositeOperation = t;
            }
          },
          createRenderableComponents: function () {
            (this.maskManager = new CVMaskElement(this.data, this)),
              (this.transformEffects = this.renderableEffectsManager.getEffects(
                effectTypes.TRANSFORM_EFFECT,
              ));
          },
          hideElement: function () {
            this.hidden ||
              (this.isInRange && !this.isTransparent) ||
              (this.hidden = !0);
          },
          showElement: function () {
            this.isInRange &&
              !this.isTransparent &&
              ((this.hidden = !1),
              (this._isFirstFrame = !0),
              (this.maskManager._isFirstFrame = !0));
          },
          clearCanvas: function (e) {
            e.clearRect(
              this.transformCanvas.tx,
              this.transformCanvas.ty,
              this.transformCanvas.w * this.transformCanvas.sx,
              this.transformCanvas.h * this.transformCanvas.sy,
            );
          },
          prepareLayer: function () {
            if (this.data.tt >= 1) {
              var e = this.buffers[0].getContext("2d");
              this.clearCanvas(e),
                e.drawImage(this.canvasContext.canvas, 0, 0),
                (this.currentTransform = this.canvasContext.getTransform()),
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                this.clearCanvas(this.canvasContext),
                this.canvasContext.setTransform(this.currentTransform);
            }
          },
          exitLayer: function () {
            if (this.data.tt >= 1) {
              var e = this.buffers[1],
                t = e.getContext("2d");
              if (
                (this.clearCanvas(t),
                t.drawImage(this.canvasContext.canvas, 0, 0),
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                this.clearCanvas(this.canvasContext),
                this.canvasContext.setTransform(this.currentTransform),
                this.comp
                  .getElementById(
                    "tp" in this.data ? this.data.tp : this.data.ind - 1,
                  )
                  .renderFrame(!0),
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
                this.data.tt >= 3 && !document._isProxy)
              ) {
                var r = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                r.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0),
                  this.clearCanvas(this.canvasContext),
                  this.canvasContext.drawImage(r, 0, 0);
              }
              (this.canvasContext.globalCompositeOperation =
                operationsMap[this.data.tt]),
                this.canvasContext.drawImage(e, 0, 0),
                (this.canvasContext.globalCompositeOperation =
                  "destination-over"),
                this.canvasContext.drawImage(this.buffers[0], 0, 0),
                this.canvasContext.setTransform(this.currentTransform),
                (this.canvasContext.globalCompositeOperation = "source-over");
            }
          },
          renderFrame: function (e) {
            if (!this.hidden && !this.data.hd && (this.data.td !== 1 || e)) {
              this.renderTransform(),
                this.renderRenderable(),
                this.renderLocalTransform(),
                this.setBlendMode();
              var t = this.data.ty === 0;
              this.prepareLayer(),
                this.globalData.renderer.save(t),
                this.globalData.renderer.ctxTransform(
                  this.finalTransform.localMat.props,
                ),
                this.globalData.renderer.ctxOpacity(
                  this.finalTransform.localOpacity,
                ),
                this.renderInnerContent(),
                this.globalData.renderer.restore(t),
                this.exitLayer(),
                this.maskManager.hasMasks &&
                  this.globalData.renderer.restore(!0),
                this._isFirstFrame && (this._isFirstFrame = !1);
            }
          },
          destroy: function () {
            (this.canvasContext = null),
              (this.data = null),
              (this.globalData = null),
              this.maskManager.destroy();
          },
          mHelper: new Matrix(),
        }),
          (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
          (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
          (CVShapeData.prototype.setAsAnimated =
            SVGShapeData.prototype.setAsAnimated),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              CVBaseElement,
              IShapeElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
            ],
            CVShapeElement,
          ),
          (CVShapeElement.prototype.initElement =
            RenderableDOMElement.prototype.initElement),
          (CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1,
          }),
          (CVShapeElement.prototype.dashResetter = []),
          (CVShapeElement.prototype.createContent = function () {
            this.searchShapes(
              this.shapesData,
              this.itemsData,
              this.prevViewData,
              !0,
              [],
            );
          }),
          (CVShapeElement.prototype.createStyleElement = function (e, t) {
            var r = {
                data: e,
                type: e.ty,
                preTransforms: this.transformsManager.addTransformSequence(t),
                transforms: [],
                elements: [],
                closed: e.hd === !0,
              },
              n = {};
            if (
              (e.ty === "fl" || e.ty === "st"
                ? ((n.c = PropertyFactory.getProp(this, e.c, 1, 255, this)),
                  n.c.k ||
                    (r.co =
                      "rgb(" +
                      bmFloor(n.c.v[0]) +
                      "," +
                      bmFloor(n.c.v[1]) +
                      "," +
                      bmFloor(n.c.v[2]) +
                      ")"))
                : (e.ty !== "gf" && e.ty !== "gs") ||
                  ((n.s = PropertyFactory.getProp(this, e.s, 1, null, this)),
                  (n.e = PropertyFactory.getProp(this, e.e, 1, null, this)),
                  (n.h = PropertyFactory.getProp(
                    this,
                    e.h || { k: 0 },
                    0,
                    0.01,
                    this,
                  )),
                  (n.a = PropertyFactory.getProp(
                    this,
                    e.a || { k: 0 },
                    0,
                    degToRads,
                    this,
                  )),
                  (n.g = new GradientProperty(this, e.g, this))),
              (n.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this)),
              e.ty === "st" || e.ty === "gs")
            ) {
              if (
                ((r.lc = lineCapEnum[e.lc || 2]),
                (r.lj = lineJoinEnum[e.lj || 2]),
                e.lj == 1 && (r.ml = e.ml),
                (n.w = PropertyFactory.getProp(this, e.w, 0, null, this)),
                n.w.k || (r.wi = n.w.v),
                e.d)
              ) {
                var i = new DashProperty(this, e.d, "canvas", this);
                (n.d = i),
                  n.d.k || ((r.da = n.d.dashArray), (r.do = n.d.dashoffset[0]));
              }
            } else r.r = e.r === 2 ? "evenodd" : "nonzero";
            return this.stylesList.push(r), (n.style = r), n;
          }),
          (CVShapeElement.prototype.createGroupElement = function () {
            return { it: [], prevViewData: [] };
          }),
          (CVShapeElement.prototype.createTransformElement = function (e) {
            return {
              transform: {
                opacity: 1,
                _opMdf: !1,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(
                  this,
                  e,
                  this,
                ),
              },
            };
          }),
          (CVShapeElement.prototype.createShapeElement = function (e) {
            var t = new CVShapeData(
              this,
              e,
              this.stylesList,
              this.transformsManager,
            );
            return this.shapes.push(t), this.addShapeToModifiers(t), t;
          }),
          (CVShapeElement.prototype.reloadShapes = function () {
            var e;
            this._isFirstFrame = !0;
            var t = this.itemsData.length;
            for (e = 0; e < t; e += 1) this.prevViewData[e] = this.itemsData[e];
            for (
              this.searchShapes(
                this.shapesData,
                this.itemsData,
                this.prevViewData,
                !0,
                [],
              ),
                t = this.dynamicProperties.length,
                e = 0;
              e < t;
              e += 1
            )
              this.dynamicProperties[e].getValue();
            this.renderModifiers(),
              this.transformsManager.processSequences(this._isFirstFrame);
          }),
          (CVShapeElement.prototype.addTransformToStyleList = function (e) {
            var t,
              r = this.stylesList.length;
            for (t = 0; t < r; t += 1)
              this.stylesList[t].closed ||
                this.stylesList[t].transforms.push(e);
          }),
          (CVShapeElement.prototype.removeTransformFromStyleList = function () {
            var e,
              t = this.stylesList.length;
            for (e = 0; e < t; e += 1)
              this.stylesList[e].closed || this.stylesList[e].transforms.pop();
          }),
          (CVShapeElement.prototype.closeStyles = function (e) {
            var t,
              r = e.length;
            for (t = 0; t < r; t += 1) e[t].closed = !0;
          }),
          (CVShapeElement.prototype.searchShapes = function (e, t, r, n, i) {
            var a,
              s,
              o,
              l,
              f,
              u,
              c = e.length - 1,
              v = [],
              d = [],
              p = [].concat(i);
            for (a = c; a >= 0; a -= 1) {
              if (
                ((l = this.searchProcessedElement(e[a]))
                  ? (t[a] = r[l - 1])
                  : (e[a]._shouldRender = n),
                e[a].ty === "fl" ||
                  e[a].ty === "st" ||
                  e[a].ty === "gf" ||
                  e[a].ty === "gs")
              )
                l
                  ? (t[a].style.closed = !1)
                  : (t[a] = this.createStyleElement(e[a], p)),
                  v.push(t[a].style);
              else if (e[a].ty === "gr") {
                if (l)
                  for (o = t[a].it.length, s = 0; s < o; s += 1)
                    t[a].prevViewData[s] = t[a].it[s];
                else t[a] = this.createGroupElement(e[a]);
                this.searchShapes(e[a].it, t[a].it, t[a].prevViewData, n, p);
              } else
                e[a].ty === "tr"
                  ? (l || ((u = this.createTransformElement(e[a])), (t[a] = u)),
                    p.push(t[a]),
                    this.addTransformToStyleList(t[a]))
                  : e[a].ty === "sh" ||
                      e[a].ty === "rc" ||
                      e[a].ty === "el" ||
                      e[a].ty === "sr"
                    ? l || (t[a] = this.createShapeElement(e[a]))
                    : e[a].ty === "tm" ||
                        e[a].ty === "rd" ||
                        e[a].ty === "pb" ||
                        e[a].ty === "zz" ||
                        e[a].ty === "op"
                      ? (l
                          ? ((f = t[a]).closed = !1)
                          : ((f = ShapeModifiers.getModifier(e[a].ty)).init(
                              this,
                              e[a],
                            ),
                            (t[a] = f),
                            this.shapeModifiers.push(f)),
                        d.push(f))
                      : e[a].ty === "rp" &&
                        (l
                          ? ((f = t[a]).closed = !0)
                          : ((f = ShapeModifiers.getModifier(e[a].ty)),
                            (t[a] = f),
                            f.init(this, e, a, t),
                            this.shapeModifiers.push(f),
                            (n = !1)),
                        d.push(f));
              this.addProcessedElement(e[a], a + 1);
            }
            for (
              this.removeTransformFromStyleList(),
                this.closeStyles(v),
                c = d.length,
                a = 0;
              a < c;
              a += 1
            )
              d[a].closed = !0;
          }),
          (CVShapeElement.prototype.renderInnerContent = function () {
            (this.transformHelper.opacity = 1),
              (this.transformHelper._opMdf = !1),
              this.renderModifiers(),
              this.transformsManager.processSequences(this._isFirstFrame),
              this.renderShape(
                this.transformHelper,
                this.shapesData,
                this.itemsData,
                !0,
              );
          }),
          (CVShapeElement.prototype.renderShapeTransform = function (e, t) {
            (e._opMdf || t.op._mdf || this._isFirstFrame) &&
              ((t.opacity = e.opacity), (t.opacity *= t.op.v), (t._opMdf = !0));
          }),
          (CVShapeElement.prototype.drawLayer = function () {
            var e,
              t,
              r,
              n,
              i,
              a,
              s,
              o,
              l,
              f = this.stylesList.length,
              u = this.globalData.renderer,
              c = this.globalData.canvasContext;
            for (e = 0; e < f; e += 1)
              if (
                (((o = (l = this.stylesList[e]).type) !== "st" && o !== "gs") ||
                  l.wi !== 0) &&
                l.data._shouldRender &&
                l.coOp !== 0 &&
                this.globalData.currentGlobalAlpha !== 0
              ) {
                for (
                  u.save(),
                    a = l.elements,
                    o === "st" || o === "gs"
                      ? (u.ctxStrokeStyle(o === "st" ? l.co : l.grd),
                        u.ctxLineWidth(l.wi),
                        u.ctxLineCap(l.lc),
                        u.ctxLineJoin(l.lj),
                        u.ctxMiterLimit(l.ml || 0))
                      : u.ctxFillStyle(o === "fl" ? l.co : l.grd),
                    u.ctxOpacity(l.coOp),
                    o !== "st" && o !== "gs" && c.beginPath(),
                    u.ctxTransform(l.preTransforms.finalTransform.props),
                    r = a.length,
                    t = 0;
                  t < r;
                  t += 1
                ) {
                  for (
                    (o !== "st" && o !== "gs") ||
                      (c.beginPath(),
                      l.da && (c.setLineDash(l.da), (c.lineDashOffset = l.do))),
                      i = (s = a[t].trNodes).length,
                      n = 0;
                    n < i;
                    n += 1
                  )
                    s[n].t === "m"
                      ? c.moveTo(s[n].p[0], s[n].p[1])
                      : s[n].t === "c"
                        ? c.bezierCurveTo(
                            s[n].pts[0],
                            s[n].pts[1],
                            s[n].pts[2],
                            s[n].pts[3],
                            s[n].pts[4],
                            s[n].pts[5],
                          )
                        : c.closePath();
                  (o !== "st" && o !== "gs") ||
                    (u.ctxStroke(), l.da && c.setLineDash(this.dashResetter));
                }
                o !== "st" &&
                  o !== "gs" &&
                  this.globalData.renderer.ctxFill(l.r),
                  u.restore();
              }
          }),
          (CVShapeElement.prototype.renderShape = function (e, t, r, n) {
            var i, a;
            for (a = e, i = t.length - 1; i >= 0; i -= 1)
              t[i].ty === "tr"
                ? ((a = r[i].transform), this.renderShapeTransform(e, a))
                : t[i].ty === "sh" ||
                    t[i].ty === "el" ||
                    t[i].ty === "rc" ||
                    t[i].ty === "sr"
                  ? this.renderPath(t[i], r[i])
                  : t[i].ty === "fl"
                    ? this.renderFill(t[i], r[i], a)
                    : t[i].ty === "st"
                      ? this.renderStroke(t[i], r[i], a)
                      : t[i].ty === "gf" || t[i].ty === "gs"
                        ? this.renderGradientFill(t[i], r[i], a)
                        : t[i].ty === "gr"
                          ? this.renderShape(a, t[i].it, r[i].it)
                          : t[i].ty;
            n && this.drawLayer();
          }),
          (CVShapeElement.prototype.renderStyledShape = function (e, t) {
            if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
              var r,
                n,
                i,
                a = e.trNodes,
                s = t.paths,
                o = s._length;
              a.length = 0;
              var l = e.transforms.finalTransform;
              for (i = 0; i < o; i += 1) {
                var f = s.shapes[i];
                if (f && f.v) {
                  for (n = f._length, r = 1; r < n; r += 1)
                    r === 1 &&
                      a.push({
                        t: "m",
                        p: l.applyToPointArray(f.v[0][0], f.v[0][1], 0),
                      }),
                      a.push({
                        t: "c",
                        pts: l.applyToTriplePoints(f.o[r - 1], f.i[r], f.v[r]),
                      });
                  n === 1 &&
                    a.push({
                      t: "m",
                      p: l.applyToPointArray(f.v[0][0], f.v[0][1], 0),
                    }),
                    f.c &&
                      n &&
                      (a.push({
                        t: "c",
                        pts: l.applyToTriplePoints(f.o[r - 1], f.i[0], f.v[0]),
                      }),
                      a.push({ t: "z" }));
                }
              }
              e.trNodes = a;
            }
          }),
          (CVShapeElement.prototype.renderPath = function (e, t) {
            if (e.hd !== !0 && e._shouldRender) {
              var r,
                n = t.styledShapes.length;
              for (r = 0; r < n; r += 1)
                this.renderStyledShape(t.styledShapes[r], t.sh);
            }
          }),
          (CVShapeElement.prototype.renderFill = function (e, t, r) {
            var n = t.style;
            (t.c._mdf || this._isFirstFrame) &&
              (n.co =
                "rgb(" +
                bmFloor(t.c.v[0]) +
                "," +
                bmFloor(t.c.v[1]) +
                "," +
                bmFloor(t.c.v[2]) +
                ")"),
              (t.o._mdf || r._opMdf || this._isFirstFrame) &&
                (n.coOp = t.o.v * r.opacity);
          }),
          (CVShapeElement.prototype.renderGradientFill = function (e, t, r) {
            var n,
              i = t.style;
            if (
              !i.grd ||
              t.g._mdf ||
              t.s._mdf ||
              t.e._mdf ||
              (e.t !== 1 && (t.h._mdf || t.a._mdf))
            ) {
              var a,
                s = this.globalData.canvasContext,
                o = t.s.v,
                l = t.e.v;
              if (e.t === 1) n = s.createLinearGradient(o[0], o[1], l[0], l[1]);
              else {
                var f = Math.sqrt(
                    Math.pow(o[0] - l[0], 2) + Math.pow(o[1] - l[1], 2),
                  ),
                  u = Math.atan2(l[1] - o[1], l[0] - o[0]),
                  c = t.h.v;
                c >= 1 ? (c = 0.99) : c <= -1 && (c = -0.99);
                var v = f * c,
                  d = Math.cos(u + t.a.v) * v + o[0],
                  p = Math.sin(u + t.a.v) * v + o[1];
                n = s.createRadialGradient(d, p, 0, o[0], o[1], f);
              }
              var m = e.g.p,
                h = t.g.c,
                g = 1;
              for (a = 0; a < m; a += 1)
                t.g._hasOpacity && t.g._collapsable && (g = t.g.o[2 * a + 1]),
                  n.addColorStop(
                    h[4 * a] / 100,
                    "rgba(" +
                      h[4 * a + 1] +
                      "," +
                      h[4 * a + 2] +
                      "," +
                      h[4 * a + 3] +
                      "," +
                      g +
                      ")",
                  );
              i.grd = n;
            }
            i.coOp = t.o.v * r.opacity;
          }),
          (CVShapeElement.prototype.renderStroke = function (e, t, r) {
            var n = t.style,
              i = t.d;
            i &&
              (i._mdf || this._isFirstFrame) &&
              ((n.da = i.dashArray), (n.do = i.dashoffset[0])),
              (t.c._mdf || this._isFirstFrame) &&
                (n.co =
                  "rgb(" +
                  bmFloor(t.c.v[0]) +
                  "," +
                  bmFloor(t.c.v[1]) +
                  "," +
                  bmFloor(t.c.v[2]) +
                  ")"),
              (t.o._mdf || r._opMdf || this._isFirstFrame) &&
                (n.coOp = t.o.v * r.opacity),
              (t.w._mdf || this._isFirstFrame) && (n.wi = t.w.v);
          }),
          (CVShapeElement.prototype.destroy = function () {
            (this.shapesData = null),
              (this.globalData = null),
              (this.canvasContext = null),
              (this.stylesList.length = 0),
              (this.itemsData.length = 0);
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              CVBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
              ITextElement,
            ],
            CVTextElement,
          ),
          (CVTextElement.prototype.tHelper =
            createTag("canvas").getContext("2d")),
          (CVTextElement.prototype.buildNewText = function () {
            var e = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
            var t = !1;
            e.fc
              ? ((t = !0), (this.values.fill = this.buildColor(e.fc)))
              : (this.values.fill = "rgba(0,0,0,0)"),
              (this.fill = t);
            var r = !1;
            e.sc &&
              ((r = !0),
              (this.values.stroke = this.buildColor(e.sc)),
              (this.values.sWidth = e.sw));
            var n,
              i,
              a,
              s,
              o,
              l,
              f,
              u,
              c,
              v,
              d,
              p,
              m = this.globalData.fontManager.getFontByName(e.f),
              h = e.l,
              g = this.mHelper;
            (this.stroke = r),
              (this.values.fValue =
                e.finalSize +
                "px " +
                this.globalData.fontManager.getFontByName(e.f).fFamily),
              (i = e.finalText.length);
            var y = this.data.singleShape,
              _ = 0.001 * e.tr * e.finalSize,
              b = 0,
              I = 0,
              P = !0,
              S = 0;
            for (n = 0; n < i; n += 1) {
              (s =
                ((a = this.globalData.fontManager.getCharData(
                  e.finalText[n],
                  m.fStyle,
                  this.globalData.fontManager.getFontByName(e.f).fFamily,
                )) &&
                  a.data) ||
                {}),
                g.reset(),
                y &&
                  h[n].n &&
                  ((b = -_), (I += e.yOffset), (I += P ? 1 : 0), (P = !1)),
                (c = (f = s.shapes ? s.shapes[0].it : []).length),
                g.scale(e.finalSize / 100, e.finalSize / 100),
                y && this.applyTextPropertiesToMatrix(e, g, h[n].line, b, I),
                (d = createSizedArray(c - 1));
              var A = 0;
              for (u = 0; u < c; u += 1)
                if (f[u].ty === "sh") {
                  for (
                    l = f[u].ks.k.i.length, v = f[u].ks.k, p = [], o = 1;
                    o < l;
                    o += 1
                  )
                    o === 1 &&
                      p.push(
                        g.applyToX(v.v[0][0], v.v[0][1], 0),
                        g.applyToY(v.v[0][0], v.v[0][1], 0),
                      ),
                      p.push(
                        g.applyToX(v.o[o - 1][0], v.o[o - 1][1], 0),
                        g.applyToY(v.o[o - 1][0], v.o[o - 1][1], 0),
                        g.applyToX(v.i[o][0], v.i[o][1], 0),
                        g.applyToY(v.i[o][0], v.i[o][1], 0),
                        g.applyToX(v.v[o][0], v.v[o][1], 0),
                        g.applyToY(v.v[o][0], v.v[o][1], 0),
                      );
                  p.push(
                    g.applyToX(v.o[o - 1][0], v.o[o - 1][1], 0),
                    g.applyToY(v.o[o - 1][0], v.o[o - 1][1], 0),
                    g.applyToX(v.i[0][0], v.i[0][1], 0),
                    g.applyToY(v.i[0][0], v.i[0][1], 0),
                    g.applyToX(v.v[0][0], v.v[0][1], 0),
                    g.applyToY(v.v[0][0], v.v[0][1], 0),
                  ),
                    (d[A] = p),
                    (A += 1);
                }
              y && ((b += h[n].l), (b += _)),
                this.textSpans[S]
                  ? (this.textSpans[S].elem = d)
                  : (this.textSpans[S] = { elem: d }),
                (S += 1);
            }
          }),
          (CVTextElement.prototype.renderInnerContent = function () {
            var e, t, r, n, i, a;
            this.validateText(),
              (this.canvasContext.font = this.values.fValue),
              this.globalData.renderer.ctxLineCap("butt"),
              this.globalData.renderer.ctxLineJoin("miter"),
              this.globalData.renderer.ctxMiterLimit(4),
              this.data.singleShape ||
                this.textAnimator.getMeasures(
                  this.textProperty.currentData,
                  this.lettersChangedFlag,
                );
            var s,
              o = this.textAnimator.renderedLetters,
              l = this.textProperty.currentData.l;
            t = l.length;
            var f,
              u,
              c = null,
              v = null,
              d = null,
              p = this.globalData.renderer;
            for (e = 0; e < t; e += 1)
              if (!l[e].n) {
                if (
                  ((s = o[e]) &&
                    (p.save(), p.ctxTransform(s.p), p.ctxOpacity(s.o)),
                  this.fill)
                ) {
                  for (
                    s && s.fc
                      ? c !== s.fc && (p.ctxFillStyle(s.fc), (c = s.fc))
                      : c !== this.values.fill &&
                        ((c = this.values.fill),
                        p.ctxFillStyle(this.values.fill)),
                      n = (f = this.textSpans[e].elem).length,
                      this.globalData.canvasContext.beginPath(),
                      r = 0;
                    r < n;
                    r += 1
                  )
                    for (
                      a = (u = f[r]).length,
                        this.globalData.canvasContext.moveTo(u[0], u[1]),
                        i = 2;
                      i < a;
                      i += 6
                    )
                      this.globalData.canvasContext.bezierCurveTo(
                        u[i],
                        u[i + 1],
                        u[i + 2],
                        u[i + 3],
                        u[i + 4],
                        u[i + 5],
                      );
                  this.globalData.canvasContext.closePath(), p.ctxFill();
                }
                if (this.stroke) {
                  for (
                    s && s.sw
                      ? d !== s.sw && ((d = s.sw), p.ctxLineWidth(s.sw))
                      : d !== this.values.sWidth &&
                        ((d = this.values.sWidth),
                        p.ctxLineWidth(this.values.sWidth)),
                      s && s.sc
                        ? v !== s.sc && ((v = s.sc), p.ctxStrokeStyle(s.sc))
                        : v !== this.values.stroke &&
                          ((v = this.values.stroke),
                          p.ctxStrokeStyle(this.values.stroke)),
                      n = (f = this.textSpans[e].elem).length,
                      this.globalData.canvasContext.beginPath(),
                      r = 0;
                    r < n;
                    r += 1
                  )
                    for (
                      a = (u = f[r]).length,
                        this.globalData.canvasContext.moveTo(u[0], u[1]),
                        i = 2;
                      i < a;
                      i += 6
                    )
                      this.globalData.canvasContext.bezierCurveTo(
                        u[i],
                        u[i + 1],
                        u[i + 2],
                        u[i + 3],
                        u[i + 4],
                        u[i + 5],
                      );
                  this.globalData.canvasContext.closePath(), p.ctxStroke();
                }
                s && this.globalData.renderer.restore();
              }
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              CVBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
            ],
            CVImageElement,
          ),
          (CVImageElement.prototype.initElement =
            SVGShapeElement.prototype.initElement),
          (CVImageElement.prototype.prepareFrame =
            IImageElement.prototype.prepareFrame),
          (CVImageElement.prototype.createContent = function () {
            if (
              this.img.width &&
              (this.assetData.w !== this.img.width ||
                this.assetData.h !== this.img.height)
            ) {
              var e = createTag("canvas");
              (e.width = this.assetData.w), (e.height = this.assetData.h);
              var t,
                r,
                n = e.getContext("2d"),
                i = this.img.width,
                a = this.img.height,
                s = i / a,
                o = this.assetData.w / this.assetData.h,
                l =
                  this.assetData.pr ||
                  this.globalData.renderConfig.imagePreserveAspectRatio;
              (s > o && l === "xMidYMid slice") ||
              (s < o && l !== "xMidYMid slice")
                ? (t = (r = a) * o)
                : (r = (t = i) / o),
                n.drawImage(
                  this.img,
                  (i - t) / 2,
                  (a - r) / 2,
                  t,
                  r,
                  0,
                  0,
                  this.assetData.w,
                  this.assetData.h,
                ),
                (this.img = e);
            }
          }),
          (CVImageElement.prototype.renderInnerContent = function () {
            this.canvasContext.drawImage(this.img, 0, 0);
          }),
          (CVImageElement.prototype.destroy = function () {
            this.img = null;
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              CVBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
            ],
            CVSolidElement,
          ),
          (CVSolidElement.prototype.initElement =
            SVGShapeElement.prototype.initElement),
          (CVSolidElement.prototype.prepareFrame =
            IImageElement.prototype.prepareFrame),
          (CVSolidElement.prototype.renderInnerContent = function () {
            this.globalData.renderer.ctxFillStyle(this.data.sc),
              this.globalData.renderer.ctxFillRect(
                0,
                0,
                this.data.sw,
                this.data.sh,
              );
          }),
          extendPrototype([BaseRenderer], CanvasRendererBase),
          (CanvasRendererBase.prototype.createShape = function (e) {
            return new CVShapeElement(e, this.globalData, this);
          }),
          (CanvasRendererBase.prototype.createText = function (e) {
            return new CVTextElement(e, this.globalData, this);
          }),
          (CanvasRendererBase.prototype.createImage = function (e) {
            return new CVImageElement(e, this.globalData, this);
          }),
          (CanvasRendererBase.prototype.createSolid = function (e) {
            return new CVSolidElement(e, this.globalData, this);
          }),
          (CanvasRendererBase.prototype.createNull =
            SVGRenderer.prototype.createNull),
          (CanvasRendererBase.prototype.ctxTransform = function (e) {
            (e[0] === 1 &&
              e[1] === 0 &&
              e[4] === 0 &&
              e[5] === 1 &&
              e[12] === 0 &&
              e[13] === 0) ||
              this.canvasContext.transform(
                e[0],
                e[1],
                e[4],
                e[5],
                e[12],
                e[13],
              );
          }),
          (CanvasRendererBase.prototype.ctxOpacity = function (e) {
            this.canvasContext.globalAlpha *= e < 0 ? 0 : e;
          }),
          (CanvasRendererBase.prototype.ctxFillStyle = function (e) {
            this.canvasContext.fillStyle = e;
          }),
          (CanvasRendererBase.prototype.ctxStrokeStyle = function (e) {
            this.canvasContext.strokeStyle = e;
          }),
          (CanvasRendererBase.prototype.ctxLineWidth = function (e) {
            this.canvasContext.lineWidth = e;
          }),
          (CanvasRendererBase.prototype.ctxLineCap = function (e) {
            this.canvasContext.lineCap = e;
          }),
          (CanvasRendererBase.prototype.ctxLineJoin = function (e) {
            this.canvasContext.lineJoin = e;
          }),
          (CanvasRendererBase.prototype.ctxMiterLimit = function (e) {
            this.canvasContext.miterLimit = e;
          }),
          (CanvasRendererBase.prototype.ctxFill = function (e) {
            this.canvasContext.fill(e);
          }),
          (CanvasRendererBase.prototype.ctxFillRect = function (e, t, r, n) {
            this.canvasContext.fillRect(e, t, r, n);
          }),
          (CanvasRendererBase.prototype.ctxStroke = function () {
            this.canvasContext.stroke();
          }),
          (CanvasRendererBase.prototype.reset = function () {
            this.renderConfig.clearCanvas
              ? this.contextData.reset()
              : this.canvasContext.restore();
          }),
          (CanvasRendererBase.prototype.save = function () {
            this.canvasContext.save();
          }),
          (CanvasRendererBase.prototype.restore = function (e) {
            this.renderConfig.clearCanvas
              ? (e && (this.globalData.blendMode = "source-over"),
                this.contextData.restore(e))
              : this.canvasContext.restore();
          }),
          (CanvasRendererBase.prototype.configAnimation = function (e) {
            if (this.animationItem.wrapper) {
              this.animationItem.container = createTag("canvas");
              var t = this.animationItem.container.style;
              (t.width = "100%"), (t.height = "100%");
              var r = "0px 0px 0px";
              (t.transformOrigin = r),
                (t.mozTransformOrigin = r),
                (t.webkitTransformOrigin = r),
                (t["-webkit-transform"] = r),
                (t.contentVisibility = this.renderConfig.contentVisibility),
                this.animationItem.wrapper.appendChild(
                  this.animationItem.container,
                ),
                (this.canvasContext =
                  this.animationItem.container.getContext("2d")),
                this.renderConfig.className &&
                  this.animationItem.container.setAttribute(
                    "class",
                    this.renderConfig.className,
                  ),
                this.renderConfig.id &&
                  this.animationItem.container.setAttribute(
                    "id",
                    this.renderConfig.id,
                  );
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext),
              (this.data = e),
              (this.layers = e.layers),
              (this.transformCanvas = {
                w: e.w,
                h: e.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0,
              }),
              this.setupGlobalData(e, document.body),
              (this.globalData.canvasContext = this.canvasContext),
              (this.globalData.renderer = this),
              (this.globalData.isDashed = !1),
              (this.globalData.progressiveLoad =
                this.renderConfig.progressiveLoad),
              (this.globalData.transformCanvas = this.transformCanvas),
              (this.elements = createSizedArray(e.layers.length)),
              this.updateContainerSize();
          }),
          (CanvasRendererBase.prototype.updateContainerSize = function (e, t) {
            var r, n, i, a;
            if (
              (this.reset(),
              e
                ? ((r = e),
                  (n = t),
                  (this.canvasContext.canvas.width = r),
                  (this.canvasContext.canvas.height = n))
                : (this.animationItem.wrapper && this.animationItem.container
                    ? ((r = this.animationItem.wrapper.offsetWidth),
                      (n = this.animationItem.wrapper.offsetHeight))
                    : ((r = this.canvasContext.canvas.width),
                      (n = this.canvasContext.canvas.height)),
                  (this.canvasContext.canvas.width = r * this.renderConfig.dpr),
                  (this.canvasContext.canvas.height =
                    n * this.renderConfig.dpr)),
              this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 ||
                this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1)
            ) {
              var s = this.renderConfig.preserveAspectRatio.split(" "),
                o = s[1] || "meet",
                l = s[0] || "xMidYMid",
                f = l.substr(0, 4),
                u = l.substr(4);
              (i = r / n),
                ((a = this.transformCanvas.w / this.transformCanvas.h) > i &&
                  o === "meet") ||
                (a < i && o === "slice")
                  ? ((this.transformCanvas.sx =
                      r / (this.transformCanvas.w / this.renderConfig.dpr)),
                    (this.transformCanvas.sy =
                      r / (this.transformCanvas.w / this.renderConfig.dpr)))
                  : ((this.transformCanvas.sx =
                      n / (this.transformCanvas.h / this.renderConfig.dpr)),
                    (this.transformCanvas.sy =
                      n / (this.transformCanvas.h / this.renderConfig.dpr))),
                (this.transformCanvas.tx =
                  f === "xMid" &&
                  ((a < i && o === "meet") || (a > i && o === "slice"))
                    ? ((r -
                        this.transformCanvas.w * (n / this.transformCanvas.h)) /
                        2) *
                      this.renderConfig.dpr
                    : f === "xMax" &&
                        ((a < i && o === "meet") || (a > i && o === "slice"))
                      ? (r -
                          this.transformCanvas.w *
                            (n / this.transformCanvas.h)) *
                        this.renderConfig.dpr
                      : 0),
                (this.transformCanvas.ty =
                  u === "YMid" &&
                  ((a > i && o === "meet") || (a < i && o === "slice"))
                    ? ((n -
                        this.transformCanvas.h * (r / this.transformCanvas.w)) /
                        2) *
                      this.renderConfig.dpr
                    : u === "YMax" &&
                        ((a > i && o === "meet") || (a < i && o === "slice"))
                      ? (n -
                          this.transformCanvas.h *
                            (r / this.transformCanvas.w)) *
                        this.renderConfig.dpr
                      : 0);
            } else
              this.renderConfig.preserveAspectRatio === "none"
                ? ((this.transformCanvas.sx =
                    r / (this.transformCanvas.w / this.renderConfig.dpr)),
                  (this.transformCanvas.sy =
                    n / (this.transformCanvas.h / this.renderConfig.dpr)),
                  (this.transformCanvas.tx = 0),
                  (this.transformCanvas.ty = 0))
                : ((this.transformCanvas.sx = this.renderConfig.dpr),
                  (this.transformCanvas.sy = this.renderConfig.dpr),
                  (this.transformCanvas.tx = 0),
                  (this.transformCanvas.ty = 0));
            (this.transformCanvas.props = [
              this.transformCanvas.sx,
              0,
              0,
              0,
              0,
              this.transformCanvas.sy,
              0,
              0,
              0,
              0,
              1,
              0,
              this.transformCanvas.tx,
              this.transformCanvas.ty,
              0,
              1,
            ]),
              this.ctxTransform(this.transformCanvas.props),
              this.canvasContext.beginPath(),
              this.canvasContext.rect(
                0,
                0,
                this.transformCanvas.w,
                this.transformCanvas.h,
              ),
              this.canvasContext.closePath(),
              this.canvasContext.clip(),
              this.renderFrame(this.renderedFrame, !0);
          }),
          (CanvasRendererBase.prototype.destroy = function () {
            var e;
            for (
              this.renderConfig.clearCanvas &&
                this.animationItem.wrapper &&
                (this.animationItem.wrapper.innerText = ""),
                e = (this.layers ? this.layers.length : 0) - 1;
              e >= 0;
              e -= 1
            )
              this.elements[e] &&
                this.elements[e].destroy &&
                this.elements[e].destroy();
            (this.elements.length = 0),
              (this.globalData.canvasContext = null),
              (this.animationItem.container = null),
              (this.destroyed = !0);
          }),
          (CanvasRendererBase.prototype.renderFrame = function (e, t) {
            if (
              (this.renderedFrame !== e ||
                this.renderConfig.clearCanvas !== !0 ||
                t) &&
              !this.destroyed &&
              e !== -1
            ) {
              var r;
              (this.renderedFrame = e),
                (this.globalData.frameNum =
                  e - this.animationItem._isFirstFrame),
                (this.globalData.frameId += 1),
                (this.globalData._mdf = !this.renderConfig.clearCanvas || t),
                (this.globalData.projectInterface.currentFrame = e);
              var n = this.layers.length;
              for (
                this.completeLayers || this.checkLayers(e), r = n - 1;
                r >= 0;
                r -= 1
              )
                (this.completeLayers || this.elements[r]) &&
                  this.elements[r].prepareFrame(e - this.layers[r].st);
              if (this.globalData._mdf) {
                for (
                  this.renderConfig.clearCanvas === !0
                    ? this.canvasContext.clearRect(
                        0,
                        0,
                        this.transformCanvas.w,
                        this.transformCanvas.h,
                      )
                    : this.save(),
                    r = n - 1;
                  r >= 0;
                  r -= 1
                )
                  (this.completeLayers || this.elements[r]) &&
                    this.elements[r].renderFrame();
                this.renderConfig.clearCanvas !== !0 && this.restore();
              }
            }
          }),
          (CanvasRendererBase.prototype.buildItem = function (e) {
            var t = this.elements;
            if (!t[e] && this.layers[e].ty !== 99) {
              var r = this.createItem(this.layers[e], this, this.globalData);
              (t[e] = r), r.initExpressions();
            }
          }),
          (CanvasRendererBase.prototype.checkPendingElements = function () {
            for (; this.pendingElements.length; )
              this.pendingElements.pop().checkParenting();
          }),
          (CanvasRendererBase.prototype.hide = function () {
            this.animationItem.container.style.display = "none";
          }),
          (CanvasRendererBase.prototype.show = function () {
            this.animationItem.container.style.display = "block";
          }),
          (CVContextData.prototype.duplicate = function () {
            var e = 2 * this._length,
              t = 0;
            for (t = this._length; t < e; t += 1)
              this.stack[t] = new CanvasContext();
            this._length = e;
          }),
          (CVContextData.prototype.reset = function () {
            (this.cArrPos = 0),
              this.cTr.reset(),
              (this.stack[this.cArrPos].opacity = 1);
          }),
          (CVContextData.prototype.restore = function (e) {
            this.cArrPos -= 1;
            var t,
              r = this.stack[this.cArrPos],
              n = r.transform,
              i = this.cTr.props;
            for (t = 0; t < 16; t += 1) i[t] = n[t];
            if (e) {
              this.nativeContext.restore();
              var a = this.stack[this.cArrPos + 1];
              (this.appliedFillStyle = a.fillStyle),
                (this.appliedStrokeStyle = a.strokeStyle),
                (this.appliedLineWidth = a.lineWidth),
                (this.appliedLineCap = a.lineCap),
                (this.appliedLineJoin = a.lineJoin),
                (this.appliedMiterLimit = a.miterLimit);
            }
            this.nativeContext.setTransform(
              n[0],
              n[1],
              n[4],
              n[5],
              n[12],
              n[13],
            ),
              (e || (r.opacity !== -1 && this.currentOpacity !== r.opacity)) &&
                ((this.nativeContext.globalAlpha = r.opacity),
                (this.currentOpacity = r.opacity)),
              (this.currentFillStyle = r.fillStyle),
              (this.currentStrokeStyle = r.strokeStyle),
              (this.currentLineWidth = r.lineWidth),
              (this.currentLineCap = r.lineCap),
              (this.currentLineJoin = r.lineJoin),
              (this.currentMiterLimit = r.miterLimit);
          }),
          (CVContextData.prototype.save = function (e) {
            e && this.nativeContext.save();
            var t = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r,
              n = this.stack[this.cArrPos];
            for (r = 0; r < 16; r += 1) n.transform[r] = t[r];
            this.cArrPos += 1;
            var i = this.stack[this.cArrPos];
            (i.opacity = n.opacity),
              (i.fillStyle = n.fillStyle),
              (i.strokeStyle = n.strokeStyle),
              (i.lineWidth = n.lineWidth),
              (i.lineCap = n.lineCap),
              (i.lineJoin = n.lineJoin),
              (i.miterLimit = n.miterLimit);
          }),
          (CVContextData.prototype.setOpacity = function (e) {
            this.stack[this.cArrPos].opacity = e;
          }),
          (CVContextData.prototype.setContext = function (e) {
            this.nativeContext = e;
          }),
          (CVContextData.prototype.fillStyle = function (e) {
            this.stack[this.cArrPos].fillStyle !== e &&
              ((this.currentFillStyle = e),
              (this.stack[this.cArrPos].fillStyle = e));
          }),
          (CVContextData.prototype.strokeStyle = function (e) {
            this.stack[this.cArrPos].strokeStyle !== e &&
              ((this.currentStrokeStyle = e),
              (this.stack[this.cArrPos].strokeStyle = e));
          }),
          (CVContextData.prototype.lineWidth = function (e) {
            this.stack[this.cArrPos].lineWidth !== e &&
              ((this.currentLineWidth = e),
              (this.stack[this.cArrPos].lineWidth = e));
          }),
          (CVContextData.prototype.lineCap = function (e) {
            this.stack[this.cArrPos].lineCap !== e &&
              ((this.currentLineCap = e),
              (this.stack[this.cArrPos].lineCap = e));
          }),
          (CVContextData.prototype.lineJoin = function (e) {
            this.stack[this.cArrPos].lineJoin !== e &&
              ((this.currentLineJoin = e),
              (this.stack[this.cArrPos].lineJoin = e));
          }),
          (CVContextData.prototype.miterLimit = function (e) {
            this.stack[this.cArrPos].miterLimit !== e &&
              ((this.currentMiterLimit = e),
              (this.stack[this.cArrPos].miterLimit = e));
          }),
          (CVContextData.prototype.transform = function (e) {
            this.transformMat.cloneFromProps(e);
            var t = this.cTr;
            this.transformMat.multiply(t),
              t.cloneFromProps(this.transformMat.props);
            var r = t.props;
            this.nativeContext.setTransform(
              r[0],
              r[1],
              r[4],
              r[5],
              r[12],
              r[13],
            );
          }),
          (CVContextData.prototype.opacity = function (e) {
            var t = this.stack[this.cArrPos].opacity;
            (t *= e < 0 ? 0 : e),
              this.stack[this.cArrPos].opacity !== t &&
                (this.currentOpacity !== e &&
                  ((this.nativeContext.globalAlpha = e),
                  (this.currentOpacity = e)),
                (this.stack[this.cArrPos].opacity = t));
          }),
          (CVContextData.prototype.fill = function (e) {
            this.appliedFillStyle !== this.currentFillStyle &&
              ((this.appliedFillStyle = this.currentFillStyle),
              (this.nativeContext.fillStyle = this.appliedFillStyle)),
              this.nativeContext.fill(e);
          }),
          (CVContextData.prototype.fillRect = function (e, t, r, n) {
            this.appliedFillStyle !== this.currentFillStyle &&
              ((this.appliedFillStyle = this.currentFillStyle),
              (this.nativeContext.fillStyle = this.appliedFillStyle)),
              this.nativeContext.fillRect(e, t, r, n);
          }),
          (CVContextData.prototype.stroke = function () {
            this.appliedStrokeStyle !== this.currentStrokeStyle &&
              ((this.appliedStrokeStyle = this.currentStrokeStyle),
              (this.nativeContext.strokeStyle = this.appliedStrokeStyle)),
              this.appliedLineWidth !== this.currentLineWidth &&
                ((this.appliedLineWidth = this.currentLineWidth),
                (this.nativeContext.lineWidth = this.appliedLineWidth)),
              this.appliedLineCap !== this.currentLineCap &&
                ((this.appliedLineCap = this.currentLineCap),
                (this.nativeContext.lineCap = this.appliedLineCap)),
              this.appliedLineJoin !== this.currentLineJoin &&
                ((this.appliedLineJoin = this.currentLineJoin),
                (this.nativeContext.lineJoin = this.appliedLineJoin)),
              this.appliedMiterLimit !== this.currentMiterLimit &&
                ((this.appliedMiterLimit = this.currentMiterLimit),
                (this.nativeContext.miterLimit = this.appliedMiterLimit)),
              this.nativeContext.stroke();
          }),
          extendPrototype(
            [CanvasRendererBase, ICompElement, CVBaseElement],
            CVCompElement,
          ),
          (CVCompElement.prototype.renderInnerContent = function () {
            var e,
              t = this.canvasContext;
            for (
              t.beginPath(),
                t.moveTo(0, 0),
                t.lineTo(this.data.w, 0),
                t.lineTo(this.data.w, this.data.h),
                t.lineTo(0, this.data.h),
                t.lineTo(0, 0),
                t.clip(),
                e = this.layers.length - 1;
              e >= 0;
              e -= 1
            )
              (this.completeLayers || this.elements[e]) &&
                this.elements[e].renderFrame();
          }),
          (CVCompElement.prototype.destroy = function () {
            var e;
            for (e = this.layers.length - 1; e >= 0; e -= 1)
              this.elements[e] && this.elements[e].destroy();
            (this.layers = null), (this.elements = null);
          }),
          (CVCompElement.prototype.createComp = function (e) {
            return new CVCompElement(e, this.globalData, this);
          }),
          extendPrototype([CanvasRendererBase], CanvasRenderer),
          (CanvasRenderer.prototype.createComp = function (e) {
            return new CVCompElement(e, this.globalData, this);
          }),
          (HBaseElement.prototype = {
            checkBlendMode: function () {},
            initRendererElement: function () {
              (this.baseElement = createTag(this.data.tg || "div")),
                this.data.hasMask
                  ? ((this.svgElement = createNS("svg")),
                    (this.layerElement = createNS("g")),
                    (this.maskedElement = this.layerElement),
                    this.svgElement.appendChild(this.layerElement),
                    this.baseElement.appendChild(this.svgElement))
                  : (this.layerElement = this.baseElement),
                styleDiv(this.baseElement);
            },
            createContainerElements: function () {
              (this.renderableEffectsManager = new CVEffects(this)),
                (this.transformedElement = this.baseElement),
                (this.maskedElement = this.layerElement),
                this.data.ln &&
                  this.layerElement.setAttribute("id", this.data.ln),
                this.data.cl &&
                  this.layerElement.setAttribute("class", this.data.cl),
                this.data.bm !== 0 && this.setBlendMode();
            },
            renderElement: function () {
              var e = this.transformedElement
                ? this.transformedElement.style
                : {};
              if (this.finalTransform._matMdf) {
                var t = this.finalTransform.mat.toCSS();
                (e.transform = t), (e.webkitTransform = t);
              }
              this.finalTransform._opMdf &&
                (e.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function () {
              this.data.hd ||
                this.hidden ||
                (this.renderTransform(),
                this.renderRenderable(),
                this.renderElement(),
                this.renderInnerContent(),
                this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function () {
              (this.layerElement = null),
                (this.transformedElement = null),
                this.matteElement && (this.matteElement = null),
                this.maskManager &&
                  (this.maskManager.destroy(), (this.maskManager = null));
            },
            createRenderableComponents: function () {
              this.maskManager = new MaskElement(
                this.data,
                this,
                this.globalData,
              );
            },
            addEffects: function () {},
            setMatte: function () {},
          }),
          (HBaseElement.prototype.getBaseElement =
            SVGBaseElement.prototype.getBaseElement),
          (HBaseElement.prototype.destroyBaseElement =
            HBaseElement.prototype.destroy),
          (HBaseElement.prototype.buildElementParenting =
            BaseRenderer.prototype.buildElementParenting),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              HBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableDOMElement,
            ],
            HSolidElement,
          ),
          (HSolidElement.prototype.createContent = function () {
            var e;
            this.data.hasMask
              ? ((e = createNS("rect")).setAttribute("width", this.data.sw),
                e.setAttribute("height", this.data.sh),
                e.setAttribute("fill", this.data.sc),
                this.svgElement.setAttribute("width", this.data.sw),
                this.svgElement.setAttribute("height", this.data.sh))
              : (((e = createTag("div")).style.width = this.data.sw + "px"),
                (e.style.height = this.data.sh + "px"),
                (e.style.backgroundColor = this.data.sc)),
              this.layerElement.appendChild(e);
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              HSolidElement,
              SVGShapeElement,
              HBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
            ],
            HShapeElement,
          ),
          (HShapeElement.prototype._renderShapeFrame =
            HShapeElement.prototype.renderInnerContent),
          (HShapeElement.prototype.createContent = function () {
            var e;
            if (((this.baseElement.style.fontSize = 0), this.data.hasMask))
              this.layerElement.appendChild(this.shapesContainer),
                (e = this.svgElement);
            else {
              e = createNS("svg");
              var t = this.comp.data
                ? this.comp.data
                : this.globalData.compSize;
              e.setAttribute("width", t.w),
                e.setAttribute("height", t.h),
                e.appendChild(this.shapesContainer),
                this.layerElement.appendChild(e);
            }
            this.searchShapes(
              this.shapesData,
              this.itemsData,
              this.prevViewData,
              this.shapesContainer,
              0,
              [],
              !0,
            ),
              this.filterUniqueShapes(),
              (this.shapeCont = e);
          }),
          (HShapeElement.prototype.getTransformedPoint = function (e, t) {
            var r,
              n = e.length;
            for (r = 0; r < n; r += 1)
              t = e[r].mProps.v.applyToPointArray(t[0], t[1], 0);
            return t;
          }),
          (HShapeElement.prototype.calculateShapeBoundingBox = function (e, t) {
            var r,
              n,
              i,
              a,
              s,
              o = e.sh.v,
              l = e.transformers,
              f = o._length;
            if (!(f <= 1)) {
              for (r = 0; r < f - 1; r += 1)
                (n = this.getTransformedPoint(l, o.v[r])),
                  (i = this.getTransformedPoint(l, o.o[r])),
                  (a = this.getTransformedPoint(l, o.i[r + 1])),
                  (s = this.getTransformedPoint(l, o.v[r + 1])),
                  this.checkBounds(n, i, a, s, t);
              o.c &&
                ((n = this.getTransformedPoint(l, o.v[r])),
                (i = this.getTransformedPoint(l, o.o[r])),
                (a = this.getTransformedPoint(l, o.i[0])),
                (s = this.getTransformedPoint(l, o.v[0])),
                this.checkBounds(n, i, a, s, t));
            }
          }),
          (HShapeElement.prototype.checkBounds = function (e, t, r, n, i) {
            this.getBoundsOfCurve(e, t, r, n);
            var a = this.shapeBoundingBox;
            (i.x = bmMin(a.left, i.x)),
              (i.xMax = bmMax(a.right, i.xMax)),
              (i.y = bmMin(a.top, i.y)),
              (i.yMax = bmMax(a.bottom, i.yMax));
          }),
          (HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          }),
          (HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0,
          }),
          (HShapeElement.prototype.getBoundsOfCurve = function (e, t, r, n) {
            for (
              var i,
                a,
                s,
                o,
                l,
                f,
                u,
                c = [
                  [e[0], n[0]],
                  [e[1], n[1]],
                ],
                v = 0;
              v < 2;
              ++v
            )
              (a = 6 * e[v] - 12 * t[v] + 6 * r[v]),
                (i = -3 * e[v] + 9 * t[v] - 9 * r[v] + 3 * n[v]),
                (s = 3 * t[v] - 3 * e[v]),
                (a |= 0),
                (s |= 0),
                ((i |= 0) === 0 && a === 0) ||
                  (i === 0
                    ? (o = -s / a) > 0 &&
                      o < 1 &&
                      c[v].push(this.calculateF(o, e, t, r, n, v))
                    : (l = a * a - 4 * s * i) >= 0 &&
                      ((f = (-a + bmSqrt(l)) / (2 * i)) > 0 &&
                        f < 1 &&
                        c[v].push(this.calculateF(f, e, t, r, n, v)),
                      (u = (-a - bmSqrt(l)) / (2 * i)) > 0 &&
                        u < 1 &&
                        c[v].push(this.calculateF(u, e, t, r, n, v))));
            (this.shapeBoundingBox.left = bmMin.apply(null, c[0])),
              (this.shapeBoundingBox.top = bmMin.apply(null, c[1])),
              (this.shapeBoundingBox.right = bmMax.apply(null, c[0])),
              (this.shapeBoundingBox.bottom = bmMax.apply(null, c[1]));
          }),
          (HShapeElement.prototype.calculateF = function (e, t, r, n, i, a) {
            return (
              bmPow(1 - e, 3) * t[a] +
              3 * bmPow(1 - e, 2) * e * r[a] +
              3 * (1 - e) * bmPow(e, 2) * n[a] +
              bmPow(e, 3) * i[a]
            );
          }),
          (HShapeElement.prototype.calculateBoundingBox = function (e, t) {
            var r,
              n = e.length;
            for (r = 0; r < n; r += 1)
              e[r] && e[r].sh
                ? this.calculateShapeBoundingBox(e[r], t)
                : e[r] && e[r].it
                  ? this.calculateBoundingBox(e[r].it, t)
                  : e[r] &&
                    e[r].style &&
                    e[r].w &&
                    this.expandStrokeBoundingBox(e[r].w, t);
          }),
          (HShapeElement.prototype.expandStrokeBoundingBox = function (e, t) {
            var r = 0;
            if (e.keyframes) {
              for (var n = 0; n < e.keyframes.length; n += 1) {
                var i = e.keyframes[n].s;
                i > r && (r = i);
              }
              r *= e.mult;
            } else r = e.v * e.mult;
            (t.x -= r), (t.xMax += r), (t.y -= r), (t.yMax += r);
          }),
          (HShapeElement.prototype.currentBoxContains = function (e) {
            return (
              this.currentBBox.x <= e.x &&
              this.currentBBox.y <= e.y &&
              this.currentBBox.width + this.currentBBox.x >= e.x + e.width &&
              this.currentBBox.height + this.currentBBox.y >= e.y + e.height
            );
          }),
          (HShapeElement.prototype.renderInnerContent = function () {
            if (
              (this._renderShapeFrame(),
              !this.hidden && (this._isFirstFrame || this._mdf))
            ) {
              var e = this.tempBoundingBox,
                t = 999999;
              if (
                ((e.x = t),
                (e.xMax = -t),
                (e.y = t),
                (e.yMax = -t),
                this.calculateBoundingBox(this.itemsData, e),
                (e.width = e.xMax < e.x ? 0 : e.xMax - e.x),
                (e.height = e.yMax < e.y ? 0 : e.yMax - e.y),
                this.currentBoxContains(e))
              )
                return;
              var r = !1;
              if (
                (this.currentBBox.w !== e.width &&
                  ((this.currentBBox.w = e.width),
                  this.shapeCont.setAttribute("width", e.width),
                  (r = !0)),
                this.currentBBox.h !== e.height &&
                  ((this.currentBBox.h = e.height),
                  this.shapeCont.setAttribute("height", e.height),
                  (r = !0)),
                r || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y)
              ) {
                (this.currentBBox.w = e.width),
                  (this.currentBBox.h = e.height),
                  (this.currentBBox.x = e.x),
                  (this.currentBBox.y = e.y),
                  this.shapeCont.setAttribute(
                    "viewBox",
                    this.currentBBox.x +
                      " " +
                      this.currentBBox.y +
                      " " +
                      this.currentBBox.w +
                      " " +
                      this.currentBBox.h,
                  );
                var n = this.shapeCont.style,
                  i =
                    "translate(" +
                    this.currentBBox.x +
                    "px," +
                    this.currentBBox.y +
                    "px)";
                (n.transform = i), (n.webkitTransform = i);
              }
            }
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              HBaseElement,
              HierarchyElement,
              FrameElement,
              RenderableDOMElement,
              ITextElement,
            ],
            HTextElement,
          ),
          (HTextElement.prototype.createContent = function () {
            if (((this.isMasked = this.checkMasks()), this.isMasked)) {
              (this.renderType = "svg"),
                (this.compW = this.comp.data.w),
                (this.compH = this.comp.data.h),
                this.svgElement.setAttribute("width", this.compW),
                this.svgElement.setAttribute("height", this.compH);
              var e = createNS("g");
              this.maskedElement.appendChild(e), (this.innerElem = e);
            } else
              (this.renderType = "html"), (this.innerElem = this.layerElement);
            this.checkParenting();
          }),
          (HTextElement.prototype.buildNewText = function () {
            var e = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
            var t = this.innerElem.style,
              r = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
            (t.fill = r),
              (t.color = r),
              e.sc &&
                ((t.stroke = this.buildColor(e.sc)),
                (t.strokeWidth = e.sw + "px"));
            var n,
              i,
              a = this.globalData.fontManager.getFontByName(e.f);
            if (!this.globalData.fontManager.chars)
              if (
                ((t.fontSize = e.finalSize + "px"),
                (t.lineHeight = e.finalSize + "px"),
                a.fClass)
              )
                this.innerElem.className = a.fClass;
              else {
                t.fontFamily = a.fFamily;
                var s = e.fWeight,
                  o = e.fStyle;
                (t.fontStyle = o), (t.fontWeight = s);
              }
            var l,
              f,
              u,
              c = e.l;
            i = c.length;
            var v,
              d = this.mHelper,
              p = "",
              m = 0;
            for (n = 0; n < i; n += 1) {
              if (
                (this.globalData.fontManager.chars
                  ? (this.textPaths[m]
                      ? (l = this.textPaths[m])
                      : ((l = createNS("path")).setAttribute(
                          "stroke-linecap",
                          lineCapEnum[1],
                        ),
                        l.setAttribute("stroke-linejoin", lineJoinEnum[2]),
                        l.setAttribute("stroke-miterlimit", "4")),
                    this.isMasked ||
                      (this.textSpans[m]
                        ? (u = (f = this.textSpans[m]).children[0])
                        : (((f = createTag("div")).style.lineHeight = 0),
                          (u = createNS("svg")).appendChild(l),
                          styleDiv(f))))
                  : this.isMasked
                    ? (l = this.textPaths[m]
                        ? this.textPaths[m]
                        : createNS("text"))
                    : this.textSpans[m]
                      ? ((f = this.textSpans[m]), (l = this.textPaths[m]))
                      : (styleDiv((f = createTag("span"))),
                        styleDiv((l = createTag("span"))),
                        f.appendChild(l)),
                this.globalData.fontManager.chars)
              ) {
                var h,
                  g = this.globalData.fontManager.getCharData(
                    e.finalText[n],
                    a.fStyle,
                    this.globalData.fontManager.getFontByName(e.f).fFamily,
                  );
                if (
                  ((h = g ? g.data : null),
                  d.reset(),
                  h &&
                    h.shapes &&
                    h.shapes.length &&
                    ((v = h.shapes[0].it),
                    d.scale(e.finalSize / 100, e.finalSize / 100),
                    (p = this.createPathShape(d, v)),
                    l.setAttribute("d", p)),
                  this.isMasked)
                )
                  this.innerElem.appendChild(l);
                else {
                  if ((this.innerElem.appendChild(f), h && h.shapes)) {
                    document.body.appendChild(u);
                    var y = u.getBBox();
                    u.setAttribute("width", y.width + 2),
                      u.setAttribute("height", y.height + 2),
                      u.setAttribute(
                        "viewBox",
                        y.x -
                          1 +
                          " " +
                          (y.y - 1) +
                          " " +
                          (y.width + 2) +
                          " " +
                          (y.height + 2),
                      );
                    var _ = u.style,
                      b = "translate(" + (y.x - 1) + "px," + (y.y - 1) + "px)";
                    (_.transform = b),
                      (_.webkitTransform = b),
                      (c[n].yOffset = y.y - 1);
                  } else
                    u.setAttribute("width", 1), u.setAttribute("height", 1);
                  f.appendChild(u);
                }
              } else if (
                ((l.textContent = c[n].val),
                l.setAttributeNS(
                  "http://www.w3.org/XML/1998/namespace",
                  "xml:space",
                  "preserve",
                ),
                this.isMasked)
              )
                this.innerElem.appendChild(l);
              else {
                this.innerElem.appendChild(f);
                var I = l.style,
                  P = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
                (I.transform = P), (I.webkitTransform = P);
              }
              this.isMasked ? (this.textSpans[m] = l) : (this.textSpans[m] = f),
                (this.textSpans[m].style.display = "block"),
                (this.textPaths[m] = l),
                (m += 1);
            }
            for (; m < this.textSpans.length; )
              (this.textSpans[m].style.display = "none"), (m += 1);
          }),
          (HTextElement.prototype.renderInnerContent = function () {
            var e;
            if ((this.validateText(), this.data.singleShape)) {
              if (!this._isFirstFrame && !this.lettersChangedFlag) return;
              if (this.isMasked && this.finalTransform._matMdf) {
                this.svgElement.setAttribute(
                  "viewBox",
                  -this.finalTransform.mProp.p.v[0] +
                    " " +
                    -this.finalTransform.mProp.p.v[1] +
                    " " +
                    this.compW +
                    " " +
                    this.compH,
                ),
                  (e = this.svgElement.style);
                var t =
                  "translate(" +
                  -this.finalTransform.mProp.p.v[0] +
                  "px," +
                  -this.finalTransform.mProp.p.v[1] +
                  "px)";
                (e.transform = t), (e.webkitTransform = t);
              }
            }
            if (
              (this.textAnimator.getMeasures(
                this.textProperty.currentData,
                this.lettersChangedFlag,
              ),
              this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
            ) {
              var r,
                n,
                i,
                a,
                s,
                o = 0,
                l = this.textAnimator.renderedLetters,
                f = this.textProperty.currentData.l;
              for (n = f.length, r = 0; r < n; r += 1)
                f[r].n
                  ? (o += 1)
                  : ((a = this.textSpans[r]),
                    (s = this.textPaths[r]),
                    (i = l[o]),
                    (o += 1),
                    i._mdf.m &&
                      (this.isMasked
                        ? a.setAttribute("transform", i.m)
                        : ((a.style.webkitTransform = i.m),
                          (a.style.transform = i.m))),
                    (a.style.opacity = i.o),
                    i.sw && i._mdf.sw && s.setAttribute("stroke-width", i.sw),
                    i.sc && i._mdf.sc && s.setAttribute("stroke", i.sc),
                    i.fc &&
                      i._mdf.fc &&
                      (s.setAttribute("fill", i.fc), (s.style.color = i.fc)));
              if (
                this.innerElem.getBBox &&
                !this.hidden &&
                (this._isFirstFrame || this._mdf)
              ) {
                var u = this.innerElem.getBBox();
                if (
                  (this.currentBBox.w !== u.width &&
                    ((this.currentBBox.w = u.width),
                    this.svgElement.setAttribute("width", u.width)),
                  this.currentBBox.h !== u.height &&
                    ((this.currentBBox.h = u.height),
                    this.svgElement.setAttribute("height", u.height)),
                  this.currentBBox.w !== u.width + 2 ||
                    this.currentBBox.h !== u.height + 2 ||
                    this.currentBBox.x !== u.x - 1 ||
                    this.currentBBox.y !== u.y - 1)
                ) {
                  (this.currentBBox.w = u.width + 2),
                    (this.currentBBox.h = u.height + 2),
                    (this.currentBBox.x = u.x - 1),
                    (this.currentBBox.y = u.y - 1),
                    this.svgElement.setAttribute(
                      "viewBox",
                      this.currentBBox.x +
                        " " +
                        this.currentBBox.y +
                        " " +
                        this.currentBBox.w +
                        " " +
                        this.currentBBox.h,
                    ),
                    (e = this.svgElement.style);
                  var c =
                    "translate(" +
                    this.currentBBox.x +
                    "px," +
                    this.currentBBox.y +
                    "px)";
                  (e.transform = c), (e.webkitTransform = c);
                }
              }
            }
          }),
          extendPrototype(
            [BaseElement, FrameElement, HierarchyElement],
            HCameraElement,
          ),
          (HCameraElement.prototype.setup = function () {
            var e,
              t,
              r,
              n,
              i = this.comp.threeDElements.length;
            for (e = 0; e < i; e += 1)
              if ((t = this.comp.threeDElements[e]).type === "3d") {
                (r = t.perspectiveElem.style), (n = t.container.style);
                var a = this.pe.v + "px",
                  s = "0px 0px 0px",
                  o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (r.perspective = a),
                  (r.webkitPerspective = a),
                  (n.transformOrigin = s),
                  (n.mozTransformOrigin = s),
                  (n.webkitTransformOrigin = s),
                  (r.transform = o),
                  (r.webkitTransform = o);
              }
          }),
          (HCameraElement.prototype.createElements = function () {}),
          (HCameraElement.prototype.hide = function () {}),
          (HCameraElement.prototype.renderFrame = function () {
            var e,
              t,
              r = this._isFirstFrame;
            if (this.hierarchy)
              for (t = this.hierarchy.length, e = 0; e < t; e += 1)
                r = this.hierarchy[e].finalTransform.mProp._mdf || r;
            if (
              r ||
              this.pe._mdf ||
              (this.p && this.p._mdf) ||
              (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) ||
              this.rx._mdf ||
              this.ry._mdf ||
              this.rz._mdf ||
              this.or._mdf ||
              (this.a && this.a._mdf)
            ) {
              if ((this.mat.reset(), this.hierarchy))
                for (e = t = this.hierarchy.length - 1; e >= 0; e -= 1) {
                  var n = this.hierarchy[e].finalTransform.mProp;
                  this.mat.translate(-n.p.v[0], -n.p.v[1], n.p.v[2]),
                    this.mat
                      .rotateX(-n.or.v[0])
                      .rotateY(-n.or.v[1])
                      .rotateZ(n.or.v[2]),
                    this.mat.rotateX(-n.rx.v).rotateY(-n.ry.v).rotateZ(n.rz.v),
                    this.mat.scale(1 / n.s.v[0], 1 / n.s.v[1], 1 / n.s.v[2]),
                    this.mat.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
                }
              if (
                (this.p
                  ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2])
                  : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
                this.a)
              ) {
                var i;
                i = this.p
                  ? [
                      this.p.v[0] - this.a.v[0],
                      this.p.v[1] - this.a.v[1],
                      this.p.v[2] - this.a.v[2],
                    ]
                  : [
                      this.px.v - this.a.v[0],
                      this.py.v - this.a.v[1],
                      this.pz.v - this.a.v[2],
                    ];
                var a = Math.sqrt(
                    Math.pow(i[0], 2) + Math.pow(i[1], 2) + Math.pow(i[2], 2),
                  ),
                  s = [i[0] / a, i[1] / a, i[2] / a],
                  o = Math.sqrt(s[2] * s[2] + s[0] * s[0]),
                  l = Math.atan2(s[1], o),
                  f = Math.atan2(s[0], -s[2]);
                this.mat.rotateY(f).rotateX(-l);
              }
              this.mat
                .rotateX(-this.rx.v)
                .rotateY(-this.ry.v)
                .rotateZ(this.rz.v),
                this.mat
                  .rotateX(-this.or.v[0])
                  .rotateY(-this.or.v[1])
                  .rotateZ(this.or.v[2]),
                this.mat.translate(
                  this.globalData.compSize.w / 2,
                  this.globalData.compSize.h / 2,
                  0,
                ),
                this.mat.translate(0, 0, this.pe.v);
              var u = !this._prevMat.equals(this.mat);
              if ((u || this.pe._mdf) && this.comp.threeDElements) {
                var c, v, d;
                for (t = this.comp.threeDElements.length, e = 0; e < t; e += 1)
                  if ((c = this.comp.threeDElements[e]).type === "3d") {
                    if (u) {
                      var p = this.mat.toCSS();
                      ((d = c.container.style).transform = p),
                        (d.webkitTransform = p);
                    }
                    this.pe._mdf &&
                      (((v = c.perspectiveElem.style).perspective =
                        this.pe.v + "px"),
                      (v.webkitPerspective = this.pe.v + "px"));
                  }
                this.mat.clone(this._prevMat);
              }
            }
            this._isFirstFrame = !1;
          }),
          (HCameraElement.prototype.prepareFrame = function (e) {
            this.prepareProperties(e, !0);
          }),
          (HCameraElement.prototype.destroy = function () {}),
          (HCameraElement.prototype.getBaseElement = function () {
            return null;
          }),
          extendPrototype(
            [
              BaseElement,
              TransformElement,
              HBaseElement,
              HSolidElement,
              HierarchyElement,
              FrameElement,
              RenderableElement,
            ],
            HImageElement,
          ),
          (HImageElement.prototype.createContent = function () {
            var e = this.globalData.getAssetsPath(this.assetData),
              t = new Image();
            this.data.hasMask
              ? ((this.imageElem = createNS("image")),
                this.imageElem.setAttribute("width", this.assetData.w + "px"),
                this.imageElem.setAttribute("height", this.assetData.h + "px"),
                this.imageElem.setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "href",
                  e,
                ),
                this.layerElement.appendChild(this.imageElem),
                this.baseElement.setAttribute("width", this.assetData.w),
                this.baseElement.setAttribute("height", this.assetData.h))
              : this.layerElement.appendChild(t),
              (t.crossOrigin = "anonymous"),
              (t.src = e),
              this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
          }),
          extendPrototype([BaseRenderer], HybridRendererBase),
          (HybridRendererBase.prototype.buildItem =
            SVGRenderer.prototype.buildItem),
          (HybridRendererBase.prototype.checkPendingElements = function () {
            for (; this.pendingElements.length; )
              this.pendingElements.pop().checkParenting();
          }),
          (HybridRendererBase.prototype.appendElementInPos = function (e, t) {
            var r = e.getBaseElement();
            if (r) {
              var n = this.layers[t];
              if (n.ddd && this.supports3d) this.addTo3dContainer(r, t);
              else if (this.threeDElements) this.addTo3dContainer(r, t);
              else {
                for (var i, a, s = 0; s < t; )
                  this.elements[s] &&
                    this.elements[s] !== !0 &&
                    this.elements[s].getBaseElement &&
                    ((a = this.elements[s]),
                    (i =
                      (this.layers[s].ddd
                        ? this.getThreeDContainerByPos(s)
                        : a.getBaseElement()) || i)),
                    (s += 1);
                i
                  ? (n.ddd && this.supports3d) ||
                    this.layerElement.insertBefore(r, i)
                  : (n.ddd && this.supports3d) ||
                    this.layerElement.appendChild(r);
              }
            }
          }),
          (HybridRendererBase.prototype.createShape = function (e) {
            return this.supports3d
              ? new HShapeElement(e, this.globalData, this)
              : new SVGShapeElement(e, this.globalData, this);
          }),
          (HybridRendererBase.prototype.createText = function (e) {
            return this.supports3d
              ? new HTextElement(e, this.globalData, this)
              : new SVGTextLottieElement(e, this.globalData, this);
          }),
          (HybridRendererBase.prototype.createCamera = function (e) {
            return (
              (this.camera = new HCameraElement(e, this.globalData, this)),
              this.camera
            );
          }),
          (HybridRendererBase.prototype.createImage = function (e) {
            return this.supports3d
              ? new HImageElement(e, this.globalData, this)
              : new IImageElement(e, this.globalData, this);
          }),
          (HybridRendererBase.prototype.createSolid = function (e) {
            return this.supports3d
              ? new HSolidElement(e, this.globalData, this)
              : new ISolidElement(e, this.globalData, this);
          }),
          (HybridRendererBase.prototype.createNull =
            SVGRenderer.prototype.createNull),
          (HybridRendererBase.prototype.getThreeDContainerByPos = function (e) {
            for (var t = 0, r = this.threeDElements.length; t < r; ) {
              if (
                this.threeDElements[t].startPos <= e &&
                this.threeDElements[t].endPos >= e
              )
                return this.threeDElements[t].perspectiveElem;
              t += 1;
            }
            return null;
          }),
          (HybridRendererBase.prototype.createThreeDContainer = function (
            e,
            t,
          ) {
            var r,
              n,
              i = createTag("div");
            styleDiv(i);
            var a = createTag("div");
            if ((styleDiv(a), t === "3d")) {
              ((r = i.style).width = this.globalData.compSize.w + "px"),
                (r.height = this.globalData.compSize.h + "px");
              var s = "50% 50%";
              (r.webkitTransformOrigin = s),
                (r.mozTransformOrigin = s),
                (r.transformOrigin = s);
              var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
              ((n = a.style).transform = o), (n.webkitTransform = o);
            }
            i.appendChild(a);
            var l = {
              container: a,
              perspectiveElem: i,
              startPos: e,
              endPos: e,
              type: t,
            };
            return this.threeDElements.push(l), l;
          }),
          (HybridRendererBase.prototype.build3dContainers = function () {
            var e,
              t,
              r = this.layers.length,
              n = "";
            for (e = 0; e < r; e += 1)
              this.layers[e].ddd && this.layers[e].ty !== 3
                ? (n !== "3d" &&
                    ((n = "3d"), (t = this.createThreeDContainer(e, "3d"))),
                  (t.endPos = Math.max(t.endPos, e)))
                : (n !== "2d" &&
                    ((n = "2d"), (t = this.createThreeDContainer(e, "2d"))),
                  (t.endPos = Math.max(t.endPos, e)));
            for (e = (r = this.threeDElements.length) - 1; e >= 0; e -= 1)
              this.resizerElem.appendChild(
                this.threeDElements[e].perspectiveElem,
              );
          }),
          (HybridRendererBase.prototype.addTo3dContainer = function (e, t) {
            for (var r = 0, n = this.threeDElements.length; r < n; ) {
              if (t <= this.threeDElements[r].endPos) {
                for (var i, a = this.threeDElements[r].startPos; a < t; )
                  this.elements[a] &&
                    this.elements[a].getBaseElement &&
                    (i = this.elements[a].getBaseElement()),
                    (a += 1);
                i
                  ? this.threeDElements[r].container.insertBefore(e, i)
                  : this.threeDElements[r].container.appendChild(e);
                break;
              }
              r += 1;
            }
          }),
          (HybridRendererBase.prototype.configAnimation = function (e) {
            var t = createTag("div"),
              r = this.animationItem.wrapper,
              n = t.style;
            (n.width = e.w + "px"),
              (n.height = e.h + "px"),
              (this.resizerElem = t),
              styleDiv(t),
              (n.transformStyle = "flat"),
              (n.mozTransformStyle = "flat"),
              (n.webkitTransformStyle = "flat"),
              this.renderConfig.className &&
                t.setAttribute("class", this.renderConfig.className),
              r.appendChild(t),
              (n.overflow = "hidden");
            var i = createNS("svg");
            i.setAttribute("width", "1"),
              i.setAttribute("height", "1"),
              styleDiv(i),
              this.resizerElem.appendChild(i);
            var a = createNS("defs");
            i.appendChild(a),
              (this.data = e),
              this.setupGlobalData(e, i),
              (this.globalData.defs = a),
              (this.layers = e.layers),
              (this.layerElement = this.resizerElem),
              this.build3dContainers(),
              this.updateContainerSize();
          }),
          (HybridRendererBase.prototype.destroy = function () {
            var e;
            this.animationItem.wrapper &&
              (this.animationItem.wrapper.innerText = ""),
              (this.animationItem.container = null),
              (this.globalData.defs = null);
            var t = this.layers ? this.layers.length : 0;
            for (e = 0; e < t; e += 1)
              this.elements[e] &&
                this.elements[e].destroy &&
                this.elements[e].destroy();
            (this.elements.length = 0),
              (this.destroyed = !0),
              (this.animationItem = null);
          }),
          (HybridRendererBase.prototype.updateContainerSize = function () {
            var e,
              t,
              r,
              n,
              i = this.animationItem.wrapper.offsetWidth,
              a = this.animationItem.wrapper.offsetHeight,
              s = i / a;
            this.globalData.compSize.w / this.globalData.compSize.h > s
              ? ((e = i / this.globalData.compSize.w),
                (t = i / this.globalData.compSize.w),
                (r = 0),
                (n =
                  (a -
                    this.globalData.compSize.h *
                      (i / this.globalData.compSize.w)) /
                  2))
              : ((e = a / this.globalData.compSize.h),
                (t = a / this.globalData.compSize.h),
                (r =
                  (i -
                    this.globalData.compSize.w *
                      (a / this.globalData.compSize.h)) /
                  2),
                (n = 0));
            var o = this.resizerElem.style;
            (o.webkitTransform =
              "matrix3d(" +
              e +
              ",0,0,0,0," +
              t +
              ",0,0,0,0,1,0," +
              r +
              "," +
              n +
              ",0,1)"),
              (o.transform = o.webkitTransform);
          }),
          (HybridRendererBase.prototype.renderFrame =
            SVGRenderer.prototype.renderFrame),
          (HybridRendererBase.prototype.hide = function () {
            this.resizerElem.style.display = "none";
          }),
          (HybridRendererBase.prototype.show = function () {
            this.resizerElem.style.display = "block";
          }),
          (HybridRendererBase.prototype.initItems = function () {
            if ((this.buildAllItems(), this.camera)) this.camera.setup();
            else {
              var e,
                t = this.globalData.compSize.w,
                r = this.globalData.compSize.h,
                n = this.threeDElements.length;
              for (e = 0; e < n; e += 1) {
                var i = this.threeDElements[e].perspectiveElem.style;
                (i.webkitPerspective =
                  Math.sqrt(Math.pow(t, 2) + Math.pow(r, 2)) + "px"),
                  (i.perspective = i.webkitPerspective);
              }
            }
          }),
          (HybridRendererBase.prototype.searchExtraCompositions = function (e) {
            var t,
              r = e.length,
              n = createTag("div");
            for (t = 0; t < r; t += 1)
              if (e[t].xt) {
                var i = this.createComp(e[t], n, this.globalData.comp, null);
                i.initExpressions(),
                  this.globalData.projectInterface.registerComposition(i);
              }
          }),
          extendPrototype(
            [HybridRendererBase, ICompElement, HBaseElement],
            HCompElement,
          ),
          (HCompElement.prototype._createBaseContainerElements =
            HCompElement.prototype.createContainerElements),
          (HCompElement.prototype.createContainerElements = function () {
            this._createBaseContainerElements(),
              this.data.hasMask
                ? (this.svgElement.setAttribute("width", this.data.w),
                  this.svgElement.setAttribute("height", this.data.h),
                  (this.transformedElement = this.baseElement))
                : (this.transformedElement = this.layerElement);
          }),
          (HCompElement.prototype.addTo3dContainer = function (e, t) {
            for (var r, n = 0; n < t; )
              this.elements[n] &&
                this.elements[n].getBaseElement &&
                (r = this.elements[n].getBaseElement()),
                (n += 1);
            r
              ? this.layerElement.insertBefore(e, r)
              : this.layerElement.appendChild(e);
          }),
          (HCompElement.prototype.createComp = function (e) {
            return this.supports3d
              ? new HCompElement(e, this.globalData, this)
              : new SVGCompElement(e, this.globalData, this);
          }),
          extendPrototype([HybridRendererBase], HybridRenderer),
          (HybridRenderer.prototype.createComp = function (e) {
            return this.supports3d
              ? new HCompElement(e, this.globalData, this)
              : new SVGCompElement(e, this.globalData, this);
          });
        var CompExpressionInterface = function (e) {
          function t(r) {
            for (var n = 0, i = e.layers.length; n < i; ) {
              if (e.layers[n].nm === r || e.layers[n].ind === r)
                return e.elements[n].layerInterface;
              n += 1;
            }
            return null;
          }
          return (
            Object.defineProperty(t, "_name", { value: e.data.nm }),
            (t.layer = t),
            (t.pixelAspect = 1),
            (t.height = e.data.h || e.globalData.compSize.h),
            (t.width = e.data.w || e.globalData.compSize.w),
            (t.pixelAspect = 1),
            (t.frameDuration = 1 / e.globalData.frameRate),
            (t.displayStartTime = 0),
            (t.numLayers = e.layers.length),
            t
          );
        };
        function _typeof$2(e) {
          return (
            (_typeof$2 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$2(e)
          );
        }
        function seedRandom(e, t) {
          var r,
            n = this,
            i = 256,
            a = t.pow(i, 6),
            s = t.pow(2, 52),
            o = 2 * s,
            l = 255;
          function f(p) {
            var m,
              h = p.length,
              g = this,
              y = 0,
              _ = (g.i = g.j = 0),
              b = (g.S = []);
            for (h || (p = [h++]); y < i; ) b[y] = y++;
            for (y = 0; y < i; y++)
              (b[y] = b[(_ = l & (_ + p[y % h] + (m = b[y])))]), (b[_] = m);
            g.g = function (I) {
              for (var P, S = 0, A = g.i, R = g.j, w = g.S; I--; )
                (P = w[(A = l & (A + 1))]),
                  (S =
                    S * i +
                    w[l & ((w[A] = w[(R = l & (R + P))]) + (w[R] = P))]);
              return (g.i = A), (g.j = R), S;
            };
          }
          function u(p, m) {
            return (m.i = p.i), (m.j = p.j), (m.S = p.S.slice()), m;
          }
          function c(p, m) {
            var h,
              g = [],
              y = _typeof$2(p);
            if (m && y == "object")
              for (h in p)
                try {
                  g.push(c(p[h], m - 1));
                } catch {}
            return g.length ? g : y == "string" ? p : p + "\0";
          }
          function v(p, m) {
            for (var h, g = p + "", y = 0; y < g.length; )
              m[l & y] = l & ((h ^= 19 * m[l & y]) + g.charCodeAt(y++));
            return d(m);
          }
          function d(p) {
            return String.fromCharCode.apply(0, p);
          }
          (t.seedrandom = function (p, m, h) {
            var g = [],
              y = v(
                c(
                  (m = m === !0 ? { entropy: !0 } : m || {}).entropy
                    ? [p, d(e)]
                    : p === null
                      ? (function () {
                          try {
                            var I = new Uint8Array(i);
                            return (
                              (n.crypto || n.msCrypto).getRandomValues(I), d(I)
                            );
                          } catch {
                            var P = n.navigator,
                              S = P && P.plugins;
                            return [+new Date(), n, S, n.screen, d(e)];
                          }
                        })()
                      : p,
                  3,
                ),
                g,
              ),
              _ = new f(g),
              b = function () {
                for (var I = _.g(6), P = a, S = 0; I < s; )
                  (I = (I + S) * i), (P *= i), (S = _.g(1));
                for (; I >= o; ) (I /= 2), (P /= 2), (S >>>= 1);
                return (I + S) / P;
              };
            return (
              (b.int32 = function () {
                return 0 | _.g(4);
              }),
              (b.quick = function () {
                return _.g(4) / 4294967296;
              }),
              (b.double = b),
              v(d(_.S), e),
              (
                m.pass ||
                h ||
                function (I, P, S, A) {
                  return (
                    A &&
                      (A.S && u(A, _),
                      (I.state = function () {
                        return u(_, {});
                      })),
                    S ? ((t.random = I), P) : I
                  );
                }
              )(b, y, "global" in m ? m.global : this == t, m.state)
            );
          }),
            v(t.random(), e);
        }
        function initialize$2(e) {
          seedRandom([], e);
        }
        var propTypes = { SHAPE: "shape" };
        function _typeof$1(e) {
          return (
            (_typeof$1 =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof$1(e)
          );
        }
        var ExpressionManager = (function () {
            var ob = {},
              Math = BMMath,
              window = null,
              document = null,
              XMLHttpRequest = null,
              fetch = null,
              frames = null,
              _lottieGlobal = {};
            function resetFrame() {
              _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(e) {
              return e.constructor === Array || e.constructor === Float32Array;
            }
            function isNumerable(e, t) {
              return (
                e === "number" ||
                t instanceof Number ||
                e === "boolean" ||
                e === "string"
              );
            }
            function $bm_neg(e) {
              var t = _typeof$1(e);
              if (t === "number" || e instanceof Number || t === "boolean")
                return -e;
              if ($bm_isInstanceOfArray(e)) {
                var r,
                  n = e.length,
                  i = [];
                for (r = 0; r < n; r += 1) i[r] = -e[r];
                return i;
              }
              return e.propType ? e.v : -e;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(
                0.333,
                0,
                0.833,
                0.833,
                "easeIn",
              ).get,
              easeOutBez = BezierFactory.getBezierEasing(
                0.167,
                0.167,
                0.667,
                1,
                "easeOut",
              ).get,
              easeInOutBez = BezierFactory.getBezierEasing(
                0.33,
                0,
                0.667,
                1,
                "easeInOut",
              ).get;
            function sum(e, t) {
              var r = _typeof$1(e),
                n = _typeof$1(t);
              if (
                (isNumerable(r, e) && isNumerable(n, t)) ||
                r === "string" ||
                n === "string"
              )
                return e + t;
              if ($bm_isInstanceOfArray(e) && isNumerable(n, t))
                return ((e = e.slice(0))[0] += t), e;
              if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
                return ((t = t.slice(0))[0] = e + t[0]), t;
              if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
                for (
                  var i = 0, a = e.length, s = t.length, o = [];
                  i < a || i < s;

                )
                  (typeof e[i] == "number" || e[i] instanceof Number) &&
                  (typeof t[i] == "number" || t[i] instanceof Number)
                    ? (o[i] = e[i] + t[i])
                    : (o[i] = t[i] === void 0 ? e[i] : e[i] || t[i]),
                    (i += 1);
                return o;
              }
              return 0;
            }
            var add = sum;
            function sub(e, t) {
              var r = _typeof$1(e),
                n = _typeof$1(t);
              if (isNumerable(r, e) && isNumerable(n, t))
                return (
                  r === "string" && (e = parseInt(e, 10)),
                  n === "string" && (t = parseInt(t, 10)),
                  e - t
                );
              if ($bm_isInstanceOfArray(e) && isNumerable(n, t))
                return ((e = e.slice(0))[0] -= t), e;
              if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
                return ((t = t.slice(0))[0] = e - t[0]), t;
              if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
                for (
                  var i = 0, a = e.length, s = t.length, o = [];
                  i < a || i < s;

                )
                  (typeof e[i] == "number" || e[i] instanceof Number) &&
                  (typeof t[i] == "number" || t[i] instanceof Number)
                    ? (o[i] = e[i] - t[i])
                    : (o[i] = t[i] === void 0 ? e[i] : e[i] || t[i]),
                    (i += 1);
                return o;
              }
              return 0;
            }
            function mul(e, t) {
              var r,
                n,
                i,
                a = _typeof$1(e),
                s = _typeof$1(t);
              if (isNumerable(a, e) && isNumerable(s, t)) return e * t;
              if ($bm_isInstanceOfArray(e) && isNumerable(s, t)) {
                for (
                  i = e.length, r = createTypedArray("float32", i), n = 0;
                  n < i;
                  n += 1
                )
                  r[n] = e[n] * t;
                return r;
              }
              if (isNumerable(a, e) && $bm_isInstanceOfArray(t)) {
                for (
                  i = t.length, r = createTypedArray("float32", i), n = 0;
                  n < i;
                  n += 1
                )
                  r[n] = e * t[n];
                return r;
              }
              return 0;
            }
            function div(e, t) {
              var r,
                n,
                i,
                a = _typeof$1(e),
                s = _typeof$1(t);
              if (isNumerable(a, e) && isNumerable(s, t)) return e / t;
              if ($bm_isInstanceOfArray(e) && isNumerable(s, t)) {
                for (
                  i = e.length, r = createTypedArray("float32", i), n = 0;
                  n < i;
                  n += 1
                )
                  r[n] = e[n] / t;
                return r;
              }
              if (isNumerable(a, e) && $bm_isInstanceOfArray(t)) {
                for (
                  i = t.length, r = createTypedArray("float32", i), n = 0;
                  n < i;
                  n += 1
                )
                  r[n] = e / t[n];
                return r;
              }
              return 0;
            }
            function mod(e, t) {
              return (
                typeof e == "string" && (e = parseInt(e, 10)),
                typeof t == "string" && (t = parseInt(t, 10)),
                e % t
              );
            }
            var $bm_sum = sum,
              $bm_sub = sub,
              $bm_mul = mul,
              $bm_div = div,
              $bm_mod = mod;
            function clamp(e, t, r) {
              if (t > r) {
                var n = r;
                (r = t), (t = n);
              }
              return Math.min(Math.max(e, t), r);
            }
            function radiansToDegrees(e) {
              return e / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(e) {
              return e * degToRads;
            }
            var degrees_to_radians = radiansToDegrees,
              helperLengthArray = [0, 0, 0, 0, 0, 0];
            function length(e, t) {
              if (typeof e == "number" || e instanceof Number)
                return (t = t || 0), Math.abs(e - t);
              var r;
              t || (t = helperLengthArray);
              var n = Math.min(e.length, t.length),
                i = 0;
              for (r = 0; r < n; r += 1) i += Math.pow(t[r] - e[r], 2);
              return Math.sqrt(i);
            }
            function normalize(e) {
              return div(e, length(e));
            }
            function rgbToHsl(e) {
              var t,
                r,
                n = e[0],
                i = e[1],
                a = e[2],
                s = Math.max(n, i, a),
                o = Math.min(n, i, a),
                l = (s + o) / 2;
              if (s === o) (t = 0), (r = 0);
              else {
                var f = s - o;
                switch (((r = l > 0.5 ? f / (2 - s - o) : f / (s + o)), s)) {
                  case n:
                    t = (i - a) / f + (i < a ? 6 : 0);
                    break;
                  case i:
                    t = (a - n) / f + 2;
                    break;
                  case a:
                    t = (n - i) / f + 4;
                }
                t /= 6;
              }
              return [t, r, l, e[3]];
            }
            function hue2rgb(e, t, r) {
              return (
                r < 0 && (r += 1),
                r > 1 && (r -= 1),
                r < 1 / 6
                  ? e + 6 * (t - e) * r
                  : r < 0.5
                    ? t
                    : r < 2 / 3
                      ? e + (t - e) * (2 / 3 - r) * 6
                      : e
              );
            }
            function hslToRgb(e) {
              var t,
                r,
                n,
                i = e[0],
                a = e[1],
                s = e[2];
              if (a === 0) (t = s), (n = s), (r = s);
              else {
                var o = s < 0.5 ? s * (1 + a) : s + a - s * a,
                  l = 2 * s - o;
                (t = hue2rgb(l, o, i + 1 / 3)),
                  (r = hue2rgb(l, o, i)),
                  (n = hue2rgb(l, o, i - 1 / 3));
              }
              return [t, r, n, e[3]];
            }
            function linear(e, t, r, n, i) {
              if (
                ((n !== void 0 && i !== void 0) ||
                  ((n = t), (i = r), (t = 0), (r = 1)),
                r < t)
              ) {
                var a = r;
                (r = t), (t = a);
              }
              if (e <= t) return n;
              if (e >= r) return i;
              var s,
                o = r === t ? 0 : (e - t) / (r - t);
              if (!n.length) return n + (i - n) * o;
              var l = n.length,
                f = createTypedArray("float32", l);
              for (s = 0; s < l; s += 1) f[s] = n[s] + (i[s] - n[s]) * o;
              return f;
            }
            function random(e, t) {
              if (
                (t === void 0 &&
                  (e === void 0 ? ((e = 0), (t = 1)) : ((t = e), (e = void 0))),
                t.length)
              ) {
                var r,
                  n = t.length;
                e || (e = createTypedArray("float32", n));
                var i = createTypedArray("float32", n),
                  a = BMMath.random();
                for (r = 0; r < n; r += 1) i[r] = e[r] + a * (t[r] - e[r]);
                return i;
              }
              return e === void 0 && (e = 0), e + BMMath.random() * (t - e);
            }
            function createPath(e, t, r, n) {
              var i,
                a = e.length,
                s = shapePool.newElement();
              s.setPathData(!!n, a);
              var o,
                l,
                f = [0, 0];
              for (i = 0; i < a; i += 1)
                (o = t && t[i] ? t[i] : f),
                  (l = r && r[i] ? r[i] : f),
                  s.setTripleAt(
                    e[i][0],
                    e[i][1],
                    l[0] + e[i][0],
                    l[1] + e[i][1],
                    o[0] + e[i][0],
                    o[1] + e[i][1],
                    i,
                    !0,
                  );
              return s;
            }
            function initiateExpression(elem, data, property) {
              function noOp(e) {
                return e;
              }
              if (!elem.globalData.renderConfig.runExpressions) return noOp;
              var val = data.x,
                needsVelocity = /velocity(?![\w\d])/.test(val),
                _needsRandom = val.indexOf("random") !== -1,
                elemType = elem.data.ty,
                transform,
                $bm_transform,
                content,
                effect,
                thisProperty = property;
              (thisProperty.valueAtTime = thisProperty.getValueAtTime),
                Object.defineProperty(thisProperty, "value", {
                  get: function () {
                    return thisProperty.v;
                  },
                }),
                (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
                (elem.comp.displayStartTime = 0);
              var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
                outPoint = elem.data.op / elem.comp.globalData.frameRate,
                width = elem.data.sw ? elem.data.sw : 0,
                height = elem.data.sh ? elem.data.sh : 0,
                name = elem.data.nm,
                loopIn,
                loop_in,
                loopOut,
                loop_out,
                smooth,
                toWorld,
                fromWorld,
                fromComp,
                toComp,
                fromCompToSurface,
                position,
                rotation,
                anchorPoint,
                scale,
                thisLayer,
                thisComp,
                mask,
                valueAtTime,
                velocityAtTime,
                scoped_bm_rt,
                expression_function = eval(
                  "[function _expression_function(){" +
                    val +
                    ";scoped_bm_rt=$bm_rt}]",
                )[0],
                numKeys = property.kf ? data.k.length : 0,
                active = !this.data || this.data.hd !== !0,
                wiggle = function (e, t) {
                  var r,
                    n,
                    i = this.pv.length ? this.pv.length : 1,
                    a = createTypedArray("float32", i),
                    s = Math.floor(5 * time);
                  for (r = 0, n = 0; r < s; ) {
                    for (n = 0; n < i; n += 1)
                      a[n] += -t + 2 * t * BMMath.random();
                    r += 1;
                  }
                  var o = 5 * time,
                    l = o - Math.floor(o),
                    f = createTypedArray("float32", i);
                  if (i > 1) {
                    for (n = 0; n < i; n += 1)
                      f[n] =
                        this.pv[n] + a[n] + (-t + 2 * t * BMMath.random()) * l;
                    return f;
                  }
                  return this.pv + a[0] + (-t + 2 * t * BMMath.random()) * l;
                }.bind(this);
              function loopInDuration(e, t) {
                return loopIn(e, t, !0);
              }
              function loopOutDuration(e, t) {
                return loopOut(e, t, !0);
              }
              thisProperty.loopIn &&
                ((loopIn = thisProperty.loopIn.bind(thisProperty)),
                (loop_in = loopIn)),
                thisProperty.loopOut &&
                  ((loopOut = thisProperty.loopOut.bind(thisProperty)),
                  (loop_out = loopOut)),
                thisProperty.smooth &&
                  (smooth = thisProperty.smooth.bind(thisProperty)),
                this.getValueAtTime &&
                  (valueAtTime = this.getValueAtTime.bind(this)),
                this.getVelocityAtTime &&
                  (velocityAtTime = this.getVelocityAtTime.bind(this));
              var comp = elem.comp.globalData.projectInterface.bind(
                  elem.comp.globalData.projectInterface,
                ),
                time,
                velocity,
                value,
                text,
                textIndex,
                textTotal,
                selectorValue;
              function lookAt(e, t) {
                var r = [t[0] - e[0], t[1] - e[1], t[2] - e[2]],
                  n =
                    Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) /
                    degToRads;
                return [-Math.atan2(r[1], r[2]) / degToRads, n, 0];
              }
              function easeOut(e, t, r, n, i) {
                return applyEase(easeOutBez, e, t, r, n, i);
              }
              function easeIn(e, t, r, n, i) {
                return applyEase(easeInBez, e, t, r, n, i);
              }
              function ease(e, t, r, n, i) {
                return applyEase(easeInOutBez, e, t, r, n, i);
              }
              function applyEase(e, t, r, n, i, a) {
                i === void 0 ? ((i = r), (a = n)) : (t = (t - r) / (n - r)),
                  t > 1 ? (t = 1) : t < 0 && (t = 0);
                var s = e(t);
                if ($bm_isInstanceOfArray(i)) {
                  var o,
                    l = i.length,
                    f = createTypedArray("float32", l);
                  for (o = 0; o < l; o += 1) f[o] = (a[o] - i[o]) * s + i[o];
                  return f;
                }
                return (a - i) * s + i;
              }
              function nearestKey(e) {
                var t,
                  r,
                  n,
                  i = data.k.length;
                if (data.k.length && typeof data.k[0] != "number")
                  if (
                    ((r = -1),
                    (e *= elem.comp.globalData.frameRate) < data.k[0].t)
                  )
                    (r = 1), (n = data.k[0].t);
                  else {
                    for (t = 0; t < i - 1; t += 1) {
                      if (e === data.k[t].t) {
                        (r = t + 1), (n = data.k[t].t);
                        break;
                      }
                      if (e > data.k[t].t && e < data.k[t + 1].t) {
                        e - data.k[t].t > data.k[t + 1].t - e
                          ? ((r = t + 2), (n = data.k[t + 1].t))
                          : ((r = t + 1), (n = data.k[t].t));
                        break;
                      }
                    }
                    r === -1 && ((r = t + 1), (n = data.k[t].t));
                  }
                else (r = 0), (n = 0);
                var a = {};
                return (
                  (a.index = r),
                  (a.time = n / elem.comp.globalData.frameRate),
                  a
                );
              }
              function key(e) {
                var t, r, n;
                if (!data.k.length || typeof data.k[0] == "number")
                  throw new Error("The property has no keyframe at index " + e);
                (e -= 1),
                  (t = {
                    time: data.k[e].t / elem.comp.globalData.frameRate,
                    value: [],
                  });
                var i = Object.prototype.hasOwnProperty.call(data.k[e], "s")
                  ? data.k[e].s
                  : data.k[e - 1].e;
                for (n = i.length, r = 0; r < n; r += 1)
                  (t[r] = i[r]), (t.value[r] = i[r]);
                return t;
              }
              function framesToTime(e, t) {
                return t || (t = elem.comp.globalData.frameRate), e / t;
              }
              function timeToFrames(e, t) {
                return (
                  e || e === 0 || (e = time),
                  t || (t = elem.comp.globalData.frameRate),
                  e * t
                );
              }
              function seedRandom(e) {
                BMMath.seedrandom(randSeed + e);
              }
              function sourceRectAtTime() {
                return elem.sourceRectAtTime();
              }
              function substring(e, t) {
                return typeof value == "string"
                  ? t === void 0
                    ? value.substring(e)
                    : value.substring(e, t)
                  : "";
              }
              function substr(e, t) {
                return typeof value == "string"
                  ? t === void 0
                    ? value.substr(e)
                    : value.substr(e, t)
                  : "";
              }
              function posterizeTime(e) {
                (time = e === 0 ? 0 : Math.floor(time * e) / e),
                  (value = valueAtTime(time));
              }
              var index = elem.data.ind,
                hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
                parent,
                randSeed = Math.floor(1e6 * Math.random()),
                globalData = elem.globalData;
              function executeExpression(e) {
                return (
                  (value = e),
                  this.frameExpressionId === elem.globalData.frameId &&
                  this.propType !== "textSelector"
                    ? value
                    : (this.propType === "textSelector" &&
                        ((textIndex = this.textIndex),
                        (textTotal = this.textTotal),
                        (selectorValue = this.selectorValue)),
                      thisLayer ||
                        ((text = elem.layerInterface.text),
                        (thisLayer = elem.layerInterface),
                        (thisComp = elem.comp.compInterface),
                        (toWorld = thisLayer.toWorld.bind(thisLayer)),
                        (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                        (fromComp = thisLayer.fromComp.bind(thisLayer)),
                        (toComp = thisLayer.toComp.bind(thisLayer)),
                        (mask = thisLayer.mask
                          ? thisLayer.mask.bind(thisLayer)
                          : null),
                        (fromCompToSurface = fromComp)),
                      transform ||
                        ((transform = elem.layerInterface(
                          "ADBE Transform Group",
                        )),
                        ($bm_transform = transform),
                        transform && (anchorPoint = transform.anchorPoint)),
                      elemType !== 4 ||
                        content ||
                        (content = thisLayer("ADBE Root Vectors Group")),
                      effect || (effect = thisLayer(4)),
                      (hasParent = !(
                        !elem.hierarchy || !elem.hierarchy.length
                      )) &&
                        !parent &&
                        (parent = elem.hierarchy[0].layerInterface),
                      (time =
                        this.comp.renderedFrame /
                        this.comp.globalData.frameRate),
                      _needsRandom && seedRandom(randSeed + time),
                      needsVelocity && (velocity = velocityAtTime(time)),
                      expression_function(),
                      (this.frameExpressionId = elem.globalData.frameId),
                      (scoped_bm_rt =
                        scoped_bm_rt.propType === propTypes.SHAPE
                          ? scoped_bm_rt.v
                          : scoped_bm_rt))
                );
              }
              return (
                (executeExpression.__preventDeadCodeRemoval = [
                  $bm_transform,
                  anchorPoint,
                  time,
                  velocity,
                  inPoint,
                  outPoint,
                  width,
                  height,
                  name,
                  loop_in,
                  loop_out,
                  smooth,
                  toComp,
                  fromCompToSurface,
                  toWorld,
                  fromWorld,
                  mask,
                  position,
                  rotation,
                  scale,
                  thisComp,
                  numKeys,
                  active,
                  wiggle,
                  loopInDuration,
                  loopOutDuration,
                  comp,
                  lookAt,
                  easeOut,
                  easeIn,
                  ease,
                  nearestKey,
                  key,
                  text,
                  textIndex,
                  textTotal,
                  selectorValue,
                  framesToTime,
                  timeToFrames,
                  sourceRectAtTime,
                  substring,
                  substr,
                  posterizeTime,
                  index,
                  globalData,
                ]),
                executeExpression
              );
            }
            return (
              (ob.initiateExpression = initiateExpression),
              (ob.__preventDeadCodeRemoval = [
                window,
                document,
                XMLHttpRequest,
                fetch,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal,
              ]),
              (ob.resetFrame = resetFrame),
              ob
            );
          })(),
          Expressions = (function () {
            var e = {};
            return (
              (e.initExpressions = function (t) {
                var r = 0,
                  n = [];
                (t.renderer.compInterface = CompExpressionInterface(
                  t.renderer,
                )),
                  t.renderer.globalData.projectInterface.registerComposition(
                    t.renderer,
                  ),
                  (t.renderer.globalData.pushExpression = function () {
                    r += 1;
                  }),
                  (t.renderer.globalData.popExpression = function () {
                    (r -= 1) == 0 &&
                      (function () {
                        var i,
                          a = n.length;
                        for (i = 0; i < a; i += 1) n[i].release();
                        n.length = 0;
                      })();
                  }),
                  (t.renderer.globalData.registerExpressionProperty = function (
                    i,
                  ) {
                    n.indexOf(i) === -1 && n.push(i);
                  });
              }),
              (e.resetFrame = ExpressionManager.resetFrame),
              e
            );
          })(),
          MaskManagerInterface = (function () {
            function e(t, r) {
              (this._mask = t), (this._data = r);
            }
            return (
              Object.defineProperty(e.prototype, "maskPath", {
                get: function () {
                  return (
                    this._mask.prop.k && this._mask.prop.getValue(),
                    this._mask.prop
                  );
                },
              }),
              Object.defineProperty(e.prototype, "maskOpacity", {
                get: function () {
                  return (
                    this._mask.op.k && this._mask.op.getValue(),
                    100 * this._mask.op.v
                  );
                },
              }),
              function (t) {
                var r,
                  n = createSizedArray(t.viewData.length),
                  i = t.viewData.length;
                for (r = 0; r < i; r += 1)
                  n[r] = new e(t.viewData[r], t.masksProperties[r]);
                return function (a) {
                  for (r = 0; r < i; ) {
                    if (t.masksProperties[r].nm === a) return n[r];
                    r += 1;
                  }
                  return null;
                };
              }
            );
          })(),
          ExpressionPropertyInterface = (function () {
            var e = { pv: 0, v: 0, mult: 1 },
              t = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
            function r(i, a, s) {
              Object.defineProperty(i, "velocity", {
                get: function () {
                  return a.getVelocityAtTime(a.comp.currentFrame);
                },
              }),
                (i.numKeys = a.keyframes ? a.keyframes.length : 0),
                (i.key = function (o) {
                  if (!i.numKeys) return 0;
                  var l = "";
                  l =
                    "s" in a.keyframes[o - 1]
                      ? a.keyframes[o - 1].s
                      : "e" in a.keyframes[o - 2]
                        ? a.keyframes[o - 2].e
                        : a.keyframes[o - 2].s;
                  var f =
                    s === "unidimensional"
                      ? new Number(l)
                      : Object.assign({}, l);
                  return (
                    (f.time =
                      a.keyframes[o - 1].t / a.elem.comp.globalData.frameRate),
                    (f.value = s === "unidimensional" ? l[0] : l),
                    f
                  );
                }),
                (i.valueAtTime = a.getValueAtTime),
                (i.speedAtTime = a.getSpeedAtTime),
                (i.velocityAtTime = a.getVelocityAtTime),
                (i.propertyGroup = a.propertyGroup);
            }
            function n() {
              return e;
            }
            return function (i) {
              return i
                ? i.propType === "unidimensional"
                  ? (function (a) {
                      (a && "pv" in a) || (a = e);
                      var s = 1 / a.mult,
                        o = a.pv * s,
                        l = new Number(o);
                      return (
                        (l.value = o),
                        r(l, a, "unidimensional"),
                        function () {
                          return (
                            a.k && a.getValue(),
                            (o = a.v * s),
                            l.value !== o &&
                              (((l = new Number(o)).value = o),
                              r(l, a, "unidimensional")),
                            l
                          );
                        }
                      );
                    })(i)
                  : (function (a) {
                      (a && "pv" in a) || (a = t);
                      var s = 1 / a.mult,
                        o = (a.data && a.data.l) || a.pv.length,
                        l = createTypedArray("float32", o),
                        f = createTypedArray("float32", o);
                      return (
                        (l.value = f),
                        r(l, a, "multidimensional"),
                        function () {
                          a.k && a.getValue();
                          for (var u = 0; u < o; u += 1)
                            (f[u] = a.v[u] * s), (l[u] = f[u]);
                          return l;
                        }
                      );
                    })(i)
                : n;
            };
          })(),
          TransformExpressionInterface = function (e) {
            function t(s) {
              switch (s) {
                case "scale":
                case "Scale":
                case "ADBE Scale":
                case 6:
                  return t.scale;
                case "rotation":
                case "Rotation":
                case "ADBE Rotation":
                case "ADBE Rotate Z":
                case 10:
                  return t.rotation;
                case "ADBE Rotate X":
                  return t.xRotation;
                case "ADBE Rotate Y":
                  return t.yRotation;
                case "position":
                case "Position":
                case "ADBE Position":
                case 2:
                  return t.position;
                case "ADBE Position_0":
                  return t.xPosition;
                case "ADBE Position_1":
                  return t.yPosition;
                case "ADBE Position_2":
                  return t.zPosition;
                case "anchorPoint":
                case "AnchorPoint":
                case "Anchor Point":
                case "ADBE AnchorPoint":
                case 1:
                  return t.anchorPoint;
                case "opacity":
                case "Opacity":
                case 11:
                  return t.opacity;
                default:
                  return null;
              }
            }
            var r, n, i, a;
            return (
              Object.defineProperty(t, "rotation", {
                get: ExpressionPropertyInterface(e.r || e.rz),
              }),
              Object.defineProperty(t, "zRotation", {
                get: ExpressionPropertyInterface(e.rz || e.r),
              }),
              Object.defineProperty(t, "xRotation", {
                get: ExpressionPropertyInterface(e.rx),
              }),
              Object.defineProperty(t, "yRotation", {
                get: ExpressionPropertyInterface(e.ry),
              }),
              Object.defineProperty(t, "scale", {
                get: ExpressionPropertyInterface(e.s),
              }),
              e.p
                ? (a = ExpressionPropertyInterface(e.p))
                : ((r = ExpressionPropertyInterface(e.px)),
                  (n = ExpressionPropertyInterface(e.py)),
                  e.pz && (i = ExpressionPropertyInterface(e.pz))),
              Object.defineProperty(t, "position", {
                get: function () {
                  return e.p ? a() : [r(), n(), i ? i() : 0];
                },
              }),
              Object.defineProperty(t, "xPosition", {
                get: ExpressionPropertyInterface(e.px),
              }),
              Object.defineProperty(t, "yPosition", {
                get: ExpressionPropertyInterface(e.py),
              }),
              Object.defineProperty(t, "zPosition", {
                get: ExpressionPropertyInterface(e.pz),
              }),
              Object.defineProperty(t, "anchorPoint", {
                get: ExpressionPropertyInterface(e.a),
              }),
              Object.defineProperty(t, "opacity", {
                get: ExpressionPropertyInterface(e.o),
              }),
              Object.defineProperty(t, "skew", {
                get: ExpressionPropertyInterface(e.sk),
              }),
              Object.defineProperty(t, "skewAxis", {
                get: ExpressionPropertyInterface(e.sa),
              }),
              Object.defineProperty(t, "orientation", {
                get: ExpressionPropertyInterface(e.or),
              }),
              t
            );
          },
          LayerExpressionInterface = (function () {
            function e(f) {
              var u = new Matrix();
              return (
                f !== void 0
                  ? this._elem.finalTransform.mProp.getValueAtTime(f).clone(u)
                  : this._elem.finalTransform.mProp.applyToMatrix(u),
                u
              );
            }
            function t(f, u) {
              var c = this.getMatrix(u);
              return (
                (c.props[12] = 0),
                (c.props[13] = 0),
                (c.props[14] = 0),
                this.applyPoint(c, f)
              );
            }
            function r(f, u) {
              var c = this.getMatrix(u);
              return this.applyPoint(c, f);
            }
            function n(f, u) {
              var c = this.getMatrix(u);
              return (
                (c.props[12] = 0),
                (c.props[13] = 0),
                (c.props[14] = 0),
                this.invertPoint(c, f)
              );
            }
            function i(f, u) {
              var c = this.getMatrix(u);
              return this.invertPoint(c, f);
            }
            function a(f, u) {
              if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var c,
                  v = this._elem.hierarchy.length;
                for (c = 0; c < v; c += 1)
                  this._elem.hierarchy[c].finalTransform.mProp.applyToMatrix(f);
              }
              return f.applyToPointArray(u[0], u[1], u[2] || 0);
            }
            function s(f, u) {
              if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var c,
                  v = this._elem.hierarchy.length;
                for (c = 0; c < v; c += 1)
                  this._elem.hierarchy[c].finalTransform.mProp.applyToMatrix(f);
              }
              return f.inversePoint(u);
            }
            function o(f) {
              var u = new Matrix();
              if (
                (u.reset(),
                this._elem.finalTransform.mProp.applyToMatrix(u),
                this._elem.hierarchy && this._elem.hierarchy.length)
              ) {
                var c,
                  v = this._elem.hierarchy.length;
                for (c = 0; c < v; c += 1)
                  this._elem.hierarchy[c].finalTransform.mProp.applyToMatrix(u);
                return u.inversePoint(f);
              }
              return u.inversePoint(f);
            }
            function l() {
              return [1, 1, 1, 1];
            }
            return function (f) {
              var u;
              function c(d) {
                switch (d) {
                  case "ADBE Root Vectors Group":
                  case "Contents":
                  case 2:
                    return c.shapeInterface;
                  case 1:
                  case 6:
                  case "Transform":
                  case "transform":
                  case "ADBE Transform Group":
                    return u;
                  case 4:
                  case "ADBE Effect Parade":
                  case "effects":
                  case "Effects":
                    return c.effect;
                  case "ADBE Text Properties":
                    return c.textInterface;
                  default:
                    return null;
                }
              }
              (c.getMatrix = e),
                (c.invertPoint = s),
                (c.applyPoint = a),
                (c.toWorld = r),
                (c.toWorldVec = t),
                (c.fromWorld = i),
                (c.fromWorldVec = n),
                (c.toComp = r),
                (c.fromComp = o),
                (c.sampleImage = l),
                (c.sourceRectAtTime = f.sourceRectAtTime.bind(f)),
                (c._elem = f);
              var v = getDescriptor(
                (u = TransformExpressionInterface(f.finalTransform.mProp)),
                "anchorPoint",
              );
              return (
                Object.defineProperties(c, {
                  hasParent: {
                    get: function () {
                      return f.hierarchy.length;
                    },
                  },
                  parent: {
                    get: function () {
                      return f.hierarchy[0].layerInterface;
                    },
                  },
                  rotation: getDescriptor(u, "rotation"),
                  scale: getDescriptor(u, "scale"),
                  position: getDescriptor(u, "position"),
                  opacity: getDescriptor(u, "opacity"),
                  anchorPoint: v,
                  anchor_point: v,
                  transform: {
                    get: function () {
                      return u;
                    },
                  },
                  active: {
                    get: function () {
                      return f.isInRange;
                    },
                  },
                }),
                (c.startTime = f.data.st),
                (c.index = f.data.ind),
                (c.source = f.data.refId),
                (c.height = f.data.ty === 0 ? f.data.h : 100),
                (c.width = f.data.ty === 0 ? f.data.w : 100),
                (c.inPoint = f.data.ip / f.comp.globalData.frameRate),
                (c.outPoint = f.data.op / f.comp.globalData.frameRate),
                (c._name = f.data.nm),
                (c.registerMaskInterface = function (d) {
                  c.mask = new MaskManagerInterface(d, f);
                }),
                (c.registerEffectsInterface = function (d) {
                  c.effect = d;
                }),
                c
              );
            };
          })(),
          propertyGroupFactory = function (e, t) {
            return function (r) {
              return (r = r === void 0 ? 1 : r) <= 0 ? e : t(r - 1);
            };
          },
          PropertyInterface = function (e, t) {
            var r = { _name: e };
            return function (n) {
              return (n = n === void 0 ? 1 : n) <= 0 ? r : t(n - 1);
            };
          },
          EffectsExpressionInterface = (function () {
            function e(r, n, i, a) {
              function s(c) {
                for (var v = r.ef, d = 0, p = v.length; d < p; ) {
                  if (c === v[d].nm || c === v[d].mn || c === v[d].ix)
                    return v[d].ty === 5 ? f[d] : f[d]();
                  d += 1;
                }
                throw new Error();
              }
              var o,
                l = propertyGroupFactory(s, i),
                f = [],
                u = r.ef.length;
              for (o = 0; o < u; o += 1)
                r.ef[o].ty === 5
                  ? f.push(
                      e(
                        r.ef[o],
                        n.effectElements[o],
                        n.effectElements[o].propertyGroup,
                        a,
                      ),
                    )
                  : f.push(t(n.effectElements[o], r.ef[o].ty, a, l));
              return (
                r.mn === "ADBE Color Control" &&
                  Object.defineProperty(s, "color", {
                    get: function () {
                      return f[0]();
                    },
                  }),
                Object.defineProperties(s, {
                  numProperties: {
                    get: function () {
                      return r.np;
                    },
                  },
                  _name: { value: r.nm },
                  propertyGroup: { value: l },
                }),
                (s.enabled = r.en !== 0),
                (s.active = s.enabled),
                s
              );
            }
            function t(r, n, i, a) {
              var s = ExpressionPropertyInterface(r.p);
              return (
                r.p.setGroupProperty &&
                  r.p.setGroupProperty(PropertyInterface("", a)),
                function () {
                  return n === 10 ? i.comp.compInterface(r.p.v) : s();
                }
              );
            }
            return {
              createEffectsInterface: function (r, n) {
                if (r.effectsManager) {
                  var i,
                    a = [],
                    s = r.data.ef,
                    o = r.effectsManager.effectElements.length;
                  for (i = 0; i < o; i += 1)
                    a.push(e(s[i], r.effectsManager.effectElements[i], n, r));
                  var l = r.data.ef || [],
                    f = function (u) {
                      for (i = 0, o = l.length; i < o; ) {
                        if (u === l[i].nm || u === l[i].mn || u === l[i].ix)
                          return a[i];
                        i += 1;
                      }
                      return null;
                    };
                  return (
                    Object.defineProperty(f, "numProperties", {
                      get: function () {
                        return l.length;
                      },
                    }),
                    f
                  );
                }
                return null;
              },
            };
          })(),
          ShapePathInterface = function (e, t, r) {
            var n = t.sh;
            function i(s) {
              return s === "Shape" ||
                s === "shape" ||
                s === "Path" ||
                s === "path" ||
                s === "ADBE Vector Shape" ||
                s === 2
                ? i.path
                : null;
            }
            var a = propertyGroupFactory(i, r);
            return (
              n.setGroupProperty(PropertyInterface("Path", a)),
              Object.defineProperties(i, {
                path: {
                  get: function () {
                    return n.k && n.getValue(), n;
                  },
                },
                shape: {
                  get: function () {
                    return n.k && n.getValue(), n;
                  },
                },
                _name: { value: e.nm },
                ix: { value: e.ix },
                propertyIndex: { value: e.ix },
                mn: { value: e.mn },
                propertyGroup: { value: r },
              }),
              i
            );
          },
          ShapeExpressionInterface = (function () {
            function e(d, p, m) {
              var h,
                g = [],
                y = d ? d.length : 0;
              for (h = 0; h < y; h += 1)
                d[h].ty === "gr"
                  ? g.push(t(d[h], p[h], m))
                  : d[h].ty === "fl"
                    ? g.push(r(d[h], p[h], m))
                    : d[h].ty === "st"
                      ? g.push(a(d[h], p[h], m))
                      : d[h].ty === "tm"
                        ? g.push(s(d[h], p[h], m))
                        : d[h].ty === "tr" ||
                          (d[h].ty === "el"
                            ? g.push(l(d[h], p[h], m))
                            : d[h].ty === "sr"
                              ? g.push(f(d[h], p[h], m))
                              : d[h].ty === "sh"
                                ? g.push(ShapePathInterface(d[h], p[h], m))
                                : d[h].ty === "rc"
                                  ? g.push(u(d[h], p[h], m))
                                  : d[h].ty === "rd"
                                    ? g.push(c(d[h], p[h], m))
                                    : d[h].ty === "rp"
                                      ? g.push(v(d[h], p[h], m))
                                      : d[h].ty === "gf"
                                        ? g.push(n(d[h], p[h], m))
                                        : g.push(i(d[h], p[h])));
              return g;
            }
            function t(d, p, m) {
              var h = function (_) {
                switch (_) {
                  case "ADBE Vectors Group":
                  case "Contents":
                  case 2:
                    return h.content;
                  default:
                    return h.transform;
                }
              };
              h.propertyGroup = propertyGroupFactory(h, m);
              var g = (function (_, b, I) {
                  var P,
                    S = function (R) {
                      for (var w = 0, C = P.length; w < C; ) {
                        if (
                          P[w]._name === R ||
                          P[w].mn === R ||
                          P[w].propertyIndex === R ||
                          P[w].ix === R ||
                          P[w].ind === R
                        )
                          return P[w];
                        w += 1;
                      }
                      return typeof R == "number" ? P[R - 1] : null;
                    };
                  (S.propertyGroup = propertyGroupFactory(S, I)),
                    (P = e(_.it, b.it, S.propertyGroup)),
                    (S.numProperties = P.length);
                  var A = o(
                    _.it[_.it.length - 1],
                    b.it[b.it.length - 1],
                    S.propertyGroup,
                  );
                  return (
                    (S.transform = A),
                    (S.propertyIndex = _.cix),
                    (S._name = _.nm),
                    S
                  );
                })(d, p, h.propertyGroup),
                y = o(
                  d.it[d.it.length - 1],
                  p.it[p.it.length - 1],
                  h.propertyGroup,
                );
              return (
                (h.content = g),
                (h.transform = y),
                Object.defineProperty(h, "_name", {
                  get: function () {
                    return d.nm;
                  },
                }),
                (h.numProperties = d.np),
                (h.propertyIndex = d.ix),
                (h.nm = d.nm),
                (h.mn = d.mn),
                h
              );
            }
            function r(d, p, m) {
              function h(g) {
                return g === "Color" || g === "color"
                  ? h.color
                  : g === "Opacity" || g === "opacity"
                    ? h.opacity
                    : null;
              }
              return (
                Object.defineProperties(h, {
                  color: { get: ExpressionPropertyInterface(p.c) },
                  opacity: { get: ExpressionPropertyInterface(p.o) },
                  _name: { value: d.nm },
                  mn: { value: d.mn },
                }),
                p.c.setGroupProperty(PropertyInterface("Color", m)),
                p.o.setGroupProperty(PropertyInterface("Opacity", m)),
                h
              );
            }
            function n(d, p, m) {
              function h(g) {
                return g === "Start Point" || g === "start point"
                  ? h.startPoint
                  : g === "End Point" || g === "end point"
                    ? h.endPoint
                    : g === "Opacity" || g === "opacity"
                      ? h.opacity
                      : null;
              }
              return (
                Object.defineProperties(h, {
                  startPoint: { get: ExpressionPropertyInterface(p.s) },
                  endPoint: { get: ExpressionPropertyInterface(p.e) },
                  opacity: { get: ExpressionPropertyInterface(p.o) },
                  type: {
                    get: function () {
                      return "a";
                    },
                  },
                  _name: { value: d.nm },
                  mn: { value: d.mn },
                }),
                p.s.setGroupProperty(PropertyInterface("Start Point", m)),
                p.e.setGroupProperty(PropertyInterface("End Point", m)),
                p.o.setGroupProperty(PropertyInterface("Opacity", m)),
                h
              );
            }
            function i() {
              return function () {
                return null;
              };
            }
            function a(d, p, m) {
              var h,
                g = propertyGroupFactory(P, m),
                y = propertyGroupFactory(I, g);
              function _(S) {
                Object.defineProperty(I, d.d[S].nm, {
                  get: ExpressionPropertyInterface(p.d.dataProps[S].p),
                });
              }
              var b = d.d ? d.d.length : 0,
                I = {};
              for (h = 0; h < b; h += 1)
                _(h), p.d.dataProps[h].p.setGroupProperty(y);
              function P(S) {
                return S === "Color" || S === "color"
                  ? P.color
                  : S === "Opacity" || S === "opacity"
                    ? P.opacity
                    : S === "Stroke Width" || S === "stroke width"
                      ? P.strokeWidth
                      : null;
              }
              return (
                Object.defineProperties(P, {
                  color: { get: ExpressionPropertyInterface(p.c) },
                  opacity: { get: ExpressionPropertyInterface(p.o) },
                  strokeWidth: { get: ExpressionPropertyInterface(p.w) },
                  dash: {
                    get: function () {
                      return I;
                    },
                  },
                  _name: { value: d.nm },
                  mn: { value: d.mn },
                }),
                p.c.setGroupProperty(PropertyInterface("Color", g)),
                p.o.setGroupProperty(PropertyInterface("Opacity", g)),
                p.w.setGroupProperty(PropertyInterface("Stroke Width", g)),
                P
              );
            }
            function s(d, p, m) {
              function h(y) {
                return y === d.e.ix || y === "End" || y === "end"
                  ? h.end
                  : y === d.s.ix
                    ? h.start
                    : y === d.o.ix
                      ? h.offset
                      : null;
              }
              var g = propertyGroupFactory(h, m);
              return (
                (h.propertyIndex = d.ix),
                p.s.setGroupProperty(PropertyInterface("Start", g)),
                p.e.setGroupProperty(PropertyInterface("End", g)),
                p.o.setGroupProperty(PropertyInterface("Offset", g)),
                (h.propertyIndex = d.ix),
                (h.propertyGroup = m),
                Object.defineProperties(h, {
                  start: { get: ExpressionPropertyInterface(p.s) },
                  end: { get: ExpressionPropertyInterface(p.e) },
                  offset: { get: ExpressionPropertyInterface(p.o) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            function o(d, p, m) {
              function h(y) {
                return d.a.ix === y || y === "Anchor Point"
                  ? h.anchorPoint
                  : d.o.ix === y || y === "Opacity"
                    ? h.opacity
                    : d.p.ix === y || y === "Position"
                      ? h.position
                      : d.r.ix === y ||
                          y === "Rotation" ||
                          y === "ADBE Vector Rotation"
                        ? h.rotation
                        : d.s.ix === y || y === "Scale"
                          ? h.scale
                          : (d.sk && d.sk.ix === y) || y === "Skew"
                            ? h.skew
                            : (d.sa && d.sa.ix === y) || y === "Skew Axis"
                              ? h.skewAxis
                              : null;
              }
              var g = propertyGroupFactory(h, m);
              return (
                p.transform.mProps.o.setGroupProperty(
                  PropertyInterface("Opacity", g),
                ),
                p.transform.mProps.p.setGroupProperty(
                  PropertyInterface("Position", g),
                ),
                p.transform.mProps.a.setGroupProperty(
                  PropertyInterface("Anchor Point", g),
                ),
                p.transform.mProps.s.setGroupProperty(
                  PropertyInterface("Scale", g),
                ),
                p.transform.mProps.r.setGroupProperty(
                  PropertyInterface("Rotation", g),
                ),
                p.transform.mProps.sk &&
                  (p.transform.mProps.sk.setGroupProperty(
                    PropertyInterface("Skew", g),
                  ),
                  p.transform.mProps.sa.setGroupProperty(
                    PropertyInterface("Skew Angle", g),
                  )),
                p.transform.op.setGroupProperty(
                  PropertyInterface("Opacity", g),
                ),
                Object.defineProperties(h, {
                  opacity: {
                    get: ExpressionPropertyInterface(p.transform.mProps.o),
                  },
                  position: {
                    get: ExpressionPropertyInterface(p.transform.mProps.p),
                  },
                  anchorPoint: {
                    get: ExpressionPropertyInterface(p.transform.mProps.a),
                  },
                  scale: {
                    get: ExpressionPropertyInterface(p.transform.mProps.s),
                  },
                  rotation: {
                    get: ExpressionPropertyInterface(p.transform.mProps.r),
                  },
                  skew: {
                    get: ExpressionPropertyInterface(p.transform.mProps.sk),
                  },
                  skewAxis: {
                    get: ExpressionPropertyInterface(p.transform.mProps.sa),
                  },
                  _name: { value: d.nm },
                }),
                (h.ty = "tr"),
                (h.mn = d.mn),
                (h.propertyGroup = m),
                h
              );
            }
            function l(d, p, m) {
              function h(_) {
                return d.p.ix === _ ? h.position : d.s.ix === _ ? h.size : null;
              }
              var g = propertyGroupFactory(h, m);
              h.propertyIndex = d.ix;
              var y = p.sh.ty === "tm" ? p.sh.prop : p.sh;
              return (
                y.s.setGroupProperty(PropertyInterface("Size", g)),
                y.p.setGroupProperty(PropertyInterface("Position", g)),
                Object.defineProperties(h, {
                  size: { get: ExpressionPropertyInterface(y.s) },
                  position: { get: ExpressionPropertyInterface(y.p) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            function f(d, p, m) {
              function h(_) {
                return d.p.ix === _
                  ? h.position
                  : d.r.ix === _
                    ? h.rotation
                    : d.pt.ix === _
                      ? h.points
                      : d.or.ix === _ || _ === "ADBE Vector Star Outer Radius"
                        ? h.outerRadius
                        : d.os.ix === _
                          ? h.outerRoundness
                          : !d.ir ||
                              (d.ir.ix !== _ &&
                                _ !== "ADBE Vector Star Inner Radius")
                            ? d.is && d.is.ix === _
                              ? h.innerRoundness
                              : null
                            : h.innerRadius;
              }
              var g = propertyGroupFactory(h, m),
                y = p.sh.ty === "tm" ? p.sh.prop : p.sh;
              return (
                (h.propertyIndex = d.ix),
                y.or.setGroupProperty(PropertyInterface("Outer Radius", g)),
                y.os.setGroupProperty(PropertyInterface("Outer Roundness", g)),
                y.pt.setGroupProperty(PropertyInterface("Points", g)),
                y.p.setGroupProperty(PropertyInterface("Position", g)),
                y.r.setGroupProperty(PropertyInterface("Rotation", g)),
                d.ir &&
                  (y.ir.setGroupProperty(PropertyInterface("Inner Radius", g)),
                  y.is.setGroupProperty(
                    PropertyInterface("Inner Roundness", g),
                  )),
                Object.defineProperties(h, {
                  position: { get: ExpressionPropertyInterface(y.p) },
                  rotation: { get: ExpressionPropertyInterface(y.r) },
                  points: { get: ExpressionPropertyInterface(y.pt) },
                  outerRadius: { get: ExpressionPropertyInterface(y.or) },
                  outerRoundness: { get: ExpressionPropertyInterface(y.os) },
                  innerRadius: { get: ExpressionPropertyInterface(y.ir) },
                  innerRoundness: { get: ExpressionPropertyInterface(y.is) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            function u(d, p, m) {
              function h(_) {
                return d.p.ix === _
                  ? h.position
                  : d.r.ix === _
                    ? h.roundness
                    : d.s.ix === _ ||
                        _ === "Size" ||
                        _ === "ADBE Vector Rect Size"
                      ? h.size
                      : null;
              }
              var g = propertyGroupFactory(h, m),
                y = p.sh.ty === "tm" ? p.sh.prop : p.sh;
              return (
                (h.propertyIndex = d.ix),
                y.p.setGroupProperty(PropertyInterface("Position", g)),
                y.s.setGroupProperty(PropertyInterface("Size", g)),
                y.r.setGroupProperty(PropertyInterface("Rotation", g)),
                Object.defineProperties(h, {
                  position: { get: ExpressionPropertyInterface(y.p) },
                  roundness: { get: ExpressionPropertyInterface(y.r) },
                  size: { get: ExpressionPropertyInterface(y.s) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            function c(d, p, m) {
              function h(_) {
                return d.r.ix === _ || _ === "Round Corners 1"
                  ? h.radius
                  : null;
              }
              var g = propertyGroupFactory(h, m),
                y = p;
              return (
                (h.propertyIndex = d.ix),
                y.rd.setGroupProperty(PropertyInterface("Radius", g)),
                Object.defineProperties(h, {
                  radius: { get: ExpressionPropertyInterface(y.rd) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            function v(d, p, m) {
              function h(_) {
                return d.c.ix === _ || _ === "Copies"
                  ? h.copies
                  : d.o.ix === _ || _ === "Offset"
                    ? h.offset
                    : null;
              }
              var g = propertyGroupFactory(h, m),
                y = p;
              return (
                (h.propertyIndex = d.ix),
                y.c.setGroupProperty(PropertyInterface("Copies", g)),
                y.o.setGroupProperty(PropertyInterface("Offset", g)),
                Object.defineProperties(h, {
                  copies: { get: ExpressionPropertyInterface(y.c) },
                  offset: { get: ExpressionPropertyInterface(y.o) },
                  _name: { value: d.nm },
                }),
                (h.mn = d.mn),
                h
              );
            }
            return function (d, p, m) {
              var h;
              function g(y) {
                if (typeof y == "number")
                  return (y = y === void 0 ? 1 : y) === 0 ? m : h[y - 1];
                for (var _ = 0, b = h.length; _ < b; ) {
                  if (h[_]._name === y) return h[_];
                  _ += 1;
                }
                return null;
              }
              return (
                (g.propertyGroup = propertyGroupFactory(g, function () {
                  return m;
                })),
                (h = e(d, p, g.propertyGroup)),
                (g.numProperties = h.length),
                (g._name = "Contents"),
                g
              );
            };
          })(),
          TextExpressionInterface = function (e) {
            var t;
            function r(n) {
              return n === "ADBE Text Document" ? r.sourceText : null;
            }
            return (
              Object.defineProperty(r, "sourceText", {
                get: function () {
                  e.textProperty.getValue();
                  var n = e.textProperty.currentData.t;
                  return (
                    (t && n === t.value) ||
                      (((t = new String(n)).value = n || new String(n)),
                      Object.defineProperty(t, "style", {
                        get: function () {
                          return { fillColor: e.textProperty.currentData.fc };
                        },
                      })),
                    t
                  );
                },
              }),
              r
            );
          };
        function _typeof(e) {
          return (
            (_typeof =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            _typeof(e)
          );
        }
        var FootageInterface =
            ((dataInterfaceFactory = function (e) {
              function t(r) {
                return r === "Outline" ? t.outlineInterface() : null;
              }
              return (
                (t._name = "Outline"),
                (t.outlineInterface = (function (r) {
                  var n = "",
                    i = r.getFootageData();
                  function a(s) {
                    if (i[s])
                      return (n = s), _typeof((i = i[s])) === "object" ? a : i;
                    var o = s.indexOf(n);
                    if (o !== -1) {
                      var l = parseInt(s.substr(o + n.length), 10);
                      return _typeof((i = i[l])) === "object" ? a : i;
                    }
                    return "";
                  }
                  return function () {
                    return (n = ""), (i = r.getFootageData()), a;
                  };
                })(e)),
                t
              );
            }),
            function (e) {
              function t(r) {
                return r === "Data" ? t.dataInterface : null;
              }
              return (
                (t._name = "Data"),
                (t.dataInterface = dataInterfaceFactory(e)),
                t
              );
            }),
          dataInterfaceFactory,
          interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface,
          };
        function getInterface(e) {
          return interfaces[e] || null;
        }
        var expressionHelpers = {
          searchExpressions: function (e, t, r) {
            t.x &&
              ((r.k = !0),
              (r.x = !0),
              (r.initiateExpression = ExpressionManager.initiateExpression),
              r.effectsSequence.push(r.initiateExpression(e, t, r).bind(r)));
          },
          getSpeedAtTime: function (e) {
            var t = this.getValueAtTime(e),
              r = this.getValueAtTime(e + -0.01),
              n = 0;
            if (t.length) {
              var i;
              for (i = 0; i < t.length; i += 1) n += Math.pow(r[i] - t[i], 2);
              n = 100 * Math.sqrt(n);
            } else n = 0;
            return n;
          },
          getVelocityAtTime: function (e) {
            if (this.vel !== void 0) return this.vel;
            var t,
              r,
              n = -0.001,
              i = this.getValueAtTime(e),
              a = this.getValueAtTime(e + n);
            if (i.length)
              for (
                t = createTypedArray("float32", i.length), r = 0;
                r < i.length;
                r += 1
              )
                t[r] = (a[r] - i[r]) / n;
            else t = (a - i) / n;
            return t;
          },
          getValueAtTime: function (e) {
            return (
              (e *= this.elem.globalData.frameRate),
              (e -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
                ((this._cachingAtTime.lastIndex =
                  this._cachingAtTime.lastFrame < e
                    ? this._cachingAtTime.lastIndex
                    : 0),
                (this._cachingAtTime.value = this.interpolateValue(
                  e,
                  this._cachingAtTime,
                )),
                (this._cachingAtTime.lastFrame = e)),
              this._cachingAtTime.value
            );
          },
          getStaticValueAtTime: function () {
            return this.pv;
          },
          setGroupProperty: function (e) {
            this.propertyGroup = e;
          },
        };
        function addPropertyDecorator() {
          function e(c, v, d) {
            if (!this.k || !this.keyframes) return this.pv;
            c = c ? c.toLowerCase() : "";
            var p,
              m,
              h,
              g,
              y,
              _ = this.comp.renderedFrame,
              b = this.keyframes,
              I = b[b.length - 1].t;
            if (_ <= I) return this.pv;
            if (
              (d
                ? (m =
                    I -
                    (p = v
                      ? Math.abs(I - this.elem.comp.globalData.frameRate * v)
                      : Math.max(0, I - this.elem.data.ip)))
                : ((!v || v > b.length - 1) && (v = b.length - 1),
                  (p = I - (m = b[b.length - 1 - v].t))),
              c === "pingpong")
            ) {
              if (Math.floor((_ - m) / p) % 2 != 0)
                return this.getValueAtTime(
                  (p - ((_ - m) % p) + m) / this.comp.globalData.frameRate,
                  0,
                );
            } else {
              if (c === "offset") {
                var P = this.getValueAtTime(
                    m / this.comp.globalData.frameRate,
                    0,
                  ),
                  S = this.getValueAtTime(
                    I / this.comp.globalData.frameRate,
                    0,
                  ),
                  A = this.getValueAtTime(
                    (((_ - m) % p) + m) / this.comp.globalData.frameRate,
                    0,
                  ),
                  R = Math.floor((_ - m) / p);
                if (this.pv.length) {
                  for (
                    g = (y = new Array(P.length)).length, h = 0;
                    h < g;
                    h += 1
                  )
                    y[h] = (S[h] - P[h]) * R + A[h];
                  return y;
                }
                return (S - P) * R + A;
              }
              if (c === "continue") {
                var w = this.getValueAtTime(
                    I / this.comp.globalData.frameRate,
                    0,
                  ),
                  C = this.getValueAtTime(
                    (I - 0.001) / this.comp.globalData.frameRate,
                    0,
                  );
                if (this.pv.length) {
                  for (
                    g = (y = new Array(w.length)).length, h = 0;
                    h < g;
                    h += 1
                  )
                    y[h] =
                      w[h] +
                      ((w[h] - C[h]) *
                        ((_ - I) / this.comp.globalData.frameRate)) /
                        5e-4;
                  return y;
                }
                return w + ((_ - I) / 0.001) * (w - C);
              }
            }
            return this.getValueAtTime(
              (((_ - m) % p) + m) / this.comp.globalData.frameRate,
              0,
            );
          }
          function t(c, v, d) {
            if (!this.k) return this.pv;
            c = c ? c.toLowerCase() : "";
            var p,
              m,
              h,
              g,
              y,
              _ = this.comp.renderedFrame,
              b = this.keyframes,
              I = b[0].t;
            if (_ >= I) return this.pv;
            if (
              (d
                ? (m =
                    I +
                    (p = v
                      ? Math.abs(this.elem.comp.globalData.frameRate * v)
                      : Math.max(0, this.elem.data.op - I)))
                : ((!v || v > b.length - 1) && (v = b.length - 1),
                  (p = (m = b[v].t) - I)),
              c === "pingpong")
            ) {
              if (Math.floor((I - _) / p) % 2 == 0)
                return this.getValueAtTime(
                  (((I - _) % p) + I) / this.comp.globalData.frameRate,
                  0,
                );
            } else {
              if (c === "offset") {
                var P = this.getValueAtTime(
                    I / this.comp.globalData.frameRate,
                    0,
                  ),
                  S = this.getValueAtTime(
                    m / this.comp.globalData.frameRate,
                    0,
                  ),
                  A = this.getValueAtTime(
                    (p - ((I - _) % p) + I) / this.comp.globalData.frameRate,
                    0,
                  ),
                  R = Math.floor((I - _) / p) + 1;
                if (this.pv.length) {
                  for (
                    g = (y = new Array(P.length)).length, h = 0;
                    h < g;
                    h += 1
                  )
                    y[h] = A[h] - (S[h] - P[h]) * R;
                  return y;
                }
                return A - (S - P) * R;
              }
              if (c === "continue") {
                var w = this.getValueAtTime(
                    I / this.comp.globalData.frameRate,
                    0,
                  ),
                  C = this.getValueAtTime(
                    (I + 0.001) / this.comp.globalData.frameRate,
                    0,
                  );
                if (this.pv.length) {
                  for (
                    g = (y = new Array(w.length)).length, h = 0;
                    h < g;
                    h += 1
                  )
                    y[h] = w[h] + ((w[h] - C[h]) * (I - _)) / 0.001;
                  return y;
                }
                return w + ((w - C) * (I - _)) / 0.001;
              }
            }
            return this.getValueAtTime(
              (p - (((I - _) % p) + I)) / this.comp.globalData.frameRate,
              0,
            );
          }
          function r(c, v) {
            if (!this.k) return this.pv;
            if (((c = 0.5 * (c || 0.4)), (v = Math.floor(v || 5)) <= 1))
              return this.pv;
            var d,
              p,
              m = this.comp.renderedFrame / this.comp.globalData.frameRate,
              h = m - c,
              g = v > 1 ? (m + c - h) / (v - 1) : 1,
              y = 0,
              _ = 0;
            for (
              d = this.pv.length
                ? createTypedArray("float32", this.pv.length)
                : 0;
              y < v;

            ) {
              if (((p = this.getValueAtTime(h + y * g)), this.pv.length))
                for (_ = 0; _ < this.pv.length; _ += 1) d[_] += p[_];
              else d += p;
              y += 1;
            }
            if (this.pv.length)
              for (_ = 0; _ < this.pv.length; _ += 1) d[_] /= v;
            else d /= v;
            return d;
          }
          function n(c) {
            this._transformCachingAtTime ||
              (this._transformCachingAtTime = { v: new Matrix() });
            var v = this._transformCachingAtTime.v;
            if (
              (v.cloneFromProps(this.pre.props),
              this.appliedTransformations < 1)
            ) {
              var d = this.a.getValueAtTime(c);
              v.translate(
                -d[0] * this.a.mult,
                -d[1] * this.a.mult,
                d[2] * this.a.mult,
              );
            }
            if (this.appliedTransformations < 2) {
              var p = this.s.getValueAtTime(c);
              v.scale(
                p[0] * this.s.mult,
                p[1] * this.s.mult,
                p[2] * this.s.mult,
              );
            }
            if (this.sk && this.appliedTransformations < 3) {
              var m = this.sk.getValueAtTime(c),
                h = this.sa.getValueAtTime(c);
              v.skewFromAxis(-m * this.sk.mult, h * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
              var g = this.r.getValueAtTime(c);
              v.rotate(-g * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
              var y = this.rz.getValueAtTime(c),
                _ = this.ry.getValueAtTime(c),
                b = this.rx.getValueAtTime(c),
                I = this.or.getValueAtTime(c);
              v.rotateZ(-y * this.rz.mult)
                .rotateY(_ * this.ry.mult)
                .rotateX(b * this.rx.mult)
                .rotateZ(-I[2] * this.or.mult)
                .rotateY(I[1] * this.or.mult)
                .rotateX(I[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
              var P = this.px.getValueAtTime(c),
                S = this.py.getValueAtTime(c);
              if (this.data.p.z) {
                var A = this.pz.getValueAtTime(c);
                v.translate(
                  P * this.px.mult,
                  S * this.py.mult,
                  -A * this.pz.mult,
                );
              } else v.translate(P * this.px.mult, S * this.py.mult, 0);
            } else {
              var R = this.p.getValueAtTime(c);
              v.translate(
                R[0] * this.p.mult,
                R[1] * this.p.mult,
                -R[2] * this.p.mult,
              );
            }
            return v;
          }
          function i() {
            return this.v.clone(new Matrix());
          }
          var a = TransformPropertyFactory.getTransformProperty;
          TransformPropertyFactory.getTransformProperty = function (c, v, d) {
            var p = a(c, v, d);
            return (
              p.dynamicProperties.length
                ? (p.getValueAtTime = n.bind(p))
                : (p.getValueAtTime = i.bind(p)),
              (p.setGroupProperty = expressionHelpers.setGroupProperty),
              p
            );
          };
          var s = PropertyFactory.getProp;
          PropertyFactory.getProp = function (c, v, d, p, m) {
            var h = s(c, v, d, p, m);
            h.kf
              ? (h.getValueAtTime = expressionHelpers.getValueAtTime.bind(h))
              : (h.getValueAtTime =
                  expressionHelpers.getStaticValueAtTime.bind(h)),
              (h.setGroupProperty = expressionHelpers.setGroupProperty),
              (h.loopOut = e),
              (h.loopIn = t),
              (h.smooth = r),
              (h.getVelocityAtTime =
                expressionHelpers.getVelocityAtTime.bind(h)),
              (h.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(h)),
              (h.numKeys = v.a === 1 ? v.k.length : 0),
              (h.propertyIndex = v.ix);
            var g = 0;
            return (
              d !== 0 &&
                (g = createTypedArray(
                  "float32",
                  v.a === 1 ? v.k[0].s.length : v.k.length,
                )),
              (h._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: g,
              }),
              expressionHelpers.searchExpressions(c, v, h),
              h.k && m.addDynamicProperty(h),
              h
            );
          };
          var o = ShapePropertyFactory.getConstructorFunction(),
            l = ShapePropertyFactory.getKeyframedConstructorFunction();
          function f() {}
          (f.prototype = {
            vertices: function (c, v) {
              this.k && this.getValue();
              var d,
                p = this.v;
              v !== void 0 && (p = this.getValueAtTime(v, 0));
              var m = p._length,
                h = p[c],
                g = p.v,
                y = createSizedArray(m);
              for (d = 0; d < m; d += 1)
                y[d] =
                  c === "i" || c === "o"
                    ? [h[d][0] - g[d][0], h[d][1] - g[d][1]]
                    : [h[d][0], h[d][1]];
              return y;
            },
            points: function (c) {
              return this.vertices("v", c);
            },
            inTangents: function (c) {
              return this.vertices("i", c);
            },
            outTangents: function (c) {
              return this.vertices("o", c);
            },
            isClosed: function () {
              return this.v.c;
            },
            pointOnPath: function (c, v) {
              var d = this.v;
              v !== void 0 && (d = this.getValueAtTime(v, 0)),
                this._segmentsLength ||
                  (this._segmentsLength = bez.getSegmentsLength(d));
              for (
                var p,
                  m = this._segmentsLength,
                  h = m.lengths,
                  g = m.totalLength * c,
                  y = 0,
                  _ = h.length,
                  b = 0;
                y < _;

              ) {
                if (b + h[y].addedLength > g) {
                  var I = y,
                    P = d.c && y === _ - 1 ? 0 : y + 1,
                    S = (g - b) / h[y].addedLength;
                  p = bez.getPointInSegment(
                    d.v[I],
                    d.v[P],
                    d.o[I],
                    d.i[P],
                    S,
                    h[y],
                  );
                  break;
                }
                (b += h[y].addedLength), (y += 1);
              }
              return (
                p ||
                  (p = d.c
                    ? [d.v[0][0], d.v[0][1]]
                    : [d.v[d._length - 1][0], d.v[d._length - 1][1]]),
                p
              );
            },
            vectorOnPath: function (c, v, d) {
              c == 1 ? (c = this.v.c) : c == 0 && (c = 0.999);
              var p = this.pointOnPath(c, v),
                m = this.pointOnPath(c + 0.001, v),
                h = m[0] - p[0],
                g = m[1] - p[1],
                y = Math.sqrt(Math.pow(h, 2) + Math.pow(g, 2));
              return y === 0
                ? [0, 0]
                : d === "tangent"
                  ? [h / y, g / y]
                  : [-g / y, h / y];
            },
            tangentOnPath: function (c, v) {
              return this.vectorOnPath(c, v, "tangent");
            },
            normalOnPath: function (c, v) {
              return this.vectorOnPath(c, v, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime,
          }),
            extendPrototype([f], o),
            extendPrototype([f], l),
            (l.prototype.getValueAtTime = function (c) {
              return (
                this._cachingAtTime ||
                  (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame,
                  }),
                (c *= this.elem.globalData.frameRate),
                (c -= this.offsetTime) !== this._cachingAtTime.lastTime &&
                  ((this._cachingAtTime.lastIndex =
                    this._cachingAtTime.lastTime < c
                      ? this._caching.lastIndex
                      : 0),
                  (this._cachingAtTime.lastTime = c),
                  this.interpolateShape(
                    c,
                    this._cachingAtTime.shapeValue,
                    this._cachingAtTime,
                  )),
                this._cachingAtTime.shapeValue
              );
            }),
            (l.prototype.initiateExpression =
              ExpressionManager.initiateExpression);
          var u = ShapePropertyFactory.getShapeProp;
          ShapePropertyFactory.getShapeProp = function (c, v, d, p, m) {
            var h = u(c, v, d, p, m);
            return (
              (h.propertyIndex = v.ix),
              (h.lock = !1),
              d === 3
                ? expressionHelpers.searchExpressions(c, v.pt, h)
                : d === 4 && expressionHelpers.searchExpressions(c, v.ks, h),
              h.k && c.addDynamicProperty(h),
              h
            );
          };
        }
        function initialize$1() {
          addPropertyDecorator();
        }
        function addDecorator() {
          (TextProperty.prototype.getExpressionValue = function (e, t) {
            var r = this.calculateExpression(t);
            if (e.t !== r) {
              var n = {};
              return (
                this.copyData(n, e),
                (n.t = r.toString()),
                (n.__complete = !1),
                n
              );
            }
            return e;
          }),
            (TextProperty.prototype.searchProperty = function () {
              var e = this.searchKeyframes(),
                t = this.searchExpressions();
              return (this.kf = e || t), this.kf;
            }),
            (TextProperty.prototype.searchExpressions = function () {
              return this.data.d.x
                ? ((this.calculateExpression =
                    ExpressionManager.initiateExpression.bind(this)(
                      this.elem,
                      this.data.d,
                      this,
                    )),
                  this.addEffect(this.getExpressionValue.bind(this)),
                  !0)
                : null;
            });
        }
        function initialize() {
          addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
          createMergeNode: function (e, t) {
            var r,
              n,
              i = createNS("feMerge");
            for (i.setAttribute("result", e), n = 0; n < t.length; n += 1)
              (r = createNS("feMergeNode")).setAttribute("in", t[n]),
                i.appendChild(r),
                i.appendChild(r);
            return i;
          },
        };
        var linearFilterValue =
          "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(e, t, r, n, i) {
          this.filterManager = t;
          var a = createNS("feColorMatrix");
          a.setAttribute("type", "matrix"),
            a.setAttribute("color-interpolation-filters", "linearRGB"),
            a.setAttribute("values", linearFilterValue + " 1 0"),
            (this.linearFilter = a),
            a.setAttribute("result", n + "_tint_1"),
            e.appendChild(a),
            (a = createNS("feColorMatrix")).setAttribute("type", "matrix"),
            a.setAttribute("color-interpolation-filters", "sRGB"),
            a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
            a.setAttribute("result", n + "_tint_2"),
            e.appendChild(a),
            (this.matrixFilter = a);
          var s = this.createMergeNode(n, [i, n + "_tint_1", n + "_tint_2"]);
          e.appendChild(s);
        }
        function SVGFillFilter(e, t, r, n) {
          this.filterManager = t;
          var i = createNS("feColorMatrix");
          i.setAttribute("type", "matrix"),
            i.setAttribute("color-interpolation-filters", "sRGB"),
            i.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
            i.setAttribute("result", n),
            e.appendChild(i),
            (this.matrixFilter = i);
        }
        function SVGStrokeEffect(e, t, r) {
          (this.initialized = !1),
            (this.filterManager = t),
            (this.elem = r),
            (this.paths = []);
        }
        function SVGTritoneFilter(e, t, r, n) {
          this.filterManager = t;
          var i = createNS("feColorMatrix");
          i.setAttribute("type", "matrix"),
            i.setAttribute("color-interpolation-filters", "linearRGB"),
            i.setAttribute(
              "values",
              "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0",
            ),
            e.appendChild(i);
          var a = createNS("feComponentTransfer");
          a.setAttribute("color-interpolation-filters", "sRGB"),
            a.setAttribute("result", n),
            (this.matrixFilter = a);
          var s = createNS("feFuncR");
          s.setAttribute("type", "table"), a.appendChild(s), (this.feFuncR = s);
          var o = createNS("feFuncG");
          o.setAttribute("type", "table"), a.appendChild(o), (this.feFuncG = o);
          var l = createNS("feFuncB");
          l.setAttribute("type", "table"),
            a.appendChild(l),
            (this.feFuncB = l),
            e.appendChild(a);
        }
        function SVGProLevelsFilter(e, t, r, n) {
          this.filterManager = t;
          var i = this.filterManager.effectElements,
            a = createNS("feComponentTransfer");
          (i[10].p.k ||
            i[10].p.v !== 0 ||
            i[11].p.k ||
            i[11].p.v !== 1 ||
            i[12].p.k ||
            i[12].p.v !== 1 ||
            i[13].p.k ||
            i[13].p.v !== 0 ||
            i[14].p.k ||
            i[14].p.v !== 1) &&
            (this.feFuncR = this.createFeFunc("feFuncR", a)),
            (i[17].p.k ||
              i[17].p.v !== 0 ||
              i[18].p.k ||
              i[18].p.v !== 1 ||
              i[19].p.k ||
              i[19].p.v !== 1 ||
              i[20].p.k ||
              i[20].p.v !== 0 ||
              i[21].p.k ||
              i[21].p.v !== 1) &&
              (this.feFuncG = this.createFeFunc("feFuncG", a)),
            (i[24].p.k ||
              i[24].p.v !== 0 ||
              i[25].p.k ||
              i[25].p.v !== 1 ||
              i[26].p.k ||
              i[26].p.v !== 1 ||
              i[27].p.k ||
              i[27].p.v !== 0 ||
              i[28].p.k ||
              i[28].p.v !== 1) &&
              (this.feFuncB = this.createFeFunc("feFuncB", a)),
            (i[31].p.k ||
              i[31].p.v !== 0 ||
              i[32].p.k ||
              i[32].p.v !== 1 ||
              i[33].p.k ||
              i[33].p.v !== 1 ||
              i[34].p.k ||
              i[34].p.v !== 0 ||
              i[35].p.k ||
              i[35].p.v !== 1) &&
              (this.feFuncA = this.createFeFunc("feFuncA", a)),
            (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) &&
              (a.setAttribute("color-interpolation-filters", "sRGB"),
              e.appendChild(a)),
            (i[3].p.k ||
              i[3].p.v !== 0 ||
              i[4].p.k ||
              i[4].p.v !== 1 ||
              i[5].p.k ||
              i[5].p.v !== 1 ||
              i[6].p.k ||
              i[6].p.v !== 0 ||
              i[7].p.k ||
              i[7].p.v !== 1) &&
              ((a = createNS("feComponentTransfer")).setAttribute(
                "color-interpolation-filters",
                "sRGB",
              ),
              a.setAttribute("result", n),
              e.appendChild(a),
              (this.feFuncRComposed = this.createFeFunc("feFuncR", a)),
              (this.feFuncGComposed = this.createFeFunc("feFuncG", a)),
              (this.feFuncBComposed = this.createFeFunc("feFuncB", a)));
        }
        function SVGDropShadowEffect(e, t, r, n, i) {
          var a = t.container.globalData.renderConfig.filterSize,
            s = t.data.fs || a;
          e.setAttribute("x", s.x || a.x),
            e.setAttribute("y", s.y || a.y),
            e.setAttribute("width", s.width || a.width),
            e.setAttribute("height", s.height || a.height),
            (this.filterManager = t);
          var o = createNS("feGaussianBlur");
          o.setAttribute("in", "SourceAlpha"),
            o.setAttribute("result", n + "_drop_shadow_1"),
            o.setAttribute("stdDeviation", "0"),
            (this.feGaussianBlur = o),
            e.appendChild(o);
          var l = createNS("feOffset");
          l.setAttribute("dx", "25"),
            l.setAttribute("dy", "0"),
            l.setAttribute("in", n + "_drop_shadow_1"),
            l.setAttribute("result", n + "_drop_shadow_2"),
            (this.feOffset = l),
            e.appendChild(l);
          var f = createNS("feFlood");
          f.setAttribute("flood-color", "#00ff00"),
            f.setAttribute("flood-opacity", "1"),
            f.setAttribute("result", n + "_drop_shadow_3"),
            (this.feFlood = f),
            e.appendChild(f);
          var u = createNS("feComposite");
          u.setAttribute("in", n + "_drop_shadow_3"),
            u.setAttribute("in2", n + "_drop_shadow_2"),
            u.setAttribute("operator", "in"),
            u.setAttribute("result", n + "_drop_shadow_4"),
            e.appendChild(u);
          var c = this.createMergeNode(n, [n + "_drop_shadow_4", i]);
          e.appendChild(c);
        }
        extendPrototype([SVGComposableEffect], SVGTintFilter),
          (SVGTintFilter.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              var t = this.filterManager.effectElements[0].p.v,
                r = this.filterManager.effectElements[1].p.v,
                n = this.filterManager.effectElements[2].p.v / 100;
              this.linearFilter.setAttribute(
                "values",
                linearFilterValue + " " + n + " 0",
              ),
                this.matrixFilter.setAttribute(
                  "values",
                  r[0] -
                    t[0] +
                    " 0 0 0 " +
                    t[0] +
                    " " +
                    (r[1] - t[1]) +
                    " 0 0 0 " +
                    t[1] +
                    " " +
                    (r[2] - t[2]) +
                    " 0 0 0 " +
                    t[2] +
                    " 0 0 0 1 0",
                );
            }
          }),
          (SVGFillFilter.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              var t = this.filterManager.effectElements[2].p.v,
                r = this.filterManager.effectElements[6].p.v;
              this.matrixFilter.setAttribute(
                "values",
                "0 0 0 0 " +
                  t[0] +
                  " 0 0 0 0 " +
                  t[1] +
                  " 0 0 0 0 " +
                  t[2] +
                  " 0 0 0 " +
                  r +
                  " 0",
              );
            }
          }),
          (SVGStrokeEffect.prototype.initialize = function () {
            var e,
              t,
              r,
              n,
              i =
                this.elem.layerElement.children ||
                this.elem.layerElement.childNodes;
            for (
              this.filterManager.effectElements[1].p.v === 1
                ? ((n = this.elem.maskManager.masksProperties.length), (r = 0))
                : (n = (r = this.filterManager.effectElements[0].p.v - 1) + 1),
                (t = createNS("g")).setAttribute("fill", "none"),
                t.setAttribute("stroke-linecap", "round"),
                t.setAttribute("stroke-dashoffset", 1);
              r < n;
              r += 1
            )
              (e = createNS("path")),
                t.appendChild(e),
                this.paths.push({ p: e, m: r });
            if (this.filterManager.effectElements[10].p.v === 3) {
              var a = createNS("mask"),
                s = createElementID();
              a.setAttribute("id", s),
                a.setAttribute("mask-type", "alpha"),
                a.appendChild(t),
                this.elem.globalData.defs.appendChild(a);
              var o = createNS("g");
              for (
                o.setAttribute(
                  "mask",
                  "url(" + getLocationHref() + "#" + s + ")",
                );
                i[0];

              )
                o.appendChild(i[0]);
              this.elem.layerElement.appendChild(o),
                (this.masker = a),
                t.setAttribute("stroke", "#fff");
            } else if (
              this.filterManager.effectElements[10].p.v === 1 ||
              this.filterManager.effectElements[10].p.v === 2
            ) {
              if (this.filterManager.effectElements[10].p.v === 2)
                for (
                  i =
                    this.elem.layerElement.children ||
                    this.elem.layerElement.childNodes;
                  i.length;

                )
                  this.elem.layerElement.removeChild(i[0]);
              this.elem.layerElement.appendChild(t),
                this.elem.layerElement.removeAttribute("mask"),
                t.setAttribute("stroke", "#fff");
            }
            (this.initialized = !0), (this.pathMasker = t);
          }),
          (SVGStrokeEffect.prototype.renderFrame = function (e) {
            var t;
            this.initialized || this.initialize();
            var r,
              n,
              i = this.paths.length;
            for (t = 0; t < i; t += 1)
              if (
                this.paths[t].m !== -1 &&
                ((r = this.elem.maskManager.viewData[this.paths[t].m]),
                (n = this.paths[t].p),
                (e || this.filterManager._mdf || r.prop._mdf) &&
                  n.setAttribute("d", r.lastPath),
                e ||
                  this.filterManager.effectElements[9].p._mdf ||
                  this.filterManager.effectElements[4].p._mdf ||
                  this.filterManager.effectElements[7].p._mdf ||
                  this.filterManager.effectElements[8].p._mdf ||
                  r.prop._mdf)
              ) {
                var a;
                if (
                  this.filterManager.effectElements[7].p.v !== 0 ||
                  this.filterManager.effectElements[8].p.v !== 100
                ) {
                  var s =
                      0.01 *
                      Math.min(
                        this.filterManager.effectElements[7].p.v,
                        this.filterManager.effectElements[8].p.v,
                      ),
                    o =
                      0.01 *
                      Math.max(
                        this.filterManager.effectElements[7].p.v,
                        this.filterManager.effectElements[8].p.v,
                      ),
                    l = n.getTotalLength();
                  a = "0 0 0 " + l * s + " ";
                  var f,
                    u = l * (o - s),
                    c =
                      1 +
                      2 *
                        this.filterManager.effectElements[4].p.v *
                        this.filterManager.effectElements[9].p.v *
                        0.01,
                    v = Math.floor(u / c);
                  for (f = 0; f < v; f += 1)
                    a +=
                      "1 " +
                      2 *
                        this.filterManager.effectElements[4].p.v *
                        this.filterManager.effectElements[9].p.v *
                        0.01 +
                      " ";
                  a += "0 " + 10 * l + " 0 0";
                } else
                  a =
                    "1 " +
                    2 *
                      this.filterManager.effectElements[4].p.v *
                      this.filterManager.effectElements[9].p.v *
                      0.01;
                n.setAttribute("stroke-dasharray", a);
              }
            if (
              ((e || this.filterManager.effectElements[4].p._mdf) &&
                this.pathMasker.setAttribute(
                  "stroke-width",
                  2 * this.filterManager.effectElements[4].p.v,
                ),
              (e || this.filterManager.effectElements[6].p._mdf) &&
                this.pathMasker.setAttribute(
                  "opacity",
                  this.filterManager.effectElements[6].p.v,
                ),
              (this.filterManager.effectElements[10].p.v === 1 ||
                this.filterManager.effectElements[10].p.v === 2) &&
                (e || this.filterManager.effectElements[3].p._mdf))
            ) {
              var d = this.filterManager.effectElements[3].p.v;
              this.pathMasker.setAttribute(
                "stroke",
                "rgb(" +
                  bmFloor(255 * d[0]) +
                  "," +
                  bmFloor(255 * d[1]) +
                  "," +
                  bmFloor(255 * d[2]) +
                  ")",
              );
            }
          }),
          (SVGTritoneFilter.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              var t = this.filterManager.effectElements[0].p.v,
                r = this.filterManager.effectElements[1].p.v,
                n = this.filterManager.effectElements[2].p.v,
                i = n[0] + " " + r[0] + " " + t[0],
                a = n[1] + " " + r[1] + " " + t[1],
                s = n[2] + " " + r[2] + " " + t[2];
              this.feFuncR.setAttribute("tableValues", i),
                this.feFuncG.setAttribute("tableValues", a),
                this.feFuncB.setAttribute("tableValues", s);
            }
          }),
          (SVGProLevelsFilter.prototype.createFeFunc = function (e, t) {
            var r = createNS(e);
            return r.setAttribute("type", "table"), t.appendChild(r), r;
          }),
          (SVGProLevelsFilter.prototype.getTableValue = function (
            e,
            t,
            r,
            n,
            i,
          ) {
            for (
              var a,
                s,
                o = 0,
                l = Math.min(e, t),
                f = Math.max(e, t),
                u = Array.call(null, { length: 256 }),
                c = 0,
                v = i - n,
                d = t - e;
              o <= 256;

            )
              (s =
                (a = o / 256) <= l
                  ? d < 0
                    ? i
                    : n
                  : a >= f
                    ? d < 0
                      ? n
                      : i
                    : n + v * Math.pow((a - e) / d, 1 / r)),
                (u[c] = s),
                (c += 1),
                (o += 256 / 255);
            return u.join(" ");
          }),
          (SVGProLevelsFilter.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              var t,
                r = this.filterManager.effectElements;
              this.feFuncRComposed &&
                (e ||
                  r[3].p._mdf ||
                  r[4].p._mdf ||
                  r[5].p._mdf ||
                  r[6].p._mdf ||
                  r[7].p._mdf) &&
                ((t = this.getTableValue(
                  r[3].p.v,
                  r[4].p.v,
                  r[5].p.v,
                  r[6].p.v,
                  r[7].p.v,
                )),
                this.feFuncRComposed.setAttribute("tableValues", t),
                this.feFuncGComposed.setAttribute("tableValues", t),
                this.feFuncBComposed.setAttribute("tableValues", t)),
                this.feFuncR &&
                  (e ||
                    r[10].p._mdf ||
                    r[11].p._mdf ||
                    r[12].p._mdf ||
                    r[13].p._mdf ||
                    r[14].p._mdf) &&
                  ((t = this.getTableValue(
                    r[10].p.v,
                    r[11].p.v,
                    r[12].p.v,
                    r[13].p.v,
                    r[14].p.v,
                  )),
                  this.feFuncR.setAttribute("tableValues", t)),
                this.feFuncG &&
                  (e ||
                    r[17].p._mdf ||
                    r[18].p._mdf ||
                    r[19].p._mdf ||
                    r[20].p._mdf ||
                    r[21].p._mdf) &&
                  ((t = this.getTableValue(
                    r[17].p.v,
                    r[18].p.v,
                    r[19].p.v,
                    r[20].p.v,
                    r[21].p.v,
                  )),
                  this.feFuncG.setAttribute("tableValues", t)),
                this.feFuncB &&
                  (e ||
                    r[24].p._mdf ||
                    r[25].p._mdf ||
                    r[26].p._mdf ||
                    r[27].p._mdf ||
                    r[28].p._mdf) &&
                  ((t = this.getTableValue(
                    r[24].p.v,
                    r[25].p.v,
                    r[26].p.v,
                    r[27].p.v,
                    r[28].p.v,
                  )),
                  this.feFuncB.setAttribute("tableValues", t)),
                this.feFuncA &&
                  (e ||
                    r[31].p._mdf ||
                    r[32].p._mdf ||
                    r[33].p._mdf ||
                    r[34].p._mdf ||
                    r[35].p._mdf) &&
                  ((t = this.getTableValue(
                    r[31].p.v,
                    r[32].p.v,
                    r[33].p.v,
                    r[34].p.v,
                    r[35].p.v,
                  )),
                  this.feFuncA.setAttribute("tableValues", t));
            }
          }),
          extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
          (SVGDropShadowEffect.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              if (
                ((e || this.filterManager.effectElements[4].p._mdf) &&
                  this.feGaussianBlur.setAttribute(
                    "stdDeviation",
                    this.filterManager.effectElements[4].p.v / 4,
                  ),
                e || this.filterManager.effectElements[0].p._mdf)
              ) {
                var t = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute(
                  "flood-color",
                  rgbToHex(
                    Math.round(255 * t[0]),
                    Math.round(255 * t[1]),
                    Math.round(255 * t[2]),
                  ),
                );
              }
              if (
                ((e || this.filterManager.effectElements[1].p._mdf) &&
                  this.feFlood.setAttribute(
                    "flood-opacity",
                    this.filterManager.effectElements[1].p.v / 255,
                  ),
                e ||
                  this.filterManager.effectElements[2].p._mdf ||
                  this.filterManager.effectElements[3].p._mdf)
              ) {
                var r = this.filterManager.effectElements[3].p.v,
                  n =
                    (this.filterManager.effectElements[2].p.v - 90) * degToRads,
                  i = r * Math.cos(n),
                  a = r * Math.sin(n);
                this.feOffset.setAttribute("dx", i),
                  this.feOffset.setAttribute("dy", a);
              }
            }
          });
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(e, t, r) {
          (this.initialized = !1),
            (this.filterManager = t),
            (this.filterElem = e),
            (this.elem = r),
            (r.matteElement = createNS("g")),
            r.matteElement.appendChild(r.layerElement),
            r.matteElement.appendChild(r.transformedElement),
            (r.baseElement = r.matteElement);
        }
        function SVGGaussianBlurEffect(e, t, r, n) {
          e.setAttribute("x", "-100%"),
            e.setAttribute("y", "-100%"),
            e.setAttribute("width", "300%"),
            e.setAttribute("height", "300%"),
            (this.filterManager = t);
          var i = createNS("feGaussianBlur");
          i.setAttribute("result", n),
            e.appendChild(i),
            (this.feGaussianBlur = i);
        }
        function TransformEffect() {}
        function SVGTransformEffect(e, t) {
          this.init(t);
        }
        function CVTransformEffect(e) {
          this.init(e);
        }
        return (
          (SVGMatte3Effect.prototype.findSymbol = function (e) {
            for (var t = 0, r = _svgMatteSymbols.length; t < r; ) {
              if (_svgMatteSymbols[t] === e) return _svgMatteSymbols[t];
              t += 1;
            }
            return null;
          }),
          (SVGMatte3Effect.prototype.replaceInParent = function (e, t) {
            var r = e.layerElement.parentNode;
            if (r) {
              for (
                var n, i = r.children, a = 0, s = i.length;
                a < s && i[a] !== e.layerElement;

              )
                a += 1;
              a <= s - 2 && (n = i[a + 1]);
              var o = createNS("use");
              o.setAttribute("href", "#" + t),
                n ? r.insertBefore(o, n) : r.appendChild(o);
            }
          }),
          (SVGMatte3Effect.prototype.setElementAsMask = function (e, t) {
            if (!this.findSymbol(t)) {
              var r = createElementID(),
                n = createNS("mask");
              n.setAttribute("id", t.layerId),
                n.setAttribute("mask-type", "alpha"),
                _svgMatteSymbols.push(t);
              var i = e.globalData.defs;
              i.appendChild(n);
              var a = createNS("symbol");
              a.setAttribute("id", r),
                this.replaceInParent(t, r),
                a.appendChild(t.layerElement),
                i.appendChild(a);
              var s = createNS("use");
              s.setAttribute("href", "#" + r),
                n.appendChild(s),
                (t.data.hd = !1),
                t.show();
            }
            e.setMatte(t.layerId);
          }),
          (SVGMatte3Effect.prototype.initialize = function () {
            for (
              var e = this.filterManager.effectElements[0].p.v,
                t = this.elem.comp.elements,
                r = 0,
                n = t.length;
              r < n;

            )
              t[r] &&
                t[r].data.ind === e &&
                this.setElementAsMask(this.elem, t[r]),
                (r += 1);
            this.initialized = !0;
          }),
          (SVGMatte3Effect.prototype.renderFrame = function () {
            this.initialized || this.initialize();
          }),
          (SVGGaussianBlurEffect.prototype.renderFrame = function (e) {
            if (e || this.filterManager._mdf) {
              var t = 0.3 * this.filterManager.effectElements[0].p.v,
                r = this.filterManager.effectElements[1].p.v,
                n = r == 3 ? 0 : t,
                i = r == 2 ? 0 : t;
              this.feGaussianBlur.setAttribute("stdDeviation", n + " " + i);
              var a =
                this.filterManager.effectElements[2].p.v == 1
                  ? "wrap"
                  : "duplicate";
              this.feGaussianBlur.setAttribute("edgeMode", a);
            }
          }),
          (TransformEffect.prototype.init = function (e) {
            (this.effectsManager = e),
              (this.type = effectTypes.TRANSFORM_EFFECT),
              (this.matrix = new Matrix()),
              (this.opacity = -1),
              (this._mdf = !1),
              (this._opMdf = !1);
          }),
          (TransformEffect.prototype.renderFrame = function (e) {
            if (
              ((this._opMdf = !1),
              (this._mdf = !1),
              e || this.effectsManager._mdf)
            ) {
              var t = this.effectsManager.effectElements,
                r = t[0].p.v,
                n = t[1].p.v,
                i = t[2].p.v === 1,
                a = t[3].p.v,
                s = i ? a : t[4].p.v,
                o = t[5].p.v,
                l = t[6].p.v,
                f = t[7].p.v;
              this.matrix.reset(),
                this.matrix.translate(-r[0], -r[1], r[2]),
                this.matrix.scale(0.01 * s, 0.01 * a, 1),
                this.matrix.rotate(-f * degToRads),
                this.matrix.skewFromAxis(-o * degToRads, (l + 90) * degToRads),
                this.matrix.translate(n[0], n[1], 0),
                (this._mdf = !0),
                this.opacity !== t[8].p.v &&
                  ((this.opacity = t[8].p.v), (this._opMdf = !0));
            }
          }),
          extendPrototype([TransformEffect], SVGTransformEffect),
          extendPrototype([TransformEffect], CVTransformEffect),
          registerRenderer("canvas", CanvasRenderer),
          registerRenderer("html", HybridRenderer),
          registerRenderer("svg", SVGRenderer),
          ShapeModifiers.registerModifier("tm", TrimModifier),
          ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
          ShapeModifiers.registerModifier("rp", RepeaterModifier),
          ShapeModifiers.registerModifier("rd", RoundCornersModifier),
          ShapeModifiers.registerModifier("zz", ZigZagModifier),
          ShapeModifiers.registerModifier("op", OffsetPathModifier),
          setExpressionsPlugin(Expressions),
          setExpressionInterfaces(getInterface),
          initialize$1(),
          initialize(),
          registerEffect$1(20, SVGTintFilter, !0),
          registerEffect$1(21, SVGFillFilter, !0),
          registerEffect$1(22, SVGStrokeEffect, !1),
          registerEffect$1(23, SVGTritoneFilter, !0),
          registerEffect$1(24, SVGProLevelsFilter, !0),
          registerEffect$1(25, SVGDropShadowEffect, !0),
          registerEffect$1(28, SVGMatte3Effect, !1),
          registerEffect$1(29, SVGGaussianBlurEffect, !0),
          registerEffect$1(35, SVGTransformEffect, !1),
          registerEffect(35, CVTransformEffect),
          lottie
        );
      });
  });
  var kb = E((Woe, Nb) => {
    var GW = zt(),
      Ei = Fb(),
      zW = Lb();
    GW.define(
      "lottie",
      (Nb.exports = function () {
        return {
          lottie: zW,
          createInstance: Ei.createInstance,
          cleanupElement: Ei.cleanupElement,
          init: Ei.init,
          destroy: Ei.destroy,
          ready: Ei.ready,
        };
      }),
    );
  });
  var Bb = E(() => {
    (function () {
      if (typeof window > "u") return;
      let e = window.navigator.userAgent.match(/Edge\/(\d{2})\./),
        t = e ? parseInt(e[1], 10) >= 16 : !1;
      if ("objectFit" in document.documentElement.style && !t) {
        window.objectFitPolyfill = function () {
          return !1;
        };
        return;
      }
      let n = function (o) {
          let l = window.getComputedStyle(o, null),
            f = l.getPropertyValue("position"),
            u = l.getPropertyValue("overflow"),
            c = l.getPropertyValue("display");
          (!f || f === "static") && (o.style.position = "relative"),
            u !== "hidden" && (o.style.overflow = "hidden"),
            (!c || c === "inline") && (o.style.display = "block"),
            o.clientHeight === 0 && (o.style.height = "100%"),
            o.className.indexOf("object-fit-polyfill") === -1 &&
              (o.className += " object-fit-polyfill");
        },
        i = function (o) {
          let l = window.getComputedStyle(o, null),
            f = {
              "max-width": "none",
              "max-height": "none",
              "min-width": "0px",
              "min-height": "0px",
              top: "auto",
              right: "auto",
              bottom: "auto",
              left: "auto",
              "margin-top": "0px",
              "margin-right": "0px",
              "margin-bottom": "0px",
              "margin-left": "0px",
            };
          for (let u in f)
            l.getPropertyValue(u) !== f[u] && (o.style[u] = f[u]);
        },
        a = function (o) {
          let l = o.parentNode;
          n(l),
            i(o),
            (o.style.position = "absolute"),
            (o.style.height = "100%"),
            (o.style.width = "auto"),
            o.clientWidth > l.clientWidth
              ? ((o.style.top = "0"),
                (o.style.marginTop = "0"),
                (o.style.left = "50%"),
                (o.style.marginLeft = o.clientWidth / -2 + "px"))
              : ((o.style.width = "100%"),
                (o.style.height = "auto"),
                (o.style.left = "0"),
                (o.style.marginLeft = "0"),
                (o.style.top = "50%"),
                (o.style.marginTop = o.clientHeight / -2 + "px"));
        },
        s = function (o) {
          if (typeof o > "u" || o instanceof Event)
            o = document.querySelectorAll("[data-object-fit]");
          else if (o && o.nodeName) o = [o];
          else if (typeof o == "object" && o.length && o[0].nodeName) o = o;
          else return !1;
          for (let l = 0; l < o.length; l++) {
            if (!o[l].nodeName) continue;
            let f = o[l].nodeName.toLowerCase();
            if (f === "img") {
              if (t) continue;
              o[l].complete
                ? a(o[l])
                : o[l].addEventListener("load", function () {
                    a(this);
                  });
            } else
              f === "video"
                ? o[l].readyState > 0
                  ? a(o[l])
                  : o[l].addEventListener("loadedmetadata", function () {
                      a(this);
                    })
                : a(o[l]);
          }
          return !0;
        };
      document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", s)
        : s(),
        window.addEventListener("resize", s),
        (window.objectFitPolyfill = s);
    })();
  });
  var Vb = E(() => {
    (function () {
      if (typeof window > "u") return;
      function e(n) {
        Webflow.env("design") ||
          ($("video").each(function () {
            n && $(this).prop("autoplay") ? this.play() : this.pause();
          }),
          $(".w-background-video--control").each(function () {
            n ? r($(this)) : t($(this));
          }));
      }
      function t(n) {
        n.find("> span").each(function (i) {
          $(this).prop("hidden", () => i === 0);
        });
      }
      function r(n) {
        n.find("> span").each(function (i) {
          $(this).prop("hidden", () => i === 1);
        });
      }
      $(document).ready(() => {
        let n = window.matchMedia("(prefers-reduced-motion: reduce)");
        n.addEventListener("change", (i) => {
          e(!i.matches);
        }),
          n.matches && e(!1),
          $("video:not([autoplay])").each(function () {
            $(this)
              .parent()
              .find(".w-background-video--control")
              .each(function () {
                t($(this));
              });
          }),
          $(document).on("click", ".w-background-video--control", function (i) {
            if (Webflow.env("design")) return;
            let a = $(i.currentTarget),
              s = $(`video#${a.attr("aria-controls")}`).get(0);
            if (s)
              if (s.paused) {
                let o = s.play();
                r(a),
                  o &&
                    typeof o.catch == "function" &&
                    o.catch(() => {
                      t(a);
                    });
              } else s.pause(), t(a);
          });
      });
    })();
  });
  var jb = E((Yoe, zb) => {
    var Gb = zt();
    Gb.define(
      "brand",
      (zb.exports = function (e) {
        var t = {},
          r = document,
          n = e("html"),
          i = e("body"),
          a = ".w-webflow-badge",
          s = window.location,
          o = /PhantomJS/i.test(navigator.userAgent),
          l =
            "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange",
          f;
        t.ready = function () {
          var d = n.attr("data-wf-status"),
            p = n.attr("data-wf-domain") || "";
          /\.webflow\.io$/i.test(p) && s.hostname !== p && (d = !0),
            d &&
              !o &&
              ((f = f || c()),
              v(),
              setTimeout(v, 500),
              e(r).off(l, u).on(l, u));
        };
        function u() {
          var d =
            r.fullScreen ||
            r.mozFullScreen ||
            r.webkitIsFullScreen ||
            r.msFullscreenElement ||
            !!r.webkitFullscreenElement;
          e(f).attr("style", d ? "display: none !important;" : "");
        }
        function c() {
          var d = e('<a class="w-webflow-badge"></a>').attr(
              "href",
              "https://webflow.com?utm_campaign=brandjs",
            ),
            p = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon-d2.89e12c322e.svg",
              )
              .attr("alt", "")
              .css({ marginRight: "4px", width: "26px" }),
            m = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-text-d2.c82cec3b78.svg",
              )
              .attr("alt", "Made in Webflow");
          return d.append(p, m), d[0];
        }
        function v() {
          var d = i.children(a),
            p = d.length && d.get(0) === f,
            m = Gb.env("editor");
          if (p) {
            m && d.remove();
            return;
          }
          d.length && d.remove(), m || i.append(f);
        }
        return t;
      }),
    );
  });
  var Wb = E((Qoe, Hb) => {
    var jW = zt();
    jW.define(
      "focus-visible",
      (Hb.exports = function () {
        function e(r) {
          var n = !0,
            i = !1,
            a = null,
            s = {
              text: !0,
              search: !0,
              url: !0,
              tel: !0,
              email: !0,
              password: !0,
              number: !0,
              date: !0,
              month: !0,
              week: !0,
              time: !0,
              datetime: !0,
              "datetime-local": !0,
            };
          function o(_) {
            return !!(
              _ &&
              _ !== document &&
              _.nodeName !== "HTML" &&
              _.nodeName !== "BODY" &&
              "classList" in _ &&
              "contains" in _.classList
            );
          }
          function l(_) {
            var b = _.type,
              I = _.tagName;
            return !!(
              (I === "INPUT" && s[b] && !_.readOnly) ||
              (I === "TEXTAREA" && !_.readOnly) ||
              _.isContentEditable
            );
          }
          function f(_) {
            _.getAttribute("data-wf-focus-visible") ||
              _.setAttribute("data-wf-focus-visible", "true");
          }
          function u(_) {
            _.getAttribute("data-wf-focus-visible") &&
              _.removeAttribute("data-wf-focus-visible");
          }
          function c(_) {
            _.metaKey ||
              _.altKey ||
              _.ctrlKey ||
              (o(r.activeElement) && f(r.activeElement), (n = !0));
          }
          function v() {
            n = !1;
          }
          function d(_) {
            o(_.target) && (n || l(_.target)) && f(_.target);
          }
          function p(_) {
            o(_.target) &&
              _.target.hasAttribute("data-wf-focus-visible") &&
              ((i = !0),
              window.clearTimeout(a),
              (a = window.setTimeout(function () {
                i = !1;
              }, 100)),
              u(_.target));
          }
          function m() {
            document.visibilityState === "hidden" && (i && (n = !0), h());
          }
          function h() {
            document.addEventListener("mousemove", y),
              document.addEventListener("mousedown", y),
              document.addEventListener("mouseup", y),
              document.addEventListener("pointermove", y),
              document.addEventListener("pointerdown", y),
              document.addEventListener("pointerup", y),
              document.addEventListener("touchmove", y),
              document.addEventListener("touchstart", y),
              document.addEventListener("touchend", y);
          }
          function g() {
            document.removeEventListener("mousemove", y),
              document.removeEventListener("mousedown", y),
              document.removeEventListener("mouseup", y),
              document.removeEventListener("pointermove", y),
              document.removeEventListener("pointerdown", y),
              document.removeEventListener("pointerup", y),
              document.removeEventListener("touchmove", y),
              document.removeEventListener("touchstart", y),
              document.removeEventListener("touchend", y);
          }
          function y(_) {
            (_.target.nodeName && _.target.nodeName.toLowerCase() === "html") ||
              ((n = !1), g());
          }
          document.addEventListener("keydown", c, !0),
            document.addEventListener("mousedown", v, !0),
            document.addEventListener("pointerdown", v, !0),
            document.addEventListener("touchstart", v, !0),
            document.addEventListener("visibilitychange", m, !0),
            h(),
            r.addEventListener("focus", d, !0),
            r.addEventListener("blur", p, !0);
        }
        function t() {
          if (typeof document < "u")
            try {
              document.querySelector(":focus-visible");
            } catch {
              e(document);
            }
        }
        return { ready: t };
      }),
    );
  });
  var $b = E((Zoe, Ub) => {
    var Xb = zt();
    Xb.define(
      "focus",
      (Ub.exports = function () {
        var e = [],
          t = !1;
        function r(s) {
          t &&
            (s.preventDefault(),
            s.stopPropagation(),
            s.stopImmediatePropagation(),
            e.unshift(s));
        }
        function n(s) {
          var o = s.target,
            l = o.tagName;
          return (
            (/^a$/i.test(l) && o.href != null) ||
            (/^(button|textarea)$/i.test(l) && o.disabled !== !0) ||
            (/^input$/i.test(l) &&
              /^(button|reset|submit|radio|checkbox)$/i.test(o.type) &&
              !o.disabled) ||
            (!/^(button|input|textarea|select|a)$/i.test(l) &&
              !Number.isNaN(Number.parseFloat(o.tabIndex))) ||
            /^audio$/i.test(l) ||
            (/^video$/i.test(l) && o.controls === !0)
          );
        }
        function i(s) {
          n(s) &&
            ((t = !0),
            setTimeout(() => {
              for (t = !1, s.target.focus(); e.length > 0; ) {
                var o = e.pop();
                o.target.dispatchEvent(new MouseEvent(o.type, o));
              }
            }, 0));
        }
        function a() {
          typeof document < "u" &&
            document.body.hasAttribute("data-wf-focus-within") &&
            Xb.env.safari &&
            (document.addEventListener("mousedown", i, !0),
            document.addEventListener("mouseup", r, !0),
            document.addEventListener("click", r, !0));
        }
        return { ready: a };
      }),
    );
  });
  var Qb = E((Joe, Yb) => {
    "use strict";
    var qu = window.jQuery,
      Lt = {},
      ts = [],
      Kb = ".w-ix",
      rs = {
        reset: function (e, t) {
          t.__wf_intro = null;
        },
        intro: function (e, t) {
          t.__wf_intro ||
            ((t.__wf_intro = !0), qu(t).triggerHandler(Lt.types.INTRO));
        },
        outro: function (e, t) {
          t.__wf_intro &&
            ((t.__wf_intro = null), qu(t).triggerHandler(Lt.types.OUTRO));
        },
      };
    Lt.triggers = {};
    Lt.types = { INTRO: "w-ix-intro" + Kb, OUTRO: "w-ix-outro" + Kb };
    Lt.init = function () {
      for (var e = ts.length, t = 0; t < e; t++) {
        var r = ts[t];
        r[0](0, r[1]);
      }
      (ts = []), qu.extend(Lt.triggers, rs);
    };
    Lt.async = function () {
      for (var e in rs) {
        var t = rs[e];
        rs.hasOwnProperty(e) &&
          (Lt.triggers[e] = function (r, n) {
            ts.push([t, n]);
          });
      }
    };
    Lt.async();
    Yb.exports = Lt;
  });
  var tS = E((ele, eS) => {
    "use strict";
    var Fu = Qb();
    function Zb(e, t) {
      var r = document.createEvent("CustomEvent");
      r.initCustomEvent(t, !0, !0, null), e.dispatchEvent(r);
    }
    var HW = window.jQuery,
      ns = {},
      Jb = ".w-ix",
      WW = {
        reset: function (e, t) {
          Fu.triggers.reset(e, t);
        },
        intro: function (e, t) {
          Fu.triggers.intro(e, t), Zb(t, "COMPONENT_ACTIVE");
        },
        outro: function (e, t) {
          Fu.triggers.outro(e, t), Zb(t, "COMPONENT_INACTIVE");
        },
      };
    ns.triggers = {};
    ns.types = { INTRO: "w-ix-intro" + Jb, OUTRO: "w-ix-outro" + Jb };
    HW.extend(ns.triggers, WW);
    eS.exports = ns;
  });
  var rS = E((tle, Zt) => {
    function Lu(e) {
      return (
        (Zt.exports = Lu =
          typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  typeof Symbol == "function" &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        (Zt.exports.__esModule = !0),
        (Zt.exports.default = Zt.exports),
        Lu(e)
      );
    }
    (Zt.exports = Lu),
      (Zt.exports.__esModule = !0),
      (Zt.exports.default = Zt.exports);
  });
  var Fr = E((rle, _i) => {
    var XW = rS().default;
    function nS(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        r = new WeakMap();
      return (nS = function (i) {
        return i ? r : t;
      })(e);
    }
    function UW(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (XW(e) !== "object" && typeof e != "function"))
        return { default: e };
      var r = nS(t);
      if (r && r.has(e)) return r.get(e);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var a in e)
        if (a !== "default" && Object.prototype.hasOwnProperty.call(e, a)) {
          var s = i ? Object.getOwnPropertyDescriptor(e, a) : null;
          s && (s.get || s.set)
            ? Object.defineProperty(n, a, s)
            : (n[a] = e[a]);
        }
      return (n.default = e), r && r.set(e, n), n;
    }
    (_i.exports = UW),
      (_i.exports.__esModule = !0),
      (_i.exports.default = _i.exports);
  });
  var aS = E((nle, iS) => {
    var $W = Z(),
      KW = Ee();
    iS.exports = function (e, t) {
      return KW($W[e].prototype[t]);
    };
  });
  var oS = E((ile, sS) => {
    Sl();
    var YW = aS();
    sS.exports = YW("Array", "includes");
  });
  var uS = E((ale, lS) => {
    var QW = oS();
    lS.exports = QW;
  });
  var cS = E((sle, hS) => {
    var ZW = uS();
    hS.exports = ZW;
  });
  var Nu = E((ole, fS) => {
    var JW = yo(),
      eX = JW(Object.getPrototypeOf, Object);
    fS.exports = eX;
  });
  var ku = E((lle, dS) => {
    var tX = nr(),
      rX = Nu(),
      nX = Ht(),
      iX = "[object Object]",
      aX = Function.prototype,
      sX = Object.prototype,
      pS = aX.toString,
      oX = sX.hasOwnProperty,
      lX = pS.call(Object);
    function uX(e) {
      if (!nX(e) || tX(e) != iX) return !1;
      var t = rX(e);
      if (t === null) return !0;
      var r = oX.call(t, "constructor") && t.constructor;
      return typeof r == "function" && r instanceof r && pS.call(r) == lX;
    }
    dS.exports = uX;
  });
  var mS = E((Bu) => {
    "use strict";
    Object.defineProperty(Bu, "__esModule", { value: !0 });
    Bu.default = hX;
    function hX(e) {
      var t,
        r = e.Symbol;
      return (
        typeof r == "function"
          ? r.observable
            ? (t = r.observable)
            : ((t = r("observable")), (r.observable = t))
          : (t = "@@observable"),
        t
      );
    }
  });
  var vS = E((Gu, Vu) => {
    "use strict";
    Object.defineProperty(Gu, "__esModule", { value: !0 });
    var cX = mS(),
      fX = pX(cX);
    function pX(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var dn;
    typeof self < "u"
      ? (dn = self)
      : typeof window < "u"
        ? (dn = window)
        : typeof global < "u"
          ? (dn = global)
          : typeof Vu < "u"
            ? (dn = Vu)
            : (dn = Function("return this")());
    var dX = (0, fX.default)(dn);
    Gu.default = dX;
  });
  var zu = E((bi) => {
    "use strict";
    bi.__esModule = !0;
    bi.ActionTypes = void 0;
    bi.default = _S;
    var mX = ku(),
      vX = ES(mX),
      gX = vS(),
      gS = ES(gX);
    function ES(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var yS = (bi.ActionTypes = { INIT: "@@redux/INIT" });
    function _S(e, t, r) {
      var n;
      if (
        (typeof t == "function" && typeof r > "u" && ((r = t), (t = void 0)),
        typeof r < "u")
      ) {
        if (typeof r != "function")
          throw new Error("Expected the enhancer to be a function.");
        return r(_S)(e, t);
      }
      if (typeof e != "function")
        throw new Error("Expected the reducer to be a function.");
      var i = e,
        a = t,
        s = [],
        o = s,
        l = !1;
      function f() {
        o === s && (o = s.slice());
      }
      function u() {
        return a;
      }
      function c(m) {
        if (typeof m != "function")
          throw new Error("Expected listener to be a function.");
        var h = !0;
        return (
          f(),
          o.push(m),
          function () {
            if (h) {
              (h = !1), f();
              var y = o.indexOf(m);
              o.splice(y, 1);
            }
          }
        );
      }
      function v(m) {
        if (!(0, vX.default)(m))
          throw new Error(
            "Actions must be plain objects. Use custom middleware for async actions.",
          );
        if (typeof m.type > "u")
          throw new Error(
            'Actions may not have an undefined "type" property. Have you misspelled a constant?',
          );
        if (l) throw new Error("Reducers may not dispatch actions.");
        try {
          (l = !0), (a = i(a, m));
        } finally {
          l = !1;
        }
        for (var h = (s = o), g = 0; g < h.length; g++) h[g]();
        return m;
      }
      function d(m) {
        if (typeof m != "function")
          throw new Error("Expected the nextReducer to be a function.");
        (i = m), v({ type: yS.INIT });
      }
      function p() {
        var m,
          h = c;
        return (
          (m = {
            subscribe: function (y) {
              if (typeof y != "object")
                throw new TypeError("Expected the observer to be an object.");
              function _() {
                y.next && y.next(u());
              }
              _();
              var b = h(_);
              return { unsubscribe: b };
            },
          }),
          (m[gS.default] = function () {
            return this;
          }),
          m
        );
      }
      return (
        v({ type: yS.INIT }),
        (n = { dispatch: v, subscribe: c, getState: u, replaceReducer: d }),
        (n[gS.default] = p),
        n
      );
    }
  });
  var Hu = E((ju) => {
    "use strict";
    ju.__esModule = !0;
    ju.default = yX;
    function yX(e) {
      typeof console < "u" &&
        typeof console.error == "function" &&
        console.error(e);
      try {
        throw new Error(e);
      } catch {}
    }
  });
  var IS = E((Wu) => {
    "use strict";
    Wu.__esModule = !0;
    Wu.default = IX;
    var bS = zu(),
      EX = ku(),
      fle = SS(EX),
      _X = Hu(),
      ple = SS(_X);
    function SS(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function bX(e, t) {
      var r = t && t.type,
        n = (r && '"' + r.toString() + '"') || "an action";
      return (
        "Given action " +
        n +
        ', reducer "' +
        e +
        '" returned undefined. To ignore an action, you must explicitly return the previous state.'
      );
    }
    function SX(e) {
      Object.keys(e).forEach(function (t) {
        var r = e[t],
          n = r(void 0, { type: bS.ActionTypes.INIT });
        if (typeof n > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.',
          );
        var i =
          "@@redux/PROBE_UNKNOWN_ACTION_" +
          Math.random().toString(36).substring(7).split("").join(".");
        if (typeof r(void 0, { type: i }) > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined when probed with a random type. ' +
              ("Don't try to handle " +
                bS.ActionTypes.INIT +
                ' or other actions in "redux/*" ') +
              "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined.",
          );
      });
    }
    function IX(e) {
      for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
        var i = t[n];
        typeof e[i] == "function" && (r[i] = e[i]);
      }
      var a = Object.keys(r);
      if (!1) var s;
      var o;
      try {
        SX(r);
      } catch (l) {
        o = l;
      }
      return function () {
        var f =
            arguments.length <= 0 || arguments[0] === void 0
              ? {}
              : arguments[0],
          u = arguments[1];
        if (o) throw o;
        if (!1) var c;
        for (var v = !1, d = {}, p = 0; p < a.length; p++) {
          var m = a[p],
            h = r[m],
            g = f[m],
            y = h(g, u);
          if (typeof y > "u") {
            var _ = bX(m, u);
            throw new Error(_);
          }
          (d[m] = y), (v = v || y !== g);
        }
        return v ? d : f;
      };
    }
  });
  var xS = E((Xu) => {
    "use strict";
    Xu.__esModule = !0;
    Xu.default = TX;
    function TS(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }
    function TX(e, t) {
      if (typeof e == "function") return TS(e, t);
      if (typeof e != "object" || e === null)
        throw new Error(
          "bindActionCreators expected an object or a function, instead received " +
            (e === null ? "null" : typeof e) +
            '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?',
        );
      for (var r = Object.keys(e), n = {}, i = 0; i < r.length; i++) {
        var a = r[i],
          s = e[a];
        typeof s == "function" && (n[a] = TS(s, t));
      }
      return n;
    }
  });
  var $u = E((Uu) => {
    "use strict";
    Uu.__esModule = !0;
    Uu.default = xX;
    function xX() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      if (t.length === 0)
        return function (a) {
          return a;
        };
      if (t.length === 1) return t[0];
      var n = t[t.length - 1],
        i = t.slice(0, -1);
      return function () {
        return i.reduceRight(
          function (a, s) {
            return s(a);
          },
          n.apply(void 0, arguments),
        );
      };
    }
  });
  var AS = E((Ku) => {
    "use strict";
    Ku.__esModule = !0;
    var AX =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    Ku.default = MX;
    var PX = $u(),
      CX = wX(PX);
    function wX(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function MX() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return function (n) {
        return function (i, a, s) {
          var o = n(i, a, s),
            l = o.dispatch,
            f = [],
            u = {
              getState: o.getState,
              dispatch: function (v) {
                return l(v);
              },
            };
          return (
            (f = t.map(function (c) {
              return c(u);
            })),
            (l = CX.default.apply(void 0, f)(o.dispatch)),
            AX({}, o, { dispatch: l })
          );
        };
      };
    }
  });
  var Yu = E((dt) => {
    "use strict";
    dt.__esModule = !0;
    dt.compose =
      dt.applyMiddleware =
      dt.bindActionCreators =
      dt.combineReducers =
      dt.createStore =
        void 0;
    var OX = zu(),
      RX = mn(OX),
      DX = IS(),
      qX = mn(DX),
      FX = xS(),
      LX = mn(FX),
      NX = AS(),
      kX = mn(NX),
      BX = $u(),
      VX = mn(BX),
      GX = Hu(),
      yle = mn(GX);
    function mn(e) {
      return e && e.__esModule ? e : { default: e };
    }
    dt.createStore = RX.default;
    dt.combineReducers = qX.default;
    dt.bindActionCreators = LX.default;
    dt.applyMiddleware = kX.default;
    dt.compose = VX.default;
  });
  var PS = E((Be) => {
    "use strict";
    Object.defineProperty(Be, "__esModule", { value: !0 });
    Be.QuickEffectIds =
      Be.QuickEffectDirectionConsts =
      Be.EventTypeConsts =
      Be.EventLimitAffectedElements =
      Be.EventContinuousMouseAxes =
      Be.EventBasedOn =
      Be.EventAppliesTo =
        void 0;
    var zX = {
      NAVBAR_OPEN: "NAVBAR_OPEN",
      NAVBAR_CLOSE: "NAVBAR_CLOSE",
      TAB_ACTIVE: "TAB_ACTIVE",
      TAB_INACTIVE: "TAB_INACTIVE",
      SLIDER_ACTIVE: "SLIDER_ACTIVE",
      SLIDER_INACTIVE: "SLIDER_INACTIVE",
      DROPDOWN_OPEN: "DROPDOWN_OPEN",
      DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
      MOUSE_CLICK: "MOUSE_CLICK",
      MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
      MOUSE_DOWN: "MOUSE_DOWN",
      MOUSE_UP: "MOUSE_UP",
      MOUSE_OVER: "MOUSE_OVER",
      MOUSE_OUT: "MOUSE_OUT",
      MOUSE_MOVE: "MOUSE_MOVE",
      MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
      SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
      SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
      SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
      ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
      ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
      PAGE_START: "PAGE_START",
      PAGE_FINISH: "PAGE_FINISH",
      PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
      PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
      PAGE_SCROLL: "PAGE_SCROLL",
    };
    Be.EventTypeConsts = zX;
    var jX = { ELEMENT: "ELEMENT", CLASS: "CLASS", PAGE: "PAGE" };
    Be.EventAppliesTo = jX;
    var HX = { ELEMENT: "ELEMENT", VIEWPORT: "VIEWPORT" };
    Be.EventBasedOn = HX;
    var WX = { X_AXIS: "X_AXIS", Y_AXIS: "Y_AXIS" };
    Be.EventContinuousMouseAxes = WX;
    var XX = {
      CHILDREN: "CHILDREN",
      SIBLINGS: "SIBLINGS",
      IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN",
    };
    Be.EventLimitAffectedElements = XX;
    var UX = {
      FADE_EFFECT: "FADE_EFFECT",
      SLIDE_EFFECT: "SLIDE_EFFECT",
      GROW_EFFECT: "GROW_EFFECT",
      SHRINK_EFFECT: "SHRINK_EFFECT",
      SPIN_EFFECT: "SPIN_EFFECT",
      FLY_EFFECT: "FLY_EFFECT",
      POP_EFFECT: "POP_EFFECT",
      FLIP_EFFECT: "FLIP_EFFECT",
      JIGGLE_EFFECT: "JIGGLE_EFFECT",
      PULSE_EFFECT: "PULSE_EFFECT",
      DROP_EFFECT: "DROP_EFFECT",
      BLINK_EFFECT: "BLINK_EFFECT",
      BOUNCE_EFFECT: "BOUNCE_EFFECT",
      FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
      FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
      RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
      JELLO_EFFECT: "JELLO_EFFECT",
      GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
      SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
      PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT",
    };
    Be.QuickEffectIds = UX;
    var $X = {
      LEFT: "LEFT",
      RIGHT: "RIGHT",
      BOTTOM: "BOTTOM",
      TOP: "TOP",
      BOTTOM_LEFT: "BOTTOM_LEFT",
      BOTTOM_RIGHT: "BOTTOM_RIGHT",
      TOP_RIGHT: "TOP_RIGHT",
      TOP_LEFT: "TOP_LEFT",
      CLOCKWISE: "CLOCKWISE",
      COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE",
    };
    Be.QuickEffectDirectionConsts = $X;
  });
  var Qu = E((vn) => {
    "use strict";
    Object.defineProperty(vn, "__esModule", { value: !0 });
    vn.ActionTypeConsts = vn.ActionAppliesTo = void 0;
    var KX = {
      TRANSFORM_MOVE: "TRANSFORM_MOVE",
      TRANSFORM_SCALE: "TRANSFORM_SCALE",
      TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
      TRANSFORM_SKEW: "TRANSFORM_SKEW",
      STYLE_OPACITY: "STYLE_OPACITY",
      STYLE_SIZE: "STYLE_SIZE",
      STYLE_FILTER: "STYLE_FILTER",
      STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
      STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
      STYLE_BORDER: "STYLE_BORDER",
      STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
      OBJECT_VALUE: "OBJECT_VALUE",
      PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
      PLUGIN_SPLINE: "PLUGIN_SPLINE",
      PLUGIN_VARIABLE: "PLUGIN_VARIABLE",
      GENERAL_DISPLAY: "GENERAL_DISPLAY",
      GENERAL_START_ACTION: "GENERAL_START_ACTION",
      GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
      GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
      GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
      GENERAL_LOOP: "GENERAL_LOOP",
      STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW",
    };
    vn.ActionTypeConsts = KX;
    var YX = {
      ELEMENT: "ELEMENT",
      ELEMENT_CLASS: "ELEMENT_CLASS",
      TRIGGER_ELEMENT: "TRIGGER_ELEMENT",
    };
    vn.ActionAppliesTo = YX;
  });
  var CS = E((is) => {
    "use strict";
    Object.defineProperty(is, "__esModule", { value: !0 });
    is.InteractionTypeConsts = void 0;
    var QX = {
      MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
      MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
      MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
      SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
      SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
      MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
      PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
      PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
      PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
      NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
      DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
      ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
      TAB_INTERACTION: "TAB_INTERACTION",
      SLIDER_INTERACTION: "SLIDER_INTERACTION",
    };
    is.InteractionTypeConsts = QX;
  });
  var wS = E((as) => {
    "use strict";
    Object.defineProperty(as, "__esModule", { value: !0 });
    as.ReducedMotionTypes = void 0;
    var ZX = Qu(),
      {
        TRANSFORM_MOVE: JX,
        TRANSFORM_SCALE: eU,
        TRANSFORM_ROTATE: tU,
        TRANSFORM_SKEW: rU,
        STYLE_SIZE: nU,
        STYLE_FILTER: iU,
        STYLE_FONT_VARIATION: aU,
      } = ZX.ActionTypeConsts,
      sU = {
        [JX]: !0,
        [eU]: !0,
        [tU]: !0,
        [rU]: !0,
        [nU]: !0,
        [iU]: !0,
        [aU]: !0,
      };
    as.ReducedMotionTypes = sU;
  });
  var MS = E((re) => {
    "use strict";
    Object.defineProperty(re, "__esModule", { value: !0 });
    re.IX2_VIEWPORT_WIDTH_CHANGED =
      re.IX2_TEST_FRAME_RENDERED =
      re.IX2_STOP_REQUESTED =
      re.IX2_SESSION_STOPPED =
      re.IX2_SESSION_STARTED =
      re.IX2_SESSION_INITIALIZED =
      re.IX2_RAW_DATA_IMPORTED =
      re.IX2_PREVIEW_REQUESTED =
      re.IX2_PLAYBACK_REQUESTED =
      re.IX2_PARAMETER_CHANGED =
      re.IX2_MEDIA_QUERIES_DEFINED =
      re.IX2_INSTANCE_STARTED =
      re.IX2_INSTANCE_REMOVED =
      re.IX2_INSTANCE_ADDED =
      re.IX2_EVENT_STATE_CHANGED =
      re.IX2_EVENT_LISTENER_ADDED =
      re.IX2_ELEMENT_STATE_CHANGED =
      re.IX2_CLEAR_REQUESTED =
      re.IX2_ANIMATION_FRAME_CHANGED =
      re.IX2_ACTION_LIST_PLAYBACK_CHANGED =
        void 0;
    var oU = "IX2_RAW_DATA_IMPORTED";
    re.IX2_RAW_DATA_IMPORTED = oU;
    var lU = "IX2_SESSION_INITIALIZED";
    re.IX2_SESSION_INITIALIZED = lU;
    var uU = "IX2_SESSION_STARTED";
    re.IX2_SESSION_STARTED = uU;
    var hU = "IX2_SESSION_STOPPED";
    re.IX2_SESSION_STOPPED = hU;
    var cU = "IX2_PREVIEW_REQUESTED";
    re.IX2_PREVIEW_REQUESTED = cU;
    var fU = "IX2_PLAYBACK_REQUESTED";
    re.IX2_PLAYBACK_REQUESTED = fU;
    var pU = "IX2_STOP_REQUESTED";
    re.IX2_STOP_REQUESTED = pU;
    var dU = "IX2_CLEAR_REQUESTED";
    re.IX2_CLEAR_REQUESTED = dU;
    var mU = "IX2_EVENT_LISTENER_ADDED";
    re.IX2_EVENT_LISTENER_ADDED = mU;
    var vU = "IX2_EVENT_STATE_CHANGED";
    re.IX2_EVENT_STATE_CHANGED = vU;
    var gU = "IX2_ANIMATION_FRAME_CHANGED";
    re.IX2_ANIMATION_FRAME_CHANGED = gU;
    var yU = "IX2_PARAMETER_CHANGED";
    re.IX2_PARAMETER_CHANGED = yU;
    var EU = "IX2_INSTANCE_ADDED";
    re.IX2_INSTANCE_ADDED = EU;
    var _U = "IX2_INSTANCE_STARTED";
    re.IX2_INSTANCE_STARTED = _U;
    var bU = "IX2_INSTANCE_REMOVED";
    re.IX2_INSTANCE_REMOVED = bU;
    var SU = "IX2_ELEMENT_STATE_CHANGED";
    re.IX2_ELEMENT_STATE_CHANGED = SU;
    var IU = "IX2_ACTION_LIST_PLAYBACK_CHANGED";
    re.IX2_ACTION_LIST_PLAYBACK_CHANGED = IU;
    var TU = "IX2_VIEWPORT_WIDTH_CHANGED";
    re.IX2_VIEWPORT_WIDTH_CHANGED = TU;
    var xU = "IX2_MEDIA_QUERIES_DEFINED";
    re.IX2_MEDIA_QUERIES_DEFINED = xU;
    var AU = "IX2_TEST_FRAME_RENDERED";
    re.IX2_TEST_FRAME_RENDERED = AU;
  });
  var OS = E((G) => {
    "use strict";
    Object.defineProperty(G, "__esModule", { value: !0 });
    G.W_MOD_JS =
      G.W_MOD_IX =
      G.WILL_CHANGE =
      G.WIDTH =
      G.WF_PAGE =
      G.TRANSLATE_Z =
      G.TRANSLATE_Y =
      G.TRANSLATE_X =
      G.TRANSLATE_3D =
      G.TRANSFORM =
      G.SKEW_Y =
      G.SKEW_X =
      G.SKEW =
      G.SIBLINGS =
      G.SCALE_Z =
      G.SCALE_Y =
      G.SCALE_X =
      G.SCALE_3D =
      G.ROTATE_Z =
      G.ROTATE_Y =
      G.ROTATE_X =
      G.RENDER_TRANSFORM =
      G.RENDER_STYLE =
      G.RENDER_PLUGIN =
      G.RENDER_GENERAL =
      G.PRESERVE_3D =
      G.PLAIN_OBJECT =
      G.PARENT =
      G.OPACITY =
      G.IX2_ID_DELIMITER =
      G.IMMEDIATE_CHILDREN =
      G.HTML_ELEMENT =
      G.HEIGHT =
      G.FONT_VARIATION_SETTINGS =
      G.FLEX =
      G.FILTER =
      G.DISPLAY =
      G.CONFIG_Z_VALUE =
      G.CONFIG_Z_UNIT =
      G.CONFIG_Y_VALUE =
      G.CONFIG_Y_UNIT =
      G.CONFIG_X_VALUE =
      G.CONFIG_X_UNIT =
      G.CONFIG_VALUE =
      G.CONFIG_UNIT =
      G.COMMA_DELIMITER =
      G.COLOR =
      G.COLON_DELIMITER =
      G.CHILDREN =
      G.BOUNDARY_SELECTOR =
      G.BORDER_COLOR =
      G.BAR_DELIMITER =
      G.BACKGROUND_COLOR =
      G.BACKGROUND =
      G.AUTO =
      G.ABSTRACT_NODE =
        void 0;
    var PU = "|";
    G.IX2_ID_DELIMITER = PU;
    var CU = "data-wf-page";
    G.WF_PAGE = CU;
    var wU = "w-mod-js";
    G.W_MOD_JS = wU;
    var MU = "w-mod-ix";
    G.W_MOD_IX = MU;
    var OU = ".w-dyn-item";
    G.BOUNDARY_SELECTOR = OU;
    var RU = "xValue";
    G.CONFIG_X_VALUE = RU;
    var DU = "yValue";
    G.CONFIG_Y_VALUE = DU;
    var qU = "zValue";
    G.CONFIG_Z_VALUE = qU;
    var FU = "value";
    G.CONFIG_VALUE = FU;
    var LU = "xUnit";
    G.CONFIG_X_UNIT = LU;
    var NU = "yUnit";
    G.CONFIG_Y_UNIT = NU;
    var kU = "zUnit";
    G.CONFIG_Z_UNIT = kU;
    var BU = "unit";
    G.CONFIG_UNIT = BU;
    var VU = "transform";
    G.TRANSFORM = VU;
    var GU = "translateX";
    G.TRANSLATE_X = GU;
    var zU = "translateY";
    G.TRANSLATE_Y = zU;
    var jU = "translateZ";
    G.TRANSLATE_Z = jU;
    var HU = "translate3d";
    G.TRANSLATE_3D = HU;
    var WU = "scaleX";
    G.SCALE_X = WU;
    var XU = "scaleY";
    G.SCALE_Y = XU;
    var UU = "scaleZ";
    G.SCALE_Z = UU;
    var $U = "scale3d";
    G.SCALE_3D = $U;
    var KU = "rotateX";
    G.ROTATE_X = KU;
    var YU = "rotateY";
    G.ROTATE_Y = YU;
    var QU = "rotateZ";
    G.ROTATE_Z = QU;
    var ZU = "skew";
    G.SKEW = ZU;
    var JU = "skewX";
    G.SKEW_X = JU;
    var e4 = "skewY";
    G.SKEW_Y = e4;
    var t4 = "opacity";
    G.OPACITY = t4;
    var r4 = "filter";
    G.FILTER = r4;
    var n4 = "font-variation-settings";
    G.FONT_VARIATION_SETTINGS = n4;
    var i4 = "width";
    G.WIDTH = i4;
    var a4 = "height";
    G.HEIGHT = a4;
    var s4 = "backgroundColor";
    G.BACKGROUND_COLOR = s4;
    var o4 = "background";
    G.BACKGROUND = o4;
    var l4 = "borderColor";
    G.BORDER_COLOR = l4;
    var u4 = "color";
    G.COLOR = u4;
    var h4 = "display";
    G.DISPLAY = h4;
    var c4 = "flex";
    G.FLEX = c4;
    var f4 = "willChange";
    G.WILL_CHANGE = f4;
    var p4 = "AUTO";
    G.AUTO = p4;
    var d4 = ",";
    G.COMMA_DELIMITER = d4;
    var m4 = ":";
    G.COLON_DELIMITER = m4;
    var v4 = "|";
    G.BAR_DELIMITER = v4;
    var g4 = "CHILDREN";
    G.CHILDREN = g4;
    var y4 = "IMMEDIATE_CHILDREN";
    G.IMMEDIATE_CHILDREN = y4;
    var E4 = "SIBLINGS";
    G.SIBLINGS = E4;
    var _4 = "PARENT";
    G.PARENT = _4;
    var b4 = "preserve-3d";
    G.PRESERVE_3D = b4;
    var S4 = "HTML_ELEMENT";
    G.HTML_ELEMENT = S4;
    var I4 = "PLAIN_OBJECT";
    G.PLAIN_OBJECT = I4;
    var T4 = "ABSTRACT_NODE";
    G.ABSTRACT_NODE = T4;
    var x4 = "RENDER_TRANSFORM";
    G.RENDER_TRANSFORM = x4;
    var A4 = "RENDER_GENERAL";
    G.RENDER_GENERAL = A4;
    var P4 = "RENDER_STYLE";
    G.RENDER_STYLE = P4;
    var C4 = "RENDER_PLUGIN";
    G.RENDER_PLUGIN = C4;
  });
  var nt = E((Re) => {
    "use strict";
    var RS = Fr().default;
    Object.defineProperty(Re, "__esModule", { value: !0 });
    var ss = { IX2EngineActionTypes: !0, IX2EngineConstants: !0 };
    Re.IX2EngineConstants = Re.IX2EngineActionTypes = void 0;
    var Zu = PS();
    Object.keys(Zu).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(ss, e) ||
        (e in Re && Re[e] === Zu[e]) ||
        Object.defineProperty(Re, e, {
          enumerable: !0,
          get: function () {
            return Zu[e];
          },
        });
    });
    var Ju = Qu();
    Object.keys(Ju).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(ss, e) ||
        (e in Re && Re[e] === Ju[e]) ||
        Object.defineProperty(Re, e, {
          enumerable: !0,
          get: function () {
            return Ju[e];
          },
        });
    });
    var eh = CS();
    Object.keys(eh).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(ss, e) ||
        (e in Re && Re[e] === eh[e]) ||
        Object.defineProperty(Re, e, {
          enumerable: !0,
          get: function () {
            return eh[e];
          },
        });
    });
    var th = wS();
    Object.keys(th).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(ss, e) ||
        (e in Re && Re[e] === th[e]) ||
        Object.defineProperty(Re, e, {
          enumerable: !0,
          get: function () {
            return th[e];
          },
        });
    });
    var w4 = RS(MS());
    Re.IX2EngineActionTypes = w4;
    var M4 = RS(OS());
    Re.IX2EngineConstants = M4;
  });
  var DS = E((os) => {
    "use strict";
    Object.defineProperty(os, "__esModule", { value: !0 });
    os.ixData = void 0;
    var O4 = nt(),
      { IX2_RAW_DATA_IMPORTED: R4 } = O4.IX2EngineActionTypes,
      D4 = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case R4:
            return t.payload.ixData || Object.freeze({});
          default:
            return e;
        }
      };
    os.ixData = D4;
  });
  var gn = E((Ae) => {
    "use strict";
    Object.defineProperty(Ae, "__esModule", { value: !0 });
    var q4 =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
    Ae.clone = us;
    Ae.addLast = LS;
    Ae.addFirst = NS;
    Ae.removeLast = kS;
    Ae.removeFirst = BS;
    Ae.insert = VS;
    Ae.removeAt = GS;
    Ae.replaceAt = zS;
    Ae.getIn = hs;
    Ae.set = cs;
    Ae.setIn = fs;
    Ae.update = HS;
    Ae.updateIn = WS;
    Ae.merge = XS;
    Ae.mergeDeep = US;
    Ae.mergeIn = $S;
    Ae.omit = KS;
    Ae.addDefaults = YS;
    var qS = "INVALID_ARGS";
    function FS(e) {
      throw new Error(e);
    }
    function rh(e) {
      var t = Object.keys(e);
      return Object.getOwnPropertySymbols
        ? t.concat(Object.getOwnPropertySymbols(e))
        : t;
    }
    var F4 = {}.hasOwnProperty;
    function us(e) {
      if (Array.isArray(e)) return e.slice();
      for (var t = rh(e), r = {}, n = 0; n < t.length; n++) {
        var i = t[n];
        r[i] = e[i];
      }
      return r;
    }
    function it(e, t, r) {
      var n = r;
      n == null && FS(qS);
      for (
        var i = !1, a = arguments.length, s = Array(a > 3 ? a - 3 : 0), o = 3;
        o < a;
        o++
      )
        s[o - 3] = arguments[o];
      for (var l = 0; l < s.length; l++) {
        var f = s[l];
        if (f != null) {
          var u = rh(f);
          if (u.length)
            for (var c = 0; c <= u.length; c++) {
              var v = u[c];
              if (!(e && n[v] !== void 0)) {
                var d = f[v];
                t && ls(n[v]) && ls(d) && (d = it(e, t, n[v], d)),
                  !(d === void 0 || d === n[v]) &&
                    (i || ((i = !0), (n = us(n))), (n[v] = d));
              }
            }
        }
      }
      return n;
    }
    function ls(e) {
      var t = typeof e > "u" ? "undefined" : q4(e);
      return e != null && (t === "object" || t === "function");
    }
    function LS(e, t) {
      return Array.isArray(t) ? e.concat(t) : e.concat([t]);
    }
    function NS(e, t) {
      return Array.isArray(t) ? t.concat(e) : [t].concat(e);
    }
    function kS(e) {
      return e.length ? e.slice(0, e.length - 1) : e;
    }
    function BS(e) {
      return e.length ? e.slice(1) : e;
    }
    function VS(e, t, r) {
      return e
        .slice(0, t)
        .concat(Array.isArray(r) ? r : [r])
        .concat(e.slice(t));
    }
    function GS(e, t) {
      return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    }
    function zS(e, t, r) {
      if (e[t] === r) return e;
      for (var n = e.length, i = Array(n), a = 0; a < n; a++) i[a] = e[a];
      return (i[t] = r), i;
    }
    function hs(e, t) {
      if ((!Array.isArray(t) && FS(qS), e != null)) {
        for (var r = e, n = 0; n < t.length; n++) {
          var i = t[n];
          if (((r = r?.[i]), r === void 0)) return r;
        }
        return r;
      }
    }
    function cs(e, t, r) {
      var n = typeof t == "number" ? [] : {},
        i = e ?? n;
      if (i[t] === r) return i;
      var a = us(i);
      return (a[t] = r), a;
    }
    function jS(e, t, r, n) {
      var i = void 0,
        a = t[n];
      if (n === t.length - 1) i = r;
      else {
        var s =
          ls(e) && ls(e[a]) ? e[a] : typeof t[n + 1] == "number" ? [] : {};
        i = jS(s, t, r, n + 1);
      }
      return cs(e, a, i);
    }
    function fs(e, t, r) {
      return t.length ? jS(e, t, r, 0) : r;
    }
    function HS(e, t, r) {
      var n = e?.[t],
        i = r(n);
      return cs(e, t, i);
    }
    function WS(e, t, r) {
      var n = hs(e, t),
        i = r(n);
      return fs(e, t, i);
    }
    function XS(e, t, r, n, i, a) {
      for (
        var s = arguments.length, o = Array(s > 6 ? s - 6 : 0), l = 6;
        l < s;
        l++
      )
        o[l - 6] = arguments[l];
      return o.length
        ? it.call.apply(it, [null, !1, !1, e, t, r, n, i, a].concat(o))
        : it(!1, !1, e, t, r, n, i, a);
    }
    function US(e, t, r, n, i, a) {
      for (
        var s = arguments.length, o = Array(s > 6 ? s - 6 : 0), l = 6;
        l < s;
        l++
      )
        o[l - 6] = arguments[l];
      return o.length
        ? it.call.apply(it, [null, !1, !0, e, t, r, n, i, a].concat(o))
        : it(!1, !0, e, t, r, n, i, a);
    }
    function $S(e, t, r, n, i, a, s) {
      var o = hs(e, t);
      o == null && (o = {});
      for (
        var l = void 0,
          f = arguments.length,
          u = Array(f > 7 ? f - 7 : 0),
          c = 7;
        c < f;
        c++
      )
        u[c - 7] = arguments[c];
      return (
        u.length
          ? (l = it.call.apply(it, [null, !1, !1, o, r, n, i, a, s].concat(u)))
          : (l = it(!1, !1, o, r, n, i, a, s)),
        fs(e, t, l)
      );
    }
    function KS(e, t) {
      for (var r = Array.isArray(t) ? t : [t], n = !1, i = 0; i < r.length; i++)
        if (F4.call(e, r[i])) {
          n = !0;
          break;
        }
      if (!n) return e;
      for (var a = {}, s = rh(e), o = 0; o < s.length; o++) {
        var l = s[o];
        r.indexOf(l) >= 0 || (a[l] = e[l]);
      }
      return a;
    }
    function YS(e, t, r, n, i, a) {
      for (
        var s = arguments.length, o = Array(s > 6 ? s - 6 : 0), l = 6;
        l < s;
        l++
      )
        o[l - 6] = arguments[l];
      return o.length
        ? it.call.apply(it, [null, !0, !1, e, t, r, n, i, a].concat(o))
        : it(!0, !1, e, t, r, n, i, a);
    }
    var L4 = {
      clone: us,
      addLast: LS,
      addFirst: NS,
      removeLast: kS,
      removeFirst: BS,
      insert: VS,
      removeAt: GS,
      replaceAt: zS,
      getIn: hs,
      set: cs,
      setIn: fs,
      update: HS,
      updateIn: WS,
      merge: XS,
      mergeDeep: US,
      mergeIn: $S,
      omit: KS,
      addDefaults: YS,
    };
    Ae.default = L4;
  });
  var ZS = E((ps) => {
    "use strict";
    var N4 = st().default;
    Object.defineProperty(ps, "__esModule", { value: !0 });
    ps.ixRequest = void 0;
    var k4 = N4(Sr()),
      B4 = nt(),
      V4 = gn(),
      {
        IX2_PREVIEW_REQUESTED: G4,
        IX2_PLAYBACK_REQUESTED: z4,
        IX2_STOP_REQUESTED: j4,
        IX2_CLEAR_REQUESTED: H4,
      } = B4.IX2EngineActionTypes,
      W4 = { preview: {}, playback: {}, stop: {}, clear: {} },
      QS = Object.create(null, {
        [G4]: { value: "preview" },
        [z4]: { value: "playback" },
        [j4]: { value: "stop" },
        [H4]: { value: "clear" },
      }),
      X4 = (e = W4, t) => {
        if (t.type in QS) {
          let r = [QS[t.type]];
          return (0, V4.setIn)(e, [r], (0, k4.default)({}, t.payload));
        }
        return e;
      };
    ps.ixRequest = X4;
  });
  var eI = E((ds) => {
    "use strict";
    Object.defineProperty(ds, "__esModule", { value: !0 });
    ds.ixSession = void 0;
    var U4 = nt(),
      Nt = gn(),
      {
        IX2_SESSION_INITIALIZED: $4,
        IX2_SESSION_STARTED: K4,
        IX2_TEST_FRAME_RENDERED: Y4,
        IX2_SESSION_STOPPED: Q4,
        IX2_EVENT_LISTENER_ADDED: Z4,
        IX2_EVENT_STATE_CHANGED: J4,
        IX2_ANIMATION_FRAME_CHANGED: e6,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: t6,
        IX2_VIEWPORT_WIDTH_CHANGED: r6,
        IX2_MEDIA_QUERIES_DEFINED: n6,
      } = U4.IX2EngineActionTypes,
      JS = {
        active: !1,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: !1,
        hasDefinedMediaQueries: !1,
        reducedMotion: !1,
      },
      i6 = 20,
      a6 = (e = JS, t) => {
        switch (t.type) {
          case $4: {
            let { hasBoundaryNodes: r, reducedMotion: n } = t.payload;
            return (0, Nt.merge)(e, { hasBoundaryNodes: r, reducedMotion: n });
          }
          case K4:
            return (0, Nt.set)(e, "active", !0);
          case Y4: {
            let {
              payload: { step: r = i6 },
            } = t;
            return (0, Nt.set)(e, "tick", e.tick + r);
          }
          case Q4:
            return JS;
          case e6: {
            let {
              payload: { now: r },
            } = t;
            return (0, Nt.set)(e, "tick", r);
          }
          case Z4: {
            let r = (0, Nt.addLast)(e.eventListeners, t.payload);
            return (0, Nt.set)(e, "eventListeners", r);
          }
          case J4: {
            let { stateKey: r, newState: n } = t.payload;
            return (0, Nt.setIn)(e, ["eventState", r], n);
          }
          case t6: {
            let { actionListId: r, isPlaying: n } = t.payload;
            return (0, Nt.setIn)(e, ["playbackState", r], n);
          }
          case r6: {
            let { width: r, mediaQueries: n } = t.payload,
              i = n.length,
              a = null;
            for (let s = 0; s < i; s++) {
              let { key: o, min: l, max: f } = n[s];
              if (r >= l && r <= f) {
                a = o;
                break;
              }
            }
            return (0, Nt.merge)(e, { viewportWidth: r, mediaQueryKey: a });
          }
          case n6:
            return (0, Nt.set)(e, "hasDefinedMediaQueries", !0);
          default:
            return e;
        }
      };
    ds.ixSession = a6;
  });
  var nh = E((Ole, tI) => {
    var s6 = ar(),
      o6 = Ir(),
      l6 = zn();
    function u6(e) {
      return function (t, r, n) {
        var i = Object(t);
        if (!o6(t)) {
          var a = s6(r, 3);
          (t = l6(t)),
            (r = function (o) {
              return a(i[o], o, i);
            });
        }
        var s = e(t, r, n);
        return s > -1 ? i[a ? t[s] : s] : void 0;
      };
    }
    tI.exports = u6;
  });
  var ih = E((Rle, rI) => {
    var h6 = nh(),
      c6 = Do(),
      f6 = h6(c6);
    rI.exports = f6;
  });
  var vs = E((Ze) => {
    "use strict";
    var p6 = st().default;
    Object.defineProperty(Ze, "__esModule", { value: !0 });
    Ze.withBrowser =
      Ze.TRANSFORM_STYLE_PREFIXED =
      Ze.TRANSFORM_PREFIXED =
      Ze.IS_BROWSER_ENV =
      Ze.FLEX_PREFIXED =
      Ze.ELEMENT_MATCHES =
        void 0;
    var d6 = p6(ih()),
      iI = typeof window < "u";
    Ze.IS_BROWSER_ENV = iI;
    var ms = (e, t) => (iI ? e() : t);
    Ze.withBrowser = ms;
    var m6 = ms(() =>
      (0, d6.default)(
        [
          "matches",
          "matchesSelector",
          "mozMatchesSelector",
          "msMatchesSelector",
          "oMatchesSelector",
          "webkitMatchesSelector",
        ],
        (e) => e in Element.prototype,
      ),
    );
    Ze.ELEMENT_MATCHES = m6;
    var v6 = ms(() => {
      let e = document.createElement("i"),
        t = ["flex", "-webkit-flex", "-ms-flexbox", "-moz-box", "-webkit-box"],
        r = "";
      try {
        let { length: n } = t;
        for (let i = 0; i < n; i++) {
          let a = t[i];
          if (((e.style.display = a), e.style.display === a)) return a;
        }
        return r;
      } catch {
        return r;
      }
    }, "flex");
    Ze.FLEX_PREFIXED = v6;
    var aI = ms(() => {
      let e = document.createElement("i");
      if (e.style.transform == null) {
        let t = ["Webkit", "Moz", "ms"],
          r = "Transform",
          { length: n } = t;
        for (let i = 0; i < n; i++) {
          let a = t[i] + r;
          if (e.style[a] !== void 0) return a;
        }
      }
      return "transform";
    }, "transform");
    Ze.TRANSFORM_PREFIXED = aI;
    var nI = aI.split("transform")[0],
      g6 = nI ? nI + "TransformStyle" : "transformStyle";
    Ze.TRANSFORM_STYLE_PREFIXED = g6;
  });
  var ah = E((qle, hI) => {
    var y6 = 4,
      E6 = 0.001,
      _6 = 1e-7,
      b6 = 10,
      Si = 11,
      gs = 1 / (Si - 1),
      S6 = typeof Float32Array == "function";
    function sI(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function oI(e, t) {
      return 3 * t - 6 * e;
    }
    function lI(e) {
      return 3 * e;
    }
    function ys(e, t, r) {
      return ((sI(t, r) * e + oI(t, r)) * e + lI(t)) * e;
    }
    function uI(e, t, r) {
      return 3 * sI(t, r) * e * e + 2 * oI(t, r) * e + lI(t);
    }
    function I6(e, t, r, n, i) {
      var a,
        s,
        o = 0;
      do
        (s = t + (r - t) / 2), (a = ys(s, n, i) - e), a > 0 ? (r = s) : (t = s);
      while (Math.abs(a) > _6 && ++o < b6);
      return s;
    }
    function T6(e, t, r, n) {
      for (var i = 0; i < y6; ++i) {
        var a = uI(t, r, n);
        if (a === 0) return t;
        var s = ys(t, r, n) - e;
        t -= s / a;
      }
      return t;
    }
    hI.exports = function (t, r, n, i) {
      if (!(0 <= t && t <= 1 && 0 <= n && n <= 1))
        throw new Error("bezier x values must be in [0, 1] range");
      var a = S6 ? new Float32Array(Si) : new Array(Si);
      if (t !== r || n !== i)
        for (var s = 0; s < Si; ++s) a[s] = ys(s * gs, t, n);
      function o(l) {
        for (var f = 0, u = 1, c = Si - 1; u !== c && a[u] <= l; ++u) f += gs;
        --u;
        var v = (l - a[u]) / (a[u + 1] - a[u]),
          d = f + v * gs,
          p = uI(d, t, n);
        return p >= E6 ? T6(l, d, t, n) : p === 0 ? d : I6(l, f, f + gs, t, n);
      }
      return function (f) {
        return t === r && n === i
          ? f
          : f === 0
            ? 0
            : f === 1
              ? 1
              : ys(o(f), r, i);
      };
    };
  });
  var sh = E((te) => {
    "use strict";
    var x6 = st().default;
    Object.defineProperty(te, "__esModule", { value: !0 });
    te.bounce = o$;
    te.bouncePast = l$;
    te.easeOut = te.easeInOut = te.easeIn = te.ease = void 0;
    te.inBack = Z6;
    te.inCirc = $6;
    te.inCubic = D6;
    te.inElastic = t$;
    te.inExpo = W6;
    te.inOutBack = e$;
    te.inOutCirc = Y6;
    te.inOutCubic = F6;
    te.inOutElastic = n$;
    te.inOutExpo = U6;
    te.inOutQuad = R6;
    te.inOutQuart = k6;
    te.inOutQuint = G6;
    te.inOutSine = H6;
    te.inQuad = M6;
    te.inQuart = L6;
    te.inQuint = B6;
    te.inSine = z6;
    te.outBack = J6;
    te.outBounce = Q6;
    te.outCirc = K6;
    te.outCubic = q6;
    te.outElastic = r$;
    te.outExpo = X6;
    te.outQuad = O6;
    te.outQuart = N6;
    te.outQuint = V6;
    te.outSine = j6;
    te.swingFrom = a$;
    te.swingFromTo = i$;
    te.swingTo = s$;
    var Es = x6(ah()),
      Jt = 1.70158,
      A6 = (0, Es.default)(0.25, 0.1, 0.25, 1);
    te.ease = A6;
    var P6 = (0, Es.default)(0.42, 0, 1, 1);
    te.easeIn = P6;
    var C6 = (0, Es.default)(0, 0, 0.58, 1);
    te.easeOut = C6;
    var w6 = (0, Es.default)(0.42, 0, 0.58, 1);
    te.easeInOut = w6;
    function M6(e) {
      return Math.pow(e, 2);
    }
    function O6(e) {
      return -(Math.pow(e - 1, 2) - 1);
    }
    function R6(e) {
      return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
    }
    function D6(e) {
      return Math.pow(e, 3);
    }
    function q6(e) {
      return Math.pow(e - 1, 3) + 1;
    }
    function F6(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 3)
        : 0.5 * (Math.pow(e - 2, 3) + 2);
    }
    function L6(e) {
      return Math.pow(e, 4);
    }
    function N6(e) {
      return -(Math.pow(e - 1, 4) - 1);
    }
    function k6(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 4)
        : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
    }
    function B6(e) {
      return Math.pow(e, 5);
    }
    function V6(e) {
      return Math.pow(e - 1, 5) + 1;
    }
    function G6(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 5)
        : 0.5 * (Math.pow(e - 2, 5) + 2);
    }
    function z6(e) {
      return -Math.cos(e * (Math.PI / 2)) + 1;
    }
    function j6(e) {
      return Math.sin(e * (Math.PI / 2));
    }
    function H6(e) {
      return -0.5 * (Math.cos(Math.PI * e) - 1);
    }
    function W6(e) {
      return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
    }
    function X6(e) {
      return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
    }
    function U6(e) {
      return e === 0
        ? 0
        : e === 1
          ? 1
          : (e /= 0.5) < 1
            ? 0.5 * Math.pow(2, 10 * (e - 1))
            : 0.5 * (-Math.pow(2, -10 * --e) + 2);
    }
    function $6(e) {
      return -(Math.sqrt(1 - e * e) - 1);
    }
    function K6(e) {
      return Math.sqrt(1 - Math.pow(e - 1, 2));
    }
    function Y6(e) {
      return (e /= 0.5) < 1
        ? -0.5 * (Math.sqrt(1 - e * e) - 1)
        : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    }
    function Q6(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
          ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
          : e < 2.5 / 2.75
            ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
            : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function Z6(e) {
      let t = Jt;
      return e * e * ((t + 1) * e - t);
    }
    function J6(e) {
      let t = Jt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function e$(e) {
      let t = Jt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function t$(e) {
      let t = Jt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
          ? 1
          : (r || (r = 0.3),
            n < 1
              ? ((n = 1), (t = r / 4))
              : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
            -(
              n *
              Math.pow(2, 10 * (e -= 1)) *
              Math.sin(((e - t) * (2 * Math.PI)) / r)
            ));
    }
    function r$(e) {
      let t = Jt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
          ? 1
          : (r || (r = 0.3),
            n < 1
              ? ((n = 1), (t = r / 4))
              : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
            n * Math.pow(2, -10 * e) * Math.sin(((e - t) * (2 * Math.PI)) / r) +
              1);
    }
    function n$(e) {
      let t = Jt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : (e /= 1 / 2) === 2
          ? 1
          : (r || (r = 0.3 * 1.5),
            n < 1
              ? ((n = 1), (t = r / 4))
              : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
            e < 1
              ? -0.5 *
                (n *
                  Math.pow(2, 10 * (e -= 1)) *
                  Math.sin(((e - t) * (2 * Math.PI)) / r))
              : n *
                  Math.pow(2, -10 * (e -= 1)) *
                  Math.sin(((e - t) * (2 * Math.PI)) / r) *
                  0.5 +
                1);
    }
    function i$(e) {
      let t = Jt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function a$(e) {
      let t = Jt;
      return e * e * ((t + 1) * e - t);
    }
    function s$(e) {
      let t = Jt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function o$(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
          ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
          : e < 2.5 / 2.75
            ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
            : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function l$(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
          ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
          : e < 2.5 / 2.75
            ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
            : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
    }
  });
  var lh = E((Ii) => {
    "use strict";
    var u$ = st().default,
      h$ = Fr().default;
    Object.defineProperty(Ii, "__esModule", { value: !0 });
    Ii.applyEasing = p$;
    Ii.createBezierEasing = f$;
    Ii.optimizeFloat = oh;
    var cI = h$(sh()),
      c$ = u$(ah());
    function oh(e, t = 5, r = 10) {
      let n = Math.pow(r, t),
        i = Number(Math.round(e * n) / n);
      return Math.abs(i) > 1e-4 ? i : 0;
    }
    function f$(e) {
      return (0, c$.default)(...e);
    }
    function p$(e, t, r) {
      return t === 0
        ? 0
        : t === 1
          ? 1
          : oh(r ? (t > 0 ? r(t) : t) : t > 0 && e && cI[e] ? cI[e](t) : t);
    }
  });
  var mI = E((yn) => {
    "use strict";
    Object.defineProperty(yn, "__esModule", { value: !0 });
    yn.createElementState = dI;
    yn.ixElements = void 0;
    yn.mergeActionState = uh;
    var _s = gn(),
      pI = nt(),
      {
        HTML_ELEMENT: Nle,
        PLAIN_OBJECT: d$,
        ABSTRACT_NODE: kle,
        CONFIG_X_VALUE: m$,
        CONFIG_Y_VALUE: v$,
        CONFIG_Z_VALUE: g$,
        CONFIG_VALUE: y$,
        CONFIG_X_UNIT: E$,
        CONFIG_Y_UNIT: _$,
        CONFIG_Z_UNIT: b$,
        CONFIG_UNIT: S$,
      } = pI.IX2EngineConstants,
      {
        IX2_SESSION_STOPPED: I$,
        IX2_INSTANCE_ADDED: T$,
        IX2_ELEMENT_STATE_CHANGED: x$,
      } = pI.IX2EngineActionTypes,
      fI = {},
      A$ = "refState",
      P$ = (e = fI, t = {}) => {
        switch (t.type) {
          case I$:
            return fI;
          case T$: {
            let {
                elementId: r,
                element: n,
                origin: i,
                actionItem: a,
                refType: s,
              } = t.payload,
              { actionTypeId: o } = a,
              l = e;
            return (
              (0, _s.getIn)(l, [r, n]) !== n && (l = dI(l, n, s, r, a)),
              uh(l, r, o, i, a)
            );
          }
          case x$: {
            let {
              elementId: r,
              actionTypeId: n,
              current: i,
              actionItem: a,
            } = t.payload;
            return uh(e, r, n, i, a);
          }
          default:
            return e;
        }
      };
    yn.ixElements = P$;
    function dI(e, t, r, n, i) {
      let a =
        r === d$ ? (0, _s.getIn)(i, ["config", "target", "objectId"]) : null;
      return (0, _s.mergeIn)(e, [n], { id: n, ref: t, refId: a, refType: r });
    }
    function uh(e, t, r, n, i) {
      let a = w$(i),
        s = [t, A$, r];
      return (0, _s.mergeIn)(e, s, n, a);
    }
    var C$ = [
      [m$, E$],
      [v$, _$],
      [g$, b$],
      [y$, S$],
    ];
    function w$(e) {
      let { config: t } = e;
      return C$.reduce((r, n) => {
        let i = n[0],
          a = n[1],
          s = t[i],
          o = t[a];
        return s != null && o != null && (r[a] = o), r;
      }, {});
    }
  });
  var vI = E((Ve) => {
    "use strict";
    Object.defineProperty(Ve, "__esModule", { value: !0 });
    Ve.renderPlugin =
      Ve.getPluginOrigin =
      Ve.getPluginDuration =
      Ve.getPluginDestination =
      Ve.getPluginConfig =
      Ve.createPluginInstance =
      Ve.clearPlugin =
        void 0;
    var M$ = (e) => e.value;
    Ve.getPluginConfig = M$;
    var O$ = (e, t) => {
      if (t.config.duration !== "auto") return null;
      let r = parseFloat(e.getAttribute("data-duration"));
      return r > 0
        ? r * 1e3
        : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
    };
    Ve.getPluginDuration = O$;
    var R$ = (e) => e || { value: 0 };
    Ve.getPluginOrigin = R$;
    var D$ = (e) => ({ value: e.value });
    Ve.getPluginDestination = D$;
    var q$ = (e) => {
      let t = window.Webflow.require("lottie").createInstance(e);
      return t.stop(), t.setSubframe(!0), t;
    };
    Ve.createPluginInstance = q$;
    var F$ = (e, t, r) => {
      if (!e) return;
      let n = t[r.actionTypeId].value / 100;
      e.goToFrame(e.frames * n);
    };
    Ve.renderPlugin = F$;
    var L$ = (e) => {
      window.Webflow.require("lottie").createInstance(e).stop();
    };
    Ve.clearPlugin = L$;
  });
  var yI = E((Ge) => {
    "use strict";
    Object.defineProperty(Ge, "__esModule", { value: !0 });
    Ge.renderPlugin =
      Ge.getPluginOrigin =
      Ge.getPluginDuration =
      Ge.getPluginDestination =
      Ge.getPluginConfig =
      Ge.createPluginInstance =
      Ge.clearPlugin =
        void 0;
    var N$ = (e) => document.querySelector(`[data-w-id="${e}"]`),
      k$ = () => window.Webflow.require("spline"),
      B$ = (e, t) => e.filter((r) => !t.includes(r)),
      V$ = (e, t) => e.value[t];
    Ge.getPluginConfig = V$;
    var G$ = () => null;
    Ge.getPluginDuration = G$;
    var gI = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
      }),
      z$ = (e, t) => {
        let r = t.config.value,
          n = Object.keys(r);
        if (e) {
          let a = Object.keys(e),
            s = B$(n, a);
          return s.length ? s.reduce((l, f) => ((l[f] = gI[f]), l), e) : e;
        }
        return n.reduce((a, s) => ((a[s] = gI[s]), a), {});
      };
    Ge.getPluginOrigin = z$;
    var j$ = (e) => e.value;
    Ge.getPluginDestination = j$;
    var H$ = (e, t) => {
      var r, n;
      let i =
        t == null ||
        (r = t.config) === null ||
        r === void 0 ||
        (n = r.target) === null ||
        n === void 0
          ? void 0
          : n.pluginElement;
      return i ? N$(i) : null;
    };
    Ge.createPluginInstance = H$;
    var W$ = (e, t, r) => {
      let n = k$().getInstance(e),
        i = r.config.target.objectId;
      if (!n || !i) return;
      let a = n.spline.findObjectById(i);
      if (!a) return;
      let { PLUGIN_SPLINE: s } = t;
      s.positionX != null && (a.position.x = s.positionX),
        s.positionY != null && (a.position.y = s.positionY),
        s.positionZ != null && (a.position.z = s.positionZ),
        s.rotationX != null && (a.rotation.x = s.rotationX),
        s.rotationY != null && (a.rotation.y = s.rotationY),
        s.rotationZ != null && (a.rotation.z = s.rotationZ),
        s.scaleX != null && (a.scale.x = s.scaleX),
        s.scaleY != null && (a.scale.y = s.scaleY),
        s.scaleZ != null && (a.scale.z = s.scaleZ);
    };
    Ge.renderPlugin = W$;
    var X$ = () => null;
    Ge.clearPlugin = X$;
  });
  var _I = E((Le) => {
    "use strict";
    Object.defineProperty(Le, "__esModule", { value: !0 });
    Le.getPluginOrigin =
      Le.getPluginDuration =
      Le.getPluginDestination =
      Le.getPluginConfig =
      Le.createPluginInstance =
      Le.clearPlugin =
        void 0;
    Le.normalizeColor = EI;
    Le.renderPlugin = void 0;
    function EI(e) {
      let t,
        r,
        n,
        i = 1,
        a = e.replace(/\s/g, "").toLowerCase();
      if (a.startsWith("#")) {
        let s = a.substring(1);
        s.length === 3
          ? ((t = parseInt(s[0] + s[0], 16)),
            (r = parseInt(s[1] + s[1], 16)),
            (n = parseInt(s[2] + s[2], 16)))
          : s.length === 6 &&
            ((t = parseInt(s.substring(0, 2), 16)),
            (r = parseInt(s.substring(2, 4), 16)),
            (n = parseInt(s.substring(4, 6), 16)));
      } else if (a.startsWith("rgba")) {
        let s = a.match(/rgba\(([^)]+)\)/)[1].split(",");
        (t = parseInt(s[0], 10)),
          (r = parseInt(s[1], 10)),
          (n = parseInt(s[2], 10)),
          (i = parseFloat(s[3]));
      } else if (a.startsWith("rgb")) {
        let s = a.match(/rgb\(([^)]+)\)/)[1].split(",");
        (t = parseInt(s[0], 10)),
          (r = parseInt(s[1], 10)),
          (n = parseInt(s[2], 10));
      } else if (a.startsWith("hsla")) {
        let s = a.match(/hsla\(([^)]+)\)/)[1].split(","),
          o = parseFloat(s[0]),
          l = parseFloat(s[1].replace("%", "")) / 100,
          f = parseFloat(s[2].replace("%", "")) / 100;
        i = parseFloat(s[3]);
        let u = (1 - Math.abs(2 * f - 1)) * l,
          c = u * (1 - Math.abs(((o / 60) % 2) - 1)),
          v = f - u / 2,
          d,
          p,
          m;
        o >= 0 && o < 60
          ? ((d = u), (p = c), (m = 0))
          : o >= 60 && o < 120
            ? ((d = c), (p = u), (m = 0))
            : o >= 120 && o < 180
              ? ((d = 0), (p = u), (m = c))
              : o >= 180 && o < 240
                ? ((d = 0), (p = c), (m = u))
                : o >= 240 && o < 300
                  ? ((d = c), (p = 0), (m = u))
                  : ((d = u), (p = 0), (m = c)),
          (t = Math.round((d + v) * 255)),
          (r = Math.round((p + v) * 255)),
          (n = Math.round((m + v) * 255));
      } else if (a.startsWith("hsl")) {
        let s = a.match(/hsl\(([^)]+)\)/)[1].split(","),
          o = parseFloat(s[0]),
          l = parseFloat(s[1].replace("%", "")) / 100,
          f = parseFloat(s[2].replace("%", "")) / 100,
          u = (1 - Math.abs(2 * f - 1)) * l,
          c = u * (1 - Math.abs(((o / 60) % 2) - 1)),
          v = f - u / 2,
          d,
          p,
          m;
        o >= 0 && o < 60
          ? ((d = u), (p = c), (m = 0))
          : o >= 60 && o < 120
            ? ((d = c), (p = u), (m = 0))
            : o >= 120 && o < 180
              ? ((d = 0), (p = u), (m = c))
              : o >= 180 && o < 240
                ? ((d = 0), (p = c), (m = u))
                : o >= 240 && o < 300
                  ? ((d = c), (p = 0), (m = u))
                  : ((d = u), (p = 0), (m = c)),
          (t = Math.round((d + v) * 255)),
          (r = Math.round((p + v) * 255)),
          (n = Math.round((m + v) * 255));
      }
      return (
        (Number.isNaN(t) || Number.isNaN(r) || Number.isNaN(n)) && `${e}`,
        { red: t, green: r, blue: n, alpha: i }
      );
    }
    var U$ = (e, t) => e.value[t];
    Le.getPluginConfig = U$;
    var $$ = () => null;
    Le.getPluginDuration = $$;
    var K$ = (e, t) => {
      if (e) return e;
      let r = t.config.value,
        n = t.config.target.objectId,
        i = getComputedStyle(document.documentElement).getPropertyValue(n);
      if (r.size != null) return { size: parseInt(i, 10) };
      if (r.red != null && r.green != null && r.blue != null) return EI(i);
    };
    Le.getPluginOrigin = K$;
    var Y$ = (e) => e.value;
    Le.getPluginDestination = Y$;
    var Q$ = () => null;
    Le.createPluginInstance = Q$;
    var Z$ = (e, t, r) => {
      let n = r.config.target.objectId,
        i = r.config.value.unit,
        { PLUGIN_VARIABLE: a } = t,
        { size: s, red: o, green: l, blue: f, alpha: u } = a,
        c;
      s != null && (c = s + i),
        o != null &&
          f != null &&
          l != null &&
          u != null &&
          (c = `rgba(${o}, ${l}, ${f}, ${u})`),
        c != null && document.documentElement.style.setProperty(n, c);
    };
    Le.renderPlugin = Z$;
    var J$ = (e, t) => {
      let r = t.config.target.objectId;
      document.documentElement.style.removeProperty(r);
    };
    Le.clearPlugin = J$;
  });
  var bI = E((bs) => {
    "use strict";
    var fh = Fr().default,
      eK = st().default;
    Object.defineProperty(bs, "__esModule", { value: !0 });
    bs.pluginMethodMap = void 0;
    var hh = eK(Sr()),
      ch = nt(),
      tK = fh(vI()),
      rK = fh(yI()),
      nK = fh(_I()),
      iK = new Map([
        [ch.ActionTypeConsts.PLUGIN_LOTTIE, (0, hh.default)({}, tK)],
        [ch.ActionTypeConsts.PLUGIN_SPLINE, (0, hh.default)({}, rK)],
        [ch.ActionTypeConsts.PLUGIN_VARIABLE, (0, hh.default)({}, nK)],
      ]);
    bs.pluginMethodMap = iK;
  });
  var ph = E((Ne) => {
    "use strict";
    Object.defineProperty(Ne, "__esModule", { value: !0 });
    Ne.getPluginOrigin =
      Ne.getPluginDuration =
      Ne.getPluginDestination =
      Ne.getPluginConfig =
      Ne.createPluginInstance =
      Ne.clearPlugin =
        void 0;
    Ne.isPluginType = sK;
    Ne.renderPlugin = void 0;
    var aK = vs(),
      SI = bI();
    function sK(e) {
      return SI.pluginMethodMap.has(e);
    }
    var Lr = (e) => (t) => {
        if (!aK.IS_BROWSER_ENV) return () => null;
        let r = SI.pluginMethodMap.get(t);
        if (!r) throw new Error(`IX2 no plugin configured for: ${t}`);
        let n = r[e];
        if (!n) throw new Error(`IX2 invalid plugin method: ${e}`);
        return n;
      },
      oK = Lr("getPluginConfig");
    Ne.getPluginConfig = oK;
    var lK = Lr("getPluginOrigin");
    Ne.getPluginOrigin = lK;
    var uK = Lr("getPluginDuration");
    Ne.getPluginDuration = uK;
    var hK = Lr("getPluginDestination");
    Ne.getPluginDestination = hK;
    var cK = Lr("createPluginInstance");
    Ne.createPluginInstance = cK;
    var fK = Lr("renderPlugin");
    Ne.renderPlugin = fK;
    var pK = Lr("clearPlugin");
    Ne.clearPlugin = pK;
  });
  var TI = E((Wle, II) => {
    function dK(e, t) {
      return e == null || e !== e ? t : e;
    }
    II.exports = dK;
  });
  var AI = E((Xle, xI) => {
    function mK(e, t, r, n) {
      var i = -1,
        a = e == null ? 0 : e.length;
      for (n && a && (r = e[++i]); ++i < a; ) r = t(r, e[i], i, e);
      return r;
    }
    xI.exports = mK;
  });
  var CI = E((Ule, PI) => {
    function vK(e) {
      return function (t, r, n) {
        for (var i = -1, a = Object(t), s = n(t), o = s.length; o--; ) {
          var l = s[e ? o : ++i];
          if (r(a[l], l, a) === !1) break;
        }
        return t;
      };
    }
    PI.exports = vK;
  });
  var MI = E(($le, wI) => {
    var gK = CI(),
      yK = gK();
    wI.exports = yK;
  });
  var dh = E((Kle, OI) => {
    var EK = MI(),
      _K = zn();
    function bK(e, t) {
      return e && EK(e, t, _K);
    }
    OI.exports = bK;
  });
  var DI = E((Yle, RI) => {
    var SK = Ir();
    function IK(e, t) {
      return function (r, n) {
        if (r == null) return r;
        if (!SK(r)) return e(r, n);
        for (
          var i = r.length, a = t ? i : -1, s = Object(r);
          (t ? a-- : ++a < i) && n(s[a], a, s) !== !1;

        );
        return r;
      };
    }
    RI.exports = IK;
  });
  var mh = E((Qle, qI) => {
    var TK = dh(),
      xK = DI(),
      AK = xK(TK);
    qI.exports = AK;
  });
  var LI = E((Zle, FI) => {
    function PK(e, t, r, n, i) {
      return (
        i(e, function (a, s, o) {
          r = n ? ((n = !1), a) : t(r, a, s, o);
        }),
        r
      );
    }
    FI.exports = PK;
  });
  var kI = E((Jle, NI) => {
    var CK = AI(),
      wK = mh(),
      MK = ar(),
      OK = LI(),
      RK = ke();
    function DK(e, t, r) {
      var n = RK(e) ? CK : OK,
        i = arguments.length < 3;
      return n(e, MK(t, 4), r, i, wK);
    }
    NI.exports = DK;
  });
  var VI = E((eue, BI) => {
    var qK = io(),
      FK = ar(),
      LK = Ro(),
      NK = Math.max,
      kK = Math.min;
    function BK(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var i = n - 1;
      return (
        r !== void 0 &&
          ((i = LK(r)), (i = r < 0 ? NK(n + i, 0) : kK(i, n - 1))),
        qK(e, FK(t, 3), i, !0)
      );
    }
    BI.exports = BK;
  });
  var zI = E((tue, GI) => {
    var VK = nh(),
      GK = VI(),
      zK = VK(GK);
    GI.exports = zK;
  });
  var HI = E((Ss) => {
    "use strict";
    Object.defineProperty(Ss, "__esModule", { value: !0 });
    Ss.default = void 0;
    var jK = Object.prototype.hasOwnProperty;
    function jI(e, t) {
      return e === t
        ? e !== 0 || t !== 0 || 1 / e === 1 / t
        : e !== e && t !== t;
    }
    function HK(e, t) {
      if (jI(e, t)) return !0;
      if (
        typeof e != "object" ||
        e === null ||
        typeof t != "object" ||
        t === null
      )
        return !1;
      let r = Object.keys(e),
        n = Object.keys(t);
      if (r.length !== n.length) return !1;
      for (let i = 0; i < r.length; i++)
        if (!jK.call(t, r[i]) || !jI(e[r[i]], t[r[i]])) return !1;
      return !0;
    }
    var WK = HK;
    Ss.default = WK;
  });
  var uT = E((me) => {
    "use strict";
    var As = st().default;
    Object.defineProperty(me, "__esModule", { value: !0 });
    me.cleanupHTMLElement = j8;
    me.clearAllStyles = z8;
    me.clearObjectCache = u8;
    me.getActionListProgress = W8;
    me.getAffectedElements = Sh;
    me.getComputedStyle = g8;
    me.getDestinationValues = T8;
    me.getElementId = p8;
    me.getInstanceId = c8;
    me.getInstanceOrigin = _8;
    me.getItemConfigByKey = void 0;
    me.getMaxDurationItemIndex = lT;
    me.getNamespacedParameterId = $8;
    me.getRenderType = aT;
    me.getStyleProp = x8;
    me.mediaQueriesEqual = Y8;
    me.observeStore = v8;
    me.reduceListToGroup = X8;
    me.reifyState = d8;
    me.renderHTMLElement = A8;
    Object.defineProperty(me, "shallowEqual", {
      enumerable: !0,
      get: function () {
        return ZI.default;
      },
    });
    me.shouldAllowMediaQuery = K8;
    me.shouldNamespaceEventParameter = U8;
    me.stringifyTarget = Q8;
    var gr = As(TI()),
      yh = As(kI()),
      gh = As(zI()),
      WI = gn(),
      Nr = nt(),
      ZI = As(HI()),
      XK = lh(),
      Vt = ph(),
      Je = vs(),
      {
        BACKGROUND: UK,
        TRANSFORM: $K,
        TRANSLATE_3D: KK,
        SCALE_3D: YK,
        ROTATE_X: QK,
        ROTATE_Y: ZK,
        ROTATE_Z: JK,
        SKEW: e8,
        PRESERVE_3D: t8,
        FLEX: r8,
        OPACITY: Ts,
        FILTER: Ti,
        FONT_VARIATION_SETTINGS: xi,
        WIDTH: kt,
        HEIGHT: Bt,
        BACKGROUND_COLOR: JI,
        BORDER_COLOR: n8,
        COLOR: i8,
        CHILDREN: XI,
        IMMEDIATE_CHILDREN: a8,
        SIBLINGS: UI,
        PARENT: s8,
        DISPLAY: xs,
        WILL_CHANGE: En,
        AUTO: yr,
        COMMA_DELIMITER: Ai,
        COLON_DELIMITER: o8,
        BAR_DELIMITER: vh,
        RENDER_TRANSFORM: eT,
        RENDER_GENERAL: Eh,
        RENDER_STYLE: _h,
        RENDER_PLUGIN: tT,
      } = Nr.IX2EngineConstants,
      {
        TRANSFORM_MOVE: _n,
        TRANSFORM_SCALE: bn,
        TRANSFORM_ROTATE: Sn,
        TRANSFORM_SKEW: Pi,
        STYLE_OPACITY: rT,
        STYLE_FILTER: Ci,
        STYLE_FONT_VARIATION: wi,
        STYLE_SIZE: In,
        STYLE_BACKGROUND_COLOR: Tn,
        STYLE_BORDER: xn,
        STYLE_TEXT_COLOR: An,
        GENERAL_DISPLAY: Ps,
        OBJECT_VALUE: l8,
      } = Nr.ActionTypeConsts,
      nT = (e) => e.trim(),
      bh = Object.freeze({ [Tn]: JI, [xn]: n8, [An]: i8 }),
      iT = Object.freeze({
        [Je.TRANSFORM_PREFIXED]: $K,
        [JI]: UK,
        [Ts]: Ts,
        [Ti]: Ti,
        [kt]: kt,
        [Bt]: Bt,
        [xi]: xi,
      }),
      Is = new Map();
    function u8() {
      Is.clear();
    }
    var h8 = 1;
    function c8() {
      return "i" + h8++;
    }
    var f8 = 1;
    function p8(e, t) {
      for (let r in e) {
        let n = e[r];
        if (n && n.ref === t) return n.id;
      }
      return "e" + f8++;
    }
    function d8({ events: e, actionLists: t, site: r } = {}) {
      let n = (0, yh.default)(
          e,
          (s, o) => {
            let { eventTypeId: l } = o;
            return s[l] || (s[l] = {}), (s[l][o.id] = o), s;
          },
          {},
        ),
        i = r && r.mediaQueries,
        a = [];
      return (
        i
          ? (a = i.map((s) => s.key))
          : ((i = []), console.warn("IX2 missing mediaQueries in site data")),
        {
          ixData: {
            events: e,
            actionLists: t,
            eventTypeMap: n,
            mediaQueries: i,
            mediaQueryKeys: a,
          },
        }
      );
    }
    var m8 = (e, t) => e === t;
    function v8({ store: e, select: t, onChange: r, comparator: n = m8 }) {
      let { getState: i, subscribe: a } = e,
        s = a(l),
        o = t(i());
      function l() {
        let f = t(i());
        if (f == null) {
          s();
          return;
        }
        n(f, o) || ((o = f), r(o, e));
      }
      return s;
    }
    function $I(e) {
      let t = typeof e;
      if (t === "string") return { id: e };
      if (e != null && t === "object") {
        let {
          id: r,
          objectId: n,
          selector: i,
          selectorGuids: a,
          appliesTo: s,
          useEventTarget: o,
        } = e;
        return {
          id: r,
          objectId: n,
          selector: i,
          selectorGuids: a,
          appliesTo: s,
          useEventTarget: o,
        };
      }
      return {};
    }
    function Sh({
      config: e,
      event: t,
      eventTarget: r,
      elementRoot: n,
      elementApi: i,
    }) {
      var a, s, o;
      if (!i) throw new Error("IX2 missing elementApi");
      let { targets: l } = e;
      if (Array.isArray(l) && l.length > 0)
        return l.reduce(
          (q, B) =>
            q.concat(
              Sh({
                config: { target: B },
                event: t,
                eventTarget: r,
                elementRoot: n,
                elementApi: i,
              }),
            ),
          [],
        );
      let {
          getValidDocument: f,
          getQuerySelector: u,
          queryDocument: c,
          getChildElements: v,
          getSiblingElements: d,
          matchSelector: p,
          elementContains: m,
          isSiblingNode: h,
        } = i,
        { target: g } = e;
      if (!g) return [];
      let {
        id: y,
        objectId: _,
        selector: b,
        selectorGuids: I,
        appliesTo: P,
        useEventTarget: S,
      } = $I(g);
      if (_) return [Is.has(_) ? Is.get(_) : Is.set(_, {}).get(_)];
      if (P === Nr.EventAppliesTo.PAGE) {
        let q = f(y);
        return q ? [q] : [];
      }
      let R =
          ((a =
            t == null ||
            (s = t.action) === null ||
            s === void 0 ||
            (o = s.config) === null ||
            o === void 0
              ? void 0
              : o.affectedElements) !== null && a !== void 0
            ? a
            : {})[y || b] || {},
        w = !!(R.id || R.selector),
        C,
        D,
        M,
        O = t && u($I(t.target));
      if (
        (w
          ? ((C = R.limitAffectedElements), (D = O), (M = u(R)))
          : (D = M = u({ id: y, selector: b, selectorGuids: I })),
        t && S)
      ) {
        let q = r && (M || S === !0) ? [r] : c(O);
        if (M) {
          if (S === s8) return c(M).filter((B) => q.some((H) => m(B, H)));
          if (S === XI) return c(M).filter((B) => q.some((H) => m(H, B)));
          if (S === UI) return c(M).filter((B) => q.some((H) => h(H, B)));
        }
        return q;
      }
      return D == null || M == null
        ? []
        : Je.IS_BROWSER_ENV && n
          ? c(M).filter((q) => n.contains(q))
          : C === XI
            ? c(D, M)
            : C === a8
              ? v(c(D)).filter(p(M))
              : C === UI
                ? d(c(D)).filter(p(M))
                : c(M);
    }
    function g8({ element: e, actionItem: t }) {
      if (!Je.IS_BROWSER_ENV) return {};
      let { actionTypeId: r } = t;
      switch (r) {
        case In:
        case Tn:
        case xn:
        case An:
        case Ps:
          return window.getComputedStyle(e);
        default:
          return {};
      }
    }
    var KI = /px/,
      y8 = (e, t) =>
        t.reduce(
          (r, n) => (r[n.type] == null && (r[n.type] = P8[n.type]), r),
          e || {},
        ),
      E8 = (e, t) =>
        t.reduce(
          (r, n) => (
            r[n.type] == null &&
              (r[n.type] = C8[n.type] || n.defaultValue || 0),
            r
          ),
          e || {},
        );
    function _8(e, t = {}, r = {}, n, i) {
      let { getStyle: a } = i,
        { actionTypeId: s } = n;
      if ((0, Vt.isPluginType)(s)) return (0, Vt.getPluginOrigin)(s)(t[s], n);
      switch (n.actionTypeId) {
        case _n:
        case bn:
        case Sn:
        case Pi:
          return t[n.actionTypeId] || Ih[n.actionTypeId];
        case Ci:
          return y8(t[n.actionTypeId], n.config.filters);
        case wi:
          return E8(t[n.actionTypeId], n.config.fontVariations);
        case rT:
          return { value: (0, gr.default)(parseFloat(a(e, Ts)), 1) };
        case In: {
          let o = a(e, kt),
            l = a(e, Bt),
            f,
            u;
          return (
            n.config.widthUnit === yr
              ? (f = KI.test(o) ? parseFloat(o) : parseFloat(r.width))
              : (f = (0, gr.default)(parseFloat(o), parseFloat(r.width))),
            n.config.heightUnit === yr
              ? (u = KI.test(l) ? parseFloat(l) : parseFloat(r.height))
              : (u = (0, gr.default)(parseFloat(l), parseFloat(r.height))),
            { widthValue: f, heightValue: u }
          );
        }
        case Tn:
        case xn:
        case An:
          return B8({
            element: e,
            actionTypeId: n.actionTypeId,
            computedStyle: r,
            getStyle: a,
          });
        case Ps:
          return { value: (0, gr.default)(a(e, xs), r.display) };
        case l8:
          return t[n.actionTypeId] || { value: 0 };
        default:
          return;
      }
    }
    var b8 = (e, t) => (t && (e[t.type] = t.value || 0), e),
      S8 = (e, t) => (t && (e[t.type] = t.value || 0), e),
      I8 = (e, t, r) => {
        if ((0, Vt.isPluginType)(e)) return (0, Vt.getPluginConfig)(e)(r, t);
        switch (e) {
          case Ci: {
            let n = (0, gh.default)(r.filters, ({ type: i }) => i === t);
            return n ? n.value : 0;
          }
          case wi: {
            let n = (0, gh.default)(r.fontVariations, ({ type: i }) => i === t);
            return n ? n.value : 0;
          }
          default:
            return r[t];
        }
      };
    me.getItemConfigByKey = I8;
    function T8({ element: e, actionItem: t, elementApi: r }) {
      if ((0, Vt.isPluginType)(t.actionTypeId))
        return (0, Vt.getPluginDestination)(t.actionTypeId)(t.config);
      switch (t.actionTypeId) {
        case _n:
        case bn:
        case Sn:
        case Pi: {
          let { xValue: n, yValue: i, zValue: a } = t.config;
          return { xValue: n, yValue: i, zValue: a };
        }
        case In: {
          let { getStyle: n, setStyle: i, getProperty: a } = r,
            { widthUnit: s, heightUnit: o } = t.config,
            { widthValue: l, heightValue: f } = t.config;
          if (!Je.IS_BROWSER_ENV) return { widthValue: l, heightValue: f };
          if (s === yr) {
            let u = n(e, kt);
            i(e, kt, ""), (l = a(e, "offsetWidth")), i(e, kt, u);
          }
          if (o === yr) {
            let u = n(e, Bt);
            i(e, Bt, ""), (f = a(e, "offsetHeight")), i(e, Bt, u);
          }
          return { widthValue: l, heightValue: f };
        }
        case Tn:
        case xn:
        case An: {
          let { rValue: n, gValue: i, bValue: a, aValue: s } = t.config;
          return { rValue: n, gValue: i, bValue: a, aValue: s };
        }
        case Ci:
          return t.config.filters.reduce(b8, {});
        case wi:
          return t.config.fontVariations.reduce(S8, {});
        default: {
          let { value: n } = t.config;
          return { value: n };
        }
      }
    }
    function aT(e) {
      if (/^TRANSFORM_/.test(e)) return eT;
      if (/^STYLE_/.test(e)) return _h;
      if (/^GENERAL_/.test(e)) return Eh;
      if (/^PLUGIN_/.test(e)) return tT;
    }
    function x8(e, t) {
      return e === _h ? t.replace("STYLE_", "").toLowerCase() : null;
    }
    function A8(e, t, r, n, i, a, s, o, l) {
      switch (o) {
        case eT:
          return O8(e, t, r, i, s);
        case _h:
          return V8(e, t, r, i, a, s);
        case Eh:
          return G8(e, i, s);
        case tT: {
          let { actionTypeId: f } = i;
          if ((0, Vt.isPluginType)(f)) return (0, Vt.renderPlugin)(f)(l, t, i);
        }
      }
    }
    var Ih = {
        [_n]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [bn]: Object.freeze({ xValue: 1, yValue: 1, zValue: 1 }),
        [Sn]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [Pi]: Object.freeze({ xValue: 0, yValue: 0 }),
      },
      P8 = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100,
      }),
      C8 = Object.freeze({ wght: 0, opsz: 0, wdth: 0, slnt: 0 }),
      w8 = (e, t) => {
        let r = (0, gh.default)(t.filters, ({ type: n }) => n === e);
        if (r && r.unit) return r.unit;
        switch (e) {
          case "blur":
            return "px";
          case "hue-rotate":
            return "deg";
          default:
            return "%";
        }
      },
      M8 = Object.keys(Ih);
    function O8(e, t, r, n, i) {
      let a = M8.map((o) => {
          let l = Ih[o],
            {
              xValue: f = l.xValue,
              yValue: u = l.yValue,
              zValue: c = l.zValue,
              xUnit: v = "",
              yUnit: d = "",
              zUnit: p = "",
            } = t[o] || {};
          switch (o) {
            case _n:
              return `${KK}(${f}${v}, ${u}${d}, ${c}${p})`;
            case bn:
              return `${YK}(${f}${v}, ${u}${d}, ${c}${p})`;
            case Sn:
              return `${QK}(${f}${v}) ${ZK}(${u}${d}) ${JK}(${c}${p})`;
            case Pi:
              return `${e8}(${f}${v}, ${u}${d})`;
            default:
              return "";
          }
        }).join(" "),
        { setStyle: s } = i;
      kr(e, Je.TRANSFORM_PREFIXED, i),
        s(e, Je.TRANSFORM_PREFIXED, a),
        q8(n, r) && s(e, Je.TRANSFORM_STYLE_PREFIXED, t8);
    }
    function R8(e, t, r, n) {
      let i = (0, yh.default)(t, (s, o, l) => `${s} ${l}(${o}${w8(l, r)})`, ""),
        { setStyle: a } = n;
      kr(e, Ti, n), a(e, Ti, i);
    }
    function D8(e, t, r, n) {
      let i = (0, yh.default)(
          t,
          (s, o, l) => (s.push(`"${l}" ${o}`), s),
          [],
        ).join(", "),
        { setStyle: a } = n;
      kr(e, xi, n), a(e, xi, i);
    }
    function q8({ actionTypeId: e }, { xValue: t, yValue: r, zValue: n }) {
      return (
        (e === _n && n !== void 0) ||
        (e === bn && n !== void 0) ||
        (e === Sn && (t !== void 0 || r !== void 0))
      );
    }
    var F8 = "\\(([^)]+)\\)",
      L8 = /^rgb/,
      N8 = RegExp(`rgba?${F8}`);
    function k8(e, t) {
      let r = e.exec(t);
      return r ? r[1] : "";
    }
    function B8({
      element: e,
      actionTypeId: t,
      computedStyle: r,
      getStyle: n,
    }) {
      let i = bh[t],
        a = n(e, i),
        s = L8.test(a) ? a : r[i],
        o = k8(N8, s).split(Ai);
      return {
        rValue: (0, gr.default)(parseInt(o[0], 10), 255),
        gValue: (0, gr.default)(parseInt(o[1], 10), 255),
        bValue: (0, gr.default)(parseInt(o[2], 10), 255),
        aValue: (0, gr.default)(parseFloat(o[3]), 1),
      };
    }
    function V8(e, t, r, n, i, a) {
      let { setStyle: s } = a;
      switch (n.actionTypeId) {
        case In: {
          let { widthUnit: o = "", heightUnit: l = "" } = n.config,
            { widthValue: f, heightValue: u } = r;
          f !== void 0 &&
            (o === yr && (o = "px"), kr(e, kt, a), s(e, kt, f + o)),
            u !== void 0 &&
              (l === yr && (l = "px"), kr(e, Bt, a), s(e, Bt, u + l));
          break;
        }
        case Ci: {
          R8(e, r, n.config, a);
          break;
        }
        case wi: {
          D8(e, r, n.config, a);
          break;
        }
        case Tn:
        case xn:
        case An: {
          let o = bh[n.actionTypeId],
            l = Math.round(r.rValue),
            f = Math.round(r.gValue),
            u = Math.round(r.bValue),
            c = r.aValue;
          kr(e, o, a),
            s(
              e,
              o,
              c >= 1 ? `rgb(${l},${f},${u})` : `rgba(${l},${f},${u},${c})`,
            );
          break;
        }
        default: {
          let { unit: o = "" } = n.config;
          kr(e, i, a), s(e, i, r.value + o);
          break;
        }
      }
    }
    function G8(e, t, r) {
      let { setStyle: n } = r;
      switch (t.actionTypeId) {
        case Ps: {
          let { value: i } = t.config;
          i === r8 && Je.IS_BROWSER_ENV
            ? n(e, xs, Je.FLEX_PREFIXED)
            : n(e, xs, i);
          return;
        }
      }
    }
    function kr(e, t, r) {
      if (!Je.IS_BROWSER_ENV) return;
      let n = iT[t];
      if (!n) return;
      let { getStyle: i, setStyle: a } = r,
        s = i(e, En);
      if (!s) {
        a(e, En, n);
        return;
      }
      let o = s.split(Ai).map(nT);
      o.indexOf(n) === -1 && a(e, En, o.concat(n).join(Ai));
    }
    function sT(e, t, r) {
      if (!Je.IS_BROWSER_ENV) return;
      let n = iT[t];
      if (!n) return;
      let { getStyle: i, setStyle: a } = r,
        s = i(e, En);
      !s ||
        s.indexOf(n) === -1 ||
        a(
          e,
          En,
          s
            .split(Ai)
            .map(nT)
            .filter((o) => o !== n)
            .join(Ai),
        );
    }
    function z8({ store: e, elementApi: t }) {
      let { ixData: r } = e.getState(),
        { events: n = {}, actionLists: i = {} } = r;
      Object.keys(n).forEach((a) => {
        let s = n[a],
          { config: o } = s.action,
          { actionListId: l } = o,
          f = i[l];
        f && YI({ actionList: f, event: s, elementApi: t });
      }),
        Object.keys(i).forEach((a) => {
          YI({ actionList: i[a], elementApi: t });
        });
    }
    function YI({ actionList: e = {}, event: t, elementApi: r }) {
      let { actionItemGroups: n, continuousParameterGroups: i } = e;
      n &&
        n.forEach((a) => {
          QI({ actionGroup: a, event: t, elementApi: r });
        }),
        i &&
          i.forEach((a) => {
            let { continuousActionGroups: s } = a;
            s.forEach((o) => {
              QI({ actionGroup: o, event: t, elementApi: r });
            });
          });
    }
    function QI({ actionGroup: e, event: t, elementApi: r }) {
      let { actionItems: n } = e;
      n.forEach((i) => {
        let { actionTypeId: a, config: s } = i,
          o;
        (0, Vt.isPluginType)(a)
          ? (o = (l) => (0, Vt.clearPlugin)(a)(l, i))
          : (o = oT({ effect: H8, actionTypeId: a, elementApi: r })),
          Sh({ config: s, event: t, elementApi: r }).forEach(o);
      });
    }
    function j8(e, t, r) {
      let { setStyle: n, getStyle: i } = r,
        { actionTypeId: a } = t;
      if (a === In) {
        let { config: s } = t;
        s.widthUnit === yr && n(e, kt, ""), s.heightUnit === yr && n(e, Bt, "");
      }
      i(e, En) && oT({ effect: sT, actionTypeId: a, elementApi: r })(e);
    }
    var oT =
      ({ effect: e, actionTypeId: t, elementApi: r }) =>
      (n) => {
        switch (t) {
          case _n:
          case bn:
          case Sn:
          case Pi:
            e(n, Je.TRANSFORM_PREFIXED, r);
            break;
          case Ci:
            e(n, Ti, r);
            break;
          case wi:
            e(n, xi, r);
            break;
          case rT:
            e(n, Ts, r);
            break;
          case In:
            e(n, kt, r), e(n, Bt, r);
            break;
          case Tn:
          case xn:
          case An:
            e(n, bh[t], r);
            break;
          case Ps:
            e(n, xs, r);
            break;
        }
      };
    function H8(e, t, r) {
      let { setStyle: n } = r;
      sT(e, t, r),
        n(e, t, ""),
        t === Je.TRANSFORM_PREFIXED && n(e, Je.TRANSFORM_STYLE_PREFIXED, "");
    }
    function lT(e) {
      let t = 0,
        r = 0;
      return (
        e.forEach((n, i) => {
          let { config: a } = n,
            s = a.delay + a.duration;
          s >= t && ((t = s), (r = i));
        }),
        r
      );
    }
    function W8(e, t) {
      let { actionItemGroups: r, useFirstGroupAsInitialState: n } = e,
        { actionItem: i, verboseTimeElapsed: a = 0 } = t,
        s = 0,
        o = 0;
      return (
        r.forEach((l, f) => {
          if (n && f === 0) return;
          let { actionItems: u } = l,
            c = u[lT(u)],
            { config: v, actionTypeId: d } = c;
          i.id === c.id && (o = s + a);
          let p = aT(d) === Eh ? 0 : v.duration;
          s += v.delay + p;
        }),
        s > 0 ? (0, XK.optimizeFloat)(o / s) : 0
      );
    }
    function X8({ actionList: e, actionItemId: t, rawData: r }) {
      let { actionItemGroups: n, continuousParameterGroups: i } = e,
        a = [],
        s = (o) => (
          a.push((0, WI.mergeIn)(o, ["config"], { delay: 0, duration: 0 })),
          o.id === t
        );
      return (
        n && n.some(({ actionItems: o }) => o.some(s)),
        i &&
          i.some((o) => {
            let { continuousActionGroups: l } = o;
            return l.some(({ actionItems: f }) => f.some(s));
          }),
        (0, WI.setIn)(r, ["actionLists"], {
          [e.id]: { id: e.id, actionItemGroups: [{ actionItems: a }] },
        })
      );
    }
    function U8(e, { basedOn: t }) {
      return (
        (e === Nr.EventTypeConsts.SCROLLING_IN_VIEW &&
          (t === Nr.EventBasedOn.ELEMENT || t == null)) ||
        (e === Nr.EventTypeConsts.MOUSE_MOVE && t === Nr.EventBasedOn.ELEMENT)
      );
    }
    function $8(e, t) {
      return e + o8 + t;
    }
    function K8(e, t) {
      return t == null ? !0 : e.indexOf(t) !== -1;
    }
    function Y8(e, t) {
      return (0, ZI.default)(e && e.sort(), t && t.sort());
    }
    function Q8(e) {
      if (typeof e == "string") return e;
      if (e.pluginElement && e.objectId)
        return e.pluginElement + vh + e.objectId;
      if (e.objectId) return e.objectId;
      let { id: t = "", selector: r = "", useEventTarget: n = "" } = e;
      return t + vh + r + vh + n;
    }
  });
  var Br = E((et) => {
    "use strict";
    var Pn = Fr().default;
    Object.defineProperty(et, "__esModule", { value: !0 });
    et.IX2VanillaUtils =
      et.IX2VanillaPlugins =
      et.IX2ElementsReducer =
      et.IX2Easings =
      et.IX2EasingUtils =
      et.IX2BrowserSupport =
        void 0;
    var Z8 = Pn(vs());
    et.IX2BrowserSupport = Z8;
    var J8 = Pn(sh());
    et.IX2Easings = J8;
    var e9 = Pn(lh());
    et.IX2EasingUtils = e9;
    var t9 = Pn(mI());
    et.IX2ElementsReducer = t9;
    var r9 = Pn(ph());
    et.IX2VanillaPlugins = r9;
    var n9 = Pn(uT());
    et.IX2VanillaUtils = n9;
  });
  var pT = E((ws) => {
    "use strict";
    Object.defineProperty(ws, "__esModule", { value: !0 });
    ws.ixInstances = void 0;
    var hT = nt(),
      cT = Br(),
      Cn = gn(),
      {
        IX2_RAW_DATA_IMPORTED: i9,
        IX2_SESSION_STOPPED: a9,
        IX2_INSTANCE_ADDED: s9,
        IX2_INSTANCE_STARTED: o9,
        IX2_INSTANCE_REMOVED: l9,
        IX2_ANIMATION_FRAME_CHANGED: u9,
      } = hT.IX2EngineActionTypes,
      {
        optimizeFloat: Cs,
        applyEasing: fT,
        createBezierEasing: h9,
      } = cT.IX2EasingUtils,
      { RENDER_GENERAL: c9 } = hT.IX2EngineConstants,
      {
        getItemConfigByKey: Th,
        getRenderType: f9,
        getStyleProp: p9,
      } = cT.IX2VanillaUtils,
      d9 = (e, t) => {
        let {
            position: r,
            parameterId: n,
            actionGroups: i,
            destinationKeys: a,
            smoothing: s,
            restingValue: o,
            actionTypeId: l,
            customEasingFn: f,
            skipMotion: u,
            skipToValue: c,
          } = e,
          { parameters: v } = t.payload,
          d = Math.max(1 - s, 0.01),
          p = v[n];
        p == null && ((d = 1), (p = o));
        let m = Math.max(p, 0) || 0,
          h = Cs(m - r),
          g = u ? c : Cs(r + h * d),
          y = g * 100;
        if (g === r && e.current) return e;
        let _, b, I, P;
        for (let A = 0, { length: R } = i; A < R; A++) {
          let { keyframe: w, actionItems: C } = i[A];
          if ((A === 0 && (_ = C[0]), y >= w)) {
            _ = C[0];
            let D = i[A + 1],
              M = D && y !== w;
            (b = M ? D.actionItems[0] : null),
              M && ((I = w / 100), (P = (D.keyframe - w) / 100));
          }
        }
        let S = {};
        if (_ && !b)
          for (let A = 0, { length: R } = a; A < R; A++) {
            let w = a[A];
            S[w] = Th(l, w, _.config);
          }
        else if (_ && b && I !== void 0 && P !== void 0) {
          let A = (g - I) / P,
            R = _.config.easing,
            w = fT(R, A, f);
          for (let C = 0, { length: D } = a; C < D; C++) {
            let M = a[C],
              O = Th(l, M, _.config),
              H = (Th(l, M, b.config) - O) * w + O;
            S[M] = H;
          }
        }
        return (0, Cn.merge)(e, { position: g, current: S });
      },
      m9 = (e, t) => {
        let {
            active: r,
            origin: n,
            start: i,
            immediate: a,
            renderType: s,
            verbose: o,
            actionItem: l,
            destination: f,
            destinationKeys: u,
            pluginDuration: c,
            instanceDelay: v,
            customEasingFn: d,
            skipMotion: p,
          } = e,
          m = l.config.easing,
          { duration: h, delay: g } = l.config;
        c != null && (h = c),
          (g = v ?? g),
          s === c9 ? (h = 0) : (a || p) && (h = g = 0);
        let { now: y } = t.payload;
        if (r && n) {
          let _ = y - (i + g);
          if (o) {
            let A = y - i,
              R = h + g,
              w = Cs(Math.min(Math.max(0, A / R), 1));
            e = (0, Cn.set)(e, "verboseTimeElapsed", R * w);
          }
          if (_ < 0) return e;
          let b = Cs(Math.min(Math.max(0, _ / h), 1)),
            I = fT(m, b, d),
            P = {},
            S = null;
          return (
            u.length &&
              (S = u.reduce((A, R) => {
                let w = f[R],
                  C = parseFloat(n[R]) || 0,
                  M = (parseFloat(w) - C) * I + C;
                return (A[R] = M), A;
              }, {})),
            (P.current = S),
            (P.position = b),
            b === 1 && ((P.active = !1), (P.complete = !0)),
            (0, Cn.merge)(e, P)
          );
        }
        return e;
      },
      v9 = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case i9:
            return t.payload.ixInstances || Object.freeze({});
          case a9:
            return Object.freeze({});
          case s9: {
            let {
                instanceId: r,
                elementId: n,
                actionItem: i,
                eventId: a,
                eventTarget: s,
                eventStateKey: o,
                actionListId: l,
                groupIndex: f,
                isCarrier: u,
                origin: c,
                destination: v,
                immediate: d,
                verbose: p,
                continuous: m,
                parameterId: h,
                actionGroups: g,
                smoothing: y,
                restingValue: _,
                pluginInstance: b,
                pluginDuration: I,
                instanceDelay: P,
                skipMotion: S,
                skipToValue: A,
              } = t.payload,
              { actionTypeId: R } = i,
              w = f9(R),
              C = p9(w, R),
              D = Object.keys(v).filter(
                (O) => v[O] != null && typeof v[O] != "string",
              ),
              { easing: M } = i.config;
            return (0, Cn.set)(e, r, {
              id: r,
              elementId: n,
              active: !1,
              position: 0,
              start: 0,
              origin: c,
              destination: v,
              destinationKeys: D,
              immediate: d,
              verbose: p,
              current: null,
              actionItem: i,
              actionTypeId: R,
              eventId: a,
              eventTarget: s,
              eventStateKey: o,
              actionListId: l,
              groupIndex: f,
              renderType: w,
              isCarrier: u,
              styleProp: C,
              continuous: m,
              parameterId: h,
              actionGroups: g,
              smoothing: y,
              restingValue: _,
              pluginInstance: b,
              pluginDuration: I,
              instanceDelay: P,
              skipMotion: S,
              skipToValue: A,
              customEasingFn:
                Array.isArray(M) && M.length === 4 ? h9(M) : void 0,
            });
          }
          case o9: {
            let { instanceId: r, time: n } = t.payload;
            return (0, Cn.mergeIn)(e, [r], {
              active: !0,
              complete: !1,
              start: n,
            });
          }
          case l9: {
            let { instanceId: r } = t.payload;
            if (!e[r]) return e;
            let n = {},
              i = Object.keys(e),
              { length: a } = i;
            for (let s = 0; s < a; s++) {
              let o = i[s];
              o !== r && (n[o] = e[o]);
            }
            return n;
          }
          case u9: {
            let r = e,
              n = Object.keys(e),
              { length: i } = n;
            for (let a = 0; a < i; a++) {
              let s = n[a],
                o = e[s],
                l = o.continuous ? d9 : m9;
              r = (0, Cn.set)(r, s, l(o, t));
            }
            return r;
          }
          default:
            return e;
        }
      };
    ws.ixInstances = v9;
  });
  var dT = E((Ms) => {
    "use strict";
    Object.defineProperty(Ms, "__esModule", { value: !0 });
    Ms.ixParameters = void 0;
    var g9 = nt(),
      {
        IX2_RAW_DATA_IMPORTED: y9,
        IX2_SESSION_STOPPED: E9,
        IX2_PARAMETER_CHANGED: _9,
      } = g9.IX2EngineActionTypes,
      b9 = (e = {}, t) => {
        switch (t.type) {
          case y9:
            return t.payload.ixParameters || {};
          case E9:
            return {};
          case _9: {
            let { key: r, value: n } = t.payload;
            return (e[r] = n), e;
          }
          default:
            return e;
        }
      };
    Ms.ixParameters = b9;
  });
  var mT = E((Os) => {
    "use strict";
    Object.defineProperty(Os, "__esModule", { value: !0 });
    Os.default = void 0;
    var S9 = Yu(),
      I9 = DS(),
      T9 = ZS(),
      x9 = eI(),
      A9 = Br(),
      P9 = pT(),
      C9 = dT(),
      { ixElements: w9 } = A9.IX2ElementsReducer,
      M9 = (0, S9.combineReducers)({
        ixData: I9.ixData,
        ixRequest: T9.ixRequest,
        ixSession: x9.ixSession,
        ixElements: w9,
        ixInstances: P9.ixInstances,
        ixParameters: C9.ixParameters,
      });
    Os.default = M9;
  });
  var vT = E((lue, Mi) => {
    function O9(e, t) {
      if (e == null) return {};
      var r = {},
        n = Object.keys(e),
        i,
        a;
      for (a = 0; a < n.length; a++)
        (i = n[a]), !(t.indexOf(i) >= 0) && (r[i] = e[i]);
      return r;
    }
    (Mi.exports = O9),
      (Mi.exports.__esModule = !0),
      (Mi.exports.default = Mi.exports);
  });
  var yT = E((uue, gT) => {
    var R9 = nr(),
      D9 = ke(),
      q9 = Ht(),
      F9 = "[object String]";
    function L9(e) {
      return typeof e == "string" || (!D9(e) && q9(e) && R9(e) == F9);
    }
    gT.exports = L9;
  });
  var _T = E((hue, ET) => {
    var N9 = Oo(),
      k9 = N9("length");
    ET.exports = k9;
  });
  var ST = E((cue, bT) => {
    var B9 = "\\ud800-\\udfff",
      V9 = "\\u0300-\\u036f",
      G9 = "\\ufe20-\\ufe2f",
      z9 = "\\u20d0-\\u20ff",
      j9 = V9 + G9 + z9,
      H9 = "\\ufe0e\\ufe0f",
      W9 = "\\u200d",
      X9 = RegExp("[" + W9 + B9 + j9 + H9 + "]");
    function U9(e) {
      return X9.test(e);
    }
    bT.exports = U9;
  });
  var OT = E((fue, MT) => {
    var TT = "\\ud800-\\udfff",
      $9 = "\\u0300-\\u036f",
      K9 = "\\ufe20-\\ufe2f",
      Y9 = "\\u20d0-\\u20ff",
      Q9 = $9 + K9 + Y9,
      Z9 = "\\ufe0e\\ufe0f",
      J9 = "[" + TT + "]",
      xh = "[" + Q9 + "]",
      Ah = "\\ud83c[\\udffb-\\udfff]",
      e7 = "(?:" + xh + "|" + Ah + ")",
      xT = "[^" + TT + "]",
      AT = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      PT = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      t7 = "\\u200d",
      CT = e7 + "?",
      wT = "[" + Z9 + "]?",
      r7 = "(?:" + t7 + "(?:" + [xT, AT, PT].join("|") + ")" + wT + CT + ")*",
      n7 = wT + CT + r7,
      i7 = "(?:" + [xT + xh + "?", xh, AT, PT, J9].join("|") + ")",
      IT = RegExp(Ah + "(?=" + Ah + ")|" + i7 + n7, "g");
    function a7(e) {
      for (var t = (IT.lastIndex = 0); IT.test(e); ) ++t;
      return t;
    }
    MT.exports = a7;
  });
  var DT = E((pue, RT) => {
    var s7 = _T(),
      o7 = ST(),
      l7 = OT();
    function u7(e) {
      return o7(e) ? l7(e) : s7(e);
    }
    RT.exports = u7;
  });
  var FT = E((due, qT) => {
    var h7 = Ki(),
      c7 = Yi(),
      f7 = Ir(),
      p7 = yT(),
      d7 = DT(),
      m7 = "[object Map]",
      v7 = "[object Set]";
    function g7(e) {
      if (e == null) return 0;
      if (f7(e)) return p7(e) ? d7(e) : e.length;
      var t = c7(e);
      return t == m7 || t == v7 ? e.size : h7(e).length;
    }
    qT.exports = g7;
  });
  var NT = E((mue, LT) => {
    var y7 = "Expected a function";
    function E7(e) {
      if (typeof e != "function") throw new TypeError(y7);
      return function () {
        var t = arguments;
        switch (t.length) {
          case 0:
            return !e.call(this);
          case 1:
            return !e.call(this, t[0]);
          case 2:
            return !e.call(this, t[0], t[1]);
          case 3:
            return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
      };
    }
    LT.exports = E7;
  });
  var Ph = E((vue, kT) => {
    var _7 = ir(),
      b7 = (function () {
        try {
          var e = _7(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch {}
      })();
    kT.exports = b7;
  });
  var Ch = E((gue, VT) => {
    var BT = Ph();
    function S7(e, t, r) {
      t == "__proto__" && BT
        ? BT(e, t, { configurable: !0, enumerable: !0, value: r, writable: !0 })
        : (e[t] = r);
    }
    VT.exports = S7;
  });
  var zT = E((yue, GT) => {
    var I7 = Ch(),
      T7 = Bi(),
      x7 = Object.prototype,
      A7 = x7.hasOwnProperty;
    function P7(e, t, r) {
      var n = e[t];
      (!(A7.call(e, t) && T7(n, r)) || (r === void 0 && !(t in e))) &&
        I7(e, t, r);
    }
    GT.exports = P7;
  });
  var WT = E((Eue, HT) => {
    var C7 = zT(),
      w7 = Hn(),
      M7 = Wi(),
      jT = Ot(),
      O7 = Zr();
    function R7(e, t, r, n) {
      if (!jT(e)) return e;
      t = w7(t, e);
      for (var i = -1, a = t.length, s = a - 1, o = e; o != null && ++i < a; ) {
        var l = O7(t[i]),
          f = r;
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return e;
        if (i != s) {
          var u = o[l];
          (f = n ? n(u, l, o) : void 0),
            f === void 0 && (f = jT(u) ? u : M7(t[i + 1]) ? [] : {});
        }
        C7(o, l, f), (o = o[l]);
      }
      return e;
    }
    HT.exports = R7;
  });
  var UT = E((_ue, XT) => {
    var D7 = Ji(),
      q7 = WT(),
      F7 = Hn();
    function L7(e, t, r) {
      for (var n = -1, i = t.length, a = {}; ++n < i; ) {
        var s = t[n],
          o = D7(e, s);
        r(o, s) && q7(a, F7(s, e), o);
      }
      return a;
    }
    XT.exports = L7;
  });
  var KT = E((bue, $T) => {
    var N7 = ji(),
      k7 = Nu(),
      B7 = mo(),
      V7 = po(),
      G7 = Object.getOwnPropertySymbols,
      z7 = G7
        ? function (e) {
            for (var t = []; e; ) N7(t, B7(e)), (e = k7(e));
            return t;
          }
        : V7;
    $T.exports = z7;
  });
  var QT = E((Sue, YT) => {
    function j7(e) {
      var t = [];
      if (e != null) for (var r in Object(e)) t.push(r);
      return t;
    }
    YT.exports = j7;
  });
  var JT = E((Iue, ZT) => {
    var H7 = Ot(),
      W7 = $i(),
      X7 = QT(),
      U7 = Object.prototype,
      $7 = U7.hasOwnProperty;
    function K7(e) {
      if (!H7(e)) return X7(e);
      var t = W7(e),
        r = [];
      for (var n in e)
        (n == "constructor" && (t || !$7.call(e, n))) || r.push(n);
      return r;
    }
    ZT.exports = K7;
  });
  var tx = E((Tue, ex) => {
    var Y7 = go(),
      Q7 = JT(),
      Z7 = Ir();
    function J7(e) {
      return Z7(e) ? Y7(e, !0) : Q7(e);
    }
    ex.exports = J7;
  });
  var nx = E((xue, rx) => {
    var eY = fo(),
      tY = KT(),
      rY = tx();
    function nY(e) {
      return eY(e, rY, tY);
    }
    rx.exports = nY;
  });
  var ax = E((Aue, ix) => {
    var iY = Mo(),
      aY = ar(),
      sY = UT(),
      oY = nx();
    function lY(e, t) {
      if (e == null) return {};
      var r = iY(oY(e), function (n) {
        return [n];
      });
      return (
        (t = aY(t)),
        sY(e, r, function (n, i) {
          return t(n, i[0]);
        })
      );
    }
    ix.exports = lY;
  });
  var ox = E((Pue, sx) => {
    var uY = ar(),
      hY = NT(),
      cY = ax();
    function fY(e, t) {
      return cY(e, hY(uY(t)));
    }
    sx.exports = fY;
  });
  var ux = E((Cue, lx) => {
    var pY = Ki(),
      dY = Yi(),
      mY = kn(),
      vY = ke(),
      gY = Ir(),
      yY = Hi(),
      EY = $i(),
      _Y = Ui(),
      bY = "[object Map]",
      SY = "[object Set]",
      IY = Object.prototype,
      TY = IY.hasOwnProperty;
    function xY(e) {
      if (e == null) return !0;
      if (
        gY(e) &&
        (vY(e) ||
          typeof e == "string" ||
          typeof e.splice == "function" ||
          yY(e) ||
          _Y(e) ||
          mY(e))
      )
        return !e.length;
      var t = dY(e);
      if (t == bY || t == SY) return !e.size;
      if (EY(e)) return !pY(e).length;
      for (var r in e) if (TY.call(e, r)) return !1;
      return !0;
    }
    lx.exports = xY;
  });
  var cx = E((wue, hx) => {
    var AY = Ch(),
      PY = dh(),
      CY = ar();
    function wY(e, t) {
      var r = {};
      return (
        (t = CY(t, 3)),
        PY(e, function (n, i, a) {
          AY(r, i, t(n, i, a));
        }),
        r
      );
    }
    hx.exports = wY;
  });
  var px = E((Mue, fx) => {
    function MY(e, t) {
      for (
        var r = -1, n = e == null ? 0 : e.length;
        ++r < n && t(e[r], r, e) !== !1;

      );
      return e;
    }
    fx.exports = MY;
  });
  var mx = E((Oue, dx) => {
    var OY = ta();
    function RY(e) {
      return typeof e == "function" ? e : OY;
    }
    dx.exports = RY;
  });
  var gx = E((Rue, vx) => {
    var DY = px(),
      qY = mh(),
      FY = mx(),
      LY = ke();
    function NY(e, t) {
      var r = LY(e) ? DY : qY;
      return r(e, FY(t));
    }
    vx.exports = NY;
  });
  var Ex = E((Due, yx) => {
    var kY = _t(),
      BY = function () {
        return kY.Date.now();
      };
    yx.exports = BY;
  });
  var Sx = E((que, bx) => {
    var VY = Ot(),
      wh = Ex(),
      _x = ra(),
      GY = "Expected a function",
      zY = Math.max,
      jY = Math.min;
    function HY(e, t, r) {
      var n,
        i,
        a,
        s,
        o,
        l,
        f = 0,
        u = !1,
        c = !1,
        v = !0;
      if (typeof e != "function") throw new TypeError(GY);
      (t = _x(t) || 0),
        VY(r) &&
          ((u = !!r.leading),
          (c = "maxWait" in r),
          (a = c ? zY(_x(r.maxWait) || 0, t) : a),
          (v = "trailing" in r ? !!r.trailing : v));
      function d(P) {
        var S = n,
          A = i;
        return (n = i = void 0), (f = P), (s = e.apply(A, S)), s;
      }
      function p(P) {
        return (f = P), (o = setTimeout(g, t)), u ? d(P) : s;
      }
      function m(P) {
        var S = P - l,
          A = P - f,
          R = t - S;
        return c ? jY(R, a - A) : R;
      }
      function h(P) {
        var S = P - l,
          A = P - f;
        return l === void 0 || S >= t || S < 0 || (c && A >= a);
      }
      function g() {
        var P = wh();
        if (h(P)) return y(P);
        o = setTimeout(g, m(P));
      }
      function y(P) {
        return (o = void 0), v && n ? d(P) : ((n = i = void 0), s);
      }
      function _() {
        o !== void 0 && clearTimeout(o), (f = 0), (n = l = i = o = void 0);
      }
      function b() {
        return o === void 0 ? s : y(wh());
      }
      function I() {
        var P = wh(),
          S = h(P);
        if (((n = arguments), (i = this), (l = P), S)) {
          if (o === void 0) return p(l);
          if (c) return clearTimeout(o), (o = setTimeout(g, t)), d(l);
        }
        return o === void 0 && (o = setTimeout(g, t)), s;
      }
      return (I.cancel = _), (I.flush = b), I;
    }
    bx.exports = HY;
  });
  var Tx = E((Fue, Ix) => {
    var WY = Sx(),
      XY = Ot(),
      UY = "Expected a function";
    function $Y(e, t, r) {
      var n = !0,
        i = !0;
      if (typeof e != "function") throw new TypeError(UY);
      return (
        XY(r) &&
          ((n = "leading" in r ? !!r.leading : n),
          (i = "trailing" in r ? !!r.trailing : i)),
        WY(e, t, { leading: n, maxWait: t, trailing: i })
      );
    }
    Ix.exports = $Y;
  });
  var Rs = E((ne) => {
    "use strict";
    var KY = st().default;
    Object.defineProperty(ne, "__esModule", { value: !0 });
    ne.viewportWidthChanged =
      ne.testFrameRendered =
      ne.stopRequested =
      ne.sessionStopped =
      ne.sessionStarted =
      ne.sessionInitialized =
      ne.rawDataImported =
      ne.previewRequested =
      ne.playbackRequested =
      ne.parameterChanged =
      ne.mediaQueriesDefined =
      ne.instanceStarted =
      ne.instanceRemoved =
      ne.instanceAdded =
      ne.eventStateChanged =
      ne.eventListenerAdded =
      ne.elementStateChanged =
      ne.clearRequested =
      ne.animationFrameChanged =
      ne.actionListPlaybackChanged =
        void 0;
    var xx = KY(Sr()),
      Ax = nt(),
      YY = Br(),
      {
        IX2_RAW_DATA_IMPORTED: QY,
        IX2_SESSION_INITIALIZED: ZY,
        IX2_SESSION_STARTED: JY,
        IX2_SESSION_STOPPED: eQ,
        IX2_PREVIEW_REQUESTED: tQ,
        IX2_PLAYBACK_REQUESTED: rQ,
        IX2_STOP_REQUESTED: nQ,
        IX2_CLEAR_REQUESTED: iQ,
        IX2_EVENT_LISTENER_ADDED: aQ,
        IX2_TEST_FRAME_RENDERED: sQ,
        IX2_EVENT_STATE_CHANGED: oQ,
        IX2_ANIMATION_FRAME_CHANGED: lQ,
        IX2_PARAMETER_CHANGED: uQ,
        IX2_INSTANCE_ADDED: hQ,
        IX2_INSTANCE_STARTED: cQ,
        IX2_INSTANCE_REMOVED: fQ,
        IX2_ELEMENT_STATE_CHANGED: pQ,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: dQ,
        IX2_VIEWPORT_WIDTH_CHANGED: mQ,
        IX2_MEDIA_QUERIES_DEFINED: vQ,
      } = Ax.IX2EngineActionTypes,
      { reifyState: gQ } = YY.IX2VanillaUtils,
      yQ = (e) => ({ type: QY, payload: (0, xx.default)({}, gQ(e)) });
    ne.rawDataImported = yQ;
    var EQ = ({ hasBoundaryNodes: e, reducedMotion: t }) => ({
      type: ZY,
      payload: { hasBoundaryNodes: e, reducedMotion: t },
    });
    ne.sessionInitialized = EQ;
    var _Q = () => ({ type: JY });
    ne.sessionStarted = _Q;
    var bQ = () => ({ type: eQ });
    ne.sessionStopped = bQ;
    var SQ = ({ rawData: e, defer: t }) => ({
      type: tQ,
      payload: { defer: t, rawData: e },
    });
    ne.previewRequested = SQ;
    var IQ = ({
      actionTypeId: e = Ax.ActionTypeConsts.GENERAL_START_ACTION,
      actionListId: t,
      actionItemId: r,
      eventId: n,
      allowEvents: i,
      immediate: a,
      testManual: s,
      verbose: o,
      rawData: l,
    }) => ({
      type: rQ,
      payload: {
        actionTypeId: e,
        actionListId: t,
        actionItemId: r,
        testManual: s,
        eventId: n,
        allowEvents: i,
        immediate: a,
        verbose: o,
        rawData: l,
      },
    });
    ne.playbackRequested = IQ;
    var TQ = (e) => ({ type: nQ, payload: { actionListId: e } });
    ne.stopRequested = TQ;
    var xQ = () => ({ type: iQ });
    ne.clearRequested = xQ;
    var AQ = (e, t) => ({
      type: aQ,
      payload: { target: e, listenerParams: t },
    });
    ne.eventListenerAdded = AQ;
    var PQ = (e = 1) => ({ type: sQ, payload: { step: e } });
    ne.testFrameRendered = PQ;
    var CQ = (e, t) => ({ type: oQ, payload: { stateKey: e, newState: t } });
    ne.eventStateChanged = CQ;
    var wQ = (e, t) => ({ type: lQ, payload: { now: e, parameters: t } });
    ne.animationFrameChanged = wQ;
    var MQ = (e, t) => ({ type: uQ, payload: { key: e, value: t } });
    ne.parameterChanged = MQ;
    var OQ = (e) => ({ type: hQ, payload: (0, xx.default)({}, e) });
    ne.instanceAdded = OQ;
    var RQ = (e, t) => ({ type: cQ, payload: { instanceId: e, time: t } });
    ne.instanceStarted = RQ;
    var DQ = (e) => ({ type: fQ, payload: { instanceId: e } });
    ne.instanceRemoved = DQ;
    var qQ = (e, t, r, n) => ({
      type: pQ,
      payload: { elementId: e, actionTypeId: t, current: r, actionItem: n },
    });
    ne.elementStateChanged = qQ;
    var FQ = ({ actionListId: e, isPlaying: t }) => ({
      type: dQ,
      payload: { actionListId: e, isPlaying: t },
    });
    ne.actionListPlaybackChanged = FQ;
    var LQ = ({ width: e, mediaQueries: t }) => ({
      type: mQ,
      payload: { width: e, mediaQueries: t },
    });
    ne.viewportWidthChanged = LQ;
    var NQ = () => ({ type: vQ });
    ne.mediaQueriesDefined = NQ;
  });
  var wx = E((ze) => {
    "use strict";
    Object.defineProperty(ze, "__esModule", { value: !0 });
    ze.elementContains = KQ;
    ze.getChildElements = QQ;
    ze.getClosestElement = void 0;
    ze.getProperty = HQ;
    ze.getQuerySelector = XQ;
    ze.getRefType = eZ;
    ze.getSiblingElements = ZQ;
    ze.getStyle = jQ;
    ze.getValidDocument = UQ;
    ze.isSiblingNode = YQ;
    ze.matchSelector = WQ;
    ze.queryDocument = $Q;
    ze.setStyle = zQ;
    var kQ = Br(),
      BQ = nt(),
      { ELEMENT_MATCHES: Mh } = kQ.IX2BrowserSupport,
      {
        IX2_ID_DELIMITER: Px,
        HTML_ELEMENT: VQ,
        PLAIN_OBJECT: GQ,
        WF_PAGE: Cx,
      } = BQ.IX2EngineConstants;
    function zQ(e, t, r) {
      e.style[t] = r;
    }
    function jQ(e, t) {
      return e.style[t];
    }
    function HQ(e, t) {
      return e[t];
    }
    function WQ(e) {
      return (t) => t[Mh](e);
    }
    function XQ({ id: e, selector: t }) {
      if (e) {
        let r = e;
        if (e.indexOf(Px) !== -1) {
          let n = e.split(Px),
            i = n[0];
          if (((r = n[1]), i !== document.documentElement.getAttribute(Cx)))
            return null;
        }
        return `[data-w-id="${r}"], [data-w-id^="${r}_instance"]`;
      }
      return t;
    }
    function UQ(e) {
      return e == null || e === document.documentElement.getAttribute(Cx)
        ? document
        : null;
    }
    function $Q(e, t) {
      return Array.prototype.slice.call(
        document.querySelectorAll(t ? e + " " + t : e),
      );
    }
    function KQ(e, t) {
      return e.contains(t);
    }
    function YQ(e, t) {
      return e !== t && e.parentNode === t.parentNode;
    }
    function QQ(e) {
      let t = [];
      for (let r = 0, { length: n } = e || []; r < n; r++) {
        let { children: i } = e[r],
          { length: a } = i;
        if (a) for (let s = 0; s < a; s++) t.push(i[s]);
      }
      return t;
    }
    function ZQ(e = []) {
      let t = [],
        r = [];
      for (let n = 0, { length: i } = e; n < i; n++) {
        let { parentNode: a } = e[n];
        if (!a || !a.children || !a.children.length || r.indexOf(a) !== -1)
          continue;
        r.push(a);
        let s = a.firstElementChild;
        for (; s != null; )
          e.indexOf(s) === -1 && t.push(s), (s = s.nextElementSibling);
      }
      return t;
    }
    var JQ = Element.prototype.closest
      ? (e, t) => (document.documentElement.contains(e) ? e.closest(t) : null)
      : (e, t) => {
          if (!document.documentElement.contains(e)) return null;
          let r = e;
          do {
            if (r[Mh] && r[Mh](t)) return r;
            r = r.parentNode;
          } while (r != null);
          return null;
        };
    ze.getClosestElement = JQ;
    function eZ(e) {
      return e != null && typeof e == "object"
        ? e instanceof Element
          ? VQ
          : GQ
        : null;
    }
  });
  var Oh = E((kue, Ox) => {
    var tZ = Ot(),
      Mx = Object.create,
      rZ = (function () {
        function e() {}
        return function (t) {
          if (!tZ(t)) return {};
          if (Mx) return Mx(t);
          e.prototype = t;
          var r = new e();
          return (e.prototype = void 0), r;
        };
      })();
    Ox.exports = rZ;
  });
  var Ds = E((Bue, Rx) => {
    function nZ() {}
    Rx.exports = nZ;
  });
  var Fs = E((Vue, Dx) => {
    var iZ = Oh(),
      aZ = Ds();
    function qs(e, t) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__chain__ = !!t),
        (this.__index__ = 0),
        (this.__values__ = void 0);
    }
    qs.prototype = iZ(aZ.prototype);
    qs.prototype.constructor = qs;
    Dx.exports = qs;
  });
  var Nx = E((Gue, Lx) => {
    var qx = Wr(),
      sZ = kn(),
      oZ = ke(),
      Fx = qx ? qx.isConcatSpreadable : void 0;
    function lZ(e) {
      return oZ(e) || sZ(e) || !!(Fx && e && e[Fx]);
    }
    Lx.exports = lZ;
  });
  var Vx = E((zue, Bx) => {
    var uZ = ji(),
      hZ = Nx();
    function kx(e, t, r, n, i) {
      var a = -1,
        s = e.length;
      for (r || (r = hZ), i || (i = []); ++a < s; ) {
        var o = e[a];
        t > 0 && r(o)
          ? t > 1
            ? kx(o, t - 1, r, n, i)
            : uZ(i, o)
          : n || (i[i.length] = o);
      }
      return i;
    }
    Bx.exports = kx;
  });
  var zx = E((jue, Gx) => {
    var cZ = Vx();
    function fZ(e) {
      var t = e == null ? 0 : e.length;
      return t ? cZ(e, 1) : [];
    }
    Gx.exports = fZ;
  });
  var Hx = E((Hue, jx) => {
    function pZ(e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, r[0]);
        case 2:
          return e.call(t, r[0], r[1]);
        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }
      return e.apply(t, r);
    }
    jx.exports = pZ;
  });
  var Ux = E((Wue, Xx) => {
    var dZ = Hx(),
      Wx = Math.max;
    function mZ(e, t, r) {
      return (
        (t = Wx(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (
            var n = arguments, i = -1, a = Wx(n.length - t, 0), s = Array(a);
            ++i < a;

          )
            s[i] = n[t + i];
          i = -1;
          for (var o = Array(t + 1); ++i < t; ) o[i] = n[i];
          return (o[t] = r(s)), dZ(e, this, o);
        }
      );
    }
    Xx.exports = mZ;
  });
  var Kx = E((Xue, $x) => {
    function vZ(e) {
      return function () {
        return e;
      };
    }
    $x.exports = vZ;
  });
  var Zx = E((Uue, Qx) => {
    var gZ = Kx(),
      Yx = Ph(),
      yZ = ta(),
      EZ = Yx
        ? function (e, t) {
            return Yx(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: gZ(t),
              writable: !0,
            });
          }
        : yZ;
    Qx.exports = EZ;
  });
  var eA = E(($ue, Jx) => {
    var _Z = 800,
      bZ = 16,
      SZ = Date.now;
    function IZ(e) {
      var t = 0,
        r = 0;
      return function () {
        var n = SZ(),
          i = bZ - (n - r);
        if (((r = n), i > 0)) {
          if (++t >= _Z) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    Jx.exports = IZ;
  });
  var rA = E((Kue, tA) => {
    var TZ = Zx(),
      xZ = eA(),
      AZ = xZ(TZ);
    tA.exports = AZ;
  });
  var iA = E((Yue, nA) => {
    var PZ = zx(),
      CZ = Ux(),
      wZ = rA();
    function MZ(e) {
      return wZ(CZ(e, void 0, PZ), e + "");
    }
    nA.exports = MZ;
  });
  var oA = E((Que, sA) => {
    var aA = Eo(),
      OZ = aA && new aA();
    sA.exports = OZ;
  });
  var uA = E((Zue, lA) => {
    function RZ() {}
    lA.exports = RZ;
  });
  var Rh = E((Jue, cA) => {
    var hA = oA(),
      DZ = uA(),
      qZ = hA
        ? function (e) {
            return hA.get(e);
          }
        : DZ;
    cA.exports = qZ;
  });
  var pA = E((ehe, fA) => {
    var FZ = {};
    fA.exports = FZ;
  });
  var Dh = E((the, mA) => {
    var dA = pA(),
      LZ = Object.prototype,
      NZ = LZ.hasOwnProperty;
    function kZ(e) {
      for (
        var t = e.name + "", r = dA[t], n = NZ.call(dA, t) ? r.length : 0;
        n--;

      ) {
        var i = r[n],
          a = i.func;
        if (a == null || a == e) return i.name;
      }
      return t;
    }
    mA.exports = kZ;
  });
  var Ns = E((rhe, vA) => {
    var BZ = Oh(),
      VZ = Ds(),
      GZ = 4294967295;
    function Ls(e) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__dir__ = 1),
        (this.__filtered__ = !1),
        (this.__iteratees__ = []),
        (this.__takeCount__ = GZ),
        (this.__views__ = []);
    }
    Ls.prototype = BZ(VZ.prototype);
    Ls.prototype.constructor = Ls;
    vA.exports = Ls;
  });
  var yA = E((nhe, gA) => {
    function zZ(e, t) {
      var r = -1,
        n = e.length;
      for (t || (t = Array(n)); ++r < n; ) t[r] = e[r];
      return t;
    }
    gA.exports = zZ;
  });
  var _A = E((ihe, EA) => {
    var jZ = Ns(),
      HZ = Fs(),
      WZ = yA();
    function XZ(e) {
      if (e instanceof jZ) return e.clone();
      var t = new HZ(e.__wrapped__, e.__chain__);
      return (
        (t.__actions__ = WZ(e.__actions__)),
        (t.__index__ = e.__index__),
        (t.__values__ = e.__values__),
        t
      );
    }
    EA.exports = XZ;
  });
  var IA = E((ahe, SA) => {
    var UZ = Ns(),
      bA = Fs(),
      $Z = Ds(),
      KZ = ke(),
      YZ = Ht(),
      QZ = _A(),
      ZZ = Object.prototype,
      JZ = ZZ.hasOwnProperty;
    function ks(e) {
      if (YZ(e) && !KZ(e) && !(e instanceof UZ)) {
        if (e instanceof bA) return e;
        if (JZ.call(e, "__wrapped__")) return QZ(e);
      }
      return new bA(e);
    }
    ks.prototype = $Z.prototype;
    ks.prototype.constructor = ks;
    SA.exports = ks;
  });
  var xA = E((she, TA) => {
    var eJ = Ns(),
      tJ = Rh(),
      rJ = Dh(),
      nJ = IA();
    function iJ(e) {
      var t = rJ(e),
        r = nJ[t];
      if (typeof r != "function" || !(t in eJ.prototype)) return !1;
      if (e === r) return !0;
      var n = tJ(r);
      return !!n && e === n[0];
    }
    TA.exports = iJ;
  });
  var wA = E((ohe, CA) => {
    var AA = Fs(),
      aJ = iA(),
      sJ = Rh(),
      qh = Dh(),
      oJ = ke(),
      PA = xA(),
      lJ = "Expected a function",
      uJ = 8,
      hJ = 32,
      cJ = 128,
      fJ = 256;
    function pJ(e) {
      return aJ(function (t) {
        var r = t.length,
          n = r,
          i = AA.prototype.thru;
        for (e && t.reverse(); n--; ) {
          var a = t[n];
          if (typeof a != "function") throw new TypeError(lJ);
          if (i && !s && qh(a) == "wrapper") var s = new AA([], !0);
        }
        for (n = s ? n : r; ++n < r; ) {
          a = t[n];
          var o = qh(a),
            l = o == "wrapper" ? sJ(a) : void 0;
          l &&
          PA(l[0]) &&
          l[1] == (cJ | uJ | hJ | fJ) &&
          !l[4].length &&
          l[9] == 1
            ? (s = s[qh(l[0])].apply(s, l[3]))
            : (s = a.length == 1 && PA(a) ? s[o]() : s.thru(a));
        }
        return function () {
          var f = arguments,
            u = f[0];
          if (s && f.length == 1 && oJ(u)) return s.plant(u).value();
          for (var c = 0, v = r ? t[c].apply(this, f) : u; ++c < r; )
            v = t[c].call(this, v);
          return v;
        };
      });
    }
    CA.exports = pJ;
  });
  var OA = E((lhe, MA) => {
    var dJ = wA(),
      mJ = dJ();
    MA.exports = mJ;
  });
  var DA = E((uhe, RA) => {
    function vJ(e, t, r) {
      return (
        e === e &&
          (r !== void 0 && (e = e <= r ? e : r),
          t !== void 0 && (e = e >= t ? e : t)),
        e
      );
    }
    RA.exports = vJ;
  });
  var FA = E((hhe, qA) => {
    var gJ = DA(),
      Fh = ra();
    function yJ(e, t, r) {
      return (
        r === void 0 && ((r = t), (t = void 0)),
        r !== void 0 && ((r = Fh(r)), (r = r === r ? r : 0)),
        t !== void 0 && ((t = Fh(t)), (t = t === t ? t : 0)),
        gJ(Fh(e), t, r)
      );
    }
    qA.exports = yJ;
  });
  var JA = E((js) => {
    "use strict";
    var zs = st().default;
    Object.defineProperty(js, "__esModule", { value: !0 });
    js.default = void 0;
    var mt = zs(Sr()),
      EJ = zs(OA()),
      _J = zs(ea()),
      bJ = zs(FA()),
      Vr = nt(),
      Lh = Vh(),
      Bs = Rs(),
      SJ = Br(),
      {
        MOUSE_CLICK: IJ,
        MOUSE_SECOND_CLICK: TJ,
        MOUSE_DOWN: xJ,
        MOUSE_UP: AJ,
        MOUSE_OVER: PJ,
        MOUSE_OUT: CJ,
        DROPDOWN_CLOSE: wJ,
        DROPDOWN_OPEN: MJ,
        SLIDER_ACTIVE: OJ,
        SLIDER_INACTIVE: RJ,
        TAB_ACTIVE: DJ,
        TAB_INACTIVE: qJ,
        NAVBAR_CLOSE: FJ,
        NAVBAR_OPEN: LJ,
        MOUSE_MOVE: NJ,
        PAGE_SCROLL_DOWN: HA,
        SCROLL_INTO_VIEW: WA,
        SCROLL_OUT_OF_VIEW: kJ,
        PAGE_SCROLL_UP: BJ,
        SCROLLING_IN_VIEW: VJ,
        PAGE_FINISH: XA,
        ECOMMERCE_CART_CLOSE: GJ,
        ECOMMERCE_CART_OPEN: zJ,
        PAGE_START: UA,
        PAGE_SCROLL: jJ,
      } = Vr.EventTypeConsts,
      Nh = "COMPONENT_ACTIVE",
      $A = "COMPONENT_INACTIVE",
      { COLON_DELIMITER: LA } = Vr.IX2EngineConstants,
      { getNamespacedParameterId: NA } = SJ.IX2VanillaUtils,
      KA = (e) => (t) => (typeof t == "object" && e(t) ? !0 : t),
      Ri = KA(({ element: e, nativeEvent: t }) => e === t.target),
      HJ = KA(({ element: e, nativeEvent: t }) => e.contains(t.target)),
      Gt = (0, EJ.default)([Ri, HJ]),
      YA = (e, t) => {
        if (t) {
          let { ixData: r } = e.getState(),
            { events: n } = r,
            i = n[t];
          if (i && !XJ[i.eventTypeId]) return i;
        }
        return null;
      },
      WJ = ({ store: e, event: t }) => {
        let { action: r } = t,
          { autoStopEventId: n } = r.config;
        return !!YA(e, n);
      },
      at = ({ store: e, event: t, element: r, eventStateKey: n }, i) => {
        let { action: a, id: s } = t,
          { actionListId: o, autoStopEventId: l } = a.config,
          f = YA(e, l);
        return (
          f &&
            (0, Lh.stopActionGroup)({
              store: e,
              eventId: l,
              eventTarget: r,
              eventStateKey: l + LA + n.split(LA)[1],
              actionListId: (0, _J.default)(f, "action.config.actionListId"),
            }),
          (0, Lh.stopActionGroup)({
            store: e,
            eventId: s,
            eventTarget: r,
            eventStateKey: n,
            actionListId: o,
          }),
          (0, Lh.startActionGroup)({
            store: e,
            eventId: s,
            eventTarget: r,
            eventStateKey: n,
            actionListId: o,
          }),
          i
        );
      },
      xt = (e, t) => (r, n) => (e(r, n) === !0 ? t(r, n) : n),
      Di = { handler: xt(Gt, at) },
      QA = (0, mt.default)({}, Di, { types: [Nh, $A].join(" ") }),
      kh = [
        { target: window, types: "resize orientationchange", throttle: !0 },
        {
          target: document,
          types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
          throttle: !0,
        },
      ],
      kA = "mouseover mouseout",
      Bh = { types: kh },
      XJ = { PAGE_START: UA, PAGE_FINISH: XA },
      Oi = (() => {
        let e = window.pageXOffset !== void 0,
          r =
            document.compatMode === "CSS1Compat"
              ? document.documentElement
              : document.body;
        return () => ({
          scrollLeft: e ? window.pageXOffset : r.scrollLeft,
          scrollTop: e ? window.pageYOffset : r.scrollTop,
          stiffScrollTop: (0, bJ.default)(
            e ? window.pageYOffset : r.scrollTop,
            0,
            r.scrollHeight - window.innerHeight,
          ),
          scrollWidth: r.scrollWidth,
          scrollHeight: r.scrollHeight,
          clientWidth: r.clientWidth,
          clientHeight: r.clientHeight,
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        });
      })(),
      UJ = (e, t) =>
        !(
          e.left > t.right ||
          e.right < t.left ||
          e.top > t.bottom ||
          e.bottom < t.top
        ),
      $J = ({ element: e, nativeEvent: t }) => {
        let { type: r, target: n, relatedTarget: i } = t,
          a = e.contains(n);
        if (r === "mouseover" && a) return !0;
        let s = e.contains(i);
        return !!(r === "mouseout" && a && s);
      },
      KJ = (e) => {
        let {
            element: t,
            event: { config: r },
          } = e,
          { clientWidth: n, clientHeight: i } = Oi(),
          a = r.scrollOffsetValue,
          l = r.scrollOffsetUnit === "PX" ? a : (i * (a || 0)) / 100;
        return UJ(t.getBoundingClientRect(), {
          left: 0,
          top: l,
          right: n,
          bottom: i - l,
        });
      },
      ZA = (e) => (t, r) => {
        let { type: n } = t.nativeEvent,
          i = [Nh, $A].indexOf(n) !== -1 ? n === Nh : r.isActive,
          a = (0, mt.default)({}, r, { isActive: i });
        return ((!r || a.isActive !== r.isActive) && e(t, a)) || a;
      },
      BA = (e) => (t, r) => {
        let n = { elementHovered: $J(t) };
        return (
          ((r ? n.elementHovered !== r.elementHovered : n.elementHovered) &&
            e(t, n)) ||
          n
        );
      },
      YJ = (e) => (t, r) => {
        let n = (0, mt.default)({}, r, { elementVisible: KJ(t) });
        return (
          ((r ? n.elementVisible !== r.elementVisible : n.elementVisible) &&
            e(t, n)) ||
          n
        );
      },
      VA =
        (e) =>
        (t, r = {}) => {
          let { stiffScrollTop: n, scrollHeight: i, innerHeight: a } = Oi(),
            {
              event: { config: s, eventTypeId: o },
            } = t,
            { scrollOffsetValue: l, scrollOffsetUnit: f } = s,
            u = f === "PX",
            c = i - a,
            v = Number((n / c).toFixed(2));
          if (r && r.percentTop === v) return r;
          let d = (u ? l : (a * (l || 0)) / 100) / c,
            p,
            m,
            h = 0;
          r &&
            ((p = v > r.percentTop),
            (m = r.scrollingDown !== p),
            (h = m ? v : r.anchorTop));
          let g = o === HA ? v >= h + d : v <= h - d,
            y = (0, mt.default)({}, r, {
              percentTop: v,
              inBounds: g,
              anchorTop: h,
              scrollingDown: p,
            });
          return (r && g && (m || y.inBounds !== r.inBounds) && e(t, y)) || y;
        },
      QJ = (e, t) =>
        e.left > t.left &&
        e.left < t.right &&
        e.top > t.top &&
        e.top < t.bottom,
      ZJ = (e) => (t, r) => {
        let n = { finished: document.readyState === "complete" };
        return n.finished && !(r && r.finshed) && e(t), n;
      },
      JJ = (e) => (t, r) => {
        let n = { started: !0 };
        return r || e(t), n;
      },
      GA =
        (e) =>
        (t, r = { clickCount: 0 }) => {
          let n = { clickCount: (r.clickCount % 2) + 1 };
          return (n.clickCount !== r.clickCount && e(t, n)) || n;
        },
      Vs = (e = !0) =>
        (0, mt.default)({}, QA, {
          handler: xt(
            e ? Gt : Ri,
            ZA((t, r) => (r.isActive ? Di.handler(t, r) : r)),
          ),
        }),
      Gs = (e = !0) =>
        (0, mt.default)({}, QA, {
          handler: xt(
            e ? Gt : Ri,
            ZA((t, r) => (r.isActive ? r : Di.handler(t, r))),
          ),
        }),
      zA = (0, mt.default)({}, Bh, {
        handler: YJ((e, t) => {
          let { elementVisible: r } = t,
            { event: n, store: i } = e,
            { ixData: a } = i.getState(),
            { events: s } = a;
          return !s[n.action.config.autoStopEventId] && t.triggered
            ? t
            : (n.eventTypeId === WA) === r
              ? (at(e), (0, mt.default)({}, t, { triggered: !0 }))
              : t;
        }),
      }),
      jA = 0.05,
      eee = {
        [OJ]: Vs(),
        [RJ]: Gs(),
        [MJ]: Vs(),
        [wJ]: Gs(),
        [LJ]: Vs(!1),
        [FJ]: Gs(!1),
        [DJ]: Vs(),
        [qJ]: Gs(),
        [zJ]: { types: "ecommerce-cart-open", handler: xt(Gt, at) },
        [GJ]: { types: "ecommerce-cart-close", handler: xt(Gt, at) },
        [IJ]: {
          types: "click",
          handler: xt(
            Gt,
            GA((e, { clickCount: t }) => {
              WJ(e) ? t === 1 && at(e) : at(e);
            }),
          ),
        },
        [TJ]: {
          types: "click",
          handler: xt(
            Gt,
            GA((e, { clickCount: t }) => {
              t === 2 && at(e);
            }),
          ),
        },
        [xJ]: (0, mt.default)({}, Di, { types: "mousedown" }),
        [AJ]: (0, mt.default)({}, Di, { types: "mouseup" }),
        [PJ]: {
          types: kA,
          handler: xt(
            Gt,
            BA((e, t) => {
              t.elementHovered && at(e);
            }),
          ),
        },
        [CJ]: {
          types: kA,
          handler: xt(
            Gt,
            BA((e, t) => {
              t.elementHovered || at(e);
            }),
          ),
        },
        [NJ]: {
          types: "mousemove mouseout scroll",
          handler: (
            {
              store: e,
              element: t,
              eventConfig: r,
              nativeEvent: n,
              eventStateKey: i,
            },
            a = { clientX: 0, clientY: 0, pageX: 0, pageY: 0 },
          ) => {
            let {
                basedOn: s,
                selectedAxis: o,
                continuousParameterGroupId: l,
                reverse: f,
                restingState: u = 0,
              } = r,
              {
                clientX: c = a.clientX,
                clientY: v = a.clientY,
                pageX: d = a.pageX,
                pageY: p = a.pageY,
              } = n,
              m = o === "X_AXIS",
              h = n.type === "mouseout",
              g = u / 100,
              y = l,
              _ = !1;
            switch (s) {
              case Vr.EventBasedOn.VIEWPORT: {
                g = m
                  ? Math.min(c, window.innerWidth) / window.innerWidth
                  : Math.min(v, window.innerHeight) / window.innerHeight;
                break;
              }
              case Vr.EventBasedOn.PAGE: {
                let {
                  scrollLeft: b,
                  scrollTop: I,
                  scrollWidth: P,
                  scrollHeight: S,
                } = Oi();
                g = m ? Math.min(b + d, P) / P : Math.min(I + p, S) / S;
                break;
              }
              case Vr.EventBasedOn.ELEMENT:
              default: {
                y = NA(i, l);
                let b = n.type.indexOf("mouse") === 0;
                if (b && Gt({ element: t, nativeEvent: n }) !== !0) break;
                let I = t.getBoundingClientRect(),
                  { left: P, top: S, width: A, height: R } = I;
                if (!b && !QJ({ left: c, top: v }, I)) break;
                (_ = !0), (g = m ? (c - P) / A : (v - S) / R);
                break;
              }
            }
            return (
              h && (g > 1 - jA || g < jA) && (g = Math.round(g)),
              (s !== Vr.EventBasedOn.ELEMENT || _ || _ !== a.elementHovered) &&
                ((g = f ? 1 - g : g),
                e.dispatch((0, Bs.parameterChanged)(y, g))),
              { elementHovered: _, clientX: c, clientY: v, pageX: d, pageY: p }
            );
          },
        },
        [jJ]: {
          types: kh,
          handler: ({ store: e, eventConfig: t }) => {
            let { continuousParameterGroupId: r, reverse: n } = t,
              { scrollTop: i, scrollHeight: a, clientHeight: s } = Oi(),
              o = i / (a - s);
            (o = n ? 1 - o : o), e.dispatch((0, Bs.parameterChanged)(r, o));
          },
        },
        [VJ]: {
          types: kh,
          handler: (
            { element: e, store: t, eventConfig: r, eventStateKey: n },
            i = { scrollPercent: 0 },
          ) => {
            let {
                scrollLeft: a,
                scrollTop: s,
                scrollWidth: o,
                scrollHeight: l,
                clientHeight: f,
              } = Oi(),
              {
                basedOn: u,
                selectedAxis: c,
                continuousParameterGroupId: v,
                startsEntering: d,
                startsExiting: p,
                addEndOffset: m,
                addStartOffset: h,
                addOffsetValue: g = 0,
                endOffsetValue: y = 0,
              } = r,
              _ = c === "X_AXIS";
            if (u === Vr.EventBasedOn.VIEWPORT) {
              let b = _ ? a / o : s / l;
              return (
                b !== i.scrollPercent &&
                  t.dispatch((0, Bs.parameterChanged)(v, b)),
                { scrollPercent: b }
              );
            } else {
              let b = NA(n, v),
                I = e.getBoundingClientRect(),
                P = (h ? g : 0) / 100,
                S = (m ? y : 0) / 100;
              (P = d ? P : 1 - P), (S = p ? S : 1 - S);
              let A = I.top + Math.min(I.height * P, f),
                w = I.top + I.height * S - A,
                C = Math.min(f + w, l),
                M = Math.min(Math.max(0, f - A), C) / C;
              return (
                M !== i.scrollPercent &&
                  t.dispatch((0, Bs.parameterChanged)(b, M)),
                { scrollPercent: M }
              );
            }
          },
        },
        [WA]: zA,
        [kJ]: zA,
        [HA]: (0, mt.default)({}, Bh, {
          handler: VA((e, t) => {
            t.scrollingDown && at(e);
          }),
        }),
        [BJ]: (0, mt.default)({}, Bh, {
          handler: VA((e, t) => {
            t.scrollingDown || at(e);
          }),
        }),
        [XA]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: xt(Ri, ZJ(at)),
        },
        [UA]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: xt(Ri, JJ(at)),
        },
      };
    js.default = eee;
  });
  var Vh = E((_r) => {
    "use strict";
    var Pt = st().default,
      tee = Fr().default;
    Object.defineProperty(_r, "__esModule", { value: !0 });
    _r.observeRequests = Oee;
    _r.startActionGroup = Xh;
    _r.startEngine = $s;
    _r.stopActionGroup = Wh;
    _r.stopAllActionGroups = lP;
    _r.stopEngine = Ks;
    var ree = Pt(Sr()),
      nee = Pt(vT()),
      iee = Pt(ih()),
      Er = Pt(ea()),
      aee = Pt(FT()),
      see = Pt(ox()),
      oee = Pt(ux()),
      lee = Pt(cx()),
      qi = Pt(gx()),
      uee = Pt(Tx()),
      At = nt(),
      rP = Br(),
      Ce = Rs(),
      De = tee(wx()),
      hee = Pt(JA()),
      cee = ["store", "computedStyle"],
      fee = Object.keys(At.QuickEffectIds),
      Gh = (e) => fee.includes(e),
      {
        COLON_DELIMITER: zh,
        BOUNDARY_SELECTOR: Hs,
        HTML_ELEMENT: nP,
        RENDER_GENERAL: pee,
        W_MOD_IX: eP,
      } = At.IX2EngineConstants,
      {
        getAffectedElements: Ws,
        getElementId: dee,
        getDestinationValues: jh,
        observeStore: Gr,
        getInstanceId: mee,
        renderHTMLElement: vee,
        clearAllStyles: iP,
        getMaxDurationItemIndex: gee,
        getComputedStyle: yee,
        getInstanceOrigin: Eee,
        reduceListToGroup: _ee,
        shouldNamespaceEventParameter: bee,
        getNamespacedParameterId: See,
        shouldAllowMediaQuery: Xs,
        cleanupHTMLElement: Iee,
        clearObjectCache: Tee,
        stringifyTarget: xee,
        mediaQueriesEqual: Aee,
        shallowEqual: Pee,
      } = rP.IX2VanillaUtils,
      {
        isPluginType: Us,
        createPluginInstance: Hh,
        getPluginDuration: Cee,
      } = rP.IX2VanillaPlugins,
      tP = navigator.userAgent,
      wee = tP.match(/iPad/i) || tP.match(/iPhone/),
      Mee = 12;
    function Oee(e) {
      Gr({ store: e, select: ({ ixRequest: t }) => t.preview, onChange: qee }),
        Gr({
          store: e,
          select: ({ ixRequest: t }) => t.playback,
          onChange: Fee,
        }),
        Gr({ store: e, select: ({ ixRequest: t }) => t.stop, onChange: Lee }),
        Gr({ store: e, select: ({ ixRequest: t }) => t.clear, onChange: Nee });
    }
    function Ree(e) {
      Gr({
        store: e,
        select: ({ ixSession: t }) => t.mediaQueryKey,
        onChange: () => {
          Ks(e),
            iP({ store: e, elementApi: De }),
            $s({ store: e, allowEvents: !0 }),
            aP();
        },
      });
    }
    function Dee(e, t) {
      let r = Gr({
        store: e,
        select: ({ ixSession: n }) => n.tick,
        onChange: (n) => {
          t(n), r();
        },
      });
    }
    function qee({ rawData: e, defer: t }, r) {
      let n = () => {
        $s({ store: r, rawData: e, allowEvents: !0 }), aP();
      };
      t ? setTimeout(n, 0) : n();
    }
    function aP() {
      document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
    }
    function Fee(e, t) {
      let {
          actionTypeId: r,
          actionListId: n,
          actionItemId: i,
          eventId: a,
          allowEvents: s,
          immediate: o,
          testManual: l,
          verbose: f = !0,
        } = e,
        { rawData: u } = e;
      if (n && i && u && o) {
        let c = u.actionLists[n];
        c && (u = _ee({ actionList: c, actionItemId: i, rawData: u }));
      }
      if (
        ($s({ store: t, rawData: u, allowEvents: s, testManual: l }),
        (n && r === At.ActionTypeConsts.GENERAL_START_ACTION) || Gh(r))
      ) {
        Wh({ store: t, actionListId: n }),
          oP({ store: t, actionListId: n, eventId: a });
        let c = Xh({
          store: t,
          eventId: a,
          actionListId: n,
          immediate: o,
          verbose: f,
        });
        f &&
          c &&
          t.dispatch(
            (0, Ce.actionListPlaybackChanged)({
              actionListId: n,
              isPlaying: !o,
            }),
          );
      }
    }
    function Lee({ actionListId: e }, t) {
      e ? Wh({ store: t, actionListId: e }) : lP({ store: t }), Ks(t);
    }
    function Nee(e, t) {
      Ks(t), iP({ store: t, elementApi: De });
    }
    function $s({ store: e, rawData: t, allowEvents: r, testManual: n }) {
      let { ixSession: i } = e.getState();
      t && e.dispatch((0, Ce.rawDataImported)(t)),
        i.active ||
          (e.dispatch(
            (0, Ce.sessionInitialized)({
              hasBoundaryNodes: !!document.querySelector(Hs),
              reducedMotion:
                document.body.hasAttribute("data-wf-ix-vacation") &&
                window.matchMedia("(prefers-reduced-motion)").matches,
            }),
          ),
          r &&
            (jee(e),
            kee(),
            e.getState().ixSession.hasDefinedMediaQueries && Ree(e)),
          e.dispatch((0, Ce.sessionStarted)()),
          Bee(e, n));
    }
    function kee() {
      let { documentElement: e } = document;
      e.className.indexOf(eP) === -1 && (e.className += ` ${eP}`);
    }
    function Bee(e, t) {
      let r = (n) => {
        let { ixSession: i, ixParameters: a } = e.getState();
        i.active &&
          (e.dispatch((0, Ce.animationFrameChanged)(n, a)),
          t ? Dee(e, r) : requestAnimationFrame(r));
      };
      r(window.performance.now());
    }
    function Ks(e) {
      let { ixSession: t } = e.getState();
      if (t.active) {
        let { eventListeners: r } = t;
        r.forEach(Vee), Tee(), e.dispatch((0, Ce.sessionStopped)());
      }
    }
    function Vee({ target: e, listenerParams: t }) {
      e.removeEventListener.apply(e, t);
    }
    function Gee({
      store: e,
      eventStateKey: t,
      eventTarget: r,
      eventId: n,
      eventConfig: i,
      actionListId: a,
      parameterGroup: s,
      smoothing: o,
      restingValue: l,
    }) {
      let { ixData: f, ixSession: u } = e.getState(),
        { events: c } = f,
        v = c[n],
        { eventTypeId: d } = v,
        p = {},
        m = {},
        h = [],
        { continuousActionGroups: g } = s,
        { id: y } = s;
      bee(d, i) && (y = See(t, y));
      let _ = u.hasBoundaryNodes && r ? De.getClosestElement(r, Hs) : null;
      g.forEach((b) => {
        let { keyframe: I, actionItems: P } = b;
        P.forEach((S) => {
          let { actionTypeId: A } = S,
            { target: R } = S.config;
          if (!R) return;
          let w = R.boundaryMode ? _ : null,
            C = xee(R) + zh + A;
          if (((m[C] = zee(m[C], I, S)), !p[C])) {
            p[C] = !0;
            let { config: D } = S;
            Ws({
              config: D,
              event: v,
              eventTarget: r,
              elementRoot: w,
              elementApi: De,
            }).forEach((M) => {
              h.push({ element: M, key: C });
            });
          }
        });
      }),
        h.forEach(({ element: b, key: I }) => {
          let P = m[I],
            S = (0, Er.default)(P, "[0].actionItems[0]", {}),
            { actionTypeId: A } = S,
            R = Us(A) ? Hh(A)(b, S) : null,
            w = jh({ element: b, actionItem: S, elementApi: De }, R);
          Uh({
            store: e,
            element: b,
            eventId: n,
            actionListId: a,
            actionItem: S,
            destination: w,
            continuous: !0,
            parameterId: y,
            actionGroups: P,
            smoothing: o,
            restingValue: l,
            pluginInstance: R,
          });
        });
    }
    function zee(e = [], t, r) {
      let n = [...e],
        i;
      return (
        n.some((a, s) => (a.keyframe === t ? ((i = s), !0) : !1)),
        i == null && ((i = n.length), n.push({ keyframe: t, actionItems: [] })),
        n[i].actionItems.push(r),
        n
      );
    }
    function jee(e) {
      let { ixData: t } = e.getState(),
        { eventTypeMap: r } = t;
      sP(e),
        (0, qi.default)(r, (i, a) => {
          let s = hee.default[a];
          if (!s) {
            console.warn(`IX2 event type not configured: ${a}`);
            return;
          }
          Kee({ logic: s, store: e, events: i });
        });
      let { ixSession: n } = e.getState();
      n.eventListeners.length && Wee(e);
    }
    var Hee = ["resize", "orientationchange"];
    function Wee(e) {
      let t = () => {
        sP(e);
      };
      Hee.forEach((r) => {
        window.addEventListener(r, t),
          e.dispatch((0, Ce.eventListenerAdded)(window, [r, t]));
      }),
        t();
    }
    function sP(e) {
      let { ixSession: t, ixData: r } = e.getState(),
        n = window.innerWidth;
      if (n !== t.viewportWidth) {
        let { mediaQueries: i } = r;
        e.dispatch((0, Ce.viewportWidthChanged)({ width: n, mediaQueries: i }));
      }
    }
    var Xee = (e, t) => (0, see.default)((0, lee.default)(e, t), oee.default),
      Uee = (e, t) => {
        (0, qi.default)(e, (r, n) => {
          r.forEach((i, a) => {
            let s = n + zh + a;
            t(i, n, s);
          });
        });
      },
      $ee = (e) => {
        let t = { target: e.target, targets: e.targets };
        return Ws({ config: t, elementApi: De });
      };
    function Kee({ logic: e, store: t, events: r }) {
      Yee(r);
      let { types: n, handler: i } = e,
        { ixData: a } = t.getState(),
        { actionLists: s } = a,
        o = Xee(r, $ee);
      if (!(0, aee.default)(o)) return;
      (0, qi.default)(o, (c, v) => {
        let d = r[v],
          { action: p, id: m, mediaQueries: h = a.mediaQueryKeys } = d,
          { actionListId: g } = p.config;
        Aee(h, a.mediaQueryKeys) || t.dispatch((0, Ce.mediaQueriesDefined)()),
          p.actionTypeId === At.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION &&
            (Array.isArray(d.config) ? d.config : [d.config]).forEach((_) => {
              let { continuousParameterGroupId: b } = _,
                I = (0, Er.default)(s, `${g}.continuousParameterGroups`, []),
                P = (0, iee.default)(I, ({ id: R }) => R === b),
                S = (_.smoothing || 0) / 100,
                A = (_.restingState || 0) / 100;
              P &&
                c.forEach((R, w) => {
                  let C = m + zh + w;
                  Gee({
                    store: t,
                    eventStateKey: C,
                    eventTarget: R,
                    eventId: m,
                    eventConfig: _,
                    actionListId: g,
                    parameterGroup: P,
                    smoothing: S,
                    restingValue: A,
                  });
                });
            }),
          (p.actionTypeId === At.ActionTypeConsts.GENERAL_START_ACTION ||
            Gh(p.actionTypeId)) &&
            oP({ store: t, actionListId: g, eventId: m });
      });
      let l = (c) => {
          let { ixSession: v } = t.getState();
          Uee(o, (d, p, m) => {
            let h = r[p],
              g = v.eventState[m],
              { action: y, mediaQueries: _ = a.mediaQueryKeys } = h;
            if (!Xs(_, v.mediaQueryKey)) return;
            let b = (I = {}) => {
              let P = i(
                {
                  store: t,
                  element: d,
                  event: h,
                  eventConfig: I,
                  nativeEvent: c,
                  eventStateKey: m,
                },
                g,
              );
              Pee(P, g) || t.dispatch((0, Ce.eventStateChanged)(m, P));
            };
            y.actionTypeId === At.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION
              ? (Array.isArray(h.config) ? h.config : [h.config]).forEach(b)
              : b();
          });
        },
        f = (0, uee.default)(l, Mee),
        u = ({ target: c = document, types: v, throttle: d }) => {
          v.split(" ")
            .filter(Boolean)
            .forEach((p) => {
              let m = d ? f : l;
              c.addEventListener(p, m),
                t.dispatch((0, Ce.eventListenerAdded)(c, [p, m]));
            });
        };
      Array.isArray(n) ? n.forEach(u) : typeof n == "string" && u(e);
    }
    function Yee(e) {
      if (!wee) return;
      let t = {},
        r = "";
      for (let n in e) {
        let { eventTypeId: i, target: a } = e[n],
          s = De.getQuerySelector(a);
        t[s] ||
          ((i === At.EventTypeConsts.MOUSE_CLICK ||
            i === At.EventTypeConsts.MOUSE_SECOND_CLICK) &&
            ((t[s] = !0),
            (r += s + "{cursor: pointer;touch-action: manipulation;}")));
      }
      if (r) {
        let n = document.createElement("style");
        (n.textContent = r), document.body.appendChild(n);
      }
    }
    function oP({ store: e, actionListId: t, eventId: r }) {
      let { ixData: n, ixSession: i } = e.getState(),
        { actionLists: a, events: s } = n,
        o = s[r],
        l = a[t];
      if (l && l.useFirstGroupAsInitialState) {
        let f = (0, Er.default)(l, "actionItemGroups[0].actionItems", []),
          u = (0, Er.default)(o, "mediaQueries", n.mediaQueryKeys);
        if (!Xs(u, i.mediaQueryKey)) return;
        f.forEach((c) => {
          var v;
          let { config: d, actionTypeId: p } = c,
            m =
              (d == null || (v = d.target) === null || v === void 0
                ? void 0
                : v.useEventTarget) === !0
                ? { target: o.target, targets: o.targets }
                : d,
            h = Ws({ config: m, event: o, elementApi: De }),
            g = Us(p);
          h.forEach((y) => {
            let _ = g ? Hh(p)(y, c) : null;
            Uh({
              destination: jh({ element: y, actionItem: c, elementApi: De }, _),
              immediate: !0,
              store: e,
              element: y,
              eventId: r,
              actionItem: c,
              actionListId: t,
              pluginInstance: _,
            });
          });
        });
      }
    }
    function lP({ store: e }) {
      let { ixInstances: t } = e.getState();
      (0, qi.default)(t, (r) => {
        if (!r.continuous) {
          let { actionListId: n, verbose: i } = r;
          $h(r, e),
            i &&
              e.dispatch(
                (0, Ce.actionListPlaybackChanged)({
                  actionListId: n,
                  isPlaying: !1,
                }),
              );
        }
      });
    }
    function Wh({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: i,
    }) {
      let { ixInstances: a, ixSession: s } = e.getState(),
        o = s.hasBoundaryNodes && r ? De.getClosestElement(r, Hs) : null;
      (0, qi.default)(a, (l) => {
        let f = (0, Er.default)(l, "actionItem.config.target.boundaryMode"),
          u = n ? l.eventStateKey === n : !0;
        if (l.actionListId === i && l.eventId === t && u) {
          if (o && f && !De.elementContains(o, l.element)) return;
          $h(l, e),
            l.verbose &&
              e.dispatch(
                (0, Ce.actionListPlaybackChanged)({
                  actionListId: i,
                  isPlaying: !1,
                }),
              );
        }
      });
    }
    function Xh({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: i,
      groupIndex: a = 0,
      immediate: s,
      verbose: o,
    }) {
      var l;
      let { ixData: f, ixSession: u } = e.getState(),
        { events: c } = f,
        v = c[t] || {},
        { mediaQueries: d = f.mediaQueryKeys } = v,
        p = (0, Er.default)(f, `actionLists.${i}`, {}),
        { actionItemGroups: m, useFirstGroupAsInitialState: h } = p;
      if (!m || !m.length) return !1;
      a >= m.length && (0, Er.default)(v, "config.loop") && (a = 0),
        a === 0 && h && a++;
      let y =
          (a === 0 || (a === 1 && h)) &&
          Gh((l = v.action) === null || l === void 0 ? void 0 : l.actionTypeId)
            ? v.config.delay
            : void 0,
        _ = (0, Er.default)(m, [a, "actionItems"], []);
      if (!_.length || !Xs(d, u.mediaQueryKey)) return !1;
      let b = u.hasBoundaryNodes && r ? De.getClosestElement(r, Hs) : null,
        I = gee(_),
        P = !1;
      return (
        _.forEach((S, A) => {
          let { config: R, actionTypeId: w } = S,
            C = Us(w),
            { target: D } = R;
          if (!D) return;
          let M = D.boundaryMode ? b : null;
          Ws({
            config: R,
            event: v,
            eventTarget: r,
            elementRoot: M,
            elementApi: De,
          }).forEach((q, B) => {
            let H = C ? Hh(w)(q, S) : null,
              x = C ? Cee(w)(q, S) : null;
            P = !0;
            let L = I === A && B === 0,
              j = yee({ element: q, actionItem: S }),
              Y = jh({ element: q, actionItem: S, elementApi: De }, H);
            Uh({
              store: e,
              element: q,
              actionItem: S,
              eventId: t,
              eventTarget: r,
              eventStateKey: n,
              actionListId: i,
              groupIndex: a,
              isCarrier: L,
              computedStyle: j,
              destination: Y,
              immediate: s,
              verbose: o,
              pluginInstance: H,
              pluginDuration: x,
              instanceDelay: y,
            });
          });
        }),
        P
      );
    }
    function Uh(e) {
      var t;
      let { store: r, computedStyle: n } = e,
        i = (0, nee.default)(e, cee),
        {
          element: a,
          actionItem: s,
          immediate: o,
          pluginInstance: l,
          continuous: f,
          restingValue: u,
          eventId: c,
        } = i,
        v = !f,
        d = mee(),
        { ixElements: p, ixSession: m, ixData: h } = r.getState(),
        g = dee(p, a),
        { refState: y } = p[g] || {},
        _ = De.getRefType(a),
        b = m.reducedMotion && At.ReducedMotionTypes[s.actionTypeId],
        I;
      if (b && f)
        switch (
          (t = h.events[c]) === null || t === void 0 ? void 0 : t.eventTypeId
        ) {
          case At.EventTypeConsts.MOUSE_MOVE:
          case At.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
            I = u;
            break;
          default:
            I = 0.5;
            break;
        }
      let P = Eee(a, y, n, s, De, l);
      if (
        (r.dispatch(
          (0, Ce.instanceAdded)(
            (0, ree.default)(
              {
                instanceId: d,
                elementId: g,
                origin: P,
                refType: _,
                skipMotion: b,
                skipToValue: I,
              },
              i,
            ),
          ),
        ),
        uP(document.body, "ix2-animation-started", d),
        o)
      ) {
        Qee(r, d);
        return;
      }
      Gr({ store: r, select: ({ ixInstances: S }) => S[d], onChange: hP }),
        v && r.dispatch((0, Ce.instanceStarted)(d, m.tick));
    }
    function $h(e, t) {
      uP(document.body, "ix2-animation-stopping", {
        instanceId: e.id,
        state: t.getState(),
      });
      let { elementId: r, actionItem: n } = e,
        { ixElements: i } = t.getState(),
        { ref: a, refType: s } = i[r] || {};
      s === nP && Iee(a, n, De), t.dispatch((0, Ce.instanceRemoved)(e.id));
    }
    function uP(e, t, r) {
      let n = document.createEvent("CustomEvent");
      n.initCustomEvent(t, !0, !0, r), e.dispatchEvent(n);
    }
    function Qee(e, t) {
      let { ixParameters: r } = e.getState();
      e.dispatch((0, Ce.instanceStarted)(t, 0)),
        e.dispatch((0, Ce.animationFrameChanged)(performance.now(), r));
      let { ixInstances: n } = e.getState();
      hP(n[t], e);
    }
    function hP(e, t) {
      let {
          active: r,
          continuous: n,
          complete: i,
          elementId: a,
          actionItem: s,
          actionTypeId: o,
          renderType: l,
          current: f,
          groupIndex: u,
          eventId: c,
          eventTarget: v,
          eventStateKey: d,
          actionListId: p,
          isCarrier: m,
          styleProp: h,
          verbose: g,
          pluginInstance: y,
        } = e,
        { ixData: _, ixSession: b } = t.getState(),
        { events: I } = _,
        P = I[c] || {},
        { mediaQueries: S = _.mediaQueryKeys } = P;
      if (Xs(S, b.mediaQueryKey) && (n || r || i)) {
        if (f || (l === pee && i)) {
          t.dispatch((0, Ce.elementStateChanged)(a, o, f, s));
          let { ixElements: A } = t.getState(),
            { ref: R, refType: w, refState: C } = A[a] || {},
            D = C && C[o];
          (w === nP || Us(o)) && vee(R, C, D, c, s, h, De, l, y);
        }
        if (i) {
          if (m) {
            let A = Xh({
              store: t,
              eventId: c,
              eventTarget: v,
              eventStateKey: d,
              actionListId: p,
              groupIndex: u + 1,
              verbose: g,
            });
            g &&
              !A &&
              t.dispatch(
                (0, Ce.actionListPlaybackChanged)({
                  actionListId: p,
                  isPlaying: !1,
                }),
              );
          }
          $h(e, t);
        }
      }
    }
  });
  var fP = E((er) => {
    "use strict";
    var Zee = Fr().default,
      Jee = st().default;
    Object.defineProperty(er, "__esModule", { value: !0 });
    er.actions = void 0;
    er.destroy = cP;
    er.init = ite;
    er.setEnv = nte;
    er.store = void 0;
    cS();
    var ete = Yu(),
      tte = Jee(mT()),
      Kh = Vh(),
      rte = Zee(Rs());
    er.actions = rte;
    var Ys = (0, ete.createStore)(tte.default);
    er.store = Ys;
    function nte(e) {
      e() && (0, Kh.observeRequests)(Ys);
    }
    function ite(e) {
      cP(), (0, Kh.startEngine)({ store: Ys, rawData: e, allowEvents: !0 });
    }
    function cP() {
      (0, Kh.stopEngine)(Ys);
    }
  });
  var vP = E((dhe, mP) => {
    var pP = zt(),
      dP = fP();
    dP.setEnv(pP.env);
    pP.define(
      "ix2",
      (mP.exports = function () {
        return dP;
      }),
    );
  });
  var yP = E((mhe, gP) => {
    var wn = zt();
    wn.define(
      "links",
      (gP.exports = function (e, t) {
        var r = {},
          n = e(window),
          i,
          a = wn.env(),
          s = window.location,
          o = document.createElement("a"),
          l = "w--current",
          f = /index\.(html|php)$/,
          u = /\/$/,
          c,
          v;
        r.ready = r.design = r.preview = d;
        function d() {
          (i = a && wn.env("design")),
            (v = wn.env("slug") || s.pathname || ""),
            wn.scroll.off(m),
            (c = []);
          for (var g = document.links, y = 0; y < g.length; ++y) p(g[y]);
          c.length && (wn.scroll.on(m), m());
        }
        function p(g) {
          var y =
            (i && g.getAttribute("href-disabled")) || g.getAttribute("href");
          if (((o.href = y), !(y.indexOf(":") >= 0))) {
            var _ = e(g);
            if (
              o.hash.length > 1 &&
              o.host + o.pathname === s.host + s.pathname
            ) {
              if (!/^#[a-zA-Z0-9\-\_]+$/.test(o.hash)) return;
              var b = e(o.hash);
              b.length && c.push({ link: _, sec: b, active: !1 });
              return;
            }
            if (!(y === "#" || y === "")) {
              var I = o.href === s.href || y === v || (f.test(y) && u.test(v));
              h(_, l, I);
            }
          }
        }
        function m() {
          var g = n.scrollTop(),
            y = n.height();
          t.each(c, function (_) {
            var b = _.link,
              I = _.sec,
              P = I.offset().top,
              S = I.outerHeight(),
              A = y * 0.5,
              R = I.is(":visible") && P + S - A >= g && P + A <= g + y;
            _.active !== R && ((_.active = R), h(b, l, R));
          });
        }
        function h(g, y, _) {
          var b = g.hasClass(y);
          (_ && b) || (!_ && !b) || (_ ? g.addClass(y) : g.removeClass(y));
        }
        return r;
      }),
    );
  });
  var _P = E((vhe, EP) => {
    var Qs = zt();
    Qs.define(
      "scroll",
      (EP.exports = function (e) {
        var t = {
            WF_CLICK_EMPTY: "click.wf-empty-link",
            WF_CLICK_SCROLL: "click.wf-scroll",
          },
          r = window.location,
          n = p() ? null : window.history,
          i = e(window),
          a = e(document),
          s = e(document.body),
          o =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (D) {
              window.setTimeout(D, 15);
            },
          l = Qs.env("editor") ? ".w-editor-body" : "body",
          f =
            "header, " +
            l +
            " > .header, " +
            l +
            " > .w-nav:not([data-no-scroll])",
          u = 'a[href="#"]',
          c = 'a[href*="#"]:not(.w-tab-link):not(' + u + ")",
          v = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}',
          d = document.createElement("style");
        d.appendChild(document.createTextNode(v));
        function p() {
          try {
            return !!window.frameElement;
          } catch {
            return !0;
          }
        }
        var m = /^#[a-zA-Z0-9][\w:.-]*$/;
        function h(D) {
          return m.test(D.hash) && D.host + D.pathname === r.host + r.pathname;
        }
        let g =
          typeof window.matchMedia == "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)");
        function y() {
          return (
            document.body.getAttribute("data-wf-scroll-motion") === "none" ||
            g.matches
          );
        }
        function _(D, M) {
          var O;
          switch (M) {
            case "add":
              (O = D.attr("tabindex")),
                O
                  ? D.attr("data-wf-tabindex-swap", O)
                  : D.attr("tabindex", "-1");
              break;
            case "remove":
              (O = D.attr("data-wf-tabindex-swap")),
                O
                  ? (D.attr("tabindex", O),
                    D.removeAttr("data-wf-tabindex-swap"))
                  : D.removeAttr("tabindex");
              break;
          }
          D.toggleClass("wf-force-outline-none", M === "add");
        }
        function b(D) {
          var M = D.currentTarget;
          if (
            !(
              Qs.env("design") ||
              (window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(M.className))
            )
          ) {
            var O = h(M) ? M.hash : "";
            if (O !== "") {
              var q = e(O);
              q.length &&
                (D && (D.preventDefault(), D.stopPropagation()),
                I(O, D),
                window.setTimeout(
                  function () {
                    P(q, function () {
                      _(q, "add"),
                        q.get(0).focus({ preventScroll: !0 }),
                        _(q, "remove");
                    });
                  },
                  D ? 0 : 300,
                ));
            }
          }
        }
        function I(D) {
          if (
            r.hash !== D &&
            n &&
            n.pushState &&
            !(Qs.env.chrome && r.protocol === "file:")
          ) {
            var M = n.state && n.state.hash;
            M !== D && n.pushState({ hash: D }, "", D);
          }
        }
        function P(D, M) {
          var O = i.scrollTop(),
            q = S(D);
          if (O !== q) {
            var B = A(D, O, q),
              H = Date.now(),
              x = function () {
                var L = Date.now() - H;
                window.scroll(0, R(O, q, L, B)),
                  L <= B ? o(x) : typeof M == "function" && M();
              };
            o(x);
          }
        }
        function S(D) {
          var M = e(f),
            O = M.css("position") === "fixed" ? M.outerHeight() : 0,
            q = D.offset().top - O;
          if (D.data("scroll") === "mid") {
            var B = i.height() - O,
              H = D.outerHeight();
            H < B && (q -= Math.round((B - H) / 2));
          }
          return q;
        }
        function A(D, M, O) {
          if (y()) return 0;
          var q = 1;
          return (
            s.add(D).each(function (B, H) {
              var x = parseFloat(H.getAttribute("data-scroll-time"));
              !isNaN(x) && x >= 0 && (q = x);
            }),
            (472.143 * Math.log(Math.abs(M - O) + 125) - 2e3) * q
          );
        }
        function R(D, M, O, q) {
          return O > q ? M : D + (M - D) * w(O / q);
        }
        function w(D) {
          return D < 0.5
            ? 4 * D * D * D
            : (D - 1) * (2 * D - 2) * (2 * D - 2) + 1;
        }
        function C() {
          var { WF_CLICK_EMPTY: D, WF_CLICK_SCROLL: M } = t;
          a.on(M, c, b),
            a.on(D, u, function (O) {
              O.preventDefault();
            }),
            document.head.insertBefore(d, document.head.firstChild);
        }
        return { ready: C };
      }),
    );
  });
  var SP = E((ghe, bP) => {
    var ate = zt();
    ate.define(
      "touch",
      (bP.exports = function (e) {
        var t = {},
          r = window.getSelection;
        (e.event.special.tap = { bindType: "click", delegateType: "click" }),
          (t.init = function (a) {
            return (
              (a = typeof a == "string" ? e(a).get(0) : a), a ? new n(a) : null
            );
          });
        function n(a) {
          var s = !1,
            o = !1,
            l = Math.min(Math.round(window.innerWidth * 0.04), 40),
            f,
            u;
          a.addEventListener("touchstart", c, !1),
            a.addEventListener("touchmove", v, !1),
            a.addEventListener("touchend", d, !1),
            a.addEventListener("touchcancel", p, !1),
            a.addEventListener("mousedown", c, !1),
            a.addEventListener("mousemove", v, !1),
            a.addEventListener("mouseup", d, !1),
            a.addEventListener("mouseout", p, !1);
          function c(h) {
            var g = h.touches;
            (g && g.length > 1) ||
              ((s = !0),
              g ? ((o = !0), (f = g[0].clientX)) : (f = h.clientX),
              (u = f));
          }
          function v(h) {
            if (s) {
              if (o && h.type === "mousemove") {
                h.preventDefault(), h.stopPropagation();
                return;
              }
              var g = h.touches,
                y = g ? g[0].clientX : h.clientX,
                _ = y - u;
              (u = y),
                Math.abs(_) > l &&
                  r &&
                  String(r()) === "" &&
                  (i("swipe", h, { direction: _ > 0 ? "right" : "left" }), p());
            }
          }
          function d(h) {
            if (s && ((s = !1), o && h.type === "mouseup")) {
              h.preventDefault(), h.stopPropagation(), (o = !1);
              return;
            }
          }
          function p() {
            s = !1;
          }
          function m() {
            a.removeEventListener("touchstart", c, !1),
              a.removeEventListener("touchmove", v, !1),
              a.removeEventListener("touchend", d, !1),
              a.removeEventListener("touchcancel", p, !1),
              a.removeEventListener("mousedown", c, !1),
              a.removeEventListener("mousemove", v, !1),
              a.removeEventListener("mouseup", d, !1),
              a.removeEventListener("mouseout", p, !1),
              (a = null);
          }
          this.destroy = m;
        }
        function i(a, s, o) {
          var l = e.Event(a, { originalEvent: s });
          e(s.target).trigger(l, o);
        }
        return (t.instance = t.init(document)), t;
      }),
    );
  });
  kb();
  Bb();
  Vb();
  jb();
  Wb();
  $b();
  tS();
  vP();
  yP();
  _P();
  SP();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require("ix2").init({
  events: {
    "e-339": {
      id: "e-339",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-49",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-340",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".c-faq_trigger",
        originalId: "2194658d-30d3-e21e-921d-f7f27471251c",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".c-faq_trigger",
          originalId: "2194658d-30d3-e21e-921d-f7f27471251c",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1654685744638,
    },
    "e-340": {
      id: "e-340",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-50",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-339",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".c-faq_trigger",
        originalId: "2194658d-30d3-e21e-921d-f7f27471251c",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".c-faq_trigger",
          originalId: "2194658d-30d3-e21e-921d-f7f27471251c",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1654685744639,
    },
    "e-395": {
      id: "e-395",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-396",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|d81effb4-0906-10ec-53bc-057e8d45e28e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|d81effb4-0906-10ec-53bc-057e8d45e28e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690203823107,
    },
    "e-396": {
      id: "e-396",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-395",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|d81effb4-0906-10ec-53bc-057e8d45e28e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|d81effb4-0906-10ec-53bc-057e8d45e28e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690203823108,
    },
    "e-397": {
      id: "e-397",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-398",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|eacc4afb-387a-47b6-cc96-575d120a4ed5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|eacc4afb-387a-47b6-cc96-575d120a4ed5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690204206508,
    },
    "e-398": {
      id: "e-398",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-397",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|eacc4afb-387a-47b6-cc96-575d120a4ed5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|eacc4afb-387a-47b6-cc96-575d120a4ed5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690204206508,
    },
    "e-399": {
      id: "e-399",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-400",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|b2104e3e-1824-bc90-e391-e8afc687138d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|b2104e3e-1824-bc90-e391-e8afc687138d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690204704031,
    },
    "e-400": {
      id: "e-400",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-399",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|b2104e3e-1824-bc90-e391-e8afc687138d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|b2104e3e-1824-bc90-e391-e8afc687138d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690204704031,
    },
    "e-401": {
      id: "e-401",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-57",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-402",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|4b69f515-b631-998f-f787-5da286dc2281",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|4b69f515-b631-998f-f787-5da286dc2281",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690205475863,
    },
    "e-402": {
      id: "e-402",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-401",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|4b69f515-b631-998f-f787-5da286dc2281",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|4b69f515-b631-998f-f787-5da286dc2281",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690205475863,
    },
    "e-403": {
      id: "e-403",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-57",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-404",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|52b200b1-ff37-6da0-5a98-1960320dce18",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|52b200b1-ff37-6da0-5a98-1960320dce18",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690205574681,
    },
    "e-404": {
      id: "e-404",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-403",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|52b200b1-ff37-6da0-5a98-1960320dce18",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|52b200b1-ff37-6da0-5a98-1960320dce18",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690205574681,
    },
    "e-405": {
      id: "e-405",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-58", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|177a8cc8-16be-6c02-0103-c1b222c5c01f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|177a8cc8-16be-6c02-0103-c1b222c5c01f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-58-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: true,
          addOffsetValue: 10,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690291307145,
    },
    "e-480": {
      id: "e-480",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-481",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757b8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757b8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-484": {
      id: "e-484",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-485",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757d1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757d1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-486": {
      id: "e-486",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-487",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|1b19cb40-c33b-d1f5-4d34-ab4fa62ff446",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|1b19cb40-c33b-d1f5-4d34-ab4fa62ff446",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-488": {
      id: "e-488",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-489",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f82f5e9b-8fda-21c6-5c20-1e74b40419f0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f82f5e9b-8fda-21c6-5c20-1e74b40419f0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-490": {
      id: "e-490",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-491",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|67f10006-4713-03f6-e727-2ffba8c48e8e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|67f10006-4713-03f6-e727-2ffba8c48e8e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-492": {
      id: "e-492",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-493",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|36046dc6-00b7-eeca-36db-c9368c2487bd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|36046dc6-00b7-eeca-36db-c9368c2487bd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-494": {
      id: "e-494",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-495",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|3193e821-607b-db4e-2eb8-5e7cc5db08c8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|3193e821-607b-db4e-2eb8-5e7cc5db08c8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-496": {
      id: "e-496",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|e2c5d600-179d-0154-bbf2-f28abce45173",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|e2c5d600-179d-0154-bbf2-f28abce45173",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-497": {
      id: "e-497",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757cf",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757cf",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-498": {
      id: "e-498",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|d595370f-4937-aba2-fdf8-16d7a1e006d2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|d595370f-4937-aba2-fdf8-16d7a1e006d2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-499": {
      id: "e-499",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|1b19cb40-c33b-d1f5-4d34-ab4fa62ff444",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|1b19cb40-c33b-d1f5-4d34-ab4fa62ff444",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-500": {
      id: "e-500",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|55edff51-00a9-40ef-0246-8255af53cafd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|55edff51-00a9-40ef-0246-8255af53cafd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-501": {
      id: "e-501",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f82f5e9b-8fda-21c6-5c20-1e74b40419ee",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f82f5e9b-8fda-21c6-5c20-1e74b40419ee",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-502": {
      id: "e-502",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757b3",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|254dea49-8138-672e-afd1-886df12757b3",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-503": {
      id: "e-503",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|67f10006-4713-03f6-e727-2ffba8c48e8c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|67f10006-4713-03f6-e727-2ffba8c48e8c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 70,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 70,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-504": {
      id: "e-504",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|36046dc6-00b7-eeca-36db-c9368c2487bb",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|36046dc6-00b7-eeca-36db-c9368c2487bb",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-505": {
      id: "e-505",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|3193e821-607b-db4e-2eb8-5e7cc5db08c6",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|3193e821-607b-db4e-2eb8-5e7cc5db08c6",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-506": {
      id: "e-506",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|beae677d-94ee-33c6-cdbf-d9e54ebdab7d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|beae677d-94ee-33c6-cdbf-d9e54ebdab7d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-507": {
      id: "e-507",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|ca416645-e7f6-13a0-9023-6df5cc8e9d5b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|ca416645-e7f6-13a0-9023-6df5cc8e9d5b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-508": {
      id: "e-508",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-52", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f53a8160-4abd-ba86-fab5-cf41024e85d0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f53a8160-4abd-ba86-fab5-cf41024e85d0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-52-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-545": {
      id: "e-545",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-62", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd025",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd025",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-62-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 0,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 65,
        },
      ],
      createdOn: 1690799208282,
    },
    "e-546": {
      id: "e-546",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-547",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd02e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd02e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690799208282,
    },
    "e-548": {
      id: "e-548",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-549",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd038",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|1bff2100-3df3-6c61-854e-fb17511dd038",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690799208282,
    },
    "e-579": {
      id: "e-579",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-64",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-580",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690813283345,
    },
    "e-581": {
      id: "e-581",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-77",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-582",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690813283345,
    },
    "e-582": {
      id: "e-582",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-581",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|19cecff8-7a95-d30c-3834-8a15607cbdf5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690813283345,
    },
    "e-595": {
      id: "e-595",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-81",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-596",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd3",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd3",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693326422051,
    },
    "e-597": {
      id: "e-597",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-76",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-598",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693326422051,
    },
    "e-598": {
      id: "e-598",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-597",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|f6b2275b-e727-152c-c36b-4379cfa43bd4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693326422051,
    },
    "e-599": {
      id: "e-599",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-80",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-600",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|acd9bf1d-3736-a4a2-0fe9-2e681dab910b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|acd9bf1d-3736-a4a2-0fe9-2e681dab910b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693328086856,
    },
    "e-601": {
      id: "e-601",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-79",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-602",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|948faa27-bedc-afe7-0c8f-aa604cf95918",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|948faa27-bedc-afe7-0c8f-aa604cf95918",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693328537006,
    },
    "e-603": {
      id: "e-603",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|3b1ee86c-f491-a683-d13c-29c76c8648ed",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|3b1ee86c-f491-a683-d13c-29c76c8648ed",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693382171264,
    },
    "e-604": {
      id: "e-604",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-605",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|80ed7594-7911-3c43-f71c-9ac48915348e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|80ed7594-7911-3c43-f71c-9ac48915348e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693468862683,
    },
    "e-606": {
      id: "e-606",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-607",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1c4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1c4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693469196414,
    },
    "e-613": {
      id: "e-613",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1bd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1bd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693487649272,
    },
    "e-616": {
      id: "e-616",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-617",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|38399fa0-72ab-4e00-1f72-3f1c74a20e1f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|38399fa0-72ab-4e00-1f72-3f1c74a20e1f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693490739721,
    },
    "e-618": {
      id: "e-618",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-619",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|38399fa0-72ab-4e00-1f72-3f1c74a20e27",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|38399fa0-72ab-4e00-1f72-3f1c74a20e27",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693490739721,
    },
    "e-620": {
      id: "e-620",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-621",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|3ea4ae27-c0d5-fb0a-1ee6-dfe8dba6a7a2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|3ea4ae27-c0d5-fb0a-1ee6-dfe8dba6a7a2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693502851830,
    },
    "e-622": {
      id: "e-622",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-623",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|a42222f2-1056-156d-206f-600778d3d07c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|a42222f2-1056-156d-206f-600778d3d07c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693504308932,
    },
    "e-670": {
      id: "e-670",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-64",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-671",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff00",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff00",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694000900056,
    },
    "e-672": {
      id: "e-672",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-86",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-673",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff01",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff01",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694000900056,
    },
    "e-673": {
      id: "e-673",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-672",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff01",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|8316a001-aea7-4fd3-29ea-e2091b62ff01",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694000900056,
    },
    "e-674": {
      id: "e-674",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-675",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|2354b017-26c6-eb25-03f7-2a336618e05e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|2354b017-26c6-eb25-03f7-2a336618e05e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694002179883,
    },
    "e-708": {
      id: "e-708",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-709",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|ec10b398-f521-f761-f69c-7bdc80162e97",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|ec10b398-f521-f761-f69c-7bdc80162e97",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694095097431,
    },
    "e-710": {
      id: "e-710",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-711",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|d3d48afe-528d-7f1b-5d4f-ada22459c2ef",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|d3d48afe-528d-7f1b-5d4f-ada22459c2ef",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694099814011,
    },
    "e-712": {
      id: "e-712",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-87", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|0d35fb75-7199-0c01-3675-1ea690105b10",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|0d35fb75-7199-0c01-3675-1ea690105b10",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-87-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1694513500235,
    },
    "e-713": {
      id: "e-713",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-714",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8d4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8d4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-715": {
      id: "e-715",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-716",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8d7",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8d7",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-717": {
      id: "e-717",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-718",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8df",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8df",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-719": {
      id: "e-719",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-720",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8e2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8e2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-721": {
      id: "e-721",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-722",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8ea",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8ea",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-723": {
      id: "e-723",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-724",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8ed",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8ed",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-725": {
      id: "e-725",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-726",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8f5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8f5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-727": {
      id: "e-727",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-728",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8f8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|dd397409-e01a-aeac-57df-06a8b1fda8f8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694514733862,
    },
    "e-795": {
      id: "e-795",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-796",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|abfd13d3-8876-303b-7bfd-14aba4b699b6",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|abfd13d3-8876-303b-7bfd-14aba4b699b6",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694619232673,
    },
    "e-797": {
      id: "e-797",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-798",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|abfd13d3-8876-303b-7bfd-14aba4b699bb",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|abfd13d3-8876-303b-7bfd-14aba4b699bb",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694619232673,
    },
    "e-799": {
      id: "e-799",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-800",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|6e180cc9-2f3f-39f8-43f8-95b1fc722838",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|6e180cc9-2f3f-39f8-43f8-95b1fc722838",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694619465288,
    },
    "e-801": {
      id: "e-801",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-802",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e93",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e93",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-803": {
      id: "e-803",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-804",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e97",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e97",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-805": {
      id: "e-805",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-806",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-807": {
      id: "e-807",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-808",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-809": {
      id: "e-809",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-810",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ead",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ead",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-811": {
      id: "e-811",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-812",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eb1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eb1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-813": {
      id: "e-813",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-814",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eba",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eba",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-815": {
      id: "e-815",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-816",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ebe",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ebe",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1694699613376,
    },
    "e-817": {
      id: "e-817",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|3ec2506b-6bcf-636a-03cb-b58f45735e70",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|3ec2506b-6bcf-636a-03cb-b58f45735e70",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1695136253886,
    },
    "e-851": {
      id: "e-851",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-854",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09975c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09975c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-852": {
      id: "e-852",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-857",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099762",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099762",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-855": {
      id: "e-855",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-92", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099722",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099722",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-92-p",
          smoothing: 25,
          startsEntering: false,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1690467131196,
    },
    "e-858": {
      id: "e-858",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-866",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09976f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09976f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-859": {
      id: "e-859",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-856",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09972b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa09972b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-860": {
      id: "e-860",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-853",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099735",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099735",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-861": {
      id: "e-861",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-864",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099750",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099750",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-863": {
      id: "e-863",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-862",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099769",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099769",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-865": {
      id: "e-865",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-850",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099756",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|84e26993-7eea-0295-3e56-cf92aa099756",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690467131196,
    },
    "e-869": {
      id: "e-869",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-870",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a49976f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a49976f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1695377912821,
    },
    "e-871": {
      id: "e-871",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-872",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a499777",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a499777",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1695377912821,
    },
    "e-873": {
      id: "e-873",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-874",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a49977f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|14948d35-7921-9a77-2607-dcf62a49977f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1695377912821,
    },
    "e-907": {
      id: "e-907",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-908",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135d1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135d1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349537847,
    },
    "e-909": {
      id: "e-909",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-910",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135d9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135d9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349537847,
    },
    "e-911": {
      id: "e-911",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-912",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135e1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|cf070013-683d-9a9c-8301-ed7e25e135e1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349537847,
    },
    "e-915": {
      id: "e-915",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-916",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce942b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce942b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349555235,
    },
    "e-919": {
      id: "e-919",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-920",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce943b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce943b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349555235,
    },
    "e-921": {
      id: "e-921",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-922",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce9443",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|62b35efc-a1bf-a776-129b-4d4851ce9443",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349555235,
    },
    "e-925": {
      id: "e-925",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-926",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349566968,
    },
    "e-927": {
      id: "e-927",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-928",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c974",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c974",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349566968,
    },
    "e-931": {
      id: "e-931",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-932",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c984",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|6d0e90b2-2db8-318b-4a6f-15877e80c984",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696349566968,
    },
    "e-933": {
      id: "e-933",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-934",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c82",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c82",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-935": {
      id: "e-935",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-936",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c86",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c86",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-937": {
      id: "e-937",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-938",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c8f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c8f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-939": {
      id: "e-939",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-940",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c93",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c93",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-941": {
      id: "e-941",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-942",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c9c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96c9c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-943": {
      id: "e-943",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-944",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96ca0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96ca0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-945": {
      id: "e-945",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-946",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96ca9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96ca9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-947": {
      id: "e-947",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-948",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96caf",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|42ca1d46-6328-4133-25ad-b5113ff96caf",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696353424385,
    },
    "e-949": {
      id: "e-949",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-950",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|c8b05812-890c-da17-5b31-2b400e62b428",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|c8b05812-890c-da17-5b31-2b400e62b428",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696436555870,
    },
    "e-951": {
      id: "e-951",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-952",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|c8b05812-890c-da17-5b31-2b400e62b42d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|c8b05812-890c-da17-5b31-2b400e62b42d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696436555870,
    },
    "e-953": {
      id: "e-953",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-954",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|fcbd8f68-288b-be6e-83a3-7eb8759876d8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|fcbd8f68-288b-be6e-83a3-7eb8759876d8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696436701475,
    },
    "e-955": {
      id: "e-955",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-956",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|fcbd8f68-288b-be6e-83a3-7eb8759876dd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|fcbd8f68-288b-be6e-83a3-7eb8759876dd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696436701475,
    },
    "e-957": {
      id: "e-957",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-958",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|d81effb4-0906-10ec-53bc-057e8d45e28e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|d81effb4-0906-10ec-53bc-057e8d45e28e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-958": {
      id: "e-958",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-957",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|d81effb4-0906-10ec-53bc-057e8d45e28e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|d81effb4-0906-10ec-53bc-057e8d45e28e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-959": {
      id: "e-959",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-960",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|eacc4afb-387a-47b6-cc96-575d120a4ed5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|eacc4afb-387a-47b6-cc96-575d120a4ed5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-960": {
      id: "e-960",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-959",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|eacc4afb-387a-47b6-cc96-575d120a4ed5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|eacc4afb-387a-47b6-cc96-575d120a4ed5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-961": {
      id: "e-961",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-55",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-962",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|b2104e3e-1824-bc90-e391-e8afc687138d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|b2104e3e-1824-bc90-e391-e8afc687138d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-962": {
      id: "e-962",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-961",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|b2104e3e-1824-bc90-e391-e8afc687138d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|b2104e3e-1824-bc90-e391-e8afc687138d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-963": {
      id: "e-963",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-57",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-964",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|4b69f515-b631-998f-f787-5da286dc2281",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|4b69f515-b631-998f-f787-5da286dc2281",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-964": {
      id: "e-964",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-963",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|4b69f515-b631-998f-f787-5da286dc2281",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|4b69f515-b631-998f-f787-5da286dc2281",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-965": {
      id: "e-965",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-57",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-966",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|52b200b1-ff37-6da0-5a98-1960320dce18",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|52b200b1-ff37-6da0-5a98-1960320dce18",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-966": {
      id: "e-966",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-56",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-965",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|52b200b1-ff37-6da0-5a98-1960320dce18",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|52b200b1-ff37-6da0-5a98-1960320dce18",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-967": {
      id: "e-967",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-58", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|177a8cc8-16be-6c02-0103-c1b222c5c01f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|177a8cc8-16be-6c02-0103-c1b222c5c01f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-58-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 0,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696863735033,
    },
    "e-968": {
      id: "e-968",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-62", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd025",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd025",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-62-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 0,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 65,
        },
      ],
      createdOn: 1696863735033,
    },
    "e-969": {
      id: "e-969",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-970",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd02e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd02e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-971": {
      id: "e-971",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-972",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd038",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|1bff2100-3df3-6c61-854e-fb17511dd038",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-973": {
      id: "e-973",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-64",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-974",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-975": {
      id: "e-975",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-77",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-976",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-976": {
      id: "e-976",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-975",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|19cecff8-7a95-d30c-3834-8a15607cbdf5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-979": {
      id: "e-979",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-980",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-981": {
      id: "e-981",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-982",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c974",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c974",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-983": {
      id: "e-983",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-984",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c984",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|6d0e90b2-2db8-318b-4a6f-15877e80c984",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-985": {
      id: "e-985",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-986",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|fcbd8f68-288b-be6e-83a3-7eb8759876d8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|fcbd8f68-288b-be6e-83a3-7eb8759876d8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-987": {
      id: "e-987",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-988",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|fcbd8f68-288b-be6e-83a3-7eb8759876dd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|fcbd8f68-288b-be6e-83a3-7eb8759876dd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696863735033,
    },
    "e-989": {
      id: "e-989",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-990",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757b8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757b8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-991": {
      id: "e-991",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-992",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757d1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757d1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-993": {
      id: "e-993",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-994",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|1b19cb40-c33b-d1f5-4d34-ab4fa62ff446",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|1b19cb40-c33b-d1f5-4d34-ab4fa62ff446",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-995": {
      id: "e-995",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-996",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f82f5e9b-8fda-21c6-5c20-1e74b40419f0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f82f5e9b-8fda-21c6-5c20-1e74b40419f0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-997": {
      id: "e-997",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-998",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|67f10006-4713-03f6-e727-2ffba8c48e8e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|67f10006-4713-03f6-e727-2ffba8c48e8e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-999": {
      id: "e-999",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1000",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|36046dc6-00b7-eeca-36db-c9368c2487bd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|36046dc6-00b7-eeca-36db-c9368c2487bd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1001": {
      id: "e-1001",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1002",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|3193e821-607b-db4e-2eb8-5e7cc5db08c8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|3193e821-607b-db4e-2eb8-5e7cc5db08c8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1003": {
      id: "e-1003",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|e2c5d600-179d-0154-bbf2-f28abce45173",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|e2c5d600-179d-0154-bbf2-f28abce45173",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1004": {
      id: "e-1004",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757cf",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757cf",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1005": {
      id: "e-1005",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|d595370f-4937-aba2-fdf8-16d7a1e006d2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|d595370f-4937-aba2-fdf8-16d7a1e006d2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1006": {
      id: "e-1006",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|1b19cb40-c33b-d1f5-4d34-ab4fa62ff444",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|1b19cb40-c33b-d1f5-4d34-ab4fa62ff444",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1007": {
      id: "e-1007",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|55edff51-00a9-40ef-0246-8255af53cafd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|55edff51-00a9-40ef-0246-8255af53cafd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1008": {
      id: "e-1008",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f82f5e9b-8fda-21c6-5c20-1e74b40419ee",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f82f5e9b-8fda-21c6-5c20-1e74b40419ee",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1009": {
      id: "e-1009",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757b3",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|254dea49-8138-672e-afd1-886df12757b3",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1010": {
      id: "e-1010",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|67f10006-4713-03f6-e727-2ffba8c48e8c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|67f10006-4713-03f6-e727-2ffba8c48e8c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 70,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 70,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1011": {
      id: "e-1011",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|36046dc6-00b7-eeca-36db-c9368c2487bb",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|36046dc6-00b7-eeca-36db-c9368c2487bb",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1012": {
      id: "e-1012",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|3193e821-607b-db4e-2eb8-5e7cc5db08c6",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|3193e821-607b-db4e-2eb8-5e7cc5db08c6",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1013": {
      id: "e-1013",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|beae677d-94ee-33c6-cdbf-d9e54ebdab7d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|beae677d-94ee-33c6-cdbf-d9e54ebdab7d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1014": {
      id: "e-1014",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|ca416645-e7f6-13a0-9023-6df5cc8e9d5b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|ca416645-e7f6-13a0-9023-6df5cc8e9d5b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1015": {
      id: "e-1015",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-52", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f53a8160-4abd-ba86-fab5-cf41024e85d0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f53a8160-4abd-ba86-fab5-cf41024e85d0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-52-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1017": {
      id: "e-1017",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-81",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1018",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd3",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd3",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1019": {
      id: "e-1019",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-76",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1020",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1020": {
      id: "e-1020",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1019",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|f6b2275b-e727-152c-c36b-4379cfa43bd4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1021": {
      id: "e-1021",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-80",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1022",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|acd9bf1d-3736-a4a2-0fe9-2e681dab910b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|acd9bf1d-3736-a4a2-0fe9-2e681dab910b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1023": {
      id: "e-1023",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-79",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1024",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|948faa27-bedc-afe7-0c8f-aa604cf95918",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|948faa27-bedc-afe7-0c8f-aa604cf95918",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1025": {
      id: "e-1025",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|3b1ee86c-f491-a683-d13c-29c76c8648ed",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|3b1ee86c-f491-a683-d13c-29c76c8648ed",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1026": {
      id: "e-1026",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1027",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|80ed7594-7911-3c43-f71c-9ac48915348e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|80ed7594-7911-3c43-f71c-9ac48915348e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1028": {
      id: "e-1028",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1029",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|394404ac-3f64-7a29-13ec-185ed61fa1c4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|394404ac-3f64-7a29-13ec-185ed61fa1c4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1030": {
      id: "e-1030",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-54", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|394404ac-3f64-7a29-13ec-185ed61fa1bd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|394404ac-3f64-7a29-13ec-185ed61fa1bd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-54-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1031": {
      id: "e-1031",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1032",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|38399fa0-72ab-4e00-1f72-3f1c74a20e1f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|38399fa0-72ab-4e00-1f72-3f1c74a20e1f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1033": {
      id: "e-1033",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1034",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|38399fa0-72ab-4e00-1f72-3f1c74a20e27",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|38399fa0-72ab-4e00-1f72-3f1c74a20e27",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1035": {
      id: "e-1035",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1036",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|3ea4ae27-c0d5-fb0a-1ee6-dfe8dba6a7a2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|3ea4ae27-c0d5-fb0a-1ee6-dfe8dba6a7a2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1037": {
      id: "e-1037",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1038",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|a42222f2-1056-156d-206f-600778d3d07c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|a42222f2-1056-156d-206f-600778d3d07c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1039": {
      id: "e-1039",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1040",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|abfd13d3-8876-303b-7bfd-14aba4b699b6",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|abfd13d3-8876-303b-7bfd-14aba4b699b6",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1041": {
      id: "e-1041",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1042",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|abfd13d3-8876-303b-7bfd-14aba4b699bb",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|abfd13d3-8876-303b-7bfd-14aba4b699bb",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1043": {
      id: "e-1043",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1044",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|6e180cc9-2f3f-39f8-43f8-95b1fc722838",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|6e180cc9-2f3f-39f8-43f8-95b1fc722838",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1045": {
      id: "e-1045",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-51", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|3ec2506b-6bcf-636a-03cb-b58f45735e70",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|3ec2506b-6bcf-636a-03cb-b58f45735e70",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-51-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1046": {
      id: "e-1046",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-92", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099722",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099722",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-92-p",
          smoothing: 25,
          startsEntering: false,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696867451727,
    },
    "e-1047": {
      id: "e-1047",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1048",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099735",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099735",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1049": {
      id: "e-1049",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1050",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099769",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099769",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1051": {
      id: "e-1051",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1052",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09972b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09972b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1053": {
      id: "e-1053",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1054",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099756",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099756",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1055": {
      id: "e-1055",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1056",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099750",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099750",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1057": {
      id: "e-1057",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1058",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099762",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa099762",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1059": {
      id: "e-1059",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1060",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09975c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09975c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1061": {
      id: "e-1061",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-93",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1062",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09976f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|84e26993-7eea-0295-3e56-cf92aa09976f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1063": {
      id: "e-1063",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1064",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49976a",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49976a",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1065": {
      id: "e-1065",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1066",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49976f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49976f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1067": {
      id: "e-1067",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1068",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a499777",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a499777",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1069": {
      id: "e-1069",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1070",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49977f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6524247afa0142fc7f5b77cd|14948d35-7921-9a77-2607-dcf62a49977f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696867451727,
    },
    "e-1071": {
      id: "e-1071",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1072",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|ec10b398-f521-f761-f69c-7bdc80162e97",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|ec10b398-f521-f761-f69c-7bdc80162e97",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1073": {
      id: "e-1073",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1074",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|d3d48afe-528d-7f1b-5d4f-ada22459c2ef",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|d3d48afe-528d-7f1b-5d4f-ada22459c2ef",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1075": {
      id: "e-1075",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-87", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|0d35fb75-7199-0c01-3675-1ea690105b10",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|0d35fb75-7199-0c01-3675-1ea690105b10",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-87-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696925863559,
    },
    "e-1076": {
      id: "e-1076",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1077",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8d4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8d4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1078": {
      id: "e-1078",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1079",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8d7",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8d7",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1080": {
      id: "e-1080",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1081",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8df",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8df",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1082": {
      id: "e-1082",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1083",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8e2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8e2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1084": {
      id: "e-1084",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1085",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8ea",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8ea",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1086": {
      id: "e-1086",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1087",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8ed",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8ed",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1088": {
      id: "e-1088",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1089",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8f5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8f5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1090": {
      id: "e-1090",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1091",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8f8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|dd397409-e01a-aeac-57df-06a8b1fda8f8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1092": {
      id: "e-1092",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1093",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e93",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e93",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1094": {
      id: "e-1094",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1095",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e97",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68e97",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1096": {
      id: "e-1096",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1097",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1098": {
      id: "e-1098",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1099",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ea4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1100": {
      id: "e-1100",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1101",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ead",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ead",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1102": {
      id: "e-1102",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1103",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eb1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eb1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1104": {
      id: "e-1104",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1105",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eba",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68eba",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1106": {
      id: "e-1106",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1107",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ebe",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|44ae3d24-f4b2-c2d9-09d0-3f5ad0c68ebe",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1110": {
      id: "e-1110",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1111",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135d1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135d1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1112": {
      id: "e-1112",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1113",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135d9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135d9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1114": {
      id: "e-1114",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1115",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135e1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|cf070013-683d-9a9c-8301-ed7e25e135e1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1116": {
      id: "e-1116",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1117",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|c8b05812-890c-da17-5b31-2b400e62b428",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|c8b05812-890c-da17-5b31-2b400e62b428",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1118": {
      id: "e-1118",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1119",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|c8b05812-890c-da17-5b31-2b400e62b42d",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|c8b05812-890c-da17-5b31-2b400e62b42d",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696925863559,
    },
    "e-1120": {
      id: "e-1120",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-64",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1121",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff00",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff00",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1122": {
      id: "e-1122",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-86",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1123",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff01",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff01",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1123": {
      id: "e-1123",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-70",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1122",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff01",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|8316a001-aea7-4fd3-29ea-e2091b62ff01",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1124": {
      id: "e-1124",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1125",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|2354b017-26c6-eb25-03f7-2a336618e05e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|2354b017-26c6-eb25-03f7-2a336618e05e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1126": {
      id: "e-1126",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1127",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce9426",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce9426",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1128": {
      id: "e-1128",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1129",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce942b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce942b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1130": {
      id: "e-1130",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1131",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce943b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce943b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1132": {
      id: "e-1132",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1133",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce9443",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|62b35efc-a1bf-a776-129b-4d4851ce9443",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1134": {
      id: "e-1134",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1135",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c82",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c82",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1136": {
      id: "e-1136",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1137",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c86",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c86",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1138": {
      id: "e-1138",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1139",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c8f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c8f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1140": {
      id: "e-1140",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1141",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c93",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c93",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1142": {
      id: "e-1142",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1143",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c9c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96c9c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1144": {
      id: "e-1144",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1145",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96ca0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96ca0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1146": {
      id: "e-1146",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1147",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96ca9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96ca9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1148": {
      id: "e-1148",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-91",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1149",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96caf",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652536a4933e168befe0ef44|42ca1d46-6328-4133-25ad-b5113ff96caf",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696937637561,
    },
    "e-1150": {
      id: "e-1150",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1151",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64a7cc8d64c6b636725398ca|3ec0e9d4-c98b-214b-606f-c2dc6286ef25",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64a7cc8d64c6b636725398ca|3ec0e9d4-c98b-214b-606f-c2dc6286ef25",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941167254,
    },
    "e-1152": {
      id: "e-1152",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1153",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c27b3adc28d6565d02d40f|c28ff285-0c75-6f10-12de-71f15e6598bb",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c27b3adc28d6565d02d40f|c28ff285-0c75-6f10-12de-71f15e6598bb",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941213050,
    },
    "e-1154": {
      id: "e-1154",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1155",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f9ce8dfcd11bf5fd4339bd|26f360e5-be70-d7ab-ef0d-59f305cc37ba",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f9ce8dfcd11bf5fd4339bd|26f360e5-be70-d7ab-ef0d-59f305cc37ba",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941253090,
    },
    "e-1156": {
      id: "e-1156",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1157",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652508a7e07f9c4c3dcf8f15|8e9adedd-6d04-242d-f3a1-dcc247b1d264",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652508a7e07f9c4c3dcf8f15|8e9adedd-6d04-242d-f3a1-dcc247b1d264",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941332466,
    },
    "e-1158": {
      id: "e-1158",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1159",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f1cf6b40c8a9195640529a|84f70320-3a67-26de-2f5b-2334f03eb711",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f1cf6b40c8a9195640529a|84f70320-3a67-26de-2f5b-2334f03eb711",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941353532,
    },
    "e-1160": {
      id: "e-1160",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1161",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "652415f6110a5e19fa41556c|c69a46b1-9af6-6536-bf54-6ea73d9c128b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "652415f6110a5e19fa41556c|c69a46b1-9af6-6536-bf54-6ea73d9c128b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696941391881,
    },
    "e-1182": {
      id: "e-1182",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1183",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|6d0e90b2-2db8-318b-4a6f-15877e80c96c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696946713303,
    },
    "e-1186": {
      id: "e-1186",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1187",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|6d0e90b2-2db8-318b-4a6f-15877e80c984",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|6d0e90b2-2db8-318b-4a6f-15877e80c984",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696946713303,
    },
    "e-1192": {
      id: "e-1192",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-94",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1193",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|3ec0e9d4-c98b-214b-606f-c2dc6286ef25",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|3ec0e9d4-c98b-214b-606f-c2dc6286ef25",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1696946713303,
    },
    "e-1194": {
      id: "e-1194",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-95", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|177a8cc8-16be-6c02-0103-c1b222c5c01f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|177a8cc8-16be-6c02-0103-c1b222c5c01f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-95-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1696969960789,
    },
    "e-1195": {
      id: "e-1195",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-96", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|dbe13b8a-fe70-1723-e5df-f04ac5fd0d39",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|dbe13b8a-fe70-1723-e5df-f04ac5fd0d39",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-96-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1697028951039,
    },
    "e-1196": {
      id: "e-1196",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-18",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-1197",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "65255a18ea2f6ed1dc4399a2|e7a4b811-c66d-1638-44dd-d587ba024a7f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "65255a18ea2f6ed1dc4399a2|e7a4b811-c66d-1638-44dd-d587ba024a7f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 5,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1697038195960,
    },
  },
  actionLists: {
    "a-49": {
      id: "a-49",
      title: "Accordion // Open",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-49-n",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".c-faq_content",
                  selectorGuids: ["8efa290d-9be1-83ae-e932-cf0e89022cee"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-49-n-2",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutCubic",
                duration: 200,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".c-faq_content",
                  selectorGuids: ["8efa290d-9be1-83ae-e932-cf0e89022cee"],
                },
                widthUnit: "PX",
                heightUnit: "AUTO",
                locked: false,
              },
            },
            {
              id: "a-49-n-5",
              actionTypeId: "STYLE_FONT_VARIATION",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                fontVariations: [{ type: "GRAD", id: "9778", value: 150 }],
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".c-text-small.accordion-clicked",
                  selectorGuids: [
                    "8efa290d-9be1-83ae-e932-cf0e89022cea",
                    "fd433d86-b836-367d-032f-f06c37906467",
                  ],
                },
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1654685748654,
    },
    "a-50": {
      id: "a-50",
      title: "Accordion // Close",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-50-n",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutCubic",
                duration: 200,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".c-faq_content",
                  selectorGuids: ["8efa290d-9be1-83ae-e932-cf0e89022cee"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
            {
              id: "a-50-n-2",
              actionTypeId: "STYLE_FONT_VARIATION",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                fontVariations: [{ type: "GRAD", id: "e335", value: 0 }],
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".c-text-small.accordion-clicked",
                  selectorGuids: [
                    "8efa290d-9be1-83ae-e932-cf0e89022cea",
                    "fd433d86-b836-367d-032f-f06c37906467",
                  ],
                },
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1654685748654,
    },
    "a-55": {
      id: "a-55",
      title: "Red-dot scaling up",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-55-n",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 0,
                yValue: 0,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-55-n-2",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "easeIn",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1690203827746,
    },
    "a-56": {
      id: "a-56",
      title: "Red-dot scaling down",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-56-n-2",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "easeOut",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-56-n",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 0,
                yValue: 0,
                locked: true,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1690203827746,
    },
    "a-57": {
      id: "a-57",
      title: "Red-dot scaling up + fade out",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-57-n",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 0,
                yValue: 0,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-57-n-2",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "easeIn",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-57-n-3",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-57-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 300,
                easing: "",
                duration: 2000,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".red-dot",
                  selectorGuids: ["573db99d-b268-f580-2396-5f12b73dd554"],
                },
                value: 0.5,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1690203827746,
    },
    "a-58": {
      id: "a-58",
      title: "Diagram switch",
      continuousParameterGroups: [
        {
          id: "a-58-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-58-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-10",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-58-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-58-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-11",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-58-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "5149f370-92e5-ae12-032f-5583092212d4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-9",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 37,
              actionItems: [
                {
                  id: "a-58-n-12",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-58-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "5149f370-92e5-ae12-032f-5583092212d4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-13",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "0b1e85f6-e023-03c0-9c10-96bd98dea210",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 44,
              actionItems: [
                {
                  id: "a-58-n-14",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "0b1e85f6-e023-03c0-9c10-96bd98dea210",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-15",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "e1d2ffe3-675d-6dd0-35a2-130aa14661a8",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 49,
              actionItems: [
                {
                  id: "a-58-n-16",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "e1d2ffe3-675d-6dd0-35a2-130aa14661a8",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-58-n-17",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "510eaa26-e28a-91ff-7d24-eb4402894eb4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 53,
              actionItems: [
                {
                  id: "a-58-n-18",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "510eaa26-e28a-91ff-7d24-eb4402894eb4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-58-n-19",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "25ef7897-9fca-d3c6-20f4-54ed65003f74",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 64,
              actionItems: [
                {
                  id: "a-58-n-20",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "25ef7897-9fca-d3c6-20f4-54ed65003f74",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1690291321296,
    },
    "a-10": {
      id: "a-10",
      title: "Text Slide-in from Left 1 Mobile 3",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-10-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "da280321-b6ec-f4ed-8a14-81291eba92d7",
                  ],
                },
                xValue: -30,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "da280321-b6ec-f4ed-8a14-81291eba92d7",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-10-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outExpo",
                duration: 600,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "da280321-b6ec-f4ed-8a14-81291eba92d7",
                  ],
                },
                xValue: 0,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 100,
                easing: "easeInOut",
                duration: 700,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "da280321-b6ec-f4ed-8a14-81291eba92d7",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1612179526965,
    },
    "a-8": {
      id: "a-8",
      title: "Text Slide-in from Left 1 Mobile 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-8-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "937dd940-aee1-c638-ce1e-fc3749775cfb",
                  ],
                },
                xValue: -30,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-8-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "937dd940-aee1-c638-ce1e-fc3749775cfb",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-8-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outExpo",
                duration: 600,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "937dd940-aee1-c638-ce1e-fc3749775cfb",
                  ],
                },
                xValue: 0,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-8-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 100,
                easing: "easeInOut",
                duration: 700,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "937dd940-aee1-c638-ce1e-fc3749775cfb",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1612179526965,
    },
    "a-51": {
      id: "a-51",
      title: "appear in  VH center 1",
      continuousParameterGroups: [
        {
          id: "a-51-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-51-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-51-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 20,
              actionItems: [
                {
                  id: "a-51-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-51-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-51-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-51-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1689074859210,
    },
    "a-54": {
      id: "a-54",
      title: "appear in  VH center 2",
      continuousParameterGroups: [
        {
          id: "a-54-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-54-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-54-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-54-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1bd",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-54-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-54-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      id: "64c27b3adc28d6565d02d40f|394404ac-3f64-7a29-13ec-185ed61fa1bd",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-54-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 45,
              actionItems: [
                {
                  id: "a-54-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-54-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".product-image-subtitle.centered",
                      selectorGuids: [
                        "1088f997-b6f0-ac8d-efc8-d061afcbbaa7",
                        "f6265468-d4dc-c3fd-fc60-0236a42c4cad",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1689074859210,
    },
    "a-52": {
      id: "a-52",
      title: "rotate image while scrolling",
      continuousParameterGroups: [
        {
          id: "a-52-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-52-n",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    xValue: null,
                    zValue: 0,
                    xUnit: "deg",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-52-n-3",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-image-1",
                      selectorGuids: ["2039dcf2-2a44-08cf-2de4-1e24fd7ee255"],
                    },
                    xValue: null,
                    zValue: 300,
                    xUnit: "deg",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1689155073248,
    },
    "a-62": {
      id: "a-62",
      title: "Diagram switch mobile",
      continuousParameterGroups: [
        {
          id: "a-62-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-62-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "5149f370-92e5-ae12-032f-5583092212d4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-62-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-62-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-62-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "5149f370-92e5-ae12-032f-5583092212d4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-9",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "717b2689-ef1f-0890-83e1-fae3c9f1f2a0",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 37,
              actionItems: [
                {
                  id: "a-62-n-10",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.diagram._2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "d0128f61-673f-f399-d41b-73e537fb4628",
                        "b399d6d1-fe5d-60c0-f88f-13f2818576e9",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-62-n-11",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.linear-production-img",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "6dd47ac6-6d7d-b47a-a9b7-82482280e64b",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-12",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "5149f370-92e5-ae12-032f-5583092212d4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-13",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "0b1e85f6-e023-03c0-9c10-96bd98dea210",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 44,
              actionItems: [
                {
                  id: "a-62-n-14",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "0b1e85f6-e023-03c0-9c10-96bd98dea210",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-15",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "e1d2ffe3-675d-6dd0-35a2-130aa14661a8",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 49,
              actionItems: [
                {
                  id: "a-62-n-16",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "e1d2ffe3-675d-6dd0-35a2-130aa14661a8",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-62-n-17",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "510eaa26-e28a-91ff-7d24-eb4402894eb4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 53,
              actionItems: [
                {
                  id: "a-62-n-18",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "510eaa26-e28a-91ff-7d24-eb4402894eb4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-62-n-19",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "25ef7897-9fca-d3c6-20f4-54ed65003f74",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 64,
              actionItems: [
                {
                  id: "a-62-n-20",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "25ef7897-9fca-d3c6-20f4-54ed65003f74",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 70,
              actionItems: [
                {
                  id: "a-62-n-21",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._6",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "a077f14e-0230-24f4-5568-0ff6c3fec263",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 74,
              actionItems: [
                {
                  id: "a-62-n-22",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.circular-production-img._6",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "532a1456-9821-6b18-a283-73d9c67a4542",
                        "a077f14e-0230-24f4-5568-0ff6c3fec263",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1690291321296,
    },
    "a-64": {
      id: "a-64",
      title: "Self Trigger 0% to 100% slow",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-64-n-3",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-64-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-64-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 1500,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 36,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-64-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 750,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1655645079915,
    },
    "a-77": {
      id: "a-77",
      title: "Self Trigger 0% to 99,4% slow",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-77-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-77-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 250,
                easing: "inOutQuad",
                duration: 2000,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 32,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1655645079915,
    },
    "a-70": {
      id: "a-70",
      title: "Self Trigger RESET to 0%",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-70-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 1000,
                target: {
                  useEventTarget: true,
                  id: "64ba95bc25b49b830451ab01|4db5df0b-3cf1-842d-9456-e4a64a70b738",
                },
                value: 0,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1655633198239,
    },
    "a-81": {
      id: "a-81",
      title: "Self Trigger 0% to 100%",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-81-n",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-81-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-81-n-3",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 1000,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 36,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-81-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 750,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1655645079915,
    },
    "a-76": {
      id: "a-76",
      title: "Self Trigger 0% to 70% 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-76-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-76-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 1000,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 20.8,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1655645079915,
    },
    "a-80": {
      id: "a-80",
      title: "Self Trigger 0% to 99,4%",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-80-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-80-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 1000,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 32,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1655645079915,
    },
    "a-79": {
      id: "a-79",
      title: "Self Trigger 0% to 85%",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-79-n",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-79-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 1000,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 24.9,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1655645079915,
    },
    "a-86": {
      id: "a-86",
      title: "Self Trigger 0% to 20% slow",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-86-n",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-86-n-2",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-86-n-3",
              actionTypeId: "PLUGIN_LOTTIE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 1500,
                target: {
                  useEventTarget: true,
                  id: "64a7cc8d64c6b636725398ca|b8e01e41-a9c0-5d2a-2409-ecece50bfaf5",
                },
                value: 11.2,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-86-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 750,
                target: {
                  selector: "._wf-column.aligned-right",
                  selectorGuids: [
                    "11b39692-50e5-f8dd-fa3b-ca5014392764",
                    "fc496506-effa-1c1c-95c9-abf1fc995c9a",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1655645079915,
    },
    "a-87": {
      id: "a-87",
      title: "lotus-infinity material 1",
      continuousParameterGroups: [
        {
          id: "a-87-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-87-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._1",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "604be6c8-939e-1751-c128-d09cce18b7f2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-87-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._1",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "604be6c8-939e-1751-c128-d09cce18b7f2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._2",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "1f0a1310-c73b-f5a9-6031-b2e1d5c72fd2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-87-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._1",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "604be6c8-939e-1751-c128-d09cce18b7f2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._2",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "1f0a1310-c73b-f5a9-6031-b2e1d5c72fd2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-87-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._2",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "1f0a1310-c73b-f5a9-6031-b2e1d5c72fd2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-9",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._3",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "bbe24b44-01ca-3af2-8794-6a3222ec81f4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 45,
              actionItems: [
                {
                  id: "a-87-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._2",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "1f0a1310-c73b-f5a9-6031-b2e1d5c72fd2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._3",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "bbe24b44-01ca-3af2-8794-6a3222ec81f4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-87-n-10",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._3",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "bbe24b44-01ca-3af2-8794-6a3222ec81f4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-12",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._4",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "9f850cd2-d62b-5a58-4b65-aa06c9b1ec2e",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 55,
              actionItems: [
                {
                  id: "a-87-n-11",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._3",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "bbe24b44-01ca-3af2-8794-6a3222ec81f4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-87-n-13",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".lotus-infinity-img._4",
                      selectorGuids: [
                        "d213e46e-b8a6-bfa3-4dd0-8bf528e963df",
                        "9f850cd2-d62b-5a58-4b65-aa06c9b1ec2e",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1694511869434,
    },
    "a-91": {
      id: "a-91",
      title: "Column scaling up B 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-91-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block-diagram-bar",
                  selectorGuids: ["8a1bbe9f-ed5b-cada-ab85-98a85284a9b4"],
                },
                value: 0,
                unit: "",
              },
            },
            {
              id: "a-91-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".bar-filling",
                  selectorGuids: ["70c0407f-b2e2-9e45-30d8-a47bbc86ff0c"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "%",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-91-n-5",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 250,
                easing: "",
                duration: 750,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block-diagram-bar",
                  selectorGuids: ["8a1bbe9f-ed5b-cada-ab85-98a85284a9b4"],
                },
                value: 0,
                unit: "",
              },
            },
            {
              id: "a-91-n-6",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 250,
                easing: "",
                duration: 750,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".bar-filling",
                  selectorGuids: ["70c0407f-b2e2-9e45-30d8-a47bbc86ff0c"],
                },
                heightValue: 100,
                widthUnit: "PX",
                heightUnit: "%",
                locked: false,
              },
            },
            {
              id: "a-91-n-7",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 500,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block-diagram-bar",
                  selectorGuids: ["8a1bbe9f-ed5b-cada-ab85-98a85284a9b4"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1690203827746,
    },
    "a-18": {
      id: "a-18",
      title: "Button Slide-in from Left 1 Mobile",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-18-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-button",
                  selectorGuids: ["6924f0e3-6f5f-d7b2-a2ba-96e862feb9c3"],
                },
                xValue: -40,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-18-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-button",
                  selectorGuids: ["6924f0e3-6f5f-d7b2-a2ba-96e862feb9c3"],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-18-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outExpo",
                duration: 600,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-button",
                  selectorGuids: ["6924f0e3-6f5f-d7b2-a2ba-96e862feb9c3"],
                },
                xValue: 0,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-18-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 100,
                easing: "easeInOut",
                duration: 1000,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-button",
                  selectorGuids: ["6924f0e3-6f5f-d7b2-a2ba-96e862feb9c3"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1612179526965,
    },
    "a-93": {
      id: "a-93",
      title: "Text Slide-in from Left 1 Mobile 6",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-93-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "079e8788-ac8d-25cd-cbbc-a32c20a10814",
                  ],
                },
                xValue: -30,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-93-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "079e8788-ac8d-25cd-cbbc-a32c20a10814",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-93-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outExpo",
                duration: 600,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "079e8788-ac8d-25cd-cbbc-a32c20a10814",
                  ],
                },
                xValue: 0,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-93-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 100,
                easing: "easeInOut",
                duration: 700,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "079e8788-ac8d-25cd-cbbc-a32c20a10814",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1612179526965,
    },
    "a-92": {
      id: "a-92",
      title: "sectional view 2",
      continuousParameterGroups: [
        {
          id: "a-92-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-92-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._1",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "cecb12c5-d702-3c56-6af6-656167560f57",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "5638d4a9-cc52-044b-3cd0-88670e4eadd2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10823",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3a",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "383362e3-1e76-e14b-5e07-636ffdbe9b98",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 8,
              actionItems: [
                {
                  id: "a-92-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "5638d4a9-cc52-044b-3cd0-88670e4eadd2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10823",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3a",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "383362e3-1e76-e14b-5e07-636ffdbe9b98",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 10,
              actionItems: [
                {
                  id: "a-92-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._0",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10818",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-9",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._0",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10805",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 13,
              actionItems: [
                {
                  id: "a-92-n-10",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._0",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10818",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-11",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._0",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10805",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-12",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._1",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081f",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-13",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._1",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10812",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 18,
              actionItems: [
                {
                  id: "a-92-n-14",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3a",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "383362e3-1e76-e14b-5e07-636ffdbe9b98",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-15",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._1",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081f",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-16",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._1",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10812",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-17",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._2",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "2599128a-9b82-c4b4-db62-c1b8fbf90479",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 20,
              actionItems: [
                {
                  id: "a-92-n-18",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._1",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "cecb12c5-d702-3c56-6af6-656167560f57",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-92-n-19",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._2",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081e",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-20",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._2",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10817",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-21",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3a",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "383362e3-1e76-e14b-5e07-636ffdbe9b98",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-22",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._1",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "cecb12c5-d702-3c56-6af6-656167560f57",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-23",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._2",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "2599128a-9b82-c4b4-db62-c1b8fbf90479",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 28,
              actionItems: [
                {
                  id: "a-92-n-24",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._2",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081e",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-25",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._2",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10817",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-92-n-26",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._3",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081d",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-27",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._3",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10810",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 38,
              actionItems: [
                {
                  id: "a-92-n-28",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._3",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081d",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-29",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._3",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10810",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 42,
              actionItems: [
                {
                  id: "a-92-n-30",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._4",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10820",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-31",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._4",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10816",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 45,
              actionItems: [
                {
                  id: "a-92-n-32",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._4",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10820",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-33",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._4",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10816",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-34",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "5638d4a9-cc52-044b-3cd0-88670e4eadd2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-35",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10823",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-36",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.dots-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080e",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-37",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "b0287a01-feea-fb1e-9b05-08235f87649d",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-38",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10822",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-39",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10823",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-40",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position._4",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080a",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-92-n-41",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3b",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "78ac3d00-8e7b-d86e-3895-b87847e19e02",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 55,
              actionItems: [
                {
                  id: "a-92-n-42",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "5638d4a9-cc52-044b-3cd0-88670e4eadd2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-43",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10823",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-44",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.dots-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080e",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-45",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3b",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "78ac3d00-8e7b-d86e-3895-b87847e19e02",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-46",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-padding-bottom.headline-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "fc3b6386-96d5-9fa3-2bae-35e54c92325d",
                        "b0287a01-feea-fb1e-9b05-08235f87649d",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-47",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector:
                        "._wf-content-position.no-spacing.icon-1.headline-1",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080d",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10821",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10822",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-48",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position._4",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1080a",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 58,
              actionItems: [
                {
                  id: "a-92-n-49",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._5",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081b",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-50",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._5",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10815",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-51",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3b",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "78ac3d00-8e7b-d86e-3895-b87847e19e02",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 62,
              actionItems: [
                {
                  id: "a-92-n-52",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._5",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-53",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._5",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10815",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-54",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._3b",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "78ac3d00-8e7b-d86e-3895-b87847e19e02",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 70,
              actionItems: [
                {
                  id: "a-92-n-55",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._6",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081c",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-56",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._6",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10811",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 73,
              actionItems: [
                {
                  id: "a-92-n-57",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-text-float-div.text-list._6",
                      selectorGuids: [
                        "1b6f78b6-4580-726d-5044-2576d4fc8c7d",
                        "e4daf36e-8a27-a55f-e3d2-c80dd3f5f13f",
                        "079e8788-ac8d-25cd-cbbc-a32c20a1081c",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-58",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".control-point._6",
                      selectorGuids: [
                        "76d51994-fe17-45dd-ee9c-3d6ff35ce80b",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10811",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-92-n-59",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-product-image._2",
                      selectorGuids: [
                        "3a9cd535-d4b7-7afe-9616-d2209880003f",
                        "2599128a-9b82-c4b4-db62-c1b8fbf90479",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 82,
              actionItems: [
                {
                  id: "a-92-n-60",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.dots-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10806",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 85,
              actionItems: [
                {
                  id: "a-92-n-61",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-content-position.dots-2",
                      selectorGuids: [
                        "2039dcf2-2a44-08cf-2de4-1e24fd7ee257",
                        "079e8788-ac8d-25cd-cbbc-a32c20a10806",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1680621338940,
    },
    "a-94": {
      id: "a-94",
      title: "Text Slide-in from Left 1 Mobile 7",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-94-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "72e3933d-f7d6-d238-81be-b15a0a81bd97",
                  ],
                },
                xValue: -30,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-94-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "72e3933d-f7d6-d238-81be-b15a0a81bd97",
                  ],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-94-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outExpo",
                duration: 600,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "72e3933d-f7d6-d238-81be-b15a0a81bd97",
                  ],
                },
                xValue: 0,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-94-n-4",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 100,
                easing: "easeInOut",
                duration: 700,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: "._wf-text-block.text-normal-400",
                  selectorGuids: [
                    "2570a049-3e5a-6559-0b6b-805292d19c8a",
                    "72e3933d-f7d6-d238-81be-b15a0a81bd97",
                  ],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1612179526965,
    },
    "a-95": {
      id: "a-95",
      title: "Quick textile recycling animation",
      continuousParameterGroups: [
        {
          id: "a-95-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-95-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "d617402a-1267-8cbf-9f3c-5ffbc9213056",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-15",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-24",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-35",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "69b1083e-829f-e7e7-da26-4b94bf8996b9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-48",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._6",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "a5a214e0-fb2f-b929-bb2f-51bae60d2fbb",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 18,
              actionItems: [
                {
                  id: "a-95-n-53",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._1",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "c5292673-ebee-1b24-8609-c4b185f1e7d8",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 21,
              actionItems: [
                {
                  id: "a-95-n-55",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._1",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "c5292673-ebee-1b24-8609-c4b185f1e7d8",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 29,
              actionItems: [
                {
                  id: "a-95-n-54",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._1",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "c5292673-ebee-1b24-8609-c4b185f1e7d8",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-59",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-section-hero-heading._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f575",
                        "35cf1843-e678-cea9-8d50-240209699c1f",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-95-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "d617402a-1267-8cbf-9f3c-5ffbc9213056",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-7",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "d617402a-1267-8cbf-9f3c-5ffbc9213056",
                      ],
                    },
                    zValue: 0,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-9",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    zValue: 0,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-57",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-section-hero-heading._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f575",
                        "35cf1843-e678-cea9-8d50-240209699c1f",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-56",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._1",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "c5292673-ebee-1b24-8609-c4b185f1e7d8",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-60",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._2",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "ef461880-f327-9036-140a-1e380f6dbdc0",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-95-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "d617402a-1267-8cbf-9f3c-5ffbc9213056",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-8",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._1",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "d617402a-1267-8cbf-9f3c-5ffbc9213056",
                      ],
                    },
                    zValue: 560,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-10",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-58",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-section-hero-heading._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f575",
                        "35cf1843-e678-cea9-8d50-240209699c1f",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-61",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._2",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "ef461880-f327-9036-140a-1e380f6dbdc0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-95-n-11",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-13",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-16",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-18",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    zValue: 0,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-62",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._2",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "ef461880-f327-9036-140a-1e380f6dbdc0",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-64",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._3",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "23ca2b14-343f-d68a-8dde-0bd1171307ce",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 45,
              actionItems: [
                {
                  id: "a-95-n-12",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-14",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._2",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "65cf0f9c-1cc0-28ef-0362-715197e692c7",
                      ],
                    },
                    zValue: 1000,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-17",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-19",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-63",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._2",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "ef461880-f327-9036-140a-1e380f6dbdc0",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-65",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._3",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "23ca2b14-343f-d68a-8dde-0bd1171307ce",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-95-n-20",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-22",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-25",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-27",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    zValue: 0,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-66",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._3",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "23ca2b14-343f-d68a-8dde-0bd1171307ce",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-67",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._4",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "4124d2ed-7ad3-cb35-8199-dc0808a66ae6",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 55,
              actionItems: [
                {
                  id: "a-95-n-21",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-23",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._3",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "da9749b1-04f7-f2a0-a62e-f5ea586f2c9f",
                      ],
                    },
                    zValue: 1000,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-26",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-28",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-68",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._4",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "4124d2ed-7ad3-cb35-8199-dc0808a66ae6",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-95-n-33",
                  actionTypeId: "TRANSFORM_SCALE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    xValue: 1,
                    yValue: 1,
                    locked: true,
                  },
                },
                {
                  id: "a-95-n-40",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    xValue: 0,
                    xUnit: "px",
                    yUnit: "PX",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-95-n-42",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "69b1083e-829f-e7e7-da26-4b94bf8996b9",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-51",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    zValue: 500,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-69",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._4",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "4124d2ed-7ad3-cb35-8199-dc0808a66ae6",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 65,
              actionItems: [
                {
                  id: "a-95-n-36",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "69b1083e-829f-e7e7-da26-4b94bf8996b9",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-43",
                  actionTypeId: "STYLE_FILTER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    filters: [
                      {
                        type: "brightness",
                        filterId: "a1b4",
                        value: 100,
                        unit: "%",
                      },
                    ],
                  },
                },
                {
                  id: "a-95-n-46",
                  actionTypeId: "STYLE_FILTER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "69b1083e-829f-e7e7-da26-4b94bf8996b9",
                      ],
                    },
                    filters: [
                      { type: "blur", filterId: "67fd", value: 7, unit: "px" },
                      {
                        type: "brightness",
                        filterId: "87e6",
                        value: 80,
                        unit: "%",
                      },
                    ],
                  },
                },
                {
                  id: "a-95-n-70",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._5",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "17216a37-5bc1-dd4d-3287-2d0242e95da4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 70,
              actionItems: [
                {
                  id: "a-95-n-34",
                  actionTypeId: "TRANSFORM_SCALE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    xValue: 0.2,
                    yValue: 0.2,
                    locked: true,
                  },
                },
                {
                  id: "a-95-n-41",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    xValue: 86,
                    xUnit: "px",
                    yUnit: "PX",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-95-n-29",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-44",
                  actionTypeId: "STYLE_FILTER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    filters: [
                      {
                        type: "brightness",
                        filterId: "a1b4",
                        value: 93,
                        unit: "%",
                      },
                    ],
                  },
                },
                {
                  id: "a-95-n-47",
                  actionTypeId: "STYLE_FILTER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._5",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "69b1083e-829f-e7e7-da26-4b94bf8996b9",
                      ],
                    },
                    filters: [
                      { type: "blur", filterId: "67fd", value: 0, unit: "px" },
                      {
                        type: "brightness",
                        filterId: "87e6",
                        value: 100,
                        unit: "%",
                      },
                    ],
                  },
                },
                {
                  id: "a-95-n-52",
                  actionTypeId: "TRANSFORM_ROTATE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    zValue: 800,
                    xUnit: "DEG",
                    yUnit: "DEG",
                    zUnit: "deg",
                  },
                },
                {
                  id: "a-95-n-73",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._5",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "17216a37-5bc1-dd4d-3287-2d0242e95da4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 75,
              actionItems: [
                {
                  id: "a-95-n-30",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "outCubic",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._4",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "bc6ad87a-c6e3-8ee3-f565-daf7d9485aa2",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-49",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._6",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "a5a214e0-fb2f-b929-bb2f-51bae60d2fbb",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-71",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._5",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "17216a37-5bc1-dd4d-3287-2d0242e95da4",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 80,
              actionItems: [
                {
                  id: "a-95-n-50",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-image-wrapper.textile-recycling-img._6",
                      selectorGuids: [
                        "98161b66-2376-b037-7bc8-0cc64fc8f563",
                        "f1922902-dbe7-4d08-d9e6-565be437ac07",
                        "a5a214e0-fb2f-b929-bb2f-51bae60d2fbb",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-95-n-72",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._w-text-over-animation._5",
                      selectorGuids: [
                        "5d7b71ce-c7d4-dc4d-70d0-8095f6742187",
                        "17216a37-5bc1-dd4d-3287-2d0242e95da4",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1696969969763,
    },
    "a-96": {
      id: "a-96",
      title: "1-2-3-list",
      continuousParameterGroups: [
        {
          id: "a-96-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 15,
              actionItems: [
                {
                  id: "a-96-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._1",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "3e11f5fa-a717-c0ce-2e82-50b10f943f19",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 20,
              actionItems: [
                {
                  id: "a-96-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._1",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "3e11f5fa-a717-c0ce-2e82-50b10f943f19",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 25,
              actionItems: [
                {
                  id: "a-96-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._2",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "88dc4e5e-f7e0-8749-0ff5-0b13cd4834c1",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-96-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._2",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "88dc4e5e-f7e0-8749-0ff5-0b13cd4834c1",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 35,
              actionItems: [
                {
                  id: "a-96-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._3",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "dc90feb4-520f-8b15-5b49-7a14b921063b",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-96-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._3",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "dc90feb4-520f-8b15-5b49-7a14b921063b",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 45,
              actionItems: [
                {
                  id: "a-96-n-7",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._4",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "bdaa4540-69c7-2b94-676b-b986d3adcffd",
                      ],
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-96-n-8",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: "._wf-page-list._4",
                      selectorGuids: [
                        "4e31a743-f423-4e30-36cc-8de64b9f3cbf",
                        "bdaa4540-69c7-2b94-676b-b986d3adcffd",
                      ],
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1697028955009,
    },
  },
  site: {
    mediaQueries: [
      { key: "main", min: 992, max: 10000 },
      { key: "medium", min: 768, max: 991 },
      { key: "small", min: 480, max: 767 },
      { key: "tiny", min: 0, max: 479 },
    ],
  },
});
